/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(108);
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(67);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Main = __webpack_require__(98);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Render the main component into the dom
	_reactDom2.default.render(_react2.default.createElement(_Main2.default, null), document.getElementById('app'));

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(7);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var DOMProperty = __webpack_require__(15);
	var ReactDOMComponentFlags = __webpack_require__(71);
	
	var invariant = __webpack_require__(1);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(17);


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var CallbackQueue = __webpack_require__(69);
	var PooledClass = __webpack_require__(13);
	var ReactFeatureFlags = __webpack_require__(74);
	var ReactReconciler = __webpack_require__(16);
	var Transaction = __webpack_require__(29);
	
	var invariant = __webpack_require__(1);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(13);
	
	var emptyFunction = __webpack_require__(7);
	var warning = __webpack_require__(2);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 13 */
[238, 3],
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(39);
	var setInnerHTML = __webpack_require__(31);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(47);
	var setTextContent = __webpack_require__(87);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(193);
	var ReactInstrumentation = __webpack_require__(8);
	
	var warning = __webpack_require__(2);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactBaseClasses = __webpack_require__(89);
	var ReactChildren = __webpack_require__(224);
	var ReactDOMFactories = __webpack_require__(225);
	var ReactElement = __webpack_require__(18);
	var ReactPropTypes = __webpack_require__(226);
	var ReactVersion = __webpack_require__(227);
	
	var createReactClass = __webpack_require__(228);
	var onlyChild = __webpack_require__(232);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactCurrentOwner = __webpack_require__(12);
	
	var warning = __webpack_require__(2);
	var canDefineProperty = __webpack_require__(93);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(91);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var EventPluginRegistry = __webpack_require__(40);
	var EventPluginUtils = __webpack_require__(41);
	var ReactErrorUtils = __webpack_require__(45);
	
	var accumulateInto = __webpack_require__(80);
	var forEachAccumulated = __webpack_require__(81);
	var invariant = __webpack_require__(1);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(19);
	var EventPluginUtils = __webpack_require__(41);
	
	var accumulateInto = __webpack_require__(80);
	var forEachAccumulated = __webpack_require__(81);
	var warning = __webpack_require__(2);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(11);
	
	var getEventTarget = __webpack_require__(50);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ }),
/* 23 */
3,
/* 24 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {/*
	Copyright (c) 2010,2011,2012,2013,2014 Morgan Roderick http://roderick.dk
	License: MIT - http://mrgnrdrck.mit-license.org
	
	https://github.com/mroderick/PubSubJS
	*/
	(function (root, factory){
	    'use strict';
	
	    var PubSub = {};
	    root.PubSub = PubSub;
	
	    var define = root.define;
	
	    factory(PubSub);
	
	    // AMD support
	    if (typeof define === 'function' && define.amd){
	        define(function() { return PubSub; });
	
	        // CommonJS and Node.js module support
	    } else if (true){
	        if (module !== undefined && module.exports) {
	            exports = module.exports = PubSub; // Node.js specific `module.exports`
	        }
	        exports.PubSub = PubSub; // CommonJS module 1.1.1 spec
	        module.exports = exports = PubSub; // CommonJS
	    }
	
	}(( typeof window === 'object' && window ) || this, function (PubSub){
	    'use strict';
	
	    var messages = {},
	        lastUid = -1;
	
	    function hasKeys(obj){
	        var key;
	
	        for (key in obj){
	            if ( obj.hasOwnProperty(key) ){
	                return true;
	            }
	        }
	        return false;
	    }
	
	    /**
		 *	Returns a function that throws the passed exception, for use as argument for setTimeout
		 *	@param { Object } ex An Error object
		 */
	    function throwException( ex ){
	        return function reThrowException(){
	            throw ex;
	        };
	    }
	
	    function callSubscriberWithDelayedExceptions( subscriber, message, data ){
	        try {
	            subscriber( message, data );
	        } catch( ex ){
	            setTimeout( throwException( ex ), 0);
	        }
	    }
	
	    function callSubscriberWithImmediateExceptions( subscriber, message, data ){
	        subscriber( message, data );
	    }
	
	    function deliverMessage( originalMessage, matchedMessage, data, immediateExceptions ){
	        var subscribers = messages[matchedMessage],
	            callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions,
	            s;
	
	        if ( !messages.hasOwnProperty( matchedMessage ) ) {
	            return;
	        }
	
	        for (s in subscribers){
	            if ( subscribers.hasOwnProperty(s)){
	                callSubscriber( subscribers[s], originalMessage, data );
	            }
	        }
	    }
	
	    function createDeliveryFunction( message, data, immediateExceptions ){
	        return function deliverNamespaced(){
	            var topic = String( message ),
	                position = topic.lastIndexOf( '.' );
	
	            // deliver the message as it is now
	            deliverMessage(message, message, data, immediateExceptions);
	
	            // trim the hierarchy and deliver message to each level
	            while( position !== -1 ){
	                topic = topic.substr( 0, position );
	                position = topic.lastIndexOf('.');
	                deliverMessage( message, topic, data, immediateExceptions );
	            }
	        };
	    }
	
	    function messageHasSubscribers( message ){
	        var topic = String( message ),
	            found = Boolean(messages.hasOwnProperty( topic ) && hasKeys(messages[topic])),
	            position = topic.lastIndexOf( '.' );
	
	        while ( !found && position !== -1 ){
	            topic = topic.substr( 0, position );
	            position = topic.lastIndexOf( '.' );
	            found = Boolean(messages.hasOwnProperty( topic ) && hasKeys(messages[topic]));
	        }
	
	        return found;
	    }
	
	    function publish( message, data, sync, immediateExceptions ){
	        var deliver = createDeliveryFunction( message, data, immediateExceptions ),
	            hasSubscribers = messageHasSubscribers( message );
	
	        if ( !hasSubscribers ){
	            return false;
	        }
	
	        if ( sync === true ){
	            deliver();
	        } else {
	            setTimeout( deliver, 0 );
	        }
	        return true;
	    }
	
	    /**
		 *	PubSub.publish( message[, data] ) -> Boolean
		 *	- message (String): The message to publish
		 *	- data: The data to pass to subscribers
		 *	Publishes the the message, passing the data to it's subscribers
		**/
	    PubSub.publish = function( message, data ){
	        return publish( message, data, false, PubSub.immediateExceptions );
	    };
	
	    /**
		 *	PubSub.publishSync( message[, data] ) -> Boolean
		 *	- message (String): The message to publish
		 *	- data: The data to pass to subscribers
		 *	Publishes the the message synchronously, passing the data to it's subscribers
		**/
	    PubSub.publishSync = function( message, data ){
	        return publish( message, data, true, PubSub.immediateExceptions );
	    };
	
	    /**
		 *	PubSub.subscribe( message, func ) -> String
		 *	- message (String): The message to subscribe to
		 *	- func (Function): The function to call when a new message is published
		 *	Subscribes the passed function to the passed message. Every returned token is unique and should be stored if
		 *	you need to unsubscribe
		**/
	    PubSub.subscribe = function( message, func ){
	        if ( typeof func !== 'function'){
	            return false;
	        }
	
	        // message is not registered yet
	        if ( !messages.hasOwnProperty( message ) ){
	            messages[message] = {};
	        }
	
	        // forcing token as String, to allow for future expansions without breaking usage
	        // and allow for easy use as key names for the 'messages' object
	        var token = 'uid_' + String(++lastUid);
	        messages[message][token] = func;
	
	        // return token for unsubscribing
	        return token;
	    };
	
	    /**
		 *	PubSub.subscribeOnce( message, func ) -> PubSub
		 *	- message (String): The message to subscribe to
		 *	- func (Function): The function to call when a new message is published
		 *	Subscribes the passed function to the passed message once
		**/
	    PubSub.subscribeOnce = function( message, func ){
	        var token = PubSub.subscribe( message, function(){
	            // before func apply, unsubscribe message
	            PubSub.unsubscribe( token );
	            func.apply( this, arguments );
	        });
	        return PubSub;
	    };
	
	    /* Public: Clears all subscriptions
		 */
	    PubSub.clearAllSubscriptions = function clearAllSubscriptions(){
	        messages = {};
	    };
	
	    /*Public: Clear subscriptions by the topic
		*/
	    PubSub.clearSubscriptions = function clearSubscriptions(topic){
	        var m;
	        for (m in messages){
	            if (messages.hasOwnProperty(m) && m.indexOf(topic) === 0){
	                delete messages[m];
	            }
	        }
	    };
	
	    /* Public: removes subscriptions.
		 * When passed a token, removes a specific subscription.
		 * When passed a function, removes all subscriptions for that function
		 * When passed a topic, removes all subscriptions for that topic (hierarchy)
		 *
		 * value - A token, function or topic to unsubscribe.
		 *
		 * Examples
		 *
		 *		// Example 1 - unsubscribing with a token
		 *		var token = PubSub.subscribe('mytopic', myFunc);
		 *		PubSub.unsubscribe(token);
		 *
		 *		// Example 2 - unsubscribing with a function
		 *		PubSub.unsubscribe(myFunc);
		 *
		 *		// Example 3 - unsubscribing a topic
		 *		PubSub.unsubscribe('mytopic');
		 */
	    PubSub.unsubscribe = function(value){
	        var descendantTopicExists = function(topic) {
	                var m;
	                for ( m in messages ){
	                    if ( messages.hasOwnProperty(m) && m.indexOf(topic) === 0 ){
	                        // a descendant of the topic exists:
	                        return true;
	                    }
	                }
	
	                return false;
	            },
	            isTopic    = typeof value === 'string' && ( messages.hasOwnProperty(value) || descendantTopicExists(value) ),
	            isToken    = !isTopic && typeof value === 'string',
	            isFunction = typeof value === 'function',
	            result = false,
	            m, message, t;
	
	        if (isTopic){
	            PubSub.clearSubscriptions(value);
	            return;
	        }
	
	        for ( m in messages ){
	            if ( messages.hasOwnProperty( m ) ){
	                message = messages[m];
	
	                if ( isToken && message[value] ){
	                    delete message[value];
	                    result = value;
	                    // tokens are unique, so we can just stop here
	                    break;
	                }
	
	                if (isFunction) {
	                    for ( t in message ){
	                        if (message.hasOwnProperty(t) && message[t] === value){
	                            delete message[t];
	                            result = true;
	                        }
	                    }
	                }
	            }
	        }
	
	        return result;
	    };
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(237)(module)))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var EventPluginRegistry = __webpack_require__(40);
	var ReactEventEmitterMixin = __webpack_require__(185);
	var ViewportMetrics = __webpack_require__(79);
	
	var getVendorPrefixedEventName = __webpack_require__(217);
	var isEventSupported = __webpack_require__(51);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(22);
	var ViewportMetrics = __webpack_require__(79);
	
	var getEventModifierState = __webpack_require__(49);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(6);
	var DOMNamespaces = __webpack_require__(39);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(47);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.3' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(34)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 34 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 37 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(14);
	var Danger = __webpack_require__(162);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactInstrumentation = __webpack_require__(8);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(47);
	var setInnerHTML = __webpack_require__(31);
	var setTextContent = __webpack_require__(87);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactErrorUtils = __webpack_require__(45);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ }),
/* 42 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactPropTypesSecret = __webpack_require__(191);
	var propTypesFactory = __webpack_require__(65);
	
	var React = __webpack_require__(17);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactCurrentOwner = __webpack_require__(12);
	var ReactInstanceMap = __webpack_require__(21);
	var ReactInstrumentation = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(10);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(6);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var emptyFunction = __webpack_require__(7);
	var warning = __webpack_require__(2);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pubsubJs = __webpack_require__(26);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//const FontAwesome = require('react-fontawesome');
	
	var SkillComponent = function (_React$Component) {
	    _inherits(SkillComponent, _React$Component);
	
	    function SkillComponent(props) {
	        _classCallCheck(this, SkillComponent);
	
	        var _this = _possibleConstructorReturn(this, (SkillComponent.__proto__ || Object.getPrototypeOf(SkillComponent)).call(this, props));
	
	        _this.state = {
	            skillOn: false
	        };
	
	        _this._getColor = _this._getColor.bind(_this);
	        return _this;
	    }
	
	    _createClass(SkillComponent, [{
	        key: "_onMouseOver",
	        value: function _onMouseOver(e) {
	            if (this.props.context === "header") {
	                var on = !this.state.skillOn;
	                this.setState({
	                    skillOn: on
	                });
	                // console.log(this.props)
	                if (on) _pubsubJs2.default.publish("SKILL_ON", this.props.title);else _pubsubJs2.default.publish("SKILL_OFF", this.props.title);
	            }
	        }
	    }, {
	        key: "_onMouseOut",
	        value: function _onMouseOut(e) {
	            //if(this.props.context == "header")
	            //	PubSub.publish('SKILL_OFF', this.props.title);
	        }
	    }, {
	        key: "_getColor",
	        value: function _getColor() {
	            var color = this.props.color;
	
	            if (color && color.indexOf(",") > -1) color = color.split(",");
	            return color;
	        }
	    }, {
	        key: "_renderByName",
	        value: function _renderByName() {
	            var title = this.props.title;
	
	            var color = this._getColor();
	            // console.log(color);
	            switch (title) {
	                case "JAMStack":
	                    var _parts = title.split("");
	                    var _spans = _parts.map(function (part, i) {
	                        return _react2.default.createElement(
	                            "span",
	                            { key: i, style: { color: color[i] } },
	                            _parts[i]
	                        );
	                    });
	                    return _react2.default.createElement(
	                        "div",
	                        { className: "skill" },
	                        _spans
	                    );
	                //break
	
	                case "MEAN":
	                    var parts = title.split("");
	                    var spans = parts.map(function (part, i) {
	                        return _react2.default.createElement(
	                            "span",
	                            { key: i, style: { color: color[i] } },
	                            parts[i]
	                        );
	                    });
	                    return _react2.default.createElement(
	                        "div",
	                        { className: "skill" },
	                        spans
	                    );
	                //break
	
	                default:
	                    return _react2.default.createElement(
	                        "div",
	                        { className: "skill" },
	                        _react2.default.createElement(
	                            "span",
	                            { style: { color: color } },
	                            title
	                        )
	                    );
	                //break
	            }
	        }
	    }, {
	        key: "componentDidUpdate",
	        value: function componentDidUpdate() {
	            //console.log(this.state)
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            //const {skill} = this.props
	            var skillClass = this.state.skillOn ? "active" : "";
	            return _react2.default.createElement(
	                "div",
	                {
	                    className: "skill-component " + skillClass,
	                    style: {
	                        color: this._getColor()
	                    },
	                    onMouseOver: this._onMouseOver.bind(this),
	                    onMouseOut: this._onMouseOut.bind(this)
	                },
	                this._renderByName()
	            );
	        }
	    }]);
	
	    return SkillComponent;
	}(_react2.default.Component);
	
	SkillComponent.displayName = "SkillComponent";
	
	// Uncomment properties you need
	// SkillComponent.propTypes = {};
	// SkillComponent.defaultProps = {};
	
	exports.default = SkillComponent;

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(119);
	var createDesc = __webpack_require__(124);
	module.exports = __webpack_require__(33) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(112);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(58);
	var defined = __webpack_require__(55);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(7);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(153);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 66 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(170);


/***/ }),
/* 68 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(13);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(15);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactInstrumentation = __webpack_require__(8);
	
	var quoteAttributeValueForBrowser = __webpack_require__(218);
	var warning = __webpack_require__(2);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ }),
/* 71 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var LinkedValueUtils = __webpack_require__(43);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactUpdates = __webpack_require__(10);
	
	var warning = __webpack_require__(2);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ }),
/* 74 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(178);
	
	var containsNode = __webpack_require__(139);
	var focusNode = __webpack_require__(63);
	var getActiveElement = __webpack_require__(64);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var DOMLazyTree = __webpack_require__(14);
	var DOMProperty = __webpack_require__(15);
	var React = __webpack_require__(17);
	var ReactBrowserEventEmitter = __webpack_require__(27);
	var ReactCurrentOwner = __webpack_require__(12);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactDOMContainerInfo = __webpack_require__(172);
	var ReactDOMFeatureFlags = __webpack_require__(174);
	var ReactFeatureFlags = __webpack_require__(74);
	var ReactInstanceMap = __webpack_require__(21);
	var ReactInstrumentation = __webpack_require__(8);
	var ReactMarkupChecksum = __webpack_require__(188);
	var ReactReconciler = __webpack_require__(16);
	var ReactUpdateQueue = __webpack_require__(46);
	var ReactUpdates = __webpack_require__(10);
	
	var emptyObject = __webpack_require__(25);
	var instantiateReactComponent = __webpack_require__(85);
	var invariant = __webpack_require__(1);
	var setInnerHTML = __webpack_require__(31);
	var shouldUpdateReactComponent = __webpack_require__(52);
	var warning = __webpack_require__(2);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var React = __webpack_require__(17);
	
	var invariant = __webpack_require__(1);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(78);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(6);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(5);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var ReactCompositeComponent = __webpack_require__(169);
	var ReactEmptyComponent = __webpack_require__(73);
	var ReactHostComponent = __webpack_require__(75);
	
	var getNextDebugID = __webpack_require__(230);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(6);
	var escapeTextContentForBrowser = __webpack_require__(30);
	var setInnerHTML = __webpack_require__(31);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactCurrentOwner = __webpack_require__(12);
	var REACT_ELEMENT_TYPE = __webpack_require__(184);
	
	var getIteratorFn = __webpack_require__(215);
	var invariant = __webpack_require__(1);
	var KeyEscapeUtils = __webpack_require__(42);
	var warning = __webpack_require__(2);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23),
	    _assign = __webpack_require__(4);
	
	var ReactNoopUpdateQueue = __webpack_require__(92);
	
	var canDefineProperty = __webpack_require__(93);
	var emptyObject = __webpack_require__(25);
	var invariant = __webpack_require__(1);
	var lowPriorityWarning = __webpack_require__(231);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var ReactCurrentOwner = __webpack_require__(12);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ }),
/* 91 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(2);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 94 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _gsap = __webpack_require__(149);
	
	var duration = 1;
	
	exports.default = {
		show: function show(target, cb) {
			return _gsap.TweenMax.from(target, duration, {
				opacity: 0,
				onComplete: function onComplete() {
					cb();
				},
	
				ease: _gsap.Elastic.easeOut.config(0.25, 1)
			});
		},
		hide: function hide(target, cb) {
			return _gsap.TweenMax.to(target, duration, {
				opacity: 0,
				onComplete: function onComplete() {
					cb();
				},
	
				ease: _gsap.Elastic.easeOut.config(0.25, 1)
			});
		},
		zoomOut: function zoomOut(target, cb) {
			return _gsap.TweenMax.to(target, duration, {
				opacity: 0,
				scaleX: 2,
				scaleY: 2,
				onComplete: function onComplete() {
					cb();
				},
	
				ease: _gsap.Elastic.easeOut.config(0.25, 1)
			});
		}
	};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//require('styles//Followmouse.scss');
	
	var FollowmouseComponent = function (_React$Component) {
		_inherits(FollowmouseComponent, _React$Component);
	
		function FollowmouseComponent(props) {
			_classCallCheck(this, FollowmouseComponent);
	
			var _this = _possibleConstructorReturn(this, (FollowmouseComponent.__proto__ || Object.getPrototypeOf(FollowmouseComponent)).call(this, props));
	
			_this.state = {
				rotation: 0,
				x: 0,
				y: 0,
				boundingClientRect: {}
			};
			return _this;
		}
	
		_createClass(FollowmouseComponent, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				this.setState({
					boundingClientRect: this.refs.follow.getBoundingClientRect()
				});
	
				document.body.addEventListener("mousemove", function (e) {
					_this2.handleMousemove(e);
				}, false);
	
				document.body.addEventListener("touchmove", function (e) {
					_this2.handleTouchmove(e);
				}, true);
			}
		}, {
			key: 'handleMousemove',
			value: function handleMousemove(event) {
				var x = event.clientX;
				var y = event.clientY;
				this.rotate(x, y);
			}
		}, {
			key: 'handleTouchmove',
			value: function handleTouchmove(event) {
				event.preventDefault(); // we don't want to scroll
				var touch = event.touches[0];
				var x = touch.clientX;
				var y = touch.clientY;
				this.rotate(x, y);
			}
		}, {
			key: 'rotate',
			value: function rotate(x, y) {
				//console.log(x,y,this.refs.follow)
				var width = this.state.boundingClientRect.width / 2;
				var height = this.state.boundingClientRect.height / 2;
	
				var centerX = this.state.boundingClientRect.x + width;
				var centerY = this.state.boundingClientRect.y + height;
	
				var diffX = x - centerX;
				var diffY = y - centerY;
	
				var radians = Math.atan2(diffX, diffY);
				var degree = radians * (180 / Math.PI) * -1 + 90;
	
				this.setState({
					rotation: degree
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var texte = this.props.texte;
	
				var style = {
					transform: "rotate(" + this.state.rotation + "deg)",
					WebkitTransform: "rotate(" + this.state.rotation + "deg)"
				};
				return _react2.default.createElement(
					'div',
					{
						className: 'followmouse-component',
						ref: 'follow',
						style: style },
					_react2.default.createElement(
						'span',
						null,
						texte
					)
				);
			}
		}]);
	
		return FollowmouseComponent;
	}(_react2.default.Component);
	
	FollowmouseComponent.displayName = 'FollowmouseComponent';
	
	// Uncomment properties you need
	// FollowmouseComponent.propTypes = {};
	// FollowmouseComponent.defaultProps = {};
	
	exports.default = FollowmouseComponent;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FollowmouseComponent = __webpack_require__(96);
	
	var _FollowmouseComponent2 = _interopRequireDefault(_FollowmouseComponent);
	
	var _SkillComponent = __webpack_require__(54);
	
	var _SkillComponent2 = _interopRequireDefault(_SkillComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FontAwesome = __webpack_require__(220);
	
	//import 'font-awesome/css/font-awesome.min.css';
	
	var HeaderComponent = function (_React$Component) {
	    _inherits(HeaderComponent, _React$Component);
	
	    function HeaderComponent() {
	        _classCallCheck(this, HeaderComponent);
	
	        return _possibleConstructorReturn(this, (HeaderComponent.__proto__ || Object.getPrototypeOf(HeaderComponent)).apply(this, arguments));
	    }
	
	    _createClass(HeaderComponent, [{
	        key: "render",
	        value: function render() {
	            var _props = this.props,
	                infos = _props.infos,
	                categories = _props.categories;
	            // console.log(categories)
	            // const skills = categories.map( ({data},i) => {
	            //   return <li key={i} >
	            //           <Skill title={data.name[0].text} color={data.color[0].text} context="header" />
	            //         </li>
	            // } )
	
	            return _react2.default.createElement(
	                "header",
	                null,
	                _react2.default.createElement(
	                    "h1",
	                    null,
	                    _react2.default.createElement(
	                        "span",
	                        { className: "logo" },
	                        _react2.default.createElement(_FollowmouseComponent2.default, { texte: "://" })
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: "name" },
	                        infos.title[0].text
	                    )
	                ),
	                _react2.default.createElement(
	                    "nav",
	                    null,
	                    _react2.default.createElement(
	                        "ul",
	                        null,
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "accr",
	                                null,
	                                "_D:"
	                            ),
	                            " DESIGN + CODE"
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "a",
	                                {
	                                    href: "mailto:hello@ahmedghazi.com",
	                                    target: "_blank"
	                                },
	                                _react2.default.createElement(
	                                    "accr",
	                                    null,
	                                    "_M:"
	                                ),
	                                " hello@ahmedghazi.com"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "a",
	                                { href: "tel:+33661497577", target: "_blank" },
	                                _react2.default.createElement(
	                                    "accr",
	                                    null,
	                                    "_T:"
	                                ),
	                                " +(33)661 497 577"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "accr",
	                                null,
	                                "_L:"
	                            ),
	                            " 75018 Paris"
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    "nav",
	                    { className: "connecteurs" },
	                    _react2.default.createElement(
	                        "accr",
	                        null,
	                        "_C:"
	                    ),
	                    _react2.default.createElement(
	                        "ul",
	                        null,
	                        infos.infos.map(function (link, i) {
	                            return _react2.default.createElement(
	                                "li",
	                                { key: i },
	                                _react2.default.createElement(
	                                    "a",
	                                    { href: link.url.url, target: "_blank" },
	                                    _react2.default.createElement(FontAwesome, { name: link.label[0].text })
	                                )
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    "nav",
	                    { className: "skills" },
	                    _react2.default.createElement(
	                        "accr",
	                        null,
	                        "_S:"
	                    ),
	                    _react2.default.createElement(
	                        "ul",
	                        null,
	                        categories.map(function (_ref, i) {
	                            var data = _ref.data;
	                            return _react2.default.createElement(
	                                "li",
	                                { key: i },
	                                _react2.default.createElement(_SkillComponent2.default, {
	                                    title: data.name[0].text,
	                                    color: data.color[0].text,
	                                    context: "header"
	                                })
	                            );
	                        })
	                    )
	                ),
	                _react2.default.createElement(
	                    "nav",
	                    { className: "itw" },
	                    _react2.default.createElement(
	                        "accr",
	                        null,
	                        "_F:"
	                    ),
	                    _react2.default.createElement(
	                        "ul",
	                        null,
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "a",
	                                {
	                                    target: "_blank",
	                                    href: "https://crazycooldevelopers.github.io/interviews/ahmedghazi/"
	                                },
	                                "crazy cool developers"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "a",
	                                {
	                                    target: "_blank",
	                                    href: "https://brutalistwebsites.com/optoopto.eu/"
	                                },
	                                "brutalistwebsites"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "a",
	                                {
	                                    target: "_blank",
	                                    href: "https://klikkentheke.com/catalogue/the-skateboard-soundtracks/"
	                                },
	                                "klikkentheke"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "a",
	                                {
	                                    target: "_blank",
	                                    href: "https://dumplingbooks.fr/composite/composite-1.html",
	                                    rel: "noopener noreferrer"
	                                },
	                                "la revue composite-"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "a",
	                                {
	                                    target: "_blank",
	                                    href: "https://www.wired.it/internet/web/2017/06/20/teleport-me-sito-teletrasporto/"
	                                },
	                                "wired.it"
	                            )
	                        ),
	                        _react2.default.createElement(
	                            "li",
	                            null,
	                            _react2.default.createElement(
	                                "a",
	                                {
	                                    target: "_blank",
	                                    href: "https://www.theguardian.com/artanddesign/2020/nov/25/sacre-bleu-france-as-youve-never-seen-her-before-atlas-eric-tabuchi-nelly-monnier"
	                                },
	                                "the guardian"
	                            )
	                        )
	                    )
	                )
	            );
	        }
	    }]);
	
	    return HeaderComponent;
	}(_react2.default.Component);
	
	HeaderComponent.displayName = "HeaderComponent";
	
	// Uncomment properties you need
	// HeaderComponent.propTypes = {};
	// HeaderComponent.defaultProps = {};
	
	exports.default = HeaderComponent;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _prismicJavascript = __webpack_require__(150);
	
	var _prismicJavascript2 = _interopRequireDefault(_prismicJavascript);
	
	var _reactCookies = __webpack_require__(155);
	
	var _reactCookies2 = _interopRequireDefault(_reactCookies);
	
	var _reactDeviceDetect = __webpack_require__(156);
	
	var _HeaderComponent = __webpack_require__(97);
	
	var _HeaderComponent2 = _interopRequireDefault(_HeaderComponent);
	
	var _ProjectsComponent = __webpack_require__(100);
	
	var _ProjectsComponent2 = _interopRequireDefault(_ProjectsComponent);
	
	var _SmileComponent = __webpack_require__(102);
	
	var _SmileComponent2 = _interopRequireDefault(_SmileComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(235);
	
	var apiEndpoint = 'https://aeai.cdn.prismic.io/api/v2';
	var apiToken = "MC5YVEdWUkJBQUFHY2JJa2li.V--_vTEY77-977-9EE7vv73vv73vv73vv71L77-9UWDvv71h77-9fu-_vT5b77-977-9G2oP77-9UnpY";
	
	var AppComponent = function (_React$Component) {
		_inherits(AppComponent, _React$Component);
	
		function AppComponent(props) {
			_classCallCheck(this, AppComponent);
	
			var _this = _possibleConstructorReturn(this, (AppComponent.__proto__ || Object.getPrototypeOf(AppComponent)).call(this, props));
	
			_this.state = {
				data: null,
				didSmile: _reactCookies2.default.load('didSmile')
			};
			return _this;
		}
	
		_createClass(AppComponent, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				var self = this;
				var api = void 0;
				_prismicJavascript2.default.getApi(apiEndpoint, { accessToken: apiToken }).then(function (_api) {
					api = _api;
					return api.query(_prismicJavascript2.default.Predicates.at('document.type', 'projects'), {
						orderings: '[my.projects.year desc, my.projects.title desc]',
						fetchLinks: ['category.name', 'category.color'],
						pageSize: 100
					});
				}).then(function (response) {
					console.log("Documents: ", response.results);
					var projets = response.results.map(function (project) {
						return project.data;
					});
					// console.log(projets)
					// projets.sort(project => project.sticky = "true")
					self.setState({
						projects: projets
					});
	
					api.query(_prismicJavascript2.default.Predicates.at('document.type', 'category'), { orderings: '[my.category.name]' }).then(function (response) {
						// console.log("Documents: ", response.results);
						self.setState({
							categories: response.results
						});
	
						api.getSingle('options').then(function (document) {
							// console.log("Documents: ", document);
							self.setState({
								options: document.data
							});
						});
					});
				}, function (err) {
					console.log("Something went wrong: ", err);
				});
	
				// fetch('data/projects.json')
				// 	.then(res => res.json())
				// 	.then(data => {
				// 		//console.log(data)
				// 		this.setState({
				// 			data: data
				// 		})
				// 	})
	
				PubSub.subscribe('DID_SMILE', function (e, d) {
					_this2.setState({
						didSmile: true
					});
					_reactCookies2.default.save('didSmile', true, {
						path: '/',
						maxAge: 31556926
					});
				});
			}
	
			// _get()
	
		}, {
			key: 'render',
			value: function render() {
				if (!this.state.options) {
					return _react2.default.createElement(
						'div',
						{ id: 'page' },
						_react2.default.createElement(
							'div',
							null,
							'Loading...'
						)
					);
				} else {
					var _state = this.state,
					    data = _state.data,
					    projects = _state.projects,
					    categories = _state.categories,
					    options = _state.options;
					// console.log(options)
	
					var smile = '';
					if (!this.state.didSmile) {
						smile = _reactDeviceDetect.isIOS == false && _react2.default.createElement(_SmileComponent2.default, null);
					}
	
					//let smile = <SmileComponent />
	
					// /if(this.state.didSmile)smile = '';
					return _react2.default.createElement(
						'div',
						{ id: 'page' },
						_react2.default.createElement(
							'div',
							{ className: 'row' },
							_react2.default.createElement(
								'div',
								{ className: 'col-md-6 infos' },
								_react2.default.createElement(_HeaderComponent2.default, {
									infos: options,
									categories: categories
								})
							),
							_react2.default.createElement(
								'div',
								{ className: 'col-md-6 projects' },
								_react2.default.createElement(_ProjectsComponent2.default, { projects: projects })
							)
						),
						smile
					);
				}
			}
		}]);
	
		return AppComponent;
	}(_react2.default.Component);
	
	AppComponent.defaultProps = {};
	
	exports.default = AppComponent;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pubsubJs = __webpack_require__(26);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _SkillComponent = __webpack_require__(54);
	
	var _SkillComponent2 = _interopRequireDefault(_SkillComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProjectComponent = function (_React$Component) {
	    _inherits(ProjectComponent, _React$Component);
	
	    function ProjectComponent(props) {
	        _classCallCheck(this, ProjectComponent);
	
	        var _this = _possibleConstructorReturn(this, (ProjectComponent.__proto__ || Object.getPrototypeOf(ProjectComponent)).call(this, props));
	
	        _this.state = {
	            visible: true,
	            imageVisible: false
	        };
	
	        //this._onMouseOver = this._onMouseOver.bind(this);
	        return _this;
	    }
	
	    _createClass(ProjectComponent, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            _pubsubJs2.default.subscribe("SKILL_ON", function (msg, data) {
	                var category = _this2.props.project.category;
	
	                var categoryName = category.data.name[0].text;
	                // console.log(categoryName)
	                // const category = this.props.node.data.category.document[0].data.name
	                //     .text
	                if (categoryName === data) {
	                    _this2.setState({
	                        visible: true
	                    });
	                } else {
	                    _this2.setState({
	                        visible: false
	                    });
	                }
	            });
	
	            _pubsubJs2.default.subscribe("SKILL_OFF", function (msg, data) {
	                _this2.setState({
	                    visible: true
	                });
	            });
	        }
	    }, {
	        key: "componentWillUnmount",
	        value: function componentWillUnmount() {
	            _pubsubJs2.default.unsubscribe(this.token);
	        }
	
	        // _onMouseOver() {
	        //     this.state = {
	        //         imageVisible: true,
	        //     }
	        //     //console.log(this.state.imageVisible)
	        // }
	
	    }, {
	        key: "render",
	        value: function render() {
	            // const { project } = this.props
	            var _props$project = this.props.project,
	                title = _props$project.title,
	                url = _props$project.url,
	                year = _props$project.year,
	                category = _props$project.category;
	            // console.log(project)
	
	            // const category = project.category
	            //console.log(category)
	
	            var style = this.state.visible ? { display: "block" } : { display: "none" };
	
	            if (!url) return null;
	            // console.log(url)
	            return _react2.default.createElement(
	                "li",
	                { className: "project-component", style: style, "data-year": year },
	                _react2.default.createElement(
	                    "a",
	                    { href: url[0].text, rel: "noopener noreferrer", target: "_blank" },
	                    _react2.default.createElement(
	                        "sup",
	                        { className: "project-year" },
	                        year
	                    ),
	                    _react2.default.createElement(
	                        "span",
	                        { className: "project-name" },
	                        title[0].text
	                    ),
	                    _react2.default.createElement(
	                        "sup",
	                        { className: "skill" },
	                        _react2.default.createElement(_SkillComponent2.default, {
	                            title: category.data.name[0].text,
	                            color: category.data.color[0].text,
	                            context: "projet"
	                        })
	                    )
	                )
	            );
	        }
	    }]);
	
	    return ProjectComponent;
	}(_react2.default.Component);
	
	ProjectComponent.displayName = "ProjectComponent";
	
	// Uncomment properties you need
	// ProjectComponent.propTypes = {};
	// ProjectComponent.defaultProps = {};
	
	exports.default = ProjectComponent;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ProjectComponent = __webpack_require__(99);
	
	var _ProjectComponent2 = _interopRequireDefault(_ProjectComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProjectsComponent = function (_React$Component) {
	    _inherits(ProjectsComponent, _React$Component);
	
	    function ProjectsComponent(props) {
	        _classCallCheck(this, ProjectsComponent);
	
	        var _this = _possibleConstructorReturn(this, (ProjectsComponent.__proto__ || Object.getPrototypeOf(ProjectsComponent)).call(this, props));
	
	        _this.state = {
	            projects: []
	        };
	        return _this;
	    }
	
	    _createClass(ProjectsComponent, [{
	        key: "componentDidMount",
	        value: function componentDidMount() {
	            var projects = this.props.projects;
	            // console.log(projects)
	            // projects.sort((a, b) => {
	            //     const stickyA = Boolean(a.sticky);
	            //     const stickyB = Boolean(b.sticky);
	            //     //console.log(stickyA, stickyB)
	
	            //     return stickyB - stickyA
	            // })
	            //console.log(projects.edges[0].node.data)
	
	            this.setState({
	                projects: projects
	            });
	        }
	    }, {
	        key: "render",
	        value: function render() {
	            //const { projects } = this.props
	            var projects = this.state.projects;
	
	            if (projects.length === 0) return null;
	
	            // console.log(projects)
	            // const liste = projects.map((project, i) => {
	            //     return <Project key={i} project={project}></Project>
	            // })
	
	            return _react2.default.createElement(
	                "div",
	                { className: "projects-component" },
	                _react2.default.createElement(
	                    "ul",
	                    null,
	                    projects.map(function (project, i) {
	                        return _react2.default.createElement(_ProjectComponent2.default, { key: i, project: project });
	                    })
	                )
	            );
	        }
	    }]);
	
	    return ProjectsComponent;
	}(_react2.default.Component);
	
	ProjectsComponent.displayName = "ProjectsComponent";
	
	// Uncomment properties you need
	// ProjectsComponent.propTypes = {};
	// ProjectsComponent.defaultProps = {};
	
	exports.default = ProjectsComponent;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pubsubJs = __webpack_require__(26);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pModel = __webpack_require__(105);
	var emotionClassifier = __webpack_require__(103);
	var emotionModel = __webpack_require__(104);
	//require('styles//Detector.css');
	
	var DetectorComponent = function (_React$Component) {
		_inherits(DetectorComponent, _React$Component);
	
		function DetectorComponent(props) {
			_classCallCheck(this, DetectorComponent);
	
			var _this = _possibleConstructorReturn(this, (DetectorComponent.__proto__ || Object.getPrototypeOf(DetectorComponent)).call(this, props));
	
			_this.state = {
				emotion: "",
				emotionValue: 0
			};
	
			_this.vid = null;
			_this.overlay = null;
			_this.overlayCC = null;
			_this.ctrack = null;
			_this.emotionClassifier = null;
			_this.emotionData = null;
			_this.trackingStarted = false;
			_this.emotion = "";
			_this.stream = null;
	
			_this.init = _this.init.bind(_this);
			_this.enablestart = _this.enablestart.bind(_this);
			_this.gumSuccess = _this.gumSuccess.bind(_this);
			_this.gumFail = _this.gumFail.bind(_this);
			_this.loop = _this.loop.bind(_this);
			return _this;
		}
	
		_createClass(DetectorComponent, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				var script = document.createElement('script');
				script.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/clmtrackr/1.0.2/clmtrackr.min.js');
				script.addEventListener('load', function () {
					_this2.init();
				});
				document.body.appendChild(script);
	
				_pubsubJs2.default.subscribe('CAMERA_STOP', function (e, d) {
					if (_this2.stream) _this2.stream.getVideoTracks()[0].stop();
				});
			}
		}, {
			key: 'init',
			value: function init() {
				this.vid = document.getElementById('videoel');
				this.vid.addEventListener('canplay', this.enablestart, false);
	
				this.emotionClassifier = new emotionClassifier();
				console.log(emotionModel);
				this.emotionClassifier.init(emotionModel);
				this.emotionData = this.emotionClassifier.getBlank();
	
				pModel.shapeModel.nonRegularizedVectors.push(9);
				pModel.shapeModel.nonRegularizedVectors.push(11);
	
				this.ctrack = new clm.tracker({ useWebGL: true });
				this.ctrack.init(pModel);
				this.trackingStarted = false;
	
				navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
				window.URL = window.URL || window.webkitURL || window.msURL || window.mozURL;
				// check for camerasupport
				if (navigator.mediaDevices) {
					navigator.mediaDevices.getUserMedia({ video: true }).then(this.gumSuccess).catch(this.gumFail);
				} else if (navigator.getUserMedia) {
					navigator.getUserMedia({ video: true }, this.gumSuccess, this.gumFail);
				} else {
					alert("This demo depends on getUserMedia, which your browser does not seem to support. :(");
				}
			}
			/********** check and set up video/webcam **********/
	
		}, {
			key: 'gumFail',
			value: function gumFail(err) {
				alert("Scared of NSA?");
				_pubsubJs2.default.publish('EMOTION', {
					type: "scared",
					value: 0.51
				});
			}
		}, {
			key: 'gumSuccess',
			value: function gumSuccess(stream) {
				this.stream = stream;
	
				// add camera stream if getUserMedia succeeded
				if ("srcObject" in this.vid) {
					this.vid.srcObject = stream;
				} else {
					this.vid.src = window.URL && window.URL.createObjectURL(stream);
				}
				this.vid.onloadedmetadata = function () {
					//adjustVideoProportions();
					//this.vid.play();
				};
			}
		}, {
			key: 'enablestart',
			value: function enablestart() {
				this.ctrack.start(this.vid);
				this.trackingStarted = true;
	
				if (!this._frameId) {
					this._frameId = window.requestAnimationFrame(this.loop);
				}
			}
		}, {
			key: 'loop',
			value: function loop() {
				this._frameId = window.requestAnimationFrame(this.loop);
	
				var cp = this.ctrack.getCurrentParameters();
				var er = this.emotionClassifier.meanPredict(cp);
				if (er) {
					//updateData(er);
					for (var i = 0; i < er.length; i++) {
						//console.log(er[i])
						if (er[i].emotion == "happy") {
							//console.log(er[i].value)
							_pubsubJs2.default.publish('EMOTION', {
								type: er[i].emotion,
								value: er[i].value
							});
						}
					}
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					{ className: 'detector-component' },
					_react2.default.createElement('video', { id: 'videoel', width: '400', height: '300', preload: 'auto', loop: true, playsInline: true, autoPlay: true }),
					_react2.default.createElement(
						'div',
						null,
						this.state.emotion
					),
					_react2.default.createElement(
						'div',
						null,
						this.state.emotionValue
					)
				);
			}
		}]);
	
		return DetectorComponent;
	}(_react2.default.Component);
	
	DetectorComponent.displayName = 'DetectorComponent';
	
	// Uncomment properties you need
	// DetectorComponent.propTypes = {};
	// DetectorComponent.defaultProps = {};
	
	exports.default = DetectorComponent;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(67);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _pubsubJs = __webpack_require__(26);
	
	var _pubsubJs2 = _interopRequireDefault(_pubsubJs);
	
	var _DetectorComponent = __webpack_require__(101);
	
	var _DetectorComponent2 = _interopRequireDefault(_DetectorComponent);
	
	var _circletype = __webpack_require__(106);
	
	var _circletype2 = _interopRequireDefault(_circletype);
	
	var _animations = __webpack_require__(95);
	
	var _animations2 = _interopRequireDefault(_animations);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//require('styles//Smile.css');
	
	var SmileComponent = function (_React$Component) {
		_inherits(SmileComponent, _React$Component);
	
		function SmileComponent(props) {
			_classCallCheck(this, SmileComponent);
	
			var _this = _possibleConstructorReturn(this, (SmileComponent.__proto__ || Object.getPrototypeOf(SmileComponent)).call(this, props));
	
			_this.dom = {};
			_this.state = {
				emotion: "",
				emotionValue: 0.45,
				message: "Smile! ",
				radius: 900,
				isHidden: false
			};
	
			_this.circleType = null;
			return _this;
		}
	
		_createClass(SmileComponent, [{
			key: 'componentWillEnter',
			value: function componentWillEnter(cb) {
				_animations2.default.show(this.dom.root, cb);
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				this.dom.root = _reactDom2.default.findDOMNode(this);
	
				this.circleType = new _circletype2.default(document.getElementById('smile-component'));
				this.updateCircleText(1);
				//return
				var token = _pubsubJs2.default.subscribe('EMOTION', function (e, d) {
					//console.log(d)
					var emoji = d.value > 0.5 ? ":)" : ":(";
					_this2.setState({
						emotion: emoji,
						emotionValue: d.value.toFixed(4)
					});
					//console.log(d.value, d.value*1000)
					if (d.value > 0.5) {
						_this2.updateCircleText(-1);
	
						_pubsubJs2.default.unsubscribe(token);
	
						_pubsubJs2.default.publish('CAMERA_STOP');
						setTimeout(function () {
							_animations2.default.zoomOut(_this2.dom.root, function () {
								_this2.setState({
									isHidden: true
								});
								_pubsubJs2.default.publish('DID_SMILE');
							});
						}, 500);
					} else {
						_this2.updateCircleText(1);
					}
				});
			}
		}, {
			key: 'updateCircleText',
			value: function updateCircleText(dir) {
				var radius = void 0;
				if (dir < 0) radius = this.state.radius - (100 + this.state.emotionValue * 100 * 500 / 100);
				if (dir > 0) radius = 500 + this.state.emotionValue * 100 * 500 / 100;
	
				//console.log(this.state.emotionValue * 100, radius)
				//this.circleType.radius(this.state.radius).dir(dir);
				this.circleType.radius(radius).dir(dir);
			}
		}, {
			key: 'render',
			value: function render() {
				var smileWrapStyle = {
					background: this.state.emotionValue >= 0.5 ? "#ffffcc" : "#fff"
				};
				var jaugeStyle = {
					height: this.state.emotionValue * 100 + "%"
				};
				if (this.state.isHidden) {
					return _react2.default.createElement('div', null);
				} else {
					return _react2.default.createElement(
						'div',
						{ className: 'overlay' },
						_react2.default.createElement(
							'div',
							{ id: 'smile-wrap', style: smileWrapStyle },
							_react2.default.createElement(
								'div',
								{ className: 'inner' },
								_react2.default.createElement(
									'div',
									{ className: 'eyes' },
									_react2.default.createElement(
										'div',
										{ className: 'eye' },
										_react2.default.createElement(
											'div',
											null,
											this.state.message
										),
										_react2.default.createElement(
											'div',
											null,
											this.state.message,
											' ',
											this.state.message
										)
									),
									_react2.default.createElement(
										'div',
										{ className: 'eye' },
										_react2.default.createElement(
											'div',
											null,
											'Smile!'
										),
										_react2.default.createElement(
											'div',
											null,
											this.state.message,
											' ',
											this.state.message
										)
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'noze' },
									_react2.default.createElement(
										'div',
										null,
										this.state.message
									),
									_react2.default.createElement(
										'div',
										null,
										this.state.message,
										' ',
										this.state.message
									)
								),
								_react2.default.createElement(
									'div',
									{ id: 'smile-component' },
									this.state.message,
									' ',
									this.state.message,
									' ',
									this.state.message,
									' ',
									this.state.message,
									' ',
									this.state.message,
									' ',
									this.state.message
								),
								_react2.default.createElement(
									'div',
									{ className: 'jauge', style: jaugeStyle },
									_react2.default.createElement(
										'div',
										{ className: 'value' },
										Math.round(this.state.emotionValue * 100),
										'%'
									),
									_react2.default.createElement(
										'div',
										{ className: 'emotion' },
										this.state.emotion
									)
								)
							),
							_react2.default.createElement(_DetectorComponent2.default, null)
						)
					);
				}
			}
		}]);
	
		return SmileComponent;
	}(_react2.default.Component);
	
	SmileComponent.displayName = 'SmileComponent';
	
	// Uncomment properties you need
	// SmileComponent.propTypes = {};
	// SmileComponent.defaultProps = {};
	
	exports.default = SmileComponent;

/***/ }),
/* 103 */
/***/ (function(module, exports) {

	'use strict';
	
	var emotionClassifier = function emotionClassifier() {
	
		var previousParameters = [];
		var classifier = {};
		var emotions = [];
		var coefficient_length;
	
		this.getEmotions = function () {
			return emotions;
		};
	
		this.init = function (model) {
			// load it
			for (var m in model) {
				emotions.push(m);
				classifier[m] = {};
				classifier[m]['bias'] = model[m]['bias'];
				classifier[m]['coefficients'] = model[m]['coefficients'];
			}
			coefficient_length = classifier[emotions[0]]['coefficients'].length;
		};
	
		this.getBlank = function () {
			var prediction = [];
			for (var j = 0; j < emotions.length; j++) {
				prediction[j] = { 'emotion': emotions[j], 'value': 0.0 };
			}
			return prediction;
		};
	
		this.predict = function (parameters) {
			var prediction = [];
			for (var j = 0; j < emotions.length; j++) {
				var e = emotions[j];
				var score = classifier[e].bias;
				for (var i = 0; i < coefficient_length; i++) {
					score += classifier[e].coefficients[i] * parameters[i + 6];
				}
				prediction[j] = { 'emotion': e, 'value': 0.0 };
				prediction[j]['value'] = 1.0 / (1.0 + Math.exp(-score));
			}
			return prediction;
		};
	
		this.meanPredict = function (parameters) {
			// store to array of 10 previous parameters
			previousParameters.splice(0, previousParameters.length == 10 ? 1 : 0);
			previousParameters.push(parameters.slice(0));
	
			if (previousParameters.length > 9) {
				// calculate mean of parameters?
				var meanParameters = [];
				for (var i = 0; i < parameters.length; i++) {
					meanParameters[i] = 0;
				}
				for (var i = 0; i < previousParameters.length; i++) {
					for (var j = 0; j < parameters.length; j++) {
						meanParameters[j] += previousParameters[i][j];
					}
				}
				for (var i = 0; i < parameters.length; i++) {
					meanParameters[i] /= 10;
				}
	
				// calculate logistic regression
				return this.predict(meanParameters);
			} else {
				return false;
			}
		};
	};
	
	module.exports = emotionClassifier;

/***/ }),
/* 104 */
/***/ (function(module, exports) {

	'use strict';
	
	var emotionModel = {
		'angry': {
			'bias': -2.3768163629,
			'coefficients': [-0.026270300474413848, 0.037963304603547195, 0.25318394482150264, -0.36801694354709802, -0.059638621925431838, 6.3145056900010567e-17, 0.094520059272651849, 0.21347244366388901, 0.42885313652690621, -1.5592214434343613e-14, 0.13850079872874066, -5.1485910666665307e-16, 0.33298910350203975, 8.0357363919330235e-16, 0.0025325096363696059, -0.44615090964065951, -1.5784656134660036e-15, 0.047596008125675944]
		},
		'disgusted': {
			'bias': -2.27900176842,
			'coefficients': [0.042360511043701296, 0.1282033922181087, 0.12391812407152457, -0.27567823277270387, 0.1421150306247343, -3.1081856766624292e-16, 0.12612972927139088, 0.23426310789552218, 0.058894842405560956, -4.0618311657856847e-15, 0.22340906131116328, -5.81584759084207e-15, 0.25735218595500009, 1.3658078149815552e-15, -0.12506850140605949, -0.9463447584787309, -4.555025133881674e-15, 0.07141679477545719]
		},
		'fear': {
			'bias': -3.40339917096,
			'coefficients': [-0.1484066846778026, -0.090079860583144475, -0.16138464891003612, 0.078750143250805593, 0.070521075864349317, 3.6426173865029096e-14, 0.54106033239630258, 0.049586639890528791, -0.10793093750863458, -5.1279691693889055e-15, -0.092243236155683667, -1.5165430767377168e-14, 0.19842076279793416, 3.8282960479670228e-15, -0.67367184030514637, -0.2166709100861198, 1.1995348541944584e-14, -0.20024153378658624]
		},
		'sad': {
			'bias': -2.75274632938,
			'coefficients': [0.092611010001705449, -0.12883530427748521, -0.068975994604949298, -0.19623077060801897, 0.055312197843294802, -3.5874521027522394e-16, 0.46315306348086854, -0.32103622843654361, -0.46536626891885491, 1.725612051187888e-14, -0.40841535552399683, 2.1258665882389598e-14, 0.45405204011625938, 5.9194289392226669e-15, 0.094410500655151899, -0.4861387223131064, -3.030330454831321e-15, 0.73708254653765559]
		},
		'surprised': {
			'bias': -2.86262062696,
			'coefficients': [-0.12854109490879712, -0.049194392540246726, -0.22856553950573175, 0.2992140056765602, -0.25975558754705375, 1.4688408313649554e-09, -0.13685597104348368, -0.23581884244542603, 0.026447180058097462, 1.6822695398601112e-10, 0.095712304864421921, -4.4670230074132591e-10, 0.40505706085269738, 2.7821987602166784e-11, -0.54367856543588833, -0.096320945782919151, 1.4239801195516449e-10, -0.7238167998685946]
		},
		'happy': {
			'bias': -1.4786712822,
			'coefficients': [0.014837209675880276, 0.31092627456808286, -0.1214238695400552, 0.45265837869400843, 0.36700140259900887, 1.7113646510738279e-15, -0.4786251427206033, -0.15377369505521801, -0.16948121903942992, 6.0300272629176253e-15, -0.021184992727875669, -6.9318606881292957e-15, -0.81611603551588852, -3.7883560238442657e-15, 0.1486320646217055, 0.94973410351769527, 3.6260400713070416e-15, -0.31361179943007411]
		}
	};
	
	module.exports = emotionModel;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';(function(global){'use strict';var pModel={'scoring':{'size':[20,22],'bias':-1.3970965781063711,'coef':[-0.019443206312618266,-0.0084626551369373984,-0.0056439963412376806,-0.0030632716896851417,0.0050581938798613096,0.0038671999692946632,0.0073781421893252819,0.008408844556368901,0.0021079916674897471,0.0088021517989660455,0.0084634202851292546,0.0091341881048755593,0.0021677708519095705,0.0057905826022958259,0.010027042924308791,0.010018015835686447,0.011074574130386098,-0.00061695783617744283,-0.0060840083569450205,-0.0094487678808903661,-0.012441209862965338,-0.0038650406223106025,-0.00031049888008515014,0.003187872856386012,0.0078183021180926356,0.010960251877128001,0.012100913210202307,0.012289318801648701,0.012872315936395949,0.0134197639066574,0.012863004278393353,0.012570470005854794,0.0144288424245574,0.013339430524005279,0.013248442014867023,0.012998181709015256,0.0080561986303109411,0.0014670228332206666,-0.011928206846124195,-0.0097909276659884133,-0.019951337591485003,-0.014601516863452837,-0.013174779761633797,-0.0060514903696567476,-0.0010407140556988824,0.0054650997555345483,0.010448591237341475,0.014061216421035866,0.015918382919452134,0.016360925963435087,0.02175676516818845,0.017301016139781272,0.014195207612699818,0.012452400847919372,0.010454129710215853,0.0040883019269826832,-0.0014194361456059026,-0.0038498599142176948,-0.010769873280441659,-0.011758097810167857,-0.0046927302624985654,-0.0022134112349382041,-0.0039804434067522172,-0.012186682535867691,-0.011886732829841436,-0.008198434083715244,0.0028353930104073055,0.0070820189528775831,0.012238372017639833,0.016348014515026394,0.020980251210150468,0.01731275318263429,0.01186526524722499,0.007237133559106634,0.0028787582373227981,-0.007467321804467685,-0.012293394385884527,-0.014833951237083715,-0.0083886394867411403,-0.001277206299448029,-0.0043237762267366413,-0.00079995554890789644,-0.0090446939377834615,-0.015715154398522533,-0.016374353020164909,-0.018048467332774626,-0.012034275948581882,-0.0072430439975880896,0.00051252407841081971,0.013091943912572559,0.018570409085074381,0.013098815816852492,0.0008591564011330168,-0.0064555113363009954,-0.014574145037132261,-0.018221531408352937,-0.01805986873321162,-0.016665959992610131,-0.016742981997331947,-0.012862200876738698,-0.037408776782215991,-0.026830315322269691,-0.036692867895355551,-0.034788073944897399,-0.021885031967903899,-0.024484660949111742,-0.028068870569776663,-0.018631752402912666,0.00033862502266578511,0.01559117928255003,0.021178968053305464,0.015184030917486158,0.002942909802540911,-0.014374637994945122,-0.025568052116952664,-0.025717989966112242,-0.023218559873459776,-0.043064179414035626,-0.042244667490572319,-0.040560989397592062,-0.029282249261991376,-0.037097180414959283,-0.050209371445049687,-0.043175446636272506,-0.038799263945784764,-0.037913350312177137,-0.024596940746816367,-0.013391546719824746,0.0026176056292311106,0.0161600431397954,0.021950494557360537,0.018824694902420232,0.006927363884398058,-0.0067099747768306958,-0.018258612142465137,-0.031150030943545643,-0.030987027023796063,-0.033628054995754796,-0.043437053800875543,-0.034534827602693656,-0.0027688241949539527,-0.0045492751804971556,-0.0029637241504820444,-0.0034067004234806259,-0.0058158675916083176,-0.0050003474884839725,-0.0052189027673953392,-0.0035094302696121191,0.0048075866050476977,0.015230282965296896,0.017877023790346995,0.015060123226282708,0.0068301148455019063,-0.00074735425779775112,-0.0047129224250249081,-0.0020172475601060438,-0.0028733715759857248,-3.2165259563759688e-05,0.0052576318460990619,0.0043528918718454875,0.016945619656148794,0.015930900625567117,0.013751773645422991,0.010130474427749569,0.0080480898297084717,0.0066539674397816983,0.0068324700348844428,0.0069577044114707276,0.0040399129489101342,0.011715241103133139,0.017439724961211336,0.014273924944517397,0.0061485975492234337,0.0064501329867605404,0.0064154824267410098,0.0087972617488658849,0.0085371084737999835,0.0087282112830335563,0.011782866421798245,0.016746943082334282,0.022118218282678175,0.020835875059091086,0.018311801034637344,0.01589801188949137,0.017833422960512931,0.01556573659143182,0.014048773907766661,0.0092415766206588174,0.008151842723012729,0.011230814598071655,0.01256801671117759,0.012111623945116202,0.0098381741274288295,0.0073611628026903006,0.0095541157333664112,0.011727533965135649,0.018125902932239795,0.019469248207063541,0.017398513191690286,0.021144199041044975,0.021132145666912093,0.019499184169656004,0.019592876054570843,0.02028149781228069,0.017450605090846959,0.01415914728419608,0.0062290511445100638,0.0038367364618697264,0.0070206311493656928,0.0096561161467108754,0.011406409148288063,0.0073273774756050288,0.0046725824974188255,0.0052535602992445293,0.00018758422847375771,0.0081523629612461953,0.012760089024104778,0.021600004613459223,0.02330330354276354,0.023745752734397885,0.018230549428489853,0.020013388637927079,0.019842171101705101,0.018799688221643948,0.010638029835974899,0.00047497591850582786,-0.0071779359181283857,-0.0013492660142831474,0.0015382005340972228,0.0026091901041104195,0.00054046824549715592,-0.00049664221846118756,-0.0004620349686195485,-0.0052440228766081143,-0.0052152354482096451,-0.010002649985436339,0.0014386382744505852,0.012845063185194877,0.020827676960957435,0.02373841052172394,0.015716685713465389,0.01638066669873605,0.014902611437895159,0.0073730357797861029,0.0019356373041797752,-0.0061999712321189927,-0.0091165414771389678,-0.008810991502401562,-0.014849548271736901,-0.002088752298238026,0.0052140970488441726,0.0010527273675475608,-0.010321625138183299,-0.016207678046552692,-0.012439252596672909,-0.013087206027715756,-0.0027969969285832111,0.0023632017053047227,0.011157492323637063,0.018368837091378775,0.009522424063657664,0.010552085697652452,0.0065611074700353111,-0.0015314856230301123,-0.0032492038209889869,-0.0031329857351426339,-0.0009277374824954263,-0.0020968871213430215,-0.002752601764726735,0.00094388371290420677,5.9164336949845309e-05,-0.0017254679888374039,-0.0034420772687673035,-0.0045773609585904318,-0.0025304599008137956,-0.00038215561598060812,0.00057078584536244593,0.0031325966195568239,0.0060237831417333659,0.01158476991744758,0.0016262584963572593,0.0032288122743198387,0.0012532877511827127,0.00062747794288786391,0.0023766730707680218,0.0028182202873619686,0.0023771129569157626,-0.0033402786707182365,-0.0048954226369167918,0.0030746977489523515,0.0062648590670420657,0.0050231159304044643,0.00044657525636142406,-0.0048270904988737106,-0.0040237200076292511,0.0024988183457590458,0.0054580394659512529,0.0072880311920233637,0.0036009634090189563,0.010569246292394684,-0.0045836905885612515,0.00057936439982262571,0.00102991877614139,0.0030014799750564766,0.0036675159287522449,0.0044718005821969111,0.0068927421100514214,0.0039124352937196984,0.007139428500837236,0.010304447674314087,0.012609007891982103,0.008958913992549505,0.0086037912511740151,0.0055408494888294774,0.0046721790312300258,0.0047921200350865495,0.0058818201004558757,0.0056047225724042979,0.0054112450019911731,0.0073264985149536482,-0.0027341865318231302,-0.0027247005346668829,-0.0034900498414649531,-0.0079957154687285564,-0.0040761105067111218,-0.0020778048501128819,-0.0028478822594267903,-0.0039662744056797195,-0.0026161203530461301,0.00092611267411275692,0.0017426886986748021,0.00055187058776232881,-0.0013723391980049371,-0.0045995868862228262,-0.004201475995629732,-0.0054721778518871953,-0.002341678055566526,-0.0025440841811939178,-0.0078777546807155367,5.340267621167532e-05,0.0046873465713941241,0.0021887942815206605,0.0013036188253628853,-0.001369820467079858,-0.015804998363084376,-0.016267691007421516,-0.018900936626522147,-0.017659450320792951,-0.011812605534381678,-0.0034436129735933847,-0.0023483321715621502,-0.0050111463464252073,-0.0050922386240516513,-0.015030789874247219,-0.020198024497642013,-0.021620507739756673,-0.018586140603325793,-0.018723839025246693,-0.0055722698499209482,0.0064480458300502788,0.0026822651632485931,0.0060010017569890623,0.0039986244661379938,0.0050813259426419084,-0.0059114072323689293,-0.027745788024718613,-0.029251292823436387,-0.023066523347947315,-0.017210413752997977,-0.015963112589643183,-0.021075188283476324,-0.023666705491108494,-0.020005598090990763,-0.019062969033403668,-0.017792117192348619,-0.025322677372927888,-0.020971240352056199,-0.003436645553932082,0.0043350896839554273,0.0084557183627534376,-0.0063213373221792614,-0.0012841346959162978,-0.0012350140140767124,0.004020967306281667,0.0092274867614143326,0.0045264965008091395,0.0041315898134410677,0.00077108445452623935,0.0017580819918377949,-0.0011577021001876594,-0.0036195352433658614,-0.0037319908665914719,-0.001666179302724247,0.0031110879435167255,0.0014906582671670387,0.0048443015054418677,0.0059990829294203933,0.0084750979219295353,0.0055827168912293912,0.0025145315352065756,-0.0046319230006191276,-0.0076182514283882324,-0.0046593775053102001,-0.0031253513278243637,0.0074653367528114828,0.010125926733440484,0.0094747053616804754,0.0035657571954442512,0.0057833695060832482,0.003888133034710705,0.0019960148005530504,0.0015056031401225207,0.0011132050024144288,0.0054876547928768482,0.0047365733649033419,0.0072106350627162141,0.010077746417547511,0.0038570243972044947,-0.003118757327733293,8.694979275512165e-05,-0.021441387266543339,-0.0072102976069877674,-0.0078359058223554552,-0.00594066743311885,-0.0016100298225058601,0.0053450064816458259,0.0071049496578081076,0.010196875445129471,0.0057577873293374569,0.0074570800047582559,0.0062731053175082022,0.0076242083673520502,0.0068436930933054993,0.0070021422399430639,0.0087250840640590785,0.0089995789681808595,0.0034314447644411355,-0.001989159567628072,-0.007896602411841893,-0.010924672368545567]},'path':{'normal':[[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14],[15,16,17,18],[19,20,21,22],[23,63,24,64,25,65,26,66,23],[28,67,29,68,30,69,31,70,28],[34,35,36,42,37,43,38,39,40],[33,41,62],[44,45,46,47,48,49,50,51,52,53,54,55,44,56,57,58,50,59,60,61,44],27,32],'vertices':[// jawline
	[0,1,23,0],[1,23,66,1],[1,2,66,1],[2,66,26,2],[2,26,35,2],[2,35,36,2],[2,36,3,2],[36,44,45,36],[3,4,44,3],[3,44,36,3],[4,44,55,4],[4,5,55,4],[5,55,54,5],[5,6,54,5],[6,53,54,6],[6,7,53,6],[7,8,53,7],[8,52,53,8],[8,9,52,8],[9,51,52,9],[9,10,51,9],[10,50,51,10],[10,11,50,10],[11,38,50,11],[11,12,38,11],[12,38,39,12],[12,31,39,12],[12,31,70,12],[12,13,70,12],[13,28,70,13],[13,14,28,13],// right eyebrow
	[14,15,28,14],[15,28,67,15],[15,16,67,15],[16,67,29,16],[16,17,29,16],[17,68,29,17],[17,18,68,17],[18,68,30,18],[18,30,33,18],// below eyes
	[30,40,69,30],[39,40,69,39],[39,31,69,39],[26,65,35,26],[34,35,65,34],[25,34,65,25],// left eyebrow
	[22,25,33,22],[22,25,64,22],[21,22,64,21],[21,24,64,21],[20,21,24,20],[20,24,63,20],[19,20,63,19],[19,23,63,19],[19,23,0,19],// below nose
	[36,45,46,36],[36,42,46,36],[42,37,46,42],[37,46,47,37],[46,37,47,46],[37,47,48,37],[38,48,49,38],[37,43,48,37],[43,38,48,43],[38,49,50,38],// nose region
	[22,18,33,22],[40,41,30,40],[25,33,41,25],[33,41,30,33],[25,34,41,25],[41,40,62,41],[34,41,62,34],[34,35,62,34],[35,36,62,35],[36,42,62,36],[42,37,62,42],[37,43,62,37],[43,38,62,43],[38,39,62,38],[39,40,62,39],// mouth
	[44,45,61,44],[45,46,61,45],[46,47,61,46],[47,61,60,47],[47,59,60,47],[47,48,59,47],[48,49,59,48],[49,50,59,49],[50,51,58,50],[51,52,58,51],[52,57,58,52],[52,53,57,52],[53,54,57,53],[54,56,57,54],[54,55,56,54],[44,55,56,44],// left eye
	[23,63,27,23],[63,24,27,63],[24,64,27,24],[64,25,27,64],[25,65,27,25],[65,26,27,65],[26,66,27,26],[66,23,27,66],// right eye
	[28,67,32,28],[67,29,32,67],[29,68,32,29],[68,30,32,68],[30,69,32,30],[69,31,32,69],[31,70,32,31],[28,32,70,28]]},'patchModel':{'patchType':'SVM','bias':{'raw':[-0.964306520867,-1.03566919244,-0.874989992149,-0.916328634351,-0.84503678968,-0.844297101434,-0.738523173234,-0.808714131663,-0.726541145855,-0.843675312327,-0.869822246614,-0.917260263832,-0.873711733476,-1.02671396751,-0.98146088848,-0.873014174242,-1.02044597636,-1.05803547484,-1.22124828051,-0.881683950651,-1.03317042471,-1.05134750237,-1.24054665894,-1.16383797435,-1.06699587696,-1.23916761432,-1.18767751229,-1.12345203915,-1.13546600331,-1.08024044629,-1.24021266444,-1.16700091429,-1.11195019559,-0.729540672833,-1.12391599663,-1.3005410545,-1.31472443469,-1.08705339489,-1.33623226644,-1.32469845456,-1.11491083141,-0.762875763426,-1.12163285295,-1.09863140074,-1.29945157973,-1.27843894877,-1.00589316549,-0.912330645934,-0.962922353705,-1.25265133142,-1.29458347282,-1.15225762288,-1.00045652806,-0.887710450269,-1.01416634829,-1.19650803217,-1.03872671577,-0.86719070075,-1.008904644,-1.12379151191,-0.950687461141,-1.12241433736,-0.889224862634,-1.11762094609,-1.22489133968,-1.24702333407,-1.24517637612,-1.09819559472,-1.2104134101,-1.2217112657,-1.17731763127],'sobel':[-0.83934766225,-0.62721260575,-0.558840580329,-0.699564404116,-0.711116468654,-0.800405507582,-0.800598028802,-1.11367567263,-0.800716892269,-0.800194374505,-0.719852733547,-0.699662339749,-0.583473094463,-0.656586463686,-0.82585939445,-0.777588904797,-0.772328358153,-0.858083769483,-0.819377339675,-0.764279660704,-0.799960100345,-0.867018791717,-0.823023270097,-0.742640730114,-1.00863469391,-0.717177931342,-0.795282566734,-0.882814402127,-0.781504747967,-0.996713581871,-0.712255820555,-0.811275119279,-0.961002025204,-1.20550193802,-0.862430611162,-0.755762286162,-0.788966054175,-0.962730404866,-0.785589168563,-0.783168017095,-0.891439881469,-1.08053052724,-0.818953010952,-0.823990582718,-0.610975113014,-0.706369334087,-0.83607795072,-0.86536700094,-0.861887789379,-0.706860677903,-0.604669076545,-0.638959509959,-0.600205200156,-0.601208908689,-0.600265306283,-0.666594192176,-0.706937637112,-0.806432197551,-0.701267093778,-0.697408794637,-0.851407473703,-0.696453841977,-1.00957402773,-0.888081735997,-0.883778307995,-0.801014108655,-0.802707601144,-0.902478661063,-0.867497240701,-0.826525935114,-0.828361611411],'lbp':[-1.2775026474,-0.801223028353,-0.800091623644,-0.800009851969,-0.706840077597,-0.771744181593,-0.764756730848,-0.668987349384,-0.722732252285,-0.669412768606,-0.599571546235,-0.799859783453,-0.800085025062,-0.800151690407,-0.800453693963,-0.770896454141,-0.657297455691,-0.599810309052,-0.583090394926,-0.952970571559,-0.7654582373,-0.799938792024,-0.727414989246,-1.31723075305,-1.14076054405,-1.33781061842,-1.40029321489,-1.29006497698,-1.28367040173,-1.15693629435,-1.21680694398,-1.40041878805,-1.29047691479,-0.928378863331,-0.926795080454,-0.921170431637,-0.911039053934,-0.843072087859,-0.863356945439,-0.975893430292,-0.891645275689,-1.19772729821,-0.994481526443,-0.974741126221,-0.796142704788,-0.771301703397,-0.911422811844,-0.920856682866,-0.865902542856,-0.849751055127,-0.806605497263,-1.05057278424,-1.21923288747,-1.3182935345,-1.30915908452,-0.608079191461,-0.939755202343,-1.10582615252,-1.02794612196,-0.913831959238,-0.874524304042,-0.818753505759,-1.06509012802,-1.18557061801,-1.18891869024,-1.3461331468,-1.39693404573,-1.19088607628,-1.13830203374,-1.37361790282,-1.39128680085]},'weights':{'raw':[[-0.00641929350098569,0.029808749809618604,-0.026783847528159686,-0.022626445601288438,-0.067696544783929641,-0.33308017010587532,0.028196651717386736,0.18244853629138108,0.015034328565348129,0.067852736181546511,0.066707601028042948,0.043757744772933718,-0.049432046935464227,0.028764976579739795,-0.023780221712776294,-0.019043996534914023,-0.14597609954565341,0.076748129651230637,0.10031267415956342,0.022404267686006132,0.039489304810642681,-0.069172555941927991,0.064453930612007271,-0.03568078024136126,0.029477578218046946,0.013670321310075631,-0.040086746434879458,-0.16483725729324836,0.060739714509717116,0.1342127393151894,0.02422269183439342,-0.023179439720271901,-0.023938362360883966,0.00080564472822024918,-0.020188203981491876,0.035394353296754666,0.0205064246422616,0.028993448164401289,-0.15875938903288647,0.086380176300005287,0.069612353949308661,-0.0051496283178931873,-0.086212516632916264,-0.11615256372599751,-0.10171915312404266,0.05044362294149464,-0.010944856179506302,-0.0019939577905011829,-0.082496323737375032,-0.19805282268418445,0.14503065839704138,0.10472965706111854,-0.054504100655757171,0.058558989674775644,0.02150968078817124,0.01730546008925736,0.05479743583896092,0.081449861658568032,-0.015926761159011912,-0.026645825852455899,-0.29395789604640399,0.26045433455042083,-0.014750981039322313,0.013565969503019568,-0.052043696631421672,-0.068507656016080665,0.026714598423665525,0.015030040573038209,-0.0036695544345779346,0.0038325864743167098,-0.029296334816602605,-0.2168604461047042,0.23218142341105868,-0.00327038976446066,0.0010937576464049442,0.022865074396730092,-0.0024710599676689565,0.027138580199090406,-0.016798852895205371,0.052896545591113953,0.0068773632280050567,-0.11534615443720748,-0.20002833023471947,0.26776687274414374,-0.012990564848598472,0.014507044952519324,-0.028376794482919257,0.0061821648519400502,0.088921914606219496,-0.029268623822226371,0.023549402065920405,0.0050119768662514469,-0.10302390187256479,-0.11265110616376864,0.2362166399750627,-0.023189771813893006,0.0035722520614683423,-0.034182137066625137,0.050630393094575593,0.010945258403000244,-0.0026518946618147438,-0.025155322122281942,0.028530077090590744,-0.13115618895267522,-0.093256001395012889,0.16420560614466395,-0.010547265652414012,0.035550139332521893,-0.020259214475918323,0.022466567725035011,0.034170311222605998,0.11907609035635143,-0.0015743444390024786,-0.064020366156778002,-0.22057027736788293,-0.072309973907480174,0.30204671935473221,0.023274069917025395,0.063584377222264996,0.042978528220157006,0.1184620505912367],[0.16667514507181941,-0.061056496077366282,0.0069211233964510538,0.017084537322497012,-0.2260817686595176,-0.3734473319351409,0.079940868263823905,0.16478474110226196,0.022649460741459224,0.05289358066562716,0.029321578215087005,-0.065686830769126472,-0.017175099236391184,0.05342642508666981,0.13196524692583625,-0.038915970355677662,-0.22142105635118151,0.17018889180755431,0.037968714516855254,0.032433038579621432,0.013114263754535838,-0.0047139766817905979,0.01449378481921762,0.016836144088159047,-0.035382521979389493,0.06459440929029997,-0.16864194241367311,-0.18183649747692435,0.22011199704153209,0.017097680726078424,0.044439120834852616,-0.065744647597146183,0.1020917702829201,0.012977428388828996,0.019775964936306969,-0.020715077614501087,0.037536099617302823,0.073188143789734553,-0.2573933108232303,0.17910460975300116,-0.012201308491933793,-0.012488637353357972,-0.027937934041822002,0.090839519859215512,0.056061692281274847,-0.029592134951326149,0.083797375549624048,0.026909019608009989,0.028447256194293238,-0.26724295246437862,0.17601512398468455,0.05747403764496381,-0.021754451570897559,-0.016094120395692652,0.034960605520111765,-0.066136093799398984,-0.086822275816825112,0.021267627399376515,0.024913839061514578,0.083351248045442958,-0.21233918154488879,0.14528347788592133,0.052103220110131521,0.0060526935312730304,0.0041057956922075783,0.073742527231735508,-0.063150982285070517,0.071706513280739251,0.050276967845660783,0.059473860357975208,0.041092776845037343,-0.23158549693983016,0.039824353302363641,0.035168096441852537,-0.03932662577032886,-0.046713411712221917,-0.029438846368243326,0.03037322262500354,0.010642421674176408,0.035443098233173931,-0.064897369310492531,-0.032863903246691833,-0.15394029962311223,0.011777952930909712,0.17418487412288675,-0.05475758571404693,0.047924066013688642,0.054346490005779069,-0.0033548564463232317,0.023589666170022047,-0.024599944457705122,0.06065500572988429,0.13656620662733865,-0.09366338113990888,-0.047444407722275428,0.062872719444471176,-0.022728230791896249,-0.027266120729298168,0.12949378554678781,-0.016064969466370635,-0.029023009596784263,-0.055703343306378029,-0.084010725120186397,0.067582673095362464,-0.021201313484205356,-0.12021659219227125,0.094859360168578946,-0.023785622470961085,-0.031181057005649077,-0.0045461011994782641,-0.00096878041950868021,0.075435938022599638,0.010017282477206416,0.06897995798959812,0.077147960801012536,0.01605850787004124,-0.19045442262141093,-0.010877182945437318,0.12221413195895285,-0.035115541235648702,0.061957485103634649],[0.0011017024675275405,-0.10082831174460544,8.594795150784762e-05,-0.0044220494782738484,-0.096739526280002486,-0.13240523784777558,0.13984373949584222,-0.0031378754168676498,0.068399621371189656,0.041644858137291046,0.12466035423467051,0.057468796042489417,0.073611208985683574,-0.010863604812754085,0.0048406348200145249,0.016396206458863971,-0.021671035744779854,0.044733205419186794,0.067921565834977882,-0.01587229208239721,-0.055943430884781355,0.01970238776563854,0.01861633041967882,-0.0056589566846889511,0.034037512362465189,0.034411475082115867,-0.10871009154186473,-0.08095953984145883,0.067427623282556901,-0.019879897471494754,-0.01366520816807866,0.035789793103949114,0.066231396371961834,-0.045917999777744078,-0.00420191665726459,0.021126802087625032,0.040187642280355346,-0.036664394872269489,-0.030092902147062638,0.0088117404767308755,0.0024160167750989087,-0.038592533464695079,-0.031144322454676222,0.03504205275969649,-0.018244427580942767,0.018916000565823501,0.00082420366538178691,0.092474565072900916,0.073297169128542394,-0.024311595897201867,-0.0027452015976400512,0.067920732187453939,0.0011865809331642052,-0.02829414542225548,0.042812086020618187,-0.022452858987935732,0.02261009594352785,-0.028250777066103218,0.043262591064003333,0.092532390695239303,-0.15324339008135635,0.050211260469539359,0.013929622339187875,-0.00089781384686685173,-0.063661201005958332,0.0048485523557203342,0.078580094123552602,0.02575794561866239,-0.032352350433290294,0.028485056134963452,0.023621395691399441,-0.2117470445371154,0.10461485137190293,0.047597936964786855,-0.013272615927845698,-0.060311993172769994,0.021931281439721451,-0.05466583518135374,0.024589654496216209,-0.053142641146117948,0.04992839103128853,-0.024452908798012384,-0.13669941087219498,0.013882012829174228,0.1070905994912941,-0.030277288574973339,0.045488870557272854,0.021158864845617006,0.0045504704709340218,0.05214959922096879,-0.031124914087522559,-0.025892240716889583,0.051505846702740755,-0.15850714978032798,-0.077434100579077431,0.14442197585402719,0.025520694414871425,-0.013359740227537047,-0.032691479720369884,-0.050760755770619531,0.0067267124662175881,0.053582968166709294,-0.066091329071098104,0.028319458261919814,-0.023395468585636847,-0.12189855936069849,0.1264108145125255,0.041070402257636952,-0.038345327797452616,-0.0051037835899539882,0.01115753611454251,-0.025558001982792473,-0.015803280214702852,-0.014570255682172791,0.058581784915518444,0.048613151833675504,-0.29657491636724309,-0.067645659352775264,0.13108882918808282,0.054569929796482737,0.062523971903905642],[-0.025232963701757677,0.022348786079614824,-0.072258840316720419,-0.18573054835716424,0.061153715684906157,0.16052559660045873,0.035735222876137188,0.032645819538200907,0.049972870544935558,-0.017744962590501873,0.12327939069776968,-0.0020676327098313324,0.01746290767019347,0.062789463078491509,-0.11704698186369022,-0.065254587170476969,0.094525133189958851,0.044950125896693824,-0.028763679134251888,-0.0075590072060936625,-0.018042703509056443,-0.042766926478698966,0.0064726653302440013,-0.024498528948216539,0.015095977860562756,0.011479770091646538,-0.22511989496614118,0.13749975960271679,0.042174383146931602,-0.00097973927564777574,0.0053458653222245162,0.0066958708608460676,0.052938783244498341,0.028662885704672569,0.0083788264626524778,0.00039142479042951484,0.058935919636454462,-0.20560278009245425,0.079502781298950373,0.10223896059315847,-0.041137991907932381,0.027330073389672568,-0.010752121223537789,-0.0022306851331074934,-0.0079242014779485268,-0.0082794956479350576,-0.032085062337155419,0.086122599207560518,-0.12113263279497796,-0.12790727680874353,0.13902963426409898,0.0088539666043742082,-0.035846424270882665,0.004579108178465921,-0.043586755702451435,-0.026440306229895939,0.012179387770686292,0.074041872436307762,0.01288390088442623,0.063137802503704196,-0.30013379565775622,0.19884603307627666,0.063815797070558927,0.049734977180621504,-0.059941845556548135,0.066082316837520416,0.018259553212376337,0.017779633684347013,-0.030632372504305949,-0.05294008910372007,0.12680914791412304,-0.23860332882902754,-0.072937437856311613,0.12736775458078498,0.063565918341235095,-0.051172875061062162,0.0097790501145352954,-0.0043407042674837651,-0.016155615544080057,-0.0091923923303261629,0.050665742508667524,0.0060984721656736629,0.017307742609543222,-0.20367784360158347,0.12046177714866035,0.012913438963355811,-0.0092051845719411662,0.035362756301432471,0.030747952698754938,-0.0068483304259888619,0.060769663776634064,-0.024830671275067155,0.032204825588141653,0.088512986534959648,-0.20132344254131007,0.0025484138158970229,0.140122587765108,0.019618593851209051,0.030770253761956967,-0.044844034190508676,0.010829012004067717,-0.018604574580413091,0.0048701187231226031,-0.053835622525193277,0.065655732448266627,-0.087834494458251325,-0.10019900548070505,0.019098697970462999,0.032625675487211764,0.013786208177970036,0.01459298085632256,-0.02245319975032244,0.023627062323695644,0.044567875847249791,0.051820387537472895,0.058960832030794469,0.011808887606369993,-0.24302913455395336,-0.10331035325930389,0.043122221975443853,0.044784114116775492],[-0.11131891807709643,-0.14268474406555598,-0.11319512819486531,0.16616863430344642,0.21669051126658584,0.14580497808064175,0.015659490036423723,0.081299765772630261,-0.024809345136602795,0.040210442226760873,0.1147788050575636,0.018929993321792474,-0.080897366155457673,-0.05933670525564233,-0.10482248256522532,0.10573530196882865,0.063140871798500697,0.059506144939088096,-0.10685781396759031,0.034082096511914323,-0.044928786246672847,-0.023391401657096106,-0.021033602025377948,0.011729129297605986,-0.12518841502550898,-0.24524516894120252,0.07503634089773896,0.16915003534917084,-0.01104335485702547,0.018698016558333488,0.0089193810606012641,-0.0095742068835864974,0.074951376080238705,0.052515621176523086,0.00076255674614852942,0.14447253116659836,-0.16116755572117158,-0.29435350805617738,0.21097730948472182,0.15322391116769629,-0.031396770107823796,-0.073199499622068412,-0.00058138919552927493,0.038373648087908357,0.071661242983008577,-0.02522805699198942,0.094355619055900272,-0.0055066260275108136,-0.31676942832713584,-0.17017797276453395,0.20181171910078166,0.038951035449355131,0.020699071667054786,0.0073524959093896058,0.01925107008541585,0.027713365493689732,0.022207504221021385,0.017801567429584678,0.1612676210022263,-0.0097926541627393199,-0.39692367057618455,-0.016344797834207933,0.084334965049200059,0.12332269298102864,0.04685154450642956,0.0026367553827924689,-0.01561848475266879,-0.0094365420154359086,-0.02615768632490699,0.093091816231290578,0.015836673962272785,-0.036104175954425388,-0.25194637763515748,0.066518889227065711,0.088768723733041136,-0.054177349140414666,0.11363104423136496,-0.074336096915664576,0.026411919672457762,-0.0069934713872144005,-0.011837151565905812,0.20495766925622727,0.040652574469842911,-0.1095170141673022,-0.19525613842871348,-0.026690291071139877,0.025635090198280266,0.084142487180791703,0.081560517413446651,0.033899581274340673,-0.04177793659445489,-0.009501675246059646,0.014146738677450046,-0.0083456640397739645,0.066156053917280688,-0.13607639700339172,-0.075200076822236159,-0.099487351506951205,0.097954762781141,-0.068031338341652869,-0.028816943621433999,0.062116569439491787,-0.056509543958784436,-0.01645775253059964,0.078178705767746479,-0.011547980097176877,0.054587296091729326,-0.017563000385479949,-0.072691438517766077,-0.034856075950508381,0.058573711770738279,-0.060289020490556899,-0.012302959633281041,0.052155478089966123,0.075227692092241769,0.053726915546722931,0.0021832390619121317,-0.0023449235386490269,0.069001946478247533,-0.05514982572329348,-0.18138153837504351],[-0.23224131638764922,0.079034696624463316,0.20679180641094769,0.17116975450055194,0.060393255799023757,0.070072109804855828,-0.061904660241219982,0.10747334033766655,0.014331963987671489,-0.032561864821210422,0.096136650220496528,-0.11702112011574746,-0.1864804302468564,-0.072635832330671626,0.12519462388086205,0.070887202616322975,-0.032713296482814992,-0.014132673438533166,0.0038161968326955314,0.065966068281342619,0.020457399865123169,0.05133413578390264,-0.001116824372617925,-0.086503852575327167,-0.17856252353561719,-0.024882107163551152,0.17291742960211148,0.076636137948616748,0.095776267371189924,-0.076644083681563224,-0.054109190285893664,-0.037610346895478264,0.10646735039870757,0.0051060331651450463,0.056304468483811307,-0.028154521230155018,-0.31728669213013388,-0.058091370831929535,0.11556013989779028,0.065723490886578348,0.030550971916660702,0.041747103093391622,-0.069587858250691484,0.092461263966589977,0.052299010395004661,-0.010485795012401211,0.011062345730906517,-0.04525324732355647,-0.23598087205664336,-0.070892557463706443,0.10680685304416297,0.11990972610746585,-0.020183291742381704,0.00057273018272969989,0.096563026611294442,0.084394132743400782,0.0061097222161349135,0.052438465571678999,0.012127916344441741,-0.025706403873987399,-0.37425731880779622,-0.12768740978352261,0.057044219322174475,0.11342314858398521,0.089909015291416469,0.088758601800430922,-0.017367003795174522,0.058573936936146223,0.0024241782448618243,0.081099658324097532,0.071614519911280788,-0.015636202687439121,-0.21764039015095288,-0.20280985898846876,-0.10017064401745751,0.076481246330856831,0.072072476074846584,0.074831950513515946,-0.071669127112894582,0.0033343139896645224,-0.020106231127842517,0.12484552374687989,0.088741504624313003,0.01253935252290507,-0.080371651389196677,-0.20667576524399633,-0.042824689058188217,-0.041960654306219244,-0.011319310972225209,0.0087351053188495856,-0.0073465804795511402,-0.014035434722362766,0.060980934347515808,0.0044957219640220231,0.060136042340486653,0.12862638541641686,-0.043407117384264018,-0.17199184431209702,-0.12411968467220214,-0.067878366625261699,-0.01454311580267198,0.01330421418710441,0.086616156710090195,-0.050869444187172472,0.05903651637207552,-0.030082478432639181,-0.039150691833121767,-0.013410175971461852,0.082024132616958054,-0.18429763963038856,0.043819988293125167,0.031005210064727645,0.010111390046324928,-0.0064173858317888854,0.024542598321298154,0.0033265330575526358,0.040210215896558238,0.10549988851835322,0.066466013297427518,0.049201722388277136,-0.093932153614813801],[-0.12203267064152819,-0.036980237066742305,0.12682937376396922,0.10063288694137082,0.082154198268033315,0.031376504219097656,0.0761930646076317,0.029643540312019309,0.067195157731181732,0.014606114158926237,0.21693479369516466,-0.091990999910650448,-0.11495742760629782,-0.057854374414651549,0.026983308635638359,0.053703744190506393,-0.0273941556868533,0.062050781886751671,-0.014064800119151746,-0.030464390345027792,0.050223229862306498,0.069522169458366395,-0.047915080066377513,-0.076312738072256109,-0.10542836060878844,-0.069963062747160215,0.063887809768190862,0.047703502973526726,0.049625632114663767,7.9371105783654361e-07,0.066938020168000531,0.022331267930076198,-0.013204459193458515,-0.051208345754393744,0.017251686675046174,-0.16855866147278023,-0.081718362687205809,-0.051493312235764005,0.044258122147233556,0.079860750571469824,0.040256904905908247,0.061167900966640459,-0.04445412975620007,0.076058551537300789,0.024484533213087259,0.0237388901616193,0.022211385002816955,-0.03909556756500325,-0.26993986747191345,-0.13809797457481326,0.10638240754104332,0.074164534665666665,0.1361114507013107,0.08862011177027157,0.023942633928693842,0.05945503505976131,0.018810531601996444,0.13332855116668979,0.019080517712641562,0.040953668701707469,-0.19369280785037196,-0.33096708018422843,-0.31537163999459777,-0.051011822183710684,0.10153083596477822,0.10646364340542763,0.014630901225096263,-0.0037911814153038514,-0.031174186442994762,0.12574438878630761,0.082746608550893844,0.13910378358879222,0.015618015934354273,-0.097010031619152184,-0.25736850771835984,-0.23890047875932624,-0.39201416081419432,0.014631649728319138,-0.0049576516790900346,0.03224914217266181,0.01990648283333149,0.0090030712698045481,0.026111426002791746,0.062897867831994483,0.14638901620146211,0.10175160175705127,-0.008366542972654184,-0.22694639696488025,0.016644643336980125,0.010640427487024477,-0.033902595425888096,-0.058870306001172809,0.022391466116807472,0.010861548153134476,0.028661031141596176,-0.0089732366008385203,0.052004121536959068,0.030892998140363448,-0.066298768516542983,-0.045462972141964375,-0.036534075016049508,0.058255109985203259,-0.090300770932724164,0.087529180603695578,-0.048367137056150394,-0.021869920641280391,-0.061934612997809474,0.02284265461094593,0.087099015316751405,-0.038225524845750966,0.042582590594014876,0.046403954163031218,0.038044057338396199,0.013279662526628024,-0.024475870996729501,0.042648427075458788,0.021205045270171127,0.02354074407698388,-0.0073299199474954058,0.0090776722049553393,0.072704385543697653],[0.076135322944236056,0.075928742328769658,0.10248245044059716,0.12142390869553117,0.061858857352832766,0.025464191080837695,0.048676474818140573,0.030285797856824295,0.11128631305542007,0.19455327377882989,0.11002956054185524,0.074606814265492927,0.013898060531860643,-0.012868505144617515,0.038119746657903283,0.0071484624304063438,-0.037389694906732461,0.027891841345889026,-0.0040180772778207266,0.051191664743506379,-0.051415059933379359,-0.065947905104447993,-0.077216280637459084,0.078792274560627332,-0.014940451970767085,-0.042428171172985307,-0.022773622035877988,0.0095521053133781186,0.089224973018742798,0.0026288446459537393,0.027795289276907741,-0.011245376233293055,0.0027789702559120602,-0.084646263411087108,0.1085122984586782,0.064787488385146461,0.071774533015530245,0.101565447736036,0.13538683839366522,0.022702180797543253,0.081382504391220065,0.10182220145207069,0.13414599015766171,-0.067254735812403973,-0.25199554524555356,-0.131377327178401,-0.16365674311148973,-0.018740825554245097,-0.062882807469171645,-0.022204060979254633,-0.072308264704348132,-0.060021508605704321,-0.15902262422755242,-0.23762263561888841,-0.27876101597724223,-0.040263587475045666,-0.08015604055016233,-0.054338910081926026,-0.19775317420562621,-0.28232046584273385,-0.23353688528539848,-0.28871468579830523,-0.14101654202670044,-0.1025403206842016,-0.091079191318669123,-7.6021920519903069e-05,0.084333775651217177,0.025776875645890322,0.027110928294315155,0.12586947033203832,0.1709457201826477,0.12107947589739056,0.23253719852668123,0.022508442929942168,0.10869072456768857,0.1033561446413986,-0.0044697029388135806,-0.019043623385769329,-0.038539230833867344,0.059623205301912882,-0.028372504860633661,-0.029359754569747713,0.00087516511679762042,-0.065918072203459618,-0.069356242665201281,0.023580387356890727,0.021727207917053997,0.039570606452870798,-0.029876932333496215,0.038706340217221941,0.054322914583595866,-0.04361035086891106,-0.014678116576553712,-0.039396900573428928,0.028347288864635375,0.13841137622066219,-0.090660897476471158,0.036895873473620874,-0.037229162146948817,-0.009894930351075984,-0.0452390438366378,-0.027744940547884053,0.041940095444971182,0.010553985420084559,-0.12123151432640322,-0.0087493439495505976,-0.022343273408815235,-0.036722825249752025,-0.074235049496179872,0.13502817700337175,0.046152107059304906,-0.00089713083287275286,0.055904759652944447,0.072800550242982834,-0.014134363015890009,0.047445934632441455,0.085859047433199678,0.055070485986852061,0.022278702781022022,0.064172293392803822,-0.070765699060726217],[0.11799509004720471,0.078210409621760235,0.1281616951498617,-0.020597034003169923,0.014336534229225872,0.11621450358247642,0.089056433936686774,0.054438463796402992,0.040501447910613234,0.077088744908712675,-0.1658906017777812,0.098327915917565289,-0.028103337633236192,-0.02658838870983915,0.024054753355259639,0.072814336465874374,-0.012893740245567331,0.081294224250996139,-0.019638851124383461,-0.059461355471660093,-0.070719091722531727,-0.12759442479018229,0.02999311492449748,0.0019697445298409999,0.026356695570939392,0.077456177036917817,-0.0065799057399700267,0.034984205817837566,-0.011141116727752032,0.037205943512359313,-0.07804833218835576,-0.042937280919520593,-0.12753528913147499,0.02845913050306173,-0.02514121956008758,0.032110847590650193,0.042951761529577637,0.11294381552310545,0.02004775184404517,0.051515900309122342,-0.235725744910211,-0.072308382261543402,-0.019056219840507427,0.0030321142503065279,0.096971125196596036,0.075809718303164492,0.1171582304881571,0.10956914475118423,-0.0024781197540262312,-0.06415838742812259,-0.26848100360863303,-0.059754498941204257,0.061910526180559394,-0.021664296531182625,0.086110025927143202,0.053233513020111881,0.17175441242058409,0.028047054519386466,-0.085902980821043862,-0.33611410752827631,-0.28144114222203132,-0.0080330325783590784,0.10513880861366756,-0.016382627034826625,0.06894681074416012,0.032997961272869761,-0.25750942110661729,-0.14536580095096197,-0.35542177348703685,-0.31543540234741724,-0.015389034147835323,0.25815532917511536,0.089607429737832672,0.024873996600298487,0.068810039618355481,0.034890175702158258,0.0094402391459942059,-0.33170429456025141,-0.084021507130023668,0.050999687890954576,0.11407450625706317,0.12380980581221895,0.061541685739852497,0.024537508065533231,-0.051412691100538532,-0.037969145008949989,-0.083159219869618037,0.060974023868713867,-0.069682639993999873,0.013136896914555662,0.054335436144424709,0.086375749604332752,0.025768018275164228,-0.03028474620608318,0.0046745647931875633,0.014048250096520054,0.0039043180440717223,-0.013243528792716869,-0.010234982174629259,-0.034348718626758923,0.089306699417503188,0.023672596441143168,-0.074063880914324018,-0.039416266912232933,-0.051467563793051355,0.0066514091767777561,-0.0056021073234813201,0.037530284479276185,0.022917723699947115,-0.028514057580272867,0.047001295013920974,0.011663892903344658,0.031577429128105267,0.03674321708145567,0.00016789538350847621,-0.032412649376776737,0.061176715259990133,-0.014965782274795558,0.027963582472569012,0.049596015432228538,0.017493695904998829],[0.095111827476955541,-0.061598206035035019,-0.027848508902761582,0.16285091177508479,0.011485186070697095,0.088227631418343583,0.033476841560767329,0.21311907036597436,0.12562992528833603,0.0056585342726571952,-0.19669291509156339,0.12201627871631479,0.065003875747784906,-0.064637578476232027,0.0076011270434201972,-0.014992832356838792,-0.01371412582796748,0.065189835192035667,0.060501772887085942,-0.007320488021864191,-0.15837390579360289,-0.11374672007199678,-0.011219765388015224,-0.037241451866588046,-0.003534620740694161,0.01418414744662963,-0.018804529282363244,0.0022002993190636394,0.086304123895880422,0.050730302973426275,-0.19347784099407583,-0.024336852899701306,-0.022104084039211852,0.11856239536141804,-0.0040746848315117296,-0.02163636804096198,0.032834767679033816,0.080034473148409696,0.18177097586869298,0.04019529190670533,-0.27026796515043489,-0.046764731646186594,0.008852085437052834,-0.0095398107877663063,0.073838224250254575,0.0022341455913789526,0.080946842014086626,0.064911153319107226,0.06885287564917604,0.052927148605433058,-0.41010712091394702,-0.0033883005740702465,-0.076620464606964478,0.028026719104762239,0.076992030561192998,0.13499559219777985,0.0010835539682531592,-0.0094521558900973468,0.1189809113716918,-0.10886395857171732,-0.31839062100092569,-0.079536575816365779,0.088035400227267108,-0.01994821470243107,0.055031181510797132,0.017355891747403651,0.11548823748390151,0.047318802613544472,0.0035588736908875526,-0.19090242902977161,-0.16923224535916537,-0.10343904409632039,0.11611444215342794,0.030139907826970232,0.092037927739449271,-0.00052811116545577533,-0.0198996720404131,0.11041139740159193,-0.11354626622456132,-0.13266289678027732,-0.16827719486229559,-0.036676195585965438,0.078177366758504091,0.065049146958536752,0.061265895750100163,-0.045421314698528795,0.038673845042327876,0.026641279640920345,-0.10482185618696178,-0.10700981328292422,-0.065258746439048387,0.10279723823243007,0.025140628570866255,0.078995252659308457,0.055586249229617551,-0.028236723374775799,-0.0025877363105662674,0.033127455377752982,-0.028093023704546808,-0.19114920828266518,-0.084372445040405197,0.032752181200734989,0.044573421483901268,0.078569580177818454,-0.076167973158059274,-0.011917584687660975,0.03886281331675661,-0.044585012472417355,-0.041774790744191534,0.06654393572162462,-0.20856381862218065,0.16839377975033309,0.028096195344995425,0.02974664466893967,-0.028107306876337092,0.040206628818593826,-0.0050223327946646058,0.061683180967305642,0.11123093181504413,0.0025290457228258033,-0.02120297614281566],[0.090435635035851059,-0.042297079072951133,0.079436400340748309,0.03842552427230031,0.018479439174666504,0.15188772712119619,0.24325152032590197,0.11801556793669821,-0.080156795814110504,-0.21178228375212024,-0.13218981199435309,0.01847519834858842,0.092018443323332436,-0.050722043815425485,-0.068374560672083723,-0.01537540593449041,0.031479819423878536,0.087358407307766756,-0.06835423776229127,-0.14664172724239749,-0.00015826019866193447,0.015682235993107141,0.051709128927825823,0.0087470901747511848,-0.082975597424275058,0.061059290685490167,0.055712846563533064,0.11256404620171304,0.12009580657518015,-0.2412015915622755,-0.014823455006292133,-0.021320510868446968,-0.0064826789690396042,0.011517249723710349,-0.0029378978150773061,-0.036511890813033382,0.040278214553535516,0.0514440140450457,0.17560605653482164,-0.16559846575808021,-0.17723807338794942,0.06664090603454581,0.025443982377752639,0.01188465218452904,0.0289513499031155,-0.062269615752451546,0.0081510081877681634,0.074139239966066889,0.15951734948521942,-0.023426085135995006,-0.39782174976422469,-0.10908536196954385,0.19810719075019201,-0.03969354994135716,0.074717236518908187,0.067657462341092572,0.0023721387419759488,0.050106233821570277,0.11669499140233328,0.10445484529679147,-0.18066291770941748,-0.13732855962266888,0.12305831238941373,0.037248666546407946,0.04039521027170892,-0.013511371889906032,-0.012463530395042041,-0.011253154667815578,0.057263714594404463,0.064123734742731392,-0.18290915356692017,-0.28693729905644189,0.16662290255364237,0.052133698720201724,-0.034519972646288311,-0.0020692840094172008,0.067412513930324325,0.069378551503912617,0.017341484161215288,0.11249597819545545,-0.12114447333731211,-0.16394194327719122,0.042618534271810712,0.0082442390404487698,0.032211543301204119,0.0013431370481797045,0.059793575679882971,-0.04185352167064698,0.16141583247142297,0.025290287768054538,-0.092771950162634342,-0.22159811768357779,-0.017539993864623925,0.044684688362074843,0.076526300295055832,0.056281907644482626,-0.038322569525682852,-0.024136451744282625,-0.063727184521766261,0.1019524390722753,-0.11143716683774609,-0.13769182869235727,0.05085564633400147,0.0118757042451966,0.075788152179100177,-0.076290068823641047,-0.081411313673654603,0.072941798976396161,0.068768484681585834,-0.033997564379039544,-0.16790192551365551,-0.13094257760158287,0.030092743795544198,-0.020741964391416696,0.00030251423268644675,0.088642737579611705,0.052492146460725884,0.087007777517176865,0.024692689071073824,-0.11263451468661019,0.075663957633193252],[0.10661930608242243,-0.024041018022432886,0.023732105856747315,0.012547179712792927,0.066200152687718561,0.072880838736859632,0.14195980975544101,-0.1884630302757157,-0.10001494467301893,-0.030399364707448071,0.0065084325390564329,0.035395980550384912,-0.016756476798346576,0.039963413543780302,-0.032920761282429711,-0.005227900049309453,0.1455513515779632,-0.045218123785947764,-0.15712918904629083,0.019388410485656385,0.069073426062715243,-0.0298852890481313,-0.013668142441217765,0.03550729334105425,-0.033905353229976301,-0.066398064416859415,0.069367258226956524,0.099068467801844279,-0.16176946602990219,-0.049743685317054989,0.049417327248947623,0.11584329961758463,-0.0099765335337247824,-0.0058946153093775433,0.024852267791530103,-0.022953834411929233,0.03536477637026525,0.07091098453159729,0.16506591436250806,-0.20260600332750361,0.0040822600350435972,-0.020994635237100143,-0.01738045300747007,-0.068169477874611903,-0.016583306399167802,0.016335356838440979,0.017414685172079863,-0.065509544776204645,0.17533271724699692,-0.077797629050437453,-0.16426179882147435,0.067990824370129876,0.015164258343913037,0.0078509177957392234,0.023952622885856464,-0.022724061899056167,0.0064689725623074124,-0.0046862624418039511,0.023956271557396727,0.17796984486026562,-0.14583559757339518,-0.064279230905094187,0.0072858891690116556,0.10176352460866914,-0.053758388167071028,0.031829796138471395,-0.0069310877889054157,0.011744209650540821,-0.022880287482633932,0.061704359435578809,0.073774321721628233,-0.20953311948246117,0.022856913389839799,0.054729377378656588,-0.019111901041743054,-0.030210238863132122,0.0030313274697504888,0.015874354673913807,-0.0064522920827583541,-0.029379891777454897,0.17844565039391092,-0.071104527084354163,-0.12962834428996683,0.074504436810004751,0.028226182768918535,0.028593401178049288,-0.019591476910773509,0.026274691487893291,0.049329376791844029,-0.002525771203732069,0.015184190784585549,0.079377622440195347,-0.19505648192438618,-0.03458185384929216,0.03928442530245542,-0.060961853070715478,0.032104621984227109,0.0010087208719327459,-0.0029091919090189974,0.001344468156507149,0.0050237130033507146,0.10378546719878355,0.022547607122337512,-0.11488746863511244,-0.022120532171003134,0.043655327718427159,0.0067756961208252711,0.025228229845891133,-0.019273769704258592,0.021906840282590274,0.076111022214773325,0.017667767612816868,-0.015508848470761019,-0.23798198014252242,-0.10029292828221784,0.068962427478186386,-0.00958082155355134,0.071808069871878891,0.0096924544958174944,0.0089571169770431072,-0.0082774624735039715],[0.1471154036752462,0.048703759783120179,0.038281571450254931,0.073332082613442248,0.092603314662736677,-0.069406279440535595,-0.18039118017356837,0.030461887926973671,-0.076527801539272758,-0.028459829410684742,0.0039885048607745666,0.091531066997998373,-0.097047418603899732,-0.021416261913473872,0.022880799394652915,0.11630110494121575,-0.11091349044337311,0.0052601237488336672,-0.0013446292981080382,0.019772833215237998,-0.010680526542495961,0.087901717718307917,-0.0062327763337505782,-0.022953022264458001,-0.011871195380737234,0.0057627067153195322,0.090589963902581616,-0.032591156196510603,-0.028720174599054245,0.018764947431906404,0.034198398065046542,0.092483125928658885,-0.039035757837943871,0.046060971646470147,-0.031919717673297834,0.035975657614667797,-0.021429646453529204,0.087312129030033464,-0.10752464144662353,0.00152080949832821,0.010463878802001378,0.017720821018342062,-0.05437049272297912,-0.041948832895335277,0.025352619756942793,-0.033214062148915535,-0.021243138027047942,-0.00088239905902148807,0.12798500264531565,-0.14587827997097436,0.0049154556879893313,0.1154467113814605,0.02439416473282259,0.02683709160566132,-0.0070260419087720058,-0.020081222854955234,0.023704875110253917,0.022950424614096271,-0.05338528177481898,0.083134108349852701,-0.19190518676745988,0.028255792687062964,0.051622701485504116,0.026882922200025916,0.0083776169731257372,-0.0056709911085335123,-0.015187911842930016,-0.052821700067161415,0.0039064424714551904,0.0052811518294068188,0.10527786608533028,-0.15535307659177727,0.012627301510895916,0.033272060865199279,-0.016015509511655836,0.04732339385165741,0.029676033680461018,0.06267237670914183,0.020359709219910163,-0.056328413014882728,0.062032262935028198,0.13944415500977614,-0.1628837619018858,-0.062736195828590677,0.0089073506518793991,-0.0034474543722587785,-0.016188172373634228,-0.058357780371563008,-0.038566049097796054,-0.0077422478015098661,-0.045254853975222942,0.13886799518652831,0.084801544603633774,-0.19493114682149953,0.067962054023332316,-0.039669253652282341,-0.042999032230963616,0.056922793567282359,0.021310369562604587,0.023652100423593919,0.0053850398495440266,-0.031872155789865561,0.12124236413591115,-0.096718330401961303,-0.094640869713099041,0.050053309978650297,-0.04109568378358891,0.06766934251303211,-0.013020222193800675,-0.017936312558531065,0.030884587986413262,0.017940556925031451,0.12318151667620229,0.08261243140085138,-0.19694230673329102,-0.084587141943991251,-0.0036587752660823189,0.046190769885896037,-0.015214414660308498,-0.037796750375678645,-0.037660099586230414],[0.028789729303638767,0.024918790237205758,0.046183744885366841,0.11406524547975325,0.12089401164677463,-0.33167640134016596,-0.30199214061986152,0.075505027729564439,0.015980848677207844,-0.03024616910429527,0.070777799814993519,0.021705154508264698,-0.014784416452853898,-0.092797386946284491,0.073387121329044847,0.21513353226194643,-0.13135516496728,-0.041009990688083156,0.0027232866435380892,0.10443594986053156,0.019234702313893629,0.026668393094573431,0.077454342178145008,0.037704653988272871,0.028345891762078392,-0.0099781631348617068,0.1639247590037968,-0.12998366709084602,-0.16954434602341487,0.044201694038575996,0.022535303634435802,-0.080570085581980172,0.02832273196113292,0.030852307058754604,-0.057281262906963837,-0.03064229252466788,0.027439907981706396,0.19418932496000404,-0.21394127367168303,-0.10822827097568048,0.078776286858231487,-0.054726484054016263,-0.0018935512700742757,0.027554055035958841,0.12724208320232813,-0.05340181008736572,0.032579369535054831,-0.0053668763896144028,0.14925943338428535,-0.15555203727220704,0.0070014801681935442,0.047596654249176279,0.15762506351670039,-0.0017752319114590492,-0.078479537238969374,0.047380596780860498,-0.054017353379027869,-0.010809602185791731,0.031689669706736825,0.23862777088364684,-0.17967729863408127,-0.0025414623844454364,-0.0044922745473988529,-0.033450167802196534,0.07325147963052886,-0.0025312860424687696,0.047270334273701482,-0.018763729160332636,-0.085707081658790152,0.037456334474121222,0.24243173611028618,-0.25408665358619748,0.043294141064992922,0.040148143400007677,0.013087435326473265,-0.019853324596188479,-0.023225826183980121,0.030177002977477579,0.030922203127136713,-0.040952858219118968,-0.0059330615062766906,0.059823934711038376,-0.22840162828405616,0.053835864895732992,0.039215482051845246,-0.019168216146914205,0.036601452638986925,0.0071216981552001818,0.0055194916843240016,0.017118320543367746,-0.010329430802956993,0.022891605120926584,0.10730721508339976,-0.081071689415751644,-0.052731168737865868,0.020938629685354523,0.027472939746776587,0.008732138872189002,-0.0119734318888386,0.029541130454324258,0.025437531916789852,-0.0032417425087455515,0.092169001321697072,-0.063484712261834525,-0.084864201819236137,-0.0055455400012650313,0.047829727088973206,-0.038728523143896021,0.02165612388923753,-0.048404026188333428,0.081106144087281604,-0.050252564268459365,0.062538501508640792,0.050008949642628864,-0.066834069762764486,-0.22862797363149073,0.13880779851328123,0.081956893470613898,-0.036534284594068323,-0.019723956545588499,0.074252965588473677],[0.080974544767873219,0.056529870095499507,0.032547574600199997,0.10152684966806072,0.0464353057497012,-0.21467483931903908,-0.20894615765238955,-0.014892577371206056,0.020894015871834565,-0.0067217043883879002,0.035252062080693092,-0.0060354856627079095,-0.027461302429899262,0.010095861403046108,0.054592365636949441,0.16828861382181534,-0.17463234553413226,0.021867928311703422,-0.041396141212343973,0.019379712333095322,0.012675043495296218,-0.02769514972624032,-0.041243567743035461,0.016051533116298963,-0.0010186840048578699,0.14437795805818579,0.078407639716172844,-0.21215391984114734,-0.057680895739320961,0.12664817413140378,-0.12395328524150205,0.071773066877171471,0.0075741150072376473,-0.051866325466372237,0.038444728263650779,-0.11281826148125848,-0.013662478929553454,0.21924860974778201,-0.14332413200544142,-0.054997300283757516,0.0029602719156689994,0.047502977291317666,-0.028485684862829264,0.020466736113513295,-0.10612328436560343,0.011155779036764471,0.013002308851003064,0.023295819752587626,0.26377227907343925,-0.25931147876901078,-0.081091456814604682,-0.00039674384915672212,0.042663298620291695,-0.0029478976003412261,-0.02670641642999412,-0.089310251851631675,-0.0050439093556460951,-0.0055020483002672232,-0.045366799032015917,0.23013430030607201,-0.090115553552161928,-0.21358662268181244,0.06901078184379858,0.01987760740252234,0.0044608961159714605,0.029591032895087147,-0.035016870610203282,-0.016930134483468168,-0.028665218589185693,-0.014126514695311079,0.23223335474778181,0.020022276028697689,-0.25100707629932978,0.089307267281698258,-0.0077044707387584482,0.033183418337549606,0.0097764251174143058,0.034273315295213935,0.020164835552348936,-0.01004293041366619,0.0084137731647092734,0.23502650629556968,-0.024429730500986124,-0.16831605537549821,0.0005290142948826404,-0.023487633169125,0.096815945866332007,-0.036177879497560572,0.002670053453748697,0.0060485344731694285,-0.03294986612777788,-0.029843164527927693,0.14655979582549006,0.0353911847412616,-0.20847127037801366,-0.057891906038571958,-0.01027014008034767,0.076537736942186227,0.082781522415119449,0.11258631635960367,-0.016599499535918771,-0.093947583003786694,-0.02515826814708777,0.13710963679628882,0.13285152491933369,-0.22309506076529734,-0.12553570046740603,0.025110108883222501,-0.03021547801359524,-0.011748686689746581,0.14400425060338853,0.043163516328968393,0.08594108251756169,0.035184741390128088,0.17622159819914116,0.19444104428116626,-0.23633459893577083,-0.077389181598155027,0.014638957467814989,0.022800332745270047,0.083545736652882466],[0.12261253014406985,0.16705127800103603,0.19069455483447878,0.064200785381356679,-0.00016272403782892353,-0.065942849362023062,-0.0079351060474115581,-0.057893265858712836,-0.05400622028081925,-0.10458693453007292,-0.054179967940119297,0.066989678608242287,-0.099219853272594943,0.062446370884785274,0.09094500180354774,0.028277578410574628,-0.047069391853415257,-0.0071510316033549098,-0.050252538655332246,-0.01470682832330765,0.095479720545435506,-0.11061849427089886,-0.14255959604920565,0.026858767731697888,-0.1946544063779132,0.18484819329409546,0.17890314023634024,0.15499366437705026,-0.028241535246141571,0.04479597904441586,-0.058444080996440717,0.013625007131520706,-0.079692834360266224,-0.11450496688056046,-0.12377645767247314,-0.065906435468448987,-0.15742481688127266,0.12985425042057541,0.20266035853202718,0.038497383031025165,-0.025653639466894002,0.075725823765211642,-0.022083431516520723,-0.085486667503959793,0.032080522906880071,-0.16479464568215729,-0.22037943812265476,-0.2229737334363267,-0.38061125130213119,0.12775872709984104,0.31739568607954666,-0.015834239969060679,0.055459428402900815,0.011929160033288685,0.024193127246187052,0.090970615276012703,0.16123203632279148,0.0089117801154802584,-0.017294928512088706,-0.35854082366702061,-0.48144436153782677,0.033786213483589664,0.1209940431097762,-0.022527387589338276,0.049459009623695566,-0.029490765269415273,0.25612944261482823,0.11469128278773146,0.12808084965382249,0.11403331019353928,0.30506897046132081,-0.19904848217033866,-0.20053793259626246,0.039641205203277907,-0.04376670404571352,0.033609985206833295,0.0098996640661796406,0.11272141584817373,0.18547440193507447,0.1524434424661974,0.06114521088463705,0.11826241926353079,0.12074606754768391,-0.019667238146597897,-0.00048386258516668057,-0.12175688660479972,0.036172066069231526,-0.11868521523662726,-0.1250203703417119,0.035904919227186707,0.017839906841583555,0.060859449561677506,0.09635166317000958,-0.049212492625574339,-0.045372607382002661,-0.055897345716822311,-0.0023764214791030455,-0.038382865278286389,0.0064116033781553214,-0.17558791205718122,0.0023250224817987636,-0.051727259802616457,-0.057790529308374375,0.013791061402471952,0.13644846669520244,-0.010155313334871414,-0.017625717203356758,0.073652902143451521,0.00069328545240087552,-0.050008478647772345,-0.31927888126001952,-0.18353351499079812,-0.085538235823548719,-0.073096290012328813,0.090190178210760405,0.10660823241153998,0.090351417639498541,0.132917195679079,-0.011857357267916729,0.052935295307996386,0.043012618340511746],[0.063687026559832702,-0.027474493344771159,0.04079252412326359,0.033944293702633618,0.067493996598322739,-0.084202990537866812,-0.024906649626728283,0.0091583686944553405,-0.068820170460425684,0.0031107283830948407,-0.097108585049124174,0.11878373624948577,0.03710017079293685,-0.089402710046412398,0.021829275829537725,0.05069263318004659,0.012340313923680318,-0.023685785769386569,-0.026839662252448132,0.034846261621930025,-0.016166129228329065,-0.027864958300899939,0.12115538210609175,0.0037368644565901332,0.13531841970369599,0.021592046315438054,0.018171005730945711,0.015072771881264005,0.070400883694442765,0.0022893852554199817,-0.038531873505113653,0.073412597254778611,-0.029637114380846583,0.14796659731395348,0.12294211400056784,0.068355321789079659,0.16846933987145341,0.09208858358733514,0.124710416844108,0.069410300558010035,0.0028282096799201462,0.028941147392732833,-0.082405863861783321,-0.099340106662704333,-0.0023105045076858566,-0.044477583601388274,0.0008809594027263945,-0.085099107788483452,-0.0064586485698500881,-0.044295114180264411,0.10095939402980549,0.14859114322412731,0.14469873810179945,0.078675636968335211,0.04110277787821804,-0.185748731574369,-0.17064830498300138,-0.17155221512879462,-0.25171330168462724,-0.27337273571997955,-0.21265235556569007,-0.17172557194975863,0.027527124955349591,0.05618012242699108,0.12158172746105769,0.079338486628700106,-0.12195189294100098,-0.13969446903752442,-0.026572222761012301,-0.0741704803065521,-0.145127075010832,-0.11500093509170173,-0.18278877520622416,-0.24714583432028586,-0.13747760229803679,-0.068392610369592363,0.098671592870279712,-0.16740306756901749,0.075274076124663886,-0.0044961465547186386,0.13260037497576577,0.31234055497812679,0.15517911386484973,0.066459928203915386,-0.015467888667656748,-0.030267329366836557,-0.056259518407299938,-0.038215914691253711,0.067128719543084317,0.12318688834042112,0.18468566964642463,0.086525001219784597,0.095783539484994351,0.15930761904527679,0.07562987308980218,0.11756704875720572,-0.0760161520649867,-0.011817169363246532,-0.051957377094306409,0.17488796559917713,0.14148464642191833,0.086956838317260601,0.081058475663970134,0.046958772348784622,0.04918174254075236,0.0034109923824553051,0.015580943744111141,0.026515084298382431,-0.062878886731464731,-0.056347428448159036,-0.093781274466081921,-0.23964397537244131,-0.13258713878159228,-0.084365859336627824,-0.12790680365138707,-0.070083706938090157,-0.044961907635326953,0.049251298465303128,0.072446618696754353,-0.016196819754861112,0.10029423625804029],[0.022794829328282723,0.031855402221378282,0.024367172994907871,-0.088290566246083876,0.07232262276136471,-0.06292516861381596,-0.0040861461107614544,-7.972988029088246e-05,0.01396609724411256,-0.025131035729871201,0.017075722683559433,0.043144050114759525,-0.077791172190580238,0.048533511736318036,0.007217025612539632,-0.035475136878956898,0.035691767227550089,-0.0053752350421711753,0.043053703162239151,0.036425942921316332,0.026331797944731436,0.018922402485978082,0.034424572379380902,-0.043306530520506897,-0.023769315918517941,0.080993967723216903,0.0014022744912380036,0.06800816187289091,0.095104587086617953,0.10798396936955548,0.024411086728309606,0.043708025161000461,0.056510394828046859,0.038012989404389352,-0.016918964127942582,0.13076340620049531,0.11446285199173112,0.21239109093247169,0.28795590334995447,0.092687450807731803,0.096764008832141674,0.07011596892193131,0.046944677248436581,-0.028109521724954359,0.18643956244021581,0.077870719895705293,0.11792219460655051,-0.035608267559333939,-0.036648812158749919,-0.13441333664206742,-0.1209205303400708,-0.15624385122841139,-0.17025727483799705,-0.12517931808717464,-0.14934420137275992,0.15932332483022202,0.04839021776339017,-0.10847969953324497,-0.12255999835004713,-0.19725754430522846,-0.15715530383375914,-0.21752678931536223,-0.20062628687872636,-0.092267339908223348,-0.020573472312880911,-0.071636670998092289,0.063397599343820776,-0.10020592169765151,-0.15580361490286621,-0.14943697528943115,-0.11920849551682298,-0.081202276537251969,-0.11695355604037566,-0.0067283708261298564,-0.046837938954313707,-0.0077863170130979195,0.019980965641957497,-0.121667094665772,-0.11522589823910821,-0.057471776109635317,-0.052229100647856727,-0.046891079021213228,0.061574055807871869,0.11811240080682403,0.17401725345189034,0.1337150650275799,0.19272562298101481,0.13837697707498475,-0.043682489526108231,-0.035940773077983296,0.011031099888345858,0.066035108027198322,0.16273538350576014,0.1001587158991207,0.15018677215060725,0.051560799730643869,0.058405889573942382,0.020232732914280432,0.080342157059325445,-0.066884304721525012,0.043091772020143498,0.061075670741261745,0.043764943962592874,0.031379229244833627,-0.0054635333665592478,0.039411450527978564,-0.017169301013184327,-0.027826140912018828,-0.0047148996567287563,0.0361035243729722,0.054667230314029543,0.046239563591323717,-0.045456067930868489,0.049402252710789213,-0.04766846057913162,-0.014224514341087915,-0.059509471495879943,-0.13173838602104682,-0.010384251552911242,-0.087812211124107614,-0.077603311445163858],[-0.032355994688810757,0.018326722847476676,0.017295570021311088,-0.027670634962396815,-0.0076809391049930537,-0.041376685856530981,-0.015061630610395491,-0.043781136658973818,0.036477149712398793,0.044228566218286886,0.18106239449231315,0.042891343822209826,-0.020853245724294339,-0.024082163468429868,0.041552139122004575,-0.014678545508214125,-0.040841976375840028,0.017432021695089089,0.0070216535002669556,0.12929994168147696,0.15511189221305455,0.24789881463360725,0.01524433890020907,-0.016082932861742782,-0.051589389728025764,-0.092487374266571665,0.045744016738876361,0.057516818919086221,0.16869815200400168,0.26354710842333462,0.13879401206280972,0.1425191292736655,-0.078455509137512092,0.0045617718808213525,-0.04996569794639541,0.080368671629425376,0.050146780922382769,0.06747673498101589,0.13151901964758053,0.16708907133321474,0.014140597465528995,-0.095378223856770333,-0.20288372470514504,-0.39934020254115926,0.018782728033396659,0.055848444235998176,-0.0052730281141155078,0.094883628210799084,0.092662084190120605,0.026342391088602909,-0.086838950610960156,-0.21345767462167456,-0.282107822115785,-0.14895903217754436,-0.15887716612865338,0.014524384805330928,0.064105061659619905,0.015209021241474052,0.094836346474780439,0.056562751972782294,-0.16636322513631874,-0.24132070876596301,-0.25962368835745592,-0.1398205940714011,-0.15531689505376495,0.011694908155279474,0.032010611040571693,-0.037560894238744175,0.066607787477416219,-0.0076642057689953885,-0.04070977708688811,-0.04226030127644731,-0.090011860309571437,0.069266838681682319,0.15114898488461287,0.15845318802936526,0.15653535363742821,0.057963227558536959,-0.031603242011597907,-0.0055733045265627945,-0.063345205711261135,0.014274572871990451,0.031680599603069681,0.039820176716201153,0.093415859365416617,0.11919257043750534,0.03989717150118903,0.1715005214515096,0.0032916843093048626,0.0044846669425230717,-0.021098541490893137,0.025809720767491551,-0.13673281369087914,-1.2468117886521579e-05,0.045303630981452153,-0.0526550700395952,0.020909495487494364,0.084789679870713369,-0.063339110924672634,0.091376945056866526,0.07252165751693404,-0.079209926148198551,-0.067293987453879475,-0.043909917127449488,0.029396455943145994,0.023947405883684936,0.017167025821694201,0.030553476010320116,-0.058621689983054601,-0.0098426856925661194,0.20196311694537442,-0.023668678155415387,-0.014001946149787309,-0.03728327654318217,-0.023078128502029227,0.015589706964187003,-0.013168968136987605,-0.031499036112030365,-0.039786236033770211,0.054516325604152802,-0.040512968956863807],[-0.11874501434881572,-0.082292851061515113,-0.095608167868605196,-0.020577868342219752,-0.051846289507618271,-0.010859373167837721,-0.022716678939708967,0.12820642967693277,0.20208152628630544,0.10326830535107219,0.19572108975580454,0.018529266875907807,-0.062343764039584887,0.036176725353944533,0.041069933083660609,0.0079762012687746575,-0.10314299674810966,0.0064955171797952682,0.12398900983956046,0.024168115641601748,0.030884610087337075,-0.074999137996260248,-0.040399947069967329,-0.026348341528788261,-0.0040063358136547406,-0.098214201253041297,-0.033435982999113351,0.11941221649994889,0.25555588605475288,0.038960204213761458,-0.072604474132352964,-0.080306295039947226,-0.10380646122757918,-0.057320493242450338,0.015515746045367804,0.06255592200477092,-0.07382948751156268,0.092347107622607685,0.19891060046749282,0.16973365981683389,-0.044617838703860296,-0.17458925689074178,-0.16855591416735904,-0.12959176095156721,0.0028653211948725388,0.039281815318144675,0.051811040864348151,0.054229861553504496,0.13870864137978747,0.27288253125832607,-0.31438783480893878,-0.43930197285264261,-0.1406383436455399,-0.11423051269906785,0.04779660456302437,-0.065061505106159614,-0.0042604236376508481,0.02946332359287078,0.025104961380266577,0.14743399932390186,-0.34597564760602995,-0.42017229785052612,0.035072831557282497,0.07959646999214702,0.13322835735966732,0.13339746737800906,-0.061957613945008899,0.068920425307499353,-0.038536206573474313,0.047215262988980017,-0.14334497896799611,-0.21161459673878405,0.14176441081563174,0.17098183292990443,0.14174756095000518,0.037859045933541086,0.31085728227189657,-0.02922935514410599,0.015150100201128183,0.034324197511492696,-0.011781519634235918,-0.077397115828606117,0.00082481393952203719,0.042534961830221429,0.04985424198595359,0.13020790077736055,0.20732411001715473,0.070041942881345881,-0.037026860217250213,-0.031791667690004716,-0.064806164590905407,-0.08258662171950007,-0.074375301162423885,0.01385894189294383,0.15057409353019663,0.13055028224014828,0.023193912685637932,-0.079370911864438495,-0.076747220775197508,-0.056515387156161861,0.070663010357839617,-0.082980693850575146,0.03859091949287638,0.03688503261834894,0.10304253122200434,0.02858154892479417,-0.11389454646540841,-0.023276097872029958,-0.02020813146390732,-0.14669512203229218,0.023730566407701478,-0.018262941034164024,0.11113049123798203,0.017809780077411436,0.20203876814616534,0.050784801616453046,0.061469567589563318,-0.0075507512091273071,0.00039041405665547757,-0.14721537985673849,-0.36919673052117485],[-0.11817248565975272,0.050807995924907354,0.027086462019090568,-0.058324085983108412,-0.069751886972065691,-0.021026807770255104,-0.0010775384566174273,0.074350384938426592,-0.0083996536342961781,0.024897232303854835,0.087435612841062521,-0.019098985323464851,-0.046097891900699461,-0.039781451834335679,0.0088894731980628458,0.0075569224053487344,-0.019310705820979837,0.055367812483190761,0.044255697213517686,0.003269187287821218,-0.010373408718694646,0.072601121525306539,-0.0081003549893320786,-0.024375359119167946,-0.0051757404707577122,-0.007608303655937336,-0.038607745687823228,0.092478375023070991,0.00029773934680776826,0.041278394763053186,0.081715888790276012,0.024739987393328,0.18485522219427483,-0.025644712781172099,-0.025676231567332224,-0.069747146376060248,0.054381153884765894,0.049824898758326436,0.13026732540299155,0.17109724133509682,0.059607917528576915,0.0898551064946915,0.095437277162761069,0.15876422270859231,-0.059133757610202321,0.090976556591518709,0.095108813979450674,0.11556486887071599,0.17970536904884052,0.033055045328156785,-0.035525492509829046,-0.10877929753051407,-0.05079396460228644,-0.076391322443933374,-0.056757989672368857,0.13477312348229739,0.12869357538617032,0.13013531388087007,0.0063887122121179842,-0.08972948672558663,-0.31295031978607873,-0.28325157301095855,-0.22477218093756324,-0.2145675780259611,-0.13307930518541367,-0.26981212419965894,0.0050165855664531731,-0.080398088607170237,-0.085216248619270157,-0.18399362322745855,-0.23965470437008415,-0.12035412983362095,-0.076983583068044717,-0.018020432830199287,-0.023775391914850265,-0.10766179954942284,-0.16700211823558328,0.015040770227884616,0.042510381440078737,-0.1295843290841098,0.029351080812140877,-0.019785888214935599,0.12163685368807528,0.19449321821046042,0.18157312421218158,0.13917958348474402,0.036259259826054727,-0.059330356189887357,-0.053816217365371406,-0.058012192775396779,-0.024991060464911681,-0.039656092354391499,0.16051410507047068,0.14621181331244598,0.076529241884836105,0.20617689470457351,0.086129886089688273,0.23683312856300526,0.17799588816524972,-0.031568685911075867,-0.011339033584039513,0.0075929000196447577,0.036795050434868116,0.033074275171315504,0.02413735006868855,0.025795926857207403,0.01249666081014379,-0.019552843326395453,0.052849908133605947,0.090518035422685661,-0.012948046871117346,0.077671915299142413,0.03560950915943991,0.077328247554565535,-0.037094066672885492,-0.0047151073853557868,-0.059216558245230588,-0.13706040241569367,-0.084997996513450039,-0.2036404817250472,-0.1023980466551825],[0.0032466543865972697,-0.0050619149620753506,-0.021817810555513489,0.020873615011084853,-0.023531149044787023,0.03236851492334604,0.023279668597308872,-0.069079320177640346,0.028858662573673435,-0.022912200910692751,0.03504956758463669,0.021373318115011183,0.043177163021661899,0.031000576507821495,-0.022727992508285319,-0.041130337906935252,-0.011956655086753407,-0.0073657698466143146,0.019513062456004551,0.05648936597537918,-0.018006917494647098,0.023594044549755097,-0.060974710958634132,0.13275136748820646,-0.02028861314235185,0.093323469753408897,0.18375935802888299,0.093307762526131197,0.017002171822373846,0.029001128392942721,-0.032620309649792054,-0.077144466336661721,-0.026312985524931123,-0.03637619977745446,0.030016539993203389,0.081068448718876446,0.17134303640361637,0.1454521161962567,0.14411586594973091,0.25089534021606852,0.1895315775753576,0.10961959096303461,0.11868995411865033,0.097649074161421504,0.017539178062786528,-0.16076583519696661,-0.08944189051045412,-0.1662700174191715,-0.19945945515698124,-0.12053950329957802,-0.099974797166572635,-0.0030787654511070864,0.17592486845741467,0.0094047611238743667,0.24137587097504254,-0.10616945372175415,-0.041295263909978092,-0.18662857060598367,-0.10128658810243146,-0.15612237408478322,-0.19263459821003462,-0.26517496264532614,-0.21075478738597611,-0.15240183455933287,-0.016383869315923158,0.10147080642825733,0.0087661143103210659,0.033117317571517424,0.022841544673590577,-0.12277060576748028,-0.10456605790706747,-0.046810877427083952,-0.051309908127680354,-0.12955150951531408,-0.085883187288628787,-0.21065306139257753,0.067423551686227948,0.074090258222003588,0.082147407869472167,0.095756878907326509,0.12800788880163314,0.19242466407747882,-0.010488011809805561,0.0024629531735309296,-0.014172878937930886,-0.069938838753530824,-0.071937788454647211,-0.07364200527100781,0.031404273448011791,0.1105219490341731,0.082629216504521888,0.072224220830742203,0.081941428822504034,0.14730626716129064,0.1368836421937018,0.093927882429139575,0.026163487559181867,-0.034217252732886977,-0.096253676626479767,0.052568923694275654,0.058021118675766356,-0.069486623440566414,0.10387349833640262,0.016885436566802817,0.005752374710489408,-0.033857627300573193,0.099199719978274481,0.0027587586225816252,0.028883082517926831,0.0077987727191536071,-0.026129748383045506,-0.10092939633783646,-0.059725181550862289,-0.16032203807483622,-0.026295964226010465,-0.081817026646661545,0.019856334497422835,0.011592637104098677,0.033535731395388457,-0.037190296797926556,0.039208766263747495],[0.15105659815179459,0.0077705624895111625,0.040428021684616372,-0.0017942995443031018,-0.041653694509876826,-0.068590774376822525,0.0062987842177157083,0.026863472745659034,-0.032303950577093066,-0.019033355915254568,0.0079979595266923831,0.27835546979835657,0.068631274711118018,0.1003446445291738,0.096879765477730584,-0.0033597601637389563,0.054326134689200528,-0.055941674871638272,-0.0054187285410067509,-0.0077552385763832027,0.0045759439983336231,-0.00017646288706738011,-0.0094759828186700423,0.20486066918593301,0.23125707799370063,0.16313521549416574,0.098539105674318173,-0.0099257073687919195,0.053672343529954342,-0.088888704815857006,0.023933003966042796,0.012746466899076839,0.013847645420023147,-0.39203581787528585,-0.21351183585569017,-0.17917201633539981,0.010686831818043349,0.16695352916474759,0.20160459511575174,0.16448815854770155,0.011414537180906403,-0.026561248426133832,0.0072564580788328503,-0.0063508243919336849,-0.16007115781686321,-0.15188987832197204,-0.22445870647203575,-0.21974868512281032,-0.14907696976575383,-0.011673426129634679,0.10655889056027106,0.1667289488285415,0.027289163008064776,-0.0080445463310044318,0.075809327117707645,0.02383788693419224,-0.060318784128438871,-0.15808704038753496,-0.15079581692449417,-0.21784799920378062,-0.18411391886373429,-0.034761650797478574,-0.003078110011040372,0.1443522382170338,0.098191594014337011,0.018899511324318399,0.14330730009269013,0.13334147887544215,0.10003033854405316,-0.011990871182064697,-0.081183725373317125,-0.091853226128579088,-0.059061176343404506,-0.03070241061676092,0.0091317924222779762,0.030031451106893217,-0.029165609653882929,0.11124860010301604,0.10478624646896353,0.060405900026046816,0.13088294144967497,0.094446823325321699,0.046888440627548239,-0.099894170503190327,0.00043866828312585926,-0.079159018990778859,-0.03095799592580474,0.051180956797886826,0.036532200341151982,-0.026313715866520357,0.048771540558330301,-0.019626512408325483,0.041811742473138486,0.020274853199404738,-0.035311251861491172,-0.035700435347725573,0.037776391130845591,-0.015390360725990176,0.10246466374888295,-0.0044949551663046594,0.0051588081839975541,0.03834429330297548,0.052952011747411765,-0.020141415030883712,0.038911185997862419,-0.025809969050729711,-0.054106671252965456,-0.059080808671793307,-0.019798138018163675,0.05184924826995934,-0.073763175158423316,-0.038340916613003422,-0.066879624217449418,-0.018985614490330482,0.048710428169965542,-0.019808728907500892,0.010561838400676829,-0.024562749419368719,-0.01514121795616151,-0.047958337256937988,0.21088916658617063],[-0.12519121067655439,-0.11688358418954034,-0.058961154017472692,0.042235378754734682,0.027384636957009777,0.073378477292935396,0.19970246516712672,0.18078323729328397,0.17754089590649072,-0.12635528181833747,0.083209749590412954,0.029824111195079443,-0.0015424767491013895,-0.016459376017527724,0.077533561237047313,0.00013267738458831377,0.093750279161917041,-0.044726997300741589,-0.19635306229962388,-0.22782377363617864,0.1158824654511761,0.28944469131076977,-0.068772338411748027,0.010802089827676834,-0.007867632781378895,0.079851071307127916,0.21292640866678078,-0.0089784453788348019,-0.068417876998138935,0.022956354752557615,-0.026211043907313703,0.057828305945572214,-0.079483020254072362,-0.016171715594615801,0.062689315224603068,-0.021796237786981598,0.12691374422028867,-0.04752547764539633,-0.049301283041039312,0.048206477749446197,-0.2171608705725426,0.02813017983255572,0.12406052692394327,-0.086131120950002402,0.07689460503666104,0.03813505264063799,0.011628762315091006,0.070698493776356452,0.0084135336178128677,-0.11267273154459259,-0.39754842405378749,0.07304069354916054,0.16994373683501546,-0.11001260539983146,-0.24501206201543754,-0.016540271332897986,0.037588646441523585,0.12220568704299391,0.04683975277378849,-0.19361692505980962,-0.50340607287084882,-0.46224605745397018,0.30127286167836509,0.3851257612605975,-0.19298521871344812,-0.50882871676217767,0.057766291481131202,0.085915688210784893,0.0025825469644762365,-0.15401989963515647,-0.081066644575465197,0.13998594331352224,0.17360289429870265,-0.0082113317756247854,0.034164433476710707,0.033688177254881144,-0.15383945741404872,-0.0035717910256200143,0.011347483637652627,-0.017873166525061147,0.039146796587724922,0.1063684799467139,0.076247636399764285,0.13995849083497702,-0.12176042704433512,-0.064375482208107571,0.022871601462242333,0.20473954746266876,0.014948129510764279,-0.039363453803276216,0.024752228243803808,0.062530143477564123,0.0078273499345180124,0.087539876894555071,-0.034542935964575638,0.058746443283951399,-0.075126285975756629,0.076597485120775147,0.19454209279112086,0.021682122234847927,-0.073488695501302631,-0.058082679101971291,0.012328447567534092,0.076038878132540511,-0.036913472724451113,-0.018862970847490845,-0.079316521304031273,0.016093982880941032,-0.18419160468838913,0.049226683231961221,-0.061457314990918277,0.0282830319555805,0.10422016934925292,0.018036735639772688,0.062905112558747867,0.07205279732777245,0.012387870117812391,0.090730029290315317,0.11439343988109769,0.10142758766032614,0.19506458179923916],[-0.037471547940615017,0.079003059168883338,-0.118094514839233,-0.011575517807246187,-0.047354837158948428,-0.043819905087823359,-0.02204068674980534,-0.015582330906619458,-0.060450140546324756,0.0056710709178786414,0.087342199767917988,-0.047484586855564871,0.055578468629173532,0.014640579783893624,0.10885390788005234,0.072560750440575611,0.053636006213721381,-0.017555923047039936,0.042133507853188069,-0.02906136252712694,-0.12501847301134028,-0.017196570903083498,-0.01339795071661689,0.011501218082141058,0.027702359090996088,0.02741155292168642,0.029974564956617343,0.073364263125587581,0.010914273919724583,0.075409891966110643,0.13043893685947877,0.023410994104295653,-0.0048253685633425289,0.074978432218179375,0.054355304633943134,0.04204747510162269,-0.0154640673353326,0.022630801443203577,-0.063888237541103121,-0.040446308747273431,-0.11272446316765139,-0.077311881416412265,0.01898064857748586,0.079484126473140709,0.042423015302388865,-0.00069403510352408077,-0.069229088452786164,0.077430303792640126,0.20473753110391857,0.28719237966682659,0.30503589992248753,0.32550043922428146,0.14073163480952872,-0.015200746246803488,-0.041860347134460144,0.17135640555161447,0.1527355824602927,0.15944325028772327,-0.046360679758357518,-0.22276635585078641,-0.34374202605941701,-0.38756252285531489,-0.37352669157727963,-0.17546418763106925,0.024941844858314459,0.038533485282303062,0.12621571033694096,-0.29897191326894157,-0.47416602764115157,-0.40533769987763618,-0.044666674782561915,0.12588265080168398,0.1850321413968945,0.074481724923722986,-0.10021514102767744,-0.34731763668724608,-0.099282213883217618,-0.29837506102690192,-0.18662023586706711,0.035652126252033491,0.4013035269477947,0.06080080045364062,-0.020916204012535085,-0.017432090909172804,0.0064526884627329265,0.31447123310066399,0.27814266592693648,-0.042857339346656316,-0.10711074543649843,0.12304888506893627,0.34204207221679617,0.11781479381803128,-0.098207505292465483,-0.22534157766971744,-0.17336955460421499,0.025185350745410999,-0.11167805937105306,0.2142012132418766,-0.043950058435965438,-0.023906769270708315,-0.065584638845817445,0.092040652752376897,-0.035310034547302485,-0.13396895532331693,-0.03899490443982933,-0.12154265439434478,-0.13006356630340574,-0.17041731619250497,0.11042010979150567,0.092651247387164362,0.13111238457685057,0.058001891637747924,-0.002652110312396515,0.15722347821642979,0.066071308703285564,0.039488088992435756,0.039274482749949047,0.19071883885744992,0.10773181848300134,-0.02812558988695802,0.05797883312162265],[0.14781185661120058,-0.039386331432373266,-0.022921264342725164,0.05388189603876585,0.12598813182555718,0.028202774466358597,0.0346074867144123,-0.042381312562632507,0.03884963956920999,0.036410085655850757,0.16289756506012004,0.089845238615583675,-0.046052810070111194,-0.082095780414563016,-0.22396972511791116,-0.11679212172424258,0.10053680749504602,-0.0082322488230325598,-0.010907332253094121,-0.029537833982867273,0.004945131369650824,0.10219160122974023,0.18663745104851179,0.21337195182960642,0.096928017302127814,0.082225401499670267,-0.042534134329079154,-0.052259406449906821,-0.020309120595503272,-0.10672463441898887,-0.088221307987328218,-0.15579389025604545,0.23092722621811365,-0.079955537176635005,-0.13801119251604682,-0.056966288552968501,-0.28523441407005473,-0.0068234259848855387,0.2637658797263801,0.035256610529995847,-0.00096948078976237528,-0.13354739530762744,-0.095292234694563882,0.10809316225785848,-0.22622473692942502,0.13750964405633209,0.30588685236073848,0.47089738278075627,-0.26225597341681434,-0.24291657949567241,0.22231836629884105,0.090543741709712147,0.043301288770093399,-0.055195333115474088,0.012450074560341884,-0.48338662295767298,-0.41101568836876001,0.015182853563479719,0.26867003611558071,-0.18587591997040018,-0.65746047656761675,-0.37080281699249629,0.26181673556057816,0.20685619441423742,-0.062913466536091131,-0.0046315163613586535,-0.3460271088384187,-0.057875831473219591,-0.080073663390408306,-0.060732968283770707,-0.063131722240472088,0.33222972618047136,0.16004023907285109,0.084047102099867474,-0.02976989350386039,0.045421274875539708,0.034504304163254118,0.37536242338238812,0.088935618162099092,0.18255926007618903,0.079936172529676358,0.2352440711079648,0.11129319261560268,0.10974139035902221,-0.04722071086520177,-0.11616310797947724,-0.067309805824712979,0.034599132623224643,0.23285705965606096,0.13190349282962149,-0.041749284399034449,-0.18971912136060662,-0.070314124515462983,-0.044339814683120031,-0.052799114165529494,-0.12425748565008495,0.045487854774525521,-0.13703396222511421,0.059172195354677021,-0.056679024139974353,-0.074184736695846645,-0.096952474536131261,-0.021836418526120411,-0.065731207012367593,0.021349416929545006,-0.083419025939874075,0.052566367769086797,-0.0026602316535740966,0.03873498024493624,0.068175817228078084,0.22646127086716095,0.082890232397643551,0.035399054654756332,0.067320652970741954,0.14239677197520148,0.085138769088166116,0.050369804354669645,0.0010887532169456537,-0.018280111009442837,-0.017225924618171629,0.08422037289529935],[0.11800749409978381,0.048641544731680905,-0.10678911358350332,0.0052911179909213013,0.23136181762806476,0.17221088012028055,0.17682279225882522,0.20044631087373868,0.052122439652192432,-0.1402595079578749,0.02243868573975058,-0.019828048061208629,-0.1373081753593374,0.092577186980583981,0.20995915555570394,-0.16372378150074623,-0.15700734079198975,-0.1736927596916677,-0.058053772103850598,-0.0157237265316914,0.019398599613700079,-0.049310374137502805,-0.11375225205060403,-0.014247453019732223,0.070739494942123643,-0.088327713510229194,-0.13682329114661984,-0.078888479596802466,0.053144758392313945,-0.19437922851131084,-0.0001706889902193115,0.13424778030432938,0.0093320725261308857,-0.18143139441084224,0.12020647648261903,0.2963908916390815,-0.0090974650834537152,0.039855885453729201,-0.08463057056034079,0.036931552840693979,-0.14788894891447979,0.19686627422843606,0.40663533420008574,-0.14336283673708961,-0.18437286091816663,-0.0387524786508332,0.29570661700880807,0.053688982795111487,-0.19564754353990196,-0.34486385728508229,-0.50121307000769089,-0.40626297518108834,0.13382493808540968,-0.00028761919063780006,-0.20091903070867112,0.11021116432324056,-0.18695906308384752,-0.23952005130108939,-0.18820014759183346,-0.020408212645899093,-0.10626227681963624,0.10776229335456736,0.19941878614236833,-0.058276572887897449,0.027521741134965361,0.18134851852604528,0.068694879008434961,0.014109730230775254,0.019795706580671063,-0.069519445032426547,0.085998705252793864,0.25121683554261642,0.24991886206451533,0.20675478705920156,0.093802467043084675,-0.071505683581074439,0.083956608622508533,0.042664222469544988,-0.044897975149803877,0.075633229451364206,0.18470969085810693,0.092312097921409986,0.16477123155033629,0.067407467708452601,-0.035391492159634129,-0.10051173548067931,-0.14948457456306743,-0.0859115996358253,0.11899616835413444,0.022232039948935078,-0.059604180367185379,-0.083714134795981943,-0.12267228192899818,-0.071817553655208671,-0.061364854031334182,-0.037122355027120003,-0.024043277802218023,-0.0077183350586837451,-0.027902500393156213,-0.070228976844589688,0.067283048218790914,-0.022096929111434786,0.030068653546629937,0.016508794156056245,0.0079910228125650851,0.053657963888500304,-0.01697467785547141,0.037888483605591022,-0.10340431444912367,0.093947011691645294,0.17568681512805212,0.053193274463334841,0.08332828325168111,-0.012241690018234677,0.11152581385082602,8.8777513975901723e-05,-0.005979464667969045,0.079576229035330182,-0.011219166299368227,0.13062677267175682,0.13093666750650848],[0.14423093057173975,-0.01008076678423761,0.0073771044594135079,0.06526902731825053,0.055848605823902463,0.052363879757229073,-0.022518577948855645,-0.0099854054434987405,0.0074881193579894086,-0.0076370273996572077,0.095115364997393592,0.007486862308122141,0.015230162163870492,0.040217891425159108,-0.085367149632064321,-0.17282741030837942,0.011588285357802999,-0.058982003588632453,-0.091214201593042485,-0.05548553721852835,-0.085056179953925282,-0.012889357099271234,0.082191503484511957,-0.088215541467796518,-0.17609926241410598,0.020767875260274078,0.2973162999706101,0.3447305749860291,0.35075038554356563,0.1675765045908931,-0.084317445336159924,-0.087650324477682576,-0.0293005697765467,0.0082197597979237341,-0.14178517944724803,0.20163787497778121,0.30622658040655926,-0.089834272556955141,-0.32991154377532589,-0.23770186950896088,0.14059485558234217,0.22935018848257269,-0.06954897481239436,0.13056609682447454,-0.031497286218108517,0.0079273791460638954,0.084811544151839932,-0.29146270301832411,-0.12913123455806388,0.070966051055694937,-0.089486674726494908,-0.076857196283176318,-0.031866717999322773,-0.094905571386768056,-0.076821230076016489,-0.28837628451753605,0.087799542000800465,0.20019432782413554,-0.17096915847133118,0.015333878953658897,-0.28908252284426406,-0.029526689505982969,-0.31385369627251253,0.043040218080409316,0.45576781944785838,-0.1807055900807637,-0.13846940283256665,0.042622648402573862,0.27231737835653241,-0.1914801913205901,-0.11016274974475865,-0.1176991482916686,-0.20542229438804735,-0.34623488704400734,0.23754568531606332,0.28599972207005381,-0.077962987774282691,0.034879273993081605,-0.026162450274433972,0.12712327036253446,0.14403182667963604,-0.034148887052881882,-0.088550823688096886,-0.027745606072896507,0.12772199691917124,0.10001931959841266,-0.18643104606782843,0.041460676340255576,0.057714352211809129,-0.083881954200237321,-0.08331277637087868,0.026147419256119429,0.057512048083849625,0.098776858052545713,0.20838336844764122,0.081416267386434524,-0.031359090867443505,0.010864074615252003,0.054167724377707081,0.036335766553862711,-0.037734056827963769,-0.058460234722864275,-0.050705505416570866,0.072100006992938254,0.077237371527939302,0.032034189952567169,0.083688285950466373,-0.018740931617032101,-0.068236920761726133,-0.067252452363989135,0.12643108826975322,0.092411361850814722,-0.032832183242141391,0.10360749350388331,-0.020641674722677181,0.050396061289050213,0.014052376131391174,-0.024231363336231871,-0.050093755663369793,0.02935370249151292,0.10979499165058046],[0.06063756206193438,0.01163357669854459,0.114137229829593,0.11754589579378544,0.020855057347248462,0.10974930449157309,-0.044990292936782972,-0.011032547892272426,-0.053612766250269506,-0.044758197602911942,-0.10039035625686599,0.13435448459204191,-0.024159164234305225,-0.084524427779703759,-0.091960375514529014,0.10788802496504861,0.045998078232354078,0.055275005037989197,0.064358819860857688,0.015789766512200487,0.020929919215574633,0.040826832309231398,0.13163339908596128,0.059409419123521795,-0.026657113464773563,-0.14316517070653423,-0.105418542401858,0.073237495897091331,0.082433610114087633,0.062596323749943172,-0.0031044464340264921,-0.085840139114289393,-0.052855154813073679,-0.058037038079642167,0.029721950798359945,0.092669209363733129,-0.14987389757269964,-0.13353796595923728,0.050257684298183003,0.014996004118443262,0.11313878950895426,0.052153057368792013,0.010577754712894294,0.013768087181216748,-0.23145094612919812,-0.067586869609837341,0.14187556860642475,0.21502139869877795,-0.23699602207891432,-0.28070386994651997,0.02443305911955751,0.017265628634335395,0.017657686358856672,0.026414327638663804,0.088077975768645664,-0.19378616438963833,-0.33747330456037095,0.10010384808690605,0.36813409114715889,-0.03425924318529136,-0.51529004919317145,-0.21455976987161104,-0.029064252143607,0.029684271548058694,0.11428024956830421,0.035997243237144733,-0.31780545305858621,-0.038939002809603523,0.17082631104569121,-0.01983209806788927,-0.015434962482212933,0.2106729777023667,-0.062119854775684574,-0.026936094188691473,-0.055531104083698879,-0.025879857930813016,-0.056537020588972059,0.082251513253328801,0.13249378757784364,-0.050895123398873254,-0.023068884844874127,-0.0065804143547715382,-0.029028619952673668,0.16670678797071425,0.037287239549273613,0.032006611053345235,0.022985541868513731,0.033097970061269799,0.25106958648152244,0.055247679841358477,-0.078427286178819333,-0.065179530102563055,0.001902992764642758,0.015118472262848806,0.031629329933778927,0.074470568205687399,0.032407934317240886,0.033762676771467104,-0.055109213717668359,0.029518107237236926,-0.0055725182709008697,-0.022571921481206444,0.0049782603577565171,-0.034892861951486748,0.030152277838361469,-0.046317536194844577,0.017217424448456212,-0.090595438047663929,0.010986708242086585,0.01475361802999256,0.11880942290428557,-0.018853830715500133,0.054570000910600755,0.052880256948674695,0.083387882797340704,0.068291238632331608,0.06359772129360039,0.051886923283943703,0.083087116244159473,0.021602565983420394,-0.059861424749677705],[0.090807144739521728,0.044777130492487688,-0.006004236596012319,-0.050363433256047141,-0.038872008341752945,-0.12117244583538275,0.022973279126560026,-0.031712447829596702,0.038054148427954987,0.0045987409431256232,-0.035659664256043694,-0.035674765832077376,-0.092990150201568755,-0.039162611712276169,-0.0069043930890978211,0.0138362499846926,0.030660708367506589,0.070549138758469826,0.029410046912296789,-0.012521892141359542,0.051323314480405155,-0.0037634551331882926,-0.070013831056655887,0.010860732256468469,0.032726783187564529,0.13748613225137779,0.058183973556349577,0.13750969320900669,0.078720320702839214,0.10378646515411444,-0.028949114370941081,0.062081587953289247,-0.036944529962483555,0.11289672176654392,0.034425804553726264,0.044915048986542611,-0.057007183048689347,-0.15438271229617534,-0.082871023728730175,-0.12982282763653841,-0.043611665688003953,0.065964351753196288,0.036324136181226305,0.063713986037557943,0.021735179394400311,-0.078258563769408679,-0.036956657136625479,0.13355366389737111,0.28201274882919508,0.32487155668793438,0.33827072272042519,0.18538129082837551,0.073223331977013348,0.019788327920499546,0.13765137512483783,0.078068271126673666,0.085180243301805444,-0.069125794874328461,-0.090878572811101455,-0.22904348013123638,-0.33513853608255195,-0.34107144821645707,-0.35147873150944769,-0.1429837248305727,0.07534805803134563,0.14776217747988318,-0.045855701305787699,-0.24152324430590322,-0.21753420627734718,-0.13093602087760289,0.020511261336832037,0.097671657751413093,0.14601331736207362,-0.12506767652167178,-0.37252357673151071,-0.40823904893654289,-0.045905807544792537,-0.1600759086755924,0.07937818266133348,0.3143974221346838,0.19157945898080572,0.029030655452761761,-0.114833479865943,0.076726138229785495,0.30135114571366528,0.27545746842581786,-0.0068620750320619456,-0.36522476092942752,-0.06701923494448854,0.20620489038853418,0.052499913955829466,-0.13265239911713711,-0.078950246082188896,-0.20641980579765501,-0.24381499902372766,-0.086797680638089778,0.23653031161361043,0.22019310254213031,-0.036973082188424586,-0.049162482847655051,0.14625921591989249,0.14505339243853665,-0.22743035761938601,-0.082066104556589428,-0.12119372823467633,-0.043181682543043637,-0.098016045425190226,0.029470016170797184,0.13747267623604109,0.0062917025392471571,0.16322306590540175,-0.091363535583626032,0.073287696619824344,0.11422898762272718,0.085210422866565244,0.15331572095963925,-0.072660538227662871,0.20466593159451976,0.026700931142256593,0.036011074297831958,0.078827707903718985],[0.18112261990369827,0.073305524770505379,0.040735943579691819,-0.030592173175515824,-0.014723051663569992,-0.009717724172896347,0.12724950542153152,0.030397078051933549,-0.058889198178995419,-0.026611166982695778,0.066681046712227979,0.066608088167588356,-0.071918745225061601,-0.0083165323796249163,-0.017286314033053696,0.038602764286622113,0.067083551068678124,-0.070282103290758444,-0.069690686774509569,-0.025274574618584636,-0.11014662057019094,0.24938498020809974,0.13937639935994262,-0.057197841279870723,-0.073330994310649739,-0.14479112276604489,0.052420027937541525,-0.12934942016932524,0.030685317385975658,0.061611117116273553,-0.10213214383142413,0.2239301020176982,0.11685706457732412,0.16687464021324355,-0.11110520756446859,-0.17122260866286426,0.056581869983290053,-0.048939035687679822,0.15917940910095132,0.19178174933281159,-0.34144279330828603,-0.00029346936519335232,-0.046900947355914019,-0.19493783020620092,0.045412349490724202,-0.0095033676128255251,-0.029117126455099909,0.041409793887313237,0.23150478397061292,0.052448688728174223,-0.56727135983775523,0.3002926921538524,0.46090762088909437,0.068318962350056037,-0.37007579263516616,0.042656412910046834,-0.13943043649625064,0.11478477562923234,0.26740569898461908,-0.10448691247946103,-0.66827654091869537,-0.28237532775707574,0.17754279911040999,0.17370357234732237,-0.17216489065584101,-0.47505336754415434,0.054836276830569283,-0.030162397455766779,0.068492907597162797,0.14670950434159008,0.0071731840592088869,0.29965767091965445,0.20250028242592366,-0.17784337927349159,-0.11561865754268655,-0.1332395677790339,-0.097221853473992981,-0.028986446755459486,-0.035807336045180493,-0.10615355684023776,-0.13901885393191493,0.016240710560221847,0.17310497729481505,0.19618607123165227,0.11531910216918494,0.085863326480380184,0.16627387139600339,0.31073734902957373,0.046358990626833282,-0.0066805547685416106,-0.11949504899391879,0.049149985727881776,-0.11684899113755934,-0.077621953166553875,-0.15566484457471233,-0.042823410792438815,-0.075958529389046639,-0.047231781924106236,0.18266592599709178,0.10710563631894213,-0.031804445585158589,0.064099712602439879,-0.083339571598682299,0.088606450058975411,-0.049001943443667206,-0.060791129502278038,-0.011938566068193671,-0.02896633660169206,-0.020442949029082044,0.030720122959175578,0.060613751104797636,-0.039897663267117758,0.063701418129868514,0.047368750939173282,0.029398381107522881,0.10605597723541271,0.087012599833984572,0.067143725554758865,-0.017892266631649029,0.069807565811236316,0.20793552791413253],[-0.036185256591647091,-0.068423651398025559,0.033948269018981292,0.25798065842164275,0.055754688409832748,0.14928617791426527,0.20629310863112724,0.22367188663579815,-0.046033543143111158,-0.10954993360673064,0.12202419922148086,0.033686025185198282,-0.11811717921720266,0.12833540839950633,-0.12897362866582851,-0.056304284939988458,-0.29473302723096206,-0.025196026459084302,-0.049804206349577773,0.052953771957786361,-0.067019497571920966,-0.068226576443395942,-0.047831454949617075,0.026913257256672624,0.088734110838903008,-0.19263180519366901,-0.011955075780035074,0.086306410506485354,-0.16802175795413904,-0.083379279329359596,0.087895961497153119,0.12511813454172754,-0.12767661265744493,-0.21930070432606474,0.40484999864474031,0.2168179404643775,-0.07267430101361208,-0.087649129132667633,-0.11089339548416925,0.015296021762153431,-0.11229804131529554,0.29574346278635255,0.080991374361556789,-0.1694969856716752,-0.097181118387015888,-0.076489518459058936,0.24095855252989079,-0.24206344311267508,-0.33278560146628966,-0.40823989525531124,-0.16983118669484359,-0.11497220840475923,0.28957955830284815,0.028529279547082176,-0.048023491796640019,0.06300024473077781,-0.030721874577941871,-0.066963046815232144,-0.01101372815939157,0.075931514278543541,-0.08086212076080368,-0.16771239481709987,0.10099670337031591,-0.24229068894050565,-0.31554893398183759,0.037389060449040057,0.15550442487747781,-0.021450780534793025,0.078024125916309389,0.22670078648533437,0.30001803369505781,0.24803967528041221,0.095538681661574226,-0.038034563476046522,-0.028631619824097732,0.0083028097894310426,0.096554125387373055,-0.093655781707343108,-0.17003471525346986,-0.046727860698759775,0.05438730002622244,-0.011590570354357996,0.19038974433125128,0.080097088742329736,0.18123484236756301,0.11932337787747498,0.021024215763941437,0.0092451671870699692,0.06740553047068025,0.017941188287962664,-0.040749800063489494,-0.082440526483723894,-0.11871195451512397,-0.13318249702629348,-0.054036326779098989,-0.081001677321437121,-0.026663685971886258,-0.010406736043617935,0.076209039356496408,0.011611786985809086,-0.0056684023812064444,-0.030538187745098727,0.020575247317142609,0.053927702112941525,0.047348833795707576,-0.03821865610616923,0.034336636225753531,-0.00018565997117961364,-0.026356654841611753,0.080691162917547063,0.12906802891828614,0.05459184679453908,0.056561011261114173,0.048193611888173539,-0.032352041989720359,0.015293367697285426,0.016804531631558026,0.13319266151582276,0.0038584083011071468,0.11727652977520774,0.10128996888306026],[0.087039001828216278,-0.086030861922398769,0.02399938271861143,-0.055000802538298317,-0.045275456153332991,0.02871882797765658,0.023278548014906846,0.0072154124696548489,0.079226988438582377,-0.032632312594033867,0.15267091964537238,0.044269487995447235,0.10051883763832034,-0.11766420459825427,0.067446412530414279,-0.016434712072576442,0.030052598489340509,0.10105556654675149,-0.10170349865733713,-0.066476723006283572,0.012013167877748929,0.0062464935422486007,-0.057659973131322387,-0.11952174430584045,-0.014950531682345641,-0.030954419784185765,0.18711958320008767,0.21588294444934941,0.18760853314788856,0.095822570293348813,-0.040221853955554603,-0.073249810582964661,0.0042778218861511397,0.055781737968025463,0.082192357333136706,-0.012445928409250004,0.17705102429087519,0.1158017657021186,-0.24107364819029131,-0.085836786800409015,0.1500735566893015,0.2849842667051099,-0.14535341708480665,0.010094356111924016,0.095916706708640942,-0.29873458100190536,0.17874640390204541,-0.22302317330187477,-0.1748799384747195,-0.043712845610052481,-0.11620374099610192,-0.23806617911756578,0.0043003795719866941,0.054212231978947381,-0.11567683342313427,-0.29339006649020949,0.12100456390445283,0.44189519506953484,-0.15496760773507526,-0.022722335616015554,-0.21405336749991405,-0.020547287844339426,-0.27084401995117324,-0.095044199035620808,0.28060020656129225,-0.27074453207286275,-0.1368725199810682,0.17055001589057026,0.3385971361439663,-0.27109736561922526,-0.35586064666592582,-0.26534732401781719,0.082943137915921422,-0.35846678240511359,0.34730776588311096,0.15494380599014224,-0.10539865152649901,0.094828052386711173,-0.10941051423376011,0.019908568726464734,0.13261552724999176,-0.049724811043381112,-0.10696620165908551,-0.25438708553660488,0.17440858544741758,0.106900230981372,-0.077671145816967782,-0.0093718677367089637,0.11752430326382256,0.025752119860827101,0.068028195805426836,0.109859958346973,0.19781198384741466,0.20369617905172333,0.17359025162546643,0.16858127865343278,-0.071588287733521772,-0.02785843176203006,0.026995181216372979,-0.04796739911574098,-0.17448260318173581,-0.096431568764831985,-0.070820859598049485,0.12975749185900132,0.10168587218941928,-0.012905483555157513,-0.0072144888762498138,-0.076308659554720201,-0.07477688141721188,0.049861846430829346,0.13897204424792844,-0.016419927285720337,0.087860802033879568,-0.035559429860732017,-0.03426567268440027,-0.041158346357247827,0.11153373670141298,0.021064007443562835,0.066653748395789317,0.031122571004505259,0.21873333106656628],[0.024271907098944792,0.2115259074770901,0.10968836638996259,0.059160601041090916,-0.042249507377398132,-0.087479837752595893,-0.010602704832708497,0.082454879411166984,0.12207559803506536,0.17548011074082592,0.04848664317003136,-0.10566377044967423,0.0072712864412497608,0.0048264824945599694,-0.037108321821793577,0.036969189242625711,0.05926595272339992,-0.091124279486143517,0.016031767906761155,-0.026239172447726146,-0.059021935429157561,-0.088672703904945402,-0.07726406615726103,0.056275133223160842,-0.051047381915993131,0.023387814606544439,-0.017324327411277735,0.012251187743591036,0.02566561133241816,-0.020852848518282376,0.0066968345396523909,0.073686269601061574,-0.099902583451108237,-0.12413190403188956,-0.018048937015446576,-0.018586297307219612,-0.044793005705344127,0.017307608148219817,0.10244118561809155,0.00032799800220171399,0.0064671351799718869,-0.1022459225049749,-0.025294477732110757,-0.034441569418776949,-0.12789282327046789,-0.022149310544806594,0.014835263850125215,0.12138287707221934,0.031882958581233231,0.032470116515611644,0.0090956520749568559,-0.063478661603039985,0.10606577340598457,-0.099169451323734906,-0.16381989457362639,-0.14343340117378295,-0.032182651726264416,-0.058018044565288848,0.022916145133555329,0.040150146384349723,0.10591359904659681,0.1170336117688416,0.051143184046494997,0.024664034757263892,0.022331370571566023,-0.14794372876832823,-0.046225532247637063,-0.05297556705197623,0.017633358715772832,-0.083088039795379154,0.039154465132006294,0.083558775558834938,0.074371516444640615,-0.010152289765342187,0.0052220614930217485,-0.094777308466158713,-0.071076534981956443,-0.019630080815721984,-0.04040811670233907,-0.046652571732075071,-0.012628590876755261,0.026326307291913001,0.057107467446696494,0.091724178404241782,-0.0027241597818778163,-0.15413869342653225,0.04417172095985869,-0.037480373466733836,-0.05858180541180702,-0.10281951751655544,-0.030064069517148434,-0.030479321832951416,0.092607838224174358,0.044944678809903021,0.045404097144968888,-0.010356704162888877,0.0060040972999510778,-0.074053150092477205,-0.041776885656914911,-0.00050145365557355964,-0.034990913951661012,-0.036125660846155677,-0.045100434109200879,0.025861248849615631,-0.053218496064615241,0.012117104458325631,0.12779186353261135,-0.16438404194145712,-0.012740091450395306,0.01918508147926716,0.084770906418973543,0.019614329268121566,-0.034807211174255628,-0.0017216001979017959,0.15755321182059503,0.005374991982287608,0.039443870135585729,0.14282549594886118,-0.047934404701260411,-0.10055944078648103,0.083257395587425245],[-0.12767186993116422,-0.06241249849097049,-0.094140716145740932,-0.064796146543488364,-0.017809834236761531,-0.069099772207516424,-0.023074608267024246,-0.017483825565269805,-0.066452845435443095,-0.036871983239677726,0.24167468985862534,-0.043100584664250055,0.08879797960904616,0.074578914712187833,0.041306113766767155,0.04109954163943659,0.054754800348057686,0.084086640696184295,-0.0097247769253423731,-0.049452947316442196,-0.081132742094774932,0.064802809772454922,0.05833403551933676,0.048858263974498307,0.0030690275504097336,-0.037721688147944021,0.054194193438541857,0.0081353567184947462,0.012381719155275236,-0.008132915823203319,-0.053456058684966092,-0.091653069394634301,0.064630353359554749,-0.0018237773961607869,0.079983168612036179,-0.085168321622783483,0.078833820035233801,-0.036841407005709259,0.14405274156018966,0.015136780025423867,-0.15091802612252794,-0.03598558709040784,0.070900917613708564,0.0031644970002940084,0.012721805049422611,0.017055461026181423,0.035740435535686108,0.020664246268072436,0.28800157393241543,-0.043946476897746549,-0.069904503860334685,-0.028875975086598206,0.013241447478979717,-0.093932780131541327,0.0073548190708109971,0.021222759365131662,0.088674320104961624,0.15572293451123756,0.18553868377788824,0.051415801134578276,-0.30813751116397192,-0.15349895484431902,0.01561395969351688,0.033258092794341457,0.0072740466714379393,0.068545921699466134,0.15637538018177105,0.027911256742741787,0.1847624277661041,0.017476811293658551,-0.32882514199767582,-0.27338241826081056,-0.08244213190925273,0.040346052358642762,-0.010354560475994028,0.048333017143236193,0.10853011009473441,0.20222782945874304,0.060163816193484057,-0.016735356900245406,-0.16834359646244612,-0.29914164075483063,0.034354440985680856,0.045517620346114396,0.020287847648788881,5.4206367187566162e-05,0.055521485631890424,0.078561317020316615,0.16849991072472859,-0.070184288770934952,-0.079488584515101129,-0.29650023726543373,0.10263152418119534,0.11173763966050175,0.13931259707716614,0.026570560269986006,0.081658242149475119,0.081827919547926536,0.083098416955329532,0.11143074354409321,-0.13932942872613946,-0.22917697770142686,-0.064351927083360766,0.16181167668638935,0.25167259170475459,0.042480647223290487,0.088318184963021157,0.10703227267716384,0.097667451839827321,0.24656917917661206,0.00077543877160522051,-0.20364545582535332,-0.12891190757060239,0.074371886138294263,0.25015791541828036,-0.0027411825679765148,-0.091129709053736851,-0.23136145870314523,-0.30385031086279557,-0.14845722077749013,-0.10313261555912184],[0.0047305556866473752,-0.025050870591785984,-0.005842007282679279,0.023076556888947108,-0.0021831092635067884,0.093205071661306538,0.16891912625347902,0.13474245274119315,-0.019108929587973292,-0.10105317234996111,0.062619436337983753,0.016839567168991848,0.011719509323776495,-0.0013487517864658599,0.038407227731668533,0.054230563051407069,0.20955349223966924,0.051310567307636279,-0.17892491374001546,-0.15156726115951782,-0.10802521892872952,0.021081696304648248,0.050526595868324198,0.037028535648191252,0.084085596639643281,0.097194453007745693,0.11629929727819752,0.10291870790396596,-0.16562571881514881,-0.29210660437891028,-0.054202915411147468,-0.025850956821510424,0.13697807226452141,-0.071432726430219529,0.10357501123134705,-0.058266512397853069,0.041898607209367007,0.12303154344508641,-0.1285936576462311,-0.32801177977089907,-0.028641152078696178,0.13915118347077776,0.070612445915567146,0.17863196007696969,0.036740485328499439,0.082604223960309545,0.0015218003492134188,0.093695825356748572,-0.11859178530895662,-0.24264276329284795,-0.17081519888982888,0.31937266012049381,0.10806272202525118,-0.025075843766076897,0.28906166338986189,0.16912014921604904,-0.005992530361836397,0.11216887671301161,-0.1176651180296165,-0.05510479012461407,-0.35074938302019909,0.075521671212450681,0.29101950812834954,0.032924045727232419,0.073924910009075834,0.13285512889163054,0.1103248869067967,0.017465838707485977,-0.0088770703779607191,-0.12337468108094925,-0.026449945142423825,-0.032574433800492478,-0.17411766159108377,0.27114933838313676,0.1301898019063164,-0.072333049559248908,-0.22304228227998185,-0.0049242594509487925,0.062008119511538555,-0.054842880821889942,-0.077836691900670815,0.062096463032945602,0.21462918302865225,-0.09288225705487943,-0.28272760465120711,-0.21340003804680172,-0.17286126694845591,-0.23320368259912649,0.10997606955733633,-0.0075161519634147494,-0.11006988886634309,-0.0034270246972780347,0.078591067637549195,0.1034985859689351,0.25431078837659582,-0.15926510728994611,-0.27033600479296438,-0.10635029202050295,0.048934737872389451,-0.021263028799828415,-0.12238693572764943,0.0070054754811662637,-0.04236502584618259,0.067623405016993571,-0.048466809027905976,0.15102700530288016,0.2213293088726995,0.039738160929680112,-0.084479657158357022,0.051462208774941877,-7.7551610484782874e-07,-0.0097437119571726627,-0.011728655305820936,0.091254840741111343,0.030319653452282984,-0.0098683560365388154,-0.004386704329111514,-0.063744543491559419,0.18971937116088505,0.08390672246062883,0.081622381542222025],[0.35396637364646399,0.22349346524339189,0.057983505942766994,-0.17547583945845743,-0.28193274673617186,-0.03504651024167714,-0.061419133419918656,0.073064245338727629,0.061645400882380796,0.077309357575596288,0.17389344512954749,0.092584703746148855,-0.19128325987736688,-0.21873404610448355,-0.15487049984698836,0.14901919885041942,0.20523341842652873,0.089397794393503149,0.029360736601431098,0.18968274233971363,0.069481373869200808,0.22547823381719437,0.093546279977833852,-0.13281477240705325,-0.17716124650576809,-0.13345922159593621,0.26005342174676893,0.18501277795048918,0.053589401248721524,-0.047950155872760955,-0.068453658862863989,0.090671100822677791,0.11835517359698741,0.067373868734555004,-0.079589464966329709,0.00040370973759143447,-0.18012258798893063,0.090180248658778828,0.17515551139257118,0.066704136479836085,-0.32348954157841836,-0.43601738248961186,-0.1534376785143956,0.078031085272144002,0.0026002087661166073,-0.0068308168925726304,0.25009089531454276,0.086593094914715368,-0.29449998435488312,-0.28057849042944571,-0.21672085891086823,0.0075953856677573595,-0.057357345275004787,0.050785649925778303,-0.13227728339293254,0.063816280146555493,-0.024929518821545885,0.10319690016698474,0.27361857287431979,0.10838211070562667,-0.10088643508412568,-0.36636108447635718,-0.09977069874425773,0.16157118049598923,0.055579136554848696,-0.12792118168652652,-0.097782153150597462,0.038950029262396463,-0.011346882847028943,-0.0057840540928373249,0.16160380601420921,0.2273189551175043,0.17202324199924374,0.11473390762833699,-0.025009740014433152,-0.012532965249099831,-0.1828653485672124,0.0058619984820548476,0.087637062619453948,-0.037284740577833916,-0.02890657791152753,-0.012640604713656682,0.029752428424497962,0.023715793388017523,0.018978087051175017,-0.06887159345950368,0.062344085837286789,-0.029720895993875521,-0.027411765498387287,0.09285676183975064,-0.017030576469534799,-0.04056883608692545,0.028206942400903268,-0.066991014330880186,0.018045780660311594,0.027421414987953724,0.026028854880743246,-0.012256884841293818,0.071946006217973257,0.13443066125142392,-0.055826414183730286,0.029494113298897784,0.067669224917485588,-0.096083771061904272,0.029156671668710249,-0.0005704450156028551,-0.1012677530478366,-0.024999495171495589,0.11149857559031927,0.068080180726917794,-0.0045362338010440234,-0.029235465914513481,-0.10839343595243112,-0.030880965310150249,-0.021535888254581387,0.03491673509206554,-0.055572778438482448,0.14692935465907733,0.057092970001380278,0.070053770867175985,0.092829523250909013],[0.090301552796241635,-0.032233505100053642,0.086011434142149595,0.057656041238979189,0.085001738116853548,-0.018556863703405688,0.10987613215108859,0.15413524848686627,0.039385960963009475,0.047346588747911561,0.13260893050724268,0.17209307394684362,0.087976535623989646,0.10797764580249691,0.063004634660501796,-0.025038437509689246,0.0015666115477200454,0.04229801081355139,-0.010856979351061558,0.038565031477648642,0.091150434541133613,0.070429356807998139,-0.33965440443849049,-0.2162661542877142,-0.079793049304100055,0.052481904095551563,0.1173724758043013,0.1235642779570921,0.14985928358577055,0.15132449797129932,-0.02085384010086927,-0.27884211234458556,-0.36994374970749644,-0.23348038589121675,-0.35031284933769036,-0.21235792854120503,-0.009620330055204282,0.168787422376413,0.10884138052914208,0.19509683780071668,-0.022160352730551752,-0.13795256421389535,-0.38229992177549788,-0.15708260361782242,0.24650430788233268,0.21040788017836443,0.0038881876095126638,-0.15092402578388575,-0.14972725998264072,-0.27657824988539942,-0.13642930996703762,-0.20644056003736766,-0.10322436864055039,0.20311966005105042,0.24971877621575894,0.098784307030971588,0.050021919690342045,0.11216084960540927,0.0082124981118818358,-0.15895814488393667,-0.24966006782360367,-0.22420253854921096,-0.081867096459771707,0.16097051245293995,0.13084583517748466,0.089777023623677607,0.0095536365062260098,-0.045308319112909445,-0.023384874480698578,0.057270281510571203,0.11323262469471058,0.14403681369736615,0.076514156970479155,0.16610902479691686,0.0012913967538901033,-0.061224715322185846,0.023338315929245221,0.046302661766759359,0.046502337732860347,0.053080092678231772,-0.022080323199307,-0.016463338605887348,-0.024589895117440461,0.036155104538384816,0.016852672260662831,0.03835086922298872,-0.031623293130520203,-0.015008982063713011,-0.0025600166682885062,-0.044171433583490446,0.020136310828580251,0.03892295204420082,0.023164046669806176,0.018929516041055958,0.016294884187040823,-0.026449976012229093,-0.031755575007436365,0.037952166059081735,0.047830269361228368,0.039080927021283712,0.01265262678231073,0.019181657421850795,0.052408264758088366,0.067771582431651697,0.071083943252673878,-0.036646443840120682,0.13604484537303868,0.010094694913875435,0.020674151088393357,0.050958350828004075,-0.017289306861633491,-0.021563726054119672,-0.011484727923504814,-0.076476788674643414,0.0025912469716748779,-0.035059742648288747,0.022443138066393878,-0.022650773632337605,-0.01342746115044742,-0.084684063476957949,-0.027860149727744976],[0.22047100243692846,0.13488498444135597,-0.0045313544299433878,-0.027832268966114612,0.0031927903565839161,-0.11096409714434197,-0.14950903865889092,-0.26496526299411616,-0.004669726241513586,0.18622994506205637,0.43026644909049377,0.083650446683214003,0.057112586332003418,0.14220244940637913,0.1016853991938502,0.097731276097744971,0.2161248251313766,0.15446657647109191,-0.13859854879935934,-0.29659395784427101,-0.17497364047276279,0.19817698639992809,0.16783396706831674,0.035357281142304853,-0.028902513964357626,-0.021290874734355772,0.087221013119957516,0.16958557489322851,0.29274282835495519,-0.061146597980816189,-0.15119828846582967,-0.14884448122495453,-0.039189658439811349,0.04540786676769229,-0.078471457860983126,-0.27300141965542785,-0.38645698179771798,-0.059759522056491488,0.17695994497522133,0.15889943771092974,-0.090045267182307334,-0.0058036165937682405,-0.029934384123982583,0.053751431227512886,0.037133238140849054,0.040634697159956309,-0.048019970488356739,-0.21069772609168491,-0.14410169096947742,-0.1866709303028477,-0.28265061246537715,-0.00363691950510249,0.22240739851855151,0.039353302240806409,-0.0086785807805936782,-0.15037741713755109,-0.012859139058527952,0.1563515063208134,0.042299197355116808,-0.29267625263739372,-0.40523406706284226,0.096518104499962884,0.2315533468508727,0.135427422332347,0.01229163523628965,-0.052368935922538475,-0.13532074699031243,-0.033103483521052836,0.073327802260493347,0.044657022603828728,0.086151403532568324,0.27385346109454989,0.16267484580953551,0.061525738630854601,-0.019745008995468723,0.10503228658291718,-0.019420795585633283,-0.10476767983876313,-0.0051748307516162606,-0.06961208659767662,0.013174971860819291,0.080847233272621694,0.064601373562742065,-0.021748261542462316,-0.0094288809818305584,-0.016281819632491139,-0.036344465904989187,0.030459415820729141,0.056433611785583565,0.11018103278275186,-0.043666018041548925,-0.0042555610080999562,-0.073124175104948314,0.029156650518305273,-0.045782313305331397,-0.018177965266959403,-0.026033702937208858,0.062742395087324265,0.057057268610088474,0.11269084904432485,-0.014280509829636322,0.066092093382691647,-0.026887244247685523,0.015276292205476869,0.0076592093566998989,-0.048902893444263441,-0.10791896457597597,0.093210147136255278,0.028852996778161395,0.032763059790276036,-0.01149082145704293,0.17616247675226981,0.10570157158224326,0.021852869595400226,-0.0058603280864050755,0.0052495755756189894,0.020608001100407239,0.026462048552561179,-0.082618285821472695,-0.079352185250698343,-0.012264971540938308],[0.024463212331441789,-0.027351907989107187,-0.0232645712975229,0.11579335581687163,0.12541294100753281,0.071655620396774033,0.059075996322128593,-0.021125383858022619,-0.052190274486374033,-0.0033401470291263557,-0.0084537171130643907,0.080912403859005846,-0.057403073303803696,-0.1672123397226157,-0.15800496262021979,0.063753554033199628,0.195605998224537,0.071413940170310636,0.11891901474904588,0.037161100558367188,0.077086909312383337,0.03586257381477892,0.13139726047159417,-0.11150130163799671,-0.040614316851042415,-0.26027911447712615,-0.1892555532237831,0.066082525575113987,0.13273683807010106,0.034848598443093043,0.019787968851060656,0.014094611768949439,0.062232334317776306,0.14344093791872772,0.042856056841363191,0.10733309533450026,0.0098223854071513642,-0.23833993172951007,-0.21248877298655605,0.084273584887845615,0.0088423427141846866,0.032948207740492258,0.071733972455376521,0.0063216999920338857,0.19400277202336147,0.014862104507331025,0.10869294352091964,0.19642768165098223,0.010298200186124436,-0.29226294005774311,-0.080019152716796188,-0.013688342983296166,0.11310866378660053,0.012927749370945735,0.15630089388412413,0.25797164469348988,0.0068688176426959513,0.15135988266283087,0.20516522088286016,0.22377486701123539,-0.37618706807030639,-0.13386204003429708,-0.020440964154418019,-0.013775408344473918,0.040573335802585292,0.055189437367301808,-0.12708652754184502,-0.058209551446079658,-0.0084420051400804774,0.17522715535241881,0.033370120570514139,-0.18112622842082776,0.034219233108481489,-0.11090094662237482,-0.14629941730977009,-0.0069698882479145852,0.094796259830696034,-0.23704721824065272,-0.15881064516551835,-0.22841097862649351,-0.054433255322752165,-0.1747399426720595,0.067643525175629673,0.085915102193942036,0.063463884214538815,-0.020900619067225519,-0.038395072191063258,0.071985712612591041,-0.052570940540983442,-0.09266739122762524,-0.13826762537196235,-0.2490025436972389,0.047882934688813134,0.31223581965614494,0.088266033197671831,-0.062809904286240392,0.034915131736476576,-0.069708063347414362,-0.0018865257473194841,0.098095420033629588,-0.05581304445284347,-0.060679329007625814,0.056061870616646428,0.17983405258220592,0.074313751222269048,-0.027044632224345715,-0.00044358577837397273,-0.067457849836666001,-0.045453145630404389,0.042968907664273942,0.079381122903214502,0.058880837077551956,0.16904284405336217,0.010963007005239452,0.042321454350631033,-0.071452129585915999,0.043645640277912456,0.077058380034888352,0.080223556633121973,-0.017561401109477071,-0.044481960782109489],[0.084549471065337153,0.014073183835550993,-0.1230740160197884,-0.061069283663190171,0.030869726497065195,-0.093121154654422861,-0.025168085495502299,0.015403998680830158,-0.056965654755122053,-0.1083328369385506,-0.16715071572866108,0.12222148379971674,0.013801001029832352,-0.10225459810121829,0.0023687253436320416,0.087394156533916814,0.049218002428967747,0.029333823960360647,-0.00088026105741263738,0.11339493779706229,0.079529564235923347,0.064893491794769623,0.076669307484134988,-0.063082264841880814,0.037023338894633273,-0.059661049037454804,0.016600380137564735,0.091314257319891151,-0.011485508114042087,-0.099932453619522549,0.065159532762354602,-0.037572072667034676,0.014463355503503431,0.067621978582367848,0.002545821510838972,0.015802700036307044,-0.10993602991728399,-0.069419149357140775,0.021295475983666365,0.060596105301526815,0.026423669980028666,0.0099005578969671576,0.065389743283916738,0.043327597311754604,0.0095510727918731442,-0.076474755187026844,-0.034130568923233656,-0.075098926490430609,-0.049786970498281125,-0.0042179442640507409,0.20027598699372212,-0.001573509922832908,0.11546201651339859,-0.0078019181260196996,0.047540267194441585,0.0074073899524036285,-0.0035661452397871829,0.050505679244823312,0.075847133121496879,-0.14425580282111874,-0.24270846769727125,-0.046072578225007529,0.24352730974674286,0.10854500954947886,0.021318739646681309,0.18208436906265801,0.070465106497684504,0.030956011752212256,0.021330978755012248,0.016480979771810872,0.0086198233570560084,-0.2974229047198671,-0.41813209224239584,-0.16138204950131452,0.14572029672416026,0.1694280555459074,0.15422865108745415,0.11272693480731671,0.046495243397517025,-0.023984750652771926,0.12619529270753593,0.029740806671949657,-0.012887870344092549,-0.11865448348338473,-0.25933005916694418,-0.10806327708697712,0.041596362223892985,0.18022097944719229,0.10169601556475943,0.018289098449946008,0.13183884426091172,-0.0044659810184938323,0.052209042897218866,0.17237101496311741,0.14892400045574139,-0.11529855402495276,-0.29240160552568695,-0.13273718724417694,0.14348887171904712,0.12546368827384355,0.11969887802419291,0.0966060351971295,0.083929200710457522,0.24096145794638008,0.18159138797074309,0.21525720611281124,0.094817137460618234,-0.17303248008130043,-0.16750824599204639,0.053188636818327979,-0.014842848833645155,-0.13262816340908251,-0.22760143827483528,-0.2847413352046097,-0.26749569041165883,-0.11356293770181579,0.12871811981161485,0.20940394327208089,0.038067867730537372,-0.18388869167744798,-0.098721772725600787],[-0.2933214566389058,-0.076673570165451121,-0.030749933623699748,0.12027682321697916,0.12710910454233743,0.051896661997998111,0.13913969924673966,0.11540205050551869,-0.06812516368464866,-0.0090238207290792988,-0.2910170972813963,-0.061268943436541726,-0.054506350086854553,0.051033716593179984,0.012541368369093815,-0.0064693249273340206,0.017938091969742803,-0.054229542502671674,0.011335519373694994,-0.025653575674649303,0.048300304626844079,-0.11406149945577017,-0.024236484184631396,0.097939513655933591,-0.043137424355738627,-0.070786255514511884,-0.068496593636333397,0.096857543753862019,-0.061432181096106472,-0.038063832392768171,0.057071174742847973,-0.035894598788348775,0.015329272078617107,0.056504250005295659,-0.01033577367928705,0.027053972547184557,-0.034952760442069394,-0.012868480551019405,0.076342833435914359,0.047322298319982879,-0.037462598161052602,-0.0093979451424250349,-0.014027283741116559,0.064562173772655232,0.053721717716616442,-0.067590362010537211,0.013910951636928501,-0.016445194379612716,-0.019461686721338484,0.010439817092615947,0.09941813341186459,-0.092003058246228286,-0.018110229860505461,-0.069116492139218416,0.090085270093186898,0.054159665897273314,-0.0018642885725487952,0.0040597588270554694,-0.085946011876088801,0.1086179140161275,0.027099949435567414,0.09914159471687442,0.00066682087757463648,-0.057660689819417535,0.024056864968152455,0.068221400186677966,0.03672191197686131,-0.0013717096205560289,-0.028205736414335034,-0.045759999314944469,0.053361593077059094,0.052631114994282018,0.0098103929417969124,-0.012203636403062709,-0.16438519522356373,-0.021001549026839584,0.10556807205560682,0.13827298919396377,-0.0070213145166122017,-0.16276133871590864,-0.18906392185671284,0.059904133889352951,0.10225970117457966,0.074039764882703321,0.0042851859251910318,-0.1845936659626026,-0.069683794916369668,0.14111364483842084,0.12749376377877644,-0.10699417534257408,-0.058972794911818865,-0.027184342145305414,0.092294147272745874,0.042730772598910421,0.029013756855529385,0.091552924634042257,-0.075056709683407635,-0.13842728606415003,0.004980535912558804,0.0097376951913064926,-0.17762638306662676,-0.053055611222672334,0.0051212513850458323,-0.031160068246315981,0.018285642027540898,-0.062989410545790991,0.0087672622600651062,0.045406407408064592,-0.15525094289000227,-0.1042418032870643,-0.33859461490814169,0.00092931377130833423,0.071523799097884699,0.24813145448099272,0.17764819914849853,0.054741690878753094,0.12448607192690106,0.21578173215435317,0.11743015273985927,0.11810059765594877,-0.27756282596086734],[0.23860743861101838,0.037220481391505231,0.031909831457287416,-0.14966246683358922,-0.098549852233202243,-0.095091345307753761,-0.030802604768789821,-0.04066312098825503,0.017506583940867015,0.028513850752452302,0.083059648764879507,0.0012190679580447311,-0.033228792087639888,-0.063142105345760022,0.035544952402444221,-0.02360819898883483,0.022431271094160515,-0.018827603717675528,0.052735695833279514,0.04158050289699862,0.031033870999142746,-0.020524724375181047,-0.074377554313755104,-0.058851568777864349,-0.018416900291008273,-0.020185360544406894,0.056555515730563666,-0.0026618188225642214,0.052187819479918976,0.12531509017121725,0.019467695962588835,0.096993280631948425,0.052629314471473787,-0.095668337004786982,-0.10779966462682439,0.047013332046528231,0.1288079363853076,0.1184985604004099,0.046938525319026703,0.011551507295904942,-0.10251614984375894,0.034819153945653339,0.089993485601405826,0.11883560873126586,-0.026071450999984924,-0.10858930623330341,-0.02899296545303913,0.12481231448842042,0.240071552691944,0.40869246369383216,0.26105260304455458,0.050071705679084866,-0.0099467245426242412,-0.032287346107244264,-0.037881104375152352,-0.042540536708484497,0.18047392726709921,0.1072902350620442,0.056244968162698569,-0.45229392780009436,-0.8393105202937271,-0.32646697573387123,0.14835849608015655,0.1562873589444303,0.14740464227965588,0.048455507232141037,0.083156966084078382,0.096330955575823676,-0.042531142223404261,0.024991947578161741,-0.13244791761311936,-0.16920198721111196,-0.46440542591162931,-0.34744594651326566,-0.047380042881461047,0.014762318653552681,0.056736228592421528,0.03669477148484114,0.013278997131524375,-0.054247783597366338,-0.01483859686236641,0.16411279929712191,0.28499310141872169,0.33270153991512441,0.077932645611871798,-0.21057989235427169,-0.1802826760596537,-0.28799247125492472,0.049020040266471457,-0.037057503544318783,0.0052054814540925462,-0.01712557992945455,-0.0034699488895449798,0.11284391028265023,0.050041748407580855,0.039230018094625674,0.083778617870413213,0.030109655245779202,-0.10733376231898197,0.052780693840456264,0.030825522124256793,0.04821793526249081,-1.217969571825489e-05,0.037877834340168115,-0.1130077331768389,0.025972330279050104,-0.040361720693582716,0.060662551316001928,-0.0029175588675382641,0.019233415533092907,-0.023247268944077137,-0.024268033659365251,-0.048050957148744342,-0.039100512532260122,0.055724286161657241,0.01959390543904424,0.0019309926921863563,0.052874955099626461,0.11053404299243735,0.059716361896183456,0.065829387455870025],[0.067033514999894656,0.026572971026187026,0.061902556598039754,-0.05061268032779824,-0.071246860564967429,-0.061282119254154305,-0.13243988526229811,-0.07738291307031675,-0.032986299158761272,0.050994057269436274,0.23205864835108797,-0.017426477727532821,0.016764191996464284,-0.0045262873127560194,0.072679551937369191,0.072143276669484363,-0.025652321290280722,0.011718912127102923,0.015719207964445966,-0.14235466059508073,-0.012765609360204759,-0.055815189675494613,0.062228430692006592,0.11098589289358554,0.1277675820548782,0.039053987447355679,-0.010542995704417739,0.052521557010413458,0.04550010649059387,0.0047551996119335541,0.040037242307058615,-0.041869690382639844,-0.077743643710486338,0.036622756449570762,0.026947327196116463,0.00487126551883902,0.011449791638995233,-0.012157643728774703,0.024207033059366057,0.083283458792015805,0.079838002453690701,0.073616421497002385,-0.072412475297118195,-0.039880892956012777,0.090274964350828088,-0.0059397628704566316,-0.079683192948853412,-0.055948766561327426,0.16964650730513986,0.46194226585948911,0.274371381660658,0.17637187708430974,0.0055754869681963956,-0.040969322056490821,-0.048391146086037493,0.025694944612614096,0.099982967744116455,0.12605224667151532,0.27677019407409076,-0.090382459188317776,-0.72366729365820226,-0.66542016392832304,-0.093850604192478121,0.12499856033014405,0.090997511837360642,0.018067463940727141,0.023895781307986239,0.11109874613217101,0.033726182042769393,-0.22604680738211497,-0.55798448073756512,-0.23540780599042138,-0.094804503513252869,-0.091208459114291623,0.007777282093728341,0.13248330185889684,0.039860046929418358,-0.25215810577191916,-0.20250122934799764,-0.17881248119439586,-0.11431317224159114,0.29676856770910492,0.227171515318765,0.27410464679565072,0.049648773580817623,-0.056866369619851614,-0.064784777105461808,0.037313367193882563,-0.11706718911764522,-0.052501869400952868,0.047052857758273475,0.024035553726984002,0.13017390712450239,0.056206121471782292,-0.040237669313721178,0.048845435975711976,-0.010397341013248448,0.0059061057848477233,0.038085874448897966,-0.010126504089425892,-0.011702353668809645,-0.036778984080859556,0.010230544538505373,0.010568912857967669,-0.005032312616026352,0.0022982360713862809,0.017050551716730533,0.016180147956727883,0.046102997696378212,0.010501996704126618,0.092567315720886861,0.079400948339318683,0.10570431930113847,0.10682942997287241,0.057218561045001268,-0.049670976577548959,0.042693039359605639,-0.038684015991685583,-0.039503682631983172,-0.020740434284436046,0.014243631289787631],[0.062853191788539597,0.070714896930592464,0.0043518201422265285,-0.02666655406813033,0.044525492329128127,0.0088609265224199457,-0.059431945920266613,0.12208756283717534,0.10823813013338997,-0.025642885151491657,0.055452978682526785,-0.030909671398170552,0.0048754534319613851,-0.1108275207792192,-0.028823536945349906,-0.0050464099159451686,-0.0020801916092238332,0.06515373811494736,0.0042318087539451182,-0.016502458630955161,0.039368681711714523,0.14469597694100828,0.036147418183642199,-0.025105477318655298,-0.0029752642733928553,-0.027230567529541769,-0.026500280856010971,0.052083733475320179,0.15939093133651491,0.029110857419989741,0.0058879547498108253,0.070683657600627628,-0.10501891349904791,-0.012994883599022608,-0.027730543376280184,-0.038084041899524274,-0.028850174915976398,0.088899107687582232,0.12716053788475778,0.09387808681070002,0.12445983906256813,-0.06046361458863396,-0.12925780819854998,0.058858708256970163,0.16394889767626275,0.066258764981399543,0.0403244530383884,-0.035531467041199284,0.074782760422794525,0.027441833600079138,-0.034548445862494469,-0.15237542888927019,-0.13604857549753155,0.065146735415548912,-0.0074264748840444511,0.0046040279752218305,0.078351950102189191,0.12973383797047089,0.095681579137167697,0.10648034656296729,-0.471163369507132,-0.76254054291835849,-0.3582093555686478,-0.013245699569145133,-0.13302631896461331,-0.10815491503392521,0.012182904199392754,0.014156573471716255,-0.026231788982935246,-0.040059881323019783,0.013820645260828969,0.24427073416124961,0.30739954052096252,0.050527595012709481,-0.02309562329583871,0.03293769077258174,0.08587868851219474,0.041107882586519373,-0.00067550084020043255,0.038300058206411747,-0.054725024091938995,-0.03259687179316071,0.078231031652147634,0.16873039089887609,0.085156469724609371,-0.075477381020669948,0.075845844149791966,-0.065615868802515548,0.026372053076710963,-0.012261443544603602,0.018816373445303562,-0.046021026430705159,0.063676911857429019,0.009164298437269125,0.021381107032976132,0.010298974711400581,0.025836499120846023,-0.0032034037426122638,0.093859948209638583,-0.044506983815036136,-0.0094275346624950306,0.014356944789664046,0.00037736419603631721,-0.047078136939779545,-0.00096697063118341472,-0.010146754282597689,0.0099516872802271478,-0.00041655889524723488,-0.035460419946042106,0.013200958086152861,-0.034597677731442178,-0.040735749134576782,0.051473603477795754,-0.03068228734251964,0.033804134588586013,0.04377149062165768,0.089866716879267672,0.0076301954407810429,0.042985878682231804,0.0073348284023678628,0.08949838726656334],[0.15588564481934239,0.015629940083505309,0.07753118222162185,0.035198943491464685,0.098615000408114981,0.069220367786417589,-0.051015845370300447,0.013531733492920819,-0.16689427943715818,-0.077939155723077788,0.021709195750235555,0.051427622717783311,-0.064348894516704488,-0.015227872851937468,0.012758529221202047,-0.012491873951225668,-0.052544744154776057,-0.069039899751267175,0.050431254230985517,0.036663595165987328,0.10484513386583763,0.086415560548891199,0.050031783118376666,0.056993606178994877,-0.0025489629815944048,-0.00079079854412655859,0.001499228924733878,-0.18328932679013349,-0.0010930528968453174,-0.051995220652956559,0.007617813274078844,0.050139617755528193,0.083660718861030547,-0.028368100712067607,-0.057670540943290494,-0.024746519800128597,-0.17552062616716269,-0.053853554159497635,-0.049492415048262267,0.028095804788870901,0.16656739764514511,0.17516444743795742,0.1107778641386053,0.23647066109018683,-0.019600601715928354,0.0020068984825111352,-0.10475575204030461,-0.053073335318213274,0.078984284067687066,0.28336794782700825,0.35165561151087343,0.20795642216210236,-0.0051422812718408401,-0.066193759629023963,-0.049047262144416459,-0.035658104876826635,-0.053201855164002887,0.076802578461626705,0.29382065156517917,0.27041543845259264,0.32595175559668715,-0.14797046003969899,-0.18679187035905376,-0.049878575994829755,-0.099670598900649929,-0.040295774069118412,0.022961845644245041,0.11787385733947886,-0.072577437649429505,0.15220959346283963,-0.11057067643262666,-0.27508873178974369,-0.22643642891650884,-0.21711971918615147,-0.065673550190076299,-0.052040181244765185,-0.091959698571150356,0.052341425230670466,-0.029014278335724536,-0.026486649395131429,-0.099176081239430308,-0.11757437729038858,-0.13254020998829666,-0.07632698439949917,0.079955224567499511,-0.17744204932338672,0.080375905404569209,-0.073856215327577773,0.08773958673979658,-0.13914743753820652,0.009984405808856886,-0.058680483231997344,-0.057028749498486214,-0.079793724629746182,0.0015768478264207159,-0.0041526349144124231,0.03459730460531342,0.0086645871269026842,0.057269417282438451,-0.026265220900470704,0.048093551927189358,0.021793273125612952,-0.11755126367641769,0.00049936995779083226,-0.09136988608727073,0.17327200177522672,0.031572859497950911,0.022296920170734737,0.0028040719529331959,0.1205545883355781,0.22973360335482984,0.053206330310550984,-0.014610065818932663,0.1166412205908703,0.082758175315321217,-0.089171794728513082,0.061309463622492497,-0.041123681778030372,0.0013240930679478125,-0.022404870056693074,0.066513648330478348],[0.10641476126921573,0.094791860020083718,-0.031528574545001298,-0.068662742567365098,-0.045583264706049009,-0.044170709745188025,-0.062373368500344591,-0.040882035203785007,0.036680666666222828,-0.031890639174042112,-0.088635427534217007,0.072486055817956696,0.001791308761835142,0.071618106508292478,-0.1084084708991033,0.055537208628036988,0.02079069078849588,0.052668231377405089,-0.011257567794659987,-0.084503145472767896,-0.055354602162358317,0.069470736791248017,-0.028454654127522738,-0.092204125208372456,-0.059138644586120663,-0.0088604191876885396,0.013755932301681914,0.013007606849729902,0.11916500018693715,-0.0054766771048394558,-0.0046385496941247772,0.10607177324908609,0.13190402522499708,0.033044593081882234,-0.0059853447957998185,-0.063203008712939046,0.042930422332914636,-0.077520137322837177,0.10193484761260346,-0.12768024901465561,-0.091566872598170757,-0.057976474892979336,-0.13595312824385677,-0.048451573720558666,0.011191570795142991,-0.0068851380519260597,-0.096621451088916122,0.081772431435869347,-0.049007285728546249,0.1976245378232617,0.18536337530011557,0.054459053626504439,-0.08541554314837492,-0.1103049477795886,0.26784310566965119,-0.04245325920849799,0.07976003455399179,0.15028246342565876,0.27326896910753634,0.2358435331414003,0.029238235516672061,0.14907460060498415,0.31048708671669695,0.40128067591951677,0.38540963021580366,0.27326818523111684,0.15636736514996508,0.14854725998180202,0.13416742860268516,-0.1553995297347727,-0.21625457306714183,-0.28189178550902477,-0.25441318585728456,-0.24392409898023509,-0.045056214003550595,-0.13583884555523959,-0.36046526211729601,0.054109881966403969,-0.27377967101430223,-0.087568631307608627,-0.027320638024760924,-0.03926220394642365,0.17562805271419396,0.0038011471806441294,-0.11815538049076468,-0.14961832586766177,-0.071034737335284814,-0.11256171108967788,-0.067347567015697357,0.043317495301606501,-0.1030173747997237,-0.1512534418799959,-0.045348211292946861,-0.2275535515430907,0.050199653444878589,-0.029910369292175915,-0.1088343982348304,-0.0018044946393091232,-0.14575679126759761,0.009524471365601167,0.017124703501667587,-0.0035126745298030559,-0.058372842364167565,0.089840061068809596,-0.043367454110254694,0.096738746749035681,0.03700212707151404,0.086995071846397459,0.0198918856448589,0.021144677203969078,-0.093457039994106067,0.027112758749156501,-0.10194181462653785,0.083879262506938779,0.075075983857442727,0.050127083431861647,0.088653279727832768,0.020525237657478601,0.086115788747519101,-0.0054914080731565951,0.14180153649129834],[-0.023176335194873693,-0.024544621317998089,-0.032357875793335142,0.061548317450878437,-0.028031573107483762,-0.11117017121562775,-0.028557173365205218,0.034625006110213255,-0.076972642567779373,-0.011745965892935112,-0.0099597650513476577,-0.054283551601990401,0.04796909671149692,-0.058234554069283725,0.03220334560199091,0.03182887188613838,-0.0085908775377060292,-0.018539673712725524,0.059493326671222202,0.032667167660611757,0.011822214610879928,0.011903166151583794,-0.091302949805953146,0.010420910286473448,0.047573929466955864,-0.010085595935941855,-0.082131001411481733,-0.035237661500281195,-0.0095365997252577495,-0.002108262261587307,-0.011204831036011803,-0.10622317570891325,0.0088673069092282952,0.080682046586781658,-0.09053303518527786,0.0092003318540036794,0.047579680643652283,-0.00347364060163316,-0.2609501387739116,-0.1992357096012872,0.12707903816980357,0.076817114916749113,0.0089467730959269243,-0.017430379757375963,0.27183434461804845,0.29540869945884163,0.24001157736704778,0.32834666729756479,0.30453119348124091,0.15738308915167651,0.27144447211271683,0.27186726673366013,0.31737875140339933,0.17968138137001657,0.34963615466399944,0.17947799656684207,-0.19852203981785516,-0.23131890333905614,-0.30348558107287027,-0.018142171891952316,0.32801789455109143,0.10087717573413153,-0.27373136424469352,-0.34405448357850948,-0.10799042948918298,-0.028605058848439946,-0.19185111341784114,-0.027745548740637616,-0.010639473223188992,-0.06235838944179839,-0.22873300656916182,-0.17306684979686754,-0.10579424926972862,-0.12594712705414679,0.0052133744642944568,-0.033020737140507975,-0.071928733715963894,-0.084042374013380106,0.03728925720093966,-0.14901085254024224,-0.051877974664164613,-0.062449829977762557,-0.14709231061360803,0.018448830420891835,0.0039521338112389198,-0.079257066628676154,-0.068341989568304076,-0.12331516121995928,-0.099563492941295281,-0.12282998155312592,-0.0063813760831064326,0.15237343336881881,0.056225478570189891,-0.0045106920049706734,-0.057588436403930618,0.098402612054188085,0.02709244060964458,-0.0051265278718723162,-0.1788182638868932,0.012716901548097112,0.014254282884224326,0.10921274021001333,0.12698286341450832,-0.04126909131947766,0.085520492564099979,0.04384704473182563,0.024665056914998047,0.12247197871922337,0.13439823365742171,0.056199865709336619,-0.07048736575183942,0.050114961739481753,-0.0003055425117918717,-0.0023066782999414809,0.054045599348802625,-0.058889848964733808,0.056481833161273906,-0.074701257036599966,0.054306583047584442,-0.0024484691527146898,-0.12795957386439072],[-0.0087719423838811122,-0.087902685556123586,-0.055052346930590697,-0.053894719312888591,-0.021765025216602493,-0.032496201274909917,-0.053936524545242788,-0.05960180358333237,0.018682206945497708,-0.024041856926648959,0.18080120923175,0.013387152203562694,-0.019460024812665497,0.08584050842604711,-0.042959888333166781,0.056139979747190913,-0.0074822617478288514,0.072637952230176689,-0.0457731161083395,-0.0079074374072526862,-0.039617671594911967,0.062009468577001868,0.06967381700346785,-0.0017890764951173505,-0.017922949357011164,-0.017328735082365487,0.10429286568139526,-0.075336563592980688,-0.019897609787032887,0.066497132377735496,-0.041929713620319324,-0.017542325191820356,-0.049375050497253652,0.04705546281032482,-0.11658200494772165,-0.050367703232498756,-0.08774512274558624,0.10296881777328262,0.0010435280990956572,-0.11190238889003506,-0.058552489144718556,-0.093601922420016692,-0.058917359043089,0.124279868888969,0.20421984908202209,-0.08692730923047455,-0.15846153558915144,-0.044231150294403901,0.14028149426418587,0.20301345397769968,0.20996770156750841,0.078368373517043163,0.023616204532563738,0.046474099815913654,-0.10918733172647779,0.34227918211166714,0.40922200549215987,0.32977893025607696,0.35276397881502514,0.17347731354344686,0.049654055979477453,0.046852605375659315,0.18540273672730367,0.2348705535220503,0.074066027456603012,0.090895328013838622,-0.35637081936313159,-0.17890098216840339,0.067023781694075441,-0.1450909663576207,-0.2414525478367974,-0.31352143109573821,-0.2085394028841733,-0.1694233082437144,-0.05072999227745726,0.07083911431869358,0.11262033996513801,-0.05565357077731857,-0.18252807611047162,-0.095111033685357782,-0.20810789102436822,-0.085215792202067098,-0.037808309132582603,0.20962708773356045,-0.087518828092840728,-0.0083270949222766927,-0.18306482243805655,0.012319186741073546,-0.16489228124607314,0.07423361221491917,-0.11013637802070915,0.00018776862044833642,0.0033474012470800438,0.10043781830311685,-0.24009618845722649,-0.055213512452654788,-0.098806399955303242,-0.014981735119631731,-0.1254106702918007,-0.035863038056541618,0.046213717459946638,-0.11767772671757684,0.075696958238519407,0.25102280647850195,-0.1506185088468181,0.10273881268388778,-0.14457410135153065,-0.0084315930228874431,0.073821935984905274,0.034203057734345316,0.12997695973099549,0.064946501430307446,0.1003816513120292,-0.04268279073187238,0.034385732695719776,0.1329989256859449,0.084680513253248088,0.16750112561515856,-0.14488980909132015,0.097226090484736558,-0.17221966876845224],[-0.032220950917092345,0.0081917299168678126,-0.08028184906386833,-0.081381381904831074,-0.06384203481562005,-0.015615271736948433,0.10708665173062173,0.080651308228208707,0.054345297791378977,0.027073639464279806,0.16812503709317206,0.1341526646829076,0.038631043495105599,-0.0055507367765743609,0.042334555898426843,-0.028373758652471104,0.0039598584650343688,-0.06359711746689202,0.056587509472392425,-0.027554813118545185,-0.0017875113664636427,0.0041025698499825153,0.092718998685582421,0.0086585130443419065,0.10683629867740597,-0.074195758215517701,-0.06305739990406109,-0.021523442626893499,0.0092341320266679933,-0.14610356759412479,0.014750802208444519,-0.0052164932593612573,0.0032641614965498306,0.097806834221344979,0.12926590150531192,0.06269754981180288,0.27475421176426429,0.092446065608718181,-0.12768877877435683,-0.14805761147879182,-0.019825200460864806,-0.0086314590567921345,0.01448064785908898,-0.0089873586037065994,0.10470942538393144,-0.11054476667297426,0.0075035505378642127,0.060005840448525999,0.31710299191646102,0.32324440176708602,0.10720495398460449,-0.058101525474285445,-0.031760977729127976,-0.1142935909746058,-0.031550903709047007,0.0017246932881514604,-0.032140984544803027,-0.01313116025549961,-0.14824372987991144,-0.10766487248252816,0.10593875445284681,0.40021227496345418,0.19725349113949914,0.083747523144874783,-0.030750695721978777,-0.028330043664018603,-0.099873850179229756,-0.2603924703966779,-0.02597866375704655,-0.074313555789072977,-0.14253780748212694,-0.27783688778439536,-0.10552358523835495,-0.011202718784634674,0.12855854774382316,-0.0003920736373502591,0.071696717198538498,-0.06071544811269014,0.079554834222746146,-0.044449538129453167,-0.036239302802330287,-0.054950113420475968,-0.07587822560403587,-0.13219044743679167,-0.11463986228711373,-0.014321816516995132,0.054633054493314868,-0.0021865578330653515,0.047599214666799061,0.071590563880558955,-0.061806931357610687,-0.098703279639705627,-0.17720783806969967,-0.050444583088944242,-0.088158091500455199,0.17305912499532888,-0.18012041201202472,-0.13789844469843426,0.069654839313687877,0.1066025347744837,0.042994905989906691,0.1324687310724105,0.10691785253509371,0.063925231237494759,0.084949424182349784,-0.14824978071410777,-0.17981670747688494,0.079887216519016369,0.0099878844963017417,0.091658809499199995,0.0039475808537077287,-0.022988366514234783,-0.025003961189405333,0.022312743486262065,0.032106124489561169,0.0060978045024435712,-0.0091097809264211807,0.13841562948388741,0.05721814889507093,0.034249424231449693,0.14165895482659591],[0.077403080391101178,0.0027902789135363509,0.085848659908945121,0.081621580183346434,0.044686861117663595,-0.010720512150544551,0.000766928295162006,0.10466386076912294,-0.015221602350874539,0.00096214663821529711,0.10250217221999841,0.10103126553498611,-0.028640249406738497,-0.050144288137646154,0.088029509421074015,-0.039184290019048773,0.027942178534501191,-0.10921729182270348,-0.091551121886366701,0.038578400934963716,-0.047089437070028148,0.0082248556916629662,-0.016698052118169729,0.14190580766416327,0.023164625852484036,0.072603303858135557,0.11866577336553505,0.014093258001003195,0.0047638608409522332,-0.012686837885249339,-0.036660213196534036,-0.077416767630940422,0.049268385768219111,-0.044394153830466104,-0.17871803212100118,0.028784448095554194,-0.0103622383273788,0.15180646423700633,0.21859707883104096,0.11630023909217539,-0.092580368552828127,-0.019700955892187733,-0.045860659847962018,0.029996643776362769,0.022719309002418732,0.025101662257832447,-0.085650564281123734,-0.12410629154164783,-0.18246293106608358,0.091966008812621805,0.087081001569446523,0.10736116620783882,0.028110496703318152,0.11507649255715754,0.038288111619517784,-0.074857538348946706,0.0003646230535695183,-0.075728095243027413,-0.25811646164981222,-0.60691515717629596,-0.57736366547659346,-0.1230196932349347,0.10818482658632861,0.016912673562240535,0.13529133328209006,0.090044145360448649,-0.017373878996459924,0.016143047062772586,0.0074705525731126043,0.038153120918174875,0.13808042440556922,0.23128272372791026,0.062212166782940587,-0.00078105935242136354,-0.0088352484968890338,0.015948358629724879,-0.0005022452937268676,0.11232364734385331,0.010961615375259789,-0.063961968540285671,0.042697690474159465,0.075697683234001015,0.18797108390738509,-0.034270718560830339,-0.076010292391831616,0.040711497962504541,0.003927652671956227,-0.008113852698322141,-0.015998115624021494,-0.060356186306471743,0.025951586831793848,0.042163344429453686,0.082425729708358278,0.14260227985381085,-0.042848628451185186,-0.063341469459500324,0.0092863458678610518,0.029863814690498799,0.0060823890399176739,0.059612446109644765,0.030082023913450849,-0.027239380162663276,-0.0073658703526070556,-0.015225093891979673,0.044419085486733505,-0.0053691160288692197,0.022425434671702167,-0.0082635729409229006,-0.040836893779866157,-0.015422443671092656,0.061348129149263644,-0.052846129433506105,0.094365596248035394,0.014525718078802685,0.0037072160051032756,0.044122648659048434,0.045794925597176121,-0.030930673355086962,0.017194230501010505,-0.019462858484744144,0.001243582445288452],[0.084113665034921459,-0.025621034960445016,-0.023221811619521998,0.053008052188471377,0.1722413378552653,0.012469440442448243,0.075121540622525046,0.040763448249123868,0.098100783614578663,0.041479003131258046,0.12635977517681399,0.070298444019280537,-0.050007246720496723,-0.0054840870702999311,0.03040544684160737,-0.089754664462184497,-0.21540766402304359,0.017230102171692269,-0.13556988205821849,0.095618226286922736,-0.11059773025824354,0.10124548152459008,-0.076498060646510518,-0.00028541240089785536,-0.026245513796004843,-0.019479552802034616,-0.39778025123942529,-0.062143591902259168,-0.024341092169919532,-0.012826724183031463,-0.014661926972310418,-0.11254901345954736,0.16096037573300526,-0.11227786126177444,-0.068532532992675615,-0.16356466589407062,-0.19653804062868085,0.031038393193058594,0.13193348705643318,-0.083422963041591094,-0.040715685787325567,0.013809808214387778,0.039665847545365757,0.0099887743329398759,-0.047952715523986306,0.0006100311386056656,0.10343067208630369,0.24890751819447962,0.3578226490040739,-0.20933412648627439,-0.039926382349098469,0.19419655464006366,0.032188369668813749,-0.040503633096404479,-0.0032348476784208602,0.17053386793770461,0.35047600865548467,0.24645797779268205,-0.12388716569831495,0.017230415937178875,-0.20274807116351118,0.13927324407566935,-0.014868221439288953,-0.11606370921716812,0.050406898699637798,0.052284706862743335,0.2179885999524844,-0.056957003125337274,-0.20647158156376177,-0.045778722576096192,-0.174715212494163,0.052739805693730518,0.099133675550291595,0.094364060620869411,-0.060202372775518737,-0.043715737000694935,0.056370290784785199,-0.0085890329179779956,-0.096057005222036973,0.019767425753796281,0.0089128377885082377,-0.043514983487809494,0.071434017069269745,0.03636602312918305,0.013983885718858599,0.073847542491404544,0.064069902818033903,-0.1243079073528052,-0.077473394951124958,-0.0030770402418191234,0.012411573849515189,-0.077233395464899518,0.052213298166160438,0.098480901187919578,-0.044983495910957086,0.0093175449591838683,-0.014435731895740433,-0.018574666756547009,-0.016642124460499341,-0.20214085319841704,0.023000105666364901,-0.056257873953405604,-0.01762107897153789,0.019130131746270068,0.020007586924534165,0.03483339161645628,-0.066635058968322142,0.019122648234895845,0.10427685298428223,0.026510785405202311,0.16286923233388592,0.02793257220207912,0.049606524388094764,0.050049491429857901,0.1019360210121309,-0.025880325806131227,0.058534465646414693,-0.061180519358758872,0.17253450900113493,-0.13459923259367187,-0.090407597313012622],[-0.027550816137581063,0.20556735223558539,0.08213180283129054,-0.042570327563692591,0.01586831912703765,0.0093698333764795361,-0.11462856052306328,0.044711856850138204,-0.15995802392503708,0.11865990971326171,0.0673921974401607,-0.13862721846117479,-0.24991581191756615,-0.12741658368348494,-0.048942245808076282,-0.10908521327615617,-0.015851721850914276,0.030010677013469683,-0.15749365231887502,-0.053420943220933284,-0.025662830013189836,-0.011092925627943839,0.058388641152087056,0.088244561781003344,-0.053728117004780987,-0.068366341306591,0.0026508458051404948,0.097817872697453651,0.016895869777799971,0.029099746903975626,0.15597074244969705,-0.017162667301283602,-0.047857867586063488,-0.066641357291646677,-0.041049665489416423,-0.029341908735795189,0.18068461986324288,0.23841021509849827,0.10720477806483233,0.0032504209495289177,-0.16875590654789738,-0.055651624441500805,0.037864293059399243,0.14496557145479333,0.30165038928541399,0.21780633210507225,0.2478067430020475,0.20611438223970449,-0.030505045384812982,-0.22354863754123386,-0.22057742020428542,0.026160777231004489,-0.014489792871384327,-0.0013992789264812011,-0.032142807111526076,0.069858404495879517,0.12952310052385177,0.062134024665833537,-0.095850197369784784,-0.15005742280797291,-0.048690422387721657,0.027625676945502317,0.087751539276551271,0.059382068636311708,-0.15547685553596879,-0.0089930406367377536,-0.2169595372240255,-0.20894528496184284,-0.17492068880682238,-0.10306183600146183,-0.083259534728607171,0.10865204818788957,0.060744670090415315,0.050196375528596446,0.059347173941546122,0.080550163011289838,0.096041183403468094,-0.1792150255632714,-0.086359515761684963,-0.19861633026471431,-0.085305595365594317,0.073404453468704292,-0.00060915535289933487,0.017864996966518068,0.015229839479410548,-0.028738700704038833,-0.030631095956117516,0.083546542374686478,-0.015199467885082363,0.0079196568766907727,0.10542259168905797,0.045879590738125489,-0.016176817524772791,-0.064404029773047405,0.056449523541363983,-0.0011675857621973734,0.0019961877116474042,0.067416701497825943,-0.0068872964750457538,0.034855870056329508,0.017610685547011118,-0.064974529939064218,0.072135113039659637,-0.038534030205095104,-0.014020364161441437,0.00029360239040131242,0.12282296947714948,-0.084526078839246968,0.072733520082105957,-0.026199337777164058,0.2622823203473173,0.056466937642953463,0.026818371415154252,0.093991868595920028,0.035828326553373244,0.18170527988919383,-0.015152288577127748,-0.017615532167961634,-0.0031861578874696761,-0.021179342150732736,-0.15213715846860609],[-0.13774523436409969,0.038746368626390894,-0.00070857044653628576,0.049355010027965204,-0.088279225323666277,0.3384991916323753,-0.064154782872609478,0.013423151043787954,-0.019629041697081684,-0.074514483376996052,-0.090355781264570376,0.096941216713528164,-0.11910664582618065,-0.15100751467224666,-0.013947233410068524,-0.28747834932862831,-0.37903665180179325,-0.2028061966058827,-0.1130350051672437,0.025054091741846772,-0.081018737004221672,0.092552127718648639,0.00082246462611298282,0.24245844724477272,0.12843614602564724,0.13562020313059403,0.08959454097829489,0.23076896835282149,0.17282137454049196,0.15120139028220045,0.2108003848913195,0.13274188314172597,-0.11296580760432726,-0.23425804061193015,-0.15388856567280207,0.047550247591945885,0.13675765224748537,0.14970887500641089,-0.014598687955070258,0.02452413980077512,0.15008479234563366,0.021969575372334967,-0.017209314441183898,-0.12566589356298841,0.057462149793583807,-0.12422822668708502,0.027717976800794235,0.076470028456385508,0.15084174315157894,0.16363419431275902,0.10314072255216514,0.098604445511354985,-0.077889086218999121,-0.1661031133394909,-0.015523729349795651,0.033968447572520016,-0.0064287733234517919,-0.077784123694540519,-0.13138597183951684,-0.16492537584704581,-0.13707718063627361,-0.24996598417430377,-0.099387315671480653,-0.041816272470969071,0.063392795262038587,0.084656792003326736,0.073596111775181064,0.0096742751571591568,-0.056184484902255249,-0.09782611167515598,-0.20167456268371736,-0.035743089697776065,-0.053853754214006649,-0.094088602733082519,-0.11120588730571836,-0.037671666252394119,0.031541190146133206,0.092725555798098935,-0.02405726855688603,0.006010846171522255,0.026069243416314662,0.052952378460022542,-0.00074538711425108095,-0.039415421335204141,0.00012581754959352376,-0.074805820908263931,0.010523867284072515,0.062406077528648747,0.015813904262298846,-0.064838239938092582,0.031265967377395135,0.027507834966997668,0.00012699672107176554,0.05079690966459828,0.078969877915991929,0.098317505905439417,0.054192666869303546,-0.013030640855035372,0.049683315230003938,0.083508971632165918,0.011784477594072869,0.091871680671077899,-0.0066226790079174785,-0.047956123703921293,-0.017090317814363196,-0.078740979480628748,-0.046730705240827737,0.018513947238313962,0.071499897543357865,0.064736690247935547,-0.032650670337155206,0.061363794900654349,-0.039888121585693735,0.06940981414444819,0.077977297819488783,0.066133719833712273,0.05598211257429133,0.072595488855594997,-0.053844526913953562,0.09608563004350644,-0.028805713693717965],[0.044235218750753806,0.03452490583678916,-0.1304293688025541,-0.03539195098364023,0.017969397644679183,0.035178036504637217,-0.010788443554145211,-0.0016502053765038854,0.039150364258434663,0.21472717137309544,-0.094799579619150101,-0.028715342944390494,0.054860337568606081,-0.039323795503948329,-0.071940860906896581,-0.11930894160210025,0.0078117674331285164,-0.13496527011108017,-0.22468220163734792,-0.041963716626139388,-0.18840317509998969,-0.12848466572254685,0.032762146633843053,-0.0022056152468009141,0.10277613826454918,0.0012177391079194258,0.077762844802185094,0.014832783378042141,0.2549270879104647,-0.14122761490223984,-0.02812892511916594,-0.090593423291392555,0.078746303030107434,-0.013334851815846885,-0.013098417976838569,-0.085997431567791716,0.0011500587455686162,-0.096291957570617565,0.16218222843705965,-0.026280879180661507,0.4059162672347385,0.2242570275495756,0.088914801219090844,0.087380936685669458,0.043235742271058968,0.10434670998406992,-0.02968326553011473,-0.096106796162175004,-0.16572721595924714,-0.17366678905777666,-0.030961339846240048,0.059505554081166881,0.049325908092511556,0.12756582867533076,0.23979790342729132,0.12399889130520506,-0.27711805486247987,0.10320304516755278,0.071366923473124746,0.066138985335745387,-0.017570740572059176,-0.21848821035302129,-0.096325738578736123,-0.013236997628355902,0.14099804783148318,0.048656476054380837,0.030847391971354002,0.12062557790469333,0.031940378289510442,0.012663844222798573,0.053034778014022767,0.023358934432241123,0.073600738663428589,-0.10514949440993024,-0.16524216303765682,-0.25669075988459938,-0.26896594887147668,0.018565946082153541,0.093589512766167254,0.028127974684171123,0.018696901200308494,-0.015875163077901967,-0.0079379097617384188,0.030609616137362825,-0.015794143119850355,-0.095236312837370815,-0.029087387305527151,-0.13651567962256067,-0.073683058450215624,0.054901623218963372,-0.060990796740251554,0.093170395781096649,-0.0023871205690264331,-0.026190765199777231,-0.04798880819540316,0.019891792536779831,0.053632284454708232,0.021996415436857979,-0.058484829619743363,-0.0082971666182568952,0.085922982573187742,0.0078349537872220328,0.0074972747215579123,0.033528171976771326,0.034258795986853316,0.040069268495681584,0.016642170052174849,0.033376554888908505,0.0094589897400608781,0.052064551717063458,-0.084929444469789464,-0.091861293774294875,-0.072335293109873536,0.017511044864076567,0.083822791083669079,0.029829413251507158,0.022676448560172629,0.092823512749215645,0.027104627928702215,0.049933127943481807,0.25204397185842226],[0.045017070595711133,0.0498642789949671,0.082320969156012919,0.11789478363532714,0.11183772343297438,-0.1253322045343096,0.073011089356233294,0.077003721577057399,-0.03717900545496422,0.11530429785134244,0.05730001513322304,0.097848781670201404,-0.03060524384717013,-0.0069899183498422779,-0.043814689161140008,-0.041086107026221175,-0.10156550268991253,-0.030984257446209529,0.062242270842820177,-0.085659902110209532,-0.031199205006548048,0.09466362301479106,0.18696360752101071,-0.1661308799155149,-0.0090085495016999778,-0.12606646172545299,0.061744312534455212,-0.10058744884305808,-0.32554386979332489,-0.093972833934417715,-0.084099675017452177,-0.19412666055289363,-0.073752883041483294,0.093206668950364335,0.053698626158480575,-0.030509976495433661,0.035499265069312287,-0.088218415409939618,0.14081935255976538,-0.015418397657317465,-0.14008063599426096,-0.021415771106654449,0.073017887242636206,-0.17726620239081409,0.049670987591142773,0.034513230883957385,0.10331367544756308,-0.039224198145387315,0.032001387649784233,-0.31709931967548438,0.36394741418078808,0.15239466974253513,0.12006928728376079,0.012632970433185474,0.13528479946899857,-0.043263351294103289,-0.041986389073361857,0.069839057237599783,0.0010105840343706679,-0.001177493293526035,-0.011794825581052382,-0.14348506855517926,0.022137252763930207,-0.039687582510860714,0.26218159086991571,0.19436953435957777,0.11018262120789611,0.022791444872238911,-0.097374550971521742,-0.016625841483821784,0.15980938407436601,0.079561148796989944,-0.075451842770343128,-0.028023527278215769,-0.12778377344107292,-0.070600952976917736,0.075854745502590859,-0.061104114583229563,-0.034255065348455287,0.047000517227076224,0.085956850425998793,0.04282729750891924,0.035824417662887978,-0.0061231911453551446,-0.038509250299150546,0.052491286674368046,-0.012429025518286289,0.027802410046689319,-0.045633571810510726,0.057329919165400409,-0.074157742801148993,0.0012829945233095302,0.04703190758387131,0.024833428093670173,0.037204577451850254,-0.028766340858447596,0.04836022604994912,-0.053270097737550898,-0.1225368009934108,0.037120069768975875,-0.089284007907524526,0.064955297078712851,0.077539064409025166,-0.027111775203657915,0.09566272146318118,-0.024483731157729047,-0.036211650145923778,-0.093915798725000027,-0.017320414345298095,-0.10222122825099972,-0.08839882935836986,0.018021145195601808,0.014346493014463765,-0.0045931108148111605,-0.041330999096111307,0.03707125175822254,0.032109088650756609,0.1327316051894474,0.075109541167208693,0.02562779748474479,0.14212920960470612],[0.15729146952739428,-0.052978575964526695,-0.0026258454378078749,0.07899544804862188,0.082044056126512888,-0.13536453065722548,-0.013649345776134983,-0.013140590068438054,0.01151285607422449,0.051596177430297457,0.025550220473819302,-0.039487220487149505,-0.034658288058216052,0.072490544458391787,-0.11567294550509376,0.067863801617483122,0.068650773394936471,0.073985890698350126,-0.16153712899081113,0.040446464260465734,0.071466438250948588,-0.11469018047321458,0.054050503923005255,-0.041043012191213868,0.14996547269454152,-0.25422330965645823,0.1969719351437533,0.11290777964377821,-0.020530641521012943,0.12889998621276044,-0.10368261923120013,0.096091901965415991,0.15324884079071813,0.051489779311227196,0.033559562206468427,-0.20829917204727766,0.022893590362530233,-0.26249604314109187,0.01920855427735553,0.23588413973673644,0.012602139087501865,0.20972078789304485,0.092568536380977479,0.10590976891238137,0.074213758099456212,0.028278486131047539,-0.034766214821145405,0.025387015471766056,-0.21114625235885243,-0.18142723897056606,-0.036903154611340375,0.074542244212791459,-0.073942717333307595,-0.12923367863313379,-0.10286993284460598,-0.0020478562727464372,0.0070327870476685345,0.041658770263764591,-0.030913879256598803,0.20126029986072963,-0.36149406972284098,-0.5918877032494142,-0.34765190314312044,-0.29917756970453346,-0.043195465679216768,-0.30777208287521557,-0.054570873464765829,0.035677453144259269,0.033779035010883279,-0.11152465910750621,0.11790825287438664,0.50742402779615148,0.23855694673921737,0.10488558912344918,0.074814936164492321,-0.010757602002390856,0.098422174417897912,0.068011512986524178,0.040081067317637512,-0.17815840391411603,0.015218382958913604,-0.043044787072747059,0.069478785978807592,0.26248348656437781,0.1306172564649099,0.15898046016824569,0.098913085077125359,0.16690881596534685,-0.045455788389378013,-0.051217783957418925,0.088651764746293119,-0.024238261127295962,-0.12061118524458514,-0.13932561033045077,-0.098447824398158607,0.084104128443532489,0.03609504694316075,0.064677179270859433,0.019556502245895897,0.054584837489264737,0.011804485067672219,0.04962752013073167,0.03158019227826489,-0.042127606074900098,-0.037246845366204762,-0.00090228035552694652,0.05127558828330446,0.017591411946701482,0.020608297506701782,0.12021482673005342,0.039021952316670633,0.021711754771879227,0.047172199479969562,0.11457521712485876,0.065529260941908848,0.057133065165575314,-0.064145843313717532,-0.079153570089738917,-0.084203588908724702,-0.13317811959911652,-0.097193108721414789],[0.016239054180390664,0.0039662727937494063,-0.0045546608488466339,0.013554085633964541,0.04287384927044155,-0.15274614529097097,-0.027274870950224753,0.009662815968977459,0.00030503272333276543,0.032218254842854788,-0.036021236700139334,-0.042600552093793376,-0.041216087356306746,0.070225279182411185,0.088251463799817353,-0.11943869442811812,0.016009417433122689,-0.025892296238322871,0.043718898111848606,0.046349743840285895,-0.045519881760365574,0.057802463286196488,0.03299849377053235,-0.074789027962275934,0.085612573613843404,-0.082967036772006134,0.12226353323600213,0.056995647983886233,0.22311371083336579,-0.12892292639894809,0.028711597590839549,-0.082294811006116686,0.074670881436146558,0.024025896326078336,0.07065603601313146,0.052863436123422466,0.13162507032318282,0.083850012252808775,0.019373316885252463,0.068601186045407672,0.16045426623761011,0.14512299636928327,0.090971987176700866,-0.11720878638068641,-0.10960101740165,-0.22989932998426871,-0.040375493650495087,-0.20170065712267327,0.21032193985451469,0.028436766808479619,0.064868788568131358,-0.18348723541305237,-0.17888322479271676,-0.24993108343054868,-0.1218218035048543,-0.032694964791572315,-0.0037869041619365135,-0.24885660964872919,-0.15602019937684342,-0.42475936671170156,-0.42360041816934524,-0.36080165394257169,-0.18904408350207366,-0.056628034016529188,0.0019947298303030075,0.0099847288775674753,0.1075269031323472,0.21965496214815466,0.18511412087840118,0.19939690136264532,0.23706194766652711,0.1585535076891107,0.23755501089495354,0.24026771887297607,0.14806350471741694,0.22743537801775957,0.12507232761343839,-0.12207706841814078,0.041225407558751273,0.12974091028573875,0.13877343222126551,0.092819074272623342,0.041456933016731201,0.12810971742453969,0.086282278039654381,0.046482152214626163,0.03598526522115604,-0.14999835453581617,-0.061994753063569302,-0.12774624354082473,-0.055468530754657547,-0.072055656326832668,-0.031200201377666728,-0.021697705969703371,-0.020319605794475559,-0.011808386343022212,-0.10716560570031625,-0.082342449185127842,-0.019256109946120217,0.066678811003636818,-0.041536723571689332,-0.040687519600928507,0.044724573527092748,-0.068305216896473495,0.035585363893159354,0.026945608802347733,-0.011423097664885327,0.061366414602964534,-0.049741414287749496,0.054484604133461456,0.14247436696258881,0.03770989015507005,0.014814583813689983,-0.12196638284522934,-0.040852970973417571,-0.0048072698419944909,-0.093844453345438394,-0.11066938503473484,-0.01308544267539942,0.020003661283812341,0.11572349318879958],[0.02861973429703818,0.054226325319119265,0.017678757532143818,-0.054622115279891297,0.00068166158543815636,-0.061011028044801754,0.025449624542795035,0.039248763551355731,-0.017614050568012716,0.086689068955178875,0.12901578182703599,-0.059155840152992877,-0.033658287075804989,-0.11303253492598647,-0.0094407403287756972,0.038300106001050702,-0.024382057855670103,0.13094817594507807,-0.17637051833702583,-0.042536434179399618,0.024839476402364308,0.025341112503526046,0.073379240915845495,0.12490394236296019,0.052334528402483899,0.01959442719741869,0.014409551889643532,0.06939173936687891,0.10114636722821412,-0.017834270494535995,-0.0052538748958707721,-0.049449629111543728,-0.018515125726140946,0.02732694249374093,0.09763594846358073,0.13398387575020193,0.028128579416720284,0.10345916561982525,0.14559912798485353,-0.062225750838370064,-0.043205385313047517,-0.13615012492801842,0.0094595802241661097,0.077643293280986139,-0.01883839881610818,0.040124806139584204,0.046082762604961053,0.11596384414343883,0.041671199210061065,-0.035255123832835487,-0.24210069103686924,0.1341304895480569,-0.12174034267618312,-0.0024940337740440369,0.019159096554587522,-0.28596248479682318,-0.064486219660767827,-0.3159404613081046,-0.32103692755655011,-0.52703621320348082,-0.523706814301239,-0.2219710388945374,0.078177953209590229,0.037152776634131052,0.079429350175809904,0.054710873615715222,-0.030973473678087608,-0.17109338841301949,0.096071725904511768,0.02326460744017457,0.18229765892428224,0.50841537933922254,0.36327137375759511,-0.17442768533982334,-0.075940774557052448,0.084582691420455519,-0.08264079354279294,0.24078778306714929,0.12327508787645428,3.0311214018877153e-05,0.20734217619087927,0.13348805342234585,0.14204478537466711,-0.016683009143729791,0.0026274236589628186,-0.050599783470677923,-0.093501642534019186,0.049346638059468484,0.027169521962694204,0.0088066775641548883,0.29974077633101837,-0.017370887640425853,0.060472611475062152,-0.083274580137458892,-0.048734360258655733,-0.12258982430184573,0.07453840474434334,0.0016868192049145497,-0.046678375687987328,0.10225565600123501,0.096413382614769089,-0.085167675344914512,0.011074699633376178,-0.058526124313595766,-0.032743113966618241,-0.1722075038150731,0.10625699459128871,0.045122620395145224,0.063156899424295448,-0.023657194122683647,-0.086189421429932939,-0.097155679216888668,-0.11778596011866641,-0.0018160616946504698,-0.01837453110222613,-0.022154736774935388,0.069072543182675333,0.061842701091324143,0.057417191163580447,0.030372244451354793,0.089787775464562541],[-0.001637558807711853,-0.01523399155873769,0.033084196663500154,0.010429688997138621,0.026387307256101139,-0.055493049532405039,-0.089867986082774118,0.031318369429763571,-0.060212072041702008,0.060345081620277463,0.033637859079548624,0.074907674442576552,0.06734422144223931,0.045408985332457019,-0.016588163375265065,0.11808910368697124,0.10674593565355751,0.014356560764954368,-0.00029905420194112353,0.032489925736142289,-0.079691004870107801,0.0021152438820417965,0.12842998293419816,0.027685506112132927,0.051037174605280025,0.0095027734141051382,-0.088577143955959933,0.072415217616874708,0.18758587336750721,-0.046260082649078216,0.032834457400313488,0.00027333660832160045,-0.0056258729733840926,0.051335227757921958,-0.028997953896369527,0.010803615722912593,0.039278862874021811,0.059934818237191961,-0.036672818526105114,0.0020455805172246433,0.08420494892293047,0.078722497431976415,0.072927829328334359,0.0029102454584164217,-0.014711323072181468,0.061978949521715912,-0.0058613640044295964,-0.0065096004647029956,0.15462308680710604,0.10998731441673203,0.055119939764749493,0.05724647785751881,0.08467350723014512,0.045415614831981893,-0.027011213416260203,-0.41690504010919505,-0.2381619432525145,-0.26802740977048395,-0.42973960239470188,-0.47128936696927559,-0.47538117711853761,-0.23332878411143415,-0.02866052018803172,-0.046785685844234697,-0.013910661881944619,0.063557340319003772,0.20816618228755654,0.1268039069069368,0.19584967158175218,0.24120710644978025,0.34247879950952587,0.22000223848712153,0.036993585153171818,-0.24940743884977212,-0.12911855055552002,0.0067607783858616433,-0.016380373357314598,0.023975770224144183,0.17281340795556549,0.06774703585492528,0.099348094695161412,0.035397538040306792,-0.034631661821791018,0.1100865505604692,0.005313191434559647,-0.1852260149514699,-0.015871161665418073,0.0086230437445217883,0.038923750125692352,-0.014894463369033356,-0.015235500642311592,0.0015905054090605206,-0.025942083213375461,-0.048032891124765054,0.056968059211618904,-0.0053550471186975812,0.070041367697070894,-0.019904063376663322,0.10013072647581948,-0.030663141377206063,0.014936482187214051,-0.053377077668385668,-0.046191143798223082,-0.049737104601448617,-0.032034940192103359,-0.026289206287861282,-0.0073802153527658398,-0.0085776521075193179,-0.067451013841572996,0.036964969790641428,0.012119189183510626,-0.012732265280952129,-0.014067660545222016,0.011208506370721377,-0.0034197755020493881,0.12161984708872418,-0.090967033228651281,0.062061367658091768,-0.023761385872915743,0.11195006309284704,0.10944483983918517],[-0.061429217767686103,-0.024854862147621323,0.037533900593050687,0.053055218475401428,-0.029090391144677347,-0.076607532589230393,-0.056250478754706124,0.03851333502343017,0.0094111122857806068,0.027627758598813779,-0.040484333944467571,0.062572284138447634,0.018534104488487108,0.099953923075381451,-0.011584012590548413,-0.027052354458091218,-0.0059961345960441587,-0.021253583302654644,-0.031551826484526257,0.13841564062729481,0.0044654988962283121,0.079158575949980478,0.09330712693847118,0.021057360335951708,-0.020072455903489106,0.0078349261993443525,0.10646163879333373,0.11394158834484362,0.095624007084734647,-0.00037973373006179589,-0.010566642708017659,-0.021229433197596272,0.11951412079200276,0.15658745914488753,0.051156677361355526,-0.06149908185714912,0.080077841970438823,-0.060312781555823307,0.10862415451751303,0.090833457141346358,0.037749802298128181,0.12669250756084155,0.019289318800248804,0.11166309161116607,-0.1161166273753233,-0.038270596780716613,-0.013961859511050188,0.057456373007881457,0.035911303378527666,0.11685366316626331,0.020811499706270893,0.042274819174293238,-0.11786932199756393,-0.20631689099465444,-0.10339540502604118,-0.032371044845522869,-0.14327246772273436,-0.25192334370553027,-0.43351265016373064,-0.32253010533464199,-0.39759972190268117,-0.39288382422516366,-0.39114382180517604,-0.24669511513347489,-0.087920593700299116,-0.088613432773507361,-0.15980594976718124,0.18785644160235501,0.19150833663803338,0.46363761289278804,0.15919333829593552,0.19352833505902622,0.23198389189372812,0.41944067807959584,0.29116622643028034,0.13265224163991357,-0.041280875296069018,0.024460830389148203,-0.058649245871120803,-0.0484310682254976,0.074458524703983509,0.038048304115812073,-0.040110091881074464,0.059869902924825739,0.052511568070781466,-0.0090562152269471445,0.023537459561038466,-0.06819758275382648,-0.058682078489213363,-0.031437612709725359,0.057289605620930092,0.09631916110523682,-0.010631903539778567,-0.072422830632186297,0.026755462358263725,0.018665513895049689,-0.035082729434644327,0.0033658937666455023,-0.025999751547288244,0.051530594005125122,-0.095877639344744012,-0.072903503224737154,-0.067948463067868003,0.0043261175722517503,-0.0040117811540246531,-0.0054864150036365369,-0.0070406076984890556,-0.023664491880765207,-0.021348914552691282,-0.055764945037704343,0.076203461056541313,0.057794773037288215,0.004991409560975428,-0.014553984524648442,-0.029743957901801635,-0.057165125367652947,-0.0010086458792998715,-0.035361751471046692,-0.0047530832054770919,-0.011301320960084231,0.11501077964365991],[0.15173553770142628,-0.014179130345110133,0.016877350096463503,-0.077204656983401884,0.07810802077917843,-0.13112570903713622,0.002753461595534773,0.051910634906651945,0.028947846824779341,0.050208812521650187,-0.004579484116651808,-0.10684515347432511,0.011155331270464766,0.065186111881263234,-0.13027319256310377,-0.080144308959196983,0.10735864824242532,0.048879724645552361,0.015758793271349616,0.12191464251681002,0.096984668731898774,-0.008083344199497508,0.02070520927773202,-0.081937807089683207,0.0046465366987262363,0.05614793344286019,0.16628267002053893,0.04618252947477354,0.077657994922063114,-0.019960907459527263,-0.096538343643650965,0.079466046122461123,0.25805196379883999,0.007762217116777187,0.069519575178526374,0.0095238196373019363,0.26151693837929407,0.086788350648662874,-0.037402260798162723,0.069485740614805419,0.071694722362200328,0.13258033500501015,-0.02145849038805818,0.056046350520208621,-0.00039374783734824614,0.03222219258902316,0.18458145122623904,-0.042539782956061298,-0.012963640462772971,0.170102640969749,-0.023561860478587326,0.051152948285101807,-0.1316626386662188,0.02066528156095445,-0.24022517587189773,0.038647270662851535,-0.025858147741203062,-0.08145590938506822,-0.11686693255496608,0.044401292680239651,-0.35730505607122431,-0.64580488622829257,-0.40587964607656341,-0.30571259666730671,-0.12682355113036897,-0.33497937322424648,0.015693363372025454,-0.078712326242700498,-0.043104245874849255,-0.15482305108138567,-0.23546372175602243,0.11116967724198698,0.45544745949997928,0.18491255398354933,0.29246815522355635,0.19673022854984701,0.1971071562521477,0.073292239939430431,0.0082411542973328047,-0.11506545091726129,-0.0097698594083774834,-0.10085941287032674,0.068419957471663198,-0.054338184555724992,0.077438069850143426,0.17116462221553444,0.0012880410065990583,0.13426211870566188,0.11060346830231947,-0.073247383642716754,0.037258219358590916,-0.012266626223890298,0.07365939898386821,0.043783414774759152,-0.10714901521414893,0.086654095775271639,-0.068763019687166305,-0.058722296121373203,0.044547323244407605,-0.055317944470135778,0.033044549367641826,0.057546028232389426,0.0013722198605476341,0.024825635569633846,-0.12204262640334872,-0.10189632816975304,0.054772548849134656,-0.079577832810170182,-0.03822925555621319,0.036494728908033278,0.13217334923490376,0.057211373582709266,-0.025832313366592516,-0.054716283139663077,0.013913569251103083,0.1233331303710279,0.0048703487927865205,0.0051743609192116194,0.028390246160885126,-0.021507757354650846,-0.034672329558215337],[-0.0056383990198644179,-0.034134669652071015,-0.022985171274173141,-0.060424905116766223,0.054918574572591805,0.068880856398085097,-0.0070134853831463756,-0.00648857975984031,-0.074996514150436733,-0.002575895078660656,0.023015025445107737,0.0083652936395193778,-0.031176094638168075,0.04257338372246873,-0.066108851141710501,0.029356311647627392,-0.013291948615577448,0.056361974052678648,0.034219482611279453,-0.012594934239664096,-0.014011911140779154,-0.062380978120753092,-0.071139980976335282,0.0024195852417379371,-0.035945491331999854,0.045638008001674502,-0.0047183763310553184,0.066745235874213119,0.045300106270492593,-0.044478673970143032,0.089640508954303269,-0.096496181994925961,-0.027741072518757348,-0.0057167706753694508,0.015013223612745458,-0.024603266772382323,0.0013274270991194131,-0.035626865786564946,0.017128923114182848,-0.045972517229731127,0.0070036531582612499,-0.043147491260715071,-0.029564377599491043,-0.020695369020395371,-0.079784746542254759,0.026833980742834287,-0.0019308823001443487,0.083257616741787083,0.1073292905313316,0.074876843281655947,0.04849810672333138,0.09169820062468502,0.04818495710565103,0.052095948996421212,0.0076798336966644315,0.10519490110752421,0.022530132067634476,0.12672233854609458,0.059196502607268456,0.073165601756717547,0.11595348012337076,0.056154381226182701,0.12932878620836885,0.088424364447093076,0.030086554964170939,0.069155625788998448,0.12091856805585206,-0.089931598708795482,-0.01901478695671717,-0.044734780540160696,0.11875971731148252,0.0019621703161090687,0.098962626854570676,-0.014935988916705181,-0.058156651049639019,-0.030280527562952381,0.039004290751598267,-0.084990899063584049,-0.046013083127367377,-0.014913760028022027,0.021155606661541995,0.064215604532574938,-0.023980009754675097,0.028088175416754846,-0.015711319084152214,0.055354677326641441,-0.10471526203870407,-0.089682724627139304,-0.285340049872218,-0.18318938265740103,-0.080773536226484838,0.0051664926844681297,0.057862500220190766,0.064363929659878055,0.089305276057643879,0.033737553106247584,-0.12462760155848271,-0.15876787514393648,-0.3559472010693181,0.09512910727572213,-0.14724808649647816,-0.20315881235781566,-0.084142690865390807,-0.21320097373742838,-0.18018782707193445,-0.21194408543671259,-0.10022760576175327,-0.021533171965098907,-0.037309088773028909,0.12624286755807518,0.22034948666962345,0.18909901249809574,0.15892762405783045,0.012004127757768795,0.05401853470010004,-0.028528312561415387,0.0032335748506411056,-0.0066271780398669822,0.08469326627498211,0.11628744535951219,0.19103429211412726],[-0.086320145870854931,-0.042516109128475088,-0.0087762457752190298,0.021241060023051747,0.0047851426838899369,-0.035472062577375424,0.0066937243438659755,-0.00018713747041253226,0.0082764260933883976,0.038739768015236681,-0.068077755324487108,-0.050241928574835407,0.005362760135839445,-0.046723041558019832,0.094159253636089596,0.025986870656512701,0.028402847338834608,0.12799263106977857,0.052174185297818504,0.03174223717567129,0.043516542799932806,0.10029999162817296,0.0098879715083901587,-0.035094445123424634,-0.007013648134597858,0.06906108560461019,0.096710723211050592,0.081381162486572428,0.057644504950450134,0.011067196959459139,-0.018381106688349691,-0.082601705729948863,-0.052683720386780014,-0.019959970942575705,0.019919134901318802,0.074764134214878319,0.0037733543810442721,-0.0014401279343240897,-0.10890764410839328,-0.057901568753596977,0.062402857017999663,0.10607261825733119,0.093355866166383666,0.16321573911501755,-0.044311905242035599,-0.0066519319038783609,0.024113039196997976,0.064553442056319327,0.15171280458638239,0.30457768060707258,0.087041706132401087,-0.1300649085600688,-0.11937696051908048,0.026590394860137298,-0.061874328052457871,0.099972551939148752,0.063820348697113671,0.1176673091939654,0.1041271101548924,-0.064651383836351634,-0.64838832442120542,-0.57718682640452723,-0.036255792881924792,0.17483800093943763,-0.082878993225198747,-0.052895537911918783,0.093450779297526765,0.13222855504871267,-0.0031158955676405808,-0.20504263887375321,-0.56713098560646558,-0.17042057724882412,0.5127831574851569,0.08057209143675742,-0.069034813778198756,-0.076493686008414857,-0.0087908313214440509,0.063359179277283378,-0.019296007009984323,-0.26310778686915193,-0.2643185488881028,0.0043899974918117923,0.41748261831713607,0.23966204304538938,-0.073562286976180655,-0.095509848197381481,-0.23474683230766644,0.028298339134101541,0.061074713423239807,-0.16176706647884559,-0.0028366628109293551,0.09422220116207343,0.12827497526492809,0.14706895212081389,0.07130221932440324,-0.074737279889640948,-0.23885224275969291,-0.085022204291187037,-0.071470035260692039,0.0091790645587277592,-0.00092605797513910237,0.084223960477746732,0.073149894313199529,-0.027624077571723846,-0.10044220817006712,-0.0028872784191937562,0.084866079586548959,0.010310191760266263,-0.00054869280830070755,0.084217742322492933,0.0054030147214450402,0.095305448601468015,0.021416282988412971,0.032093023880259933,0.095157599788670486,-0.064421030882217095,0.028974651903107149,-0.0069885504710366086,0.15811077547403324,0.077388062511628844,0.22282468960474461],[0.076468088841762316,0.094525480369675952,0.013417457238376423,-0.065411302473434824,0.0022049098738461115,-0.19542909991536384,-0.01036325544715716,0.00068240056414065053,-0.025036329876752375,0.10709994456938719,0.17509342504686981,0.14614357796041205,0.053718089360122373,0.033398784940497278,0.05851426192031009,0.10088626385947798,0.12393259984256801,0.00030036795350879553,-0.072506053021494155,-0.053549467701917083,-0.068974945061981693,0.068142910765739376,-0.0032046953892697905,-0.023764344412627286,-0.033057372612734337,-0.046769398096507681,-0.12086069080136047,0.13198139059769748,0.010909080970491494,0.11805853563674065,0.00055654489186848788,-0.0058049086792519716,0.035993036729574671,-0.0082657161673258817,0.06835085226718729,0.030100108849902718,0.11300169606234395,0.049423358201738793,-0.18768681794943032,-0.089816229291464017,0.12209444756370379,0.065398341021977502,-0.23087808851819352,0.013400992883371765,-0.096887032265275258,0.09659335704424854,0.089714531995257141,-0.0038843040921827804,0.12013144346588932,0.37404235084965881,0.21211466109416433,-0.011527049200226763,-0.049283581516932851,0.018754604765659974,-0.082644951395777433,0.10817924171979713,-0.058116213333392674,-0.049761441433128661,0.038467810528975951,-0.27345429596810805,-0.84643475711205407,-0.29645101227395931,0.088275591343327284,0.11386954716890384,-0.043246196130588041,0.0080366797469389184,-0.10745428649421408,-0.31046605943055011,-0.044147921462402942,-0.1780528735930817,0.27176076889250983,0.52374603988343083,-0.34603331319263742,-0.25552652026400441,0.041698726893088206,0.17631040231935152,0.089000463451089376,-0.034971907472605007,0.015213546106438838,-0.16155001168047278,-0.0044616122955418308,-0.19608326491524342,0.52390737300255208,0.38353319497536614,-0.18308498375136645,-0.36865739333612096,-0.051599769698091352,0.18507587383644392,-0.03905957968438431,-0.11293732152378697,-0.29448175156766543,-0.24257847708785274,-0.020336287901657812,0.16460493865286885,0.042028560709745783,-0.034578770254525062,-0.080621311330306228,0.0023780590689402997,0.097090140036115533,0.25587417177669869,-0.25284237850182822,0.061610630265467842,0.096069531106907025,-0.0530490597234618,-0.016158178823568958,-0.051427555078757459,0.15564444153816212,0.18885757011599216,0.008434900332647044,-0.048989097338605264,0.17712068560704061,0.19164022835084701,0.18133053179257821,0.13611731878917838,0.16529628517400261,-0.029342409275796733,-0.042788443152580583,-0.05354612070195941,0.043048475539918307,0.00043498176350832696,0.043391550136365135],[-0.067392496195279539,0.15603790499391812,0.33005542485267503,0.17019472884597617,-0.0097698948495494181,-0.11247473585306066,-0.094639604761681095,-0.024494294275221998,-0.0039792348017262669,0.10994471173246248,0.034232693599063196,0.17574157070401114,-0.058307873942274629,-0.086035618850559076,-0.089377803027838487,0.13060740524380768,0.083342578777239079,0.045589343153219719,-0.021500197744655239,-0.0396176985432692,-0.040282895436041813,-0.05490829999440229,-0.029620701005614619,0.033422070447237745,-0.18107420807866342,0.062628310049176433,-0.15452481995687467,0.16302391245774031,-0.19245645289137592,0.025898631717022558,0.13801998524859399,0.04258082061725732,-0.10231719535275768,-0.047878669979998692,-0.084651539536313797,-0.10421201862848327,-0.11475351378970063,-0.077447511407303965,0.1751315391960965,0.31630961804401514,-0.21234361067848667,-0.13717780192340084,0.032256315027359303,0.16117460365654565,0.12436610992083444,-0.1960223209372981,-0.10316972333420724,-0.17989050580766375,-0.030776595813913885,0.36723472811894087,0.26822822948346281,-0.14255591471090923,-0.34284397107479048,-0.1686302689762979,0.20717723978005761,-0.043610297940625702,-0.21591071858781744,-0.35645281884894064,-0.35914145172088552,-0.356538210400283,-0.22838433437597963,-0.25414794447519751,-0.027037660554611806,0.10429938241738665,0.070313100422815272,0.19633410406749333,0.011469003363448749,0.056100652037588905,0.20979311430234168,0.31382740777390794,0.36266090418492758,0.15632710796745802,0.043118215553735822,0.15941891562233157,0.13799810456009839,0.082456547922922868,-0.097362706765706603,0.017535763817111305,0.18875412500763653,0.1322991804906124,0.093159878677258945,0.10015739152045183,0.041771828139582301,-0.16461226846925919,-0.010269758847271757,-0.016121723288740217,-0.10277571356356704,-0.093042910656409489,-0.049186781888682446,0.011398226094967184,-0.0002700750754074388,0.0074397035104696863,-0.20028112611108601,-0.11832761511884456,0.015078283473006854,-0.018452548998716053,-0.036365176981792632,-0.020537843773772754,0.067467358606416949,0.098981148732411567,-0.0055674402731293593,-0.092027331571991416,-0.011441078700565044,0.040493420073942243,0.072106906433957396,0.047544507543730935,-0.010627683042822508,0.010378739620038546,-0.037361124694111458,0.049440729101802861,0.23172672133978298,0.066224037066196395,0.053604258546808725,0.070224030431698115,0.00044743519172646407,-0.024040752967206758,0.017027400054980629,0.082502176517533055,0.04411754553266678,0.094445759480196179,0.026070122517550864],[-0.014874410513740596,0.0064652695167254359,0.18058268416301498,0.10639801800645622,0.1462435538011862,-0.18549085716772629,-0.11946585223026567,0.13336875353850036,0.1431606374421438,0.21268324578348111,0.074573037321912006,-0.02366332846738356,0.00030162505180833521,0.034923909748155624,0.0004976437330811434,-0.27860795914035602,0.019649427691563706,0.22428728221168509,0.10634587212193486,-0.055747191566415763,-0.1720320898158253,0.14652429997383487,0.083678061663021136,0.080059996853547033,0.12676990913561681,-0.20960004749175651,-0.11992969772303724,0.079651052418806614,-7.0500155170752365e-05,-0.13159968070216072,-0.12185636491051369,-0.12212386528350992,-0.063471599790802455,0.11591606931628659,-0.0003121176220944738,-0.16158531692072389,-0.20509977937167723,-0.015211020089078528,0.33419363858602386,-0.021197972311742794,0.051573854058283256,-0.081190824612454526,-0.024248010908752227,0.031952786144903177,0.089889994122808292,-0.055347674287966539,-0.19026769408809097,-0.20571271554392964,-0.0034200030533805825,0.42337060834486751,0.27260930919391929,-0.084997674317356983,-0.27009030033562559,-0.26984679182059201,-0.17357361480162312,0.04962098882240612,-0.0035750137874818316,0.036592663452975821,0.0086359424090483965,-0.27032750814312834,-0.39994957932057346,-0.17183609797060095,-0.24083907079152436,-0.20001978264666828,-0.25264329034684119,0.04388992532969703,-0.064259834604107113,0.074043933060256278,-0.0141401497703907,0.12916245281008937,0.13074274654586848,0.027929401203914232,0.018943370061503276,0.12690634935975603,0.28764725653855128,0.28887242369486649,0.29998179562162908,-0.03702797972780987,0.049533958877091146,-0.018197380038773844,0.19754195456455448,-0.004838219692821645,-0.067001942206080342,0.095328743007717764,-0.077328594117775401,0.097921602001023816,0.11726746577896972,0.051206198923195473,0.014744273305796744,0.07451554959247797,0.076594731593470355,-0.10212719204511148,-0.01010359791820685,0.053405269433162157,0.025967683489007781,0.04284255334511395,-0.031649551549700956,-0.10112182853935778,-0.06200392753579289,0.080996710847300729,-0.096227422002488489,0.0027222873646967627,0.0032193461798180056,0.028018068894715878,-0.08039298406512714,-0.068243680675678459,-0.0065763377264938458,-0.10138976161964301,0.0057770284685309745,-0.0019333108741061561,-0.028478055121693616,0.078148481244774387,0.0046718269408599078,0.086525505520541446,0.075149875794137733,0.080911904001598672,0.14299067937575605,0.058254811658775857,0.060032259045003374,0.069309198206046474,0.13733947078713762],[-0.026403086547123783,-0.020917609288306105,-0.035101904048185611,-0.014306912310371803,-0.0042972195364363863,-0.058077881414638405,0.038178564444327087,-0.0028111815245872307,-0.0038941084518951119,0.0018813296297546939,-0.10078688565961993,0.021583238308296865,0.073511926370810235,0.054528482565529779,0.18987936161675673,0.13986078152038808,0.072940725148909008,0.059256836874555796,0.031090669459266307,-0.015844740201760396,-0.02361837940991314,-0.064937204109534769,0.075642983811850889,-0.079466195820172975,-0.020769014944646391,-0.1040432783776685,-0.033012967133522031,0.072788464701810857,0.10548105228938642,0.0019405459380496259,-0.0070425924572238563,-0.028398618166747935,0.04518643635595633,-0.019186199862506761,0.10714569627787791,0.11822684975817753,0.038571217188388802,-0.027458148938472732,-0.098264611636292687,0.056390894688735219,0.0401565173462511,0.12886782282388654,-0.031555895682836455,-0.02313957239134061,0.069122427442892292,0.025102249881310351,0.029789415685897214,-0.070652870595506262,0.016314783301103308,0.28688684230956962,0.1702619783984527,0.012540634976734383,0.070850865861622578,0.0048605100782281585,0.033197753461072857,-0.091328697630636863,-0.15097408737648729,-0.024120509010246885,-0.024570140846357655,-0.41480944335467018,-0.77687153219324112,-0.27460992951941543,0.13785951824037135,0.13544781633672992,0.13313817386432886,0.082652802520245455,0.089237854154998297,-0.044081186993255472,-0.076883101321275515,0.12600419964023202,0.40959366052382118,0.087069283116805757,-0.46621168156582082,-0.43761485411451395,-0.10812067804268631,0.01768640051563608,0.12729816882590003,-0.064747448694650156,-0.10763464536172436,-0.08524826938436865,-0.23150319320387719,0.15315343856469926,0.55619678100250369,0.23774692046366147,-0.1666896681928125,-0.17715538120217467,-0.16976838686613122,0.025008504484853387,0.060377572120923748,-0.20713294145422401,-0.18646194822017553,-0.08066176191384393,-0.0061085279041063756,0.13478699831707003,0.05663233125435585,0.17462609841438137,0.017491495363805537,-0.015088475844073315,-0.051792080298022347,0.086678653491882515,-0.043885434378402269,0.048343192446375916,-0.11502969777881612,0.14059893815190727,-0.062258291133083843,-0.1133470132940385,-0.064953910797987582,0.027741435654062445,0.11898150752091059,0.030260843676813906,0.1715435352553567,0.057333117013068161,0.16205339464116109,0.098608813006722904,0.073912318801590465,-0.090815553665590618,-0.010370607459546058,0.092275726044843492,0.11030039690306363,-0.0058808178655301233,0.033150477829288559],[0.26549778400602297,-0.0011965636289475029,-0.022916846645374064,0.042429672318282589,-0.13811673855846254,-0.037430883372056925,-0.040559761655224888,-0.023933501028027243,0.079258690792885986,-0.034521886198656038,0.17450462509358011,0.041790623206738556,-0.022740750277082458,-0.0013539969792274592,-0.10138864950556396,-0.053305913995103191,0.058908760919113429,0.093372903179051017,0.050140067951328054,0.0084539027069934353,0.021166550278200705,0.10388208219238029,0.0076348046928304547,0.013138640062169096,-0.075217338734674163,0.015069141903176639,0.24056352482102478,0.064464323761281916,-0.061520565707010158,-0.084694104843374141,-0.06805808373087846,-0.010291588861849124,-0.035798773818091045,-0.047137578793397347,-0.030265001058571481,0.025114433975426814,0.16953416528873916,-0.081754314336625597,-0.16483577488792853,-0.090215602604801506,0.19963523508019926,0.18826320002737132,0.045614733683874802,0.10861139159661171,-0.028328921848054453,-0.10351624721954029,0.075321623520557809,-0.034012524380715156,-0.05869582193122358,0.44090992264428214,0.084019251874953446,-0.012849576849437369,-0.04246094681649424,0.13375661768225128,-0.12950865617271876,0.0026410719089161178,0.044977821596146744,-0.090312411108535592,0.055733826199718409,0.060061106002439482,-0.71527711468395772,-0.2823457778181207,0.031272225391427405,0.11880824524917351,-0.004276759953008441,-0.011347995604354372,0.0023675469047975545,0.00043485509660366739,0.18958682252204556,-0.085759813410154359,-0.45257574229053438,0.15961507301364802,0.31736731659376055,-0.062412313090533911,-0.33746000415329924,-0.24412114938634538,-0.06141338958196621,0.13078793636510849,0.20848205264195724,-0.20955124959973886,-0.28812988786360966,0.14444443144018609,0.46815272589228218,0.085138932615497556,-0.22658732896395356,-0.027717075192951288,-0.16856281398342385,-0.13753538355338668,0.15059745895188464,0.00078477376683321054,-0.17890918828775537,-0.067288794701022059,0.11813620983475538,0.1093966751655376,0.10647641748777864,-0.077849502674635002,-0.24214140318686445,-0.15597210638677117,0.018451936251225459,-0.065300427051986951,0.042693539088593954,0.11063899895595043,0.13459602826469319,0.03073808878575153,-0.014969922588453921,0.039307213284366038,0.041004905630175364,-0.028333785559137958,0.015742037834556716,0.1142681683436582,0.021003468182292317,0.0077221565554255883,-0.00084805796798508026,0.056396970533902469,-0.11249629487295199,-0.064031279727990664,0.026888150461400945,0.12621843363263308,0.25061555337122832,0.11067999815380504,0.26256731149626561],[0.072041366938857376,-0.022942168421451581,0.20654586373496231,0.0021517723151043971,-0.14297221024604706,0.00060653444070969675,-0.058092024602730497,0.13818306134022745,0.17791598188652985,0.1233364171367471,0.0044528518545720458,-0.046059785461132652,-0.071586300701623362,-0.10073784448195211,-0.073740011819088014,-0.018045859949657725,-0.11863305748309075,0.17617564045249434,0.14977841506896911,-0.060747330352864684,-0.0027955678212599061,0.16785791445724135,-0.1069842654168507,0.082999543239617682,0.12903189836552459,0.047202915960078598,-0.030333770559695314,0.099121495138076013,-0.051746600816636498,-0.20797950839871948,-0.0060523253550806566,-0.24640179139614737,0.0025429730685309904,0.056675953090986081,0.13754251807005335,-0.079126091054087175,-0.17638998336346334,0.055182291054404795,0.29992999912154811,-0.12374985838286831,-0.15473061907953733,-0.015285688493998806,-0.0054135361559385919,-0.085840477677166474,0.22138328866134657,-0.13129536918746371,-0.33146872033096603,-0.21124338516694569,0.24711637651267865,0.46372432064270608,0.002706170884996334,-0.24160873975021052,-0.10141666077006732,-0.18322786018052334,0.11158412852904591,0.16760494025045042,0.029994319879768874,0.025682099122424931,-0.11958702177240098,-0.33142254026746104,-0.15444906222705926,-0.16381735574030895,-0.18306921419312999,-0.40205221035750643,-0.26593698021713486,-0.15682020509672343,-0.0002611999532893261,-0.028755553239042705,0.27424611760615036,0.21592566014741185,0.2548708412154177,0.097667264438525039,0.20034297265732981,0.19878852497931995,0.30685861615553289,0.17246611044410129,0.018739306158119473,-0.031064357609991294,0.02636646794424298,-0.18776759014039729,-0.1548117904943781,-0.037429208180667362,-0.11875155323060346,0.10726451368176571,0.17942453854019957,0.11733499751282206,0.0052778895571915507,0.23971575743086301,0.0079700671972805642,-0.05150273918961891,0.055320037436683178,-0.040007912106383381,-0.092708107077101642,-0.031471166411299017,-0.098759311933464516,-0.092930223695402298,0.055517948982359747,-0.037796492017755555,-0.0063425594979251848,0.024882508886736474,0.034983156636445717,0.071931496060268246,-0.031592475014589311,-0.08635043298071296,-0.0090016951668947798,0.071457472968914776,-0.060721615092941987,-0.14319100457707667,-0.048321071596804911,0.081485340665029743,-0.028272073748030507,0.063683871776067519,0.0055479754033408712,0.11811279082577647,0.1406537167258409,0.0040600159105901035,-0.01371930228275231,0.12724155992658021,0.099627352699487401,0.13231658613798591,0.13873127011038072],[-0.027795762801489036,0.19015374353251102,0.097864499370304614,0.12602658180552559,-0.033269074628986733,-0.089500715499542943,0.04755987206442841,0.073741060179395967,0.10899124384412755,0.010865871673477301,-0.057265695902511626,0.17802866217244057,-0.063866674386830136,0.018021373487705536,0.025918690785187992,0.052575744386986367,-0.021274343355739661,-0.13048583355248472,0.029635938133951767,0.021720608681606558,0.074926473794418733,0.05982963712461653,-0.076901179289292132,-0.026484578757325183,-0.15053176420715175,-0.13725487193154184,0.087833236099425338,0.066023074778773477,-0.09194730471659307,-0.2149017706218482,-0.020022004139598079,0.061471356479686365,0.041399022424228001,0.031512385832822058,-0.015300106252072884,0.026068470255320511,-0.033971179507359804,-0.056571591160507355,0.18971099504863476,0.088995348857820136,-0.15964206297954237,-0.1658659652422706,-0.11188281516561152,0.12234793752765391,-0.052307886639272771,-0.37845338665931738,-0.096613913262061174,-0.069048222879974586,0.06616884325249589,0.45010838044304829,0.11905472109942555,-0.089092894933614275,-0.12904510069418687,-0.036526361323872623,0.054821578766419167,0.024810152389095064,-0.29747232226539949,-0.29999245801199964,-0.30525086777987692,0.020996924029338435,-0.24088524064845188,-0.24200960208227415,-0.089790636212287028,0.040398429108714586,0.02526034075506383,0.02738946668147809,0.27071204540517796,0.36231522138833033,0.17799155604913797,0.14461290644587801,0.039188380670349868,-0.12174172594558236,0.062379698671313509,0.053786808004118926,0.077565363377853025,0.08914298237579163,-0.082913498201941188,0.047935941038607571,0.032227521369624083,0.1350352800448287,0.01205967148514378,-0.0045403010495765339,0.04815794062847277,0.081651621340802089,0.042005542551939397,0.00094719895582431185,0.013451602816859323,0.046158292820973189,-0.086770110141339035,-0.019510393108648688,-0.011154645591627543,0.027566377877780268,0.061728447633688933,0.01211458002765884,-0.023208391928071358,-0.031607312720043738,0.059642540508696808,-0.036765889133114592,-0.015928896212769141,0.0064080901614296526,-0.081899254344496963,-0.029769584611185507,-0.088820881932459628,-0.028070658348809674,-0.023691860637635141,-0.019599361049671284,0.057438128582313362,-0.038195671616113237,-0.011284460479520503,0.039955132103732395,0.099447536075713397,0.068549557521697391,0.073047585512767549,0.062482862870410376,0.026345779828657455,0.051335172427723452,0.055074573131097329,0.05467724826002196,0.024905693805908301,0.045383956637533654,0.032908498475190132]],'sobel':[[0.021622445358756535,-0.039044416006162902,-0.037053874418492755,-0.070221762884057529,-0.14277178789038111,0.010719228314107376,0.23521416713985532,0.042585931839459745,-0.066838617434589909,-0.035785952249555719,-0.04059161986118337,-0.04764960919347714,0.015365501205621496,-0.0089412911030321875,-0.018093607051941449,-0.041156433480069976,0.059193526101543679,0.034970124073028692,0.008553519349948524,-0.012132573309561322,0.037118604219805298,0.0111042284552757,0.013666753799685936,0.057115927906324922,-0.039502379569608656,0.0017172576948862456,-0.10081077815789569,0.037477947956047315,0.16094952648226463,-0.067174391154844304,-0.034197546339512892,0.043780102673210156,-0.028950198305796655,-0.075338573644424867,-0.037953071524472706,0.015621349282515417,-0.0062936629565303812,-0.11863605824421611,0.049183193707198238,0.17069808619279628,-0.019042518561221543,-0.04243830041050764,-0.017632482496080508,-0.075731520983345624,0.0095324271735924976,0.032929665395846554,-0.014258152251170213,-0.0098967025572965356,-0.080727554710942118,0.076950547720302298,0.13010453872990779,-0.11441193151685329,0.020647144228869374,0.0074901484299721502,0.029524457284514791,-0.012759212791825812,-0.0093580562023970887,-0.0058362056553335484,0.064104388310505842,-0.16470494179736736,0.094417901873677768,0.13506762949639728,-0.044141557668112785,-0.052786309985618965,-0.010841128696787369,-0.0066630125429543163,-0.023002077304622413,0.028816328444530765,0.041660776154130552,-0.032027957181329177,-0.061564972379557034,0.13252072121529024,0.13006898279253504,-0.12914934815826734,0.0036201984235415957,0.036105422059974968,-0.012106081202489141,0.0040581921012012682,-0.061907628638589444,0.0076003677847962282,0.036719522198239138,-0.14105768367312649,0.20291678804533386,0.060388661168118758,-0.096589560951574671,0.054589139338588007,-0.10018987380801381,0.041122915048875108,-0.036635205055412415,0.11599660938438668,-0.072959009619801077,0.0058380920703229103,-0.080459185128702371,0.15241049645522284,0.064258128129055292,-0.099760237579099881,-0.038508522408432909,0.0044401907717541295,-0.027741747177757195,-0.03436923493861925,-0.015116464251280038,0.0058884423068488005,0.046096447137350165,-0.057576787493043513,0.10122734774744221,0.074735445752117727,-0.082870214204482526,0.016464177481322798,-0.035808109707655661,-0.034750714642449623,-0.0037473815699105711,-0.026826464835886445,0.0056597480426354915,-0.067769751698199487,0.0568032112071548,0.22043446790836069,0.017122291321192216,-0.14459243689689222,-0.079001488823724236,-0.044799531513801144,-0.099981836109005212],[-0.039421733196747563,-0.057937375185619755,0.074729383153290238,-0.048044786321738378,-0.037187904273169307,0.052702736653325186,0.26142655681091542,-0.061948912592336147,-0.10675064435044604,0.031812102150842861,-0.051384587313130461,-0.0060010201665935334,-0.00075896323127177395,-0.0050347123305201219,-0.041064685490394513,-0.017208529601601026,-0.0095905987638112492,0.1312641811720012,-0.051457805250329162,-8.2456846587079802e-05,-0.063001416106639091,0.00662330181235226,0.0045051030283342064,-0.0083206197174064897,0.034912618703663689,0.012366610223709981,-0.059276577400723146,0.052288462081552911,0.15469918793188286,-0.051591770863725732,-0.045778765567233509,-0.0078960352945247718,-0.018756915070729453,-0.094971301563454444,0.065529490603964152,-0.029158529667124129,0.046869488668256493,-0.070024824171941891,0.062730640085547337,0.12065622163679911,-0.068657561209928358,-0.019058676809837402,0.0074337488818226119,-0.067123189259470334,0.02052950643564122,0.013044402474017169,0.0035087666835479231,-0.012030134512047277,-0.097183241294960532,0.028501913912727009,0.15192055414504166,-0.070640175383792636,-0.075748676174115875,0.031913417912056846,-0.031981916836030161,-0.023049214827213602,-0.030048256280766128,-0.003272100719358767,0.060009116628550338,-0.10610745181060459,0.071599910972010128,0.029747261693937183,-0.05575743675365958,0.010540784627845606,-0.038579439103590962,-0.013055960468351072,-0.046603955087347805,0.045824656843064061,-0.011912196563431354,-0.011526854332901983,-0.09532744148529379,0.051839761132369919,0.069491936832294085,-0.078788466397808288,-0.022076046119921762,0.055685206611929355,-0.028690189358575251,-0.010750075363214893,-0.03415858882057192,-0.038029784044701004,0.057878914546968016,-0.13134480414052568,0.085607992375635905,0.12614414610906796,-0.044827306225034641,-0.049757164378562924,-0.024712106659159953,-0.071507148759382411,-0.024192130054643594,0.01362951330665179,0.048433953081083739,0.024359386660730259,-0.0051155106774921633,-0.1051390039795366,0.14444393915678838,-0.0088548431670526818,-0.068772016948969117,0.041548890783175252,-0.034167152155519381,-0.021582188034119092,0.030182799067988354,-0.0040014629061505859,-0.0083662081635181747,0.026868483822945988,-0.022177672343113145,0.083313762448314871,0.010010211142558997,-0.030072184867643174,0.037843489218722132,-0.070383902910739399,-0.083548620924597278,-0.036391935661160918,-0.016615937603765441,0.062407519296053184,-0.091602024121955034,-0.0068430434289176237,0.095085963164938239,0.048338691169388215,-0.027514079584110885,-0.13108991117518859,-0.096683781412949532],[0.026521552932905021,-0.045757706968443369,-0.0065411884067677981,-0.085061179165153294,0.14722881834024182,0.047880871068860825,-0.019733975062189213,-0.051041982772424166,-0.06667461611485706,-0.018868367139866095,-0.041407892531913994,-0.1135165849534281,0.06494420088328412,0.02647152281327755,-0.00090233232791716786,0.012634138439591477,0.016736706302279282,0.0066229675581288353,-0.027195497182580936,-0.013683547901060635,-0.053134066940332091,-0.037126651114853963,-0.022632575689387369,-0.0018942229311252846,0.033462110153666749,-0.1182492365861096,0.020164248753763356,0.11022756484626357,-0.034399331322643348,-0.004049118679745123,0.015540800383945969,-0.018762684144165639,0.031382890856517,-0.034906110659518569,0.0084090652945358179,-0.044334707129056128,-0.018500134350316173,-0.03677441221924304,0.11924665863029466,-0.066556956316230043,-0.0157217782738675,0.0088049969447932253,-0.073061057426566628,0.024309817051911063,-0.0022227005091241224,-0.027084812593866206,0.11300564532044208,-0.089657724195424393,-0.069330694925671552,0.1522788162456262,-0.11814107191405709,0.041522705944297272,-0.055858865503919525,0.03589699264499422,-0.022839973856335079,-0.062359056865698051,0.017954041686744696,-0.0023516930568763042,0.024292471256874525,-0.020140941604535046,0.16616378156217479,-0.060547479040507682,-0.095993631877149627,-0.035171531857736707,0.00017003372512303105,-0.054486904900661617,0.0051046874832875108,-0.024970809646617714,-0.026948648737005924,0.13211777318770576,-0.015912595374394843,0.14876817147359678,0.079640820231395598,-0.11230282633524796,-0.0092441791382505342,0.058819068131640312,-0.077920153621443,-0.090482271757585608,0.11102826856966876,0.042626094052885727,-0.002195518726305995,-0.036122267119977257,0.047146706015838369,0.18615910807929142,-0.063269368645278462,-0.06350591196288817,-0.029534950411274838,-0.029986821385842868,-0.01600285092423518,-0.030794045583080902,0.0070419278101264172,-0.030444390319950831,-0.12718798875016957,0.041134467878119835,0.20405185525846614,-0.029811157180004131,-0.08705268526814279,-0.016364346582207326,-0.037891810417653854,-0.026401963421238878,-0.013779084822577579,-0.013032137299750876,-0.053538279554311299,-0.056779607970010679,-0.079377223053779367,0.1823700488331369,0.04187996112061794,-0.046827200345602865,-0.01941969694818884,-0.032796142514734263,-0.17044345125001231,-0.05402585591400131,-0.012647256817941261,-0.067305588382767928,-0.10224311399966124,-0.34971902980023623,0.21798581432121136,0.33121516682963281,-0.020319476107282762,-0.12056665218545416,-0.11656639490906624],[-0.034745756067027414,0.011922066572062268,-0.098449291804937236,0.18031082717496805,0.17476539334005353,-0.046518346780788547,-0.10946016872645539,-0.075727469917264756,-0.004279528158131065,-0.017696596899397482,-0.093983562864041803,-0.010800135732187889,-0.0045569323185074284,-0.031379361612413698,-0.11850675752648224,0.2367012443070334,-0.014785597277977354,-0.063302331262239414,0.022536827576278201,-0.025071938686129294,-0.0027915071853978554,-0.020334914936012752,-0.026008027089296101,0.010703003018176116,-0.043029867343547329,-0.047195519513412248,0.12321706281055818,0.071786005282978516,-0.065282274004568347,-0.067638221239958093,-0.030061503019037598,0.0027284619191995756,-0.030746019874450269,0.034300317469793756,-0.01548496672283399,0.00061797218192791159,-0.12212293111148122,0.050022803331177507,0.14679567560544277,-0.084454888753618507,-0.010415558440521971,0.017746373390555303,-0.037888913263606695,-0.0042452861377769227,-0.074445323746479414,-0.011522402982276407,0.0065317653275813771,-0.093067685671222949,0.00025768497943800921,0.23352117567061204,-0.0049839681159744506,-0.070961394834865091,-0.040406385819728594,0.0038935193964216783,-0.063087695343447811,0.0028549201129295862,-0.011365105715306072,-0.0051871840857717968,-0.011323145685494362,-0.15258276867230808,0.10052717621074529,0.12368458705231265,-0.077847390546605971,-0.059471418250267638,0.028026328084379253,0.048885641757861406,-0.019665152356733828,-0.017240548423916428,-0.041027265162514856,0.0011509894918183342,-0.082241935288892523,0.078604867885532073,0.16228781290785055,-0.010523700344121451,-0.030965934865738454,-0.041503959227228673,-0.039718938540816928,-0.038748556042536665,0.051470420149172191,0.030039107409380247,-0.051469295929946292,-0.06031302048942426,-0.081417936654068115,0.17732474397593703,0.025219765376655087,-0.012727987606368688,-0.064523296079121037,-0.013167312882832634,-0.013895314055951707,-0.049375572219517737,0.014179550428987366,0.00062312741669435373,0.007284514890717856,-0.10894474372759466,0.027784507036578657,0.19201834106729118,-0.085036361549911121,0.023988581116611958,-0.022828104571709931,-0.014372052338263167,-0.026342474575395736,-0.0055467921457708243,-0.019470544310970943,-0.033931503651495665,-0.0091536544294716152,-0.036739492608220362,0.10446088448224827,0.020969726335668189,0.024776193018576149,-0.078829730104535034,-0.053245132855933908,-0.010433310611867591,-0.010210640679316214,-0.051308025398501503,0.037884008160365974,-0.099324142895464845,-0.12671107025252934,0.083828567543130963,0.12485291624334745,-0.019875141138885395,0.021159178415280137],[-0.073813428578515319,0.0455540146431333,0.21317974541835555,0.054485804091818982,-0.10981511144389543,-0.10268425646919861,-0.046501163519200653,-0.055663971820637946,-0.020862778212020025,-0.0016239951963715644,-0.002629558452717437,0.0099974094135370853,-0.1034433191717149,-0.0080814385350999121,0.20536698014540328,0.06126371127783943,-0.059836319781441494,-0.038790294476037351,-0.053677695944028214,0.019923647746113771,0.00067536759966540377,-0.035726207464042412,-0.035441015599980488,-0.024733560212268406,-0.15079839806148979,0.10615849316820197,0.18684548267040532,-0.064070280932145493,-0.067087150871195628,-0.0055311193006368775,-0.086092934395195775,0.061425846472940575,-0.035219155593812501,-0.039575091828705944,0.049801600957609174,-0.033980895382327146,-0.11533858246663227,0.18080146842113642,0.12760232482142872,-0.083273979291499017,0.0040506256439491184,-0.0099808928737386143,-0.067759137702010225,0.0026835543791823638,-0.0080343381743012698,0.023532332559458254,0.043117469529290763,-0.14058656961156304,-0.0016268330065314137,0.15585324976494819,0.069626580205874283,-0.1243686355938375,-0.026479623846533681,0.020383199203834142,-0.028768935662109356,-0.0062857702132087974,-0.028321313745657696,-0.01168709222463879,-0.029152829240080027,-0.094922161457253018,0.052872274283144463,0.11087851911197262,0.054251608937427767,-0.053296632141531824,-0.027558550405789028,-0.03854510047924891,0.011349127429016066,-0.026961940685359908,-0.0058849527355114006,0.00206567265274352,-0.06205567284106403,0.027107120468617331,0.076720226540601719,0.0095546142954107578,0.062120958180423839,-0.032629976188592258,-0.021507467744680639,-0.052784084736165693,0.0030423247653671021,-0.0080315707017271191,-0.063924511094123684,-0.00021021475214931008,-0.10024981203982601,0.1015512962019214,0.064157555723561771,-0.069916492771215075,0.082103122053598113,-0.046503334103402447,-0.0048848007312446012,-0.02758565365129036,-0.0140809555182348,0.019042840231226918,-0.033131129031483485,-0.0089135928143168203,-0.054256262048008735,0.11973166937117143,-0.018268580157864991,-0.023883645532026994,0.049231832011293608,-0.014577787660792423,0.046127787170430763,-0.075110202669192799,0.046626886126717067,-0.041747134956936049,-0.03251487077000792,-0.054338733400030953,0.017222361404870275,0.11676824759018707,-0.026438027156220366,-0.032102992542435496,-0.055241109787953276,0.056235913315409988,0.009962320928060292,-0.032473557036913243,-0.019767314495135732,-0.029422259501493818,-0.05097365566473705,-0.086442579719706786,0.012598629009327726,0.066122215427308853,0.01211368001348305],[0.0004667357969735525,0.00054849626182419664,-0.00013618713228205742,-0.00013253085166550519,-0.00080157461570931794,-2.691133605066146e-05,-0.00065764288432581446,-3.6579683998914057e-05,-5.4660118200278811e-05,0.00014604635132977641,-0.0001696182636010491,-0.00015906228894248253,0.00011235296245967744,0.00050518233975373769,0.00015356454550761702,-0.00031323963237401761,-0.00044300984864449697,0.00053200461227834563,2.3644509619358614e-05,-8.4831714279420429e-05,-0.00027200405736615936,0.00022416316434788062,-7.1194625315486616e-05,-0.0001921201138109542,0.00057396177783196486,0.00035815207686277155,0.00031159259445471095,-4.6937311155920448e-05,-0.00065506326926790702,-0.00011995580027392686,-4.2348005140095457e-05,0.00010587326804443578,-7.9322550005703508e-05,-2.3721764802441496e-05,-0.00017040147572136739,-0.00057593165429725875,0.00065222177121013831,0.0002665414702900902,0.00035667127123066925,-7.7691777858289972e-05,-3.8172905741614115e-05,0.00010049476721076365,-0.00012168481580056376,-4.0491064147097386e-05,-4.8159547975361617e-05,-0.00023287151964227542,-5.0225019821443275e-05,-0.00080182622897892767,0.0010438945255279268,6.1969706422453793e-05,0.00028901935081157955,0.00010579037778190963,-0.0002724803030345158,-0.00018248333714674828,-9.7893609415735343e-05,5.6122266787632407e-05,-2.4109435187230215e-05,-8.256402305014017e-05,1.2275769358770228e-05,-0.0011837300475309662,0.0010387599962857208,-0.00030106456925788061,-8.2942949550413037e-05,0.00046305034318953886,-3.4941522492179002e-05,0.00026047826388847961,8.0063314441238695e-05,-0.00023204308256855825,0.00028043251942060473,-0.00017992926522449743,0.00024111256847714896,-0.00077707368713531705,0.00087258670230551394,-0.00047310681975866464,-4.8903566618300337e-05,0.00030165105394839128,0.0001523693782892032,-0.0003214720006770571,0.00014500490168671901,-0.00014868675403801115,-8.4069171507120122e-05,-1.1488930694997235e-05,-7.3103538477843621e-05,-0.00027257580575307944,0.0010045581248467467,-0.0006063389015931106,-0.00030283901680250476,0.00023946215844236965,4.0874050688199964e-05,0.00020668776684328811,4.6264165950036471e-05,0.00022120225803604759,-0.00025433190468929917,-6.962082684627835e-05,-0.00011541458342628763,-0.00025522292698570287,0.00090807721332292896,-0.0001479625967791515,-0.00027356753032273425,-0.00019226090250733943,0.00015027389750788632,-0.0001041059494256247,-0.00012272487478783012,0.00033766836773768683,-0.00040885269632123106,1.4064712871159069e-05,-6.0893502923708986e-05,-1.2270143878473361e-05,0.00046367307715139069,0.00018271794499197247,-3.3562064556917105e-05,-0.0001861452801387312,0.00024747597697189313,-0.0002203964126913302,-0.0002655235806198683,-4.8267361401083814e-05,-0.00013654454453562725,-0.00016522236506379823,-9.985241041834958e-05,-7.3084705394677342e-05,7.6496751819820884e-05],[0.00014192493009219931,-1.0849997241092063e-05,0.0001677566369007906,-0.00011605018962013852,6.6756115456784171e-05,-0.00015562939648154986,6.4164428186169048e-05,-0.00016144031937152109,-1.1567201873632915e-05,-2.9389666004610293e-05,-0.00018545690110512159,-0.00014192965770924021,0.00015688900011993565,-0.00022987170475181201,0.00050601894856794338,1.147904121199389e-05,-3.5358004185095937e-05,5.4151378378504422e-05,0.0001162675133458968,3.7185858557914342e-05,5.9553590523481192e-05,3.1314783550819014e-05,1.2057174878739307e-05,-9.6695987945233375e-05,0.0001044847847413502,-0.00015507143992373601,0.00022022799757739214,8.3866880430806534e-05,-0.00012962060856349517,-6.7578262074236006e-05,-1.3555990987554334e-05,-3.5737704882077281e-05,-4.5808795552465531e-05,-6.3548782069412779e-06,-0.00015612384897251141,7.0085223497301508e-05,0.00029763597940726805,-0.00010577343553129503,0.00012730480076296458,1.2399248204064683e-05,1.8645837807265697e-05,0.00024212785489370614,-0.00015872860498579444,8.3707241213322459e-05,-0.00032597535960855739,0.00041133058083372975,-8.8687656587524422e-05,-0.00049296444707497278,0.00020605423444788884,9.3561174143157178e-05,0.00024762885023246056,0.00036524470776032325,-0.00023688791970755824,0.00033172236655580611,1.2629398500677014e-05,0.00024080466741264323,-0.0004006372668640644,-5.9563129205519871e-05,0.00028033907001259045,-0.00028345593539583214,0.0001339187071822609,3.0493512604909401e-06,-0.00034838001372515526,0.00059746238210751923,-9.9846486972976489e-05,0.00041453928701537524,-0.00023073595005270592,0.00034208508615191091,-0.00016580817990245744,3.9765764453518482e-05,-0.00027830373100982964,0.00012537929853667987,1.4736238159517717e-05,0.00027567237234161351,-0.0004888438970630446,8.7212866113350884e-06,-2.0493341142208132e-05,0.00020499966401848688,-0.00032257655852790945,0.00032032979815644486,-0.00024321547888298814,2.9086686149870644e-05,-0.00028867101368240666,3.0825398830508499e-05,-3.6797589493049732e-05,0.00029228356787954629,0.00052891319033434442,-0.0002405873549854512,-0.00029898967584843228,0.00023190078400971148,-0.0002429945590425725,0.00012631644056069861,6.8365713355195146e-05,0.00010549540200119334,-7.3225818539288112e-05,-0.0001018216734522126,-7.6341945218480478e-05,-0.00040021222480832175,0.00051868831128347101,0.00045282278366730322,-0.00025642054830855854,-5.3312433065010739e-05,-0.00015071920454498566,0.00026346273973178874,1.5723135233985941e-05,-0.00010611552565827076,0.00010030771494402846,-0.00022901452791959653,0.00029515413913742961,-0.000378103168520591,-0.00048426748955096577,0.00022179377366644826,-6.5521532191739271e-05,0.00033674118948758686,-0.00046179298814816305,0.00010507012245129441,-8.1386075936565327e-05,-8.5409170546155155e-05,-8.8995879690176305e-05,-7.5853311223957054e-05,2.6564465721370945e-05],[-0.010683117891894434,-0.026203517318029858,-0.035348631234462732,-0.0089039476697588757,-0.078264832133459569,0.014533495211292522,-0.039735497439144417,0.0028868136525013826,0.0082563432282671927,-0.036876327986247723,0.0019617637025766575,0.052924193889526149,0.035478526483873563,0.021452215773512737,-0.012058498396393419,0.032415748027272206,0.0081487313430126454,-0.0082878430591127438,-0.011301795333024143,0.045191867790093425,0.044327234784062801,0.019363765884505585,0.11356516329476325,-0.032979098377165179,0.075697516409139673,0.019096851467574182,0.0083417566704703065,-0.0060608317184354613,-0.024521250232898754,-0.0062563950604268004,-0.019424549966013421,0.042617826976536294,0.11771045618920394,0.14806853397919761,0.07242131632098367,0.05825312332492652,0.036446775225891515,0.061850429851318528,0.049704669459738865,0.055430561498123407,0.070266675660789452,0.10791776313079825,0.053117037443650719,0.12942596556811628,-0.037520978380153586,0.09370958660148157,0.067576770360366523,0.068724981441630334,0.076126783309853729,0.12311586010135872,0.083411336336100567,0.039387077762465639,0.056425147284172514,0.014237983090907416,0.05663383500458416,-0.0075863136735932618,-0.083041404471318359,-0.033129983631350668,-0.027636238642020229,-0.047768510607462976,-0.063296204253032298,-0.062578786189099095,-0.046277350408935075,-0.0014999128228245229,0.03590831793842944,-0.15153224136771898,-0.067460025003045793,0.052979163538064387,-0.025619303894120496,0.037941615130038006,0.064910895081062597,0.02230202042681128,0.055270751907329552,0.092705497561621455,0.018963378238524085,-0.053973086464825723,0.0083301495482443391,-0.021218159929265457,-0.030570605486973344,-0.0021454021899788445,-0.026875831051993617,-0.049042673990263554,0.0051260754520939906,-0.0069454575735653475,-0.055541305029020473,-0.024578161869174033,0.015168445899802574,-0.068003320439275344,-0.00048112098031016792,-0.056520449187868235,0.049669608030607104,0.016316278463441431,-0.034085744774588048,0.063066726935569931,-0.0080033228303419916,0.033385837489126907,-0.044575967029709188,-0.023441355247158995,-0.044509209526914333,-0.037161871027802405,0.0073190175238074615,-0.073157626655641225,-0.011373417119033976,0.072030602760077223,-0.018015670069586549,-0.00013858608242610544,0.028374321207992069,-0.025567271987302419,-0.013903313076025374,0.052807958873996745,-0.038318416663269968,-0.022987196513577734,0.0062781886098834845,0.029733530440722515,-0.090236504820046956,0.0094683723177513002,-0.067606870737129718,-0.012207168455778569,0.0039498809113422051,0.0017680506907682904,-0.13205065018196771],[-0.00048965833343866949,-9.6133835888349839e-05,9.5024409277118249e-05,-9.4831286650623459e-06,-0.00027318400850575436,-1.2859674043262659e-05,-0.00018753431578469315,0.00025359827484301711,0.00013593197045175948,0.00010671640250792952,0.0002520834422912871,0.00030575486026798715,-1.8677323289251202e-05,-0.0001359879426809929,-1.8596724042641011e-07,0.00018716058456554746,-2.9456499708931105e-05,1.740372235658344e-05,0.00029170983943693773,-1.6893395160838542e-05,0.00029142657372808328,9.8200013060809055e-06,-0.00012201675367805309,-0.0001821511041478624,5.8727835859570532e-06,-2.3871151498152526e-05,-0.00016916476120136525,-7.7175542381152651e-05,0.00053887625860423588,-7.5954327703381397e-05,0.00047546289643572714,-0.00048532553637742337,0.00025243488298501968,-5.2889703167802171e-05,0.00026631391925304587,-5.7069012077345938e-06,9.4805004026109196e-06,0.00012583697976619596,0.00045284900761148605,-3.7921325421477747e-05,0.00010519128394604477,-0.00021574981428573378,0.00013058799005061239,-0.00055512020354029647,0.0001429939062747021,-1.5370391169694519e-06,8.0653707619851578e-05,0.0004067755777601087,0.00038999196381222373,3.6877374512293837e-05,-2.6107472160714212e-05,-8.5583627116723321e-05,-0.00015583615391241354,-0.00011965945062380329,-3.6535280401381234e-05,0.00054094084831822487,0.00037630623255849316,0.00052269658935158447,0.0001311189140969643,-0.00040060332113688729,-0.00026993542547641691,-4.3072617173671446e-05,-4.6582954130174048e-05,0.00011704093153555931,-0.00025561950600206523,-9.7988597560771939e-06,0.00028045364993524793,-0.00016083954183774771,-0.00025723583975659214,-0.00046505036856739346,0.0004039314021320739,0.00034091132239879793,-0.00019370884391506013,-0.00012426188246242656,0.00014610355538470163,4.8874632263766482e-05,-0.00016902502798560315,-0.00037191521627369384,-0.00021579609440836728,0.00039961530180981919,0.00079812645123661374,6.5350682398865323e-05,-0.0006637329476850487,1.4201540184693995e-05,-3.0668778868838537e-05,-0.00013015400162084967,1.1834065800214733e-06,-6.0452686671833011e-05,0.00046003104033802422,0.00029649152999927653,-9.7422158500198863e-05,-0.00054615394798594036,-0.00054555045433753169,0.00030505150102402845,-0.00012282307114507701,3.1042354130282612e-05,0.0001268834643597741,-1.1535964674028176e-05,-0.000176869063298763,0.00011095223633189599,-0.00059224455990757041,0.00021684456404430508,-0.00045799378668898855,0.00057995315228567129,-0.00013936531291453697,-0.00021220643616092633,-5.4136569800536383e-05,3.6608907478852953e-05,4.5939329531563544e-05,0.00021478664432446337,-0.00032699755621773408,0.00012689634262805921,-0.00034230468492685989,0.00034767742030643312,-0.00067549072348433575,-4.1513304792857586e-05,0.00018063222856385536,-0.0001881377600047654,2.8973339703669554e-06,1.3507237580291653e-05,-0.00041261401631562805],[-0.00013436781157403349,0.00012210804930180494,-8.2414422599333403e-05,-5.7301863805120368e-05,-0.00030739486254432319,-2.2492441595647894e-05,-0.00017176271831247786,-7.7101711693922104e-05,4.7107570331945958e-05,0.00017636492999561354,0.00032836342762108256,4.1087699566198788e-05,4.9949350228714606e-05,-0.00011875800957268645,-0.00023943950047199125,6.1005765033241011e-05,-5.478607070270522e-05,-0.00036631651977345886,0.00016730329224556167,0.00025493108839291095,2.2226604097883018e-05,-4.460834588607826e-05,4.8917262263498129e-05,4.1964097110273185e-05,-6.1314318202332352e-05,0.00022686166653692816,-8.9247938207914768e-05,-0.00019302109650852495,0.00023804561802531765,5.5691335582086499e-05,0.00016699837552209412,0.00017965604481385428,-0.00038349627139956134,3.1918639160310319e-05,-0.00021914285377726619,0.00033657077159139626,-0.00015380926340578804,-0.00012640377325787849,7.8443598190786057e-05,-2.5921418374194594e-05,0.00038527701539335657,-1.4538798784193008e-05,-0.0004928838914605993,0.0001028736165327223,-6.4383123833527955e-05,0.00023810111270487072,-0.0003138610278263735,0.00014008262478101469,-5.8913029426684027e-05,0.00032747301458163625,0.00039023015135071504,-7.447541605180158e-05,-0.00041729123414768754,-5.2260202109827292e-06,0.00012735624759406539,3.6629059847052489e-05,6.5628761203077868e-05,0.00021839305017589544,-0.00011813071478151277,0.00021698143307999351,9.6287514756765447e-05,-0.00026080214823867576,-0.00039654273422187053,0.0001167125140248762,-4.0162626760084641e-05,-9.6609081976166411e-05,0.00019201207703931078,3.5894679076095559e-05,-0.00013215815809999171,-2.2031139214596929e-05,-9.3108375419856393e-05,0.00025391719334226688,-4.0757163905339486e-06,-0.00012808461454903692,-0.00015139230658256335,0.00022616830885492656,-0.00010182951161811366,-2.148301565258609e-05,0.00028356599204855393,-0.00028490640829138825,-4.2891750138746021e-05,0.00041455916689240452,-0.00012603793107361649,-0.00039707365188554333,7.6033479427833894e-05,0.00029653613924018885,-0.00021374066277618509,2.327117911399279e-06,9.5164172314900208e-05,-0.00068014772917070199,0.00037026320560729076,0.00019251368934372626,0.00013551091552941458,-0.00031120640022949675,9.6849928779750571e-05,-0.00011268464289018038,-0.00023013062013480662,0.00015401847444745237,6.4205342809563193e-05,-0.00034974297656181069,0.00064853396513063488,-4.4729954720712506e-05,0.00021224544758897262,-0.00034308486716421273,-3.7733988311935626e-05,-3.8868349370377309e-05,8.6498659390518706e-05,0.00014456882901125664,-0.00014732698311536454,-2.7613250230533459e-05,0.00026354361705206719,-9.6315009198065515e-05,-8.0323755983983947e-05,-0.00018998607556105357,-5.9127250430376921e-05,0.00014091011956727205,-0.00012996537552621701,-5.035229587568163e-06,-0.00015231914400671252,0.00023099545000895144,-0.00021587551857769893],[-0.011113779995796793,-0.03264498365428932,0.032393323977037813,-0.053019160588067986,-0.052289631646412357,-0.14090905182270536,-0.10662971417607917,0.076743291125837804,0.19183514586283293,0.090512780806032617,-0.098345016495789458,-0.011356541223655056,0.036592642227365337,-0.05386114520342726,0.021336401858911159,-0.047044247520027484,-0.079543004866070119,0.069134815260962129,0.16070569312483246,0.0038456939033156331,-0.086695570600295979,-0.030081196583984296,0.022665182076173018,-0.023072771394334196,-0.018331023996742943,0.0011057635434971857,-0.10917005303651976,-0.046906120609124184,0.10879721410619564,0.17214824601663198,-0.16345419009446593,0.047387129776087451,-0.050130663511261289,-0.029615346796994284,-0.03838162551818361,0.0016626820450895159,-0.034779798819093558,-0.070943150474272645,0.077909629347024584,0.23019976126978281,-0.14284459018595042,-0.033305599050588101,-0.012579026667957113,0.008416322955214002,-0.032993580574607821,-0.048339483281004764,-0.019525308661791051,-0.06984453532422541,0.014727444216795713,0.14996686179447366,0.078031653033860421,-0.15724129008645732,-0.0040330836908469385,0.020646425620089916,-0.010654017089976087,-0.068656231122255579,0.024297601174406921,-0.0024877247232191202,-0.030227587432549025,0.090227014733457928,0.080842697753928994,-0.086654876220284532,0.012959715152821044,0.018917133744079905,-0.045623035776481892,-0.032739391111555147,-0.036378708143565655,-0.052934938098819245,0.0072628401319736191,0.025315816651209383,0.065354988831480165,0.050830135881118316,-0.051373434850408066,0.012062843823364068,-0.053921495179175792,0.0041695268579246721,-0.0082264831168346701,-0.011220404620470506,-0.0075848833821621966,0.059000048222753509,-0.039920656848886502,0.11125743952652592,-0.021519034940123919,-0.057332486848285534,0.0055259953878360642,-0.004210488740013946,0.0091543763669089812,-0.029533996573194402,-0.0046618916800951343,0.086826792205214331,-0.087905681977735253,0.060049094735024719,0.082239574433654317,-0.067950997259202672,-0.052836508855635379,-0.08178791847111451,0.043805514127629036,-0.035918644150708633,0.030943034122503259,0.048873707654045383,-0.078419292949069422,0.036039114074194384,0.15301950458013516,-0.0020635318713273093,-0.062144295014710749,-0.0042182974120457458,0.018342722938454691,-0.006300758423097505,-0.011523161046205615,-0.047258227242310442,-0.028717665984571757,0.078801626072277128,0.069201975729093201,-0.080059626916277549,-0.14106514638245227,-0.025481816722181624,-0.020508997543042289,-0.01550940323134436,-0.0094705410641920743,0.014878235172793254,-0.0034914923955158606],[-0.049718431000340013,-0.035758892423982919,-0.022242832727659471,-0.035623182950114192,-0.068946269831888563,-0.14441155948249546,0.23465172605260556,0.15846679355786267,-0.065971982658149603,-0.018535961144545934,-0.024797174426993557,-0.0076368074855745118,0.0066227612551196706,-0.017526536442783753,-0.010789194077319021,-0.040286032320290231,-0.0056961640316873343,0.13973218361056991,-0.042841041755946108,-0.030912602586234482,-0.050612857016701492,-0.014451167351557435,-0.033321133339262024,-0.05328285157863482,0.0084956582707995769,-0.033398618106686311,-0.10205034437720886,0.030196139746642148,0.2111090058125159,-0.085711586785949756,-0.030766677319517009,0.0065005921075326949,-0.032107623303140612,0.010380556950672306,0.037670595949217942,-0.056206087740664497,-0.03260370052730352,-0.1561008405998785,0.15115473184883424,0.087468002407858153,-0.079714267429888366,0.018202271840872142,-0.0045105431343512043,0.026832614720378654,-0.043425866989209555,-0.026066523869096081,-0.02528972705916014,-0.042096869598745652,-0.070925721200100544,0.23530476499553221,0.011520678728863858,-0.095816584560911452,-0.018725466710660395,-0.037048558120658111,-0.026821912497833961,-0.01958185753544785,0.044676748759910678,0.028809635953963519,-0.05826188687569988,0.024776575417213054,0.12549740842491305,-0.035929129393416859,-0.087118885673774085,-0.0026901477265302994,0.0046237475146514552,-0.018050296026597318,0.016779033899148251,-0.012651134169698123,-0.089944685004007208,-0.061952592133401846,0.10990524701743055,0.15037999590612067,-0.090163580684813671,-0.035133862878716476,0.019258114736171422,-0.023010078969621379,-0.026283022557721171,-0.066214843146827421,0.0036081782275008047,-0.019205792810695364,-0.020171831093293915,0.1989806157237472,-0.024158681457602471,-0.048082389466265169,-0.027408223538038137,-0.075525139612688572,0.064454122161252458,-0.058575382013248689,-0.0086368186115048165,-0.0086035574489204472,-0.06007705027057858,0.045971736951263456,0.1261833313396889,0.022410860296875529,-0.11049746928652586,0.0069619169388782584,-0.0094112963401279358,0.015502770454642434,-0.048438381054499359,-0.04682917755552031,-0.00022238890926721058,0.0014117579120073859,0.089525343812046881,0.079141464963506603,-0.092462497930681176,-0.018048972610507721,0.0014867057354299527,0.0047595475949270549,-0.0017287964469103294,-0.027304885422683407,-0.032110966856619273,-0.017611444082195685,0.073415867740449725,0.11601887154016219,-0.044348274914784672,-0.098407184448392707,-0.0088182813632140204,-0.042990020804917144,-0.039402653777542929,0.014836527788627827,-0.050635006343958483],[-0.068700619776660254,-0.032923512495656206,-0.028684838657940429,-0.027346807901848392,-0.012437513369475654,0.04530776482700738,0.14146963669196641,-0.024737285685323483,0.021872256378449306,-0.029614351891534337,0.0014704403181207623,0.00061449227400070527,-0.065002449904543999,0.036643808233299588,-0.032209783114478335,-0.013719980201209792,0.00426188928669817,0.043978918430192894,-0.046107785040272825,-0.020623098141049494,0.092668229881848918,-0.085226509118630056,-0.047326937943777285,0.056895689933855451,-0.038867744245311142,-0.0917328495389379,-0.0024675929250557657,0.054788109957318712,0.092324754023680886,-0.083976508299966168,-0.022272456922531034,-0.015278750110002501,-0.037660821714487036,0.0079480050392521789,0.035560068131964134,-0.051925142923762622,0.0048634554998182172,-0.05161245009194064,0.069926770229373256,0.019603910194766427,-0.058129948226766356,0.034120468186704639,-0.02278922943675725,0.0056803547423852491,-0.011190673015587217,-0.045209539216465838,0.042701687889130674,-0.027745655178843524,-0.083075835673998288,0.15661348719695239,-0.028533516906845684,-0.064018904490445727,0.0071637332946361681,0.010946513456513277,-0.026171760394870333,-0.039176510971348735,-0.052625382319528485,-0.032610615849156512,-0.024151118786911202,-0.029592259235384895,0.14367118076515981,-0.017566095578734467,-0.054659523961357363,0.057155438782691928,0.029811006572219523,-0.061339856579619337,0.040778203393560836,0.011699351049567291,-0.0088243741839378435,-0.13867569479385672,0.0070547616779323835,0.13839794109305759,0.034595641270555019,0.011188421962504996,0.048423842059529723,0.010037686002641197,-0.0018497520280923579,-0.03785572945780738,-0.043325856166240725,0.0080411887462800754,-0.13690073357640112,0.15427462008814505,0.053185882421555128,-0.062848800580544401,0.098908008073918904,0.024336051774163703,0.0012517787347508663,-0.02085091104539423,-0.010458871685104971,-0.013997622908016392,-0.062995080399173814,-0.12717711870320439,0.18117010896522742,0.12557740084057686,-0.13691773676225652,-0.022943723539645338,-0.023607554390057763,-0.0059308586972001906,-0.029008536818149494,-0.11052936897449649,0.01676636486201016,-0.0299062367975718,-0.010995032071071418,0.17825885072525774,0.052695253789213546,-0.15856871540171691,0.018373413764860413,-0.062619297278227404,0.02519282178146548,-0.0018928521098937135,-0.067840528056599431,-0.050794234172886574,-0.10116936098857549,0.13362153032125096,0.3407549635188265,-0.12171874249866213,-0.21070461874955115,-0.083359485995745247,-0.078475687667453164,-0.029251874573081954,-0.22249275032005275],[-0.06557132981627023,0.057387702833085238,-0.13424650578557906,-0.095896584636417009,0.24651372455616202,0.14475023251856034,-0.10963067096889349,0.025484984396096345,-0.0066750222960001646,0.018031088995289345,-0.072827217628290308,0.03072620730408979,-0.044556908489582235,-0.015540996433387919,-0.05684501901116374,0.085633232484377222,0.10033013618746886,-0.03742948303225134,-0.062461794161772756,-0.033926854157860981,0.014833446973797017,-0.031363558199583357,-0.023246290106997476,-0.032758472101354803,0.02961216484574446,-0.098209283771892336,0.077943952125225799,0.095671313752652476,-0.083245612577197897,0.020905717661596379,0.050810743632591124,-0.039132208011026501,0.038703668840843024,-0.040633395391036504,0.00067527853135830943,0.013989351386346478,-0.13054119279823606,0.045163670832086458,0.11112335558160061,-0.063735525164717574,0.037782451346632551,0.017424010888546733,0.061583223515939242,-0.063673752054099628,-0.085357765364971541,0.034715298877846669,-0.0030215396455599607,-0.074514610988951263,0.12038888042278573,0.11914516519976012,-0.066498159580288485,-0.05748981868984826,0.021247874106887919,-0.043395801614457857,0.056092405859263811,-0.05090562582130901,0.030755476067636615,-0.01704186923067369,-0.086372670819938935,0.043707175171625617,0.071729094880973843,-0.046172009255220331,-0.12569107869407672,0.062777551061848486,-0.054877769372877368,0.0098492983016237878,0.042534935799133616,-0.025427465203307967,0.0048504140831612669,-0.034534331263074952,0.057141387115833393,0.071824130085929444,-0.078856689082400497,0.046186589384248661,0.014021943501927311,-0.0059724118990401249,-0.059074101001239145,-0.052311447457610932,-0.018659392189258467,0.016795417135235888,-0.048576100654742473,0.005696565881307656,0.17000984187958204,-0.14025171691578273,-0.014920288189935977,-0.02450105995756531,0.067679703872773542,-0.052641577006571058,-0.077081344604230786,0.042504990176632659,-0.035988224869212784,-0.048450595717557901,0.047674683252699607,0.055032983271467065,-0.064761096554407135,0.020292721123239928,0.0052680731730131965,-0.008724092125284879,-0.060606693409500888,-0.069110808496291656,0.024795838594949066,-0.027097938518918639,-0.0012386914962327609,0.015076588937461598,0.055874096614049337,-0.027944142757713664,0.0052288086550267444,-0.048321181890514542,0.085961844501422302,-0.0020462600675238323,-0.11993808096408821,-0.049600877387059851,-0.092973801829541652,-0.031980349139618128,0.15102131486065962,0.082755130102661653,-0.05812569461482564,0.041661463970234,-0.037047057993232331,0.00087626833626111805,-0.080283390973512447],[-0.034048621962106597,-0.013918394846682072,-0.06548772211399817,-0.047310073653148807,0.23782208982702535,0.10576669895809315,-0.16563976884791567,-0.0108553004703765,-0.078836410655958505,-0.050020076625922213,-0.082311636984324865,0.0046221592868833806,0.027970146226042773,0.0058953162542283617,-0.040403941884181518,0.085253805301136465,0.028249211911977573,-0.056799025228174559,-0.038359856825438986,0.064561651783710705,-0.004954534081803498,-0.0026872237095931402,0.015597774984475364,-0.018251513667145277,-0.059710086387074215,-0.057150732848946277,0.13137766031471873,0.056842489251044542,-0.023477089345610051,-0.04715337162739789,0.00085770297510117874,0.011008761901938887,0.0056123703931996918,-0.055914997492275034,-0.028097049059282828,0.048624529525826458,-0.09611678916961594,0.13044452791174554,0.1272054903208456,-0.12259017298086688,-0.022445774624546361,0.0076033086689639515,-0.007813929706646499,-0.040902985091359895,-0.00098022228977209802,0.010151778602803127,-0.055308792888781488,-0.09226196374306854,0.078710234946180416,0.14963503373654086,-0.059601167114054721,-0.075910372743932211,0.069756019388331106,-0.012391419754460144,0.016171610667790957,-0.01017022339581132,-0.0099408597626345213,0.057862818914423922,-0.053500193833918241,0.0023150521701103197,0.24267633702175795,-0.1627124626737711,0.0030389904814953246,-0.0019134583602005394,-0.031934733720563539,0.031240729347724282,-0.013447900401826515,0.018762854504427245,-0.027194103497078681,-0.063834611729319063,-0.019315034866382974,0.17296296924653209,0.0047779566564492282,-0.046724087968013847,0.00063750179780768315,0.012018498525607005,-0.049906231428034672,0.0631023423942359,-0.059113148710084523,-0.0019439172858828069,-0.014409167351918703,-0.015148208183996925,0.15802729853460101,-0.009547054530539667,-0.14207668185762945,0.10783009215784571,-0.029316341593904699,0.0049958861272639266,-0.027229716588043594,-0.027547849025221866,0.011938104583316997,-0.054219992876510435,-0.092135020260128445,0.23665714027812351,0.043819126959151938,-0.041978283190380716,-0.0056029326770753868,-0.027255334727821774,0.0096145043238918745,-0.041549931903191728,-0.034068436330191069,-0.012401382536206651,-0.041537969321840174,-0.049314333651992288,0.16482326808377185,0.042083362292458376,-0.1097240094748354,0.066033601812019324,-0.0077249598120593538,0.0029248566859087777,-0.080850631612695664,-0.057690051594666086,-0.037836445771667115,-0.093750009831868486,-0.14353454214499062,0.17090805592445343,0.14406736607449203,-0.019806817871862357,-0.037179860963505104,-0.013199402310805103,-0.047378006725271239],[-0.089355795589857873,-0.043598613334664152,-0.040685490869347668,-0.056314801498742351,-0.064317257271733375,-0.036305703402461552,0.087124549743226198,-0.025232182382037796,0.060762583071081767,-0.016932442688114099,-0.040974561824924392,0.0011692733530746166,-0.023469947694595206,0.039360151665226911,-0.004433224342906196,-0.014202479654525112,-0.070463664877363302,0.013142057597150633,0.0033619826211813905,-0.010205721175565105,0.039510232304449916,0.020167450302709292,0.056938011555847157,0.034174491642619889,-0.062666774603916287,0.083900397057253467,-0.0039050936206950077,-0.12023709783757955,-0.019127477277872861,0.068195203204562405,0.004239692936547787,-0.024727068518684399,0.013195391150686318,0.10092335285374379,0.083732978098471689,0.093601488222699147,-0.028064279101364227,0.1530929534721796,0.01908068436728888,-0.13458558446941826,-0.041819118595992209,0.023907908538223728,-0.0036807630455928317,0.007893862945026961,0.064006968331711225,-0.027474745577589776,-0.014962346779522961,0.019431039040092461,-0.10421624372835411,0.18788293784249166,0.0038646939965042704,-0.021850967831761797,-0.071620009503902279,-0.0073304196952225197,0.023479102591966762,-0.032992466061732159,0.074771930860797808,0.11997396053811867,0.16652757445893027,-0.043450925728879812,-0.19633494915962973,-0.015120380697294114,0.015595534851796003,-0.041435710686911043,0.075826650575169657,-0.0062698135667015216,-0.13523262558321089,-0.13542793759250013,-0.079399992955661691,0.013399321738180064,0.29846443483321561,0.12612688550553225,-0.082084690167688573,0.034499018867023584,-0.060887460666349029,0.028443725041023785,-0.036122039638383077,0.0051284231998723478,-0.04605609290697394,-0.18431251645987262,-0.209810670926456,-0.12018234374910172,0.095623809719311254,0.012101575052632325,-0.022524769880679987,-0.045282477028056718,-0.012822428753938651,0.043771209187441484,0.080442241536594447,0.053685027638862681,0.040661690320921172,-0.010274132182098798,-0.10557211882546326,-0.073595782434368109,0.038444068551446525,-0.01907471602474492,0.012245888918847134,-0.0015393549215302338,-0.021036517265939442,0.05518243063690028,0.044093645228280701,0.028389644682731155,0.0097436040384290198,-0.041472720807566095,-0.055377684790392047,-0.016991109046279269,-0.0081617619250853313,0.0076016249396629494,-0.0066456574053765025,0.040565096868620157,0.081751315687418724,0.050780047897429154,0.1155676026022933,0.055483067679641382,-0.057897491813207046,-0.1105898575072263,-0.071828681966453228,0.061970511290256887,-0.030281369882132307,0.019304831483575841,0.054296933756856992],[-0.2437388912119279,-0.072313525080502913,-0.041971984175469032,-0.14300397257914568,0.061522596957557102,-0.030205439566140864,-0.020864680638780005,-0.047647886319076141,-0.004129658790494567,0.04027736046562435,0.0059092092920419587,-0.061426215758847547,-0.049227621653249579,-0.070004334019369369,-0.064272761487378705,-0.026633980149117817,-0.065741384613963089,-0.051050316403064497,0.0043410772798304284,-0.016116178354041721,-0.031515372710218439,0.037031195841364675,-0.1228147574490851,-0.030325889054245894,-0.047121946899635309,0.006945477959475678,-0.12020262635091686,0.033919560718345204,-0.036501468385288172,-0.023249455180030049,-0.11560461380300818,0.038387197660639291,-0.0026532986572997824,0.061601452701894321,0.10391565419224812,0.10819008673388165,0.068685203069905748,0.11775867403705874,0.017679110509122742,-0.058901821293154327,-0.020290611595912264,0.0001469059966410502,-0.12261361036045612,-0.010208071253787782,0.25551979619962417,0.13824223662087887,0.14467947383464419,0.13522961725652033,0.19144244169061975,0.3152710823580756,0.11571778386301039,0.11681561560364913,0.032566473003269106,-0.050278128345735251,-0.13473831638652176,0.00889663273590241,-0.06668638820919999,-0.10871364490994836,-0.18658986296561081,-0.34157171141342124,-0.34638493808149179,-0.011264008251140406,0.029142444614928986,0.12461122431395127,0.10800578593966685,-0.022809897357387282,-0.047431594853249527,-0.016065811361968149,-0.012088172884114928,0.13024386066616567,0.16585917678227963,0.08223171490137017,-0.18073427281823529,-0.23905771961269479,-0.0034760942387594002,-0.0025528511815767485,-0.0080703270400058758,0.035854903717420804,0.060889803984584323,0.05280523963556441,-0.0033159964189498209,0.12385169566242266,0.18824042049023279,0.29210060042127328,0.11943421064782488,-0.07449416534755314,-0.037461734684461859,-0.023737648801047031,0.072598572988186116,-0.00045486095293109652,0.00074298234712233402,-0.0015928557141097338,-0.17246645124725063,-0.15444027225745488,-0.13465384352760257,0.032776686516006764,0.070859809216384226,-0.0004770524214243281,-0.032343629149890175,-0.039986157743816128,-0.074752388387847202,-0.069851711472991157,-0.082819246951454234,0.032778177162039637,-0.0042937782327582136,-0.015012757926196954,0.01819273756147026,-5.6098151787711825e-05,0.019859569434228445,0.033074166094270323,0.016572156520835511,0.091964106413136654,0.073376911105508508,0.098478285913656774,0.036105178755291706,0.050869520986871988,0.010385433683375911,0.040242105632122271,-0.070134750890519848,0.0028041075844665309,-0.10929235377523264],[-0.076118949202517425,-0.019269106767557935,-0.031754535045991392,-0.046455653491455862,-0.040704384737309626,-0.050843290857606804,-0.021973706618717698,-0.025543401663111642,-0.07416056040918946,-0.013170588459795768,-0.11347265323402626,-0.057227893055629329,-0.029590820633760687,-0.034243625770240413,0.0061905334896895231,-0.0094644557199642584,-0.044625667555150392,-0.10436846800575,-0.028686249322612808,-0.041090017647881019,-0.046151869816618452,0.0098325948939372923,-0.067695778385091526,-0.028012701414139411,-0.071396857165263158,-0.075353072177860636,-0.10565554313610695,-0.075522794580878821,-0.026283961786762969,-0.031035439373623519,0.045981881415172052,-0.029752407317735798,0.011392587697051898,-0.1039429255200454,-0.034764441427698627,-0.037846056000007268,0.00012123885743986484,0.091278706547537475,0.14577205157542866,0.1104215855219802,0.18869952301023718,0.10738370259626208,0.13268927139759373,0.010378228400827957,-0.052734405426765968,0.07627991587110855,0.13003488750036463,0.24685954687761555,0.21183725748584104,0.24704340387352622,0.22867523573571288,0.036921057188982587,-0.028737222239043028,-0.070384615788671751,0.0055155357845693004,0.11568430941686651,0.10660133014829948,0.19511953592195094,0.045422489839321928,-0.075768281672479496,-0.18361820859428674,-0.31804072962510349,-0.19549450758187809,-0.077995164144666299,-0.031296132745874644,-0.077327917406273622,0.12870564027407561,0.041486516535153339,-0.13922180905243858,-0.20395686432544152,-0.1572834919140717,-0.072166722893366869,0.086563963129244234,0.10757801321268952,0.081809003061111898,0.066724060401920929,0.047445258557963374,0.017639198538912979,-0.1058218276867447,-0.056754378546732487,0.048224352355707559,0.14306872525152498,0.12358807932424302,0.071726754535007084,-0.018593224747300865,0.069247194070239257,0.0029737893381716479,-0.0012683824671753524,0.0058616562424005786,-0.039955178776990612,0.069868180941963884,0.014017003861568525,-0.046600910938925849,-0.047068333385668161,-0.046681863281231521,-0.024440679090069646,-0.037553368502167325,-0.059138302137312151,0.039269526323743462,-0.033803159785026828,-0.016677251343357832,-0.036287370622927695,-0.033653158506393541,-0.081054618119207861,0.022448731777965539,-0.051864605704516141,-0.0022564588924538012,0.0065500568568099202,0.019613695988714784,0.035674619157173841,-0.088137935604942944,-0.049861006869088897,-0.046523335250325093,0.015602894296518968,0.070302678780579275,0.025611762172576102,0.06845737037990568,0.035739036571478075,0.014800222944481767,0.028993857532204525,0.026773523645769501],[-0.058789866419249687,-0.03992289616881476,-0.010605417103711993,-0.018499457729712329,-0.004865080190320413,-0.060301330529616955,0.00031834469339242499,-0.12557104846760686,-0.080004274046988455,-0.13698273850528309,-0.22799077610365462,-0.025563254532452423,0.031596931721125744,0.034180802606017344,-0.050379683190577049,-0.036900574597293838,-0.020122798822353932,-0.11425996362570746,-0.082449949096166764,-0.12939384502163268,-0.015453432533256775,0.16525998969962169,0.0054733899561779098,-0.021933035683807854,-0.058344539474112764,0.022961713249665269,-0.037437068374264519,-0.1277856597415159,-0.028890639336882469,-0.0028919209327963741,0.26948646721448222,0.1755823507659644,0.34733594380543498,-0.099005604765418503,-0.03282593950620348,-0.065174445338135711,-0.02845735040351216,-0.062602372298509845,0.032022397582957891,0.15695159271707296,0.34154299673599708,0.20280139720653914,0.12458150522764966,-0.093375723727740126,-0.072239020683553506,0.0090947163917505652,-0.044389015283926039,-0.052574599103869434,0.029479831254029615,0.26924859691625802,0.22826750438753873,-0.0022877017320989818,-0.1114646531276304,-0.13529114203352183,-0.15036111092012305,-0.085842755314764929,-0.024536907507225265,0.0086890807497300507,0.021944209642358908,0.16653403493301283,0.08152009064661242,-0.14404674546435942,-0.14990102541427039,-0.11121323411132536,0.0010729953777799395,0.098095234511134735,-0.034221197248638688,0.0040175961684953184,-0.018012784825030465,0.073210106805800909,-0.0072272106254334667,-0.015972640001127802,-0.061003687664664949,0.054833426188111108,0.067576339145725264,0.074127017865976058,-0.042423930579678311,-0.037337363882495159,0.022891392960963857,-0.0034269311956898834,0.04377607969407446,-0.0055550198865683478,-0.060684852096268893,-0.045928233440519814,-0.0088830951753407356,-0.077574617772135271,-0.073068573889404992,-0.0075845224916686986,-0.05870405744262968,0.032429727788504017,0.11139987187807623,-0.061069384823273565,-0.022957481391546936,-0.081456668310723568,0.013486103859614872,-0.10699268871745335,0.026815142447461103,-0.046958076560392775,-0.0095643677181986124,-0.0078126265354927348,0.021325652288010453,0.027800587316513206,0.056728645862545959,-0.07588999178312969,0.001849623431887229,0.022933740393987989,0.013435613550251885,-0.030879626804123601,-0.0049468588623556402,0.0040992199004741686,-0.0091408161111731587,0.10871928144408688,0.020712482757044768,-0.030869482809578623,-0.0019257988508574048,-0.011927083397448635,-0.081405740634482276,0.063922112367951894,-0.010456133387573327,0.03707660212821462,0.088835355921773829],[-0.036641259174083958,-0.022318782338815249,0.024522274312524583,0.033440491760940591,0.088325318805097308,-0.078447223191200052,-0.047208492835296774,-0.047259416670676881,-0.025215781435357056,-0.015414996185524978,-0.092115101238035485,0.044024131261608312,-0.0091153987713104428,0.0048974270909144524,0.030833576332085333,-0.020765236921067881,-0.020723615749795563,-0.012243854655765614,-0.046289817377706238,0.018593204344671412,0.0051453347328788007,0.034378456965152134,-0.060076223671287794,0.057462262515044049,-0.029604759889713811,-0.032984761062248569,0.019793815460092429,-0.091801878345608684,-0.03956459119173994,0.14253192152349636,-0.01806439485632861,0.012289491688936907,0.04911968723662781,0.057131455553269941,-0.0053968509987426319,-0.027773037404305069,-0.0045553437237598471,-0.016293864219002016,-0.1018126126459068,0.21507853086133841,-0.039233573544075251,-0.01388758790666203,0.045506921385831317,0.12176852006259906,-0.0049585365213533662,0.012483286148479648,0.00022150651974826852,-0.0047489494995995168,-0.056359601414396263,0.17519663761795012,-0.055694439201051764,-0.082196839716537948,0.064537741077840327,0.04748422973872729,-0.0028928449210207825,-0.015338697146168576,0.002703261150090952,0.0067497963183427712,-0.040248133668722312,0.078968141080816637,-0.10963403655958821,-0.17062543905350416,0.22859560603386642,0.07851962872419016,0.0080330152274108758,-0.01142427708908322,-0.015145649505435649,-0.023532868284188511,0.0099659612341810866,-0.026743099199774509,-0.042414654589513018,-0.049675570929287774,0.29646343280477494,0.025690805425905093,-0.048511227932622428,-0.10023827450589579,-0.16647012418573801,0.026747181544677607,0.034918992877789233,-0.012381071612453791,0.031328960840184238,-0.03808798675298581,0.13554403224476577,-0.038600519161136035,-0.15955152669761682,-0.18650119722295797,-0.057062155489439867,-0.012769517962987352,0.014753730819575053,-0.034539139458789864,0.006058740052616929,-0.0098108713410034829,0.069117277622840978,-0.071244146237570763,-0.13192760007023469,-0.031815896848603233,0.027197733872446832,0.044915537687674,0.13641539907523023,0.051541344109272018,-0.023022917497770818,-0.0075024647062180427,0.0075301826652961409,-0.059347528011641199,-0.044234947284663123,-0.011581128699856197,0.0014665467844986665,0.047135698296650763,0.015656423092764042,0.066012956376650042,0.058200473354046559,-0.015586985696736753,0.0052092264230974294,0.014817241711833552,0.018388023474896837,-0.086675877098822782,-0.067044063522772729,-0.0035215449899233878,0.064161373931149845,0.065318498548821255,0.067259148989151349],[0.0045060454140400386,0.045655120374964497,-0.0064830700717017822,-0.0032628436084326529,-0.010410124902832244,-0.03702402040624643,-0.036963266474149589,-0.091093906028424584,-0.11864573227941409,-0.064289797687791306,-0.19247581164633484,-0.001736762598627155,-0.0097469459578441008,0.0016447907097145286,-0.040872882087491146,-0.014221224057596007,-0.035842689053500638,0.016146856355897986,-0.039843139194713842,-0.093130420560655763,-0.0023746538984200771,-0.13830477342208627,0.028428452224738408,-0.013697468079493669,-0.11156935100514298,-0.0089864206453983495,-0.080752864691162371,0.012804209858369449,-0.062406450316134982,-0.010725880834214149,-0.033419853775967602,-0.013381072105187686,-0.12601376127960781,-0.0011651414984304651,-0.096302794160834315,-0.033960833636545611,-0.07271627207480294,0.035903231272948394,-0.050366776129811802,0.039465836216112535,0.089595240957993455,0.080323722760925531,0.15694230593686581,0.13046741922551686,-0.10541702655016309,-0.055080126117310738,-0.0081043441898794311,0.049795401559017696,0.085050117897638097,0.33220650657354384,0.25591351064686196,0.17170416430885482,0.11686339946258112,0.11405546450621301,0.22946835883838218,-0.012135608835537007,0.083665324516254844,0.13743718640771305,0.20760286167445086,0.024810385626267768,-0.25485287037990362,-0.37635120927444349,-0.27148633180868637,-0.10307518032579147,-0.073758021077069053,0.006322005152026515,-0.0071614241191596956,0.024394639535414139,-0.030595356710155303,-0.22377146981167628,-0.21688041618965234,-0.060604397244649409,0.18640642704652977,0.1411775414679666,0.071715708604953896,0.013663567087826838,-0.059637629532230764,-0.079133304381083139,0.051501100412118382,-0.10958403078776109,0.040357653528253698,0.24551987265937023,0.19850031772812765,0.13276295660894386,-0.0033277520526472926,0.095717281270899235,0.0060754811619981117,0.070214032074900512,-0.060295737352707629,0.023305858534584164,0.036241683301989451,0.094785196684708778,-0.051030541969498217,-0.048582060783967027,-0.13620414142167206,-0.042785196097045466,-0.055491249841953014,0.0010026144494500872,0.011273492179008152,-0.0070417417384625314,-0.02690303608673969,0.012495419954788797,-0.0049652674891686524,0.014207910106334196,-0.058316356599182127,0.020100992201083454,-0.055565658068763756,-0.058257850577289112,-0.12154724005307756,0.036276619232864585,-0.11927424459722163,0.1109090327897103,-0.087204589244144426,-0.0029129212052817939,-0.025028390260139831,0.012106502056846706,0.068613886378663252,0.071374295120005704,0.098125263845276922,0.14037322438964439,-0.0029560423417013919],[-0.086666708451327651,-0.065564519145399541,-0.023817463535297907,-0.020440748189549322,-0.071969614065115983,0.00028668951002261411,-0.048727572694679672,-0.025160320872547617,-0.071502198767284489,0.0094940082400308788,-0.072386589094650886,-0.025153788858944419,0.023459850224754719,-0.05950332009913685,-0.045615311205432989,-0.083519770284241707,-0.085543219025638439,0.013730208280768347,-0.021148981295175229,-0.0073162588177247967,-0.037712812535064255,-0.074773800976601495,0.03462239265337725,-0.02547365067836567,0.030186212545732116,-0.019963247487852623,-0.04969209404043104,-0.11327298065324004,-0.074519227217117595,-0.12603792583344542,-0.037063997844313232,-0.024954205133118107,-0.083735964905377686,0.024750173546374571,0.059330282701814688,0.062204749968921932,0.17133136972067453,0.16121648224746851,0.16387294452638612,0.058308117323603761,0.025830807003138445,-0.043479982176188162,-0.041636429687936197,-0.12914102690849677,-0.040109360336824149,0.020146168363946934,-0.0014664956647692795,0.091342016467911402,0.11971706786628006,0.23880056181382195,0.30997519288915309,0.24621925944009149,0.18586785581035009,0.12052801882874073,-0.0034211287368824117,-0.030529992172357766,-0.032290577650566622,-0.07619354278341188,-0.1960657681886227,-0.20015100244650072,-0.19677279724795954,-0.18308786989283266,-0.00055713480106216878,0.13743504158235739,0.12949126333024466,0.20559599476304927,0.02351134428016869,0.016946777735827437,0.073623968286197633,0.065649323472256313,0.062699413579597518,-0.05017906172626907,-0.092252062144122904,-0.22544582106641978,-0.14498855282877299,0.019198250206979468,0.08296161046033787,-0.019486237898005958,0.011992512029289193,0.041329981058323459,0.07636271244077264,0.031761554053674354,0.15907477211435514,0.10336465086935449,0.039866126496747839,0.021911878458555786,-0.15923424669690406,-0.013828911493878555,0.076214097730179772,-0.018094163035829308,-0.022784108454190939,-0.07576679032280903,-0.00479472472165271,-0.12287034163039613,0.031158696953220461,-0.051655022084203854,0.096187316481263704,0.0095670984140750134,-0.031623662424778903,-0.052567997778793368,-0.0031420233178607662,0.023308733927797941,-0.0023387082999069553,-0.0094487986093912645,-0.04582399432870362,-0.0054810246023805631,-0.081257910575128434,-0.053087043188049285,-0.0010084105650565306,-0.10300285383556548,0.05010294929397674,0.039084033656922076,0.00078260416687278567,0.06658472055870629,0.019512702741612473,0.078540493706748191,0.012933307469298647,0.061861312662757253,-0.037748621235955342,-0.044013957061032435,-0.058653414400645094],[-0.23765593793991233,-0.10644252010202958,-0.14205331737791968,-0.033409658821102896,-0.051746525740039011,-0.04902914905506061,-0.010142689387288009,-0.045800121111205794,0.034452092003027894,-0.037462523290761315,-0.052617568352887403,0.10954838938856398,-0.13610118046500422,-0.0095471511929971949,-0.12706132231951731,-0.092228798361772418,0.021263651882758011,-0.080027642431201571,-0.0100550311904971,-0.021203318677089002,0.016576191285134906,-0.028370386427869553,0.33291003086902288,0.28090106038207852,0.12847553299199477,0.033792763942573037,-0.023904470117744384,-0.16851016358623308,-0.0060729181420751625,-0.023245122034615213,-0.056640550891660243,-0.012010707479483837,-0.098774094475144666,-0.064504327550212237,0.10265691959773923,0.25554233719714792,0.24276990386303868,0.21966976582871933,0.11091090952626349,-0.10183584175603527,-0.087459644795301786,-0.0029720828981545685,-0.00012924753214214532,-0.025079977013448711,-0.086435061104407823,-0.18087547713194091,-0.11352267862578171,0.032889611202360142,0.15787019926944854,0.23051337575410985,0.14879854133516468,0.032437611765298205,-0.057059196511395328,-0.069308077657970535,-0.082356064599434647,0.04228548674166778,0.043412923933183953,-0.072264826939583221,-0.16689179449726901,-0.16026349114722624,0.028474874784694099,0.18131198489108219,0.041852912264988044,0.0049306527163999643,-0.00083249749637829239,-0.047831996372009418,0.0010252465231246899,0.017497628114831826,0.074031972038296395,0.054062759312123537,-0.0048788678858039461,-0.1017614042122941,0.018693005132704797,0.0076210492973557671,0.0085934586035815354,0.029130058487575196,-0.076722340878408429,-0.04443504101988021,-0.041904181084809797,-0.042181657033595429,-0.027448364698935662,0.043452694941417874,-0.014281471541844684,-0.11364364120314924,0.021624342767224931,0.059887867734099376,0.048249692701759446,-0.025917915651940925,0.02805763343822287,-0.035965266748084215,0.010590677166796214,-0.061232693431225199,-0.057899063583557495,-0.08844340564057801,0.0012600977398065059,0.015191608284153623,0.014315608183696132,0.039038170262391945,-0.011070372964504849,0.0044675582793348174,0.0051525001918035183,-0.076856408464383241,0.024632015663543207,-0.046933647548906957,-0.0043118009452010539,-0.041968903018102854,-0.01569526374931584,0.013525540172630385,0.048796773614702041,0.00035467155966114033,0.071901198369965086,0.016274926781300325,0.070923477382927924,-0.00882484521729196,0.043457848227967125,-0.01463905425635062,-0.013191689698509215,-0.037524320749473053,0.024708931479837257,0.057086614057279259,0.0058576139736190606],[-0.024541961538258487,0.03267163162338621,0.11772757167816214,-0.034174233168758797,-0.0717426324714492,-0.16174536289395333,0.014164562611569745,0.019531072825155295,-0.054978468415161165,-0.0038956868428951796,-0.090196113790009247,0.064812251885165414,-0.0472339389168712,-0.019133679594543138,-0.080948115948705671,-0.1101849445159255,0.10726549986933923,0.11986161329611322,-0.13898042378726411,0.029469805860096759,-0.069941197461236101,0.10165481762063706,0.0042591037232074525,-0.049347547297978321,-0.083661416571785413,-0.087655843717195536,0.020522117345934385,0.080191817405819127,-0.15728279592142505,-0.028885847231444647,0.073544321095523182,0.20706344381077879,0.066144278705455667,-0.069631881661333023,-0.055387270887946399,-0.0099158960524032974,-0.039717793915661548,0.14583324737347106,-0.022727060768185453,0.017713374718806421,0.28062075184074708,0.07576339464353285,-0.15759577923577814,0.12669291481079187,-0.0065957965533044935,-0.023038500644189407,-0.016203548822575214,0.011443563605701524,0.031044733818071997,0.099390009396605278,-0.05047331939795989,-0.030750723936850188,-0.15956288120485115,0.01286776308068685,-0.1670547469453125,-0.047963831961764791,-0.077402955827408276,0.025311426471354537,0.040894848866229114,0.090108524928684319,-0.3117498185712026,0.059978928418208476,0.17392049002395632,0.068215126727969963,0.22655017146929168,-0.11277740982522262,0.015117918949874534,-0.062899724806877555,-0.069945490124479578,-0.044909742287021881,0.14433444462851913,0.29232937226395989,0.1955873798585851,-0.057850714258981209,-0.014726496195370711,0.088840761160314488,0.26941150721674784,-0.054033771011003262,0.0111591965306495,0.024544359195103477,-0.0050102759877621028,0.12289773365466525,-0.042268194241055185,-0.045072456104567213,-0.023985660885704002,-0.018776641626454649,-0.064872108441076909,0.17923288498496057,0.017718431179447353,0.012676757235305675,-0.084141918563022666,0.0927046391653705,-0.14741704405082073,-0.077405293524682478,-0.041954355353188345,-0.018944672617029513,0.060652295217796734,-0.044563097079480543,-0.046248836126650289,0.033353665903115184,-0.0018617038323594237,-0.067677746878476538,-0.023333614214616976,0.0136221936446786,-0.012602435194539463,0.056141915908750409,-0.019617155818133693,-0.093416021391092674,0.025935720217831887,-0.2107611868683418,0.040245343412419005,-0.077188871326229633,0.01421259796769439,-0.11506917731449372,-0.080209944956327744,-0.12403747829586499,-0.034792135391462455,-0.051307124154093234,-0.044478904070419822,-0.042402134083612701,-0.074816944103372168],[0.011580340758841009,0.076463412301783149,0.00079803404858471978,0.048838428314634974,0.12248324878819095,0.013743650358534375,0.018861138121382369,0.011586008838870166,0.045389746032794658,0.031693376594253822,0.074989649112201823,-0.009866261755352353,-0.10340488386695112,-0.071572160434485707,0.0043787474738315128,-0.07778860136521136,-0.019559075604586286,0.012039914910358105,0.0018614793888236656,0.017976562122428465,-0.04708343149187328,-0.0071367900965603071,-0.17555550753460089,-0.080029090945432202,-0.031800223769076583,-0.057597347069660187,-0.022591430940203699,-0.024015557136778228,0.020306356095828103,0.0070646865909845908,-0.049745509295279933,0.010918207861832434,-0.0079759574056427959,-0.057844329934535914,0.040415092756685103,0.05051297898637875,-0.028679830302952441,-0.088878085058129219,-0.11596341833461316,-0.14726999841028157,-0.12186458373388864,-0.013719238451893214,0.0032337827790390591,-0.10004453617576921,-0.017783520567117159,-0.043426790290178846,0.002516237987708639,0.031180239925685315,0.092564938676877706,0.021358915086836516,0.17681853360539368,0.06626948027510339,-0.056798463424251405,0.020214558939605977,-0.088730140207167144,-0.019043455841855041,0.12149386494436711,0.039670736228732052,0.12658659654781676,0.25102106759056364,0.313616299442317,0.22183627286461596,0.1359746158531317,0.10115711474812561,-0.24302403404704537,0.0097296125255306402,0.18356713494692423,-0.026126940847291485,0.034416695001123848,-0.0047517120355681092,-0.19721799705664833,-0.3026191738381685,-0.31481960231473161,-0.1434027289225949,0.093247316689862428,0.26017905533217356,-0.15231835953736883,-0.11886377910271781,-7.950240878037973e-05,0.14995167348160249,-0.07737337854954085,-0.01599863660324637,0.2521561754016366,0.22726143797909176,0.051761936974425632,-0.070375767384878163,0.039304142728632772,0.046344087243253736,-0.018432448385731964,0.22509099226938978,0.059917659545538168,0.046242964966830113,0.11839665900852914,-0.19506738398455795,-0.14025844275720523,0.057466302603268626,0.11019012358572904,-0.013541932475265537,0.047028476991846445,0.024667584373991497,-0.0058190883316349695,-0.087336525273645438,0.089096154875776434,0.06500967167977309,-0.043338205557104159,-0.019092524599200814,0.14832868404659605,0.078021069640875934,0.070724212934028391,-0.031358410965025847,-0.072958714026414753,-0.13112668083166459,-0.086263740082819146,-0.072841242282538562,0.077042927232936959,0.077562899744286179,0.10315256178304716,-0.053457712000654738,-0.045827447338993611,-0.02900391837847402,-0.22848349838247778],[-0.069051215490355838,-0.13695919912679141,-0.0056563275282749768,0.017174473739632906,0.054750990465431963,-0.059932166353439724,-0.015330830129175563,-0.0068192284467516124,0.0012622017178931346,-0.019229773264106312,-0.059761024322663912,0.078692856969722169,0.1089393724650921,-0.075681394444025663,-0.20952756667787314,-0.005312913294763244,0.10044708684084892,-0.11640309355112993,0.024356159573992391,-0.0012586164900474876,0.05069107388375764,6.7084393214669399e-05,0.20191076124513427,-0.045181133059133377,0.10144127341109486,0.11705452040763065,-0.22632970742930147,0.0184688808155756,-0.0013541832015389887,-0.12017877991510166,0.016842236983854095,0.052652180804933044,0.083145511130703426,0.057329748095278965,-0.040374712776183777,-0.11575057028044615,0.11707621621679364,0.069672785018686567,-0.13863634203166464,-0.079607983082249159,-0.022216919274236187,0.033593966744265236,-0.11362588566413499,0.10269722191626784,-0.24155215048670942,0.018756954826990843,0.27956157401899873,0.039218371860729156,0.073588480345744861,-0.044888999157036903,0.13769429349072093,0.0032477373467352548,0.022428521170885826,-0.038465640538281942,0.031154883554520594,-0.16441653723937766,0.23625286909405968,-0.081428432405938125,-0.011107263657897232,-0.062666400207005535,-0.17075494746168615,0.27269490990139,0.031157268147637196,-0.055470185891144386,-0.006952885879328791,-0.053436281993972892,0.42537068414459028,0.018283114946247542,0.13283560236845615,-0.015069149158958085,0.10328347994406929,0.44999154699931465,-0.0011928954570129824,-0.16086510891352077,-0.12774404557332408,-0.042099179368697587,-0.0018649195557395998,0.24605932528385696,0.074298264981605869,6.9784477611684395e-05,-0.052135626941050443,-0.086745017818760359,-0.22499073514863255,-0.045344789395678611,0.033108065913800402,0.032025942933416617,-0.053699697308726382,0.033624356023422591,-0.12434062876294572,-0.13435098170091592,-0.10102320426887956,-0.10333974326967209,-0.072744104098523374,0.030026079255193142,-0.027686487813203597,0.0035344601119742178,-0.059592180823454702,0.031353387154932702,-0.031956460680317295,-0.18985564540590008,-0.066673937571019595,-0.030281628842088536,0.015287505098408646,0.010680344185151468,0.044316674060265779,-0.0092002144294807825,0.044711089149172344,0.032936423173475296,-0.028902000094102702,-0.019831895072516134,-0.1083289835481895,0.017001459487365853,-0.016581037303639058,-0.047452480796807951,0.01964408724082841,-0.043525154566764424,0.022793656727439479,-0.031968227415916144,-0.1191326261973889,-0.012951530456903462,-0.077945906276183335],[-0.0042180435203333227,-0.177849827056837,0.10345176940428125,0.14691821176034053,0.032856437685713946,0.069906188728512633,-0.0063945110693917079,0.012858674522952751,-0.031362305638645026,0.048788464134757729,-0.21008276813725216,-0.14262226241092743,0.27350682670700188,0.13675983935772454,-0.29666625074261765,0.13073198270538819,0.052879354221863011,0.20819060117120861,0.054692335523337222,-0.070712189277451695,-0.0072302981622757783,-0.037876207980575435,0.016205298964287681,0.032611323558465855,-0.21236590603680106,0.19488138090854343,-0.050183688887998762,-0.10106171926311576,-0.19451804410928483,-0.097570273334807611,0.14803373393480754,-0.11936458691698297,0.090357091614167315,0.0059923455004580184,0.025455653887793486,-0.019228242751246096,0.084191785333891184,-0.1088352303605908,-0.19709666326225239,-0.084653777829652263,-0.086888144789493554,0.36808967859442904,0.10964208390108912,-0.06453781682173701,0.015795651214486534,0.0372255583573948,0.043017883593270814,0.11952788902899536,0.10395017914010175,0.04553068266111155,0.05441345422005224,0.24912633653507255,0.002223137297252974,-0.10580881478072197,0.090087613906571426,0.16662136065460986,-0.15730886509144254,-0.091248525393662711,-0.053757621594197856,0.022178794252692133,0.27116243919778504,0.33866879890439228,0.14040194814605061,-0.051936697245067276,0.013903415563632955,-0.065676039555647242,-0.12825582201243901,0.19222801891437483,0.066176686136318968,0.073803898255870817,0.14569502232430348,0.071160030480564657,-0.0095456596009633743,-0.10489910337220464,-0.081457920709183701,-0.078985379590762378,-0.11641729288088618,0.02271274135586502,-0.040783573204296208,-0.0056622589430029863,0.0036835932550680038,-0.066780309193843077,-0.12713315993774849,-0.1586600519695244,-0.063328586222237665,-0.055759758783947483,-0.037458086574487418,-0.022460685295330809,-0.022028900024817097,-0.011882201801517509,-0.046972799168275001,-0.14701204551638941,-0.037217728702544514,-0.082831218869885689,-0.0016295615745458014,-0.021758715372862947,0.059906725662667415,-0.013176728966978149,0.064518845785987863,-0.040907493521731432,-0.02724481426696284,-0.014614954526350594,0.11052684024818323,0.027444907166189095,0.022162414399074806,0.0024547001841418916,-0.01609068146442251,-0.058966580405083346,0.021584412865348603,0.032765251105065299,-0.1716263843502637,0.038525696603424579,-0.10090104298395008,-0.082755480397067163,-0.12651405684060268,-0.031346851498544215,-0.051126139081003386,-0.088046305344413461,-0.003187155224522592,-0.027110133357033151,-0.11431300136421083],[-0.066924227135342934,0.041699164002372696,-0.10385522794561593,0.055675362062145774,-0.074260470462326228,-0.091189960480717175,-0.045789683018577006,-0.053408546616140973,0.0016410632283570901,-0.010001962022561817,0.021791861105379333,-0.051951291323868297,-0.070200622462203655,0.097279876582038807,-0.15048632688284508,0.12149505097298019,0.015842805768137305,0.01783019614395083,0.028679225099310354,-0.13093015859478119,-0.0032724249962371582,-0.076392560780105201,0.023827921599709007,-0.10048639075186741,0.057647734800977908,0.14769797654526404,-0.058573134153914214,0.036566470887259887,-0.038113001252617282,-0.035949645768287825,0.13214950219821359,-0.11750728810678948,-0.027309528175229383,-0.15554238984918572,0.18384157344434507,0.10897982741577553,-0.055054919090396615,0.23295461106984391,0.16692460259498326,0.34350821795606212,-0.061818935287900251,-0.024811829586858465,0.079963429313170714,-0.18727278866453625,0.077134089493061789,0.20554995099374251,-0.025108602454572731,-0.016911421678591866,0.027522221377421628,-0.18467242934043285,-0.12870450689623072,0.2705100330044119,-0.23570033354568337,0.1600690210988466,0.060772731257298589,-0.040057046042739526,0.0061976917126070254,-0.21240599027215282,0.22776373257918395,-0.24459850621169732,-0.11110091474536704,-0.32900610024199545,-0.065957274593286902,0.38918437667082284,-0.037061988998483932,-0.013214304459370309,0.11361559841851943,-0.13116091416864151,0.26148934106645616,0.13109860511874102,-0.02559270333763761,-0.10769559173489475,-0.029541835495651814,0.21030527945911404,0.20083517469185433,-0.15455102744651888,0.098485941721442954,0.053759144210784301,0.082713231452363006,-0.24255028029402606,0.025733657047261198,0.17680889892790308,0.23330773415315006,0.27752776373592319,0.17725610536084593,-0.16258826629493126,-0.17144766528315306,0.083644424511134546,0.016994501600820736,-0.071477397540526386,0.074912024363340463,-0.07565486524045649,0.021346987911851578,0.12285156854226099,0.031741176745010577,-0.079711919211636756,-0.010975662352579296,0.020719019955012588,-0.14947464235426425,-0.05912634010598853,0.025068359943792605,-0.076954325737705429,0.01069978220983156,-0.035726380166860028,0.010452571251196202,-0.020801433687767192,-0.10029057450694524,-0.05347120776294563,-0.048791402971955875,-0.043406971496632182,-0.10411181696202407,-0.0096115795367616441,-0.040122338177384982,-0.046812122680620266,-0.064058112417089225,-0.14541168506254615,-0.075679730264006442,-0.032466738656732913,0.0079790695503431444,-0.07581427323024105,0.020303485166861458],[-7.0956605279434704e-06,-0.095051438182964521,-0.087881575580860127,0.0047062408698162472,-0.098027263270710638,-0.0027616522983207395,-0.097227127279984199,-0.063000737106212207,0.1183446266588927,0.054456621706851616,-0.0099413502699212952,-0.070139195335673504,0.058249435624697594,0.03289065810180454,-0.077908796650873274,0.12060553802938856,0.041916937919234294,-0.12018601094319402,0.024991064566815515,-0.15610551053004948,0.027447361841557171,0.0061691806469063477,0.22277923739993141,0.07777153698627623,0.15813994477460777,-0.017009298898611493,-0.14311974342433334,0.17959497330783272,0.051525754847030057,-0.11409305598330613,0.0087348047214590788,-0.11631550153784051,0.014926258001363192,0.035969081785568666,-0.053625843536913562,-0.023997302411323432,0.19964826933410396,0.036096776017663271,-0.049210808628064102,0.12245938533273446,0.060611269299314152,-0.095796932751361336,-0.069519386575027736,-0.050249772835886296,-0.0058375428161391262,-0.012563499903927425,-0.14780320613165895,0.031772227910289275,0.1340288392048273,-0.15156587379880926,0.12631446141014752,-0.0052889953007679499,-0.0019668259446668848,0.054030336420065141,-0.063631403170866352,-0.34919842820174568,0.086316002230514569,0.1498086851219177,-0.01958777908962751,0.12206293626181336,-0.19933801771288356,-0.048029128706853393,0.052601068176454692,0.038693350122585096,-0.093007050474004316,-0.025563344264592822,0.177347641964092,0.22163601611492076,0.094680687451677889,0.037985353513600273,0.0088876390621224696,0.33248829688044318,0.16504809583361016,-0.0078675683065857933,-0.004089442342142393,-0.073882292576678388,-0.023509082885282934,0.38130178103352774,-0.019291678040942513,-0.086843448560368325,-0.040173020823503824,-0.04644318688990192,-0.10185859440346755,0.16438891805551265,0.0026682289367386675,0.076749174458747987,-0.067947692216907357,-0.0010386668473387935,-0.1071413883705663,-0.030576591810295518,0.032786203858462565,-0.0055510882120406793,0.020069023492512786,-0.017109613552384946,-0.1436550284492504,-0.016711779362517481,-0.069886123624812627,0.011359667056578288,0.0048980919655428265,-0.071130858325672064,-0.065545434771973304,-0.079794688129113223,-0.069727649875106712,0.057019363580092276,-0.021992787171872023,0.015178002477788638,-0.00020471363886212166,-0.025514430736042228,-0.026882894230500245,-0.045297853805246369,-0.15832593006621121,-0.031428749312098873,-0.0062888408902217752,-0.0057807583295211989,-0.087719175812133982,-0.014850613830471766,-0.098570157493344357,-0.1178588681684648,-0.058161768326308934,0.025496330937214109,-0.027500922923648384],[0.033385872123633739,0.029449410773330013,0.050373165760226532,0.033759553320561811,0.043978212175572511,0.083180076982955681,0.071686676768404664,0.026805901274190462,-0.040212948527338761,0.074455765899692133,-0.015556797943286706,-0.0052349749182220018,-0.019241697521412499,0.055811600772115361,-0.061555692140009097,0.022157119108767706,-0.037499771041887051,-0.091842013395178321,0.0021346112094529357,-0.077528445870580553,-0.070339569427925713,-0.021843780086959141,-0.028323350880137224,0.00011164923792164605,-0.063043678969301159,0.0312281473289511,-0.027814517961888829,-0.023586402460836806,0.014274870264679794,-0.0099112948624283936,-0.039421607735394437,-0.036124694755188508,-0.14334911700158648,-0.030906231546069748,0.026456805364020539,-0.055731905472351545,-0.099791023065150669,-0.11300163966955051,-0.096702307648394478,-0.14134937562707614,-0.095762099342366805,0.012996731697811542,0.061452509807262426,-0.10845706522050219,-0.095954535650827094,-0.026481658468726504,-0.09342212328404359,0.025974710463679895,0.048411867352889076,0.13854747029920722,0.0089877939638353527,0.1412865429641629,0.018873766998065353,0.0068619328268330129,0.066028998755879767,-0.069576990925801802,-0.13630992697783664,0.053261035495914627,0.17932579331025728,0.20451416645740492,0.25417885834428638,0.42794011719114639,0.08044763293045501,0.060807812906450633,0.050979231912287287,0.068724551062169986,-0.079585125467176915,0.16947242780377064,0.071750399564743134,-0.17602834598556363,-0.20609506703378996,-0.27585183265236618,-0.45996207117951626,0.041977085392240453,0.14013188266658397,-0.10129069427591146,0.042032097653530609,0.0010700558006018247,0.033269813089743,0.045261284159797271,0.18492968093047082,0.11250515788380208,0.079146011997887886,0.27604374526273284,-0.29337379824901733,-0.032404962081403643,0.24482947691686244,-0.11730122219590641,-0.00039308173073460823,-0.082855210467204926,0.14722185737303153,-0.050887412106644436,-0.11313790447392723,-0.045971837803545731,-0.12976452682175901,0.36520902694991747,-0.091821999799496623,0.085864390337494809,0.076512715542274651,0.1029210140799042,0.0027325839402362467,0.070586710333678859,0.10533730048009346,0.11195874976952475,-0.072147843907271553,0.04958613688607464,-0.031050732598035459,0.14407295372271284,-0.085587606300639052,0.087228804147073041,-0.17190628673080169,-0.11561123789185015,-0.092875168889563639,0.029308812125760478,0.03997500953017151,0.12185883649720056,0.10737184929932188,-0.039136971459624983,-0.08075374206140308,-0.053377354274828807,-0.19749855557352708],[-0.078856631490001827,0.028609754041207199,0.028065667582647003,-0.021834041252276289,-0.071731644229173191,0.041943503021699281,0.0034420782526643334,0.099852416772104879,-0.07205432251463359,-0.14404103188347261,-0.099453272442615065,0.030831458745725907,0.029895496253457346,0.0015406398850859385,0.05063743421782619,-0.061536371482124472,0.02259540959954133,0.058299280629769371,-0.21504560821843677,-0.10742200693101064,0.13531193618860787,0.1292569094640518,-0.023228953646059501,0.081512184345085004,0.00055798660700738349,-0.098023802602571472,-0.066933869931841583,0.030281268644703027,-0.19700701283846223,-0.07452246871817525,0.29428494587030196,-0.019357176004156089,0.097885648631463901,0.086819751550199789,-0.043231492206504837,-0.018463852192367017,0.062745383271060842,0.0092971348018957081,-0.24863827359607188,0.010777357730302948,0.2316312466976955,-0.085329575508557826,-0.1144533554642945,0.083801285402681849,0.075830927030971565,-0.014032603342417981,0.049484524164173316,-0.021590806395398253,0.01544196314913996,0.086162432936096586,-0.044102733314784051,0.12334022048862069,0.0731644245704271,0.1088690387955715,-0.15316811061648344,-0.078737489667754818,-0.017284888207398728,-0.039703575150386236,-0.056905519161583623,0.18660214037769024,-0.023526673216460528,0.0097119105430037156,-0.11068696302980902,-0.0033322120127640339,0.22171201468168639,-0.14381135593764638,-0.044159431475442788,0.056899281315330237,-0.062535558479373796,-0.096715665724386363,-0.042463185527764596,0.33605398681131693,0.12771999969210951,0.029306037892139189,0.05296083974268942,0.018388136003953504,0.5836401595356645,0.078369782006029357,-0.14774018856780891,0.079310575246893361,-0.13568107571099638,0.033726128645812273,-0.19371960002191677,-0.048923336377734009,-0.079048275095496057,-0.09345765767848567,0.0084687991049249428,0.02446655940112101,0.024072807776000009,0.045654023909503204,-0.049520678628329894,0.11131277121530644,-0.082671959669512629,-0.01281734719311349,-0.058436346732921529,-0.090027065890889588,-0.061291547168362749,-0.12266871096386792,-0.10084079570396901,-0.038685969609545547,-0.034857542952191456,-0.00069531684714200376,-0.05711976301891046,0.065894606637351888,0.076843927132624321,-0.0099221911757089998,0.038382533425733813,-0.0018487126462470374,-0.03501906580527725,-0.16441171510027652,-0.08279114832431804,-0.066047134941834895,-0.081932618886619485,-0.010547381209761031,-0.051038369726976479,-0.025578508207813648,0.00959733436024926,0.0049533230583025667,-0.061062803017560258,0.033453744496612564,-0.12571424039710155],[-0.079439136902308832,-0.09707485383450068,0.069013639062420487,-0.074505761065334339,0.075011587478881175,0.15666344682780237,-0.081193505392068127,0.092118683011617047,0.16894882838291519,-0.064300711893237078,-0.10649892578590311,-0.20661689203008798,0.1403179918871823,-0.13859623598009607,0.15068161397003726,0.0818655854637374,-0.014124777365337841,0.15933582287539705,-0.056122956200266111,-0.14961952361740766,0.26418260048580505,0.00014354663354841646,-0.0073547177374536712,0.079306683498707897,0.020928941460220271,-0.10994253368145199,-0.1737068099917021,-0.023790675949004782,-0.086918445142954964,-0.0043349673789482186,-0.085954954881572246,-0.029420848660444726,-0.0090500058502500022,0.041530999507431957,-0.069423567534389233,0.24688351427911395,0.20546023916088876,-0.17598878843872648,-0.24389316703559294,-0.19015439770039061,0.22071277516100238,0.077210599045731132,0.014424585107587845,0.0067033339564058075,0.14557756666221139,-0.10028307012545846,-0.046263766310684282,0.17807074556144536,0.23207365188169671,0.068919009550189744,0.13997442592318893,0.08843295944139111,-0.06619014796452205,0.039954930324093148,0.044429111474699981,-0.081010967478443885,0.068410955264807463,-0.048059234788064731,-0.0052523124756469336,0.19319439038918368,0.22920446006103862,0.086101063476146392,0.031256459311461635,-0.017769668585097209,-0.081514861804228012,0.05257244191659842,0.0065146809658001778,-0.17665071040880326,-0.019856913059721516,0.081102049633683185,0.043277973324065216,0.1177242078686942,0.11137298745761917,-0.00073261542200567242,0.091978290618997344,0.082389423312920304,0.034022525912699247,-0.053097609779258953,0.099288071298097996,-0.10854924126379789,-0.17742490622599222,-0.1788673671646884,-0.14114600439166541,-0.064004772896817302,-0.0530848482065642,-0.001659672063313692,-0.070676871764606644,-0.098803538640278576,-0.055944765770140174,-0.0052751644189938454,0.032007780955169478,0.057629819382953605,-0.019709560268588652,-0.057823914219534894,-0.068256964756672839,0.027890820691469885,-0.076656239311701027,-0.023631977229926458,0.019705542780305209,0.062780023228323073,0.0043080812012436104,-0.0068539298994425221,-0.06958545243479107,0.056698946025054167,0.04217344775125749,-0.02598409561655364,-0.033097604108995968,0.0095921823100812154,0.041800833565904215,-0.050819206523713883,-0.10689758970874308,-0.015847929055034071,-0.060764599912676534,-0.0062175219913371549,-0.085347310202452731,-0.097474869441167511,-0.059282139115269104,-0.035577269192877056,-0.075014161045616631,-0.060536079286523312,-0.11817678424233188],[-0.024906089757269871,-0.0020839929168818827,0.03600621465641745,0.040388199406629903,0.0046367828095772237,-0.050097408580542964,-0.019438803749024975,-0.099398454194897373,-0.039682250621000295,-0.0028157838678664303,0.003598249335640377,-0.054099425886740632,0.098751567366142629,-0.13208302404353375,-0.18035374659388975,-0.0043732111233372346,0.052329318134350926,-0.04335824692063206,0.17086900465322874,-0.087788905809879941,-0.044980405576590651,-0.03163490494923718,0.070376930420080558,-0.22835180537374491,-0.053228685368124661,0.20061806426747758,-0.010253623864425198,0.015916215379575709,0.11152189577260957,-0.12242970393701272,0.20444421875737073,-0.11370776685859571,-0.079913946642613046,-0.15288251066153316,0.013009551196509275,0.24933943719410992,-0.15783799994383102,0.14723844916068518,0.12653772742745573,0.087844531937603762,0.15842166298167773,0.048090301745894584,0.30801127557408381,-0.11761230465763839,-0.09838866239110361,0.21453595775800124,-0.1423387911053251,-0.0057875034434971828,0.14715035050010203,0.037047259467474523,-0.050841281845606351,0.14408577985508386,-0.2038513895714491,0.12419113537768206,0.16468328842666694,0.012860540177512661,-0.060259991855088471,0.075149602462860884,0.32707138878173159,-0.40030305735760485,-0.26935994114991207,-0.27607955331013073,-0.11367870913437449,0.18759384386653338,-0.1163031684096954,0.011359887068835964,0.09104201353611753,-0.023930250513817877,0.027145616702753089,0.26867810752766969,-0.040944043069847058,-0.051185346442636469,-0.062555156572748197,0.1472213528555063,0.17279204270125498,-0.045587324746883026,0.040778081769105995,0.077307454201848841,-0.045917861885393978,-0.14679289792741518,0.058857192810905033,0.30472542738820174,0.2683300390974695,0.20924065894919816,0.21225020570051081,-0.22492319213360987,-0.1053571313533698,0.10129898309130989,-0.058699658556484721,-0.056962291919962646,-0.053784567323456531,-0.064199356290904355,-0.023276261041638765,0.1463492641852929,0.17298005397684749,-0.17279567370535234,-0.028270599211786665,0.054369003114690263,-0.10106883014481371,-0.14024347735480464,0.018313526646667293,-0.037983673629831183,-0.065301664052257818,-0.012949891765581065,-0.094604107423927594,-0.11534207274853202,0.0076674644006928493,0.066321539829234916,-0.050400969350873806,0.0074219548220236372,0.028869570811624359,-0.015979869180987795,0.0047547098123721819,-0.023242027383037541,-0.10363187962188126,-0.08083238636814595,-0.038313754638492299,-0.086839600348980459,-0.019540426477005362,0.031333439883288614,-0.15193982135608425],[0.26630462964519636,0.030128294989303788,-0.11791438037260804,-0.11737308015815517,-0.062861100017125554,-0.096766046107599188,-0.082199316172390957,-0.08602044544779823,-0.075246502052840794,-0.029806813487391677,0.24281116497344327,0.067042165401364526,-0.0073445552680056064,0.019073705951446834,0.02402774328620054,-0.022036865798413671,-0.041360734184431945,-0.021551677954214206,-0.020934734000922058,0.0016783573161842508,0.044653551257398255,0.047330499149608574,0.070320918539436658,0.0049339384317501345,0.068284358255943409,0.0027795836778768818,-0.0466896472535712,-0.055777797336017988,-0.053408170439317705,-0.00010746082973150939,0.053647124251753928,0.014169718568750114,0.02905438269701309,0.023031619273586216,0.00066727081308550005,-0.00051462984272446916,0.0056491204378612469,-0.0020259322895197036,-0.016498390040156383,-0.022442940786663319,-0.035029164960025241,0.063846154826204329,0.044687185096032603,0.058668246749611672,-0.045157147571444921,0.06041887311954984,0.040368811541336383,0.099232499506447247,0.048066185349036866,-0.046324953034900501,-0.00080887873698461902,0.11409453701686445,-0.00033137478785196135,0.03735595742910118,-0.0079674076739742593,-0.049741034524289095,0.13611114777264577,0.023766455706096472,0.053497687988346081,0.015733350480013578,-0.063824933259796907,0.033330568088863713,0.027844489959796326,0.081691899842932555,0.09714592419415595,-0.064828174985232315,0.01437395739678209,-0.047331107121522768,0.044196999907911393,0.10629752929835162,0.073542689176749262,-0.04442637013096748,0.049683512301096674,0.068365456286007917,0.081523009768297947,-0.015087145755708103,-0.0019638115525515282,0.039051783324939186,-0.017850512607641256,0.02370779603383788,0.06201068601506067,0.073783766823374425,-0.091844803840924111,0.010696782251581938,0.086036514718463936,0.094596207999147933,-0.074054927866882767,0.027915857377493219,-0.037642014739791167,-0.040193374604089255,0.0024468858328299675,0.1274974581652491,0.0093404351484588644,-0.040375276072868213,-0.090114609127803932,0.10326418667261725,0.02917729347842522,-0.0077046231605733149,-0.030226724173417804,-0.02693842944612336,0.03299558344045618,0.037655280816208281,0.060384055506334661,-0.011607343174437262,-0.088458663756049549,-0.0089621130215228745,0.041335212079519151,0.025264577237378585,0.032067053817915525,0.023830466137715112,-0.079345931632774758,-0.11617934147005861,0.035620949281212844,0.10013927849222683,-0.048809475943344949,-0.11446551821055255,-0.095813017973671741,0.016305663265873432,0.11707531676597775,-0.06319976004011861,-0.16222515899222084],[0.056794304038679966,0.10167830608861393,-0.016503737435740885,0.0046764347911659732,-0.015979430307930184,-0.047920295093506274,-0.055022283646318906,-0.10379295727074533,-0.049717862262312687,0.10568238875466442,-0.031174132439086774,0.083704603950004272,-0.091368133200752627,0.057269302584031172,0.018684874349729957,-0.032113253507965796,-0.001736967749467095,-0.072079756116517402,-0.09935581393877263,-0.024667483850197125,0.08617572294614978,0.040040155644135919,-0.15099062261616583,-0.00067872303189795563,-0.015247157304283773,-0.052523565344750653,0.042551307369904048,-0.14444354746621113,-0.0065487046921334988,-0.071842610189861628,-0.012850025711011279,0.014122793694046731,-0.0033943022739370415,-0.039640354001140646,-0.0031247601407242975,-0.04585791859357094,0.0019020572673282693,-0.12415842588927675,0.073896324144092557,-0.045015519750068421,-0.042377317003355355,-0.018876095794982992,0.066199553272244749,-0.038229410201656738,-0.081067787682230996,-0.03945825059342991,-0.021573688648487861,-0.08753783022136527,0.033366036076064857,0.13641185499907951,-0.063205201260604499,-0.0012659096018193816,0.0057982623571657815,-0.01152673538233475,-0.0079257311321652285,-0.14126097140944649,-0.034964896400424342,-0.05417735615198177,0.098662735854543188,0.31744333379137851,0.039452304758183607,-0.12302035212752997,0.090307702196104955,-0.018426534125878427,0.0076069917669535497,-0.063786017925961197,-0.13634861844502966,0.021706398551087892,0.088489197364119254,0.24006998601480642,-0.038574376291261439,-0.20903973825035016,-0.028547940107015453,0.088542726499488494,-0.021390725008154893,0.044285016775694894,-0.026993312698921287,-0.064465983803312712,0.12944644855572515,0.19089244056580751,-0.030480082660302492,-0.11056842407420524,-0.030936086975706011,0.11334521747158818,-0.035129148248064457,-0.086017765013793296,-0.0072168706451755035,-0.10752750376129108,0.04312283194476934,0.16933458944871088,0.04045539432256913,-0.23664539634671644,0.11812030967359738,0.075939969650854852,-0.10351739032237361,-0.030300589898196291,0.086878456898969891,0.020132080229428105,-0.023337176463668542,0.1929319867081439,0.022201478223351577,-0.099101135273428051,0.15510108808703874,0.063727924452699231,-0.2536830626984794,-0.11398510745687342,-0.060714100288377329,0.014445183346757966,-0.078060776119834835,0.019868445241697584,0.0081798453460741917,-0.058441780232701836,-0.12524948970895577,-0.042729684478892374,-0.10578506496128201,0.082761699659597399,0.22610842991965319,0.19472107409175121,0.13770970450022119,0.25212791464266937,0.073498142085367354],[-0.091381241401881697,-0.058079620328844089,-0.076530504628475743,-0.0199353534219689,-0.11698549667840648,-0.049621401738281688,-0.077132621657016204,0.15067146207913978,-0.050781047593468576,-0.02068608682311579,-0.07749948573069973,-0.096758567391562439,0.0077571560895567868,-0.0095979406212449749,-0.099565859084337058,0.0051600482008870227,-0.052061725176615475,0.21007930845912845,0.065151157684292277,-0.07131801809693715,0.018812215208894742,-0.00086442135402349518,-0.046564358647237104,0.013463679946637018,-0.049760289181046941,-0.075120052315886143,-0.016205730606521709,0.20370769256587995,0.21631569735613507,-0.21639898101726901,-0.010174498767059056,-0.080744395481969419,0.00065762540281793375,-0.10941455592056311,0.0051919514244158776,-0.061527253139188519,-0.01884736889232981,0.21787195260154674,0.22243219444192475,-0.15575200547256071,-0.10816017929215728,0.0051881907601944027,0.031785513639906941,-0.11820319244612582,-0.091955481834663816,-0.065886002565202856,0.045741458364707437,0.16229065484815031,0.18370330017469805,-0.081324008115822286,-0.096899444925845776,0.11220947396556524,-0.12652409273694068,-0.056954083685135951,0.0037198361414339312,-0.040598532368215791,0.039300218532823339,0.11791439151540004,0.0326000042015889,-0.021776978247445074,-0.040529054786980857,0.01854198366161787,-0.085732791470378808,-0.004251519029603433,0.031088165635845141,0.10946916476597079,-0.030520300750865037,0.024588867262970132,0.031028281179074996,-0.026058776582265818,-0.034739864282203929,0.042015930066768251,-0.15813943081690485,0.098811275146536204,0.17664760200291613,0.12060292796297431,0.28365889513274267,-0.0098819391479129104,0.020720424432064774,0.041373041991295892,-0.021038365304358167,-0.095202664058810157,0.14910980302517288,-0.025721833368892062,-0.12819902853565343,-0.023631492175036073,-0.031597247870627954,0.10824280634239519,-0.091173425222870613,0.063567445633335107,0.021728192985388861,-0.10568636568278675,-0.03165356681046462,-0.0087472418572157873,0.14635866247530055,0.137170585551738,0.040902403217571118,-0.017771123105949502,0.038560203534045476,0.039245273632345951,0.056815291462562527,-0.11183679663036641,0.064817659114458095,-0.0814319418691829,-0.03407437639196588,-0.11203464618304287,0.15240885057308393,0.13533724849720771,0.068633687203628974,-0.036633006460861393,-0.046692920364638499,-0.033281368663026875,0.0071094850495891995,-0.024376962431089298,-0.086464142800486851,-0.048461882500802841,-0.085872378316760006,-0.17119204490022732,-0.12548065175775711,-0.10025652608610795,-0.067724150717968543],[-0.11048795383128253,0.17729666058333263,0.16552135430896192,0.034404289623548884,-0.089588724846092802,-0.0098956908398675769,-0.092669573892880996,-0.06203414994882403,-0.13027990600802769,-0.02774126581005951,-0.033782876400120204,0.068485642196071284,0.075989574144754934,-0.036571377943051521,-0.027073113771866435,0.051358605941092213,-0.12486678803139802,-0.11937553330158295,0.00027670008133570678,0.039242940114803171,-0.065341658588557533,-0.032591209892933931,0.0094873995209515255,0.077228802276500336,-0.11978965646742909,0.065175622098800165,-0.0045330682114145572,-0.093210957468272904,0.20829565218067517,0.034407695510313439,0.20900868773517667,0.18059530210220634,0.080546449898943231,0.011691715187434483,-0.1036261996342592,0.089440339361349333,-0.18290277626865079,-0.17449211585023297,0.20463646978781697,0.16205227161355945,0.1248389858520476,-0.033920943885589638,0.0050538696227267789,0.011335298516995454,-0.001853830495579134,-0.13334091118720467,0.13244272444684829,0.131632260424145,-0.095949574197512086,-0.14905751361173961,-0.1371680896219323,0.078006860735210071,0.22398467991789892,0.060077091359143922,0.080459089156971392,-0.044226547302833194,-0.02641690246856537,-0.021047236515817119,-0.022107985555041423,0.27081392806687543,0.20243579723370436,0.052508427611470655,-0.081686945424025187,-0.028000437521812652,-0.069004413488459787,-0.019947203774680143,-0.065108523571595467,0.087304868895712956,-0.077077120690107775,-0.18137313212262005,-0.11403701580048946,0.1344871234635103,0.23244603542157677,0.055124623486195068,-0.066463747876115559,-0.091451832072540304,0.018849225191806832,-0.024654340248073531,-0.024966200161235935,-0.091424575201207697,0.072527831499301726,-0.065216059830789028,-0.11921754880632893,-0.17337893909947941,-0.057219238952144341,0.0067422534626652882,0.011248995976294755,0.068047811183628626,0.049614879488339002,-0.097275846898811927,0.0082358567684881357,-0.015023386519351074,-0.053933000536622519,0.022181719818654445,-0.078603056286837239,-0.096990160520272428,0.053341686179560657,0.038592658381352868,0.073273892990471573,-0.0027339150021431086,0.0087236349272764163,-0.056654841529851035,0.0089929406550926932,-0.047992111069460372,-0.072470382965599156,0.013556901031652455,-0.0027078537211853854,-0.020808961745466689,-0.023685877670394262,-0.082885320875324089,-0.024581734079028472,0.011675698399989887,0.010268763903630733,0.00027727025909281972,-0.10403456880151318,-0.031328630320557459,-0.048762641369514532,0.013870483338988132,0.009776937951070902,-0.0016096606912818917,-0.11084797308275902],[-0.30333471569576326,-0.098154450360570744,0.0015410657868983949,0.045929458780550832,-0.065355998121677139,-0.13987052383343457,-0.083088561382526641,0.082669066314702278,0.061904779698073738,-0.11069374343220081,-0.28290200253357906,0.22673155788863875,0.18594415935524841,0.071854402503120182,-0.030528580748157334,0.028577245402910886,0.031060985030853229,-0.043861615284254557,-0.044105176677454817,0.022159810237959286,0.21654680444315066,0.30278316304132502,0.012213805294510331,0.086126585521097476,0.18984475627300115,0.17496536348485808,-0.084862281907876494,-0.081456542808588703,0.01832638457011089,0.13673417025774948,0.27284413141414504,0.094612335659298857,-0.07613963041950092,0.062933406187327873,-0.097443958251205609,-0.068403980749692395,0.0096655524754083975,0.095040552086250632,0.15936905785590366,0.072995084064054722,0.031252763725467911,-0.16546942109824656,-0.16677751455927864,0.12669754079805604,0.22204531073147377,0.1873578562466022,-0.037621658900903542,-0.15711170707975403,-0.17298791364700297,-0.082555273200012824,-0.14455053081729527,-0.22415305552359763,0.042542402815446807,0.1038139770409886,0.20625177708368309,-0.15880889026588421,-0.075658865558639876,-0.021485883747037457,0.10891607713839715,0.091092897473454199,-0.010416568160451598,0.069543852325783792,0.16542830711077747,0.065217336152304003,-0.0148176716125085,-0.20521529011852879,-0.14264824540169307,0.019756071252460615,0.0058040644663103075,0.039643334769194863,0.15659048313489107,0.22864706757459258,0.14254650813759029,0.057073186388449368,-0.053152191307381427,-0.034477291485900341,-0.077598395442579862,-0.066725783977938199,-0.064230325525589035,-0.089991097501851386,0.028289830388051281,-0.066129155191647263,-0.11896201994465391,-0.082558170326111818,0.012810697942117068,-0.024384133696020396,0.015087500169279289,-0.13601461458960581,-0.075236980328811445,0.039014121011195529,0.02815424125400038,-0.055013916259284479,-0.008254101582952672,0.002655866524947384,-0.021125020025650129,-0.023746573840204926,-0.042683164777021068,-0.059495722156300584,-0.019042694817947538,-0.12936213546879713,-0.026222299825073875,-0.025812691605142032,-0.041703863747776904,-0.0661914684158392,-0.097506063642520957,-0.058396072583561887,-0.089961267739098516,-0.0037007256822108175,0.0011179813727885506,-0.10090477889016067,0.064140298767104573,0.010238148607735212,0.06440364812729471,0.076684547115576734,0.039151433631154905,-0.025802896171529727,-0.00019835521728821248,0.071841486242385455,0.13125162014433939,0.046056658246170903,0.053499157763845701],[-0.12965724207701509,-0.037580246387615174,-0.067610081744866102,-0.10396968869944452,-0.050146681143041577,-0.11661839201437256,-0.0134094248817632,-0.003812121401652345,0.14551889487217159,0.20960814138138711,-0.11572556521584892,0.038199771776252472,0.053736720825050086,-0.033780376813536642,-0.013778088995604357,-0.12296410846003263,-0.190779199296427,0.063623184193675034,0.072719948625815545,-0.18712323706253348,0.13564826018751774,0.10041735856871029,0.0663871462462544,0.075875100621604977,0.10518317164208223,0.14542272105614312,0.12359189084318592,-0.033750642430414049,-0.1168093845370131,0.047363177697914378,-0.078115158492371495,-0.0068072546065389011,0.022330740883073977,0.043345000603673689,0.0061772562098951697,0.10018581879835563,0.12543189326433035,0.29106180455164443,0.15950577579932912,-0.041016614728731443,-0.24664638490921542,0.10243965713284461,-0.022249340976419691,-0.03998099582023288,-0.054513454865913025,0.10149283919617619,0.12490712516373728,0.024443018843315022,-0.1715648928173428,0.0098209256442637616,-0.099464482677069699,0.10892786493077161,0.10795471728528551,-0.03038255212780229,-0.052093742890319261,0.081082286817464475,-0.096274050930638774,-0.036267436417549877,0.075185345713630086,0.096808220000748818,0.02028571579311067,0.33290510761917347,0.01733913364880374,-0.16522028580434994,-0.0040897062381491101,-0.051775053344798386,0.065670470719540894,-0.032772885393817147,-0.085058808488073845,-0.11929889732683205,0.092455936215032175,0.25655461456536199,-0.13119179078724852,-0.099868329749784879,-0.033238669040386949,-0.014474294906370588,0.022015269325752353,-0.0068706343634212103,0.030438728104146773,0.038215294505712517,-9.8671203312486466e-06,-0.13106943853344732,-0.11029667516487467,-0.05651270541297225,-0.035091478549347271,-0.021024591609859103,-0.037796865064866875,0.0024114282376300894,0.066872760480572752,0.06279809114300125,0.015860273651693568,-0.066417984558896942,-0.044395452917303999,-0.056739278057440889,-0.074490614504174629,-0.0017445397987308903,-0.001856208967092543,-0.031296834327762674,-0.080379010855047062,-0.032932702209649889,-0.039466027214634262,0.026868758362947193,0.052720469111467889,0.017821499479210093,-0.0812792524309323,-0.0098243462809757751,-0.035827346651628185,-0.018665339965729243,-0.030414846245718247,-0.025397750118409348,-0.12699585584653394,-0.051270046062598378,-0.059492797705412472,-0.012977814302096748,-0.040201161068129737,-0.0063003255036662778,-0.059572314072736721,-0.060873397857079979,0.025500546592364254,0.056765099592826794,0.012716285965905683],[-0.053342785646891183,0.00524567552363564,-0.047374753370638178,0.094781074251503727,-0.040976740413566221,-0.096552554457401962,-0.074881802597734803,-0.046657906236577507,-0.091330632489740368,-0.040717971184299956,-0.093076755058470406,0.0037318258071586674,0.0012979923922400161,-0.072971306435051883,0.057699016112258382,0.21677924213445596,0.062692077375228986,-0.044090195812729369,-0.023130229334030562,-0.021606172607987695,-0.016753725645425696,-0.089114918695803486,-0.018011910259290234,-0.048665499037987205,-0.038883468315214373,-0.1600836076867248,0.12324454290748962,0.16213596071632191,0.081890999010858709,-0.026691379256621572,-0.078939099722900294,-0.035177884757280425,-0.070559193083664304,-0.081449629456742917,0.041254495310394122,-0.0082409283980089815,-0.06410405058088145,-0.19223363085057119,0.19698561203334053,0.075457705890398047,0.10168065244977331,-0.011407968361767371,-0.027454319260572038,-0.096909253770893336,-0.027762551704027569,-0.099431835349921047,-0.065804778038646372,0.0079576419011488393,-0.031079452139909713,-0.025254998311881022,0.13286239727231575,0.10025133561412032,0.065637269228549927,-0.003144015511429633,-0.044383514517180048,0.055436478646850723,0.059891048250770511,-0.0098526217416507553,-0.15354872527543872,0.1700617723129286,-0.1844295002128809,0.068014427221688975,0.029876275367864972,0.10799501360998554,0.085618199850133345,-0.10413623068849565,0.24464749614213879,0.10562029167251738,0.15464122158870292,0.11486770498168064,-0.16275359615761803,-0.10100376605498677,0.095138924293591193,-0.10761116645534677,0.017873153892635395,0.11423888867213229,-0.0018411500448220972,0.086874147832482249,0.16367347677496105,0.044733386292518801,-0.094761623273037748,-0.14397973597021768,0.21757349732675985,-0.034529293295072087,-0.12834039570251105,0.039442131452955824,0.052146536402598725,-0.0027754429203348772,0.092486771466581935,-0.10000875137392633,0.0219682748340118,0.076096240514652802,0.26484488873456774,-0.068778998021732471,-0.13150962876054156,0.0011599240934269256,-0.068092913704283053,-0.027604333874574859,0.0055121360660488131,-0.074848915014377543,0.031133754790612762,0.10057960203336513,0.16473981410325628,-0.021659253601673652,-0.084824882710566013,-0.016801310205887945,0.022993395502963216,0.017167179382408942,-0.056374112089754111,-0.032324211286495264,-0.018053909855479569,-0.050023765149209809,-0.14089885860421936,-0.13965160319931622,-0.11870197019087025,-0.062036231181908014,-0.04101797266105614,-0.050867286670802161,-0.058573069820662169,0.021580959803428883,-0.042699365835973099],[0.019902842485734224,0.15561506976085307,-0.028017485754111875,-0.17651276038235375,-0.039197701387862535,-0.060229014076549556,0.040413897080862501,0.0039324663973003132,0.035474887918963999,0.086187127716139331,0.066211423470236119,-0.011482759449640119,0.021711326088798229,0.011537755053333605,-0.031843183714078183,-0.08491361323535157,-0.023265192234759174,-0.11448125258912051,0.039181067323331403,-0.056998902182359298,-0.064776818516311493,0.063733692782339729,-0.043075172605832698,0.05638433416632907,0.025730822225084077,-0.10729102468091503,-0.043117991855032033,-0.053657854256318194,0.01584487603201426,0.013290760860429117,0.010200015604431685,-0.0031793878712187678,-0.11412253559205487,0.030883839158126154,0.021462269136898211,0.034969864237521547,-0.079456104230846078,-0.085031737678128175,0.11503343538242178,-0.10993782268920241,-0.089572802157924417,-0.0039431094236408934,-0.04578774281544791,-0.029069481413135097,-0.029312843103912124,-0.0022281839533548724,-0.015461174173461611,0.08016859253876335,-0.096417465851594955,0.068169543109748931,0.14488842713652675,-0.020620161448456426,-0.12127975627620319,0.0035402670006761464,-0.10860121905429683,-0.025759025070910151,-0.015907799649678353,-0.019318209958923922,0.027711942877274104,-0.010691765460204925,-0.11261913121914686,0.22919127543697509,0.19547240621082879,0.062576613714025703,-0.032437508756967479,-0.17049052524689434,-0.054887759421750289,-0.0086606964527578961,-0.032470312195105946,0.050117935111423713,0.038409765488664892,-0.15181868441017379,-0.17238837635837911,0.17800490245662465,0.15774737196971728,0.11238684789419333,-0.11549538053161687,-0.1051441923254989,0.029627428418807066,0.010047460882148362,-0.03595190922317814,0.015687349765215325,0.10710721567720438,-0.041276051064384339,-0.23137836087848457,0.10813840323639234,0.20398998249936215,-0.014741356900987223,-0.062683408610174352,-0.049411487995288605,-0.035967710177904844,0.041871499068939354,-0.072184903859897467,-0.083863872617445712,0.098734320072343104,0.11031868253657633,-0.22002867944446203,0.12779602690138148,0.14218707015954651,-0.0011896001696623804,0.079366530371097477,0.043588532242198656,-0.035424574718560489,-0.054609455641465063,-0.16492582250638183,-0.17557350746334122,0.15889132124334202,0.0041503307895962432,-0.10134763057667201,0.19023517186356353,0.084659592208096879,0.11510279765301401,0.16224249442600286,0.17763576210351251,0.22133908024822241,0.14596218529396179,0.02887144459288063,-0.10378678936442846,-0.067205691571172455,-0.088716399430536996,-0.041101641158728192],[0.15920136420084935,0.060406604769127695,0.058122346605073032,0.00477008922714715,0.019787104327780913,0.087203596056315003,0.030264199678037729,0.017304599070370644,0.085575429473619624,0.023958591314004331,0.12884963809652478,0.068599905466411953,-0.045567154593245292,0.064960440039459111,-0.057217993135935161,-0.025447705395343731,0.0909487087326179,-0.079769498949750814,0.036730991722000075,-0.038480072535680726,0.006076468777062756,0.062315581478503454,0.002067988991471037,0.0065579719955623714,-0.0043517925373637197,0.0096289999341297033,0.029116266207693448,0.01426370898438685,0.029690457152439259,-0.081627383427878258,0.046850542350542257,0.006214888501193401,0.018397271891386333,-0.012561848571951174,-0.040551619526904017,0.028504081990583418,-0.011486869296661643,-0.059191179697348155,0.022429209245582032,0.078039055277124986,-0.015415531651337386,0.019964992266425875,-0.066503829548354446,-0.0013193086595682316,-0.10842019255646421,-0.03697337790527494,-0.020534261687351601,0.040747539700920002,0.053337194618316,-0.00116709964776604,-0.0095601528497191515,0.016298910205605192,0.0077277626889895347,0.00037443623014628974,-0.19227631613374657,-0.13238394826418348,-0.030124775371821032,-0.015887858135493947,0.025013961658704745,0.027518775349448854,0.024198826147774258,-0.047760885812468984,0.12256242261650652,-0.055852213081364149,0.065026093917872521,-0.1285269471537781,-0.059058110817278908,-0.032314037012273589,-0.050141311125915716,0.08014056175866828,0.035775922639718939,-0.052897492514335016,0.0028741733491999197,0.082628087231978217,-0.021869185345972597,-0.069854074675508887,-0.068575988216225736,-0.064584701819010937,-0.00693137015502477,-0.063835739267782257,0.065183894970587242,0.085579887773321761,-0.089783371778548476,0.02413243559151125,0.12236645633019359,-0.0081031241390048803,-0.10893007981107913,-0.041047520032544138,-0.040485575357566729,-0.018772198351639475,0.024153345138070187,0.10036333221955367,0.068740306407003446,-0.10245398888523655,-0.016349166098083526,0.0070380009438652663,0.12265704999147381,-0.043113460086378494,0.013370230023298443,0.016729136801514881,-0.039288684774408056,0.057728476425995087,0.041012638786676131,-0.049978733723102124,-0.032347506063964117,-0.08817543486159464,0.099869944360031201,0.065600331696059444,-0.015359581783002035,-0.028528989655607573,-0.037199051460136613,0.15244521122136684,0.18336254107941996,0.054287847035064243,-0.046369032846879508,-0.1119122723959507,-0.11519151048090097,-0.022731910011617007,0.11225252067886338,0.28560328365377685,-0.067985252020442657],[0.058958788260075945,-0.021876278629613638,0.037612479257211687,-0.099005159575964105,-0.1165516680699821,0.021078862330256215,0.015957444616884531,0.059647685916549217,-0.065505591575810915,-0.083395277179433458,-0.18213933265545079,0.084305230751524365,-0.025710617818550302,-0.0014530727721881326,0.062922294533444001,0.010828617512124508,0.077505124497846897,-0.066208360763709506,-0.055002695608746162,-0.061510630819380879,0.068900345436844659,-0.055539144857880557,-0.020784660567228427,0.089398233599742291,0.1288331620004711,-0.12816590368747446,-0.0096792212613234004,-0.11505461495101575,0.073195596999562046,0.013390797267512064,0.063157106796453089,-0.11664356591893797,-0.087677499975957904,0.064068527412859982,0.089552329159210686,-0.012366311546488887,-0.084841814209484792,-0.30992838085367469,-0.31591124672801529,-0.19715224674545362,0.020969019898039606,0.14193745471028157,0.061843173279961985,0.073936168201219551,-0.01304258854189852,-0.07497702247252562,-0.20603881883896738,-0.070945540809535773,0.28309265451797216,0.57742199459415977,0.31262023603175498,-0.083661619056098951,-0.0039166593479060124,-0.007008189710296639,0.040088156481113336,-0.049394984833606687,-0.029191264319536905,-0.081163508484737398,0.19268793954258898,0.21144872967342784,-0.29773471400507556,0.12406492440813296,0.3660537274903351,0.093082413567314573,-0.024580539876515733,0.10110689340406492,-0.062910539274161195,-0.0034612665515367895,0.029116324782821203,0.0020626436307547343,0.10964075240294091,0.064158923379264071,-0.21854402897708003,-0.12925232991277491,-0.079675200291648277,-0.01811196962139593,0.035957827281212953,-0.046726417696597952,-0.060929938641963624,0.01119071426640683,0.02353396464233623,0.072568418302712129,0.23270637226267299,0.33170083850101384,-0.057955687348093615,-0.12545830581187295,-0.039267158405268378,-0.056155244480238127,-0.046609200143938004,0.060498849366474053,-0.043016662084753868,0.024841779701571622,-0.099367884763605085,-0.16431861879138088,-0.15146165000437428,-0.0017544026515488691,0.17032294123573102,0.064867648206299922,0.15233819334655943,-0.032910847411962485,-0.0071731964963948833,-0.0081380849704634252,-0.050724307248593621,0.011173233429224511,-0.062101699142451269,-0.052308817017819691,0.00051654855856720847,-0.0075192043437920311,0.039091511248705406,0.071465889129755322,0.0063359942967715424,-0.095630124560084281,-0.025392132057811982,-0.10041647140235001,-0.097928005682022187,-0.027282327996318675,-0.038112131251473808,0.012061424608286169,-0.035596588506541682,-0.052821862323290544,-0.11313037428451306],[-0.15324006372195415,-0.061965612404142049,-0.020864586176693893,-0.0004281080429524662,0.0730549833543368,-0.061347651024975337,-0.031466364007885647,-0.10327863822100901,0.057558435766753083,0.011198077448874383,0.045234383554630685,-0.064711224992117677,-0.067011155811770431,-0.0057205043684774096,-0.028643015431602602,-0.037131071599513364,0.053748889551759958,-0.054199304651787503,0.021887370672747687,0.016189862073254922,-0.019016514253116644,0.11379602147808761,-0.11165312886440776,-0.0087496200052688267,-0.014474316621162608,-0.026251634435374149,-0.002710236678190989,-0.030990248737400521,-0.04127464832894278,-0.11453289829380965,0.047907282053055035,0.038421978515818717,0.015082505447196207,0.028769815253706164,0.01684473164289961,0.094727188915121593,0.20593647137919804,-0.15159924031985617,-0.24555118979497925,-0.27707522357288905,-0.18048921280574989,-0.011307677999135979,0.11441322835116891,-0.014636046617138777,0.079198125709557601,0.012007403858779957,0.0072428501587866109,-0.18640141319376874,0.16780516380957566,0.56826306685500816,0.34085510546495534,0.15391020895285537,-0.22202084848747994,-0.093193681017569682,-0.005005130632420085,0.080166786371967738,-0.0010856269574332431,0.033973275724025434,0.29561270160331643,0.36482758672358029,-0.31466398989768735,0.062497098572653162,0.21968853798387469,-0.026684311034055108,-0.054686227873073694,-0.15194326555534887,0.054278240860889532,0.07409840320590326,0.0050038364543304997,-0.11139002424195973,-0.29694277435857414,-0.0028083524198520352,0.085921492659009169,0.054283294807933521,0.041159753010144698,-0.040069399672292144,0.020583515255041856,-0.032968306498467749,-0.12400399212637832,-0.12690204319933657,-0.087864335801985299,0.25943260806255236,0.25468901684408091,0.11148837097156279,0.016197234685087623,-0.035512335618043525,0.062529085678797003,-0.061876366590392667,0.042653661514922003,0.1456886858554321,0.100266511239698,0.049106374130385599,-0.1692085663504731,-0.15021472143352776,-0.036437790125085939,-0.094174544970770241,0.052142701469356942,-0.02443775761673006,-0.043904470755572772,0.097322253365795447,0.025963340060584358,0.04495779540761817,0.015315696105485712,0.028566823650113198,-0.099804513025419234,-0.056574603633366818,-0.0025488357793481964,-0.066924339863506169,0.010193965172470135,-0.0061765952954370151,-0.10526334482403006,-0.064591418118637667,-0.0082273846843367929,-0.028937589097058611,-0.0021874049091571094,0.0064020706434689961,-0.082473697153836373,-0.10584367018509927,-0.016046741087392458,-0.065096168336001459,-0.076610989193125839],[-0.039511428419417599,-0.0080173333971271382,-0.016551615434322393,0.0756169606326558,-0.029722132603671139,-0.025034558630525398,-0.072171220087672988,-0.092474182124173826,-0.075211870880661391,-0.044360430478935647,-0.069348984382251233,-0.022490503780794903,-0.0057147316926908116,0.052051258112528066,-0.054607716916367378,-0.058372621238702842,-0.060777353546059718,-0.077336809794399691,-0.045476724941883415,0.030772582414215349,-0.11620967239502454,0.10797792795409909,-0.027779187806584747,0.042775504075928825,-0.029085091874604285,0.070665070823427989,-0.10670180015368308,-0.12972554862345784,-0.061184746782739483,0.022941312169178836,-0.01197768577248755,0.16487084184278611,-0.048341409303366112,-0.026936350074678175,-0.048056362033197193,0.032473762460042528,-0.13513407425749813,-0.11294851883996024,0.028315126778450446,0.10779312846779725,0.13718980587277638,0.094828465533259992,-0.029662193522414011,0.1321112375584729,-0.11093428808802747,0.029166874149281159,-0.065792824284420015,-0.082565002818216271,0.024708088751542928,0.22293675583854181,0.23881873192468081,0.084903111184386287,0.040208497032350327,0.076545573835757594,-0.06123753763864033,0.0063284441525853219,-0.051374467063856455,0.062827084295813851,-0.036988261540257486,0.22358537142740625,0.048437402611115017,-0.25353214195075419,-0.19261045779830849,-0.019422340552033769,-0.062847643771965708,-0.036853496173419903,-0.12964946819383125,0.044458755188555237,-0.12226738775925999,-0.075998647776664346,-0.066285036198489203,0.2852615582722664,0.39166626094060492,0.21583615293103556,-0.00059671763801670552,0.028281927318908495,0.14150420560575661,0.029357515776456754,-0.0073652568066015778,-0.018181855688694376,0.0045056549707617743,-0.11281100988725729,-0.12216102487292639,-0.045821897312377555,0.027683086807535735,0.044114075431245875,0.012960273742704111,-0.01033045914794202,0.017525421607595383,-0.026815178240449843,-0.038433562205767026,-0.023176466057391931,0.018238150229464657,-0.10609098396328405,-0.0078365274088666032,-0.1692715238790774,0.055230115768598605,-0.038599121201013137,-0.030083122414206388,0.033498786150872692,0.064549273785100114,-0.054456334956194834,-0.00056162434047704601,-0.12305574145274481,-0.052312038879843335,-0.0062559873241414682,0.066658808641008482,-0.083661410065433844,-0.0050756577353415835,-0.053945762783515969,-0.00027041140698932931,-0.029193425089981271,0.060243323194549399,-0.018406883366667015,-0.031509946993241944,-0.02305392310291406,-0.14523023321109388,-0.083398220870461837,0.0083801401834026554,-0.054527177498857458,0.0051808659359899312],[-0.065848619594800789,-0.053261079120780402,0.035473933387924081,-0.043773076764098175,-0.042948902519114054,-0.035839763275580229,-0.03670964756282482,-0.035889928945933514,0.0084303424035014791,0.070959935481377259,-0.039990937836020757,0.00062919576125276822,0.02301560832911255,-0.01209375762579383,0.023507991177519026,-0.0043852583759025239,-0.017754505089411822,-0.098393451339086613,-0.025598526153569709,-0.093253517869822292,-0.060084598840034829,-0.0067732954612012303,0.0047322343217982392,0.0098854552921198643,-0.0079343145894890839,-0.048435067329455274,-0.011810163769240992,-0.044468277499084281,0.029161537175831059,-0.052373485912767012,-0.012794443685316442,-0.073999770655031175,-0.11228628800766731,0.00053718856153291486,0.054814439087026594,-0.058611861795578993,0.031704764448120752,-0.0076501524160651341,-0.10568592093548473,-0.19589466237166098,-0.12315650606608049,-0.011442858954517257,0.11925985331634427,0.0010363876176450598,-0.099823252161576004,-0.010168708525203837,-0.077187879437463067,-0.066004695514408407,-0.28363396719594336,-0.093300462947429247,0.03526227396896657,0.1315555866231668,0.091980662692318527,-0.0081160541251212113,0.12425322308370529,-0.043160319385198737,-0.010050897456012592,-0.025512330079287684,-0.054800141064251164,0.020003986809914401,0.31672436340823878,0.27826309013079648,0.13789936294639166,0.048833669604749802,-0.033553110848946716,-0.043105117290175021,-0.046986705987033792,-0.0079365698973256626,0.048609259060924025,0.091879922847580314,0.23510886392711264,0.016599220831810764,-0.12371629321306805,-0.063234562962815682,-0.089970415822645783,0.010187402027455342,0.072231276389250101,0.013954273076743703,0.061917245142637543,-0.043802817323688611,0.043710574812090564,0.034237891220848124,-0.14964785672058278,-0.021062558513936316,-0.0065214932642196285,0.10036739854860938,0.025703084368196946,-0.023339141967235796,0.039960562146232739,-0.062023256504603302,0.019839319918413791,0.12567284760581157,-0.12435675118258002,0.051042313590592921,0.05395714565825474,-0.016946352293375488,0.04332098462941552,0.03818482834599253,0.067064810396032543,-0.092507745085479834,0.13190717572685476,0.078818792684562711,-0.087287307293906408,0.13682219566390141,0.022366303998031124,-0.0032543902188911095,0.11492942524291971,-0.070293221413877185,-0.0097661701896662682,0.079120220441492722,-0.13762756714606011,-0.026907508147589007,-0.12733408978979363,0.086009164316699582,0.011950067353004187,-0.0089315833809120327,-0.049144400030709225,-0.044693326486270502,0.01772819118739517,0.012376530468464944,-0.085355211057613248],[-0.15926058536081383,0.084896584812555423,0.010352869323630227,0.024130584286049001,-0.009902524763821266,0.016912897049950096,0.073092475986395414,0.082369501233162098,0.0043022384356816712,0.083855432144435457,0.032979428566029964,-0.034178053263341474,-0.029838590632024091,-0.10512208483111922,-0.008974556089922564,0.036813559154062092,-0.020708179559887629,-0.010090767452007834,-0.072879198018760527,-0.0016777678298555698,-0.076743314512725452,0.036399119709258167,-0.022292045391296408,-0.079820967715901137,-0.031169859791016094,-0.023949824087409338,-0.09000717940002298,0.049463895166498989,-0.011624433079905679,-0.012190094457130381,-0.038313237174491976,-0.013830623631471112,-0.049168224717006298,-0.087380247558461244,0.036253216857834919,-0.13554744530431564,0.023838368099940645,0.050095096402370184,-0.053271595872730261,-0.085011920306738001,0.0061676064127104344,0.0016709301712408975,-0.013992899617507056,-0.062742876584451587,-0.056305160151194564,-0.080727059672253937,-0.042390280602992117,-0.14776692164523289,-0.097021309585960669,-0.070734044703521598,-0.015526870018377249,-0.2258827744334686,-0.12300661118492401,-0.11675473231723006,-0.16926423521447898,-0.11923817183461347,-0.012360787613125972,-0.053242566102073702,0.030546117724330767,0.11823686169287259,0.1835792066113906,0.16422671841790268,0.13230129923057396,-0.066626949058822132,0.034498938620505855,0.23002917423607563,-0.10642345721363024,0.095720714414564798,0.18783595134907466,0.1135920030571944,0.025587855512019128,-0.067439730759943028,-0.04765764814588825,0.10204615431399511,0.30589644738015032,0.1207425327574773,-0.019907430927027056,0.079052792051151108,0.091497228092328589,0.053534935883382609,-0.0018597176390167877,-0.036332301992695111,-0.067753380558353393,-0.038232412213873655,0.0085333812446309193,-0.16436890766057954,-0.041481437968170019,-0.024498004464789828,0.10683536971967762,0.011812992251597404,-0.1175917440126058,-0.012836857177767773,0.0010457282789089889,0.072147347565764422,0.12614593084743808,-0.055281692968689629,-0.0069995168866165275,0.060200941049300377,0.019190774932036525,-0.00068959398576445841,-0.015094903464007381,0.082564956168390671,0.029352696699322452,0.02052763134499494,-0.031246302084582171,-0.059332749185159739,0.096753036088350022,0.037229564658005795,0.02552939083091145,0.056861247331111683,-0.023450845541740421,-0.023607393595097947,0.01954177012013153,0.019437963266884198,0.044548459713283819,0.038280883907943236,0.061662221134642245,-0.088155201525030202,0.079304082788044877,-0.051664305162406034,0.077757861731466968],[-0.061708370720548342,0.047170428243489285,0.012296886297672109,0.0048086430115889811,0.089273037261738325,0.03230033333916793,0.0099210922415796515,0.077314960663833185,0.0072189861909926004,-0.0057895901610497437,-0.027110780745009062,-0.13988755144130377,-0.056492694825430186,0.043740683484729231,-0.001146343682998166,-0.087113548760168219,-0.049878803860526635,-0.044601413295294053,0.037026759136881797,-0.019657603932586268,0.0018226974562157855,-0.13718210083603291,-0.023654469782779481,0.023928892232900345,-0.06122045854429186,-0.029673384135270382,0.020848245415982687,0.078336447612606816,-0.040875528946684489,-0.039873516281161016,-0.055583967404462552,0.080912317767847408,-0.15785957027200945,-0.10648703433887595,-0.13229515155412883,-0.043310171649513257,-0.10793874347611057,-0.087527306016331546,-0.10889258052047679,-0.094200174396959033,-0.068306135251702482,-0.04422556269513133,-0.13934687419321917,-0.1704639053008461,-0.21416865484332515,0.055183328393643288,0.11437493872756643,0.20663278657310677,-0.10572022382588278,-0.17195276126460635,-0.070753945164719556,0.056465453539173864,0.14099415930836151,0.1946078610379961,-0.082660101380364309,0.18247573517682947,0.11507042684035029,-0.012083622193608423,0.071742093963169731,0.19214713056103003,0.19212718354463745,0.17144674880884414,0.15448386542420869,-0.010181744325890758,-0.075106220762733905,0.17626659048346999,0.072929611062275981,-0.085362521503941843,-0.101891980495703,-0.093910933641212807,0.0033217473718428897,-0.0056858529460113855,0.010932950962091154,-0.1295062582171746,-0.046960749909438458,0.0032455130187898154,-0.0090717781099731581,0.0068370840428534224,0.052015337511096507,0.01835745774621482,0.012669751254791792,-0.074411187515711824,-0.063973999886746402,-0.029665290241513848,0.058058821799073575,-0.018533488843353246,0.010601655483648394,0.081067124952225955,0.020392890895924158,-0.022919324383815623,0.12127224411021978,0.0071001462180422178,0.12312966006288995,0.13042358466157222,0.046876831123739637,0.042704169294137791,0.068078423886842515,0.046053854796515033,-0.0067836016920987396,0.045065140276322649,0.032495429886824072,-0.043798472997901496,0.039504422768531992,-0.050502036141981343,-0.02941424277017704,-0.072356052312286992,0.010414642546130649,-0.037595357550694798,-0.024335687688017353,0.025902421447803838,-0.0063118171276183854,0.028123124281161538,0.02743154969855563,0.0088219909651752332,0.010829518047857936,0.021827682953003358,0.043520974366854995,0.0035936083619636447,0.056883805856356655,0.040877092282017878,0.015956636369652812],[-0.0083507468620479183,0.061639371991654111,0.063042641119523318,-0.015296208138174606,0.10245170405475104,0.0039985678533539099,0.077652024216616294,0.030021244554642851,-0.021835994938437471,0.056396603655322688,-0.15006956293703871,0.010032941582169524,0.0050163763218688817,-0.018546011439547875,0.015951124664690213,-0.0011364559207565524,0.011706775239053238,-0.058604015442668633,0.0015384317043948658,-0.092476074016002344,-0.061290397480221234,-0.064372135135045749,-0.036227342676995969,-0.027815877384510204,-0.024540854835821482,-0.03665117868630987,0.017808195417626349,-0.13330602418496687,0.093825439776295122,-0.063647339534804878,-0.050293417559033632,0.040497807859436338,-0.093307118406317613,-0.051282463447807104,-0.013632758698631245,0.0051772510548923657,0.028088081363910312,-0.069493637727032959,0.029169511310514418,-0.065714751210128819,-0.0095799664282084675,-0.0075631952942880921,-0.046689398469438127,-0.036037308824896461,-0.16326411718263986,-0.068090435834012641,-0.090402159417016945,-0.189584820342072,-0.10038557840858034,-0.081409742082743278,-0.053687695693256356,-0.16229791121556614,-0.053231203082402576,-0.075002109435830411,-0.12647068989268548,0.18340634478038664,0.016324182102231133,-0.095198942566774997,0.046462085929464936,0.13804558707599751,0.26953073102703096,0.10023542270642752,0.053013201346585902,0.043485094470545015,-0.012145589101238131,-0.056648567004507461,0.022122779976736926,0.14925047779460079,0.20113371911375733,0.15087642306265311,0.081589939721924146,-0.094399747262114364,-0.0019980179561955858,0.10064758348146532,0.14323151379670465,0.13388503720638026,-0.013345742399046789,-0.027656328955928452,-0.098837422849065534,-0.015845908439641777,-0.029293403577799304,-0.12585250537276885,-0.076534053854507705,-0.025133636251120382,-0.078349075129356405,-0.02574433170418873,0.038564326983106453,0.084352144623457942,0.034971800593565937,0.021597995522587295,-0.0096451137676172999,-0.024148476054881025,0.035439018890817242,0.094838888204336252,0.013834291541066517,0.047416120389632277,-0.052763377378187162,0.099286557947731571,-0.042715908236761815,0.065423720561164633,0.012164923448017582,0.048080933808946395,0.046868409986020515,0.043736365228833965,0.033547437900394127,-0.046381661633450463,0.062765142428707038,0.024133154758299614,-0.097568717053638926,0.13228826368262767,0.043959645127688234,0.0069923806816005706,0.029834519712280835,-0.02842119488910682,-0.042758777280284009,0.050490465625002964,0.050638143272702621,0.044201806819941999,0.015928366919704041,0.050283819730028469,-0.094578811274961511],[-0.0093002340146824125,0.066420687864649622,-0.057988261829786683,0.030467914093403506,-0.088942632863114157,-0.014873330866996408,-0.06903000288081293,-0.05977259337654181,-0.024750165724362155,0.076980585184517628,-0.11219177639078851,-0.00026098838462658425,-0.10643324365636619,0.046966125920151987,-0.10536876322983255,-0.073429349480272951,-0.017258600082246129,-0.0097549083090397049,0.028937359707606723,0.058320145229388498,-0.10852363274246603,0.0093034019216029201,0.0032394886759010109,-0.11758435763177846,-0.030716524173680759,-0.012968473875358794,-0.072432676585988245,-0.02951516712700545,-0.030306917069408162,-0.010562351852173165,0.00059347532650239152,0.045901836344348218,0.009959243815588284,-0.14726958069576429,0.10665865350902941,-0.058288735861848573,-0.081332140906973854,-0.10522554630509694,-0.092706118193706472,-0.080448776925478707,-0.054722262004125631,0.035003945293075787,0.018233850654384959,-0.064682184713342458,0.082552298558358356,0.043969243290146544,0.10735340934065053,0.17551198745608881,0.028146227406542355,-0.093032253049539659,-0.080991883086283231,-0.17304587761466295,-0.08397564913817572,-0.082186994451058898,0.026086345132597978,-0.024523009144156466,0.061837165471639872,-0.0031532579414115108,0.0138867394019625,0.22791162384791516,0.17839063189638452,0.16802924166508618,-0.02242358838747683,-0.070478648225526089,0.075631000143473515,-0.13496798278125824,0.061914443579036908,-0.013965499326545715,-0.040287173996164619,0.0049442314234498172,-0.14234850191040116,0.13422797072590037,0.0044641492895416265,0.17884346888192523,0.033152160970333064,-0.084186014593884625,0.022681908276631663,0.069503167546493966,-0.10838151310589246,0.025867188572352328,0.062726350687918833,0.051958392475047875,-0.15684747676320326,0.13621424644871002,-0.077635757069622086,0.027664309706770987,0.099426252087916597,-0.024066482717244451,0.018369096774303477,0.11490785777152708,0.017998296859149974,-0.024584275074312559,-0.072970928250824352,0.070923228278133063,-0.084294490518602633,0.14548924260173943,-0.081488578294887343,-0.046883067570820579,0.065571023838321571,0.082578114864735361,-0.036743335018587939,0.054909713394909312,-0.024501097951853828,0.19599838240616638,-0.047414397145733048,0.0027762441038286303,0.030268059356193769,0.14718296789670926,0.043111866833212033,-0.045242662159025837,-0.056666701926203059,0.011024035468495882,-0.037469678178404013,0.034539200168746578,-0.093469946147855573,-0.030232213433933387,0.092526075272763977,0.0033730560801506935,-0.074954887684573437,-0.056309553485681563,-0.12734695058277604],[-0.074008406292552564,0.059418218830081374,-0.16185533770248933,-0.095113775751815649,-0.054156530748324355,-0.09524659355343601,-0.027700374104369613,0.13095967694644639,-0.082898147730574467,0.043236330248349053,-0.073265765844677394,-0.010406688952704322,-0.17908099782642803,0.11214349559047893,0.011254398841125272,-0.07213174644946746,0.011242646811143842,-0.12960939072644068,0.01738837182774236,0.052081850613964469,-0.016141307058450453,-0.0031876314325390964,0.0604762980771201,0.12062873361043944,-0.11552428611131449,0.053112984787895695,-0.11175835774514202,-0.085344942760827144,-0.10341778301339327,-0.077512128518261517,0.022696330581442322,-0.061166227958907707,-0.02680129950339076,-0.013512513628398493,0.072871648911960699,0.21355653955799342,-0.06105176975794184,0.23221322645596984,-0.006049593164551087,-0.11934471718699403,-0.048734896641230797,-0.0037696701788163915,0.0015806523808981135,-0.059016242821538792,0.1691633875802479,-0.10636213299345615,0.013867670987275399,0.13029048317364064,0.17375284613983333,0.36096974973474127,0.072557346833875574,-0.050622427061095779,-0.061396795580056514,0.012028170399798491,-0.059738878843501417,-0.15920195495822725,0.073525564169076851,0.01066435580390359,-0.12349031715778719,-0.20862800209268534,-0.24386438086421988,0.22269546157582101,0.046982082135201012,-0.10969479870317536,0.046793880429372367,-0.067828443916568087,0.15296218972876791,-0.074195141988218055,0.042910924531490646,-0.0147654055974203,0.37959648332332935,0.41757874715387594,0.021898097003166472,-0.11237855306165129,-0.043153207830735951,-0.0018388342246165729,-0.065448802775457518,-0.010369032880327395,0.043814853347705546,-0.0090643466570875519,0.10571938625442225,-0.044969836340908724,-0.060017098930422549,-0.12351913057017941,0.072888367558094025,-0.073015583002772777,0.024488919824195432,-0.046994862580658568,0.0061025804809166778,0.032988941004012923,-0.05586087652942285,0.033548851659122456,-0.10250477896692914,-0.085369660888008486,-0.091447097764426569,-0.071752973305231893,0.0060015981451380443,0.0048780288701872482,0.091777742044399785,-0.063911243276619789,-0.10839434894029129,0.14049866674905956,-0.16291269836434877,0.049227460809667313,-0.053956655700712897,-0.025757221007218452,-0.059498509327258808,0.029021784211283319,0.037106210375188055,-0.043182242815119842,0.0044685625872698392,0.037890914860866522,-0.12462488658167202,-0.015315868709315207,-0.099421564094155007,-0.057912073130086672,-0.070463075067971545,-0.069349456777686752,0.036224904169083069,-0.0096669174590530253,0.0072113489889556875],[0.00054000377819494582,0.019228224673755647,-0.0041211476935454003,0.010351942594428495,0.0060644135516636222,0.030583158266134808,0.018242859270646162,-0.011484714916580121,-0.012453527735116602,-0.013982904116162584,-0.073494945256138519,0.00061003908987491105,-0.035456925731861377,0.0091981481987587037,-0.0079306422406691113,-0.031346516850493486,0.056360544230430694,0.022269255182565641,0.02097553828852184,0.021592667245958069,0.022292447571617122,-0.036376354666677192,-0.004893428694286564,0.018803611912471426,0.021642092128736024,0.022979352605310751,0.057278991872406218,-0.062846882957114797,0.0080146423492344007,0.001741066749290629,0.023316260549374829,-0.0019692454830054218,-0.0097663509133344983,0.026552602939686681,0.019311702846604575,-0.040478949128969023,0.042963456569752451,-0.0055572047143666106,0.040028541338850074,0.039092247288585756,-0.014760769957556222,0.039287083950504967,-0.028685719461485404,-0.013542811096967075,0.042796941924027478,0.0093264852956811625,0.071104573120828796,-0.012855025544723991,0.0048120974901788259,-0.019345118328359015,-0.0068647366946253605,0.060026504369553271,-0.051710217047649373,-0.0088037835413147456,0.0085936562322940259,0.011216837793947578,0.0043659955128466099,-0.052365485216350149,0.018585701567693985,-0.043301048775860274,0.017257179405366647,0.033163069502218985,-0.063371870872828223,0.022236310454164437,-0.010282665078434856,-0.029097248102949336,-0.072928557864272242,-0.0065263865825004024,0.021707948805501379,-0.012869723919694227,-0.036092446130363755,0.049588404031142494,0.0037685978390409776,-0.0354492999119638,-0.0174997172625617,0.0017064827547835885,0.027702634451048022,0.010552265815024279,-0.015110098334354602,0.010755306598934415,-0.042384518316625354,0.055155751834777625,-0.046341678141637581,-0.025334054233096058,-0.031804391467191218,0.0074468314164195526,0.014822972242049056,-0.04150177712089112,0.055659760596936877,-0.015163449841913621,-0.033479207943135934,-0.038074300748303883,0.018025384518394062,-0.042187806169951603,-0.068458630665157463,0.03254289254551393,-0.043000247054897869,-0.017041867015704329,0.031343919493743794,-0.079988199511458247,0.016715851151657413,0.032905055715790735,0.070750458478696737,-0.02652191057953172,0.0097948892817532884,-0.008359095601141911,-0.022132176548511583,-0.010266695795141155,0.027387007127093858,-0.019456613274216179,0.047471229897352391,0.0064639452494934177,-0.036820611388149953,-0.014924071652059345,-0.048381451190304049,-0.035401457202280787,-0.0011683979389548946,-0.054012963892719104,0.079190962502102447,-0.046040607646046963,0.010260604991224952],[-0.0001569077120156144,-0.00010972965005487043,8.6821335664521299e-05,0.00028959182937081038,0.00013336820101180619,-0.00020448462499146614,0.0004636545850201651,-0.0001952429751545387,0.00033248408073506541,0.00026250426925845949,-9.9022792602876386e-05,0.00023043331960011237,0.00033250215597799282,0.00015431271343276792,-0.00017517735947227692,0.00017580915476165387,-2.7857926473168204e-05,0.00010573427076637082,-0.00016548039725969299,-0.00010017127208199195,-9.3138582793007851e-05,7.6297189543994559e-05,8.4224838605342217e-05,-9.3286798510637536e-05,-0.00028719968349017605,0.00021350040915488894,-0.0003150556862943979,0.00045188552513562852,-0.0005495709535034074,0.00054579146755674018,4.2926655116619361e-05,0.00052308254239302049,-0.00068598038313558152,0.00018154537313607583,-0.00019968317282380993,0.00023651893221749917,8.5020480110765267e-06,0.0004909646746514007,-0.00041196038371525689,0.00037236304958472577,-0.00014792807116663712,-0.00020787769585125376,-0.00031631921796769491,0.0003509716053853168,-0.00053024827751745746,0.00019205484079722751,-0.00035924357541414903,-0.00014479534658806692,-8.220562624946387e-05,-0.00026762194550129792,-0.00032865721811569347,-0.00013872646247882828,0.00019337977765215147,-2.8930782715007319e-05,-0.00021530682683792296,0.00050075583422803938,1.2869664429884797e-05,0.0002877888733890388,2.1516688855943711e-05,-0.0003850355075187134,0.00026923989061119341,0.00020120455885001831,7.1269908071457111e-05,0.00025510516920475984,-0.0005497530710414731,7.0801300207756768e-05,-0.00031443494990798099,7.2727814539388924e-05,-6.7647317771771243e-05,-0.000105969532620806,0.0002042525509826365,-2.2660407178250186e-05,-0.00046405924788414654,0.00029312274831753277,-0.00057910649202903841,0.00046348258977586126,-0.00018921419605052309,-6.8310692835912151e-05,-0.00011583420771371644,0.00024261083736967087,-0.00013788873457702688,0.0004658190984066779,-0.00037781566966009483,0.00087162452307387728,-0.0006364250227483409,0.00019146350082690361,-0.00030213932128696913,0.0001548061422106152,0.000359478662719067,0.00034064528670862265,-0.00013396590679365383,0.0006282001548930799,-0.00026281686425658202,0.00062900456753615941,-0.00083565053741081752,0.00055501251620770908,-0.00039221531463511788,3.0416452512397468e-05,-0.00021895611944867249,-0.00025050813688963502,7.579225944163992e-05,0.00032480822488636235,-0.00028410221135238486,5.0197060845594277e-05,-7.6049710996853315e-05,0.00029722546826794691,-0.00059771003008261131,4.8137549730292717e-05,-0.0001438309620388073,0.00046738458634185825,-0.00043149354775268156,-2.2304724232195816e-05,-0.00053506357248750067,-0.00011828488032837592,-0.00021777877913900512,-0.00010840223620667971,-0.0008066009231476462,0.00028972319720168074,-0.00013991311235211912,0.00043597630491348099,-0.00043607463640516625],[0.00079929115048048283,-3.0120444183670547e-05,-9.6683286293641757e-07,0.00086494515998912502,0.00050305294849800619,-3.4861905346544875e-05,0.00042196435679157235,0.00065681743351262561,0.00012927605196788594,-0.00026826496297133184,0.00070485728728817559,-0.00045054232451688381,0.00062841852757652972,0.00021810609410295723,-0.00022766549944826936,-0.00057437187197429546,0.00016670399815210679,-0.00045504871054576762,-0.00051896406488366464,0.00016278501839328552,0.00078467988668153021,-0.00020117424541528373,0.0008133233405210466,-0.00054661334706784803,-4.6455199192108054e-05,0.00039251101344009443,0.00089045431724624202,0.00044803263329346033,0.00067252439816681275,0.00034323953360750059,2.970582797436061e-05,-0.00033407540980814887,0.00020838216438882895,-0.0014686441499898312,0.0013210643314603837,0.00036229797084270932,-0.00042100922626168297,-0.0010662328062863852,-0.00047868856534150767,-0.0011025209542825376,-0.00011142308623937613,0.0003605454081693979,0.00080536848328376098,-0.0010504288820343197,0.0012459778440163868,-0.0012889417769073701,-0.00010349556762601422,-0.00032598744524173912,0.0008195978542099927,-0.00032869537508760371,0.00078427904311249158,-0.00031027891242364769,-0.00013199686164484803,-0.0012037863711194877,0.00056966626743207988,-0.0015831212285748082,0.0012383789939280389,-0.00020329286471698974,0.00054441517775214582,-0.00047971421799346964,0.00036398024475242652,3.0135996240618357e-06,0.00034630267917200308,-0.00016208082819759925,0.00076531009349528958,-0.0004374341893310929,0.00035576070800035636,-0.00024010306236346007,0.00021524875497277648,-0.00065504769214781017,0.00036034608435831644,-0.00028137429763217675,-0.00014369965739139887,-0.00019791219870676433,-0.00050361569379568649,0.00056144872177278649,-0.00023162087151370331,-0.0004190557849820635,-4.5824271728219651e-05,-7.5822332618488003e-05,0.00080031407570023763,0.00055839973489382397,2.2265876928228429e-05,0.00089772546330477848,-9.8580631232442206e-05,0.0011729728289751398,-0.00052769578439227499,-0.00056096133489415972,0.00010460229482414998,0.00047497799203599991,0.00073708806200396479,-5.6914197126341215e-05,-0.00031024215768372942,0.00087524112410012483,-0.00044804418685771147,0.00049555628484605416,-0.00070264579048571682,0.00085455641871353544,0.00012341905578699096,-0.00093546710283165697,0.00037822251053991601,-0.00032902309441029502,0.00056646914676724593,0.00025216417640113158,-0.00037243077631573997,0.00061576720559803309,-0.00048527538553305369,0.00051397678370687996,-0.00076368821209107408,-0.0002717643717346516,-0.00036517822732572668,-0.0012782404754204373,-0.00037035199188238405,-0.0012045089669873877,-0.00051115856617512181,-0.00047596944593941704,-0.00072161260682115057,-0.00037669329780016733,-0.00075398515762274687,0.00013432829456021169,-0.00059059014732752192],[-0.00025150140763611817,0.00020005435484797551,0.00019417083739569404,-5.7923010958152443e-05,0.00055863820768581925,-0.00029404960975239897,0.00046418988043501249,0.00016919725054860514,-0.0001365681365060609,0.00014340737825123363,-2.7245579659461233e-05,-0.00017462744794458128,0.0004320870347869557,-0.00024872373436234194,0.00033850066080495095,-0.00042824500087672388,0.00045274589383560021,-0.00033817558566411835,-0.00015836618254124374,0.00037188063032157683,4.0013223047928148e-05,0.00029638131479669633,-1.1757971572848584e-06,-0.0001744667552400006,0.0001268511029074151,-0.00025760998701211679,0.00047735971540077606,-0.00015834145077744249,0.00011916420387451162,0.00015943376359087678,9.3650022541307172e-05,0.00013240084078796482,2.5813088587590515e-05,7.7538776799327379e-06,-0.00041105076291241384,0.00045452204783612738,-4.040458358791927e-05,-0.00042518565093397536,2.9496406138524887e-05,0.00022369184176485946,-0.00022326384816004656,-5.9696847652630737e-05,9.5900199581322714e-05,-0.00021800428194160856,-6.6285576454976763e-05,0.0006383470103711519,-0.00035775911240443345,-0.00043585234193858034,0.00055520311419225742,-0.00046867848529014242,-0.00036668240995048861,0.00044104545236546815,-0.00016743491057120887,-0.00015286382598361098,-0.00042267651180960325,0.00017696200882469978,-0.00087954556419632575,0.00041465822593126441,0.00030450324586917162,6.846537634285204e-06,0.00021324027853833406,5.5444233738137332e-05,-0.00045538727717156589,0.00036257374232944806,5.8126129137410108e-05,0.00048701098444248843,-0.0010394561974651842,0.0011088516063339896,-0.00047446710387000549,-0.00021639705414199396,-0.00030264565453152321,-0.00031876669624713905,0.00018256793655110101,0.00022085306808071166,-0.00045708478654703222,-0.00016764562120866666,-0.00038680711837089563,0.00023465496957380009,-0.00089058592344853351,2.7029323083889965e-05,-0.00019392260432311614,0.00043159570786490569,0.0001466476034520035,0.00020276998330380014,-0.00016623775962797588,3.3772960168344411e-05,-6.9000858996467757e-06,0.0003173325151770612,0.00013183707157224346,-0.00026275451596236401,0.00030496779772497273,-0.00022988038412455076,-0.00034410662962488809,0.00033974096399670022,-9.4370346309838749e-05,0.00015929656150039573,0.0002208318439938517,0.00023298688340578377,0.00026684718412763758,-0.00042236166617067028,0.0010171866741304654,-0.00066560749024659172,0.00023102910516509278,-5.1105334736391728e-05,-0.00025247439169374941,0.00027604436336503557,-0.00017760551435710054,-0.00010325189793795159,8.8214957933602754e-05,-0.00022473324648105992,-9.1082737484730111e-05,-0.00032298641944957397,0.00049768435071036133,8.618913329085944e-05,-0.00027278781263277881,-0.00012650947795273654,-0.00052227277756379986,-5.2140779588955022e-05,-0.00031611240635322224,0.00017884485805307976,-0.00037941318770559661],[-0.17866885726802303,-0.01004627890548361,-0.042589675487805567,-0.065934664074428745,0.052273011858990394,0.03312160535571991,0.027950496866449639,0.034597017771390251,0.040653401856438627,-0.006028884452193628,0.012100171644170557,-0.005823115292745859,-0.07582851399159081,0.11466944513385099,0.020113986866166972,0.068302399730251775,0.053667514905722302,-0.0019151045898751218,0.0032161515425703988,-0.02286773204984241,-0.036064260364357094,0.0030444356366628143,0.0050268251131806128,-0.016159035960289652,0.01343428575788129,0.046278393980945166,-0.019863576518606291,0.033081554152618362,-0.011511204742527398,-0.02336066267834247,0.048030531271691712,0.072162863127648066,-0.034706965262833941,0.015742792044845896,-0.04365784041015932,0.052989886160218033,-0.00057782844346462858,0.053685241409785159,0.056409616043422858,0.031927074543435394,0.076208252276906155,0.035084748498761961,0.016016932367084777,0.097829252626441224,-0.010932961737962918,-0.057604724295680525,-0.046117493596561435,0.11586835368372229,0.016630360691506946,-0.072380612241233516,-0.02721078987250658,0.10400189079503686,-0.049863708111842611,0.013157090965211962,0.068758075593380402,-0.086093382914331593,0.10550940203644331,-0.051925636293921058,-0.08457695827736228,-0.023868518013074047,0.11534819907311766,-0.029927793894114596,-0.098805321065736557,0.08174885118680475,-0.1060908740185344,0.031317095721549532,-0.028082259348080146,0.079441855776121006,-0.093214174572659181,-0.069858116578834631,0.1070256004886421,-0.071547923438654293,0.064465129204212171,-0.099164651058250175,-0.013469569177392421,0.034352271480565931,-0.10594412155782011,-0.03578650235512626,-0.011063899652176858,0.01837774789897521,-0.039253607512632752,-0.14016878911229191,-0.03721312667737868,0.011543278654149135,0.0046564754198335154,-0.076081218695912403,0.021616522856597421,0.0056963747245355328,-0.054225456412860529,0.039976482103285263,-0.014191880258275905,-0.056038754162233653,-0.085955467898357049,0.022657092076657198,-0.0022047701913627767,0.0023519724649996229,-0.0086408360440515565,-0.064880638505246765,-0.0055523419967167011,0.079595981567899043,-0.011189689119441921,0.019694004932030575,-0.0090801628377648672,0.0030332790803103706,-0.11172688994501827,-0.037768645256787345,0.14407928948205997,0.0085417960067592294,0.051063118511239784,-0.013809133479955219,-0.018804152269311619,-0.07472568370647939,0.06221295634359636,-0.031173033698703514,0.023265775517157146,-0.013229707925293089,-0.088087391935272305,-0.16850726894231444,0.014989271963221966,-0.045790255154309852,0.038301569939229688],[-0.12471960559298051,0.016331688001818473,0.010132274081235342,0.0072416673905218165,-0.059929049564220245,0.014888737012368864,-0.052418796845186043,0.022430681494682764,-0.043701832681609432,0.021372011063678874,-0.066551867105933471,-0.076751551449093222,0.031454085069049939,0.00050698620363882289,0.048208537020902352,-0.043606360639726817,-0.026401547797884867,0.11494953428588206,-0.00084487993298972171,0.041763229275026299,0.01662088156180045,0.095743595922567412,0.016932325856871336,-0.031217493839729042,0.021554336392332216,-0.061228351827234268,0.081696206527506948,-0.055099500179900118,-0.095301583024627504,-0.031351972335037837,-0.035124606327755464,-0.028837124821496515,-0.047884715408835349,0.060702425126256093,0.080684564761646177,-0.039627899139767567,0.064709803419545964,0.013113165039676609,0.16301141390375001,0.12824898952567468,0.074636476814154057,-0.016897285990514471,0.010567173254586882,0.0033568218888065868,-0.041216089414404501,0.083780621282672774,0.10218950832276399,-0.048555074093876056,0.095493142695549343,-0.12104629625143107,-0.1493368753465891,-0.038946784830535597,0.053670879181312289,0.10886118501283593,0.0623983957252945,-0.064004861565808618,-0.0011642109155079912,-0.017989480311898197,0.10376420696530403,-0.021666202371688252,0.20636172793169102,0.067515676746473546,0.022594628822994373,-0.10875049523175929,-0.15367838830228961,-0.10156435275826153,-0.056219286606131964,0.0048935577385261636,0.080508839991384598,-0.048986994532721484,-0.054673573535446829,0.034417241571081683,0.13788724353627765,0.17933790589816131,0.22694206874489239,0.16714737286853379,0.28887901477932182,-0.0045505039085086373,0.12853746432697205,-0.14688209250590184,0.039803550389166095,0.001161697593967297,-0.19133864743440931,-0.11485627148408395,-0.040556116529253762,-0.07701433461570141,-0.064919136067342759,-0.17402303487112258,-0.069451907977663707,-0.17069839255636562,0.097553381246305429,-0.012417013824468703,0.008779997988951951,0.033808465522018064,-0.040323952860908119,-0.12350740477425591,-0.071103775036993527,-0.032842030960087386,-0.025256511130247631,-0.13557637802150552,0.13026525943758985,-0.098978661007624966,0.016539720299720638,-0.055393829003122938,-0.017477845213565581,0.082533142084316155,-0.0052692792534465727,0.023714959705274333,-0.025127637792893034,-0.054493603758074591,-0.0065251479532096798,-0.19551796620580655,0.00051533084431857473,-0.12469764291808262,-0.010402114917957516,-0.040854371970225421,-0.050091277739518963,0.0061714297831496267,-0.022234206683905616,0.02500462259196987,0.053771861975124485],[-0.06953146063004409,-0.027855167396772469,0.018198128969876097,0.015264256008671422,-0.021354522403683483,-0.060614589679217915,0.0074260205660308318,0.044909342578395892,-0.022290100457800159,-0.045038114215761482,-0.055530719421861996,0.0902442269939355,-0.0038080752412905372,0.0018190374684997207,-0.023994658931284905,0.022637227704013697,0.034385575661622605,-0.0041323426627789817,-0.015239537988315635,0.059722981968446186,0.0035446565552159082,0.10857055311904133,0.015827587897896331,0.0089878658118320159,0.021416627127059842,-0.026000364715464741,-0.072053616087858346,0.0067502383554667415,-0.043797404208141606,-0.086222116691012249,0.0012469216786467549,0.0139677771449414,-0.018800069260904509,0.091106469337856627,0.071482857933576227,0.053141334521401601,0.0091480821350588895,0.0032188812978254239,0.10531967232382244,0.013069231097604272,0.11321624512420622,0.024085428042357526,0.10571237447906545,0.097249430799325298,-0.040356773391022248,-0.052072201970584105,0.0094838487447085687,0.023224654347251975,0.048982273381055874,-0.077047377168934061,-0.016369059725570845,-0.0483990050185562,-0.017518918630372055,-0.048725264078332518,-0.090695565054201857,0.14584898982636468,0.020202497107516055,0.052473273376908665,-0.0059210182550390594,0.0022813027410172881,0.011431314884242511,0.098601714425802095,0.035390606662766999,0.11802445684529828,0.014488333933066366,0.14985625484032264,-0.083365081182869311,0.02604166398390495,0.057536223475310372,0.10289686959448127,0.13376253308792016,0.098599279015396224,0.11296262694625853,0.066811519947584497,-0.030392332219791651,0.037677148170599001,-0.080465409013379868,-0.013433044614551137,-0.079050272382343106,-0.086927785491348469,-0.13723308506024745,-0.16180861780403702,-0.1559436708245299,-0.15633705073107523,-0.15765816424278123,-0.019054153693685204,-0.066428041346772757,-0.040315394300378581,-0.15529720969926392,0.12101901933989367,0.0073739433496777876,-0.039042313006326899,0.044864452505471414,-0.031074257750175131,-0.037869139729967256,0.02693566917864209,-0.025703296599595565,0.030655452436583908,-0.0083294916392306975,0.030463719734315588,-0.016822379770469454,0.010025642600714306,0.023941947007600384,0.0037369192163097253,-0.0062061382772640519,0.040478298614511805,0.015199733590990229,0.035362093609806654,0.035113913555059863,-0.10029441782907185,-0.10610472749034416,-0.052099942445672578,-0.0037985170316418085,0.029290155294759784,0.020763196785263893,0.037574297260543371,0.050568193891647441,0.0025948365095440178,-0.034033364904604929,-0.031897318483976964,-0.072552877764797324],[-0.074150761326980147,-0.00066986401946685092,-0.038515158134214342,-0.023181050413543618,-0.032101285996002565,-0.016813865511960804,-0.043281469336209986,-0.034096544273423686,0.01015713603552236,0.030027201044358451,-0.13569617378270427,0.05532035184255174,0.041422683304832522,0.054237693471711729,0.075158352517811028,-0.0045611635231176673,0.0049336835448356223,-0.027804205731258878,0.037859313146976444,-0.010636484133250523,0.043039074634147079,-0.031109281470661186,-0.026842848775607248,-0.03367029747858763,0.0053081926498119852,-0.039719826466191911,-0.011433401479806288,0.0018726799542050226,-0.030624975101159628,-0.0029380651582422979,-0.0095989319691330288,-0.013587888941593039,-0.0090228406954841085,0.013981082758308103,-0.027132225331696645,-0.066722260341411405,0.029996307562002861,0.10810874336228038,0.073932536945285954,0.094596891288321466,0.021326989785555719,0.0051895327288904308,0.090625514956272496,-0.0014967572066416635,0.095691596028677217,0.071032806785292307,0.093121494030091692,0.086410233422467064,-0.082911827913294739,-0.063317188738201691,0.058040828225321459,0.094123280130627499,0.048289462433899338,0.0065600637976757845,-0.017978915242308827,-0.10529465762835961,-0.099505376903884918,-0.11641428549809074,-0.16336914552196619,-0.03066309873006054,0.037327302518737379,0.021715752289796372,-0.036984427993582598,0.10584212495392706,-0.038900837284283257,0.042388662040559938,0.15761090374525039,0.14948261048000774,0.15123269083375968,0.26082790242726567,0.24549601207125132,0.20845042919094864,0.014092314529055919,-0.081544305437015088,-0.12046457900197742,0.19946559288633667,-0.12279301434870472,0.043147465336577269,-0.0039359433149267903,0.041944507737883142,-0.14662824409559153,-0.16841554816441323,-0.21746364722425923,-0.14593598626028459,0.12453643290997443,-0.018239200160202453,-0.09647557951641697,0.096744958348161519,-0.16116049604787364,-0.10959035389321688,-0.18407080190584757,0.028717350720618054,0.017940145844063823,0.067712609426401407,0.070426899449170036,-0.11002871292121127,0.093083619307167409,0.015479935983498054,-0.15557089262678336,-0.014144367587187956,0.032512137754861198,0.05556774883075101,-0.017472918751953406,-0.029533628631708192,-0.038827731306693092,-0.03021232345401817,0.045497082764698535,-0.15437986410128418,0.13419753386333874,-0.20134066892161695,0.062249155617802823,0.024284286780838271,-0.036965190357203068,0.004665449800701868,0.019888261193014966,-0.083467980409420606,-0.016566558945081397,-0.083160175930132627,0.0045192184141086209,-0.15565975294086548,-0.091842377438527273],[-0.066489372545755529,-0.047718799252733826,-0.09410351655788475,-0.013599740258147358,-0.045530705171441511,-0.085061538345857085,-0.063093532506485611,-0.053820778098933868,-0.1222176787662156,0.047517892917907548,-0.10543817119017407,-0.12135417994296471,0.020628638474339593,0.038231355833956926,-0.043392365131814319,0.0044224749450447378,-0.038085077795412883,-0.079830174085868372,-0.028985978187303432,-0.065505748977689585,-0.088402519021417422,0.0075685626418508772,0.014599611957773671,-0.0022052017437265842,0.018238800652908803,0.066199495089427851,0.014132567520511584,-0.018584781288268692,0.0097275167736109152,-0.013372741092406291,-0.13951730470879722,-0.099454439128528874,0.0024536802212185172,0.023325717552923071,0.052273179874949491,-0.0078433789568586876,-0.019449100540297075,-0.03793640930232544,0.006026659571149097,0.040309888608414196,0.06132376182771021,0.12961234902069763,-0.05246356331115444,-0.092316625226469162,0.12501372859645493,-0.023511024540922139,0.068699855508214253,0.081178430452994624,0.081636331620792119,0.13284552600960509,0.11443480169918706,0.031137356793659591,0.03957361525706285,0.064206693867907672,-0.026585623441445331,-0.069602244432452998,-0.006882701260322803,-0.086642203201899415,-0.12201442995127351,-0.087602601453127441,-0.097081289635905094,-0.14353417247406297,-0.032404092368745641,0.016664803245589305,-0.028877650787150662,0.046660756524674038,0.1676934927534405,0.081856698021962743,0.1329811871153378,0.15796978913910928,0.15420647629486711,0.23507941566445101,0.10845077567152385,-0.02663613626038222,0.10225924257045012,0.074815640105395723,-0.067484345697152587,0.014558971240431304,-0.031796943969915691,-0.060628238131727054,-0.091575240277000952,-0.021836966217199869,-0.1828633961798013,0.094501673222211161,0.013464938214634688,0.017062888577847678,0.047282001792194439,0.10222149429615252,0.0032626808542848551,0.014576952315965966,0.053700266574035892,0.04846835624654347,0.0033060862248684986,0.10214575008785104,-0.077242394031282607,0.018934507344396237,0.00098413451682097947,0.047211817912021947,-0.042523626918625143,-0.059478892430034694,-0.043645446723720886,0.0072259828467460575,-0.045364397904695007,0.0015257865026378006,0.033942020440189763,-0.062868543989156617,-0.011162136740504053,-0.026181503928468051,0.11832542908426394,-0.11894486304453102,0.0030266795551997794,-0.019806603799353117,-0.020184767444436195,-0.0019914632003974475,-0.028348567852824622,-0.051936208080729802,-0.114547660653914,0.016934758716036884,-0.037824591697152236,-0.01375883701059563,-0.14176618903476443],[-0.12379363868138007,-0.022793163596252192,-0.056572016200135848,-0.039201119991114218,-0.014505658462787643,-0.14164430469555672,-0.066772525835277804,-0.01689199875955201,0.018395341706225341,-0.060257373814153137,-0.11708273412158036,-0.16991897990888952,0.02268184312792898,-0.037431787558444535,0.0278362850257034,-0.10391555593395135,-0.024895792104006661,-0.10240649559419762,0.027892065133358145,0.037030240290622553,0.025269076865704919,-0.18054736103209962,-0.13783839666730963,0.03215416365047865,0.10446321758795965,0.042116319344015371,0.0035951247503783063,0.065346577329699312,0.022452948281901614,-0.0013754778263451381,-0.030524202281055096,0.030663561315706717,-0.09877455975225044,0.21124607085784919,0.031922562444243588,-0.034705389173491433,0.036621988513888717,-0.010853119077650658,-0.0073890345339706932,0.0056782910255717134,0.029566782664102689,0.096433520675437784,0.029157767155665329,0.29856892064118878,-0.07919582633844692,0.00025703866042990631,0.030975751575185936,-0.077561027711158165,0.10470636569751657,0.1428460407644222,0.099401781103168885,-0.040836585779750967,-0.11174053722087644,-0.067308311411080401,-0.18341503352838884,0.13979526699252226,-0.041934973700445265,-0.092866471596007444,0.019653227675469925,-0.090390148741556695,-0.20734375167567454,-0.072877904472334984,0.0027432574380281405,0.0061245885209975925,0.094598126228364096,0.15505695773274958,0.041295097014746554,0.006098921880011085,0.20246902024512597,0.18772782665817625,0.14967157503073222,0.29059802382753935,0.18823387968962019,0.15999395370095998,0.11915607104783087,0.056017723784593507,-0.02792887117414139,0.056676427194019247,0.014381577347003349,-0.043592335358605627,-0.10690022762213068,-0.06224823853094813,-0.17877352623373868,-0.092288169841172746,-0.18022508861455536,-0.061398773420600558,0.0666828177706692,0.095796826575196115,-0.075610336916687143,0.033484310787615143,0.0090710017296596057,0.0023841350072704715,0.012849690649430291,0.0037371676082230965,0.056507739912754651,0.071820826637994356,0.074186721529350602,-0.027905258130710861,-0.084135488182671275,0.10542017164154836,0.028027285290237042,0.065445007475626482,0.064161641086581678,0.03294077475246366,0.0054020657546699907,0.035715241209970591,0.0077120039679083111,-0.035145762312081205,0.095730503021840191,0.068293341444558953,-0.1743073123711078,-0.053416372888697425,-0.043073098090359502,-0.075042084240128315,-0.0026001415644313353,-0.026744723242628617,-0.014014546902059697,-0.037147009442388884,-0.029554069220702237,-0.052552735398048014,-0.20455065610576798],[-0.080336718914324784,0.031542907328002801,-0.080333284552386419,-0.16579677604599055,-0.012897402202476056,-0.10178589629685617,-0.017890795871391321,-0.047932174101883621,-0.069572714289158219,-0.013085371055274415,-0.06403048933442046,-0.04738918650528029,-0.048253300258942214,0.010624097533814846,-0.088303853599706453,-0.024800418220789627,-0.017016233501825004,-0.0731122923145789,0.01795798282892851,0.020031779934763197,0.026270539591568495,-0.10026542176987073,-0.055354197675606544,-0.019202819676109054,-0.17886561336922624,-0.047929449603121586,-0.015476611158838961,-0.036580931341111331,-0.0013977731542055873,-0.024379638918464477,-0.013239317850851168,-0.016219240360668748,0.033455910961528168,0.031281534097803848,-0.11781030984741167,0.08675961993407609,0.096838260201831047,0.0075779597881384594,0.04020793008597133,0.039796641743254979,-0.007964327106749873,0.057675226481024938,0.065973169052705491,0.076368677904105231,-0.094338220047695015,0.027581810662796059,0.17673036090517169,0.0080281795881781692,0.079733536301333036,0.14711146045229179,0.066918272520925415,0.050334009299972608,0.001155762195899003,0.013615235385982936,0.0030149122423125882,-0.0015609840824338042,0.13349258506848927,-0.080526523771321704,0.050306757732385049,-0.13744070442042641,-0.073796305193363679,-0.031880400975331472,-0.057867003215660712,-0.065217491770658081,-0.066794148181761118,-0.088250637948153923,0.0096844572434620149,-0.042763801342421685,0.094637934686230163,-0.066201626509630768,0.13555077154373779,0.15162691406173393,0.11508260905995207,0.091265965106029301,0.14083962832741773,0.12798665154188912,0.2063621060271425,0.028581014482874013,0.14481738942061018,-0.064493408628708213,0.14635053020889283,-0.03932501773954096,-0.049277809721883913,-0.080228288656955471,0.016307833788669575,-0.064651428896592297,-0.0779270812226531,-0.029574158180475041,-0.024416232437453507,-0.13305347995208761,0.13699379135763934,-0.022414216362762814,-0.005868709852490793,0.0049991943700797639,0.070540277709872645,-0.0003799065544888118,-0.011858514238347152,0.094750691888543861,0.032188664060007421,-0.084874702797453586,0.14236331721498632,-0.035524545957734237,-0.025841070343849228,-0.0789528097144718,0.048317846092030999,-0.082026719163858675,0.043364294508417431,0.0027045844775661172,-0.027920654078814632,-0.071950926204345095,-0.099679715705843941,-0.1207171044051677,0.027685856470463906,-0.065396577120716684,0.041932056613189474,-0.063470441933357852,0.015317705347783588,-0.088954618003619201,-0.0024258796088682186,-0.055981681173908476,0.02502279163090345],[-0.16063469325056712,-0.05067950894114695,-0.017602698377438247,-0.0024719881205989246,0.025626936786392211,0.0064474558094759424,0.040905232267662323,-0.019412107970519368,0.010907705003810574,-0.05700007695501437,-0.16989061568410888,-0.047847975558597475,0.045770960450897138,0.036605131005038968,-0.034700480386556126,-0.038814165043767439,0.059925472084798384,-0.045041592097425781,0.0044791344272125319,0.010085652451881422,0.017232862062283152,-0.014699311623237801,-0.031158529886819011,0.054785786247363535,-0.045018671355357719,0.027938316028020466,-0.050947638456247675,-0.058027574321254612,-0.018142649252876362,-0.073467281992698821,0.029761358083885719,0.020105401337809463,-0.03083009871677686,0.0089384529359374659,0.0094917883425194721,0.031257493638173192,-0.074324621899297436,0.047502293228496903,-0.087202881668554666,0.019497480457585127,0.018801723895544558,-0.020783146883739074,0.037407226253197187,0.01202907895240941,-0.085640174497543325,-0.01250123023712826,-0.027083881602897025,0.012926155302517221,-0.020812027426987748,-0.14055809283539628,-0.11374506591076419,0.017924843458942127,-0.028516516145943489,0.04585868851160263,-0.13117828388950331,-0.17389092870879497,0.053714156567446165,0.032300075701893374,0.057520195145752226,0.05904654140586256,-0.11508635724303731,0.043565776393052071,0.059536594262724729,0.076599133764207433,0.014207229570090983,-0.1199427514262921,0.0034830414572159379,0.08308252095344841,0.068672949782330364,0.06634459181806078,0.084012567514670983,0.10863093494536288,0.036021688136296692,0.12380137951173706,0.043236576328048351,0.059399643665654131,0.042445309474632237,0.12789338744678247,0.014244324437140979,0.067136246650945752,0.086699105492600792,0.059557262090246026,0.01809855186232609,0.010713420148594992,-0.00059579884010052542,0.061343460083962291,-0.0001398559588360257,0.22412677713663717,0.088013675847793266,-0.058215067302030736,-0.0012260538656294895,0.042305970671931085,0.052067344797856172,0.075414674705730864,0.077471176915617654,0.045711382613932913,0.017695427073964477,-0.0030658636257887804,-0.02962365327526081,0.12896765936351437,0.042183866960819091,-0.039394998979108344,-0.041007428922027155,-0.13390483965174424,-0.042499818684505593,-0.05819462525466032,-0.09519971864692886,-0.049990903182070265,-0.035359428820787173,0.15859976300873996,-0.11702120905543276,0.022050407195940078,0.048192823572219948,-0.0056565047319631634,0.055321599542422356,0.0039771126512435362,0.0088791472452440304,0.03097294566737252,0.036136614851221327,0.077636657455759733,-0.11747304066916951],[0.0032106468813388467,0.088885172720810104,0.10096080668798724,0.022292605842750123,-0.071525453247951051,0.00574314306889687,0.065381001294423258,0.008264090951624635,-0.052297923633555253,0.055063249156703478,0.042135956165554989,-0.0027337283351114711,0.061070962060578285,-0.10701158010008113,-0.055827956173158652,-0.065032694832464877,-0.011795338702579206,-0.16486859585693212,0.021281059707202635,0.011339055054131499,0.015607579889776426,-0.085750449282884861,0.0043087122389073168,-0.0028333671241141632,-0.075704651954975333,-0.095023634532319393,-0.024443325177031752,-0.0048742931725701613,0.05373563149718516,-0.046164464204305776,-0.0933941298749114,-0.089491902135308304,-0.070094066124814669,-0.034764911995005567,-0.11036613659441624,-0.041699289757935284,0.048555414105324039,0.037316594330165868,-0.0091258495682343954,-0.02483773607684505,-0.10811625353969287,-0.011196019395676729,0.062000571065406324,-0.030908870870323263,-0.20817374216641296,0.02840804114908593,-0.03422871356001763,0.015547093956459614,0.042037769469384534,0.14900049504903043,-0.077828081337516036,0.33343667124234072,0.36268347456674099,0.18381088902743745,0.18801989730141397,-0.026760107917241149,0.0010510016353630809,0.04098821271669377,0.14354810186479433,0.14720129753717756,-0.22198578529791352,0.31511902115816237,-0.097933631284173289,-0.34108764393991897,-0.17922303207403625,-0.075037516162488077,-0.060600402883750376,-0.019190950400804669,0.16686302854511445,-0.012989494224628011,-0.34656568745617206,0.14668241885677219,-0.053557529052454082,-0.24973215975275748,0.24117194525976043,0.06744086845556567,0.11113519003246129,-0.17424338350633975,0.12201079994643065,-0.092746950927085375,-0.065790817932440571,0.35855596322291078,0.22608246117392661,-0.11160227633029404,0.3057247528769656,-0.10906402198659501,-0.15714103185870401,0.068395565832379809,-0.040921771078119888,0.0013632455963754134,0.10794141319894564,0.11370966065944016,0.05701046666820303,-0.082634473203882411,0.046327777049956803,0.056396935402095699,0.020212301071998881,-0.029754364902733033,0.054466892130944161,-0.014207485080892181,0.09398894647188305,0.044572073845120443,-0.073566232664765058,-0.15318361570533576,-0.061212185339614172,0.026710531000834609,0.036455363958898757,0.13879792308934241,0.23979908542525458,0.11099690466514582,-0.12734356041026987,-0.070921107619058815,-0.084031488042458663,-0.052911204994505273,0.0080270279483869375,-0.048337382618909748,-0.040315087393064393,-0.089109265448894498,-0.10259547678103018,-0.091800365225332997,-0.21140522933050648],[-0.070541898294382954,0.055085384725324385,0.10152834971804957,0.023622039667971106,0.029955712367899665,-0.026059948581330213,0.11064289610687274,0.024489022629065639,0.021970470387027496,0.020456590772125735,-0.041116693610535521,-0.024812216615053395,0.0095703813283907063,-0.048146399939075685,-0.0415428906870009,-0.0045487046086217439,-0.022900698211748033,-0.10095741160721779,-0.032652208533819588,0.037091125467489772,0.014636490326762966,-0.010920356400900416,-0.02620802388201364,-0.14214922225914331,-0.1328932262467217,-0.033250828448682102,0.0054751584145303622,0.091854391607495395,0.036012195904709637,-0.080267047096344496,-0.02961991599551142,0.026872737466068011,0.024976155299922739,-0.10102174245681092,0.10923707161980402,0.070655061966962251,-0.10935696983924399,-0.32088041870161305,-0.20436936980030787,0.050938666453356984,0.046305961616782271,-0.052624691159288021,-0.10829047665507778,0.090882846941261863,0.19174066515666341,0.12934192659574403,0.11859841393368513,0.26210791199518413,0.43760372512053292,-0.073859947159134118,-0.076583679569516755,0.10680813952910222,-0.089974391000751788,-0.061555396291372189,-0.092350841658524696,0.024140264345503374,0.029438378546550566,-0.01563817377224519,-0.149531624982499,-0.10876112523177132,0.19097881484789375,-0.049896292556932682,-0.16239346086432074,0.046709908191980121,-0.033452494674046207,0.0046310617213296502,0.0064216883730265698,-0.12476862042997607,-0.031313709978211708,0.0042103020860465371,-0.025365848313462613,0.063684281624447031,0.13395358129694848,-0.065578135598012649,0.057463929084066473,0.17256882128548656,-0.11823900246670159,0.060333559941145434,0.0037599080210207157,-0.038200462163356909,0.066276004488180856,0.25634069005457549,-0.093935031031732064,0.13649945906964844,0.0034794918389711334,-0.072761719812314288,0.029458016256965223,-0.015677874033259744,0.19131561225163415,-0.12071257308516789,-0.049397234429007029,0.077175842050914406,-0.030486255311673066,0.049783169498945609,-0.057532752863027073,0.14083206176111882,0.17408755180270033,0.009344634962950172,-0.12819205088510488,0.097921797602201988,0.1484657616745283,0.21719783447349841,0.044315601741240343,0.11561949899769568,0.079276552023405805,-0.12048788468641375,-0.04967266400627008,-0.032827416046744835,0.0090015538375795498,-0.13278686515158378,-0.20143225012684127,-0.012865208501911994,-0.05226303626701382,-0.05920262987618654,-0.11792756657567573,-0.18198524247067943,-0.00074838377765898412,-0.13713941392620788,-0.061325425375407194,0.019950339910709103,-0.062147365713498569],[0.051024887449384534,-0.019223957182048931,-0.0091744618546339037,-0.022468174999506808,0.021117503507854546,-0.017503811543560385,-0.22284744975320528,0.022524903374325514,-0.0024244960757924712,-0.09669110978372604,-0.025360870037480849,0.073434608083223593,0.15108583605808631,0.11522226443939282,0.12970385672228196,-0.078929081412293864,0.097198425724444398,0.21130504158510516,-0.24960514180766633,-0.011817596006589312,0.064527752619131462,-0.085347869009334901,0.049274344563864814,-0.061577460717206725,0.063000636986332417,-0.043023349305368858,0.069051463619963616,-0.09609209741271528,-0.061694173137081795,0.18034406030249844,-0.16664450863414379,-0.051093562238691319,0.06917571184956009,-0.11903894138190432,-0.085789849163004972,-0.20469477506639042,-0.037005982899997764,0.034798731541538161,0.063283307686923376,0.14789727159527061,-0.066932830661805331,0.1370086179892735,0.0071805490139787067,-0.062055289428567216,0.22475761134030817,-0.07322221407641237,-0.080357922936194939,-0.11455643304613655,0.20483233186130478,0.10475578834704286,0.10684387147188838,-0.10691746278338331,0.018058380084354078,0.12868991682224998,-0.071026767781369002,0.044129913597283861,0.12003274537827949,0.14236952685647059,0.2190537724998522,0.069722814432948976,-0.08245383109483935,-0.10618366730381419,0.079817401692356071,0.17121755891446927,0.11078325008253855,-0.15750058347569248,-0.026069272820390225,0.17501467279210839,0.19358075940702646,0.15583357970340797,0.1314463732378697,0.10802544440564531,-0.015809166657440241,-0.066108299277505417,-0.14852678093276445,-0.054744536677585956,-0.065217128725905391,-0.026931855854101287,0.017929035819714334,-0.025775341056924528,-0.12464418113700747,-0.13001928465651194,-0.23174171618582257,-0.066900407583412314,-0.03709918303218513,-0.030813190076789343,0.11264856069224632,-0.035279582432038409,-0.06628848394994874,-0.094885511316959062,-0.13366242376792553,-0.077209892711532127,-0.094368973509414381,0.053335878160273763,0.041074067958430979,-0.044715009215503601,0.14382963030480442,-0.054988125961259349,-0.0022013354694158885,0.021968655062323525,0.032943999375576301,-0.0067769203537865596,0.055702627244551682,0.051114355169129717,-0.0071487492413514087,-0.050493456857222105,0.11605609625221396,-0.10773904713211513,-0.017706549245958297,-0.029669410521942108,-0.16640935186157127,-0.048751600204259019,-0.074769821455474811,-0.066227226009553525,-0.10651310165824517,-0.00092592029991533063,-0.0045899177380518182,-0.041812504602206868,-0.029841850511205213,0.040029808070416978,-0.11834854906365051],[-0.14161129968710029,-0.061296967431052014,0.0081528021970500054,0.095805261150028409,-0.1214127956380826,-0.15258322744582525,0.14459270305794539,0.10275339944853681,-0.076911198841414979,0.010478075151826548,-0.064039029125021005,-0.084813043528063153,0.025051235358785943,0.087180794533482028,-0.20873218012341008,0.0040298784271375204,0.39082631888817743,-0.018288190749202606,-0.19371161443949322,0.21355438299293414,0.19218769418470427,0.051337448826137444,-0.099999229754227564,0.065604462250388712,-0.033196627957087541,0.077857375844632745,0.22272869520521954,-0.096601683736006277,-0.13244590058883512,0.22634536048380136,-0.023759721621360811,-0.16636289752872985,0.024375919555805453,0.01118486694572602,0.0090202885193231622,0.01738778004965464,-0.043080447051755857,-0.064752417676871371,-0.15373325493809581,0.1030300818297557,-0.086295964021762886,-0.18748306121414288,-0.083187547465909659,-0.03706603563440538,-0.091363337934458527,0.043056498585826733,-0.0076223164368175653,-0.072300257528729178,0.18949250084010411,0.091582898551156061,0.093209834464958313,0.078433318552627251,-0.086071434197630858,-0.16935758248124871,0.21392186250732342,-0.076880494683872147,0.1402483451766991,0.18838915415855717,0.1152888395062736,-0.16631002548138826,-0.13317013948622,-0.019452425619901188,0.013015089132922257,0.28543941281728724,0.23881984846112189,0.23929137572253439,-0.02547786873886692,0.0117330467833913,-0.031329573296911523,0.026405820579143084,0.17735025822121503,0.15386780686160581,0.02287846002087459,0.15423023351465021,0.10953014299545374,0.19864560710489487,-0.10957662520495322,0.004096363221989148,-0.0032426759955409418,-0.064959771096032265,0.0023590326963191174,-0.082443728464586391,-0.087192941443454491,0.0056234248083327464,-0.024093687385405751,-0.12474400395578267,-0.14738765659502367,-0.13843396166689709,-0.094736599019599688,0.043475674535487348,-0.022122242308695854,-0.05800862114062226,0.074104094697999404,0.02746811155866092,-0.068145973484399658,-0.086381198469412904,-0.072754777541353594,0.01615999106259601,-0.095064179193335305,-0.055944272676650919,0.024970060878891819,-0.092155618763515842,0.020485700004193069,-0.0495383796436729,0.062127427369453307,0.010981352953109556,0.0281069884335561,-0.023412794627361646,-0.011846497332482567,-0.041460283596954112,-0.12375563021141642,-0.007547760161504144,-0.035060694212351605,-0.054382050709510382,-0.1278750006993222,-0.06311331594403119,-0.0786704970157521,-0.0052472339656002079,-0.027462118424014734,-0.04814512084639927,-0.097095104463997481],[0.035455977436737243,0.012809942897525101,0.018180045357868893,-0.0038058205145671403,-0.047339142890578501,0.008615195889998109,-0.046294359253758216,0.016896391023979114,0.073402760628239458,0.057853718952836961,0.046801239911643658,0.017572755691014366,-0.023834114056900314,-0.028005108801406949,-0.06170353602256768,0.0041492518341007534,-0.099934491404056913,-0.074151439249343809,-0.097134157834440793,-0.050639923311780105,-0.051915740613493869,0.046339971767650957,-0.10129345971353371,-0.010697452082017556,-0.13071299055096386,0.065224314051882337,0.035157185372583166,0.078444236629937963,0.020870147580858485,-0.0830089239809709,-0.041877105840284014,-0.032513609221769081,-0.065938639791909268,-0.081371766652620733,-0.042073049920613614,0.11944084377042556,-0.19373361811893469,-0.14790789457158546,-0.091870520419793419,-0.021840321854902631,0.047335657392996534,0.060396938302831077,-0.07953507862322387,-0.04669220242777411,0.19614607438362058,0.15002481494362754,0.22469015540171652,0.4336980233057709,0.17626836068479479,0.085002991074548617,0.17628001447054742,-0.089798104842342991,-0.10576233006915464,-0.00490481488295888,-0.064591709504694866,-0.076503661467680131,-0.048692615426703015,-0.19597570662883559,-0.27569298690784427,0.26254751209472921,-0.056874362198840442,-0.10875561753818253,0.27052154823814067,0.2063604487272373,-0.0015736429213762324,-0.17758806144586672,-0.0015425548641356899,0.050842447030100948,0.092668112807239883,0.030409316616439044,-0.43178847946646337,0.36701605407304039,-0.059155527136146031,-0.34464726238122173,0.10848868139611262,0.10612621366138617,-0.049251160488806033,0.16014445150386469,-0.12372249481679706,-0.15509121511818685,0.10449868648330295,0.1609037713099512,-0.14487084764912184,0.43188545598260436,0.11981190997739517,-0.13832753618194632,0.011269255569863787,-0.081012227269308429,0.17513077192869736,-0.046057084014966006,0.033710883104789563,-0.01526891657845986,0.18262045149400891,-0.10024918536752747,-0.097021078480102316,0.066110972626649445,0.15775023905966529,0.10256401881259318,-0.065278008956546119,0.019464702453137826,0.18820857985638101,0.076080517225552272,0.20711454885952529,-0.009713325447248497,-0.067601022770299377,-0.045103764368489015,-0.047137892479800776,-0.043049664063698055,0.029932336717446141,0.0056790774310926523,-0.17630517422062925,-0.030884369614532808,-0.020628025119333808,-0.10197146214534561,-0.11425424743932233,-0.020673918969270674,-0.024767884264564922,-0.074424950506940507,-0.055048990658499254,-0.037227045102696574,-0.16215779511908984],[-0.07004854198277595,0.085300667599954416,0.0028140785761861914,0.010033301281905325,0.089867623592597673,0.052912807279738502,-0.050135511453302736,-0.022285839005171091,0.045302414609929523,-0.030119412353457265,0.021823370321703377,-0.0060856428833483836,0.023125728063449959,0.014528954043079753,-0.0015683794659443039,-0.027995624014821439,-0.16607590496950553,0.078730103754242331,0.036994242953970073,-0.016141830613884009,0.06880105102941908,-0.043417173628397525,0.038981169845932473,-0.066540457403796618,0.0031039127673838261,-0.013008774392859419,-0.092595121588066404,0.12644069271642389,0.040772818622368645,-0.085448406785026368,-0.13739227291848727,-0.13311138084893973,-0.11021206177568971,0.070762580804387104,0.08026074315831877,-0.16877857679840644,-0.05206002447695942,0.13425360508864773,-0.10535134533195308,-0.33737573498423878,-0.070808291113453367,0.057003657841298426,0.092279918372553824,-0.011615223103444766,-0.05091285023944582,-0.16069489160844241,-0.048847803217798323,0.071389129185656347,-0.043639202430883289,-0.13394293080575723,0.30515544278533629,0.23788255098353511,0.20977385697294298,0.12056019868772624,0.252825166497261,-0.0023561720800214826,-0.035137059913897026,0.049604725798679972,-0.10416358483192441,-0.14206356834350237,0.25291808177088004,-0.038235474676427975,-0.053226677896758709,-0.16540845786613148,-0.014617042590940904,0.02880120515663584,-0.10096787597225529,0.10737683950894401,0.12267043383933657,-0.058069637469088484,0.07352676227256455,0.010539954637614604,-0.051688256904700788,-0.072824552067626475,0.11389405098260616,-0.099763013941535167,-0.099681076524513995,-0.0083154924851436066,0.02878172341423068,-0.016643684462931133,-0.10306462657645374,0.17421739601581576,-0.012649043926851018,0.26025794182930068,0.13061127474097123,-0.13680683615114592,-0.055878226752606029,0.098670144436524707,-0.13970261425268571,0.029744590816758114,0.073907056540957833,0.1684324925668621,0.08906251617397061,-0.081254083870154856,0.0080562412391433046,0.15433309501581671,0.061774969198347712,-0.05038568057644794,0.19950920633649696,-0.095579333074787581,-0.078848113914305407,0.066656901533640664,-0.07772986657418926,-0.059687592569233103,-0.0023500722459320737,-0.0046282038086771929,0.075460714684052924,0.11777073451853808,0.24712980105754503,-0.021968024854625706,-0.093773910434377064,-0.011643488223564324,-0.055253337050732328,-0.067446244455495186,-0.097859711494188872,-0.067747061381834131,-0.11419175135531312,-0.15447612433882574,-0.053913847600707908,-0.072082530188140578,-0.10185711157346036],[-0.014135164933848525,-0.083516200530839357,0.025061773696956152,0.075977313837335109,-0.15437088222766421,-0.04240467277326615,-0.034524278854966582,0.1318746103998901,-0.018956619417625505,-0.0026675236384224726,0.10305833569336915,0.040329893324884791,-0.10561491356176617,0.017365472828129225,-0.1593697493161278,0.032279086189098444,0.10529509601866645,0.075027736842911114,-0.11928350111773782,0.10401492407708587,0.14421269322823677,0.0071286351316720287,-0.079992301428582629,0.014274946401273955,-0.038729777215095025,-0.13694960123251429,0.186445386861957,-0.065110687724615285,-0.14101483402071849,0.22619054701312596,-0.0019016328709244301,-0.049331211684928558,0.014047517480666363,-0.033852195689686469,-0.028526407496796823,0.086229830449351855,0.10755614463917934,-0.040378243554949227,0.040168336461144302,0.25442368338483701,-0.3499242547867164,-0.11829463044440175,-0.11321507805468442,-0.036040402153841591,0.0091418924051510815,0.015127629290737882,0.048542079162587376,-0.11506255204173602,0.081696307746731978,0.17250695232340318,0.15415826584650585,0.10510570127990954,-0.21704507894326638,-0.14596864247047642,0.1970892398119917,-0.12398828975192644,0.10066494813730779,0.12172147584675422,0.12480836369060534,-0.055987894617694878,-0.21828759073305709,0.080538081042609941,0.23046289660391583,0.31883071306960742,0.20521924642268785,0.0081842939400904868,-0.054334680492246989,-0.11191127753279448,-0.0056946625135289586,-0.04305552710584918,-0.040460404096243685,0.10030692443116394,-0.060036553045197671,0.14527330616853071,0.25790754371580937,0.16199120552860652,0.049309451989560361,0.0040739095783849238,0.11099001371044198,-0.020691143951251361,-0.11143944147535105,-0.081094875651466974,-0.11638633381884322,-0.038956249190972861,-0.1298485818109307,-0.22365399252260121,-0.0058588467993392259,-0.03608666892894484,-0.077144042211452088,-0.047407377167887781,0.027428548856661739,0.099597053423751136,0.040004259955310414,-0.073006673209536049,-0.017635812509909359,-0.07207223200520288,-0.0031645685054547332,-0.065567214011750335,-0.10478061295325353,0.009440525764280297,0.025831878010087357,-0.038820039872570433,0.027511569211728273,0.036751337723812103,0.040562322742325699,-0.0038665480911575581,0.012355677864371528,-0.053858176855473526,-0.00065956354595068066,-0.0026597994151184197,-0.11895782317212758,0.022143400716859319,-0.046808396987253115,-0.074910221874449304,0.018173403762517575,-0.066412768816517184,-0.03312873600388673,-0.12808543381027454,0.0050880558741760937,-0.088215241900397035,-0.11219840847108876],[-0.036364274597361676,0.056083891847620769,-0.054614528430129372,0.12841266882397054,0.034694915130257929,-0.099268838937359272,0.035218360577730458,0.0017050223771709963,-0.053720515111571325,-0.10469756632201047,-0.057793517872112406,-0.0079504586166561902,0.079079001374876626,0.17475876751746433,-0.073745536055607713,0.14078752799492825,0.17945289782476989,-0.028798495109090064,-0.053413953610016891,0.088642497593947489,0.0067588194601195459,-0.13125029810181102,0.03217045565830174,-0.07593804991299713,-0.045683415387781846,0.098321469102132006,-0.11054865427299748,-0.085251684099912406,0.19879712870261834,0.020722064313346493,0.022471477480525272,0.082375788173085274,-0.11575790465692171,0.032842645738555103,-0.083484194971592596,-0.077331550720375883,-0.11177282516936979,0.024984273273181961,-0.030403360600728728,-0.029024515371594548,-0.10371511880806172,0.011701378243922171,0.0093277747988130214,0.002431192271711265,0.15006757232014231,-0.21394797471762256,-0.11853920458017891,-0.0019533526563885917,0.18177937076706377,0.054954598440171316,0.1551092512502385,0.030060622456317722,-0.019865094069587117,0.070850991969667099,-0.00048596237286066242,0.17946399285467196,0.30638569966633139,0.14694241644943901,0.10067729378037348,-0.073081243699588155,-0.083394453453312839,-0.13131133309870838,0.02608780563916567,0.15390102230569283,0.14965704056352619,-0.12432072266765236,-0.055197512874001355,0.23539003120249477,0.23071437717412627,0.17815006433908051,0.032433010859872255,0.085250215236998952,0.10099385760580901,0.076038809649047315,-0.013731917856005003,0.0186901648513353,-0.032924756112736785,-0.22858777194216445,-0.12675914211780165,-0.11187142301820072,-0.12231050055181397,-0.022442794199238097,0.014664186213991334,-0.049708524052554312,-0.031971360150189108,-0.03211971771044804,0.044761469162405726,-0.048496783217227474,-0.035899743760748851,-0.059853454803789952,-0.046858773572646534,-0.054268508959597561,-0.025596949047592216,-0.059820464842134907,-0.029518961263161905,0.0036297431646178518,-0.020509064754665129,-0.0015230193399059302,-0.090002680596330681,-0.026575598812970537,-0.010828662191731439,-0.0095882629855936694,-0.0089047256965019833,0.0029521526762387035,0.003804200299764901,0.061865649665059336,0.033689817096841081,-0.066066128467731536,-0.02437191906735954,-0.034185476570230244,-0.10893624295233989,0.0071168280186506665,-0.09401277488927702,-0.018408076739696223,-0.057181782869844225,-0.026056248846387006,-0.088889605365135904,-0.10212222492182724,-0.043049828055051656,-0.085050747749882583,-0.026051110695555976]],'lbp':[[-0.027900321369488244,-0.0060441994553984916,-0.029117905545804415,-0.012327610537342652,0.061854476662081867,0.095671317895324293,0.045971729446465374,0.01553067346468753,-0.012023121825700329,-0.040293165022942272,-0.033221733066527162,-0.0035958268721606613,-0.013857406372198591,-0.034503775174297223,0.017543175352255434,0.036807902994090223,0.084770163856199093,0.060825220456424196,-0.0093584374782611293,-0.048192584791248279,-0.0065946784148823052,-0.030168034388727068,-0.007336172112964571,-0.049812230351494888,-0.028525647622325873,-0.0089851436778563571,0.037542932347811336,0.07584997109273485,0.040463627176522118,-0.0202219777393636,-0.010643448968773972,-0.025973324357000831,-0.029295410910686326,-0.049585573800075042,-0.016454172237658507,-0.013482276454755721,-0.034207328190167335,0.069169117093015112,0.043414738683023937,0.066514631750824477,-0.028013646641570675,-0.0028085168494333609,0.012846026283526629,-0.020229423320994658,0.026363734996447397,-0.02400313852588018,-0.071418628861473987,0.019799399074940063,0.047961802211596821,0.090395789173746133,0.054870436486652595,-0.015562181031975555,-0.0052396854064607895,-0.01338270347368932,-0.0017450580356042078,0.00097397016632680411,-0.034245488638524155,-0.029304216678874513,-0.015762970169531754,0.01232351078031502,0.11024357683264789,0.0052690576096130134,-0.0082710664495191447,0.029191444997078354,0.010481969078390848,0.0048675356582309672,-0.0043579148871963208,-0.025720306996157922,-0.06530772196855876,0.016283145128269706,0.042681321861108915,0.074985247321301865,0.016473247914334525,0.013771073119619424,0.0024092712098635191,0.02402373658667337,0.033110911546988531,-0.056874923774983661,-0.027797079980336641,-0.033810769624174404,0.015078596551516596,0.048209545205572732,0.11415003087810688,-0.0050453148806184067,-0.02453712965304819,-0.0046878076136616098,0.030698630375551105,0.036164393720748929,-0.017659727315601441,-0.02758989133869354,-0.023775739038709096,-0.0031653848755319783,0.043853892725709331,0.093522192523850758,-0.0015598570273860773,-0.019099238204545323,0.041500642827912271,-0.0029952551344066894,0.02004832980498979,-0.025805960318499716,-0.014023218349180466,-0.052045089337890343,-0.0089676761596982277,0.059688184012493893,0.082792114958395474,0.021692573098100312,-0.012200151839688603,-0.0040158722713318634,0.048254090507913572,0.0050565259058356522,-0.029779592751576791,-0.045801516188543855,-0.02221712686320438,-0.026806365466397059,0.08055750324533141,0.11124706386872835,0.024835176089393517,0.013030726244874311,0.026214268291071548,0.0092541421104222928,0.054743249486413466],[-8.7334058636959547e-05,3.7445117935188191e-05,-1.6718852112379556e-05,2.6449717430186009e-05,0.00026446237412404601,0.00018012006397465953,0.0001307947973358814,-8.9233727162704377e-05,8.7778261435746477e-05,-2.8629705583770731e-05,0.00019466262098214414,4.0175132952787601e-05,-2.4470034822768327e-05,-5.5302995306328803e-05,-9.4642365284064098e-05,0.00013992126181657828,0.00025974343567526995,0.00010836805931595294,-2.8508338861643612e-05,2.061224391589761e-06,-5.4546501619936929e-05,0.00011548126318818193,-0.0001788968780262537,1.0106236414454163e-06,-1.6477072134012073e-05,-5.4462479167990247e-05,4.6056613212522041e-05,0.00020886964911843303,-5.9860313621762362e-06,3.9146617021777741e-05,-0.00015653886989401913,-5.0893371838153789e-05,8.3828512715357351e-05,-3.9259965209559669e-05,2.9022913523094052e-06,-5.5656299347785557e-05,-3.9745247630351005e-05,8.2727825803138866e-05,0.00021615221821938771,0.00016964902161820464,-0.00015046509771197286,-3.9211986704516637e-05,-4.1804257750674423e-05,9.8942673641209088e-05,-3.7700357389545795e-05,-2.1777257226037079e-05,-0.00010841746095995551,-0.00011250296826445516,-2.8088672225879026e-05,0.00024500271057997097,0.00011698005994424145,0.00013699860971772872,-0.00011632402760545536,3.8758627518911681e-05,-5.0383597695171332e-05,-5.6491249769561463e-05,4.1858840099188652e-05,0.00010510216324040138,-9.5908590272430344e-05,-8.2666457891138537e-05,0.00014673240802820162,0.00017376564896403636,-6.6785749466828637e-05,7.6117972374779332e-05,-0.00016836279120163201,0.00012436785920524364,2.572483873684861e-05,-6.2337391140390188e-05,-0.00015376902099116518,-2.748263618047534e-05,-2.8455141653132252e-05,0.0001245843209365903,0.00015628289279003135,-2.4736989716003788e-05,-2.091205958625747e-05,4.3221191511700133e-05,-1.0154715937089193e-05,-9.9849401355839133e-05,0.00014166961818393338,-9.9758503461578121e-05,-5.3681414486151866e-05,2.4697228767074902e-05,1.8249672491638027e-05,0.00019364243897489978,-7.2708659052964433e-05,3.8335032297432542e-05,-1.941096106845841e-05,-3.2115893129546109e-05,5.1948009027611569e-05,-3.8286652867905793e-05,9.7189147669228537e-05,-0.00011816184055358711,-0.00016089510526324721,0.00011623698043458554,4.9146090188779967e-05,0.00010181714739832155,-1.4287799392848771e-05,4.3291869782970463e-05,-1.9967142031866378e-05,-1.7367657007066883e-05,-1.9582956908605959e-05,-3.2832817909847489e-05,-5.3813630280598324e-05,-5.6207569526993666e-05,-5.3241932910777154e-05,0.00024615067562027901,9.7553256739707516e-05,2.184380833295408e-05,3.0258380552987147e-05,-5.3699454869285401e-05,-2.5230762735903084e-05,-5.8324496095124025e-05,-4.7049519791985783e-05,3.6195180921022346e-05,-2.9440640435682286e-05,-6.9516912145691108e-05,0.00012456823815416661,-3.5053968305372846e-05,2.1986527300186251e-05,-1.5332062580714734e-05,-2.3047309958091743e-05],[-3.6084043411983239e-05,-1.9306572941766697e-05,6.6469627400028188e-05,-6.9626706859858556e-05,5.3717685606707692e-05,8.63369060391736e-05,8.2142164694962855e-05,-8.1711140914987948e-05,4.0205836428920672e-05,7.8479400685671497e-05,-4.9039572793939737e-05,5.7453551592964724e-05,-0.00010018086975340998,-2.6147792389851886e-05,7.1198224997405762e-05,2.5682689442775401e-05,0.00011929111371736115,2.7860714214499385e-05,3.2654486739197575e-06,-5.5573777784770351e-05,-2.4040836230674462e-05,-3.7015814775545261e-05,-0.00013308586174926723,1.923769352976841e-05,-2.7445843212351578e-05,-1.199439585908063e-05,3.5032215132376919e-05,9.4889623314988944e-05,4.1828095702725956e-05,-3.4147434353455977e-05,3.1692057309944382e-05,-0.00012748342849396022,-1.5840876485394284e-05,4.7073815318422058e-05,-5.4219379703623893e-05,-2.7057823555193261e-05,1.957250209402156e-06,-4.2885362544764494e-06,5.1784247492511759e-05,9.7614017595303026e-05,2.6206437789333403e-05,-3.840723379957417e-05,-4.3620727456269992e-05,6.1282931602328416e-05,-4.1484546914841158e-05,-1.8991776069687133e-05,-3.8766273328664363e-05,2.4842026175204979e-05,1.943116733871264e-05,5.7022083599506113e-05,3.6943371778189182e-05,-2.2802079412020948e-05,5.8533333908400431e-05,-3.8134075295223613e-05,-0.00010733273350739298,-2.1349054282106955e-05,2.0212901591327992e-05,-1.0308234675579855e-05,-0.00013178259714422685,9.2792721038507942e-06,-6.406096160121999e-06,0.00010489353656312206,-3.6972486442386071e-05,1.9205959162101743e-05,-2.5119901163566229e-05,6.6677926942838254e-06,-5.3173101432296699e-05,1.5595662104549764e-05,4.2063861440242226e-05,-0.00011208840161249227,-8.0476085046677498e-05,8.680420622040122e-05,8.6344181199115091e-05,2.8719099287293631e-05,-5.3155476409198592e-05,-5.4570646040804499e-05,2.7740013315707968e-05,3.1290284801600062e-06,1.8897139614309187e-06,-0.00012179101932861119,6.6840019799997014e-05,-0.00010633851278423791,3.5859740502247259e-05,0.00015372154099424235,9.3482108860959943e-05,-5.1252862294083688e-05,-1.1146007599487084e-05,-1.9744343489652011e-05,-7.8768975259988112e-05,-7.5893435004921461e-05,1.324648660373383e-07,-0.00019713417520837023,-1.337483475241652e-05,-3.2243587432437271e-05,4.5963036203394009e-05,1.3630966931021948e-06,6.1090824316110785e-05,-3.7063944354813472e-05,5.3774349412737815e-05,2.8714809252497475e-05,4.3068787919792184e-06,-5.9398600734514111e-05,9.4064471326807484e-05,-0.00012585758504905786,5.0460919318804677e-05,0.00013218227218045244,9.0391008869705747e-05,-6.4299214936155979e-05,6.1428536959399344e-05,7.239739626676775e-07,-6.366839054444684e-05,4.8758759963537721e-05,1.370601692269463e-06,-9.7972856753872155e-05,2.9714662401220159e-05,-0.00017065450862235659,5.6129420667599961e-07,0.00013050423194534838,3.9512648229014097e-05,-3.0858474698957153e-05,-8.077273509681307e-05],[-0.00010041713705304361,-7.5004427981998842e-05,7.7578836709558431e-05,0.00015060096637672937,0.00010272729354795368,-1.3455811985058075e-06,-8.513816673568278e-05,9.5277958304541138e-06,-5.125057113741175e-05,2.1937041723950335e-06,-2.9906736665197275e-05,-1.7822507535654366e-05,1.5920560761634173e-05,-4.2619825694686919e-07,7.5621519507984916e-05,0.00012391090326623749,-3.7227119771730648e-05,-5.1851912943837175e-05,-8.0359665516151202e-05,7.6556506706648296e-06,-2.9340700929650354e-05,8.21553152150125e-05,-6.0163498557478517e-07,-9.0231354808785729e-05,-0.00014677611474230284,5.8459186367564031e-05,0.00012920305793076987,6.872786215014054e-05,-5.083503031854536e-05,-4.9057975777679064e-05,1.4667265166828924e-05,2.286695792285548e-06,-4.0793147414804661e-05,3.1833081357390651e-05,-4.6139907270008307e-05,-0.00013108954174256143,-4.5014849167218651e-06,0.00013512478717948309,8.2693053849276603e-05,3.7212849225235281e-05,-0.00021401767748336522,1.2160803497153136e-05,9.9526098024278753e-07,-4.0751249249773927e-05,-5.3363285595225268e-05,1.3589464997432535e-05,-3.4575952982748501e-05,-8.6226276956346756e-05,0.00012833142734719472,0.00017949919377930994,-7.6588263679235394e-05,-5.9446820945188023e-06,-3.3933589792761384e-05,5.9031307218506898e-05,-2.015941600058864e-05,6.8480128461272105e-06,-3.5080450032940217e-05,-0.00010776252403311049,-6.0092138186616101e-05,-2.1591874499028371e-05,0.0002085712636860533,0.00013308075647107918,-0.00019038894948568419,-4.8311736467392813e-05,-4.4977282909152566e-05,9.0492245632955992e-06,-5.3993236004005844e-05,3.1275503979513383e-05,-3.2914668064622926e-06,-0.00013006251102497951,-6.2666458502351387e-05,5.4666608924943544e-05,0.00011702845908493319,1.0892085020900236e-05,-0.00019162055407114659,1.7055725050175042e-05,2.974210675293909e-05,1.5551139561116503e-05,-4.5023716002432629e-05,-6.5835168557154544e-06,-0.00012255723604855578,-3.9207372768674739e-05,5.7719587707099479e-05,0.00026173109381898325,0.00011301129674169685,-5.0802156995757072e-05,-0.00012438693915498879,-0.00011512378434027151,-3.3743545817560561e-05,-3.5132235241363229e-05,-4.6345900066929873e-05,1.5030465562238389e-05,-7.9108333110193552e-05,-0.00013976057205664083,0.00019173792465106837,0.0002331493622096184,-3.2682257327322451e-05,-2.227669270683898e-05,-0.00013159576482307811,-5.3703861605495715e-05,4.6651971536551334e-06,-2.9729790998640759e-06,-7.4266730748546658e-05,-5.389279737498141e-05,-1.316760153250926e-05,-7.3089820491645252e-05,0.00020790545462955686,0.00015786906649726715,-6.9607449746187828e-05,-7.3261780378834282e-05,-1.4507107393861574e-05,1.3219651490949808e-05,-6.5930835653411554e-05,8.7110618181049371e-05,-6.5267580373248521e-05,-9.1012781288057377e-05,-5.19613620658093e-05,0.0001223100464897317,0.00015993077204011844,5.6612364799854542e-07,-6.6482888690664547e-05],[-0.018520133751243464,0.033336491324542555,0.060819720527029927,0.040323418834132499,-0.049047834696932316,-0.063470960442844934,-0.041691385681480758,-0.044039608866153525,0.011258972442574882,-0.025539787514069722,0.043103535419798611,-0.028504032717188526,0.021790396749209295,0.044813183605805482,0.072342677373923595,-0.0054580991763535022,-0.068820734524706939,-0.027963615041034923,-0.043243973359288305,-0.0078418754694789261,0.024040296276847006,-0.035356451324435254,-0.00086042742890664065,0.0096467844413907385,0.029019444355814925,0.067022867313017098,0.057029519949577098,-0.043873902116144253,-0.075663372407398011,-0.046868046699417951,-0.018264867445612423,-0.0074626900784457925,-0.021262044142767906,-0.0082441046273046235,0.0029955900266555547,-0.0089729220855647492,0.061100791900219963,0.099636125742843085,0.01246798784414134,-0.10296028529728725,-0.052371289202456622,-0.027534950783727603,-0.029445539405478512,-0.014438110426238521,-0.020597801030636742,-0.0069192729388266542,-0.0068353911578240287,0.046888843535454167,0.095419422615776378,0.11952740651114951,-0.071759879152842584,-0.097543349347774588,-0.038581839090091406,-0.011359375549234043,0.0096414218165537698,-0.019377865703622918,-0.027301905307660128,-0.018976931848243853,-0.0097874220322787808,0.052494465523833397,0.13673694152340612,0.079522839381611823,-0.12204275357398138,-0.086659087964125608,-0.050788452961220157,-0.0095706052201628006,-0.031867426563525113,0.0065403023175219614,-0.013821229136400558,-0.025841844477207752,0.039927962074705635,0.078783857519568928,0.14509479705134329,0.015223051588865631,-0.15795321280384766,-0.07811502424267372,-0.035586118805957023,-0.0074434198140412022,-0.003139865749646073,-0.0037907036206188023,-0.017030151899642937,-0.028687071734543906,0.033231292617662847,0.078112982645069926,0.14321815919795058,-0.019232041974005604,-0.14758943164396549,-0.079879348969855837,-0.0083758813479438005,-0.0013328452184675349,-0.0069555223602641852,-0.013965719003215596,-0.0084517142743534557,-0.030635979725422979,0.062564657139202229,0.097483933781118526,0.098393109491561992,-0.075765704484413554,-0.13450497059632649,0.014088590669959079,-0.011155752837349455,-0.013224455473029723,0.016020761294862018,-0.0092009384061512017,-0.026044280280468072,-0.0089942622699424254,0.040511999855926281,0.13765939646555747,0.019532039084030235,-0.113685740386246,-0.014674643494660689,0.010068963393355071,-0.0027238337107524657,-0.029503771627642287,0.023985321668865342,-0.030691543491141608,0.00075273240464540647,0.016509439032383569,0.052598123173995245,0.093807407073263682,-0.010161298965641691],[0.022420101691410947,-0.012639778282766856,-0.054967524914303248,-0.096783598284995914,-0.029278797210954027,-0.027140150032464422,-0.0090862764272963831,-0.01436525543604809,-0.0036874965912717952,0.046401379667166204,0.06944892468679216,0.046437605749818221,0.054029149328551414,-0.014720520773996864,-0.062916130856065233,-0.098775700155922658,-0.045678178604865977,-0.010326416710093567,0.0033233465331775174,-0.0034083775958032849,0.018489145293850089,0.061679618222812545,0.030027128801833766,0.056347586928367471,0.025440360022667211,-0.0079353236613027636,-0.090410021555884179,-0.12919633261589189,-0.034536772506999741,-0.018948700084980397,-0.0010618822071395313,0.013098312160546995,0.032363848313171489,0.050549191984487554,0.031990411924285006,0.050348641795340286,0.055949633963116994,-0.021494030157359074,-0.10945006672723176,-0.09734195910364446,-0.069733612116043384,0.00046788820631171735,0.0088096432516313414,0.021994342501025908,0.0027410119068893707,0.039372454591750629,0.046870579313232824,0.065600872379856318,0.050120908492025634,-0.016483195978918071,-0.12612174723616837,-0.11190212135650279,-0.047331697359264666,-0.01726103679627998,0.012596718517964785,-0.0075349876913478053,0.0038005877790431991,0.051789101650355995,0.056092751053536116,0.084082295492619821,0.077148767905369536,0.011050271359062259,-0.12128857542605344,-0.12084191927896829,-0.053176729528096434,-0.02708040311428029,-0.0075678521991022762,-0.01607121542877013,-0.019007628063393803,0.030912220436668407,0.061182793511099738,0.067857694007842001,0.11648893540497803,0.051234448548712098,-0.062047768790331637,-0.12295702506362237,-0.11728242791483995,-0.00044317389712395395,-0.0022492229405423753,-0.027298027461083098,-0.0037412679982248703,0.018339305301497556,0.014062213845781296,0.042776761103683739,0.12121831309988876,0.043922241629075237,-0.060790512107661343,-0.14710686167847625,0.016829211914154221,0.0097743210845070427,-0.02655745267922931,0.01411019215769007,0.0015911500130474376,0.0048095535457472055,0.029093722335047395,0.02204063036696597,0.11057315594923375,0.028480643798939262,-0.10628170570505348,-0.035908284128103249,0.0133539331015953,-0.0026337425678592541,0.0037217642215676694,0.01211758091302224,-0.017185123404806685,0.037539560931704963,0.021332506924666678,0.037076669230181408,0.034944297335335751,0.0038125076728691906,-0.011494533354137266,-0.0025310349463153192,0.017794319144349827,-0.0060675629645619775,0.0061802385692899253,0.023087539721666911,-0.0090737645476416107,0.039516536947320213,0.034463079883642105,0.032448600915701092,0.034402984786170009],[0.0068336647996234817,-0.018868811143753335,-0.059136035832249842,-0.028733110863327534,-0.04829617939991479,-0.013674449873764477,0.021589567751534984,-0.011045509577009407,-9.2586309830101649e-05,-0.019604821913896741,-0.043554281780948161,-0.0067654209020675676,-0.02068305720368354,-0.030701868023452029,-0.028849057542991427,-0.017812677518967715,-0.045031832483275663,-0.060820037371985124,-0.010178321392366178,0.015937284977666402,-0.016985093495210109,-0.040648498140976104,0.062808978784564026,0.033289631093537754,0.0086340994321458635,-0.010322738843516595,-0.059032523363236167,-0.063911207518901086,-0.04096234057148166,-0.027001415147463827,-0.034989832948803361,-0.028182307754725123,-0.042998203295550722,0.069170072619876719,0.043703797355855584,0.052829105392347621,0.047980736517133415,-0.062746508827205477,-0.07875819635466827,-0.075127670879345507,-0.067143876925195398,-0.066726399172545248,-0.041696339372405265,-0.060750152079557279,0.024187583912489444,0.068640938449234204,0.041598533606845969,0.078906569214333658,0.083979421652039477,-0.0038263845041486728,-0.12006341244852366,-0.11316397468328382,-0.13578926241060613,-0.093037742063093384,-0.094331325266374944,0.039374839837024993,0.0018502894554712629,0.00098403884557300703,0.043251075195119761,0.10289600250798445,0.10139457516638843,0.098296318213992984,0.0015172138792846615,-0.091353309472808869,-0.14408600311908051,-0.17601217218477397,0.0027216978532337011,0.0050459512202331094,0.013052368344425278,-0.02268381542321192,0.0018963147223881672,0.058561197832169565,0.10081746684744355,0.1284091469146558,0.081889066464071528,0.020432446864236044,-0.041167990010434322,-0.0055028747128956224,-0.0065942601568496836,0.014863290940840906,0.0037309761431811826,-0.0055733957673353585,-0.0095154141766328471,-0.0085635423630069374,0.013253049308240551,0.048732591229276791,0.06968257130273349,0.046720703389001979,0.017479981197113373,0.013140374943216824,0.0057338967701967298,-0.012003741816435577,0.023955505761992523,-0.030000657870097674,0.047563304649765062,0.0077259610173529046,0.033237902464347463,0.017011399778159172,0.061533921370621733,0.020212718731567866,0.017305311353954009,0.0022897792857957105,0.0016835294612028012,0.0010206390840901067,0.017475023171824131,-0.017949934386931946,0.016500074421584708,-0.011803197631711164,0.0071375865755149634,0.020110991820133289,0.0066510650617606984,-0.035354962478288801,0.027934388454869896,0.0035907122794057167,-0.011547179475815586,0.022730843153114938,0.0063450556387456142,0.063988285390432748,0.033769980297886006,0.019839431713957675,0.040068406254536615],[-0.091835947946248234,-0.046604387675826101,-0.041676874531984251,-0.033930262028828845,-0.035175875655805863,-0.0080453626545488738,-0.0090216589851604481,-0.02121447197147619,-0.062925485862957847,-0.05369020745787989,-0.061858807625239501,-0.06937986410985425,-0.020603691282656961,-0.034830971939882417,-0.019889322846467439,-0.011468099868646962,-0.0094847742535054055,-0.025059650809968075,-0.013132163916809988,-0.034373831808455289,-0.029388799791445819,-0.054678738402223398,-0.040920673499650034,-0.079026490477792366,-0.031301237226933717,-0.0071872341290014803,0.0034458433272600772,-0.042065809644383292,-0.021031719352458608,-0.001277101170823379,-0.005576040960812231,-0.04990522219778968,-0.067835745978871653,-0.025379854810453996,-0.06049669189310318,-0.095683850344630256,-0.066897542916176167,-0.065214493641294946,-0.042633834046964025,-0.077401334220438017,-0.069225159677055934,-0.046596567405820979,-0.048532202776120179,-0.039853128982711955,0.058791987986470867,0.019029808637362255,-0.024286125044301457,-0.032536348362445913,-0.054850631234694594,-0.029159852423518498,-0.017140255241788596,-0.025126219632764957,-0.021866221424523921,0.028552819914696353,0.039991900782009912,0.097745845928933414,0.075003405416456781,0.07430547425958485,0.046933143764967475,0.098596680830569355,0.069830184507780863,0.076647971552195535,0.055005419110830067,0.032350115276010255,0.096665962740361017,0.010918853676894331,0.022113519271821657,0.052322536591560803,-0.012178262012994243,-0.010455542631323735,-0.018880441466414811,0.0047199732120972978,0.0026889619208184806,0.018985019723820939,-0.0023284725516955788,0.0062286539593777134,0.029915434795143629,0.035545042009691323,0.031166989162956585,0.023817329421070923,-0.027070265784234368,0.012571032012612495,-0.010191882170487051,0.038027976545602443,0.021583936786457751,0.0041709730151021779,0.0055753825352771154,0.017282900358889321,0.012313387276719573,0.014888890182775907,0.0026555936507575845,0.0041491311841516786,0.0089247523949147946,-0.035192223449134509,0.014939222809458778,0.014096628107623346,0.0038994744074676031,0.0038988514456372763,0.017266521138772535,0.034244356006098528,0.049763931691756066,-0.005218910309326261,0.026330780935207528,0.0018007141228710017,0.040201841967386298,0.008387995416966193,0.0089671250498080113,0.021011865402405266,0.0053809467478302536,0.011462851184232362,-0.0066133988743292821,0.045841349785302882,0.047592090089117703,-0.01138244385540027,-0.00070927480002307142,0.0074075056026355335,0.0019847009079824521,-0.030303270976541313,0.018517753986476031,0.026216734168329519,0.034368064491053237],[-0.027531037432672691,-0.04099006670908386,-0.026965623295530559,-0.012312380363310317,-0.039447686525463981,-0.03666523046247578,-0.037447390315664068,-0.022587619011761463,-0.062582100174721697,-0.033423508713191781,-0.0076373179884149161,-0.033315735899947165,-0.0039483412696357774,-0.016273510510130911,-0.012992687546803472,-0.034372636966254512,-0.03435111582313348,-0.051089306183329297,-0.046268014832446261,0.033800057143038305,-0.0073586595715814766,0.019133386626946858,-0.058297854363401749,-0.031082988073954963,0.0083772509744956935,-0.037071324198600958,-0.023704461959529924,-0.039291684655309064,-0.048263910448506031,-0.012347480993205387,0.035773003788554164,0.037156659417232431,0.026570153340676375,-0.037942266517026105,-0.024176653665932857,-0.031307061474069642,-0.054205313513014206,-0.06768275375230659,-0.053316198087527286,-0.010338522140239293,0.029942502875344803,0.014711352823963025,0.049805637603742653,0.052371502049621543,-0.10703071666798925,-0.045011199304251487,-0.092731348345214376,-0.085093349694216031,-0.063610110950440779,-0.0095235206492992573,0.042742365251146427,0.043444162762555597,0.046036485816212142,0.028778886437521231,0.047907150554463943,-0.12009138239136509,-0.11012922541438776,-0.078798363732678192,-0.018737247881031881,0.031173984486382707,0.095074649576190343,0.060365097674145295,0.019220554797620699,0.01388973862340221,-0.0076666833910165461,0.016336606646977139,-0.0089402055834871645,-0.009503128569333559,0.069645335781562456,0.10401039886252086,0.052459790243731555,-0.026938277073398003,0.004284176371855913,-0.010856375573225323,0.01605273011301905,-0.02894886868907141,0.00023294115249347658,0.10367861418152627,0.050069068200320935,0.03685333261379678,0.0065038291189368977,0.0055476321647372102,-0.001084420000763836,-0.0013256537401329926,-0.0055543179731149875,0.04532956341916991,0.0065356074227495148,0.00060778524209767829,0.072038703955503394,0.028968613954759095,0.01396712994861575,-0.0072270944036459395,0.0072231709415025436,0.0088564229032674913,-0.012818406202984009,0.0018158551557052593,-0.011048631845851281,0.0081952063010873877,0.012550415026440526,0.030696565794881558,0.067975847115216093,-0.022209795527931789,0.017373946107885192,-0.0058381708959014574,-0.016933088119923018,-0.020606794484921063,-0.0037043871743785168,0.0029398368329221804,0.0096078974834835768,0.0041619321053977393,0.051668501796067898,0.0039989461136227533,0.031118179883235883,0.026294533996712728,0.01753286865508474,0.025533735463243126,0.015158623449280213,-0.0079480930999361321,0.0038964542185176585,-0.0053933087386399264,0.021361178289641174],[0.012975868416211518,0.019239320212785932,0.015861069262982933,-0.050083983501051685,-0.014830404072943748,-0.042428924530810298,-0.0546374523172155,-0.087876214943823805,-0.026658677207938124,-0.015590232984336386,0.036899434494932132,0.024659476737796934,0.0020171111101438682,0.017921834795381661,-0.027324028879693207,-0.013180029299528148,-0.055753129702174518,-0.049084869856142327,-0.022370349979819272,-0.004286198645007025,0.041588558750575308,0.026714819884015438,0.033049974332900536,0.0089521448811692717,-0.017401493840176877,0.0075428243019341618,-0.059296477399313652,-0.055868974136098246,-0.057660433887213092,-0.042846351191628017,0.014163595597386905,0.016126409391757648,0.045832162409125146,-0.03439907801328182,0.024141395323280069,-0.034808445161098753,-0.040342652019852668,-0.071211354083205405,-0.066220814617881887,-0.021197302763752403,0.040154246023236077,0.026897565966803642,0.041075505774253465,0.013102896697572107,-0.054802347574740791,-0.036158434286273147,-0.0256495795872312,-0.031709300211612938,-0.07192249463955766,0.0018536114632540868,0.06135675209286226,-0.0047182623867055755,0.040748587019009241,0.013385521369616127,0.022021140563933967,-0.071345017456805687,-0.032751414465768555,-0.061368302060063384,-0.077484017233162547,0.040235459113155417,0.068103358625634269,0.052652304806050272,0.037109981850323923,-0.0069502207163615664,0.0099627248261238005,-0.013836396194806236,-0.1076545781769893,-0.055495023231610416,-0.03496995103010396,0.011211930076389209,0.071812499425325693,0.073452579592106007,0.011482805374590529,0.0046876216072186004,-0.018292746840584097,0.034170522532356445,-0.010280828511826764,-0.11953193347980212,-0.027928919333068614,0.039183167556650897,0.054784445312102498,0.058364392086528799,0.010347645401137313,0.024383436691158888,-0.037224914576266671,0.018329010676908897,-0.021362338634851388,0.016317900816211706,-0.036988609665871267,0.02534543374576112,0.049929079774209781,0.046243114162446489,-0.0049605182450543489,0.0034919992815497097,-0.044846569032337441,0.0083151693429875384,-0.0013347971554703852,-0.03179501043076588,0.008411224541488016,0.04299524896058729,0.010370090496971934,0.032726802355203644,0.017613621443155619,-0.017879863195363097,0.01304441155731989,0.0031245950737431721,0.017805613201477818,-0.0083911278501079337,0.006798248666313525,-0.013767337935693395,0.056008431245866491,0.046170998183484704,-0.0067630944098937273,-0.011002116865157521,0.021424043858876557,0.024102164398572545,0.034701661533462574,0.021782351862351945,-0.020308680817982358,-0.016830911622128797,-0.0089977505477456202],[-0.00053288722928734877,0.01181232486259727,-0.0097595448326459004,-0.032900195859997115,-0.040055309118167202,-0.087664118249866321,-0.054682271367624567,-0.012138385460291765,0.0081352895357042071,0.058249646659419167,0.030708308006623514,-0.015344928171805335,-0.017993990035881716,0.0049203910914597283,-0.013878741210342176,-0.030835237792518008,-0.057101218092033765,-0.032671359607370866,-0.0037749689752403365,0.046975259888485603,0.027796476796038583,0.0092523091282655789,-0.018920714229260328,-0.017057777895009705,-0.0026666003038471045,-0.032119731896417023,-0.044973722999436631,-0.055383689969028219,-0.009123266518274652,0.042052749594025995,0.0059455404022271778,0.052199892821319531,0.013921729795046189,-0.019417768980458633,-0.0042120805724511906,-0.016059476497225951,-0.019873270609575895,-0.0632108563907854,-0.06190209155478818,0.010727975525090354,0.048801088568173723,0.037392797038495587,0.0072673632685977124,0.012809806033498544,-0.0034510716108627883,0.016898125070602375,-0.022589640104992519,-0.062363076360741024,-0.060954585959324542,0.018029070106769074,0.071600992694912186,0.039034855273469921,0.020918995904994631,0.016561765175755305,-0.023866961496342709,-0.027629495788895585,-0.029461697539283106,-0.055111224665105978,-0.068953324385477396,-0.031776432477510531,0.038108515593093778,0.032616236844622878,-0.0056891246860652223,0.0095690633852811985,-0.019286757729714242,0.0062446121687075654,-0.028641062503210957,-0.044571632732540445,-0.056247188104149033,-0.035749753102891232,0.073365539091992032,0.067655332791377198,0.026480919164869672,-0.022367434017255376,-0.0069125347125725614,0.0098899156936733956,-0.013395387566733363,-0.059837543834672623,-0.055071395971080822,-0.057234682668758363,0.026937252303024146,0.056778003501821217,0.045512331377432672,0.010489795280571829,-0.021873444057054492,0.00025673627436038904,-0.0091984359947323291,-0.0032360325511277127,-0.098453946376152596,-0.056634390573377422,0.040879143636173176,0.053707788468343107,0.021417408905106447,0.03366002971067647,-0.024266957419143365,-0.039720531313110208,0.025845458247811957,-0.0036737275747508319,-0.0019562811556378054,-0.092075643980856242,0.0071537732617090663,0.048235488203754229,0.031953649727852425,0.003989147112834171,0.013123842004803394,0.011507174787329752,0.0048599025473536617,-0.028069938515581847,-0.01371471244881068,0.0044504142002205899,0.011633142638130397,0.016824865792836985,0.044010419049233987,0.043598608889422096,0.010461702283433252,-0.011713831073031492,0.023350032280673588,0.025824508444130562,-0.040208662190134595,0.022221624473925089,-0.018983577713146488],[-0.00012902298195700823,-6.2039143102904371e-06,3.2701886255415841e-05,-3.1071238546384605e-05,-7.8012389908108104e-05,-1.2260737746391803e-06,-9.3428634947009467e-06,7.5833942839328289e-05,1.8838025439401641e-05,3.8241995713984844e-05,-5.8626520388890824e-05,1.2707156678677667e-05,-2.0943050504294153e-05,7.2618095238986824e-05,-0.00010859928908422273,-2.8985456628716211e-05,-0.00016736251968167692,5.8133891860739917e-05,0.00011171839620466306,1.7754895131873172e-05,-9.451887160561584e-05,2.1444236751338823e-05,4.6865300624759562e-05,-4.638768128616827e-05,-8.9560896987736505e-06,2.9042840169843376e-05,-8.1942849377705101e-05,-6.1236466778755941e-05,-1.1152819677964776e-05,0.00010188996994199562,-2.219289260330104e-05,-2.2868962134298121e-05,-0.00011509542457514149,-4.9758057323850968e-05,-1.9393139160640838e-05,-9.4734362441235842e-05,-3.0802279410412688e-05,-1.1207452486435205e-05,-8.8749274811722153e-05,0.00013300646840005981,-3.5925271800810177e-05,0.00013742103255615784,-0.00011808493242440599,2.241467472778591e-05,2.3854116688329374e-05,-4.5322376845374768e-05,3.4573180042879459e-05,-4.6142794075512694e-05,-7.5348994747592712e-05,8.1387747235452806e-05,3.3796552020320947e-05,8.4447120378403073e-05,-9.0274895458430926e-06,7.0080857293354504e-05,-6.1460029718581055e-05,-5.3967745923230769e-05,2.2718206186092202e-05,-0.00015616234415340852,-5.6948505482531941e-05,-7.4115836868962615e-05,-6.348787135312256e-05,7.5446184729599519e-05,4.4606522477112776e-05,-0.00010450123996736185,9.5752201968071771e-05,-4.4579197955377237e-05,9.0414806759177291e-05,7.3014201662432998e-06,-6.6094432640280421e-05,-0.00017393323793045423,0.00014375964009427644,0.00014113080383144211,-1.4170194328547159e-06,9.805969688744115e-06,6.5253060614042357e-05,-0.00013047653881412095,3.4993317070665386e-05,-0.00010216225080474789,-8.4219700147578113e-05,-9.7025062000797874e-06,-8.5183069646590538e-05,-1.8574643331822427e-05,3.8637504285300153e-05,7.924976063334796e-05,-9.6774013405367953e-05,-6.2754497545105745e-05,0.00014663167384857193,1.7006970539279118e-05,5.5150673017173579e-06,-5.1711502024315639e-05,-0.00014948514404445907,4.8590777832147047e-05,3.8820345659114353e-05,4.3569583440402574e-05,1.1474225398808158e-05,7.3156504448345511e-05,-3.8172280966974892e-06,-6.3707580509990425e-05,7.2659510936171068e-05,-0.00010594170361082414,-6.3344621752967588e-05,-5.4025363748051725e-05,8.3061403910164588e-05,0.00010798285789356821,-1.8400164812460568e-05,-4.9804496028007378e-05,3.6572621350011714e-05,-4.7481622172728527e-05,1.7943415993419156e-05,4.7690435629216266e-05,-1.2465656421243882e-05,-0.00019635305944052869,2.48024743702141e-06,0.00015032297597119496,9.5319611595749698e-05,2.4341784711353828e-05,8.4135307912430735e-06,-1.0237800380508144e-05,1.7639768025006289e-05,-4.9211961308678887e-05,-6.4779795722127997e-06],[-2.1081829939189364e-05,-8.3620881162482352e-05,-7.9323901484131551e-05,-5.6369563666456841e-05,-2.5225019111016402e-05,6.7038340261255428e-05,1.8979428320805604e-05,-3.6383667643090627e-05,6.3535381529804258e-05,5.820117801163101e-05,4.1579935042042955e-05,-8.0246257085953183e-05,-7.7024543088595118e-05,8.015274585669932e-05,-0.00014513612413195485,-2.5225497027576353e-05,0.00016501583478403825,2.6271142708690046e-05,2.5316005334570513e-05,-6.7103148717620464e-05,-1.1803827654757997e-05,-3.7280704814898497e-05,5.2411115100495795e-06,1.9188281117332165e-06,-4.1461064150758939e-05,2.4848310095391263e-05,-0.00010693164000688581,2.6294649429827789e-05,0.00024742918857803727,-1.3795393578770743e-05,5.7821874727727318e-05,-6.3546201653433363e-05,7.9184859554841738e-06,-2.9438053918515172e-05,-5.1191789614749364e-05,-5.229702720297184e-05,-0.00015826280154122114,4.4709933911597777e-05,0.00010006580584785707,-1.5725171825552758e-05,0.00011394254284542574,-1.2176783409917694e-05,-6.2006183805807247e-06,1.6735056790493242e-05,-3.2321218056508699e-05,7.0455310764595564e-05,-1.1204046406237695e-05,-3.7759252495142039e-05,-9.6707313847678444e-05,8.5280328383621697e-05,0.00010626012688529703,-7.9059523137930466e-05,8.7526351723081312e-05,-6.0072534243107534e-05,2.90057435677212e-06,-2.231589629678437e-05,-6.2577199005761815e-05,5.1834601699592012e-05,-7.8178877034198557e-05,2.8746546782532946e-05,9.1197009731421724e-05,-8.5285435194773496e-05,1.5505315731474678e-05,-4.3117674284669292e-05,5.1101985086758703e-05,-2.5995519087103932e-05,9.5403159591622017e-06,5.4456486999133005e-05,-0.00012492021323487425,-8.4468616262168552e-05,-9.000869760849206e-05,4.617292956130177e-05,7.131283142743387e-05,-0.00011470771088624421,-1.4346991649049484e-05,9.7453713062413318e-05,-4.1037923649930581e-05,4.6700567506506845e-05,-3.9864452388190625e-05,2.8496279151997124e-05,-9.066823994197191e-05,-4.4743333617536891e-05,2.8884441623257457e-05,0.00010540785842768621,3.850540540015733e-05,-0.00015698623100240949,7.3335058638763877e-06,4.9803028096866153e-05,4.7614922439986993e-05,2.1925161837212364e-05,-6.8629674967009865e-05,-0.00015530778840890948,-3.100212558819124e-05,6.3968237768941005e-05,-3.1106521259080533e-05,9.1934837059831501e-05,2.6946272223389578e-05,-5.4282762803284628e-05,4.019534042066982e-05,-2.9248092071432023e-05,2.7237642583656692e-05,9.8185766607061667e-05,-4.2389429439307238e-05,4.37933802041688e-05,1.6481438603041521e-05,9.6248410750655877e-05,-3.3118875722210842e-05,6.7699125022684103e-06,1.8952909147867698e-05,2.9371419846995129e-05,1.8803983863591715e-05,-0.00019186119469311551,-5.361492348410202e-05,-6.4625196625645032e-05,6.2101642194700582e-05,0.00011142710960054477,2.7597534422937219e-05,-2.5794525775165963e-05,6.4102040847752173e-06,4.3683270110482682e-06,-6.8056030788576048e-06],[8.7288421870321264e-05,-0.00016058377648589737,4.2400373088111865e-05,-5.4107084248774395e-05,3.0344295765780732e-05,8.8236089089935299e-05,0.00018665417186519012,-1.0617952797905769e-05,4.8858460377767388e-05,2.5608835436190377e-05,-0.00010410765791478177,7.9333875062426173e-05,0.00011912193130779857,-0.00017617567516805917,-0.00011561862531249794,-0.00015414695744926516,0.00014088130997128717,0.00016468128155683326,0.00011507720929629026,-0.00015709778676884618,0.00010763417094498772,-9.118060462058597e-05,-5.5086539995887829e-05,5.9474220836819866e-06,-8.6291073686201622e-05,-0.00012420251221447246,-0.00010346788082849325,9.3599593697178099e-05,0.00026254729278605779,6.4222765577659057e-06,7.2572661937003226e-05,-4.033497396762134e-05,6.7905724745284668e-05,-2.93776948290119e-05,-2.3486357610992304e-05,-8.3910324209424228e-05,-0.00020864486749087939,-6.7755590215695969e-05,0.0001515708034109664,0.00017533733335889368,9.5332896045297044e-05,-7.861973811299286e-05,-1.9995583621156693e-05,-3.9618775529985661e-05,-0.00010062395102337484,-4.9007295684973088e-05,-3.3360058372429793e-05,-6.022956312257328e-05,-0.00015274074428942797,5.8063262650909908e-05,0.00017946285495735103,-1.3678668845418327e-05,-7.8757246044701288e-05,2.392826356772957e-06,-2.3839343828305911e-05,-9.248265240540364e-05,2.9770206634176059e-05,-0.00014104067824765015,-4.8579147311816374e-05,-0.00017751495448386015,0.00018735013824282797,0.00010606389466041302,0.00010933903734035946,4.3269015151447881e-06,-7.1743566359979186e-05,7.0321014536656851e-05,-8.93257874152939e-05,-3.4592052390203243e-05,-0.00011018808045150374,-0.00019880825872508473,5.2018749766881422e-07,8.5410387895845825e-05,0.00020004668933091391,-2.2823030905125513e-05,-6.622604266612233e-05,-1.4683429230855091e-05,-9.0830073547348844e-05,-7.0533087103265366e-05,-4.3155104080978553e-06,-6.6612089885383471e-05,-0.00012962736237221795,-8.4205562721053305e-05,0.00019015519131662401,4.6517997794389906e-05,6.5029919190847871e-05,2.5248133705620211e-05,4.9506668943670649e-05,5.4034388762582352e-05,-8.5820743604511545e-05,-9.1440849227466376e-05,-0.00013511882193446021,-6.0564085048693712e-05,2.1193874455255248e-05,0.00015210079798582028,0.00017075069883851484,-9.0844790719107459e-05,5.4302802042653642e-05,0.00010180348435486356,-6.0323087261991346e-05,-9.446302123957586e-05,-3.2240495441221377e-05,-0.00012010188056445995,-0.00012404303956506726,4.4630583568044946e-05,5.2507061058221227e-05,0.00017356731784019808,-7.6959696971629126e-06,-2.8710064423776577e-06,-3.4925643861908121e-05,6.2447442756253732e-05,-0.00017903527875390193,-2.0437146053053435e-05,-0.00018575226473759824,-0.00012521765442334218,-2.4217309442219341e-05,0.00014051754345432033,-8.2035171331245466e-07,8.7475802753541048e-05,2.4934621660151039e-05,6.4845825162306749e-05,-6.3934442578149898e-05],[3.539459461619765e-05,-6.807572297566275e-05,-6.0927166479846084e-05,-0.00015316315161422248,7.3480222355239155e-05,9.7563808442280298e-05,-1.2450172577060936e-05,-1.4500568661798829e-05,-7.3970664566741506e-05,-4.0340386747484986e-06,-3.8654627032383426e-05,1.4379221778954175e-05,3.4687131743454946e-06,-0.0001584469264043209,-7.2931081155691132e-05,-0.00011775139382447231,7.4047592217506633e-05,0.00013239001684919123,4.7081715214836173e-06,8.9098227572539934e-05,-3.4630714238897964e-06,5.0421055899113609e-05,2.6442780926408394e-05,8.6582559483544541e-06,-3.7941259438345476e-05,-0.0001398658685568422,4.0145443855138518e-05,-5.4757761041059061e-05,2.303092327018974e-05,1.535566924483478e-05,-7.6915169280877826e-07,2.6449624305313613e-05,3.4036177513768751e-06,3.916281041301678e-05,0.00015363454768414775,3.3088056267130406e-05,-0.00016826406184210219,-0.00014952301925194589,3.5498105323300555e-05,4.88793394428505e-06,4.9269962297551761e-05,3.206760857812907e-06,6.9986096689830801e-07,-5.7017488941165685e-05,0.00012398343835970382,2.8576108184866222e-05,4.4996957731510689e-05,-7.6581956260302758e-05,-0.00017982376102392873,7.7913987986955036e-05,9.182050843792311e-05,2.0136049025466763e-05,5.9720574201015814e-05,-9.1171378305762718e-06,2.2421059441793401e-05,9.2991945137864407e-05,1.5504680551996219e-05,7.2486851610271963e-05,-8.9180203210073236e-05,-0.00025973470234600185,3.0931649627910485e-05,9.1341641323305949e-05,2.3131495582390249e-05,1.2246773344729012e-05,4.2369277568246599e-05,5.3252080969970472e-05,0.00012342596764605002,8.7665076725869373e-05,1.2940257800994875e-05,-8.4930704521106549e-05,-0.00012907568039395578,-1.2681617590354355e-06,0.0001043685768841035,0.00013644771823127788,1.6057523568244192e-05,-4.4318088826156288e-05,-7.4065080743923595e-05,8.9411278556494889e-05,4.0459656558203272e-05,4.7207547890018575e-06,-1.2596513258189557e-05,-0.00010567536025424262,-9.4991903417787626e-05,2.7651247338847385e-05,7.609666823792105e-05,-1.9995057402716343e-06,6.7764367183351104e-05,3.5254672333742687e-05,3.2643123012973674e-05,2.1440245180040507e-05,3.8887571817136646e-05,-0.00012810855432182633,-0.00019782945249277595,-7.7662951400422897e-05,0.00014426765708057399,-2.1274432415119282e-05,0.00012320100907245446,1.0102538176598452e-05,-1.605497818817081e-05,5.7714933317881689e-05,-5.6046568401510455e-05,-1.7521004885695524e-05,2.7609299548841948e-05,-0.00021782421795693563,-0.00010669318029415953,0.00020791845527659558,0.00011483573627234234,1.3285234615884045e-06,3.8059477856533053e-05,-1.2194043980374991e-05,3.8422458442419205e-05,0.00012682223060628273,-4.4551723471827898e-05,-3.6962727574252341e-05,-0.00019867893992770206,-7.9969698622255254e-05,3.4788527334016846e-05,0.00019429872846807102,-9.2258251254903612e-06,-2.1814133753517151e-07,7.6668947854130476e-05],[-0.040989361407028427,-0.072592926530304011,-0.020477833122960813,-0.025777644705128749,0.022397648046425161,0.0030979965185144592,-0.025475041444791693,0.0014983432415610135,0.013473198352794237,0.015343737042018784,0.013699123091301883,-0.042585561573300484,-0.04138694292044983,-0.088632835869019461,-0.058018494615619191,0.015073506060712692,0.0039591744812569069,-0.0024599044551481515,0.018532342878064281,-0.0072520896771801763,0.039351067096824496,-0.010583759958094123,0.031659008994451787,0.0049459978895588508,-0.023228219899002735,-0.098922351529419611,-0.083752279838564703,-0.038392682480552429,-0.0084343370007130825,0.0076728523005259591,0.048785186591904672,0.017104325073902631,0.020754499614758781,0.049112315782768368,0.05763971849416781,0.019838597096741267,-0.002711097174265778,-0.10015290955737972,-0.1320216915887979,-0.062977989737248996,0.025823602205800371,0.015879808082835109,0.023625409629796024,-0.0046384308741842795,0.026114060550781391,0.091319153616595122,0.15889496663514957,0.077891023551431793,0.095775074298850682,-0.12439872197360356,-0.14160536960462869,-0.075509861563522143,-0.02844030015622347,0.021985439206375433,0.015548610852228811,-0.0023889058702177349,0.034888033953786937,0.071073458263117534,0.14647023139119036,0.20034906031914418,0.16005422621447674,-0.086760118043380546,-0.13617760143493793,-0.015931290696152286,0.005887974985659461,0.0084439895294871475,-0.095816033487544763,-0.06971296020482845,-0.017803306714053436,0.027850106601549955,0.099568377990365997,0.18576028306369899,0.10917191640951349,-0.064365376981623867,-0.053216331409250542,-0.029502881465266584,-0.0098622631787540771,-0.10680613413351928,-0.14825732796410135,-0.11347081176660601,-0.064061353902307328,0.0027156666630031856,0.091809632965261706,0.11261031536840553,0.043783501816099038,-0.0270698877015552,-0.022521165339643115,-0.010411461095651862,-0.062429490602539911,-0.078462922695807291,-0.099126684507961943,-0.097931900585343207,-0.053658802519860244,0.020026860523391449,0.097467511896917089,0.045269155637793823,3.4982892145374311e-05,0.00096205693095272049,-0.0042046666568070074,0.012970749419225602,-0.018376496479439189,-0.044256889054004316,-0.076150433998355901,-0.039790311947249343,-0.03211080346166089,0.060508684856887124,0.066025243127584496,0.043696389663569632,-0.0062411434380450354,0.0065600929269337555,0.070876692004307851,0.055992154723297945,0.017986548813861334,-0.0038241581051177281,0.011310267599780391,-0.010487970918616498,0.020902380949651758,-0.0025446887362083059,0.059004430404734909,-0.013398145289176891,0.0035443428720070419],[0.030346036175779943,0.0060729291720623552,-0.039343234393949156,0.015518327303993051,0.026091031799842485,0.05707488929867742,-0.0076810101047968676,-0.0080709248858639449,0.016419173022353517,0.0028420019312691766,-0.013730810525757281,-0.01952233856199849,-0.016220877105556714,0.014953867372257727,-0.034021908696086872,-0.013762279640316323,0.024752967636295586,0.039530055629976274,0.0045832864073847429,0.0083765062096497409,0.036851407285838494,0.055084117544986336,-0.056975578544102429,-0.029317707997872627,-0.025594697243718541,-0.0209462093989107,-0.058040406822408838,-0.013577428197324267,-0.010020990828990349,-0.0018451035217218088,0.020025419779784451,-0.0075917489409040063,0.015631011927141059,-0.082665619369575963,-0.080551448664543737,-0.050440509420469251,-0.072777006043539996,-0.062636415930186193,-0.071288814601525669,-0.044269272303937818,-0.019290397771040843,-0.00063643565990734174,0.035648090161244705,0.0080665566901492874,-0.069973032306163641,-0.072405787021877846,-0.062813161592231409,-0.060859099341869331,-0.10296927011026999,-0.074726837298926568,-0.077151004103565929,-0.089632117423250057,-0.060207561869611841,-0.036005373570064905,0.030580152351007542,0.018237066287994937,0.02174043579052555,0.026790712318865414,0.078394679005428389,0.079774453891859387,0.048844596953047867,-0.011284404445060854,-0.042892655919123217,-0.060469291421125677,-0.07771702221123683,-0.041768476829136147,0.11044800435479082,0.084453033189816312,0.058716658475689382,0.11796990936830279,0.15001483899962584,0.14682265151923721,0.13948544434843163,0.071900535535049409,0.022951582623399639,-0.037573009410766148,-0.064497267516120824,0.10514145685057832,0.014295615161356343,0.047946276454789161,-0.018432919080500723,-0.0048603160651503538,0.039432239140443998,0.090925443024842678,0.075278132366418865,0.081170655224668736,0.0073833672168802864,0.00032987076164094076,0.022814449998299069,-0.0086827680648501639,-0.048521183046406041,-0.019108747944309772,-0.065560745830540057,-0.080182991518368607,0.0032263375068990836,-0.00099658547565971249,0.052424135738000213,0.022385739723059378,0.039120492922030209,-0.031163626046383244,-0.063939589567716518,-0.07911716509669843,-0.078917040495979945,-0.058880520828822197,-0.10110781394222774,-0.05114064572351204,0.014884135572375071,-0.014461306825219532,0.036091619454282908,0.039865935139445363,-0.028625117209377549,0.02387850967371026,-0.02520581913037356,-0.023467115929623323,-0.076187598481757157,-0.040233406732182481,-0.051995660903622447,-0.040468336476741307,-0.026854374302776318,0.026999904989888759,0.070255583454977802],[-0.0028030032154688772,0.040758904890067268,4.1767863328545651e-06,0.020260138546443159,-0.0059647140070275915,0.05181012213641132,0.02634646200863381,0.012264698464511966,-0.010147315743495306,-0.03354793984589477,-0.019732136738390867,-0.0022577603782329772,-0.016261980311150601,-0.017314099330176039,0.014344127941805743,0.037970408394952859,-0.01383697548566333,0.016742082124341348,-0.030123200807178369,-0.027735921784170836,-0.002268324918850477,-0.01917565837724932,-0.015693411602399308,0.013113857326043843,-0.036320774018331614,-0.063043192413591909,0.0049614486973488248,-0.036804629569037517,-0.037438386219278155,-0.023603350699011483,-0.0072298451341650145,-0.059868515686104032,-0.041755559167967415,-0.034103966764113251,-0.037695383284049352,-0.019865628782664548,-0.037320716015948836,-0.02961465787379973,-0.062378820692505714,-0.077726227410309545,-0.064330260920173826,-0.067627424844985615,-0.066911336391702644,-0.051813667955715265,-0.064044427932397077,-0.040497690544443715,-0.068570648963837993,-0.064781691548234432,-0.077465204305072172,-0.059300747266943024,-0.045729121636768441,-0.033973317009316689,-0.014236662779295712,-0.0051403679981302051,-0.015748032805591644,-0.12090686617751288,-0.11592358261333773,-0.04603582196444924,-0.026967258372596087,-0.0013908674792289851,0.070814456498094619,0.069291900499805825,0.071816590137885883,0.074605172083137966,0.095414524189679439,0.10748657093841106,-0.095995837009767118,-0.0040975794639001714,0.045306386276777189,0.075554395869981195,0.11845891486270177,0.084776040800571786,0.084263987235035837,0.10125452225992537,0.073977388593481214,0.080838313693573999,0.054211476638108123,0.020058468071589643,0.071877396983204195,0.073614039598840109,0.090269964916123019,0.047955914710934591,0.043147097517420303,-0.0011985739101095343,-0.013094268546257911,-0.030256147604258272,-0.0095366918389557919,0.016708576234233975,0.061142458735716491,0.081217451112605782,0.010385841248297306,0.037777595415280037,-0.018148165795748364,-0.025190339821193043,-0.047771796894360688,-0.061855276889718092,-0.053652712540413733,-0.051551732136435637,-0.034374232230165572,0.019703032705119687,0.040214664876207923,0.0094462636189203749,-0.022748100395121915,0.0069180366776436381,-0.015913447714255638,-0.02702812779628725,-0.014329312669455431,-0.027715089020423824,-0.062068298599209024,-0.062014863808505023,-0.021183572775251798,-0.039143122374945834,0.022829943433131737,0.0032038909949711619,0.00034299573515796187,-0.012230615709466378,-0.00321123286886877,-0.025262706824797615,-0.0022994727249915775,-0.027050395247399217,-0.039549420763164561],[0.065220937475473084,0.025071384298351367,0.019912107113077518,0.019312893018644271,0.022456599328416219,0.038123430189094545,0.0055996572848110715,-0.012446229774174283,-0.020127115717722095,-0.019608397123268811,-0.051920391537350181,-0.003802076622644604,0.02754021132514629,-0.031394259292046901,-0.018499328737516675,-0.028503473075545686,0.010984204362234747,-0.0021914954953508982,-0.019643099824274573,-0.042421207289507476,-0.08150780546124696,-0.072243889331467748,-0.0017841827891482871,-0.010892973047937691,-0.0094800158033443715,-0.0041070641350081693,-0.031710787864217896,-0.025316943368023079,-0.048904598523338408,-0.039097937616454012,-0.066266518850005215,-0.057170442088922122,-0.12354156377380103,0.0019260014740339094,0.010454913576309843,-0.047326416677592284,-0.01495404872484582,-0.014952122468299345,-0.060398890698931722,-0.051481889909297689,-0.056998707528354522,-0.05627894012903209,-0.0082531761509003106,-0.0047280014663064196,-0.024889267516539609,-0.046324614411320443,-0.027070396350913073,-0.03551136665508927,-0.041562027780064917,-0.042411071747144299,-0.058674084084012826,0.022288023763534795,0.042564482569643847,0.091510651781399763,0.10752994926292046,-0.023190276830083741,-0.016616935256775666,-0.083807089690502004,-0.058259488808172902,-0.07074223249458611,0.025573920295602542,0.11913595016311473,0.12549016018794748,0.12135882291557651,0.11708353956070845,0.086422717935291424,-0.00030667403806635199,-0.03844014599380597,-0.049405321408958772,-0.092975443881900155,-0.03284956400921088,0.10352519252428011,0.1495830558840523,0.086083576215801955,0.035830958340715563,0.024742932326467473,0.036726117488561486,-0.0024422161164114609,0.00040112728912663695,-0.052518659689077332,-0.044570270280448174,-0.034618820381680696,0.049818549902821328,0.0024548081543993572,0.026915963481285166,0.00043142435222983527,0.012653778112578708,-0.051855646667650884,0.030046740129158762,0.00061640821688112302,-0.031155023683595174,-0.044323068746703012,0.0045373176149612893,-0.0071958412445839864,0.0063657993250404304,0.018539257939901993,-0.030330920312567851,-0.031773666542542808,-0.0088228132461829062,-0.015163459489751625,-0.058175569457230444,-0.0040183309769827903,0.018491731360507427,0.0022898116286867859,-0.025630328318981953,-0.031896766124389749,0.020493167081276655,-0.0060866772039110534,0.0079194766798410254,-0.020676688933417536,-0.031624660983727432,-0.028353726901198459,-0.05878024973072718,0.016740816129427953,0.026376082128799203,0.015891236744592419,0.048440426175221846,-0.0032500905630761939,0.0044459428797915534,-0.016655671281387799,0.0096495524818720826],[0.038712194178439893,0.012490504356042306,0.025251907017849726,-0.00063429003793935568,0.03592838646617745,0.023762703799074122,0.040774989926937774,-0.023414811564391472,-0.048639833740482294,-0.050012993742178324,-0.064429231547649846,0.021779562035487404,0.049861519461227979,-0.018288852383901953,0.035889988699122341,0.020066404067603016,0.049563142262502483,0.0077522337501277072,-0.055571126615815716,-0.068510835596184025,-0.057716925501775554,-0.034900580413033497,0.021956366706459132,0.035414544709005326,0.026124404566658876,0.0017094541674472288,0.034316099935257596,-0.027522376974677576,-0.099289021369931285,-0.072699424099411505,-0.040033682201417037,-0.0025525135698269523,-0.002910098811699801,0.021515199868527068,0.040227070486607036,0.036476407601091332,0.031515192940717834,-0.0086615704493458838,-0.13841198674869082,-0.11458519361763039,0.010450235100959555,-0.0035535572148689162,0.071253276886399569,0.042723571343138186,0.0093416587003654419,-0.012870114338850977,0.032545576670786378,-0.015625402120347201,-0.1166589992557556,-0.14109288836317121,0.067348402717295516,0.076093181341659599,0.11561514970947856,0.050225495205762929,0.042124269950079882,0.02144480828358869,-0.0084782658103722819,-0.012099681800612577,-0.03095626225613321,-0.11121071517451651,0.08286092692880892,0.14790102050186232,0.10500772996280258,0.046748436389971462,0.019903102032436296,0.030520336087391395,0.018229439697434548,-0.010089005330986278,0.001308077365090185,-0.046366176234370893,0.044459976275507344,0.10593917475179987,0.079518755787114162,0.019359952078597017,-0.005288773156741304,-0.072262116264494303,-0.063106627791123013,-0.0032666604463477689,0.031860165644442898,0.01864598039125592,-0.012064807733087081,0.084958238907565181,0.04802342664859964,0.005601477454409115,-0.071195354950384843,-0.070333235397725374,-0.10990854275232402,-0.1177120894307484,0.019377435122344126,0.026706728888751419,0.073583862415767962,0.054153278022732301,0.025448394821031554,0.0040382013610863465,-0.054678863283269957,-0.089932995823321094,-0.071996417021936918,-0.062770298499433386,-0.065225875464714131,0.038396171047075017,0.016151719170832315,0.027022919493260036,0.082904215002364987,0.047186912351547414,-0.0007951610725080438,-0.095891032022590528,-0.049461949437344832,-0.072304694379190848,-0.011679870201172761,-0.03019370550552411,0.014156325508013962,0.050859597296224669,0.039189955160956538,0.061498796624547394,0.022736333947648714,0.015951433136659473,0.015999485485705945,-0.043222982001008485,-0.024248450132379966,0.040111753431796314,0.060524773249175837],[0.0024768759755275302,0.023654123616632314,0.0065904790765780874,0.029715029129248505,0.016981592598277626,0.035002323306005056,0.015060065696298572,0.0023775406467376609,0.015462766613147202,0.0082508228535331379,0.045204211891526569,0.029099062971049541,0.037371073946768252,0.048546717205389139,0.039674546516756559,0.025867829117725033,0.014831551938788254,-0.0075820940876098059,-0.020930287111501134,-0.032499439495609725,-0.0018020463301167342,0.043937967078790628,0.028725701880571525,0.0010439011442610552,0.042588108222669757,0.017847587041736074,0.0022798348220216258,-0.004587349161816804,-0.0088422374374940368,-0.040477333059008636,-0.084833179199067868,-0.075253592768237038,-0.043639965989430526,0.048831110435565261,0.031624229858512876,0.012489522167499711,-0.044447404162642853,-0.023793861367563091,-0.09439256686884244,-0.072032359608776186,-0.0647083446116518,-0.064216711834332502,-0.11171103897265756,-0.098730030535537361,0.034790924045997138,-0.0062696265352133948,-0.037764001610176845,-0.066031600218691366,-0.085654849487946563,-0.056461446300125208,-0.067826191654306867,-0.060587570752587347,-0.060359414639319361,-0.0751011736397387,-0.11166068555690369,-0.049682643011916917,-0.032238361809498267,-0.086484331579425255,-0.054274490762439093,0.010712582267959646,0.05148433045951871,0.072737308199540607,0.066174010870382105,0.047052504278498768,0.01457256785498192,-0.037236312562938446,-0.038926353894852897,-0.045892840879106347,0.010370006985215077,0.11284308997633244,0.12481359471847972,0.11597764568809359,0.11519355137781671,0.11439984797014933,0.11282552440063413,0.072652367921491337,0.069633041676226207,0.01208106094914059,-0.012907318992784259,0.078196952096765804,0.084842433468674594,0.025448732267674412,0.03331830161640717,-0.0032466624596392407,-0.00077916004722033971,0.019237134849348372,0.040467729220002191,0.081825040597662269,0.032173008592532942,0.0072246459578335781,0.035145895408776745,0.032218364331414756,-0.004156953045711051,-0.032283733334807226,-0.048063813532225441,-0.036307980564993167,-0.0088796328542093544,-0.05064778668384444,-0.00020999998824228205,0.029706187708307435,0.032099114896280957,0.0077899941541672846,-0.0059912168184391018,-0.037977889970615276,-0.032942632694837909,-0.074827929106081326,-0.08659379822525845,-0.070294616151199862,-0.021597866813346515,-0.034674752012622045,0.039149518450188769,0.016074895570088787,0.0072486058613543264,-0.021666046904459044,-0.015742207167039945,-0.05712862549021637,-0.069825857774372807,-0.04304681823818908,-0.00021744057288860825,0.0031613995838588056,-0.005483972769325985],[0.0078584091809587239,0.010417579110589992,0.015826355571398901,0.027799757333554075,0.037504301634208481,0.021889790101079235,0.038404904299075615,0.033823662292883222,-0.015110545900434889,0.020273256963547384,0.032943002507679647,-0.0012523671626505639,-0.020725236647321815,-0.012427007685905524,0.015267851215295052,0.015474020823992577,0.021471502743067288,0.031768288951377815,0.012185070684608057,0.0036406626398330366,-0.0025327193617110944,0.0078853574405562885,-0.042335704666714866,-0.056683453836849029,-0.026575160075451746,-0.028598384095741225,-0.042657752775160783,-0.041423915179024752,-0.036798184223634865,-0.038262807915101713,0.0019026661303272879,0.0093814405628215997,0.0084715945489586136,-0.045038182654970449,-0.075791753641229712,-0.059375219468428109,-0.061831665311961263,-0.043298853126234195,-0.043800781365845892,-0.051617842166787962,-0.06561103766772261,-0.047247281088380666,-0.057968313986108362,-0.0096926997405703125,-0.0009781358811463553,-0.0011437786713959204,-0.03286534603195844,-0.03543397020422262,-0.072328933800212672,-0.040236082624187208,-0.06694954641402831,-0.082126388033458689,-0.062803853478933039,-0.081491583056840441,-0.067532179029439018,0.09455840560652598,0.050160391480084388,0.085678836867230254,0.046323368625148131,0.055992607831429286,0.048911953221190102,0.031194793059301035,-0.0026453507092326911,-0.040343576884242428,-0.097032593515522902,-0.10038707585163729,0.0739805809466271,0.044680789118382247,0.049529551721828768,0.11289040045432666,0.077052640980907514,0.08763910565106886,0.090660770031109728,0.083977779480882225,0.064049007217798604,0.02432712562725322,-0.042320375772835706,-0.0021388818804320281,0.0059538906304443806,0.0021758658789993446,-0.0093587766742978112,0.02428998075376837,0.02607694341280449,0.078772783324117121,0.091982202732447615,0.064361385528919693,0.081984130680270037,0.028646331657783269,-0.042604626187250638,-0.039659301448687317,-0.023542389520778348,-0.044811266972915445,-0.037047417039871328,-0.027700762351676803,0.0033550142769088881,-0.013100169049559234,0.05927068198924744,0.0462821833376071,0.087354800090269857,-0.053790152494941693,-0.052155542043995237,-0.05679486910467426,-0.021944281329168733,-0.031143592336575283,-0.032408839769337699,-0.013571281557370071,-0.031193974331133204,-0.024377807778057786,0.029148757012459989,0.030672698641111273,-0.022977914200020516,-0.011077006000089942,-0.005511238658071696,-0.016195245042137235,-0.010223061193558224,-0.0017693869577628148,-0.016982213231712635,0.023120107237225143,-0.0046448944161024547,-0.0051816660513786528,-0.022733320422779334],[-0.0090421114800203067,0.017452648291795582,-0.017831824210342989,-0.0037291040947286724,0.039064969998310481,0.02317336140566292,0.017934159994940135,0.013098455548679191,0.045167700869445056,0.042194405025245518,0.040022284994525766,-0.12964953846391289,-0.098695979295591207,-0.057791701915265933,-0.036039163287215216,-0.028193969502811,-0.0054251636725232699,-0.0069512490121659137,0.020700356583589666,-0.027658839175524981,0.015383455695099066,0.029921130490476885,-0.10604073203109947,-0.13745243530604678,-0.10216024104657673,-0.082044560977983155,-0.062542359265559622,-0.0060266314348334099,-0.034856310541847978,-0.019904486880246444,0.00031967817856416725,-0.032389674206707089,0.02439765120257871,0.10508921937209786,-0.013046874416846273,-0.077743955313128527,-0.12222903080184096,-0.11250348266352571,-0.074496424196395211,-0.056697350656609337,-0.041103845003295766,-0.036650131470619435,-0.010932005853568957,-0.016449841939567944,0.15622348456563409,0.096726642307413055,0.054041690574303913,-0.0030989655565997892,-0.046208134463465035,-0.065923493353222368,-0.065578917403099152,-0.059507067127686442,0.0088062798799869793,-0.037442732388913005,-0.017902872235218317,0.092956218539764199,0.14428628109803446,0.15460969896616991,0.1048812845736138,0.074650094161246447,0.031358758882895854,-0.04452428857515188,-0.028002592637281058,-0.074285506534393586,-0.017952472566438823,-0.023442772221301825,0.00067036565834080464,0.048256451782623298,0.064112377935327092,0.12605612565913182,0.11963258828536688,0.10488112893887513,0.033679327685633892,-0.060980339086270673,-0.043663902054247729,-0.023617241119377099,0.010588509810459399,-0.042280794649115334,-0.020903906039379281,0.0042454596033642683,-0.00023866951219775334,0.036855270749386923,0.064226116507300965,0.058946958099653515,-0.0015713950413312611,-0.0095707447875607171,-0.013147541392034126,0.01220983149141934,-0.05139007557791643,-0.055205672622494331,-0.033651076834393279,-0.030728487231012208,-0.0069395759324256887,-0.011575545867157727,0.0073685965063561426,0.069747145603705707,-0.01352110025060841,0.0065960127234735433,-0.019525371968609762,-0.017643912421121496,-0.036983208587429477,-0.032526065041563926,-0.059542328663049392,-0.021432558932001102,-0.036208028263420761,0.00082772178238150421,0.048327127751533125,0.057950807377417229,0.00157328627865716,0.0068908384829364025,0.04482168429267052,-0.0029221677687706754,0.001555929650738838,0.015954469458610742,-0.025599595653019336,0.047827295986180768,0.0062288949733256688,0.021267131642709981,0.057035735175472703,0.018964085848628326,-0.042249457791622765],[0.082567408275720941,0.055832613072691675,0.037656390091085033,-0.025000895212346053,-0.028412812812500174,-0.050161619093851889,-0.064108798123226451,-0.085322773771942473,-0.01353721252260974,0.013708942774828675,0.018599027844067556,0.075347485030620276,0.062559343055246922,-0.03128511392926582,-0.042802981085729774,-0.031429420711545787,-0.073826763416081242,-0.024221657973838032,0.0076412601149810772,0.024211901395114054,-0.059471082878315346,-0.030880411920166984,0.067967009546189686,0.04082287464016688,0.010013710465744799,-0.076238220410531951,-0.068200014146132609,-0.03367028790032036,0.0026545839293711116,-0.046483364330604897,-0.013765405332683583,-0.027634708597073385,-0.061826223020465573,0.031594341220290985,0.021366233937152687,-0.013394045470305607,-0.094757756449669439,-0.049118966746885373,-0.045552478080449647,-9.1106347612770686e-05,0.0079383464198565928,0.011254760704320157,-0.006576707889103077,-0.047661893009333725,0.044446166087195968,-0.00093206421252194083,-0.0095390604213271557,-0.050732858964937649,-0.086831280616566725,0.032526279694198093,0.092701707289924745,0.0094083798882231232,-0.023484064976748834,0.0092934449765007306,0.02279135558872019,0.039002806478279112,-0.008609839726177404,-0.034767835308972636,-0.031883916942249346,0.066428675225469649,0.15091207989976943,0.13215693372891743,-0.059200843092382029,-0.13695949641012162,0.048045367981310844,0.098721373524397166,0.012407354261466811,0.015256770812382667,0.052010168560839946,0.10320819909661162,0.04245915005083583,0.088724399991559885,0.068938951136573001,0.01700823743506874,-0.085317525028892435,-0.018126337068159522,0.1151877033509508,-0.02501683859550265,0.019451431676204792,0.022494547242750674,0.052600283738925238,0.03386730293679828,0.032216970357249304,0.059359611168712786,0.014140731647494846,-0.025091371779791677,-0.026683396681205493,0.040958328581346411,-0.050855525747530585,0.0049323754481217317,-0.00049816712567916054,0.0165528823762962,-0.0059580238260248993,0.045306611135122,0.057897639956120503,0.042726052702478742,-0.0017969310686201884,-0.014382085486339657,-0.037002141588783934,0.025110698146086761,-0.00016281815464665172,0.024515446575861129,0.021258758684308279,0.02440056095349824,0.036876396850616146,0.039422926098447282,0.040371042135130944,-0.00092562301771988154,-0.0052628779193808206,0.0093270497285016501,-0.011241199658509435,0.0019912846764176652,-0.025004542955752537,-0.0056085835864598393,0.014352464943112106,0.050873140541023154,0.10004246984101947,0.064681249139415239,0.046195695636661947,0.069300630286532647,0.029510327635330871],[0.031888415387708945,0.017285328668591005,0.042744527705477556,0.03122774045587115,0.025513813891834124,0.023253690464280233,0.017244825416223117,0.0091143993389209352,0.061254787835178667,0.028607811797974354,-0.017058017936675305,0.031260250011373267,-0.02279872758399017,-0.027837704295921042,-0.031937522919072092,-0.0079426595101877613,0.0022781874855602822,-0.0029790518398695341,0.014262174386869931,-0.011888449098713878,0.10179674598415357,0.017490236098508173,-0.02165996876082555,-0.029500462768637277,-0.017844168428477268,-0.0065925436789264179,-0.055317992740958985,-0.009073270159867055,0.00041946738785142434,-0.056492643690931717,-0.073201827719489312,-0.04664521751707891,0.062081869164307177,-0.03133901253116169,-0.065409572850245706,-0.026259743760947321,-0.028514182658014458,0.010511476228221489,0.02613935213955948,0.033080893278420273,0.010410015030915412,0.0083593994733951738,-0.066648409600459646,-0.061126901668253825,-0.060660381708882702,-0.029413222816308055,-0.014383044755888905,-0.061112839649371503,-0.086766346192871005,-0.11103482776376336,-0.09555898737155176,-0.06964802327565453,-0.044427747427205108,0.025755829147256798,0.0069560148421303133,-0.081587604416162807,-0.10519239832835522,-0.071335786418767255,0.00057041734117410647,0.01381305071587418,0.02671011460828427,0.049812200550972158,0.093581918010311488,-0.021925041934278508,-0.055497660342767811,0.0065150133739862448,-0.054554119234424388,0.00830487062795153,0.13185407364756932,0.1221341345788353,0.011707416843401106,-0.025907153899071139,-0.024819747703220919,0.054010873733490401,0.13634127194350476,0.1239665593358083,-0.0094684152953362077,0.082360263679196688,0.12981624266421773,0.03824468200113923,-0.028862798409555725,-0.012401760304334902,-0.029028735431258695,0.0060991842887090728,-0.0040297230866682713,-0.04688451714216009,-0.0033330755921011992,0.055326238808625749,0.1303088292739335,0.014467140584733071,-0.059526756731551528,-0.024457345180703714,-0.0011606998001983324,0.049886658808720834,-0.021188637788723458,0.0053422931322432837,0.019766544177656983,-0.075051486751190319,0.0555814059557561,0.11043646644803568,0.071964938687580013,-0.090663298598382638,-0.035117192369403236,0.048069490373574331,0.041133552052815187,0.083493841136462049,0.029110800123453531,0.031266615170663099,-0.039507972523892779,0.027490662445642008,0.092284055227579875,0.066698389632811675,0.0046770738712216178,-0.057627559498254564,0.035842091912123522,0.082677685179469218,0.097331854898258463,0.050682016519834582,-0.010180548751966102,-0.033100630833083927,0.0060053227921194573],[-0.017680769530502086,0.0050575359825280469,0.025215835784359819,-0.0050258332473204909,-0.05703325304593862,-0.052107314429079093,-0.045596915669796345,-0.0066502467091907602,-0.0040890258536624702,-0.003602657066238215,0.054264533749242831,-0.041054754537631868,-0.0014472636395811613,0.034596974606557113,0.060835620970621208,0.029247288961593898,-0.072140352884815212,-0.079672750193131428,0.0063943947450929156,-0.00075078758391063094,-0.0024171227661776481,0.00014142207761613443,-0.071900657382605787,-0.071309977692602319,-0.070946767853089718,-0.033682470049253795,0.059045673260628345,0.098589338565389609,-0.0012453848467233811,-0.01886197406327271,0.070384962538390106,-0.0038593266123758303,-0.035716458393740325,-0.028903911986307623,0.022169135417800519,-0.0056379833253350636,0.015211997809574936,-0.077801426518747177,-0.029803914664715693,0.019461806372238301,0.066876022242886704,0.074347040390291497,0.075531131612437005,-0.047354917440969799,0.038231304234948887,-0.014507685304722101,-0.088435278499214176,-0.10062367804515003,0.067343499222200565,0.024924241317476573,-0.092546195735034087,-0.014997924286342293,0.027950457247449642,0.066063768451511823,0.021890400355813813,0.13086032772885903,0.090325158487119389,-0.051343743059489008,-0.10634460607642149,0.041577154860304527,0.18956400875634438,0.15361519295302384,-0.11769518397502723,-0.063931131406821079,0.053765417183016397,0.012820707173704704,0.167023415641573,0.091883459451496383,0.046064066872463991,0.025159894360370735,0.071125103615519797,0.035423035999105047,-0.002838856695844709,-0.062881344605136932,-0.078523790463108811,0.0060488942027592946,0.03132431227969934,0.057799944092782066,0.035258713861660206,-0.015525519214079311,-0.051490678426958481,-0.070998438684272358,-0.088339548926410272,-0.063258396382083443,0.00058157944958722729,-0.016398858534322075,0.063472042872487172,0.059448129985677542,-0.07202298014311552,-0.020115104672309998,0.019270115460302426,0.043044608199681589,0.00016106438180805288,0.009691999561702698,0.0068556383978288504,0.049380946460201247,-0.0045235379987111357,0.032977942564106202,0.0312528099407361,0.056899719241569002,0.028262649207511509,0.035152375519136879,0.035461884262258922,0.039852047474645012,0.019659199103084442,0.033958299060307638,-0.019839700512063366,0.059036824142858109,0.0097260124868806426,-0.014938126441501644,0.019066829899126298,0.070681909220785974,0.067102293590922832,0.069012992594614686,0.010044929257701042,-0.0063893114284036059,0.0050956154428648042,-0.045817829646248108,0.058780525393498484,0.015058802906741012,0.0093868702997460529],[-0.059247418607529398,0.0021432691584650498,0.003053764423463598,0.00585551031972327,-0.085630217055580576,-0.071756493495543111,-0.042450305971163171,-0.042689147138431187,-0.011110262401512888,-0.0079405339217739623,0.027079022725668131,-0.027546655085047056,0.039877525719018654,-0.032474059766464794,-0.046922091139332156,0.033617721815522757,-0.034287802568748103,-0.043372117290399935,0.041613978045622203,-0.043095118331613398,-0.010110834614272646,0.022894839712910425,0.075386609934159521,0.009212959623099537,-0.08827817592255309,0.037397659635345859,-0.0022263066749607652,0.0099245075234207572,-0.020030347390232447,0.056811150198365509,0.0073928398206897228,-0.0781863011094375,-0.0081464259829627586,0.079203527612630331,-0.049193984035058869,-0.10782004673639323,-0.041093953548195783,0.036883013437131441,0.037669473568050518,0.013220385631969353,0.053407888162839971,-0.026733606753513141,-0.12858397516523337,0.021075355334599859,0.12903555239275516,0.017326720125844478,-0.14567221562979574,-0.082472121566578308,0.058956938749701163,0.11485586936136895,0.1285955897812025,0.095518552742746426,-0.061066124259299644,-0.0067976743155836045,0.11055046294774236,0.11155870568673898,0.11891259668944891,0.017851730403568578,0.00062816999621169434,-0.005602233426512779,0.077624806223943812,0.060406967434973535,0.059516586297504614,0.027001848941292254,-0.044412198771888872,-0.02565017828887654,0.068363333459277184,0.063020564366818924,0.059444497458773948,0.010334144455870962,0.042110605756137134,0.0154145426818727,0.0023343740302978946,-0.027062765771009509,-0.053547005048963876,0.024499224751391858,-0.05226763051205905,0.088856993121431069,0.023557929383932572,-0.013779427079024981,-0.023579161648517932,-0.062755190864561161,-0.078234101715106377,-0.04428664124215103,-0.05597874471510085,0.032155339112342099,0.054400692992883637,0.048229610031197051,0.045141190902855795,0.038704798976786192,0.085911390919109945,0.004357866690440651,0.012844338732011615,0.010882943225392516,0.028932161983739102,0.064841494314718556,0.0083150497181525597,0.028736590709835023,0.052023311678142746,0.033414052448422112,-0.0015520060820524428,0.042606687446733821,0.022301779226108837,0.022174303630313905,-0.019435737837121839,-0.00050395773291792012,-0.0052139822121909096,0.03017407278550048,-0.0046409824519108023,0.049755854435395347,0.0048321724860692639,0.052625745447092698,-0.0043469856762714323,0.024475775577038505,-0.0014550689238583339,0.0025587670842842497,0.02335062238389126,0.00075945420194640373,0.067061312439412685,0.066720064906692217,-0.036179831263457696],[-0.057111668714524069,-0.031888560395926815,-0.020364646131771198,0.0031373605136144483,0.013436737732060224,0.0059512553325854946,0.0080221362250533727,-0.0033221874193103476,-0.004827846253580151,-0.026659247927967398,-0.062783175554247617,-0.076967276770677301,-0.033637293299445814,0.026369958665574775,0.013899807316877229,0.041920953666546329,0.050480088450960914,0.040061952380199911,0.044564528130835168,0.0069941117747924636,0.03093737186111541,-0.0062436290541180578,-0.046320908761036353,0.011237053256609078,0.03625881873734127,0.008296320294636228,-0.10315152186935141,-0.12978400882646329,-0.10762360396379125,-0.028238442365860296,0.077774908415915764,0.057645200841886443,0.020682314424331508,0.015698799166135785,0.023614524698368555,-0.041771874129604925,-0.12746951561572256,-0.031282550658931839,-0.012702497649368927,-0.031002821266721811,-0.053233125623346492,-0.11694882872058675,0.019915333787276241,0.030434079899803762,0.034286620375398126,-0.042572007349056584,-0.084215624143568424,0.069861287834688535,-0.012204622606775559,-0.018891406834175561,0.019639551076716097,0.077724504862555804,-0.080366494513686909,-0.015106150328832637,0.034588469301179037,0.11597907830248098,-0.022649572331124024,-0.10542134577114659,0.064909164241530898,-0.0032238315195849358,0.10106249830020778,0.028244619862228884,0.13831334399041184,-0.029406130060508649,-0.1747975534137946,0.10110596129570967,0.10656117039170004,0.0077235863703064567,-0.14344418956701926,0.050109495007546564,0.086715745692903579,0.093089685501030639,0.12450293694496621,0.12884230003597821,-0.070419779564091803,-0.12323154963040814,0.070753486613016892,0.12050632408764064,0.010233622798694719,-0.097733233903663133,-0.059331174485382117,0.058782895880653968,0.085326083200578981,0.076775855235002285,0.029787153121228482,-0.018648323277872803,-0.021041250623019279,-0.00034304860813555438,0.084298241516976985,0.056835020648177442,0.053326494938013475,-0.039638663459144921,-0.0050145752734991195,0.013779029282405111,-0.010485661499173113,-0.007234560404816931,-0.011950044363487594,-0.002596863452470205,-0.039481955312791167,0.092829813875564882,0.04294346095881349,-0.0075415218000726147,0.01831664591755916,-0.039130110094255752,-0.041539280566723305,-0.027051679902780887,-0.042059150111380464,0.051858253540492213,-0.038626104291501345,0.089621659475075818,0.071389073995249491,0.086449311698936798,0.055650817209077025,0.013638815876452798,0.017995842737628248,-0.01801617871484959,0.063458705330672521,0.053363636563368205,0.074742248974209113,0.070779246477809463,0.038021312100079668],[0.016782329804763754,0.022184009254756339,-0.017610151854017764,-0.083789286898927368,-0.061012255632239214,-0.049436805730274716,-0.016010628978889538,-0.0012930764671227057,0.018100227337522104,0.042203188910774361,0.091115107725438613,-0.030973163753086161,-0.0032195286052498912,0.0016759860931787329,-0.014121001324428797,-0.048981904044656924,-0.010745318377515141,-0.097652326517780441,-0.082418824248892006,-0.0086675634058914763,0.038492534598761105,0.038421970823334595,-0.023684080137090627,-0.042571211439382639,0.02767445118866517,-0.0045846119818084147,-0.029036296488781282,-0.014288492306115716,-0.036492483953748919,-0.073188419406786581,-0.058473938306242701,0.061157356628457379,0.037513132599877139,-0.044262690874014056,0.037080163847070004,0.0088659608282077099,0.00080272687834155587,-0.029635044582425114,-0.061890394619628558,0.0038985935655814069,-0.055588932181221483,-0.064825910358400518,-0.040454364747733541,0.071936402641623182,0.051467957240617299,0.016629850744416953,-0.040009434139141736,-0.019115829817856561,0.091904921049085792,0.06837146364091487,-0.035381668896085239,-0.031695935446360804,-0.023950933267367816,-0.0394003966580148,0.03763781004513285,0.1197050728253103,0.089542091951175892,-0.048321863792027797,-0.10361580068468161,0.03196026187380821,0.22708318047185561,0.096992802612123799,0.026709846902001309,-0.043788789977080037,-0.030431230119196698,-0.036199091708226813,0.11281418451835055,0.058353797638634589,-0.064975276585847841,-0.065781446400588514,-0.0084482038519338096,0.091241523771951369,0.12717594497795892,0.076435365308040473,0.05263655140428726,-0.011143586147963506,-0.036137839085706183,0.069124578846449444,0.013398711580413412,0.029824240574494128,-0.003761299877294923,0.0021895992476564027,0.063411958556754897,0.05214012614545932,0.05038609451252047,0.035324986438009076,-0.021229516140167864,-0.041481082779968939,-0.02340383743107953,0.025148825203493166,-0.0071054288136557786,0.029757691086840125,0.0085264919185421041,0.049978808930559324,0.047608485947021148,0.007387529728713386,0.023177640471752005,-0.034372485157573206,-0.02211841910582997,-0.03255077177054265,-0.0095360632808114149,0.02395181727198023,0.0097167002818091229,0.033561780635984223,0.044589517984731777,0.040595502460242246,0.032653779800933931,0.0057648668309821221,-0.015195338017169461,-0.04482684339688519,0.07120843129770589,0.041893263952033938,0.048927297048636464,0.073827844317264732,0.065244542220815133,-0.0017292511368722507,0.058389555203693405,0.046492272714646857,-0.044448592181834709,0.0032057986445928333,-0.083491824073505749],[-0.021979451476262124,0.041749536510466173,0.036317482818499322,0.019303759385788856,0.043331105658738031,0.039532451044482823,-0.03647609905532502,0.012807077503951922,0.022713576127722859,0.026792414564902785,0.017780821834078364,0.021847416207194322,0.035542788551473518,0.022495282054875682,-0.019211730168732774,0.046687383535703716,0.032073200197188671,-0.028686832095504631,-0.06812268823509858,0.001294075100742806,-0.034564145835298599,0.050972273139714794,0.017344511387778011,0.035613261169431379,-0.047698589768029459,-0.033623331365756862,-0.032521260678616007,-0.0013900797467142137,-0.038202063259482284,-0.031763114785060997,-0.046960749111957488,-0.049070236071480984,0.017434726053958804,-0.030703215315142654,-0.057162301791745529,-0.0037112416196131703,0.0060696367369069372,0.038135057103153125,0.011368938851434945,0.043811886314067822,-0.034217588390491993,-0.05354120670482268,-0.039937408320660416,-0.061769626775271688,-0.035240350915125673,0.0016450283116066916,-0.019800744266528034,-0.07722000486464739,-0.075502378494275851,-0.087592049096889849,-0.11012945508577086,-0.061232503015605372,-0.038229892765514702,-0.064265277827533399,-0.052614544822152443,-0.023205841324039467,0.011034902978061789,-0.00097880135493109283,0.015271729427483255,0.010026868737236877,0.057985348035531209,0.070840729971491434,0.019039403044224391,-0.041761958313936615,-0.15551177552373613,-0.07628198734805558,0.017047176529394591,0.093014754421786722,0.093581458110479965,0.043402580662633972,0.0066461038347559332,-0.028933285567003395,0.071468870303731766,0.099203191964259974,0.16737897607114252,0.069043657929340946,-0.07749686881409408,0.099573378334475354,0.048571278979090152,-0.0641451014524268,-0.017708931611072284,-0.033773357420827717,-0.036770341744953708,0.021125297287466011,-0.03253144131642647,0.016179841472347585,0.090577750229154597,0.10585324720051341,0.10393909903192404,-0.039146928692158481,-0.030447885188444671,-0.0058756393399591045,0.0049200955007691616,0.065014535940290191,0.02355974270510458,0.0086861952813323678,-0.066304296641173113,-0.0023589044880598853,0.10485324285454203,0.041243799776074036,-0.0046939490366109116,-0.050265505473230082,0.079897314990575993,0.051811860629177822,0.05936381965465605,0.063038602309119562,-0.0096553750564754778,-0.069242556576336475,-0.047051759275558228,0.071057903450201951,-0.034427035272532699,0.033352431404995275,-0.038713428810432646,0.040541117523422751,0.067513694210917949,0.082805954892964315,0.10708141658638523,0.017928056812146861,0.0011601162267517867,-0.043673577511548753,0.12867110066084922],[-0.051871694661995885,-0.019280829936621956,-0.054682607758164609,0.0009447920461082629,-0.013017072859738549,-0.012890228722627788,-0.035616894294724373,0.0014514513795995301,0.042883217734102162,-0.010520379849197729,0.007557764016209687,-0.022057597937526343,-0.029115164929706994,0.0012528790852251032,0.023269338421732191,-0.067474514241851885,-0.039425127112679564,0.047182643334052331,0.018571000663569977,-0.031453248579785112,-0.0042627544710682353,-0.065390808213087154,-0.062309588573350783,-0.00018350956129405474,0.03407593431333647,0.020712134681679213,-0.015816412935546649,0.036106476966187746,-0.0057176038296621896,-0.0078034581275657263,0.022001767580951286,-0.075063089515289755,-0.056833269479676471,-0.078487811169271574,0.053314994300153781,0.08979192045945919,0.065579735163271619,-0.02013808088107881,-0.069354719259617226,-0.012900359094848712,0.06749429214896617,0.0052091689986741314,-0.0050445817378490798,-0.034013340544313847,-0.049220624377965441,0.036992846717020605,0.073527164422162408,0.023626785644426024,-0.12668833039918156,-0.049929820048297914,0.13709290290146586,-0.043083359856046347,-0.11283440510072536,-0.022957546531399264,-0.016380363567833241,-0.061480443278703056,0.083722789203042061,0.026145798642064663,-0.10930012120125338,0.093485417462155301,0.21229414611822872,0.12152486504801896,-0.0085143078714366941,-0.11195109821400444,0.0087569591283611289,0.11393373946480671,-0.058279470412456076,-0.0080421662325995125,-0.0037127964633908161,-0.090611461392314269,-0.023750445832424479,-0.0033262359419465592,0.051599394503568374,0.11794682063279016,0.05218760955456582,0.051040480785423475,0.13055799836266763,-0.01221412005055704,0.036431789368042852,0.036670703720440317,-0.0078012137698507981,-0.080637182319625592,-0.098441747577097227,-0.03508837974768049,-0.032648567450681995,-0.016984796908047974,-0.027536458166992319,0.06115870091554932,-0.0051669231621845379,0.054346612146431938,0.045746752439773088,0.064739446750120125,0.049552711275373883,0.018862295590649777,0.048983187153556228,0.062541985576739914,0.0072514834621828835,-0.023346720324739785,-0.075601926169402353,-0.057354038392425574,-0.017630696493874162,0.02294588190926191,0.090873111715422297,0.0042984842735071613,0.028246302042173196,0.0087607006248174284,0.07435181540431253,0.035004927442402321,0.031603063242742584,0.034524004650933401,-0.076590160387399964,-0.017921124400819347,0.0062988574109997869,-0.013815145103657209,0.080616454932859072,0.019781761084500894,0.075647735229095237,0.043189525185656379,0.074149096904190248,0.04770033275626058,0.080840156186910761],[0.026722003554860107,0.011659299846958612,-0.030401027328402285,-0.078933516409380317,-0.025083013651028968,-0.051258138411005405,-0.063738133597399105,-0.045360978905662902,-0.0072454540129453099,-0.0016165196721033143,-0.089855064600654358,0.0097207854833627934,0.032566632530092121,-0.063546487797010456,0.0040586505412308974,-0.011780242044409216,0.046622082528177268,-0.0061913239369574095,-0.00040805875755831446,-0.038285077303976116,-0.045803388237714085,0.00013567048096911616,0.071841011636230273,-0.0035184890415564662,-0.054904449860221666,0.02924191756204008,-0.01689557308935365,-0.018744528704994677,0.075716926828176739,0.019648278025953467,-0.043885654656954369,-0.018293295448074808,0.029236899127084933,0.079480753652723696,-0.10678554242785285,-0.13518893526708742,-0.0021617736445511959,0.057839422567807532,0.046852963852851211,0.010613998677874176,0.039439684131787889,-0.09285753056846846,-0.05413777579109947,0.041015207873276241,0.06345089058106948,0.047469937132271711,-0.11150623495169829,0.024332828493630963,0.10456565053537453,0.11492526729638461,0.064349122666039232,0.024960207207532441,-0.12312652337245503,-0.0357276852240003,0.056357845948048858,0.035122396434681416,0.040853396388258245,0.0048171237774400641,-0.018877573782764997,0.063834223394559408,0.099594433304481159,0.10457424633849259,-0.0059323860818025122,0.051540993351738555,0.043792467918237224,0.06682182319421423,-0.022981366626334779,0.012623816899516915,-0.027434183623551101,-0.037320166273082822,-0.040760599767723449,0.0054311112775042138,0.077856612886341992,0.061025832668360973,0.06291439314075388,0.039278945628749652,0.051551436211894681,0.068228206982137857,0.053793243256798989,0.033116294799969533,-0.087230566689965136,-0.062413283562578893,-0.082179387336970056,-0.049408458616677628,-0.051359759856891118,0.01704176534606279,0.0083052629894674324,0.057973181889856361,0.049273067989623984,0.050549115680086437,0.054189519887507934,0.076357459282641149,-0.020159764614916531,-0.01496772437088123,-0.008318755358141354,0.032399494222174856,0.029724547489281376,0.081167503706311317,0.0010766805091777659,0.003132081148303891,0.039599122177480288,0.032665101862452292,-0.0076123889523127567,0.01439000505445691,-0.024144476806805197,0.015900895762450868,0.036463449654478043,0.0059983182179931529,0.0073771085938482096,0.068757588979111023,0.0018450028156024381,0.058983317021274982,0.061022660493410763,0.019189271609420328,0.052228673471552065,0.022903569800211365,0.0093545739337794684,-0.022264194312743783,0.028742917273488648,0.031821039680558945,0.031024768487282525],[-0.024931914403123902,0.0067371102591031948,-0.007391490442242972,0.017496948430487498,0.023422622609065046,-0.0094928852122032684,-0.021940305477306223,0.00025349416488679166,-0.041633427271842161,-0.046280330971315689,-0.06778901544234435,-0.024673968258041953,-0.029907852335896074,-0.0063449215025076638,0.038828302806607679,0.06846252343470445,0.027205296230138769,0.034295058790694666,0.020017420759176036,-0.044147644646415102,-0.059872005422267019,-0.051482095492071264,0.011124069340270715,0.016763058258717323,0.050886840442624481,0.02549815480352427,-0.0939546655207978,-0.092391189277661337,-0.032479032153627907,0.034462594953754824,0.059969474942545953,0.025584824798319902,-0.054353591667338476,-0.021502238752819661,0.051546501452992721,-0.034007866675401628,-0.10294183533637649,-0.068214384945964324,-0.036091128635311429,-0.035862209668492087,-0.066950369902671863,-0.0788669358196743,0.01348990123782938,-0.0092991627936537726,0.051242254594595721,0.063155120324530495,-0.057574046015223528,0.018890388699001628,-0.042698436177047515,0.0063897190194895787,0.035993788676757676,0.10789490348622735,-0.068180236257618904,-0.075881929824815911,-0.019747504672663209,0.10735747383087241,-0.03869822606166641,-0.15857079396383206,0.077711698878954072,0.0027821735741544867,0.033503358473603001,0.044529328438383697,0.11469939192954226,0.03762916616171235,-0.11802211992760672,0.089816131200894628,0.14094896752231051,-0.021944857285476876,-0.18628488220757861,0.05722715554404334,0.17885030648332761,0.12350597080986565,0.03287297640709165,0.13094265605576585,-0.079054276690131695,-0.098874284973658105,0.07103695210415123,0.024172138802402793,0.044359819339575904,-0.051012505698565642,-0.039065923553229673,0.10490932756038186,0.12042204998724948,0.16359720010359963,-0.0083141685472531146,-0.029805224335517175,-0.023079186944148275,0.059849592266809526,-0.035424217542300893,-0.025330293256378603,-0.034242830366423213,-0.063441839555084145,-0.046964192520516257,0.00071815932595863455,0.022784193984670673,0.0091085690333239377,0.017544256490621302,0.028537852311277645,0.080903467002397131,0.062288009683574119,0.048189715163459962,0.021557195959710354,-0.022313472699576162,-0.091203959029137333,-0.048678117782736216,-0.018880976433473903,0.02319770864597645,0.011883122070171566,0.040745024174235034,0.055217772192963144,0.0752915524448943,0.12950685960404881,0.034066733228072771,0.055263332392194921,0.00092956340022609663,0.0025829434849187483,-0.012623470754591415,0.045045466234092293,0.035721398778730123,0.073251215610966064,0.094939799788321122],[-0.054693996761883468,-0.036142257709420977,0.012139987915473143,-0.015154402745934992,0.0068463302216838166,-0.0093136851521987245,-0.048684400948289616,-0.049430372046362539,-0.041064971222999513,-0.077253849675155653,-0.052659701580420708,0.02644006417674272,-0.035825803881623458,0.00018949187702807166,0.020886062450068934,-0.00065949460591928355,0.022071058438621102,0.0040313708607001772,-0.035333022236136671,-0.028226767346863704,-0.01809822098267436,-0.020234382561405761,0.015320984616764413,-0.0014404272920333708,0.011179661842263149,0.011479905349418697,0.050415046288148357,0.011825597601556187,-0.0058861573381156773,-0.010693467291456787,-0.052711803776757507,-0.039587295536248207,-0.015153382931397254,0.021776177677289621,0.018485275683894062,0.017270703576438604,0.025545107202705496,0.003552691996951074,-0.0072077192628247633,-0.016927777585758572,0.01010327735896166,-0.011396759513419105,-0.054135995207295812,-0.008775918099563268,0.045428799230222999,0.026078742599032825,0.018401462157094414,-0.010304766106153093,0.031175273783970961,-0.022964877769659248,0.0073488459201091344,-0.033664533213207795,0.0040173488287653797,0.00073105699963767201,0.00092920767763406131,0.038455564657623509,0.051027184464204699,0.032163653730152494,0.003091909476963195,-0.01805086224294028,-0.037580600034212458,-0.042983404923079879,-0.032973836490514191,0.0034357039654534238,-0.0029191330430502482,0.049102114568624511,0.045968351963145374,0.037533034565610877,0.053551748804077495,0.0025191362420830836,-0.04750855266321341,-0.072788896259128044,-0.064427335224849849,-0.041220523667029399,-0.026780660598796205,0.045893029004908492,0.043426979158010505,0.063353229422186602,0.057675805158847071,0.04031026644948954,0.041067495849464855,-0.051029374332638877,-0.081222848002171583,-0.10623271352478328,-0.040384319505111455,0.012698889514418027,0.027850330309453372,0.073422603729637589,0.013872383376783981,0.086837219868510659,0.078231498196284319,0.025402065662503196,-0.0085959304722693069,-0.1009426660553958,-0.079770896634910687,-0.089307575006007389,0.015197805521062258,0.061289339594082198,0.065948610641877861,0.041035546434975201,0.059557826909646928,0.080006232863982965,0.074882607029051015,-0.014113346378857847,-0.032420747653342651,-0.11384852443855065,-0.10291516846863054,-0.012980508793377513,0.052220406103339362,0.12082717968395887,0.10605397357987933,0.086255183281375047,0.08321354397182873,0.048514817007833,0.044243911058542376,-0.042578630343806573,-0.10029735035508303,-0.10409726347948557,-0.086307810468093438,0.033369049739091161,0.16060915775050888],[0.12273861405978125,0.042814508752045621,0.018061966478661248,0.0053062383942378208,0.035823523447581954,0.010649293754868217,0.016551078536122706,0.01489993969426269,0.067444152505856128,0.0014205983259976962,0.017061484842956845,0.10625529836546962,0.035660360418095283,0.002751078412191129,-0.012307530679996168,-0.013785633291103078,-0.05132782373436337,-0.086000385495835899,0.051802568141879196,0.03904805873472704,0.047853825999159286,-0.026265747542033639,0.030741255453331229,0.039406757558914624,-0.0082191970520293089,0.0099449690730434304,-0.011588775094071746,-0.069863331862633757,-0.071219401021746773,0.026730481405145667,0.064361266677040244,0.049962478130168061,-0.024025875808116548,0.063809323364770701,-0.014373658398046024,0.023604867877091828,-0.042856616912313392,-0.030014181333617398,-0.098897121704490082,-0.04373899159435149,0.034309424166718241,0.071347736418952548,0.03761434445919945,-0.00082170423945062548,0.020111151000193242,-0.0023310749229815061,-0.015928238873940369,-0.024231713696889132,-0.1221269192682253,-0.077411569100787531,0.0032849717401806887,-0.010022001408555678,0.084366733947847855,0.068284080213949994,0.027109602968543318,-0.034520822432145569,0.0059705622321129803,-0.054405452170679082,-0.058782564084633948,-0.10071244219183988,0.0067297619046283036,0.052325883194804468,0.021602083823943383,0.033365772587175026,0.060449981481694115,0.028671597117484994,-0.069275563884935831,-0.046529106869698536,-0.071031022601829363,-0.068871541073595624,0.046653811370795717,0.13893639005159752,0.088206715220373294,0.0091340091832131931,0.033848018094446569,0.047381238825923169,0.043417512003515984,-0.099682793139969056,-0.072929356853561139,-0.076420909130552717,0.030782008777859689,0.14194448580394009,0.1054078132040758,0.050343613237156831,0.042627816282501868,0.0019869408179327142,0.002912892694045377,0.033417927689340168,-0.10626474257229218,-0.089797364954523645,-0.012630641916284824,0.10656465605540676,0.081787444241139498,0.015706150749096585,-0.0081474894960576333,0.017962048380179174,-0.0076820753247799078,-0.018533162764163613,-0.025747232327919242,-0.06863640651652167,-0.016416507375672674,0.05202743487028412,0.08441518809008719,-0.031665719212890506,-0.081384934590939706,-0.042068123788522205,0.00053001779352805818,-0.034027551289153801,-0.036058497578668941,-0.094126599607925632,-0.028723845930421731,0.036956160575588454,0.11399236758087031,0.047784293848876058,-0.084617974292537104,-0.1041988894674926,-0.096930663266632036,-0.038842231479212945,-0.019078175570027882,-0.045970102698338858,-0.1043619020843051],[0.065757941109192197,0.074777897508991442,0.018292785286432484,0.028173020338814948,-0.0089483449436603552,-0.052545580386797019,-0.1087949901255694,-0.039787230769942346,0.0030209786294805308,0.043861504558306494,0.020559045374589795,0.04470571436425777,0.012784570202518724,0.016258299543353186,-0.038126906658306502,-0.037497943202709987,-0.1176914965804748,-0.048822632662462465,0.039098390799118754,0.067055649329849032,0.075500071483937753,0.076145526827718329,-0.04103203468659232,0.015971731655258753,-0.037660696603424096,-0.03882889344260633,-0.10585017234815822,-0.049772329981684821,0.0044956232113971175,0.11402219053620558,0.090970410758093978,0.082806478184774074,0.059837386632622405,-0.013124940068416517,-0.029059840714413719,-0.0085931859468618976,-0.055642225665546378,-0.08586524174843943,-0.010731942001337424,0.12910594217065441,0.033630584320905196,0.034969345305899749,0.022613172456202865,0.023083805067396955,-0.026126622747118175,-0.036555728898516215,-0.03454946027988387,-0.009697212267244612,-0.039485260868956623,0.044563725924654886,0.10334272388553382,-0.022990981360463417,-0.068461711924414873,-0.026650640178318748,-0.04235340979767379,-0.063143412724810472,-0.038670479860085677,-0.032190500890796184,0.0024621208503444285,0.033854260568938976,0.10018347106209433,0.039049779541599661,-0.14322204153577417,-0.06792156608979899,-0.083174058543035695,-0.086985543398739873,-0.049996676858093628,-0.069642162140837696,-0.017580665091978198,0.045666600981940773,0.064474542322985828,0.066381323532462677,0.049759120323402989,-0.16687707277418293,-0.10148113813854155,-0.045651850601446282,-0.025088926732828348,-0.046920284310850276,-0.063091363282112678,0.0092456865886239858,0.038333207077261205,0.061578125540969059,0.056229950013552389,0.077372534333749188,0.043186131128634953,-0.038313312025859518,0.011391766806405483,0.029085717674323781,-0.087357953773625374,-0.045745395595645708,0.035034140501439034,0.038753107277930694,0.01028453604755696,-0.017745509526202401,0.011578683352821917,0.10678493475168932,0.12920759729821871,0.062105404373375861,0.031614742242985883,-0.03599156339869132,-0.03580586208307926,0.032429174955818194,0.013349521240161158,-0.00025561537496165965,-0.0075836537904609078,-0.057809872184653305,-0.02737962405414552,0.077504449878040088,0.13303768141468877,0.070151605162437541,-0.018705354807535012,-0.015887137408581595,-0.012405772738829302,-0.036314766817913874,-0.057460340751641914,-0.034056167300506576,-0.07157545200554731,-0.068299510308264991,0.0017292217190058162,0.06083852156997098,0.15051364383348281],[-0.120254202400746,-0.096169017184156325,-0.017372420837296856,0.11248443570944938,0.14311280665471804,0.082528015127987145,0.040999748265665256,-0.0022276752168216667,0.010467790781802488,0.023760234093264703,-0.028258264318314828,-0.084469173229205441,-0.06310610366941509,0.034557979503718569,0.080540040228858856,0.030927414852254288,-0.055931722549191307,-0.02359479370263956,-0.021307923642893911,-0.06310798271161458,-0.073253467634114292,-0.058338840997439398,-0.045165611251598459,0.026985236670137049,0.084702435833259607,0.041280837981018503,-0.12024366873436408,-0.10042897365913865,-0.049765123602586149,-0.027095288662972609,-0.010458303155168436,-0.089462141062869843,-0.1289437118045591,-0.010213525065954888,0.053979540894161043,0.069468772869540479,0.12952759376479325,-0.14182340494484172,-0.14285062277610125,-0.0528606979553762,0.063969476799177832,0.053939270199952309,-0.022029152784641744,-0.10818698528187731,0.016491832436736686,0.038639318505357401,0.024020989335001519,0.065592897425442109,0.16112502640598336,0.023615052509284043,0.043352450132583868,0.0076979018918599679,0.043112121029937528,0.00071987756274229098,-0.045960857982681895,-0.0069127442592640644,-0.0077204882201102748,-0.031891871843114539,-0.017036960892809219,0.035037325548395559,0.16303059281511678,0.17418427554606328,0.057001247041575748,0.022916289242805976,-0.010513114683071652,-0.052886209418476507,-0.0043129908452952349,-0.0018884698638378054,-0.044790060375371074,-0.032320374513797531,-0.048960971185410075,-0.0094052564622430085,0.052253286388732362,0.14016474879016858,0.04065676611467136,0.024408426423858556,0.029985555367538438,-0.033973239042800897,-0.017546572766816648,-0.037345271053038906,-0.061375928930807219,-0.03937344145819692,-0.054467136784434225,0.037876693223627467,0.09858135152652249,0.08915095169603543,0.012958414651170758,0.027624783264719604,-0.0058828017121677761,-0.057086791129319164,0.00032844804874246347,-0.037840469280978235,-0.033695751439804925,0.025912743632823754,-0.017024947537232993,0.06774754790560647,0.064529829344964221,0.059856281606444586,-0.0040794712071662576,-0.064492010817941703,-0.022926783895192725,-0.068256941312238154,-0.038787091103630163,0.015688747762662825,5.5171662105987784e-05,0.032388446527829046,0.053502152462023958,0.062621310565998928,0.011267099083652837,-0.039490456581147762,-0.094319475634422542,-0.047548409339035126,-0.0091541278282420042,-0.048201431835308582,-0.012240843418624294,0.0012540759296775089,0.016595878790118618,0.020434407588746067,0.036700109021096272,-0.0026055496863919281,-0.039180334358498638],[-0.039044382493438445,-0.014031835439091891,-0.01717497943397446,-0.041781540002782738,-0.059373536092440463,-0.0085344327706754902,-0.016300069172747539,-0.037294900567202499,-0.017549755907846534,-0.078447962882527866,-0.02004008529828297,-0.056768697829428338,-0.059967040212345959,-0.049253129103857415,-0.069471541008027285,-0.071902666850531496,-0.044718491551717546,-0.03636510105928939,-0.0034411563298461321,-0.046411031373760819,-0.028589990691112652,-0.083768492808513548,0.095116180742419232,0.062452246419035309,-0.024833981241255007,-0.097858575559795102,-0.1127986872143521,-0.088067854572432464,-0.08883593725007502,-0.068545154777893094,0.0011510544062942052,0.068272249927958051,0.080893673619898535,0.1353343839303309,0.18057622473716234,0.089392921016127391,-0.03771266910646548,-0.18004516845335108,-0.16759680953524253,-0.11135480418062912,-0.046002363039963315,0.067488034958263582,0.16040808091097752,0.16020908007929302,0.032242746883539272,0.072926540225657518,0.1267341164708839,0.076774965852314164,-0.027586193949245066,-0.060585053483984741,-0.065958103899050796,0.04618881719914493,0.06405321366734254,0.066545184375501457,0.04695382149034999,0.0044609113824994155,0.0091618342219318277,0.041960317974973543,0.090848513403254741,0.099018853508946403,0.090333756224992956,0.067825639738709226,0.012714203390510964,-0.0052083322470473023,0.011531736842481339,0.046913351524415829,-0.0026789314124194552,0.028085116456833342,0.027040588615283353,0.015104267552866583,0.059852806875527353,0.032101419463347713,0.025279126213945874,-0.045499782999878127,-0.0092654514634481905,0.032695973667332234,0.0058023061141843219,-0.0018139112732011575,-0.0029108731958343292,0.010427305260203787,-9.6032476966920188e-05,0.021288607450265881,0.041079801640464084,0.016357363013747531,-0.032396279409626833,-0.0096468473033134161,-0.015146538620363123,0.013412806275636471,-0.0013427741295518741,0.038224090646334606,-0.01337749153937268,0.026455615442210673,0.022399735833748824,0.0083203718092760871,0.0021986789243084309,-0.014293946476503921,-0.011197610424383816,-0.025764602165002509,-0.0044402614564183623,0.026453211631295465,-0.016392272773541029,-0.011847008501585585,-0.030834902384847707,0.0092711300250400749,0.0079231656727102029,0.015033519474474451,-0.027785535484879158,-0.03370942439196669,-0.015542452577597912,0.00048635059573182279,-0.026694531555004813,-0.012724799179976064,-0.013286763364002738,-0.042306321931516747,-0.033424166864698804,0.0087293255484813519,-0.030242759324034616,-0.013050994461220922,-0.037603985335936958,-0.048537758115318075,-0.061784216202301949],[-0.064895613231398419,-0.020224286971327814,0.015905264409012548,0.013551842188797097,0.082225664059696169,0.052591399404863487,0.042257887471961172,0.07064771573560033,-0.0011991945255137408,-0.034366640312061339,-0.072360555553281497,-0.056223603404509992,-0.046254629023798989,-0.030584855242000546,-0.034996133864494572,-0.043017778242875414,-0.074116618465999901,-0.058193036991492836,0.099174902047441449,0.085979159623767315,0.0260790473140005,-0.090335795957093609,-0.10362582311773169,-0.05683029227387211,-0.032955228570346592,-0.035953196903694445,-0.083669598501602105,-0.14307384019801234,-0.17021343406030898,0.056559505125885055,0.1353903981543188,0.11264594916548558,0.011673755450064008,-0.065805649175016551,-0.015916968368203999,0.049371535828759125,0.032602131500708426,-0.023482372439204213,-0.14884937691675146,-0.14122378994790352,0.038947574553526224,0.090754777377725832,0.11462434476555877,0.049232968649695563,-0.020681162710889808,0.0059189166530157098,0.048035670932309434,0.048756668898357711,0.015029939401784822,-0.0045822873172906703,0.044145082900123096,0.050071852397185944,0.0094509750493274383,0.024378668316836539,0.052749214069398115,0.0064390139543627628,-0.0002811989012708239,-0.0064546940403005376,0.067241804853012926,0.14641906683964209,0.12089002549596747,0.045524123195999813,-0.027903819777222599,-0.020728023595215268,0.011972589684504081,0.023139835261794185,0.062288213971794335,0.0030852567167743063,-0.010563156113489056,0.054746231145096608,0.10798773024900726,0.014816168604569607,-0.067729122880713061,-0.069428819952578644,-0.039672679449664974,0.0072944844869031189,0.031665801169246242,0.077903468071470375,0.03314357843621181,-0.011090195620338333,0.025953154918250638,0.040728866157606014,0.015524058836610692,-0.021280018049330086,-0.074601124345350517,-0.032634705813619005,-0.040767214304249212,0.029068927489674708,0.050403637093174664,0.016601304925128416,0.0082563132518792444,0.040076199043347638,0.031009017378264954,0.02125830223035903,-0.0026364504616102971,-0.025393115408776517,-0.040100437968749382,-0.05110548671081025,-0.067993377103616609,-0.00046432557130123052,-0.0039876483166379033,0.022729109377199703,0.039555964359429222,0.053830169668727355,-0.0014414045704570968,0.037267802189446919,-0.022231980521954575,-0.034050491080049324,-0.073951655494023091,-0.043557983601915228,0.0063278734791331892,-0.079884297677682306,-0.05179614099105008,-0.012967977410458104,0.016769677941412969,0.03933948218335899,-0.014906721458355397,-0.021082645685981671,0.00037445636334414081,-0.082723281977227794,-0.1030737258893234],[-0.037002829518880356,-0.051800501938286336,-0.060853004537176597,-0.0094150409945243096,-0.034328030870577425,0.0033825861478738173,0.012446709688320332,0.028263939384084974,0.051241250294029178,0.029467212390683409,0.094296073781751158,0.017996331462246259,0.074494909584215466,0.018562434067668762,0.0011775208660011255,-0.03343642198912352,-0.035845758685869263,-0.02469974718432548,-0.024948855129499292,-0.024856433920733188,0.022654621557346655,0.013969959583284512,-0.015621110631660393,0.08434398198734791,0.12526052771855398,0.058408231821464381,0.045127451768280695,-0.043164240869397401,-0.1023993834271598,-0.096781070009609851,0.0053916393051223234,-0.033844402314595262,-0.012657848528438927,0.0013785476814248063,0.011572904307556139,0.068403154355265131,0.052980959912984543,0.1266701829984114,0.035045725726125722,-0.068960202229844197,-0.060072231451733973,-0.062720555693278807,-0.030009692601680373,-0.0092089352686221815,-0.053346169244103861,-0.051521839481652648,-0.019671024276837101,-0.055873607630573113,0.041978873563040947,0.1638861354064878,0.00106361294464159,-0.053910040513112212,-0.068153591022086388,-0.055292950731728449,-0.039462171388406658,-0.095725937501121905,-0.092290911359049418,-0.11338803995859958,-0.13838339127374222,-0.0357462740536892,0.22606772554633187,0.12813795776647591,-0.0024481614307838503,-0.033611168519571522,-0.051839059280132632,-0.084236132619828999,-0.029032249699063171,-0.058898794655031249,-0.11075161830580202,-0.15312117095255712,-0.020724783620647211,0.16842588938808492,0.12743855198340154,0.080331925597410064,0.021566448195444857,-0.082352620029737575,-0.069017983250065099,0.049857379267076132,0.040106054682231364,-0.055333820775483558,-0.042096211664252689,0.066708704425261028,0.042419812012600137,0.069011669576221873,0.079983677018715033,0.034371804092794715,-0.017332099818488572,-0.083009418854646341,0.042453939466233076,0.051060642403565164,0.07316878819733981,0.10110928490296386,0.015416346633545026,-0.074121651760900326,0.037506205371324909,0.056372316384434969,0.069802712453019444,0.022830083664882234,-0.088476191224756862,0.056380990619929745,0.11796759975891001,0.085159502068178794,0.0057506785680517813,-0.052150252418282778,0.00071341189171907071,-0.033052078906102914,0.042466154564593551,0.066152570678099751,0.041058972780051016,-0.07491213514221709,0.059832650863602857,0.050036282518436601,0.073439101106600166,-0.035055451687694333,-0.043213965757215783,-0.028433835254721582,-0.049722879871748019,-0.042468775260800257,0.0058211813366477044,0.0033813738235871967,-0.064579878516043021],[-0.05204926560099437,-0.057237880289236279,-0.0083905804002989276,0.0062458102695772955,0.035746619926900439,0.078399463599589062,0.078852151476007562,0.065079376584073825,0.051674438501644049,0.056599491625845932,0.1112401778738227,-0.049451770190799972,-0.03311327028822704,-0.04470398589450323,-0.0069392182793978074,-0.023794576977256759,0.010055161607694707,0.051861925861248687,0.032051221900923126,0.0034551032431236958,0.060342507325651218,0.071820561865178004,-0.011974167972497493,-0.026068365839870898,-0.020182681121343846,-0.013949638537375686,-0.050699316492772886,-0.020355931447011116,0.029014508674471667,0.044992661189607805,0.04170522023063189,0.033987569666887124,0.042094071544786019,-0.031292621485756067,0.022301326642790088,-0.01743554965010255,0.0086405189226159418,-0.033429116543261993,-0.059143520853118206,0.0055852565804648813,0.0041508387138344781,0.049460528858195588,0.050859527708305804,0.079934023736357787,0.0095959128701056558,0.025688470585585318,0.0055600019316925584,0.013382028934657897,-0.058013808148885737,-0.089499818472389137,-0.071592085149893764,-0.019107360505553072,-0.0082744851179119318,0.032585012634967978,0.046701290308840598,-0.0096067810012472332,-0.020512636464317932,-0.0038438246468142923,0.014613700602723453,0.068186284724516349,-0.01830963397214188,-0.11322752216975147,-0.09640633091246717,-0.052403236939622524,0.027222341781097337,0.030317752268627929,0.019657001659076179,-0.0096600042345343605,-0.018626726339795667,0.0081908090585838672,0.12179883942046363,0.1508103124239786,0.075806639792132646,-0.062761170942153277,-0.10013344453499878,-0.068245483773719195,-0.022265844067301123,0.00065583914591630342,-0.015208724489903314,0.018866572887032564,0.0052684885324918579,0.065684028931326841,0.10986728461260108,0.14928723727825088,0.059434744289182703,-0.060185571636217253,-0.089354598820007264,-0.066216926969791326,-0.023535680546190665,-0.054962379947465514,-0.059013306627190822,0.019989607048620271,0.0054003206627150548,0.032462771758462849,0.045866640394699523,0.10505871662329165,0.055755510306947052,-0.059889616340963951,-0.092315810433916068,-0.071619045947736437,-0.075031199722232336,-0.062253911446631852,-0.04694709230045966,-0.048116321043479529,-0.036582441951753884,-0.061107036339067312,0.036504990974571036,0.10110597080448579,0.051177845114249831,-0.044432074886152584,-0.10159227266715132,-0.077158568747903805,-0.030393198761254205,-0.050071313080747346,-0.074595676179791612,-0.073458542100526297,-0.078358062777158496,-0.030278657221277715,0.084453877904946462,0.12337283504154144,0.062469168412561921],[0.11115260218147537,0.051560842999883991,-0.019027323692840041,-0.053735438913629183,-0.0071101075931705657,-0.060331674975749636,-0.01273389146899935,-0.083913899585844304,-0.0068742819184818144,0.036449537875718169,0.057484281155208095,0.1019949723289555,0.082976543297385519,0.018623799266703829,-0.020037210469670844,-0.058991687133825438,-0.0043094092108171798,-0.061801131907737672,-0.032137171525331368,-0.019997943427430342,0.029477714358382982,0.09332163289552993,0.070136049723979091,0.057019933758274077,0.053899973004219538,-0.0026387634530392612,-0.0087944700091126295,-0.044886516736232299,-0.03176715948743207,-0.042173672069529447,-0.032508457873831956,0.034115235511423689,0.093105995907237046,0.018636796052156644,0.046735806088687395,0.021858174501294951,0.027569212512874617,-0.0019748228182896871,-0.020011467438642447,-0.038263327232506431,-0.041760709971461987,-0.030814576931739321,0.028817248098680567,0.07178725501146116,-0.009708063399979483,0.040408045290464156,0.047902942272710962,0.049152309684650786,0.016182293978584075,-0.017238522908897977,-0.040468598163172567,-0.045702820531370383,-0.016281604371356659,0.0034546404119755736,0.034807390777535141,-0.018385622040759317,0.01969433114929478,0.067998668027008519,0.064831298138631047,-0.014464528171849848,0.011124972290677312,-0.0612303154617381,-0.076620988117942754,-0.023624167810504887,-0.0028778143977437054,0.037589255674998712,-0.069263304031074682,0.0031359656960172622,0.057377595091023581,0.052691820606641286,0.017399699182203937,-0.018570302353960122,-0.046213889206180463,-0.066632711107939349,0.004937253121457652,-0.0038828611488524456,0.025713646541403734,-0.083379308461335996,0.0056691392712922076,0.11608252277008832,0.073533161219590859,0.03822657644961075,-0.077118650194350102,-0.055463194241750072,-0.04304259780973764,-0.019189005860534236,0.017297615166657204,-0.023170677964515524,-0.097271316382778222,0.026385141514079502,0.084668815279573317,0.092504840629287294,0.016711157910872847,-0.044362782624102759,-0.0454511239473053,-0.049550862988714514,0.013625451869519002,0.020561667154105095,-0.030006622146731568,-0.063980647406975705,0.075872467722288658,0.053120016709717416,0.065923774906762364,0.031465876517252786,-0.012255926181853973,-0.031398789946512198,-0.01876926970569838,-0.040221379151225214,-0.0015619003771453512,-0.0069604389489614123,0.060783419102048972,0.075568709103222456,0.05225568745879651,0.078139550494287488,0.038095011814273147,0.052434561149658568,0.048883832083824116,-0.055025867820072974,-0.045282107044195954,-0.041013497771644633,0.099043866859741717],[-0.11203549175295996,-0.039741638112244869,0.011060178958798239,0.068771522760862389,0.091947029926868651,0.063013461864849213,0.053208457143949908,0.020539339513306422,0.038057193997243076,0.038787465988623426,0.028121764350374646,-0.044919650035753551,-0.028946060113256775,0.038249964049902802,0.064448692316739498,0.074566886448479031,0.056117982339109772,0.057712083798571012,-0.019732262989866904,0.012262999619765316,0.0040347651881646211,0.043113689501805767,0.0036261933857882275,0.040928710043322158,0.053219648605966417,0.046769367826384994,-0.017166264963499114,0.0054891268723304132,-0.020480699308758406,-0.022929172836275616,-0.019377222102737297,-0.050393274670934379,-0.028341154356359134,0.044368745080340603,0.034906291107670129,-0.011071953214126184,-0.065544146068916828,-0.057326320735171105,-0.098654044879250974,-0.021150583208668992,-0.038971057948257913,-0.051954652796451138,-0.065697052369735887,-0.076668618468381175,0.057536826222298318,0.0059026131536024304,-0.046203872539273341,-0.082611420120622253,-0.084852191816498154,-0.079141430325910062,-0.097004168435828902,-0.076062125522098539,-0.06316389153647553,-0.083320929461625837,-0.057460537409920194,0.02780118613240987,-0.018767946276596975,-0.029691882937965902,-0.014540521259465585,0.08390634737694766,0.20739444418621977,0.046700493845665721,-0.060571735762272969,-0.1303813417107452,-0.13805261674986721,-0.12358535758970328,0.0074710539580880447,-0.022238309187360118,-0.0067832182121356881,0.00050856838356390724,0.12335224504872636,0.15023440850791586,0.24255876784390559,0.13265122710423893,-0.036349215955504527,-0.096342261434848489,-0.12379973942082877,-0.005922294079732774,0.0092528719228638871,-0.0086414366404968038,0.014911679170252864,-0.0069709626853085849,0.062192115575895698,0.048857235728622855,0.099736221902574501,0.10382748525934579,-0.0017267232813016238,-0.03337998864511238,-0.041015759215952706,0.028074948889879575,-0.024175373112944334,0.00037851506203986224,0.028290086601225291,-0.017177690879414606,0.012211197073898714,0.021090624041023867,0.04880110436342628,0.058893006766919061,0.041186307677804096,-0.050228037757938743,-0.06358869101157405,-0.01627885622405395,-0.0047556909859505087,0.019166267525767756,-0.0042859855426942489,0.072221293664227526,0.027667668809319687,0.0076072348731966626,0.046251642681222054,0.045327516936598013,-0.058087271467788915,-0.052568654253287897,-0.044762413503640928,-0.023155518065321151,-0.00017763235014638958,0.052359997711985393,0.017613369441475152,0.026754240173532909,-0.0071592410268532612,0.021450091526662492,0.026061341438602878],[0.074443033622211968,0.025009703449449541,-0.0072387396885091188,-0.034581203239581096,0.0075069226962646007,0.05053220778206742,0.097728950382035856,0.10515405254550375,-0.0020885631160830892,-0.06460650708474773,-0.071900877008339387,0.062709555161575961,0.04810964818959447,-0.0061288197958455914,-0.048707571007934714,-0.028878035144916103,0.049283029611296138,0.10301464073332151,0.091885368660922062,0.1083066909121139,-0.0069201860463068421,-0.0710800467482154,-0.032385403501740219,-0.041456597157549895,-0.037318284584525352,-0.037271263481650524,-0.04033581670492567,-0.030542208455988901,0.027846343886639854,0.051125764403077464,0.039457863125580993,0.061533816212355034,-0.0088597136956959643,-0.058002594376894451,-0.036151038770433672,-0.039853560057399352,-0.048559742972093256,-0.05876298366017621,-0.083101870117629206,-0.091875530060523458,-0.077266837651363607,0.00086206636286371985,0.064567560492729381,0.05176416503907634,-0.08735727608117326,-0.053385067235642,-0.019429217609104946,-0.023415415744384521,-0.085630336992695857,-0.12611138326972099,-0.086691614144378967,-0.12449403321207964,-0.05512595439100107,0.030267444104458113,0.083602405077763398,-0.12583781900425739,-0.091278147423601561,-0.073530346048646777,-0.085045520153049808,0.011889706660064834,0.13738456218349074,0.12691757918372121,-0.020511658061573332,-0.083331527006269501,-0.045688290860109199,0.094721631783419011,-0.1176819000585845,-0.11560656474484407,-0.060549525031994025,0.081984888033411141,0.1704420734813879,0.11965727243025565,0.11254484229099559,0.074741052413934445,-0.025737622919062741,-0.033587219072488843,0.03411352154081515,0.051552692766032665,-0.020222946025836006,0.045690451059582811,0.056071133353337008,0.020997592772981258,0.044561510792265002,0.02939148849213119,0.026725272806523891,0.013325176508616088,-0.019772518292927338,0.0027475572519997937,0.12423204721233166,0.045549710745386038,0.018947387510806379,0.0057239875049261008,-0.0058699208305394712,0.0050369550657840267,0.043724054901299908,0.019509400602205587,-0.0018887858002489578,-0.0096177381092612257,-0.013199600334816992,0.10143636127977371,0.08518214265041664,-0.013319980029247946,0.0029189074659387582,0.010087593201327683,0.009493285904375974,0.017930356539244602,0.031406637685000433,0.011733720402003947,-0.050901070261947852,-0.015735781911257421,0.029231279797781562,0.048511610011102664,0.013899380735429394,-0.031157761675669398,-0.040662087603105253,-0.0083011423756094577,0.043045372058056516,-0.01096803936953996,-0.0012438578375955772,-0.022626520337825511,-0.11765611182461798],[-0.039873480685186327,0.00012184835774546317,0.018432499523696314,-0.06030489971984803,0.014643208225874137,0.012981315846513394,-0.0070294048340999865,-0.055624566982403527,-0.011913096749220649,0.0084124976996370008,0.010420634562858239,0.014232327032235419,0.0046832226936113219,0.032819982634319213,0.01320726418626594,-0.023533808891275709,-0.011404581263416494,-0.042582175203416311,-0.018915023456131434,-0.049511208703627144,-0.01836613958153846,-0.0058433446262533108,0.02231630230741475,0.021334764569425978,0.034666291388462299,0.060010301185060864,-0.034246065227552185,-0.047005499650124551,-0.047921871802546437,-0.041048831403235529,-0.026713641204057077,-0.038789996127014961,-0.018331240491325174,0.037976867862023977,0.028813877664190697,0.019770359402909235,0.03728944535318747,-0.066962988411517793,-0.10295356437958489,-0.090035338267466014,-0.060415802785235138,-0.030821512733484054,0.02401335406847712,-0.023615740770755671,0.014617912689912915,0.0051973456583133126,-0.0053408769578060511,0.019716826597634293,-0.078766904193264292,-0.029296548169388054,-0.023280430828030781,-0.014403388911157673,-0.0092263628747704454,-0.033409036299127719,-0.020726200729135634,-0.035931925994181074,-0.023010380673947554,-0.039252395604041306,-0.016760733401697973,0.053608280303007586,0.13329950551225564,0.16489717632675976,0.090281268337484705,0.045229665505339148,0.017404381514372763,0.013597897839994186,-0.047297713743641646,-0.067622094327431645,-0.027195636559411811,0.065506393613748479,0.02232560477300298,0.046885888199241804,0.043068894433184998,0.12018260070272857,0.084302508484961486,0.02067188016168707,0.020184511766629731,-0.071050894359262914,-0.079541739094958583,-0.016269072364149793,0.033354715485268173,0.028706024706301091,-0.012011749840849373,-0.015402866346903674,0.031358471867631604,0.10476667408686299,0.0025587486589462027,0.02110857377048439,-0.039307670372500075,-0.093767551228405063,-0.022120949123226506,0.023658016755843218,0.001624116197708074,0.011496266326477288,-0.039666836714535372,0.010910001919740123,0.063815810827050498,0.062964749256176525,0.011666021976556945,-0.024049027553408542,-0.0027908618863511994,-0.053241603898009714,-0.014763231808325047,-0.0095880408564158331,-0.031086972870322235,-0.030644620324520727,0.010272461123314607,0.03748199758443737,0.060317495169656093,0.024907320438576977,-0.045599623540660161,-0.020357685838190937,-0.062106166980994727,0.036986556057447252,-0.038453069856899391,-0.044856589426634154,-0.034310651524162267,-0.011783723308224799,0.018762824804810944,0.061657489154879043,0.040804009950206069],[-0.030967376640442579,-0.034704706474157576,-0.030029036584246833,-0.073209132466448931,-0.048949076143639865,-0.038640662410442561,0.051474764052445811,0.074236855663231974,0.11134675135754504,0.076704056724054892,0.047486303599635876,-0.068455613733398521,-0.035128511996496081,-0.0025321681540545343,-0.057133697514561765,-0.053440600419679241,0.017148650385363479,0.052110170662047414,0.058782183168318736,0.047056961446036369,0.040322325256064898,0.0078030024380692647,-0.05608339456723066,-0.04684682593449583,-0.0065577385795995147,0.015471094977111979,0.0066614780906229729,0.052620395249402485,0.00019300929351519225,0.077547069508788119,0.050313782394810311,-0.024569188095571692,0.034662886943856788,-0.0044029950458541103,-0.038893398080935566,0.018694283839760885,0.035428018363409447,0.060685907655044814,0.0587413540716437,0.0014872430743369924,-0.045756325846127051,-0.047944642008308877,-0.09281792081715598,-0.021043716683786656,0.007562208390103603,0.0087802886352499401,0.024402794551533658,-0.01824493391613341,0.0056819486787151258,-0.122005902409504,-0.11277710237979818,-0.054719494073167244,-0.090166889383778037,-0.032774893151098286,-0.079640484686983273,-0.0081433425803733028,0.036415554732213973,-0.029719246379058512,-0.08343173036099473,-0.097009718713933338,-0.078382336396330896,-0.061852431233739499,-0.023645551992256014,-0.040447890302015635,-0.078556226205249061,-0.035218950640358182,-0.027448566314184852,-0.0024221651587159679,-0.0086513582329476105,-0.069055941187435799,-0.046263515682347614,-0.026683587106414781,0.0085151284734774242,0.01510527176030271,0.031314100341752416,0.036056075842148129,0.025591220637012156,0.0051353834527485057,-0.023005349498057173,0.02104724020668694,-0.014202301085685001,-0.043601992702429357,0.014083946209181006,0.047988366041463205,0.0040768949537646898,0.040069615686237701,0.031368092441017473,0.041401907932681482,0.0083542366285301942,0.053523984896854969,0.038346576189893421,-0.0075354880301602006,0.03383654934661684,0.037701959013775557,0.023170719193185016,0.00063874518894980505,0.022456779814042073,0.058804006814905982,0.033465949399417834,0.011933873490689997,-0.0031202988762389951,0.016068746672777481,0.037621893043980711,-0.010942651485316122,0.046299383766535571,-0.0027637682590763851,4.2316925059140975e-06,-0.0038944346280027366,0.0096576323773187346,-0.01850966706940272,-0.054006078059137416,0.017238219091326883,0.0091596910151990184,0.028996863874777658,0.033952601882988653,0.070753339834244089,0.0037809506474898429,0.027199587204016329,0.0091419719045753873,0.027115188408680799,0.012709694003767591],[-0.059221606655608681,-0.0013807397121916331,0.027612645957779638,0.10526838045136652,0.056162190642178922,0.063381996846630956,0.0052813907213748162,0.022701227707487698,0.023071399548784132,0.011640586008089752,0.037100581562280036,-0.096537301671241846,-0.037974704225794617,0.00038732579738916815,0.050625050016267568,0.065086729085677475,0.0010273202640978113,0.01030282761678826,0.0050327500226482608,0.050959342703142202,0.053161832471559013,0.03088817116176755,-0.021359024956780739,-0.030126662636484423,0.014336380788901357,0.044081582390044685,0.045143284913980009,0.01394262266053127,-0.074479563024112405,-0.021194650491958511,0.010166296540795764,0.028011887127611046,-0.022728767470732637,-0.033769750654749603,0.0042313533530659725,0.022686514054856353,0.046542045913330762,0.11310013896650321,-0.0045051511040681974,0.072383588936866153,0.037891919978813249,0.044639985453488233,0.053304796345090825,0.055297501218708925,-0.025259737537897203,0.023523250437604698,0.029550788938781603,-0.057103923688581644,-0.037228050464029057,-0.040334547113759743,-0.066002394454861085,0.051805877339979295,0.09092132214492693,0.015823331139374411,-0.038665412143877739,0.0092906515574926254,-0.028826426019922906,-0.074980989084462088,-0.05787442193814954,-0.10795622255952429,-0.046546338514420166,-0.11181899441749669,-0.10192418752175381,-0.085702414165345311,-0.093905868491930569,-0.14398389568329137,-0.056828585605448137,-0.06626357512710776,-0.071883231030884079,-0.05541027253169447,-0.0092822545503814802,0.0018363519548447033,-0.0066183382174312272,-0.011825162483750359,-0.092520252931136554,-0.088262059348965707,0.0069521222062057519,-0.025393087237703255,-0.0063946991298149333,-0.043361744350810506,-0.02217358952694239,0.0077218815463931945,-0.025334117749954241,-0.0083152640572634468,0.037370584638286568,0.012798906233440717,0.015685495564438989,-0.0096592020340569573,-0.0057848888032873691,-0.010756955350811635,0.017757324648215944,0.044529547669743041,0.0041941047626251615,0.054645185961794018,0.039709597938149141,0.033910773481424995,0.065271769100368901,0.034889848272914054,0.095387104413498985,0.012473593139358034,-0.0089935075779601324,0.044380357060880754,0.030765480187302234,0.018886724239982972,0.031787912403243176,0.031673790743440955,0.020196643029900062,-0.0012983094411241694,0.046204156701180166,0.043616528938776683,0.052279675166504697,0.035528670172807794,0.048752827422166391,-0.010956478364744832,-0.010948307255129602,0.0023335073954288315,0.00082619959707538188,-0.028699221681917506,0.014221929018802294,-0.0098068806836790964,-0.035272762342824268],[0.062946872449031063,0.064519394879077666,0.032897359514565301,-0.045711891879663097,0.020599391374711062,0.063655199236485299,0.014615769796257505,-0.027440870743054617,0.035616222562863675,0.0094036093827168515,0.056507446197265193,0.031272529009901337,-0.011034554575282393,0.038887056697409605,-0.021343232536083438,-0.016082974355130925,0.03398009131937528,0.052626400504158947,-0.02529516749703499,-0.026548720706405481,0.030680991925506617,0.027583071986928488,0.080966719325337916,0.035373199613146035,0.034900256392934439,-0.012798813313152833,0.04319156099995615,0.022703220357838422,0.050265373853632632,0.0003437400231437425,-0.012567197236507482,0.073429633782059245,0.0065301063919971924,0.017281768786973933,0.049276004779088722,-0.02725340162513791,-0.0086520578662400288,0.047527074820523915,0.17861942818684309,0.086809068021657401,-0.019355178240588661,-0.041870304853726628,-0.055304753608100707,0.078290837231694221,-0.12690621836570407,-0.096279890589654596,-0.092541121932859904,-0.10216764911335079,-0.041913347291723559,-0.0061568695399335446,-0.02394181893475637,-0.05181154571828913,-0.12530688042526772,-0.097862179590048642,-0.10634083467860724,-0.088741745636640959,-0.060958836535120312,-0.031993056376924268,-0.036846220231738974,-0.092274010347915825,-0.11353320653734295,-0.036146695566072848,0.011596830638808633,-0.013143670931630894,-0.063917360565445863,-0.11042459480083613,-0.012415575911984202,-0.061286683792012901,-0.019683898333121175,-0.02351836883559362,-0.0066523400160384549,-0.014484754457127935,0.018028020927321566,0.008084275012827935,0.036972370716564971,-0.018618144071885362,-0.10924354613828609,0.030523206341700047,0.01298880090453846,0.040120142620378607,0.061496119916373056,0.048449961530989391,0.01921366891131086,0.021510068544701624,0.07209312331150311,0.037410161917291698,0.049160122975013168,-0.013141343062868835,0.060642537004008013,0.022194682981879085,0.05129865380619493,0.013217705879822975,0.041765969490498975,0.010615751276552232,-0.010207688567782834,-0.00057559828671693847,0.076314244622539648,0.017510356925100834,0.060847396478783206,0.03300347337813607,0.048984734512022551,-0.0064822252096019221,-0.0021063249759751858,0.010622816122664164,0.028538830399705187,0.028618408701009158,-0.023485260352655107,-0.0028276174189336839,0.044105954184393642,0.022574759621766721,-0.025473428596684167,0.026401062552437127,-0.029859950686759645,-0.035148145207273412,-0.028004242193563095,-0.010874515898578971,-0.02520644976850539,-0.031472616887933583,-0.013822064554071298,-0.01097289405425797,0.076092357186882495],[0.03690386612248002,0.056002218089369685,-0.010951719270400923,0.040331097511643155,-0.0037441455323561496,0.049112125114183058,0.0079169665374183087,0.11344386642727713,0.0007563312264983052,-0.037482571931358309,-0.018735772189985789,0.011744945269622539,0.036505508708255696,0.053399713960056966,0.023086150106013142,0.0044152509684453195,-0.0036748654077677217,0.049656981135381167,0.0045969535450092955,0.040392794162983123,-0.029097892231179194,-0.074893865276321803,0.0016705057712694963,-0.032135738557994634,0.036750173986759005,0.032029774955991561,-0.025110352420147287,0.022110635776293401,-0.011118779729623884,0.027123502587836187,0.061095462079700222,-0.024783808630182078,-0.059955925032526225,0.013711673076898898,0.036557533368247498,0.084110261886928162,0.055950231294746772,-0.020007452447925414,0.020788588159875922,0.049865734304206946,0.039021923151225379,0.088845664746401071,0.012344115511745107,-0.05538843672808838,-0.0283890960033647,0.025833332510384673,0.10641983969927944,0.052722918301459212,-0.05478356057464559,-0.10190284716601143,-0.049794325260415453,-0.0069085612468734042,0.018752575433158634,0.0082097852631209702,0.013268033828822395,-0.18180783799950825,-0.12595865108667029,-0.094587062767344646,-0.027564647202767342,-0.064339970972324884,-0.091630782859498369,-0.092278488340619053,-0.075570027119632732,-0.11647913534085745,0.0033701825247711877,0.029872248721253027,-0.049119870012074435,-0.10950490287540141,-0.082985533821943222,-0.020757266879069626,0.032839871737627147,0.027498688090949394,-0.051265177840992882,-0.028726904129193459,-0.074362520404752469,-0.078828379945006022,-0.048211245977380933,0.024174951415566678,0.0074472807679010818,-0.0074232491688529523,-0.00077866185976915858,0.056674802683761974,0.022479560933966962,-0.022053321065962445,-0.025989291569709812,0.0064102606195954315,-0.020235352690214578,-0.064838171573315492,0.081539627065815912,0.050559787196516853,0.027640931483737141,0.056668491330416827,0.031151110583386293,0.039877476311591838,0.032443819125262119,0.042982667461244774,-0.0018215713348507297,0.0070637700109989279,-0.0058429795351756103,0.067603762059298383,0.03091253675538988,0.028071888777783896,-0.0010850231199715735,0.015534670537972986,0.043687190194000733,0.01938400318015672,0.032939688927880212,0.057370488644266582,0.0076083295877509421,0.0044986928101548411,-0.011421955766557471,-0.029081272069140879,-0.0036106413708782165,-0.0032691409082095807,-0.063551586196383944,-0.022937264529547606,0.0091467010626821721,-0.011390797309113472,0.068187506046327936,0.003884385505889279,0.071448625051746401],[0.093670053378816731,-0.0060185803724412124,0.064975253447979997,0.057204813928574239,0.032039357303312588,0.017360690928795997,-0.054310388367495258,-0.074304010831156467,-0.022133608826072002,-0.03441434222392329,0.0044162963247191128,0.028938348016603214,0.01658488166499885,0.025525405954675534,0.035893961967071938,0.0076746895655852576,-0.0019368459518004297,0.0066707535959328046,-0.1042360605814506,-0.00055454840969697966,0.0022380826663202374,-0.02840948162941799,-0.004017714090244609,-0.013989051801159828,0.02542809328073873,0.064148365472184235,0.077485765766674375,0.034007352893400962,0.046771269374739369,0.054056001025575479,-0.068291615724358462,-0.01191564128605152,-0.08236908091325304,-0.034026953075964254,-0.093926696408503804,-0.028299026068272781,-0.083187856060272347,0.0068670213408899561,0.07996019523365458,0.063771902655339469,0.00087634234802598868,0.020691801513151017,-0.012739227946535911,-0.018539467931270818,-0.082159033883173249,-0.035509269486481018,-0.0903794995968909,-0.072582351048290333,-0.10221116757608581,-0.10665056526245895,0.00090250733424238061,0.015334595491633053,0.046227730069698332,0.038103240152997334,-0.0062461221580594889,-0.06724561414366495,-0.053325522122090241,-0.0029145163841420574,-0.055345741892996264,-0.055246137408700977,-0.11556942735569369,-0.12678748176917243,-0.018650402834112373,0.0201115675159311,0.0072374544322631939,0.013539302016072579,0.039109407585483882,0.051641698907963052,0.0078965365952058768,0.023870730531144614,-0.017458058805458504,0.018892420656760625,-0.10504680212429973,-0.089680004128360968,-0.04272524613046922,0.026724916448450958,0.011635965581891422,0.084889133812557832,0.034194689506569786,0.065857255458405553,0.0042427078937929356,-0.012401464228490738,0.042722865239520375,0.033509236615387683,-0.0086452874579218859,-0.091769778804805302,0.020750157767451382,0.01987667311893981,0.010694698759597054,0.047156458758485842,0.044111484618501104,-0.014434725200227233,0.071373855704184225,0.03475623227161978,0.040578493255194692,-0.0071662870654205096,0.025407664409730447,0.043339417631733802,0.010480242779609582,-0.0087307063681051136,-0.013411411822995711,-0.020394509035250141,0.0060121542292144725,0.024188238197290803,0.041668193822485079,0.041183226601004416,0.10243115564821167,-0.02940584456446451,0.0031099245285817669,0.0030508999908164854,-0.017382195539308282,0.0048263750639246927,-0.026781565476663695,0.011942148044968376,0.0024678281518802359,0.040929003265524629,0.080622599957161575,0.029178579118654943,0.043038714976740611,0.0055501733506574946,0.00027909537625575576],[-0.033397311394149677,0.0096415007713644973,-0.018236744035314625,-0.034138584815056695,-0.0024438916753326198,0.0055087071850375355,-0.0026268037119103198,-0.028241098838151658,0.0052159942036530127,-0.021235364030436632,-0.047073948370721506,-0.026121704506604584,-0.027138348751118566,-0.048107435408362653,-0.040211279822578397,-0.030102378969085283,-0.0032792712208641666,0.059678613392050002,0.006758383300518157,0.030667242997798105,0.0095436115343644611,-0.016919082533258429,0.0038233095813847151,-0.058995625065273824,-0.030890606711754587,-0.058149589871913064,-0.0815351815818076,-0.0063579538770199284,-0.017080813200946385,0.043337478406891949,0.062983597436613734,0.040401309594868401,0.0072034023998875183,0.011592685433827972,-0.0033021456500918062,-0.057816788607124699,-0.037812512707325552,-0.12425681152290456,-0.10985738895947982,-0.093812839880628898,0.065001290338761564,0.034843561028987141,0.056616004034855671,-0.014925007654415651,-0.021164736244188381,-0.0032162052770800531,-0.012309755363306994,-0.017827196918306518,0.035551161867388673,-0.07046756271563373,-0.034864456303405046,-0.017196442705869938,0.02847927116818913,-0.022806581184283581,0.03213417823424855,0.026469237488508546,0.009589558238125101,0.035119287178089001,0.13550727924378436,0.13688661973317756,0.16247997796144609,0.015875158167285394,-0.020831151874117201,-0.0011812318416458828,-0.019841048216886314,-0.088082464896673471,0.030457768879803171,0.026063097480707995,0.047026463061375465,0.070569136656278841,0.062916792803278332,0.049798812429405107,0.085485860229359792,0.035141696932625741,-0.020167444245680122,-0.061685159646736681,-0.092847554814415742,-0.0015896852645350262,0.016608882932934957,0.055001587269276467,0.070867931570141707,0.013234850523530295,-0.00082083705696721354,0.038004857877911483,0.07357330886595341,-0.035371927316790286,-0.031697507137062611,-0.086248516693940486,0.010390223430695129,0.020133865530716527,0.013595826448211168,0.055294702876020299,0.0095627226336793825,-0.021797178139167303,-0.0091913269986637625,0.042724178575335753,0.02896574564861093,-0.04832930579382462,-0.097000076388255058,-0.035392090036565821,-0.0091230528722667514,0.047734194414938147,0.024899519254075436,0.040201783336123773,-0.042437436186437194,-0.0088865115923605353,0.0034760730494084874,-0.012834489181082792,-0.011082107946660119,-0.086373612626070725,0.010906720579881624,0.001585372406144106,0.059934049355052657,0.039390631946712135,0.025936130645470831,0.018352465543086088,-0.066654985053579988,-0.036968952314477735,3.6890828317398539e-05,-0.037622268779505898,-0.087738993271721605],[-0.0096923145306643255,-0.014831123980443256,-0.020109046114375438,-0.041529783531830268,-0.079112823290570247,-0.028439541923334352,-0.047215277761511222,0.017919873457542868,-0.043730620825476289,-0.0083077673092849316,0.0080637615090816683,-0.042847844269627344,0.015732582480551337,-0.035877042331939335,-0.020274620631426151,0.0060017334212957209,-0.011038427925582694,-0.0079321859154538772,0.0024669467939925456,-0.047174751648789807,0.019484888947581012,0.038912158226446558,0.039176172588516966,0.0053797578511889238,0.01139452493864973,0.022134514065384248,0.10262246569682075,0.060645448427255277,-0.0049047335544548376,-0.026337548147820675,-0.00031049715236153297,0.021471089177500111,-0.02913111856188328,0.049020954146217169,0.04824653180085528,0.087540872822502711,0.07299558540439087,0.019711133472069112,0.053346275999322679,0.068713013463729239,0.0089235415332704765,-0.0091036040048159544,0.0059129844090943101,-0.012742345396119917,0.056214606413909123,0.063790565651105968,-0.020641135671904988,-0.030946926450396303,-0.016711976557631042,0.1127244564225961,0.02689697887910851,-0.013567479905524482,-0.017090058647780196,0.01477668396540264,-0.010781920436714542,-0.006922091337546267,-0.089428459457285198,-0.067232570801827068,-0.026910735478631764,0.035336793970009189,0.16956999523533778,-0.0065457838988597361,-0.024077365950438537,0.032166605250999306,-0.017459200412506121,-0.040088844438940743,-0.099301197361124693,-0.011984969849644441,-0.027641332988394961,0.012259320892963398,0.099469618921912001,0.030178783959567166,0.017806737961083313,-0.031243892294941327,0.036952968809518559,-0.062248228689263954,-0.018966613344436702,-0.066056215647809571,-0.02680077856103967,-0.012533495449249166,0.024584778032468828,0.056249746142491924,0.041206463201368705,-0.010337287195679248,-0.044756156557245824,-0.072391192005918537,-0.0056600512539719122,-0.022191532906063322,-0.02597985228049178,-0.0048569317681961439,0.0022456495424232501,0.048041845230600719,0.021878224718166694,-0.031093682711296713,0.03107864582201561,0.028619968620320131,-0.059947445075684995,0.016801646203229784,-0.0025822067852190656,0.084438821665531974,-0.003253904863717641,0.02175579697998456,0.044396143599607973,-0.0081787327528522191,0.04342802310153146,-0.012815929012254187,0.014790808529243901,-0.028622217225797268,-0.048854772240751264,-0.035404776408354405,0.070880645278505183,0.054724662067758528,0.086068694846379121,0.049869516112302004,0.024134618019859611,0.016045127809092008,0.021408152684806558,-0.0019594348922353459,-0.052756609552716119,-0.046484303325115398,-0.068062813120118207],[-0.044331925230770723,-0.054329522119882984,-0.051769461081186574,-0.01525353279808098,-0.01070122111548966,0.0092804570085843405,-0.0062410209171876582,0.020071586960402881,0.063349260545734795,-0.04992151146932073,-0.024847935737445589,0.061077328397192293,0.073126703765815121,0.034270104298964765,0.035888286964653064,0.065558812412295553,0.0050893801576369253,-0.01742526677567887,0.06410303374113939,0.063690998960531819,0.011936936642071773,0.0065558893104545879,0.059351618349500423,0.036170614252957374,0.073144876020142385,0.043276296735218094,-0.0077362104397021465,-0.022748848048502378,0.004668960540261835,-0.00069002660498715396,0.063939712901835977,-0.014966710082811807,0.0030727592791528514,0.026662644906728487,0.052820346942979893,0.017109036507216773,-0.022408542987520336,-0.087084724994147211,-0.097569765420874172,0.021721228084129754,0.051712419939002871,0.032756768677244273,0.017819938585971133,-0.037825552779906096,-0.099906582374084577,-0.11007916981172988,-0.063039969832338297,-0.11065720406183299,-0.056463971331915969,0.026810997895988217,0.075619829451265996,0.073184027699837118,0.035501377120659039,-0.023904618994720753,-0.017844665146339908,-0.11756514198915489,-0.12168288991626966,-0.083114279850997466,-0.034920888410994,0.046766450072332821,0.058773833741353781,0.010496365445282875,-0.0022130497808088385,0.051099528389418059,0.024774714859440425,0.023471290407304626,0.015631876716462951,0.017970346390513474,0.0019335540535132985,0.03051462142073259,-0.031110061550176205,0.03360548749067617,0.036258212592403839,-0.022201080422089837,-0.023002827294496608,0.014758321300040728,-0.0070368058672472117,0.11790263516593479,0.049474341493852388,0.062413173309873948,0.052777269288969954,0.0094326378468209612,0.032163792810796982,-0.0071375680551991191,0.0032748797229581496,0.0067896199680393572,0.022973239078915367,-0.030044038850916659,0.095054792203179583,0.077918278809296693,0.025170796867169457,0.03248633395739102,0.00548093487382893,0.046288431253225307,-0.0048346651023808999,0.010140951369667767,0.0064050414683687936,-0.016192674375299247,-0.020769896639595678,0.071543155267954142,0.041811635752456604,-0.0011513813928812448,-0.0069609227018348346,0.016359548418687996,0.025002761420305327,0.02055238314967053,-0.0015891153508810953,0.036688265432544012,-0.059254810876512506,-0.004524146766604867,-0.022764896844005511,0.055697322831434269,0.058835090349322952,-0.017695954014236001,0.01434475115987981,-0.020605598415603534,0.021010015372295208,-0.022474770741166539,-0.040296790452836906,-0.040551682538183538,-0.036579658592001969],[0.048679672604873575,-0.0052210780917486968,0.011189809961728723,-0.014770773614183955,-0.034142207536203256,-0.028004372616342227,0.0059493580101942483,0.015102059175930433,0.019900835917708519,0.039960819331958518,0.0038194214559740605,0.01388991934048571,0.075502995650847393,0.05989103883686564,0.075512404372436573,0.073756282062729772,0.10697289779941345,0.068740762469562872,0.048031325115771309,0.042366249770111879,-4.2026778606093357e-05,-0.012109444919293957,-0.011318629446975792,-0.037381626729477938,-0.021548420500173249,0.018481632817077147,-0.0052013341004672684,0.027476505756756441,-0.013858276037494007,0.043728377691453817,-0.02503235093554558,-0.029686717094650691,-0.019073492339460648,0.033491515961355481,-0.065963899461171427,-0.062341635557177519,-0.075624328092431956,-0.053585585183758444,-0.02877361255805902,0.0066218070173488103,-0.10035769919352369,-0.089046460941984568,-0.046139804006717938,0.07297541439744247,0.08725084363158328,0.045168092371441648,-0.05333664579595656,-0.082409439250664893,-0.091444433373020814,-0.074425623111224221,-0.092126329411898994,-0.037674636051740117,-0.0056525304036601151,0.067513154505640993,0.093934210469869675,0.0092896691237717884,0.018516434326696123,0.037297581799338571,-0.021567249747191534,-0.034818877231227827,-0.02178280374647603,-0.02580882232156104,-0.036853163117586477,0.005007242741758529,-0.0054865350633394733,0.03688895314986719,0.02030363893313307,0.062349708701591948,0.038517231153257302,0.067307645991564954,0.058616348298225311,-0.0042177704428246199,0.054673040661478024,0.039230731169713394,0.031392491178710777,0.043919434454236447,0.043292679240196676,0.01880512733348403,0.017382645623532596,0.059661624010023243,0.033698675096640159,0.013341888531181467,0.08421015245705174,0.025430986838139963,0.012904413846026745,0.065431122065089942,0.011197289986359183,0.029135622794168346,0.062540987885654917,0.045382776129875506,-0.0053462603961966226,-0.017266787058448405,0.020420174075574692,0.013123043389498143,0.01525904905961481,-0.018730258477720974,0.023824284687915143,0.052818399981128895,0.015447226033022343,-0.012489602024893638,0.014683734340722451,-0.02685260219002731,0.028989118420292514,-0.0048952379910385084,0.024941536558213226,0.080074825915833162,0.013282727442137699,-0.030419960916935621,-0.0077058669293919302,0.0057615039328642731,-0.022997491985162988,-0.031813252703541905,-0.0074071331247387365,0.0074685762164737393,0.066651669608706721,-0.043189594128709249,0.0087486094318929737,0.035607481241798619,0.0093449129697469185,-0.060325944063403136,-0.02989706486831599],[-0.021246880546086595,-0.022203836487912819,0.086827201278774843,-0.025228269953020035,0.046971762650786793,-0.032032705567453051,-0.018784965671998312,-0.004315941436901353,-0.0418268952943677,-0.06928924256853522,-0.0081666516254654542,-0.017438229004257164,-0.024335471310471764,0.028654380266214648,0.072066491882920122,0.016590540091147674,0.024633229035089028,0.078139556365993512,0.056622200409004196,0.037502807115330446,0.037840229470096992,0.032000001430608604,0.013106472326739116,0.012369223564270927,-0.028705902974894969,0.0050659301606566509,0.013853418541047425,0.00055953040940459609,0.020322571781100932,0.07527603584001831,0.091912646107956533,0.11098583412431406,0.078216838723305357,0.015546123816145365,-0.01174475399733392,0.051737996061461511,-0.012734123174444889,0.016768985632801714,-0.044365898602312492,-0.099553508533813909,-0.050100281868429075,-0.0572477447691047,0.016222179759918118,0.067599657169812671,-0.008648050879736989,-0.0032868833097521172,0.0085922588825274523,0.046767940575399347,0.072793826165235873,0.045294967050798711,-0.084825295102879616,-0.14860512013508548,-0.051316060883006345,-0.12479434422523886,-0.085078856704692979,-0.0057128248462955805,0.044162552063783153,-0.001048023139082116,0.030855043319812047,0.035139310135952784,0.072277327757524351,0.053917648452753389,-0.044671527799533012,-0.082684884460253502,-0.10599899450799834,-0.15447137644238773,-0.011133194850090913,0.028927718717327938,0.0038563782177809536,0.016247602026169011,0.017415917794260313,-0.021407239152637751,0.026964006691972034,0.028130757592115849,0.025157803866096017,0.037924085124599397,-0.0046849643873905084,-0.027697413203631536,-0.041378992383391267,0.0087612328882413319,0.0052052300046328374,0.043900410523183886,0.077610211778951319,0.023415755123284865,0.060860467661889836,0.035574343781129072,0.071927577630225378,0.064070926820927313,0.013357966646117945,-0.048365636178152809,0.029793021490433041,0.005225453074711478,0.001772380719733067,0.043271021300702546,0.061871883282456325,0.060250041239335972,0.0059220775592172988,0.067275053929414422,0.10149603554983715,-0.030661903793952457,0.00089428604746767844,-0.057645311311752261,0.033294846298777651,0.024005678533927544,0.0049160862915328327,-0.018549226060485483,0.028088385775127147,0.023382362593578041,0.034065125172518744,0.07678838837073973,-0.057670084152690565,-0.034527649268692978,0.021760161147630741,-0.072333662591223591,-0.00053618118175239454,0.029546492159811099,0.0043528145210185842,0.0050096626752825398,0.045672332663587202,0.027025414018034634,0.047574909566606413],[8.4608016445507188e-05,-0.00051458603662822393,-0.00065583344160838331,0.00020678855120534164,-0.0011087422000772406,1.7282608213937956e-05,-0.00069139299457388927,-0.00067753460732458931,7.4613346472338082e-06,-0.00070526584292512906,0.00036510757807054156,-0.00022612583636142519,0.00083733124736023318,-0.00038556424752306945,-0.00020677490024442052,0.00010703864033769633,0.00015849441156012833,-0.00023178848590595102,-0.00023816000343533997,-0.000420628080187814,-0.00035892451039670759,-0.0010410723256383952,-0.00070994799374692746,0.0007230031202940905,-0.00024735560793927303,0.0004891872672126707,0.00024923784651577352,0.00060668980402729254,0.0014982106812944096,0.00053619751642124819,0.00050086941012989633,0.00089806877848291194,0.00023875283911756195,0.0001569025840717983,-5.4315342210856099e-05,0.00056173407996628483,-0.00015464198944174475,0.0003080961595964592,0.0010477498266872332,0.0005403071450221222,0.0020027631503172446,0.00073696212701762631,0.00041837758978503781,0.0011534221243659493,-0.0014158435817800425,-1.73851858713929e-05,-0.00033269545836868853,0.00025908994851942674,-6.7895175314192091e-05,0.0020025402967875014,-0.00060120961823892718,-0.00063728772747552453,0.00088528834369269727,0.00051385231712379464,0.00080076929798790497,-0.00021374130033396943,-0.00012763782981460581,-0.00032299201148121293,-5.5463761258908728e-05,-0.00038413195736432953,0.00098095746371240633,0.0016769261261450272,-0.0002368271084003809,-0.00047131327166750892,-0.0011833841321572391,0.00011652969229286516,-0.00069780759172321442,-0.00081516216404033115,0.00031471538464767062,3.2977760094066362e-05,-0.00074268117841487513,9.2834374935888298e-05,0.0016276084011049713,0.00052039347413883026,0.0003285769128429112,-0.00090914431575088526,-0.00066273949795000141,-0.00049429425680350917,0.00081787103240475723,-0.00028646816494606181,-0.00047774822091328339,-0.0011287002050334449,-0.00014958608778612575,0.00067727909838368253,0.0018426861751217457,0.00042127435964937898,-0.0011897602501548844,-0.0021020944752171283,0.00025862501872599489,-0.00028164777099942001,-6.7871288290041742e-06,0.00010673321891338397,-0.00081946733629025144,-0.00050655780311133561,-0.00045739009384393806,0.0012233134687435353,0.0012483089084911257,0.00023366693745787998,-0.00049653822033247572,-0.00060431039974054301,0.00048856312080340636,-0.00039402287572039285,-0.00030282982425909599,-0.00048297968441542161,-0.00045029888856688155,6.8065154860727506e-05,0.00029380813408220671,0.00080750067552030902,0.0010027117298195727,0.0012117980796380462,-0.00031499882641429153,-0.00096615449547508142,-0.00016520767145138809,-0.00025930083458174102,0.00070444567594835084,-0.00051524971604912512,-4.9950991088697216e-05,0.00023269835482522989,0.00098128070058338401,0.0017427389161336626,0.0012748954300746823],[-0.09216726473640563,0.0056728742547598144,-0.0093745125247278963,-0.013062003758843106,0.026810754174940429,0.049001345358430204,-0.021651121797821183,0.037001156569604607,0.0042183127400313627,0.0018620748056430826,-0.00028650345860718393,0.0053573451925248185,-0.024952282021024397,-0.053963168016106317,0.02220135440090492,-0.013351422685652972,0.012385499720994092,-0.018031103648731638,0.025521909572096997,0.01253732595969557,-0.011991546378321899,0.045186572016900094,-0.0094335083884424294,-0.0044184293091944493,-0.013784342121793192,0.025926061962200528,-0.04105356169652366,-0.03889277471178329,-0.039895674599080957,0.035441461163177923,0.023677237357549445,-0.041021777310156667,-0.057695608854404799,-0.01762676919993638,-0.020216604797755007,0.027628137586160582,-0.018841264850454086,-0.015264367494595166,-0.042662519918908834,-0.076631880879329428,-0.057528782374830695,-0.014904729302692682,-0.066897780001713703,-0.06532989573225445,-0.0076505652205603458,-0.048586565493310384,0.085981797610375443,0.023144594932235765,0.069502587525011622,0.023606740362224744,-0.03701131089094889,-0.086463629853619134,0.0048593320315824251,-0.047933152033371423,-0.065202394397951363,-0.0083087466099175528,0.0036048909369455263,-0.014176009427905843,0.086524500164412141,0.025019184064985066,0.18351010232889509,0.1773063621666941,0.05264594509899273,0.046296374049865419,0.017268040614808002,0.091744326777185067,-0.011476730811934746,-0.0031098305214721789,-0.044720850821788796,0.035194984568811871,0.035161502690833665,-0.085225661297846492,0.059125980810968093,0.14804082639627478,0.094893897974964725,0.10021021442994898,0.09479988677758025,0.016819487190214488,-0.001620802251457232,0.0056983698526431037,0.024660235147196684,-0.001744068586085468,-0.031929007957278016,-0.08234588274111157,-0.036631877507097843,-0.00060561413909040454,-0.0084923776484023029,0.029092555992398725,0.021733620396429669,-0.019868686758322113,0.0049377342712525838,0.0354455889830066,0.035659507135636787,0.057301879108241027,-0.038291855034349676,-0.061603790001514017,-0.062081937237464455,-0.043689034974759226,-0.019286854706340784,-0.015927077135257463,0.020688030294743746,0.0061874980221431662,0.0079544756336816427,0.038210084103014429,0.017747129076694818,0.018299098668275414,-0.071993890721030018,-0.04880614394384078,-0.041477514541540167,-0.074196014839536834,-0.043570050319461741,-0.024269573468651304,0.048012036866646256,-0.0022007186161765308,-0.012800711217039476,0.05287613915145286,0.06224964320115732,0.025342119373221679,0.0028708573689360251,-0.041475224097980136,-0.016770635320925542],[0.020791522234705886,-0.026685059276677248,0.0052683881367612678,-0.034938985350819116,0.021609135295030821,0.072759833840912294,0.041388662663081791,-0.022050570784842675,-0.03766921280042098,-0.038135589145765356,0.056138069483269673,0.01870086519715047,0.024053272871131241,-0.044521548367207869,-0.0072802659094019905,0.025521806490733729,0.055898032390660567,0.020086252624459025,0.022257708387705265,-0.043113185738142573,0.025460765149070363,-0.041999586106773602,-0.022103861342994947,0.020436961749637446,-0.0089104142150475685,-0.040754212701411704,-0.044989111609801367,0.014513662447400134,-0.024972880286720952,0.041775700269714146,-0.020617899446434662,-0.027451770104515237,-0.0581210200819193,-0.01972807133154101,-0.064863569531781962,-0.065429246017521078,-0.034021394098613274,-0.070154069814679601,-0.047185801462871463,-0.066864913651470764,-0.066928175305740994,-0.045242116038150926,-0.041527188035858031,0.0090971915515874469,0.066566987623413135,0.09217912843511486,0.035601037862094155,-0.031646183711611257,-0.084854398526009359,-0.078071918455593067,-0.058063889054538138,0.027433416517916739,0.038430683267361994,0.093545180120055263,0.020820155765660042,0.053867582404908895,0.080126804974505278,0.12823246066629901,0.10909482374666421,0.12328440515687174,0.10908470088869585,0.12750021442141796,0.089820420443205415,0.13206669887005298,0.040999003255566858,0.058589622623364139,-0.028140612810618193,0.011014387203399659,0.010818445027512502,0.057563125740994966,0.043454150260847313,0.0638052153810197,0.039304942349605,0.014669342715182604,0.031072595757211559,-0.064253742074883269,-0.058945218947391416,0.01193269465678194,-0.088116225981897403,-0.13130241652649149,-0.083772332396980051,-0.057941723086485299,-0.054054451777421325,-0.052884392643230117,-0.09093972499912327,-0.054181261740231752,-0.048566262449049533,0.041761684409925268,0.052504158945313288,0.04064045371279662,-0.017347415771619662,-0.076719756803110536,-0.061854859388876034,-0.020823169528688797,-0.062266455107789991,-0.047703214610949791,-0.040227307948697298,0.046901220891254883,0.057527412627830121,0.02543790657840345,0.069956528520047301,-0.0081337298400100972,-0.020791993788821496,-0.040001890418240753,-0.05758450686937977,-0.023269358988961084,-0.04372684111076177,-0.025274229592385768,0.047881871341667451,0.055113090538271091,0.041259701309823663,0.030577926161307056,0.04016185297326795,0.077325910227506373,0.049074284090185986,0.020718323049837589,0.05262692548423558,0.057604266834923888,0.051058314474601463,0.023973320452055122,0.10154029156391102],[0.038641739990258633,-0.0050244591541973721,0.0046136555572029725,-0.0067584458968164562,0.03142115173410135,0.043863820713166662,-0.0015664513032071729,-0.080587538587864549,0.023010888007158094,-0.031974497946145916,-0.045852604775241584,0.0073321619577446512,0.024538236370796981,0.026493986359803483,0.012817297004288597,0.015872668762235975,0.010885319603060616,-0.025021809184165841,0.03751411496590415,-0.046294554576462262,0.011215007929641349,-0.02865689693597509,-0.015741373908333564,0.010582364969449747,-0.0060245340950563914,-0.0021638463212280828,-0.012232405683626778,-0.038573436738902116,-0.034196779922251591,0.021758828506470554,0.0040701402954654298,0.033018994443948589,-0.051703841216797261,-0.053297422863193972,-0.087986965234679054,-0.036088517832627981,-0.024713800986492014,-0.045558468938308061,-0.06323440947763162,-0.0079875844696831663,-0.0012689882118882348,0.047524990788468238,0.014455312192059422,-0.018256989781913674,-0.027677988718192631,-0.073305419918544265,-0.062178446834711937,-0.056046138548416793,-0.061582574394783318,-0.013981639384921803,0.036486130784949389,-0.018426595901044535,0.072796751112711278,-0.0075590705083293415,-0.024644110824231222,0.06168186724387318,0.060668636974430631,0.037713982535211056,0.078054934945803039,0.14418916995002865,0.15559892027908628,0.067521632288650851,0.019945580585251987,0.026658612914922927,-0.012069655500885873,0.0057425840485807404,0.083144548120109421,0.11628270848199979,0.053997152612150712,0.074409611827373545,0.067028727192838367,-0.054231046134796825,0.0039030350681543971,0.062433312935196959,0.025820518574058156,-0.026726551682383845,-0.010193345611774624,0.020415993983784991,0.060395051991757931,0.011092152032282707,-0.04696569874087772,-0.07052421722415371,-0.072561804228264887,-0.027650589315538845,0.068449933489119735,0.03300031824163617,0.041736298644040548,0.011928446975795447,-0.054917381191681824,-0.051653802268125909,-0.028773541890526888,-0.037452616870395278,-0.082340063854409298,0.012374637017067137,-0.0058925331814810994,0.11104715646061467,0.016941481040333578,0.03319422535043131,-0.00183737049680259,-0.095054133079783387,-0.05896573649709879,-0.040233306687047658,-0.046408592586160452,0.0083076855640988323,0.044775412494742942,0.063589932355388373,-0.010508998580612362,0.066094053744825035,-0.0027753074050847724,-0.010075721966416776,-0.050323575669113996,-0.0068444216705598714,-0.0041475728122527351,-0.0038945396282382776,0.028366828254517029,0.032085016082864043,0.029300197945124618,0.0032286359611920848,0.071385590020760878,0.023726429769362518,-0.071250665399322441],[0.10872537789851011,0.014278189525074661,0.012273877115053775,-0.0081392543273338877,0.057053104705377521,0.042321601806311455,0.03332397665498274,-0.0094696243183966938,0.022832248497195895,-0.060308217357328699,-0.029388353818991391,0.047862958793470828,-0.010046448412779706,-0.018988029533582834,-0.039885552090269713,-0.040504055383590309,-0.014328694386006549,0.066888009783769464,0.054680567071356045,0.036468027087737401,0.027426069930502159,-0.041156646091381657,-0.071083792516037081,-0.038858148067829321,-0.052404651812680655,-0.037439793873889099,-0.072141553723678531,-0.064831984361939266,-0.093370898670026015,0.012492784149001596,-0.012992603451236887,0.012827984972397261,0.028495833153019318,-0.088967419902127892,-0.059144923132213638,-0.073603628874425425,0.0014228258212915287,-0.061365580816495208,-0.054662891582800743,-0.10167804607960763,-0.086349086183820561,-0.013058338568626704,-0.020967276930948797,-0.02496861635421278,-0.00867806660644585,-0.05092789276026935,-0.012321465172884127,-0.00979595224133116,-0.06038602061828513,-0.073566019699290497,-0.098900952710465395,-0.095044913253043817,-0.050810313973777735,-0.020639393298860699,0.0068008806732431596,0.15285717060929618,0.097545372872726313,0.11067705492765795,0.11229427860410809,0.18427633371321137,0.11307184167377732,-0.0045716220662144038,0.0064434015987714695,-0.052854132609023295,-0.020146160375414821,0.0036234729462064491,0.055736679511239132,0.046045942922945615,0.022877085053644025,0.019701551970110434,-0.044509960624947387,0.026260060577445368,0.0012791409413432393,0.11282744913606092,0.045955737539801839,-0.036756266818064348,0.013792875001360963,-0.00031411118081339784,-0.024157026907081533,-0.0076891189431453205,-0.018310688556061716,-0.036924502766096871,0.01587681789027176,-0.00074296065299485348,0.04435085579041969,0.093549734756817104,0.034106620050054992,0.0074666958029946731,-0.055729238389459056,-0.024914950480349144,-0.040394064221819001,-0.014479423659402343,-0.021786228199499567,0.034462836766090535,0.019018078277086774,0.019995937468091644,0.057264247676035301,0.04080735202882977,-0.028382616191986051,0.012260696627029324,0.036426534866617746,-0.022902539374817468,0.0068340274728649064,-0.0095408080735063794,0.021714345796159974,-0.002425244709437491,0.026186714013621812,0.06273849289505809,0.013100065944167471,0.02184527152625354,-0.0064556273106626955,-0.018059624197655194,-0.011501119699467793,0.011069356592404581,-0.0076555726632192645,-0.060373289292683437,0.018730638535199164,0.010878747575572504,0.039313330705399122,0.050533322267807532,0.030800301775522385],[0.040802901586182709,0.065103705890545233,0.01571760146393637,-0.042967026067333894,0.053812288839959845,0.074783021511556802,0.057112073514354537,-0.0020897181911366594,-0.031444155008721532,0.03665938914354934,0.079577902386804983,-0.014494517062943354,0.023853876703959682,-0.085960234475358457,0.016421056516635474,0.053098980528390891,0.044587319319406481,0.075787383037682066,-0.020575193628669223,-0.052303363133645836,-0.0027125538469783411,-0.025364536060143633,-0.075564109154979769,-0.039844635860099079,-0.035503765834440412,-0.031982916804728603,0.016275057515532626,-0.014982688136025823,0.0085162879583037827,-0.010415191123769537,-0.080245107677651376,-0.068933869414995408,-0.082117266151384732,-0.10868042731437648,-0.11517402154338535,-0.052169980652789334,-0.078002618803070467,-0.084743043622459768,-0.090079412279082061,-0.045560705318270327,-0.099137819733507423,-0.089931119548774821,-0.071756723384732823,-0.1011983905001102,-0.026108924802754015,-0.02895558848827974,-0.052952747867330424,-0.040651011278506941,-0.062403675645972413,-0.062530867826569025,-0.047639683852648468,0.021549892035432196,0.042011742541525871,-0.0014168202056091244,-0.060017710153938739,0.050238665733522286,0.094413292104875743,0.14252847594850043,0.12070740630935128,0.11697697498229397,0.098975653037204459,0.12840555821628419,0.1092645611216749,0.10934335033079282,0.037269298258601313,0.022780470067651784,0.044473900840241241,-0.0060598467528648128,0.0061609144853983725,-0.0064768658816174163,0.034870432574956867,0.039379809714831654,-0.0013957543834296031,-0.028962960938971525,0.0046569189597002736,0.043727516840792277,-0.006941018795027367,0.018088182930952126,0.0082023947523770183,-0.009919468949588936,-0.060300576196604963,-0.04961731590236345,0.032033275510473247,-0.01701144350548291,-0.040658744671612526,-0.017714249349095157,-0.017210598588884591,0.055569751424096779,0.064732172425609261,0.0142514421392548,-0.026792644729731044,-0.037619803421594447,-0.035454019366795209,-0.0033597142606219474,-0.0018841722971697202,-0.03513935986915321,0.001299552487248638,-0.020445085521288382,0.037428045865738391,0.021313292534809361,0.054608035940519203,0.044538080793511958,-0.025502640115099909,-0.045072000923970221,0.014585725040689751,-0.031780543877902773,0.0068856119179188241,0.0054808839404315718,0.010447966359669152,0.036007093277555829,0.072977664284250968,0.0081451532648436076,0.018677942155355585,0.0022220414820895706,0.038133960894140659,-0.022256466219839181,0.018473324676275091,-0.019158933928994693,0.053864036371846072,0.0041178771402385003,0.042051744426760795],[-0.11959471143292481,0.00046908871164344848,-0.017806537583872739,0.060028987830965261,0.010482881406572234,0.1134097871181696,0.060972001775857071,0.0095573140622628831,0.024171870288714075,0.011559219957486627,0.074094322684175498,-0.0015330263524836879,-0.042433991686828154,0.0093887703280045344,0.054396766959822755,0.0498214705214945,0.0059163111595279677,0.023110497561564927,-0.025327700927906302,-0.071391862957095473,0.0028116491031619471,0.040639736088270678,0.023985187089475772,0.00080593035361482476,-0.017294104303814381,0.019318061091531672,-0.051785631407524797,-0.06040231096160379,-0.051630865282623027,-0.026410009167490766,-0.025387094238179267,-0.086705148484331765,-0.031667117402875984,-0.03259729996049833,0.0060777751022725451,-0.030850143895008959,-0.10889563458102586,-0.059264340142843021,-0.058026751391014861,-0.065550940259139531,-0.076388204506250154,-0.014694324172739949,-0.1161029182457609,-0.13336448135124818,-0.013871869353886061,-0.071354914609700726,-0.046295795137470362,-0.046341257133683728,-0.059803897951158161,-0.0556899798471754,-0.088752078300497958,-0.0092766852217181367,-0.010765871754746199,-0.013689713283032208,-0.058953596738130137,0.018926773961227689,-0.027282178971395361,-0.039857478520104385,0.012549232916158878,0.010688241731306974,0.080319165930301445,0.15262100299518466,0.086960661319310489,0.15252525992290902,0.069463873136678234,0.11198174180776471,0.01737147006474421,0.015812778630970917,0.032806003786103988,0.017746821396218554,0.073544673139239528,-0.032110260377912717,0.019566763627964195,0.029618292548164962,0.038786297055650301,0.032627871772587649,0.069816775578256801,-0.0062508202311634649,0.051458415560465681,0.030408800781210513,0.046777479573010872,0.040002134296522718,-0.02008807639444515,-0.01263470418907111,-0.045249735132798174,-0.034253925513510058,-0.021875531092695553,-0.045998549423427841,-0.024164107680801648,0.0075636530397308332,-0.00091421816686280792,0.035702717797856873,0.088574974690186048,-0.013734861595105412,-0.0098033211306002566,-0.04282565326207903,-0.0012702256209832369,0.012700494745847814,-0.043166253351587705,-0.032268233451616377,-0.0035432592129699403,0.0067580471025863592,-0.0053453862422648962,0.023287783646401855,0.074292726072946569,0.019466527108545371,-0.017987962764354493,-0.0012524056877380139,0.022263654018090235,0.0012391427069160937,0.0013565429618937579,-0.0046713438401512937,0.016578328153419922,0.036584208476039909,0.001097170617763564,0.011356767972489225,0.053430214295184963,-0.00068444374047767209,-0.0384483419844764,-0.00058389549992762108,0.0032910175381761254],[0.0087136750269642335,0.021184676494079766,0.044118373966988256,0.040648025991879715,0.032447241186740375,-0.013324459836625741,-0.020142424050336942,-0.025882484787532859,-0.0024840579433286908,-0.019010478599687353,-0.002112799546736252,0.009101832461506542,0.039625693797873313,0.017970409804111777,0.037360151074966881,0.019343344984558475,0.014756799698268486,-0.0010528464090698991,-0.025961909366916235,-0.010285595270832736,-0.011165374267784578,-0.0019598758278640237,0.0087081620119244998,0.034494100706365091,0.028652254710913989,0.040299978182407034,0.033374343071050708,0.050349542304153089,0.0063625956689595461,-0.024011839291926199,-0.042233372866263372,0.022057516258499003,0.053376443527016197,0.020620147730700943,0.029540439011999847,0.057651788173259826,0.067979091933384042,0.062646746017868765,0.049240173935889892,0.021169919247216541,0.011453866008363397,0.010299220942533334,-0.0018357416874219962,0.055929573434282689,-0.011231564367321699,0.032042065774273598,0.01571280002325131,-0.0070039251490842721,-0.009101648993736014,0.016511365940874906,-0.019704911391892579,-0.039092331240561939,-0.045771081107692201,-0.0077691616125735372,0.049862458553556741,-0.06736549253306108,-0.076963070633090172,-0.040595361000206484,-0.030389356872258563,-0.092514337569437666,-0.057211588696462493,-0.00095436298004251963,-0.045682047502914935,-0.036818864364637389,-0.068243509434178257,-0.027587536268803375,-0.041645167478661045,-0.04303078919819505,-0.054497722201413787,-0.068638447295754565,-0.09778610861618825,-0.065713312081331784,-0.052881969043814835,-0.01339699229959858,-0.019033794283482786,-0.023493218289815446,-0.036063450059278426,0.027782266928957237,0.012906654330914466,-0.017337278434917267,-0.064487941544117314,-0.099835383781717732,-0.10289791170276469,-0.064663551431551017,-0.0641236728999387,0.010795364389364459,0.024949528393138493,0.018119888699965225,0.10433442726226234,0.10219165136667126,0.013336681266255849,-0.023600080179398731,-0.089887755873483743,-0.10446013110840585,-0.11164381762372182,-0.051551762026531431,0.045266919305088242,0.069677166083149861,0.13697123941472913,0.064482888607458697,0.098551199117389618,0.09360636141971522,0.037819160682802944,-0.0035166197905182836,-0.0028484068050251173,-0.031608943165469139,0.0046811946910951807,0.017171967845917853,0.10536533016879272,0.082514398940340364,0.010270426109688261,0.04723579496187133,0.079022702429357855,0.073711303154692515,0.040152485755633946,0.077664793581362607,0.044442834049414938,0.014455191975205124,0.022399756108926826,0.017224699650463141,0.064738964118889505],[0.086171813825423521,0.043276344722271272,0.030057182293563189,-0.012272805932473568,-0.0084497919375918426,0.033191584991409173,-0.034725622268988551,0.018176702115917775,-0.0097127781766898486,0.0085166182323308352,0.030226931221559766,0.052416098527926294,0.051668837837120909,-0.013910386317496911,-0.014892754899464261,-0.030204392408315697,-0.023348595772105338,-0.039154056656942125,-0.020299148174262385,-0.026870214226325,-0.021026881302678255,-0.048342252841896659,0.050216024122317592,0.0017508003206529706,0.01784781112040023,-0.035663337208851044,-0.055701361822959372,-0.034565501095180508,-0.0001449409970588969,-0.011843034224678937,-0.030725274086672746,0.037181115372523707,-0.014334667924480585,0.026402505410657532,-0.02157219826244711,-0.050784579030140373,-0.0067591136459494716,-0.057082366222224006,0.0016645285356211514,-0.0041546960728905628,-0.028755773827423173,-0.03714082137578157,-0.058966690069682928,-0.016029429438384403,-0.0031721930051920033,0.0023077585454026051,-0.048021525210782345,-0.093376311841670362,-0.055542556473841764,-0.11398186442053326,-0.027456752012806465,0.016614108182758672,0.0027741155498583747,-0.016348951668857664,-0.072146978965869676,0.0015395126311125717,-0.052682834934778711,-0.060378727516170197,-0.068266862134838471,-0.036771885672760463,0.11935191252954988,0.10244934755298962,0.027542982076475292,-0.032070419062542696,-0.022385148133489435,0.056289823602901912,-0.034119337486394785,-0.069686895736583362,-0.049955802720861683,0.029733455414129237,0.20068856127367213,0.1162085020692212,-0.043410251863060023,-0.0030593783022195981,0.00063195918916066768,-0.0015553440469552871,0.065277285494402815,0.010466423234828076,-0.020040852081297265,0.061755629831554908,0.12136556526370923,0.078247187170092367,-0.08072517073390352,-0.075077412337979363,0.012154159684612222,0.036821934539862315,0.02472102052087196,0.040715988579243925,0.021622540244536845,0.038658271107198355,0.052578818327128657,0.083631018106240448,0.04788200302645329,-0.075156815694368884,-0.050687783633637906,-0.0088389729616671769,0.091034820744931355,0.078447244012908812,0.06227592062517176,0.060594909680654375,0.01693797817353428,0.06408103556895299,-0.014547815241575009,0.065658196419567896,0.018129490859442446,-0.08798530089434585,-0.026622130825924434,0.060886174973499241,0.077750707436133701,0.066437874598894484,0.019421765119352175,0.048504723287502369,0.07041372195878251,0.035827424258234999,0.083548417322279078,0.060027813387995552,-0.005432499769252413,-0.0020892485624801555,-0.030512250542840812,-0.00047303040700700464,-0.023511765584947494],[-0.019836270599180916,-0.0017613217539587485,0.020980704061465912,0.032444977290163338,0.035482360716385192,0.051463914122762917,0.01387059443680283,0.012773320795543788,-0.0056081410148611094,-0.011615184428147185,-0.044318141985502046,-0.060123468169623585,-0.014777416807908089,-0.0053582542779810755,-0.054379500064678565,-0.04137798510918636,-0.048976925694358256,0.076953418090969714,0.026914330698442304,-0.0014016954910277407,0.0097461019716972574,0.0046963778137781992,-0.0069130491706136665,-0.040628477563491361,0.034128908242092887,0.011113734772594072,0.026923522254639856,-0.034901970199125179,-0.083572453474777542,-0.017956322789516803,-0.013806163282359438,-0.06239361835505905,-0.0041426826588957799,-0.037637167036336384,-0.037724529658588551,-0.013774694560670805,-0.057704817420390679,0.0048236498871859993,0.07228227823302627,0.032161882846836277,-0.065744929925494702,-0.043635280281107837,0.00026056292826356561,-0.019142520605292868,-0.028407833505873292,-0.057929038649120537,-0.05076593603511028,0.034535717074437706,-0.092192499765500688,-0.10532839199459904,-0.012076014852148213,0.047512930831949463,0.0020511676860901244,-0.026304839763800526,0.059014485786431731,-0.04121884738294615,-0.037908511573603157,-0.035253683963737445,-0.003764225518756617,0.1058253214787373,0.15061197856457278,-0.044965430671133816,-0.038672944035853724,0.032859085087083864,0.036836423091902562,0.091521334284663594,0.067930349704352549,0.001657465766571567,0.011255029837672278,0.019714575278699853,-0.046029623685046345,-0.0051819605809679953,0.13027259585766382,0.076244041762153464,-0.062532299911886025,-0.073583991135358184,0.077174533475065421,0.049432650608868409,0.035864444263751481,0.035719679749892569,0.020318474287435453,0.02861748003954917,-0.18444657518134203,-0.027969189014098672,0.14692467780203242,0.14809587852238354,-0.03290596643929547,-0.022816759205720398,0.081642802242600315,0.073319424746687803,0.096551558434272475,0.057497490294592224,0.019593324904571427,-0.060101281088941985,-0.055289785260653201,0.077752523928707032,0.082231188321325199,0.043012682164453975,-0.084998541929117044,0.047226746411041548,0.11708089871954172,0.073957832946588489,0.068481921009760804,-0.025787797068816443,-0.042547833499527232,-0.028797349310348233,-0.028665140255539324,-0.050465025239779027,0.0099282727284533898,0.0074795255927929058,0.035767022417524885,0.013422682869269679,0.059916646550554516,-0.017252353019081054,0.00014025453940576249,-0.028232578424891228,-0.037232130930961754,0.03807283410302556,0.017200727451423696,0.048123699773181455,0.082874942910174415],[0.0081889230474460895,-0.058861620555009528,-0.043961481598665794,-0.063177035412865831,-0.018314195969373462,0.034878450378990955,0.035304175797457732,0.014293668892683664,-0.027456916509392928,-0.068367628925221052,0.001669119251847942,-0.040967945915871377,-0.03943941310209053,-0.021637978943057967,-0.037684292945808551,-0.017747783335439818,-0.042288824584737462,-0.0018176642328489589,0.030934243801926706,0.011733255516551085,0.02708984163398926,0.0017191072696037882,0.043276004610731736,-0.072532619647830976,-0.030223836313618479,0.021071961346727626,-0.0074147497494400638,-0.043925229543362393,0.020288776715248001,-0.034527237586023503,3.0471360021155913e-05,0.026067397032741996,0.088540464798406104,0.01413941347644106,0.022766394260563719,-0.0018480555055750275,0.042675799328757251,0.017054471283286493,-0.096746137235194679,-0.10757348404679792,0.070754873906539423,0.01575558139579953,0.0096692478638847699,-0.0032289840854645077,-0.015101060431773538,0.057926005617948362,0.05010944609735675,0.03438493002343132,0.05420170443576617,-0.15712629885767235,-0.10755100231803701,0.054215855416940288,0.15265730024840482,0.055888119645312602,-0.095941401277040039,0.03328672046334586,0.09353086897835676,0.14384249052592857,0.12025171427727349,0.055496873043967186,0.036285296296363331,0.066833079592868674,0.042161382611612397,0.047587995565539137,0.021867654432298031,-0.0564119641379216,0.067603194336726846,0.031338290457222959,0.050713005156545185,0.052148045957678787,0.018648322758803917,-0.050759157693301679,-0.044588001217457346,-0.039312995512573896,-0.059936417610193665,-0.055184693439938245,-0.019957035127630418,0.050192754841022036,-7.1757395827626302e-05,-0.033091702048858869,-0.034428104974273177,-0.034413465790208278,-0.023267082967762434,0.031901848606379901,0.020238538810505934,0.0042221466771613057,0.015602237108089854,0.060847091700473442,0.041401859346669609,-0.0034146015221089565,-0.0074559961064889491,-0.015893641385376203,0.056392351962400708,0.063354540983474289,0.0087304477448395465,0.013014118991186936,-0.0020131002441534374,0.045231849909967176,0.035378207480516677,0.082600299684899986,0.033715599170522123,0.016512586361955336,0.015814071825167364,-0.016536993108816449,0.022388288048192512,-0.012153283754204335,0.024539743316687932,0.023108504039178981,0.0067064141727297411,0.01196006995554437,0.01808564781799793,0.022564539714186704,0.029240080645026825,0.0070031422851894731,0.042819312072206572,0.063646286047359391,0.071444911692377322,0.025002430371161628,-0.02988386458099207,-0.044839473616139255,0.0048106139958749294],[0.00760442586653437,-0.031647161439197435,-0.063172441009770042,-0.074495313815639272,-0.018994314341887673,0.052826629441971945,0.032890225420068343,-0.013629701917450165,-0.064807806031904142,-0.029393773930843553,-0.036471213615816359,-0.0098221768646617295,-0.03512116201717283,-0.03943473473657854,-0.028818473185370876,0.03850092276204857,-0.0049328775196173652,-0.027624833158639117,-0.067846866445995579,-0.0011073069182334881,-0.05184142360008933,-0.055930573972024514,-0.01741185166520046,-0.057527466793733051,-0.055499304805210641,0.028375118140619545,0.035910848122856304,-0.01496101773521763,0.011606597964401194,-0.0075876694292307534,-0.0045075356731610269,-0.0082002978749069391,0.013779697793775076,-0.050073087994743797,-0.04908451276428849,0.070063159827065333,0.041211290659651782,0.044221912404898908,-0.092510156542300173,-0.017245900432612329,0.0054614497516805513,0.0057317904111747475,0.033492765079685211,0.0086141350275894379,0.019265007144101023,0.0091441578432992152,0.05844498925238964,0.11212586773198896,0.0075004000045361648,-0.14040933702091665,-0.13224491934624966,0.046900879586457916,0.043118887082018047,0.082579685212893703,0.068683773505795701,0.041317670630771582,0.085514694418916445,0.023787162317564083,0.088925450535202996,0.13628690428327328,0.0054697771027137181,-0.086543108426525212,0.025964600319029363,0.10587654052203503,0.094459611375660418,0.081346300231989077,0.041592204326461928,0.0066817887839110994,0.077674394412019773,0.0056683876342300127,0.042096017073306194,0.032191303817394351,0.030452658585607126,-0.025984256753419858,0.025271063575447547,0.034211665699899252,-0.011964155896605516,0.037076527694802561,0.04508649436861286,0.0051587756376244853,0.02880706384910163,0.038599720493081482,0.024875515796822671,-0.013891640751740861,0.021755723908671087,-0.065358451817548596,-0.061057887606313227,-0.024592482102494873,-0.0075328437080993543,0.019986689878947826,0.040909136201569898,0.040437015091600761,0.040034799263731949,0.018812605341074366,-0.030276192569776476,-0.030270565458533134,-0.016190643318727164,0.006809905422805987,0.037916482000601909,-0.038319315218418547,0.010306777237133882,0.015829001844016963,0.040800282130470392,0.05615449330992818,0.04786297945430712,0.034288336490960442,0.060681491982977377,0.0032702943730984618,0.0013152591778692133,0.060954595988390148,-0.040791733055038019,0.016183415755703048,0.019528209635753736,0.028893550793992792,-0.0012918699135948258,0.034618023394595597,0.043405940357484581,0.029089370346889853,0.0088268285651632861,0.018259597579594153,0.075373115466755555],[0.027450771793035074,0.041262824664966939,-0.013144559153806662,0.012207909150661903,0.0092477333330207509,-0.012848538408191307,0.0045635591482721073,0.010876267701812489,0.02890459475433247,0.026391802511985279,0.010732731929258464,0.015032366451770748,-0.029908421422182082,0.021411606012816192,-0.057536773751919248,-0.053416159980357834,-0.048865576382574959,-0.035570469790391759,-0.018461415692559838,-0.0029790588112649907,0.032112270223907544,0.051477612075197313,-0.0057662482825229858,-0.017766588527875229,-0.028238377182112806,0.023528561546172357,-0.04216007246124067,-0.041032389593882487,-0.06680999261373205,-0.039632149520821544,-0.022226688774540718,-0.0041149160188688749,0.032302323242771602,-0.013890604091560638,-0.034276275118401742,-0.0051502741378656337,-0.021066308656931813,0.022151630661472133,-0.0022992341581987014,-0.062769638896883875,-0.019723620835675727,-0.057691275310445302,-0.042378894883198112,0.028983236593136813,-0.019395597488888486,-0.029331542199886471,-0.010745732705029043,-0.013921448513401852,-0.029609437928951193,-0.12537702206143342,-0.095617188384870627,-0.035129241573632897,-0.039982481822552207,0.0090952641871177801,-0.022086955744048412,0.029136077983963546,-0.032593887678401656,-0.020183882523267208,0.061602041888744921,0.15458403910635235,0.16957224934392182,-0.040427938845436127,-0.14425377583803428,-0.071643094865452436,-0.042253187333205683,-0.027875249558229672,0.058879183410993005,-0.00047065192114704134,-0.043920137358857254,0.05496654067473021,-0.069296625387029825,0.11118740085537496,0.2366565621922726,0.12148462555955851,-0.011433917074149466,-0.048194932808641386,-0.079327638115028978,0.0017254253058667443,0.037708824963847712,0.042182164843196458,0.035829815786488792,-0.073357898816589731,-0.14576211923026078,0.048290332077963939,0.14879922368454307,0.10064792412919202,0.063705043016025004,-0.030692614056442261,0.056255605990735619,0.10255361685355899,0.078604273448134934,0.0164658420906807,-0.0056463798547232141,-0.13298053803801668,-0.028765330682998365,0.05939355800317566,0.1402292273171811,0.011410410356375363,0.016039694083752262,0.032382125330787596,0.10195998512893362,0.061382477156473686,0.082411738292981068,-0.063666416770640277,-0.018779258750025916,-0.038365933733688989,0.077993417865157774,0.037853307835213006,0.040996995997873285,0.011082725441736859,-0.0056644922101654026,-0.014754708114634627,0.018864758145484002,0.0075267868116950659,0.014018215345551104,-0.010120746615713067,0.019767300172685923,0.0399406347657522,0.099260521955006772,0.052915278088062984,0.022179211937403773],[-0.09716085296718216,0.021642032331918873,0.029135209902749426,0.013999315045878299,0.059316507135864754,0.033067474971013311,0.0085646291438248312,0.010286012651575784,-0.0083817553445004675,0.018753974201751927,-0.030375458058801961,-0.041904429008824615,-0.055862255737819402,-0.010903003336047129,0.068264567248243077,0.026035515966818988,-0.0012923504068929892,-0.0017623356640995083,0.005468527639103056,-0.021755603593697069,-0.049505653044107159,-0.066112447625837761,-0.022252491484929221,-0.0081982834517316944,-0.037367281479721751,0.012774986112044792,-0.062950628458933039,-0.045045256304144507,0.048001463004758223,0.030007357346820335,-0.0018969086500039145,-0.015723154153853357,-0.055120061189717733,-0.012097061948313372,0.0026362460701923537,-0.072632828079189402,-0.068872601631521924,0.017772853215430318,0.072338704068217213,0.018535361160719493,-0.045281275098323914,-0.011332122576621917,-0.027280199109967439,-0.058723208914210012,0.026327853635139689,-0.010818050423826983,-0.030610533234455353,-0.028512931740957648,0.0012488868339177971,-0.11197453226805695,-0.055269858760533572,0.01115586891047237,0.0082228892980596331,-0.032306255269305653,-0.01502375948544021,0.049382773019192819,0.015328141296235664,0.037662383891850018,-0.035013020016662372,-0.029449621040367344,0.12073107144262626,0.022860361772779912,-0.023256473556698243,-0.083648467631806001,0.0074002327452034888,0.010004461021878228,0.099371522997238476,-0.025221784791065922,-0.096640580498928999,0.053094250603911208,0.15893756445998802,0.033387109550868377,-0.04808482373966641,-0.010053840415886486,0.037823846526014906,0.039700388908815387,0.054256090345082275,-0.02401468040990247,-0.02904286935058728,0.046138517230890852,0.16216994825276426,0.016089864404032872,-0.091198675686446171,-0.076360513817770065,0.031988084842499293,0.036454996777462445,0.025464944340111234,0.074147409146892329,-0.046979415183956125,-0.049629380484653082,0.079771651767589866,0.087758100333019146,0.049828916696142006,-0.03045459513307306,-0.024452096514010858,0.0670092926908578,0.1175218881400763,0.11426518181326391,0.074066541158350152,0.0062338373377257422,-0.043366039912113838,-0.039950077856114423,-0.035409502206233817,-0.035863781498548762,0.01781322399419219,-0.024727256297427454,-0.022275869771454817,0.076761480744383326,0.062045464769250311,0.069837551721133845,0.073012923366347696,0.060190713224507614,-0.025405925372675192,0.023372682335303596,0.030477986314785502,-0.0002301213960560905,-0.026087148164954402,-0.019019953457663552,-0.036714807308876246,0.058817728969904087,0.068381158254896449],[-0.011512245145694655,-0.033323501539032144,-0.077599795617108003,0.030092014051291281,0.036890045147122533,0.015052871160868519,0.028016899365407681,-0.01018960630350095,-0.078317704208198474,-0.059233122702466653,-0.01852728410941332,0.053961496737718939,-0.026974467838019357,-0.01804059271627316,0.044307115164341854,0.015818943834284213,-0.031953640726807273,-0.02740130304193715,-0.046790507127582773,-0.020608188350333664,-0.026272324411271628,-0.080186654850075562,0.083845698779704644,0.001406750687297384,-0.04985438587843697,-0.021416757758446515,0.066537065419636068,-0.0073244717556784477,-0.018144551509999312,-0.015182424540353442,-0.045130661218423247,0.029947581486485145,0.0064481392557531048,0.042274921462388107,-0.074358994945938048,-0.014176533090006271,0.077655160397082798,-0.010551243188291676,-0.12637948483078057,-0.033586964208765883,0.062817071093444254,0.0053909310356757764,0.025794636422243125,0.059721803691538844,-0.082995318825107134,0.0042617087053962791,0.10584522112949336,0.071364312990742557,-0.026422021145727979,-0.16100970751240665,-0.054720311746107982,0.048999446881141787,0.075434840832607986,0.010535530941215229,-0.048016579048604152,-0.080339712203917474,0.039576695247329777,0.036637245201813592,0.12098760898076155,0.1354854848272127,0.051194513568370764,0.018225873276029245,0.085661323891760843,0.18621829874239049,0.10338152957413216,0.023906079145933318,-0.0041822936350238149,-0.10643206407862182,-0.078124959614174122,-0.073468903649519218,-0.048419863477576881,0.015108685112589434,-0.03264596890745973,0.036235615700722507,0.0080904621985001118,0.11267954130800725,0.10278655485723889,0.04428157837866404,0.010681413475295332,0.048922714210986845,0.05487352908643979,-0.018064605730554309,-0.018189270455657311,-0.071125211325311799,-0.10260837121452346,-0.052490034378075492,0.024031776304340315,0.019694437269126286,0.049636749977074832,0.032195647589762615,0.0083280385163384298,0.070138954785336591,0.067549912235517831,0.057433630830398048,0.020438461876702188,0.0032421342973983297,-0.050695230761191784,-0.015383897879732399,0.020203015057404895,-0.015662916885770546,0.031709069862233888,0.012505528157918055,0.02862303507568463,0.05946324529661641,0.011987063839091858,0.029655839160397587,-0.0016058379565756595,0.032924927535037493,0.031881210667308521,0.050423216186573444,0.015557492045852508,0.021385779192598299,0.0099932753661932591,0.01435070815322266,0.039479442983270135,0.066851597833738896,0.040296519398888356,0.0099526419122588083,-0.0023557651823443021,0.01814873401521766,0.059119163848392789],[-0.015757148978644712,-0.049129440678390021,-0.023997668342014205,-0.0210026283214945,-0.0015357942036982875,0.0021065236794876874,-0.037107041689779741,-0.042351598868691012,-0.061162744591386403,-0.034051484714528485,-0.022720119467757083,-0.060739564477761535,-0.026757001184959561,0.00055934070843080205,-0.022616038258239973,0.0070861976821720955,0.013566118550461286,-0.002811474898052356,-0.038580343099048009,-0.014823359019323232,-0.034835879559876048,-0.026656015152450085,-0.019477669860262788,-0.012106727392046226,0.0042483765645461719,0.016084907645647312,0.00066552379900409325,0.0016008277659419479,0.020524088921093323,0.061832709878829155,0.0036079221207767423,-0.069861609806567429,-0.027833309957886129,-0.032568850186226357,0.045124349364128763,-0.020541851129595723,0.0062259884473188087,-0.01720385416905687,-0.06713753737721917,-0.021510388883911769,0.10815002779082451,0.037209771283314999,-0.006027660384665387,-0.016395255789040913,0.027666465419402944,0.073069001175329412,0.050575531097015479,0.042567636344617243,-0.040728282661866906,-0.1802492901591394,-0.05180382591629118,0.068698953085444853,0.10468627376672648,0.046930524622527739,-0.024345410159748448,0.081518930532773398,0.13437717506819735,0.12767282811582661,0.058828417946620012,-0.065397413329707027,-0.010971808997436964,0.015964690557018213,0.064316346804789856,0.092047644756938635,0.079924220572783422,0.0045625327525128379,-0.018286902500448191,0.017429694084018413,0.076145282866436848,0.042835485463588514,0.080206981146474676,0.03611723597888207,0.047379298714446218,-0.019874915866582681,0.037657544445781559,0.026115602677467167,0.07158768649462971,-0.057638081455141071,-0.08380678196623717,-0.020457096575091122,-0.0066815930156417236,-0.010481709236786138,0.0098188814326595486,-0.018910890692478463,0.027174343530639883,0.0048186838638660939,0.0084831162501448551,0.046647277306884644,0.074896293430210287,-0.0027052061320910203,-0.052390985898152595,-0.035810710910889471,-0.010963380484187036,0.036472476309506702,0.015668137547351885,0.031880374182724422,0.028320973681942418,0.029976561112701736,-0.0029437318832178684,0.034619959909237122,0.085724767242456062,0.014661848811874373,0.057456266218902825,-0.0077949735252234144,0.056966918817289783,0.039173853530589081,-4.3950988622729753e-05,0.039524712301200832,0.033815106883289522,-0.053148463650792468,0.046135279317716708,0.034368318225618644,0.025850606000479254,0.04364205260106227,0.028915316089906759,-0.0046553412351980628,0.04069494423398308,0.050441914764901605,0.023379190793916069,-0.0043673996422118923,-0.067829031610357429]]},'numPatches':71,'patchSize':[11,11],'canvasSize':[114,102]},'shapeModel':{'eigenVectors':[[-0.25918455544134117,-0.04931221385289683,-0.13803814349503365,-0.050835603939836389,0.00068526965694575893,-0.019143738616150919,0.023318915050125469,-0.016196086952925716,0.0036093752391787967,-0.23833211080603259,0.020657546002336193,-0.015932434823103549,0.064261608443706916,-0.090634823520771873,0.022055884293867813,-0.093725674338304407,0.055117695896951036,-0.053233288056152572,0.0062574485928118722,-0.094495464626663847],[-0.015370973540248745,-0.27558869894124727,0.043057403787850598,-0.017591738525834334,-0.095866808468540898,0.0374588242132479,0.028917777439805392,0.1301742315782318,0.063868665266122795,0.093354241092818813,0.031861264081329624,0.020242117972802134,0.27294001002937818,-0.13041313331164875,-0.0031444285383698803,0.065211427933209776,0.23796562485879649,-0.14726562188674308,0.036056872536145354,-0.1295200257644685],[-0.27438982091500397,-0.039852896309116981,-0.13450394922360476,-0.02978745313734707,-0.079525846479578263,-0.11664515605739997,0.035665518184535103,0.002417177334119754,0.071000059730337906,-0.19400193419982176,0.047707150663056336,-0.060782105477894047,0.075256164849826432,-0.086536933340027627,-0.01049404960505459,0.0038623295139433526,0.019088595829792152,-0.010833090632415429,0.017289975723166609,-0.048709062934321569],[-6.061111652085234e-05,-0.29074417421901644,0.061164679549491507,-0.040564059065553715,-0.096173988191784646,-0.0062410078701849517,0.098421939897005872,0.12644765063670191,0.052339831131799547,0.14548890663706876,0.019044522282414742,0.11593290854472875,0.11303783009345467,-0.2265378936630382,-0.026028516734775083,0.14284328457404893,0.10352737588140382,-0.031495507236198358,-0.047636212684011393,-0.031405728625543],[-0.28061079598099281,-0.028500046273409296,-0.1334817649766244,-0.048224158070504508,-0.11475625312727053,-0.16357836516870289,0.048639735952709248,0.010323257138876579,0.0443093902362139,-0.1122958426982017,0.056896751191640699,-0.046270327611954258,-0.037397127347545092,-0.13317587328341315,-0.010863704903627043,0.039312364878041281,-0.010946095593356596,-0.012651374705749084,0.01110571327997853,0.030546324103711924],[0.014069445433529164,-0.25865071929613004,0.06560840664757342,-0.045936250949625834,-0.077032475339967266,-0.012716551912464895,0.12470762874060179,0.11891551534656634,-0.013669877748084244,0.1204323060226194,0.011009487547689111,0.19012847506135711,-0.03216941527475374,-0.17265241492952857,-0.036626526966033413,0.11828907037835129,-0.077253487513163063,0.04910794244586042,-0.088365360868488049,0.034692232042363554],[-0.26489741712968851,-0.016037983258916397,-0.15478385413970339,-0.054519082640759414,-0.11072137606892071,-0.13806773721053522,0.08315118429370677,-0.00084688851852063318,-0.066659068943074468,-0.014543116847374027,0.052713555008319181,0.02738844249422287,-0.14573813333209454,-0.069109651372657108,0.0058712282175771742,0.038653027715924451,0.035448688300325895,-0.027970894206667783,-0.0058316372883610388,-0.012350421356814981],[0.046354114624841548,-0.20340754175093081,0.067448564665621949,-0.041981284856941324,-0.013920156097499539,-0.049310247697232024,0.10476409205774134,0.16148555792101416,-0.057377287008889992,0.068718208751115062,-0.055874799238903254,0.29988249724968391,-0.16587089947669748,-0.018901809319898571,-0.021824056547298361,0.010150208790264993,-0.15609860291657318,0.1312205105925727,-0.13142200190156222,0.1313708927136652],[-0.20187217065452481,0.0034527151175131731,-0.14526611889720326,-0.05454907575651035,-0.077670454771007258,-0.099693213880673814,0.11162648299874731,-0.02756432531919592,-0.17000009910036681,0.05281736505253104,0.0046486044929276646,0.1380118729404875,-0.22662371465236356,0.025099449481837843,0.057390225910467232,-0.010585092198184265,0.062813389289858523,-0.066384169837743451,0.029034161785279667,-0.11014692197967303],[0.059919400550256997,-0.17456494999571195,0.045546642557409332,-0.02138218670533986,0.056054364424078185,-0.055753394121748678,0.050949925906493082,0.14366157895544562,-0.05830434414633804,-0.039881695287267399,-0.029733515204826259,0.24120260128368567,-0.15389614651721623,0.099337119716714856,-0.0079105830001858224,-0.091413272768399764,-0.17108589062548851,0.079535911804176379,-0.070080057453948172,0.10304814751540158],[-0.11406660762823512,0.0077005020180582742,-0.09712804940172437,-0.048797807796913756,-0.034682059363515927,-0.034999010561767685,0.08692061344032842,-0.095835584563062681,-0.20896282413005149,0.082039982644742646,-0.038156988159574197,0.17097326940727633,-0.22949142171270936,0.12076557157672954,0.083445432006383657,-0.068849538566075189,0.10657376324662199,-0.11111649307286262,0.14356689523278729,-0.14730065680490895],[0.050548778821860631,-0.13771378257629774,-0.0080120262544440511,-0.0015714671798822168,0.11898190894868126,-0.070033187766031402,0.016790814058871895,0.1115574984393187,-0.082310332466199038,-0.17681195482737475,0.031785253577691228,0.1357465923958473,-0.030874986613362576,0.14056871465194681,0.01192742650959086,-0.12276147059314364,-0.089723294438478984,0.026135494001851646,-0.012284577171365987,0.045455675500381779],[-0.010279976005766538,-0.0013953711369666941,-0.04250049853613809,-0.040683978397024659,-3.7807469383838166e-05,0.035049138884785544,0.013909369315673437,-0.1642247505591371,-0.15344312139650054,0.063720470459392275,-0.0320687619302093,0.093030342984283365,-0.10431016285986502,0.21547866370529961,0.062045477425420881,-0.097500495716327684,0.082375488307347727,-0.15217807555912072,0.21187698224878029,-0.078833239119551118],[0.020506937371916202,-0.080791931896572647,-0.076177957918269826,0.048751387201977775,0.16094247296613129,-0.084899633131099411,0.019595650306679674,0.042553966112101993,-0.09219934929892451,-0.29635110512711466,0.068276859562881098,0.016316501361075333,0.097753223293390701,0.078153996089610878,0.043342705639799292,-0.075376215034118968,0.033022672135110301,0.059877672085514894,0.024112321053863524,-0.088305909642851566],[0.040972435984073623,-0.0012967065227411441,-0.0020002072259834333,0.0014908104373190423,0.0030002881861055167,-0.0021443336138593531,0.00056119264462986193,-0.19612476201187881,-0.0017679409974512839,-0.005915857570869501,0.0012463328686438402,0.024610291061966494,0.0022006976231346842,0.22487906560306467,-0.00058423344006947042,-0.082013296389981449,0.00042633285032667168,0.0033161283064071234,0.27617149440602085,-0.0016608591645283499],[-0.00080695403900045968,-0.065839220606613555,-0.10155889748442845,0.075694689232978118,0.15233719604557805,-0.10887679778045856,0.028494100773441226,0.0038626863414954055,-0.089765768359496567,-0.30037286375515754,0.063281539229365746,-0.00048470083109641848,0.1117386345766342,-0.0044290036927669973,-0.029663978449883902,0.0016152557001810619,0.021646704240411981,0.16837372165287368,-0.0054392104719929515,-0.084328775256603178],[-0.011079460967186748,-0.0017868787382064001,0.039468046485298627,0.042572005521116126,0.0063748590623499482,-0.038364866443237666,-0.013127007549216979,-0.16577295084318866,0.14969379516837522,-0.075339827378120047,0.034732282019907856,0.092315739679176251,0.10807828706143377,0.21223426285676972,-0.060290750609962682,-0.09445696025894304,-0.081011345255935258,0.15441773571152759,0.21076325569431353,0.075295075514214896],[-0.020086262263831419,-0.080784221136093515,-0.077792332238160178,0.047111656712928704,0.16081617519949246,-0.083453740869734394,0.020128133010894365,-0.0360546459811006,-0.098169645018887586,-0.29361230607088495,0.066961209884496664,-0.019966901109739643,0.093570222859445912,-0.086577822140769686,0.045752123360719078,0.0791568260887245,0.036240583447840397,0.053839253272887647,-0.032436240265909071,-0.091341473993148653],[-0.11596849930813256,-0.013116985772102267,0.096737255583673187,0.048698089400280059,0.039340055065449797,0.032214325050749303,-0.08619207218565357,-0.10015382155604448,0.20555982124599514,-0.088938300452201954,0.03937893647811963,0.1654956838827967,0.22809775661613474,0.11513705136942748,-0.082911080726013248,-0.063962435697576758,-0.11002395504744786,0.11205940383716617,0.1439392637120111,0.14897623582114547],[-0.046018226654389961,-0.13730378118266232,-0.011830212484348301,-0.0034916534255774868,0.11752403995019094,-0.071356957547947811,0.020200276481911836,-0.1076974779384491,-0.090474375313770575,-0.17344452956176146,0.030258179923130457,-0.14237336413481283,-0.039887226837474088,-0.14521482782108197,0.015203825792165698,0.12537720862495605,-0.085457392267481364,0.02174003429599114,0.0066221299522591405,0.039620488272067433],[-0.2040749366376528,-0.010323501069181723,0.14694685748653932,0.053664853798831569,0.07981735270651405,0.097420623037042547,-0.10953377373376602,-0.033199598310539855,0.16757254284815026,-0.054346740346640714,-0.0058157513624386148,0.12840753724004372,0.22038833739666719,0.021168603923268747,-0.057657198208393295,-0.0069775024105939165,-0.069501154359836337,0.069464401864851408,0.031771035766236862,0.11411900652766432],[-0.051924253325491068,-0.17429362677494198,0.039791494349163466,-0.023513465098568491,0.052952634705427687,-0.059635560339677464,0.055305687484985627,-0.1424648306435416,-0.064952853084940268,-0.037771093229790866,-0.029527419227873053,-0.24644974400170233,-0.16270006974558165,-0.10024837118797988,-0.0056447186125896803,0.091759168888906895,-0.16847994951283402,0.076860367844075961,0.068882496250225952,0.09863121958635232],[-0.26651717704026873,0.0080164106263588761,0.15731959607269588,0.052823798159396113,0.11008740922723979,0.13601908508035385,-0.078961634198715797,-0.0072046965504718591,0.064348155222560377,0.017237605925488529,-0.054872736396182065,0.015559383693739215,0.13909397820541167,-0.068311802263162552,-0.0067259934445731695,0.038223390076617916,-0.04156755263603501,0.033115987080266057,-0.00065239724213180667,0.017513549002972584],[-0.03588787939011167,-0.20388129416118475,0.061301672646978556,-0.044095407904282118,-0.018268995429649042,-0.05470840045462301,0.10795691158419214,-0.16132698157729128,-0.059957480403291671,0.068092285932813801,-0.053755882208369909,-0.3007283566909435,-0.17148068120730831,0.021608331263090086,-0.021575953678715676,-0.011664293426726147,-0.15458176445677577,0.1300174016145369,0.13154970526426454,0.13078272042359684],[-0.2809471673004571,0.018293619273973799,0.13596157055287497,0.046378029155166152,0.11163412106971948,0.16295080001590137,-0.043691675935328148,0.0056329745488485471,-0.044813277771594974,0.11695075889501491,-0.05641913180049743,-0.053720719978482434,0.03610146135197502,-0.12627443909954122,0.0094131173123349898,0.034624267714095353,0.0078957648480725562,0.014575180101932733,0.014576471105685423,-0.029156635373887185],[-0.0030095351372760588,-0.25957232272307262,0.060301707578672363,-0.04779944544237455,-0.081491244326026321,-0.019147559060772947,0.12652610020709304,-0.11922977407437629,-0.011914602642074834,0.11591728350468518,0.013241249151964583,-0.18815914671221168,-0.033616973409560061,0.17776230094115714,-0.037025879925952965,-0.11974525580807824,-0.077624578833955071,0.048571714178185676,0.087859549048355606,0.035868084615777118],[-0.27417464809767067,0.028373991287752209,0.13680799115243847,0.028167150771118182,0.075677341587864086,0.11630896046960627,-0.031762513797499781,-0.002563550650307844,-0.068884128538267364,0.1995800873684675,-0.046920279658476186,-0.065299807041030028,-0.070746960308591109,-0.077549936108553166,0.0094610434231444662,-0.0017650943059575458,-0.014997421039161352,0.0095845597607114308,0.019152234841120983,0.047434694682454287],[0.010864613936708935,-0.29208790595457063,0.055821178220925659,-0.041705477694428728,-0.099230722224523796,-0.010829050067781528,0.099749938133941091,-0.12644476780740671,0.055094856748521673,0.13773729035274815,0.020908213939107564,-0.11344971939308535,0.11591336845781641,0.22976959221520196,-0.026421533223327465,-0.14288458971934956,0.10419870157452782,-0.0318976338136387,0.046918481646092865,-0.033299284419085695],[-0.25837833137347876,0.038422717347508448,0.13962647397057357,0.050103509953396942,-0.0044594765706110371,0.020603827321857861,-0.02216219920682656,-0.021309114011150192,-0.0010917590066734501,0.2418230933395254,-0.019386994764398195,-0.016717109149155869,-0.053464810497761417,-0.085429543562532892,-0.022162591507878665,-0.09622067935685491,-0.045705099076477906,0.047393448869087945,0.0048328631429115712,0.089322356732992353],[0.025564398752122981,-0.27731664250606558,0.037588786187509049,-0.019579739085062099,-0.095765482451470027,0.03667599404697252,0.029813530107823345,-0.12943556489477503,0.063961254324508471,0.083897561937034196,0.032649943180716366,-0.019599083680427811,0.27525863734504508,0.13388072923874367,-0.0022735435936609982,-0.061470425631865222,0.23995133451147066,-0.14924747016700576,-0.036275296743394379,-0.13314032633541523],[-0.041103875384795478,0.038239853031118279,0.089308340197752648,0.10751656645645798,-0.15823655809172577,-0.20815985286534691,-0.056779787102027732,0.031965366692216453,-0.036292401444057432,-0.01028392045647775,-0.22616361790176892,0.0035659176428170783,0.061194979549606385,-0.077356786233732905,0.10905509076128247,-0.32122938814240976,-0.062436557004036941,0.045060861466935012,-0.13893160149555642,-0.075946865540707897],[-0.00058625790621224356,-0.028013371862265588,0.033925327852879071,0.096975699528199108,0.12885275561493442,-0.1343267701212868,-0.054634853688639656,-0.18670671387006435,0.12024253293549851,-0.016775889537029812,-0.37344128248102121,0.16617216199661805,-0.043638146038944767,-0.021518964566529398,0.088330233282570475,-0.099975305795148767,0.11085010836922597,-0.017708386232239637,-0.082914213924979024,-0.0077088662798212998],[0.027140406330796465,0.023191258515235343,0.068434406926246014,0.071893202281616386,-0.14539857122015881,-0.16792155660430991,-0.070781226760149307,0.066657108411771637,-0.076044747467265861,-0.034879855298791729,-0.27800383194452666,0.061320468907899509,0.072299824382141803,-0.023704580444342142,-0.04401851516889442,-0.27110695514654515,-0.046476184600678129,0.00043869932085638733,-0.123130650146417,-0.15560608030108736],[0.0076812184072904523,0.0270311651114079,0.051859835503390045,0.093607017053067176,0.23700136702110891,-0.11818205744677762,0.012899446976310756,-0.13978186955176913,0.10628086971480236,0.053511612608857485,-0.1084063259342577,0.14453111355415171,-0.046948170771035469,-0.028787155822266295,-0.027495091326601381,0.054014240557880865,0.070313223463565402,-0.078649587711269939,-0.033769719376426907,0.11645995186870747],[0.059718922428571741,0.019365231759092102,0.039768313524315972,0.029429966402313459,-0.099502797903459367,-0.095192410148050341,-0.037385318448383657,0.087589530307537841,-0.063223996440049848,-0.023055656510996579,-0.11333588796545234,0.070632460945445522,0.040519800690015498,-0.016140269978734072,-0.20118930063482968,-0.13465123232579196,-0.11306409222256064,-0.21054801092291384,-0.043694131861398491,-0.05304245009937468],[0.0041644730679859399,0.070451588741912277,0.057002625903047041,0.12331122141071403,0.23820814567299181,-0.13581472991575944,0.032580608751462875,-0.092174145754420192,0.027563573177978199,0.12746487446937488,0.12378971431383365,0.10985577224508172,-0.021825682517284502,-0.040456493338143169,-0.0041164909929070218,0.063284870734335225,-0.0047004007689977496,-0.052424157462174416,-0.018129540228518343,-0.030724004702528798],[0.072668914107824084,0.016043138606478196,0.026273691374946138,0.003534210656636574,-0.059452568136465732,-0.049834770359896835,-0.023930069153882849,0.10364100685763086,-0.062651308587342996,-0.0089580363305431388,0.013307479894258992,0.068490119380549511,0.042476545594048995,-0.012886684482588185,-0.32344815313001357,-0.10205399447154681,-0.17376613813501907,-0.23316498095342783,-0.011128358009024508,0.0081901718752386641],[0.00094691433464800026,0.086262349909223726,0.056561901106857174,0.14777082451223772,0.20316466873179587,-0.15155458483522241,0.024606362028327177,-0.059727599838801694,-0.081607162628284866,0.20453126101362504,0.20790338659205185,0.061225806497161923,0.028168686557436835,-0.03613120581327809,0.026537321190343684,0.0399906464556435,-0.049028578602568942,-0.014036011010793178,-0.0096336013044976583,-0.23758677297853398],[-0.041048915985355559,-0.039313219925048652,-0.087903278890068839,-0.10361478783196754,0.16318740146031308,0.20270933480404102,0.054584517473603988,0.039292121166248098,0.040998785186190767,0.009615397758339965,0.21128404722349167,-0.0029798466635748131,-0.062865767668902076,-0.076449491545646189,-0.10549253270595446,-0.31704376863591516,0.066752841216077483,-0.045723181789561418,-0.13555912932484426,0.075584434365469327],[0.0022042609665398039,-0.026485960470782596,0.037415518961758119,0.1011339414049796,0.12252229572983372,-0.14241885794880885,-0.056828178864929177,0.18530329432091194,0.11872027940742755,-0.017167807538024354,-0.38205683466253854,-0.16618370469188254,-0.041194763832225485,0.024548186385952311,0.09255575874027222,0.112546125407831,0.1083057171416579,-0.015920390263162824,0.088320321679712793,-0.010693282303843322],[0.026816912653847814,-0.022108926689108781,-0.066339365110991089,-0.068151690447571606,0.154617702418614,0.16313793805226023,0.071234250106644068,0.072109302523390373,0.08017056572858236,0.036959816474844275,0.27351976347701962,0.055582028975215948,-0.074092332445527556,-0.022552708724486555,0.042901765024783274,-0.27302351570941347,0.049208713355905966,-0.003535172477924954,-0.12170548706792439,0.1600709991585626],[-0.0087439103230266685,0.027923354373289518,0.054514211233918808,0.096365207751641604,0.23109253250922421,-0.12470228964547822,0.010102445531173702,0.13704885861179808,0.10320420183042034,0.052096726920325277,-0.1192686088871901,-0.14683351370610781,-0.044064970409795748,0.029698195291400976,-0.029206990301820602,-0.043297565538332972,0.068428704932438536,-0.078571322120720946,0.03859177852602421,0.11024267705524989],[0.059508635688315326,-0.01657619560715708,-0.037493005500270155,-0.024551786635688039,0.10880503745780122,0.089770908937590918,0.038639182155073365,0.091150946000188748,0.064260277665368251,0.028056683600415983,0.11812219496600855,0.066252134990526679,-0.041347760355287144,-0.014534786232973301,0.20087119446951981,-0.13703864218459774,0.11279133483747732,0.20832054150697926,-0.042946400162149997,0.05179156411057094],[-0.0065126653897697728,0.071159456831373979,0.058524291187230383,0.12437439455627154,0.23410551313326314,-0.13945759111788802,0.031083302663808848,0.088653843731240148,0.025052764449437451,0.12645821454533035,0.11923113656771699,-0.1125517207508219,-0.020213297081514984,0.041060640001920251,-0.012035091209235904,-0.057933925975352643,-0.0091486339462259602,-0.060673793152006633,0.019835929550468437,-0.032788715505280473],[0.07257527558866439,-0.012634132825075228,-0.024026201740383193,0.0022869797091045522,0.067406035601524444,0.043828689541326828,0.024880382727502041,0.10591239790125603,0.059389455848107335,0.017004471070657168,-0.0051110016551842363,0.066026250938385003,-0.0413344685392531,-0.011454031274301169,0.32424222491809251,-0.10354947723779616,0.17170089296042518,0.23243149868662624,-0.010740406772858133,-0.017538756921170968],[-0.0038075054296584183,0.08682715010851387,0.057552559849395196,0.14779538878396109,0.20066618261034311,-0.15339929104950317,0.023645037900407406,0.055600435751653965,-0.084010761179813057,0.20401992821861864,0.20826613944580338,-0.063875112688849336,0.029819348392480016,0.036610597346155127,0.013781028965228558,-0.035941276484260015,-0.055832567903871658,-0.02320595540794813,0.010064307647554213,-0.23708004052505138],[-0.023504007886404551,-0.039047800473709746,-0.085567297317111615,-0.079150315989127945,0.12465270020306099,0.13891518919190615,0.024300699494946811,0.066995320302391054,-0.036811078599646774,-0.0058878608825939736,-0.090782550970527828,-0.0042989063216246773,0.043496107700883378,0.062508429522197345,-0.078226082145878048,0.043008728528105333,-0.0069160402174302023,-0.042679506006784697,-0.01902871870181784,-0.015975265866074697],[-0.0073612866881341606,-0.021107032591126607,0.039763310309730814,0.055625685982699735,-0.049656312820928236,0.08481039531092055,-0.11231670001231263,0.12600108757905643,-0.023631913679965172,-0.057175431216096452,-0.0059588667870986217,-0.12646241348822884,-0.03442652732340299,0.013453138542856213,0.017896987050537695,-0.076871198151648765,0.010909247964377937,-0.022517785800987001,0.0081302635992548909,-0.034045787038876937],[0.016948514923620445,-0.02193513643769434,-0.063152363053562643,-0.05279979640116144,0.10435342424836205,0.10824853130712549,0.033041462823043537,0.08633503164767041,-0.015563261507495417,0.0087724257539355619,-0.091029953142718001,0.005261084458105819,0.0074128482411619833,0.12677166922406993,-0.010973650363561953,0.12218436711438121,-0.032292648360242045,-0.041307828155396936,0.0097001513532332835,-0.046119921825401256],[-0.0066832172944956327,0.0080822202324519078,0.046932304539841756,0.080999330413291576,-0.021246022388930752,0.077223007894173301,-0.1208024553957209,0.097572471349082826,-0.098662078545974516,-0.081071918722385755,-0.00075065076725868026,-0.10367608652818795,-0.10332194965606889,0.018813730318266546,-0.010497200676673153,-0.061595641076937518,0.18741244184973282,-0.10373942661667772,0.0019642020598160115,0.19296689375226381],[0.0011332836074734035,-0.011108535310006282,-0.044177040561706557,-0.026937857839190442,0.058202747644603162,0.067660378971863971,0.01252332721829966,0.086955312557543449,0.014537206052818295,-0.0024289122507333647,-0.067246547639804657,0.010135633490719997,-0.021703799990268176,0.059668358321338308,0.090059081877064975,0.058504432644668598,-0.095514911708738368,-0.060412988824551053,-0.017228627814190295,-0.065438091003328161],[0.0015010210285302467,0.012001351176920534,0.026456098121273891,0.050506276299144316,-0.059043613350488425,0.092763446808496491,-0.059215687883914112,0.051446206696285059,-0.03372817088174114,-0.013303363349763798,0.052355162524900162,-0.072966497652211054,-0.013674015384355876,0.03057299590116571,-0.00012694541907415412,-0.036559417235039519,-0.07723897190816445,0.00060168847264390314,0.0056980306445756287,-0.095808032622795122],[0.0045410658335984311,-0.029739632923257285,-0.061285405847324483,-0.051928527681961829,0.095878693787256303,0.10776669151268725,0.018083231455709298,0.11656925567843941,-0.018095403188716327,0.0028618652877730761,-0.1116403729402848,-0.0016145266116992633,0.018507271803891171,0.085962991157207722,-0.0049371044283928944,0.10296554953916494,-0.034908946306265815,-0.032021722740051613,0.026463113300104341,-0.058609101108032663],[-0.0038940101674299864,0.01249229063887494,0.035153288200359269,0.021732063618845297,-0.075236503021887086,0.11222268661870922,-0.1223327365171915,0.089597851601173534,-0.025863497436002837,-0.0013532772920339293,0.037452430817598512,-0.095172396847614027,-0.025294237043152014,0.0092336770328444798,0.045197831390106642,-0.060782377972329979,-0.10825269327067877,0.10079245210813292,-0.015704918925440504,-0.15393418284118934],[-0.0022816888324770947,-0.024060777904828332,-0.064375093915972514,-0.051683675703232124,0.082586761882057172,0.10799981168598963,0.011766005324578267,0.13475702007336832,-0.022040198973617333,0.002726563752619001,-0.078307843630374088,-0.00853731897183721,0.018274693017327637,0.14968884350468206,0.011604584974515436,0.20993316574217549,-0.039923368624747504,-0.056634414817972573,0.061774450547349605,-0.10280319608126552],[-0.0045581789111749909,-0.00066198929864758874,0.030116361303995344,0.052015237018933534,-0.057149166326883417,0.10832378488024449,-0.12176894478021971,0.094733181412691519,-0.053777107185287908,-0.066173515321594226,0.02667771816372827,-0.096802491865775248,-0.073708163708604835,0.014542543817590731,0.0079362155357385559,-0.062350724930571956,0.0114457464518416,-0.02293387196898488,-0.0045563429569467628,-0.014345756963712557],[-0.02319593145002526,0.038186433726972717,0.08706661401447259,0.081279187172167727,-0.12651124179728229,-0.13546806794789074,-0.028704304423922179,0.061982096023738401,0.035852029667403952,0.0036320225960270566,0.090477520800764724,0.00068386220739691012,-0.044817915269828791,0.06193024001847991,0.078870109330660007,0.046002165330352646,0.0073402265804111229,0.041759774758871937,-0.019334089807545696,0.014622330486136953],[0.0082810441729772831,-0.022628164438439315,0.036363277368764858,0.052466019430260261,-0.044709627260733048,0.09021438636649573,-0.11127276398624342,-0.12854130381332382,-0.025063016988668928,-0.057362925765527095,-0.0095287923605207759,0.1265336119507815,-0.032687178519142643,-0.01590396394734752,0.014802970227304249,0.075118124442728321,0.010628470124414376,-0.024180821376674457,-0.0073747062951664902,-0.034648408127107316],[0.017198522016467425,0.022236361949753605,0.064951340141844366,0.055948184803736797,-0.10510905763267528,-0.10512394373069515,-0.03777241447816871,0.082426181285644662,0.011666390781661908,-0.011957815046176372,0.090929803683901009,0.0093392317964502772,-0.011475382834925737,0.12593257195353708,0.010551815031581582,0.12451493177521945,0.039646936943170577,0.03719107313677409,0.0096152888906913137,0.053682193055150589],[0.0060106898082263171,0.0072122605101080043,0.044409296126462966,0.078857533847899383,-0.017120649032104904,0.081425388748712191,-0.11940777277719844,-0.10089623131434634,-0.099198367818690861,-0.080663635662292399,-0.0043343566705041454,0.10338853261811562,-0.10294994506346151,-0.023790752142643957,-0.010921145722281386,0.056736886871193083,0.18599558835956628,-0.10528546614138183,-0.0023446205569316245,0.19100128644165718],[0.0010733023256969559,0.01157247180697759,0.045184485859170752,0.028905643369866726,-0.060482443709835215,-0.063955365071974413,-0.014845222571675594,0.084862194545056543,-0.015853973269866806,0.0019032111181755047,0.069255873790655065,0.013000816134354817,0.021148557038695486,0.058418279958511371,-0.08999424051007307,0.059898583580402356,0.092399570333022443,0.06038983059651247,-0.017439626135533855,0.061614920444553849],[-0.0015444798414713842,0.011554647683167758,0.0246961186876711,0.049406435936464904,-0.05670610296740488,0.095355625030301761,-0.058676663018436867,-0.054830160517857759,-0.03312961518654288,-0.013388684721706963,0.049666740963896033,0.072510824197000667,-0.014517994556078053,-0.032898717753508326,0.0034192131689155551,0.034227464304296157,-0.080939956402453508,-0.0017775286940463495,-0.005015237764972166,-0.098310347613168508],[0.0046908702369999706,0.030208451863458361,0.062622034091439752,0.052743953778594359,-0.098766764690733908,-0.10326437154591862,-0.022886037597294896,0.11295095822829268,0.017062999846528665,-0.0029129309928138786,0.11302847979225221,0.0021341214358619517,-0.019488875651691228,0.08553275343853213,0.0067129322364770753,0.10527899609166107,0.030619444487241902,0.035965574913564891,0.027060969805652244,0.052502519649912253],[0.0037121867556401582,0.011311610311061645,0.032712925387670642,0.019670534211132365,-0.071402951632534434,0.11637895325503753,-0.12152584485104628,-0.094118262926394095,-0.026555943824720034,-0.0012395424097627105,0.03302756727713687,0.095162163403298403,-0.024545901145632716,-0.01261129372682537,0.044968383374253566,0.056680991926790526,-0.10954327798574533,0.099453439107694774,0.014650759610565341,-0.15612253139789609],[-0.0021004419336657651,0.024016053328674791,0.065510998051054106,0.053691686183182048,-0.084772954903796452,-0.10365082949147385,-0.016551511206833645,0.13092241552622599,0.019905643125049638,-0.0053300195908336321,0.07929754711756351,-0.0047191176774989373,-0.021162766878001702,0.14900015141933146,-0.011283098688825861,0.21222541347290966,0.040343082701711962,0.055687478374924389,0.061905950329526664,0.10215861174289849],[0.0046444851811399722,-0.0016088647336668569,0.027558248660570186,0.04993986434842837,-0.053853008893656552,0.11249225413654093,-0.12121122997047816,-0.099965750296801714,-0.054603232503147428,-0.066014840536623001,0.023573672637086641,0.097063578004294562,-0.072931441095314686,-0.020425237513237268,0.0083869895337177064,0.054036292009652237,0.0098648949467138435,-0.025146056897783802,0.0021204516891783834,-0.018382489334929881],[0.081810771753296499,0.0013428505322772349,0.00052034004062908137,0.0014149728204025361,-5.5785446345156184e-05,0.00050436857578441802,0.00014499662069079183,0.053461428336135319,-0.0023340734387916891,-0.00054673940084752561,0.0024140020816934941,0.050804016409159894,0.0020717140421122162,-0.043036085806402301,-0.0041824626647224408,-0.048410973331845873,-0.0026616866809261075,-0.0028679704469060968,0.023711183240833517,-0.00077900682440931561],[-0.0016112669680105572,0.068182145216188247,0.026419842982680058,0.071844095823552181,-0.0028324607335239714,0.025608904825977018,0.0073620856604533986,-0.0010529253262692335,-0.11851068329922455,-0.027760249058210628,0.12256899523055254,-0.0010005874743438097,0.10518959800104026,0.0008475977185642829,-0.21236114512593507,0.0009534563792407331,-0.13514497960633581,-0.14561887029600593,-0.00046699286059298517,-0.039553438859890044],[0.093166740094738354,-0.014400575595609583,-0.02425869037887983,-0.036742157033356856,0.00078129167135466688,0.019454205498741453,-0.0039861327960365994,-0.02099317038141546,-0.038746820011047511,0.022798678000079339,-0.026621044116277828,0.0015937490043979945,0.056984551915887666,-0.12002685484945716,-0.024167878123722158,-0.0052871980258868368,-0.06641761215588543,0.13427170902105776,0.12116397276410566,0.017717186022320208],[-0.0043276594230666661,0.10938077275025079,0.025032360614155796,-0.053334284454520042,-0.076358196693512861,0.04166704372049216,0.12200349265013893,0.019618940666931924,-0.0087274878540610709,-0.02790569419575932,-0.0020209270918830997,-0.037179968015268169,0.085756673591485144,-0.004389545295775843,0.18879471579957491,-0.013536420311015865,-0.080458557180323409,-0.096480592550878083,0.0087287715663233352,0.10538650345322242],[0.068925789004882776,-0.0038994871276475762,-0.038483088818842055,-0.053421640113207228,0.020614388358821466,-0.02427508186739339,-0.033834645110336244,-0.0013678098316814412,-0.040894256133445342,-0.0036977002778182584,-0.022243390064701673,-0.0092915975150358755,0.047028873154851922,-0.13509260700221762,0.039418674703283973,-0.023948367571516027,-0.17001516730115412,-0.072578057599643309,0.1202115539637188,0.10088447004350533],[-0.0035850918142771512,0.098584534210232375,0.036484755081029566,-0.078370073077591376,-0.060738169839910622,0.024631053138221219,0.11530991223411222,0.025280805195852688,0.02033204974869221,-0.017891370222691924,-0.012565485446069457,-0.029378799703956352,0.056812766852860047,0.016354624703901362,0.17160493997741857,-0.027596329561658473,-0.057952679396500159,-0.014688921034535446,0.0048945221808571505,0.096282275263389047],[0.082029257315952384,-0.0074757163649968785,-0.024317219559781427,-0.059450697624626736,0.015388354923859244,-0.017755496878605441,-0.031009613692150929,0.014232679001682458,-0.045997650792277849,0.014613540618649851,-0.029813283030589052,-0.025341296256074276,0.057084476163641755,-0.13353605511897121,0.028972212579385332,-0.022874981819277038,-0.15035368981841191,-0.014709236489244142,0.11573380339300179,0.087448158866064024],[0.0031065122369682264,0.097354708154303596,0.048803407878371549,-0.089656786129114069,-0.053981454541723428,0.01618876328493523,0.10550879640444577,0.028379974224971769,0.022378952453626672,-0.012573185226640944,-0.023347021041790376,-0.037642437913027099,0.067803785546888304,0.010191767475728952,0.14003184385552006,-0.021789923937985227,-0.031733332445823145,0.0074465847536980302,0.0062392987933809346,0.02754136582668306],[0.1387392468659556,0.0029894476997011136,0.00093655830249406418,-0.00071956529721012004,-0.0008872730067093457,0.00037083649983887671,0.0039663222876059846,0.011515406413235096,-0.001605791484448746,-0.00059454204947576147,-0.00015462731808354332,-0.021428183483375163,0.0017941691288204662,-0.18742897143429363,0.00028052668699122749,-0.061963185529603594,0.0010059641470246006,-0.00058911793994807001,0.18354627085177028,0.001104489680699863],[-0.0027324759423598926,0.15178677915220828,0.047552987208318576,-0.03653534359011034,-0.045050566340589578,0.018828922114365518,0.20138679301047269,-0.00022679646676340305,-0.081532758522211576,-0.030187389720664079,-0.0078510764992025268,0.00042202907381617971,0.091097480429496794,0.0036914223402121347,0.014243514709650809,0.00122036783099561,0.051077012598222192,-0.029911984964390393,-0.0036149523710262976,0.056079566555546495],[0.081843326175564626,0.011303243144873897,0.026219987228758131,0.055874374446870795,-0.017501931484022883,0.018379157328786692,0.035139955952998056,0.013104185338561095,0.046843147349681404,-0.015097274885653114,0.028870878407626664,-0.023839480142389981,-0.054370445929998568,-0.13383379839837584,-0.023436016295804645,-0.021999268190288232,0.1489875979432729,0.014991037574045143,0.11539838184369516,-0.086295907464403285],[-0.0063339904172092188,0.096984855670291956,0.047808075231963468,-0.091928118806094347,-0.053333678815841917,0.015477089583819052,0.10420597754290616,-0.028918375044037915,0.020550448601090406,-0.011988029328599841,-0.02450280834026132,0.038611055599596503,0.069998895439423989,-0.0049259057318324553,0.14106402636925069,0.022673724386324326,-0.037628873079354773,0.0068616364698298798,-0.010791457969181364,0.030963263322166375],[0.069013500164363681,0.0077782114133199123,0.039889826275969542,0.050294404698156978,-0.022989956636996347,0.02522610009548568,0.038348713762754429,-0.0023621762657445875,0.041663113891177821,0.0029903632691728448,0.021731376833849146,-0.0081276070323543018,-0.04475541031321123,-0.1356318045872692,-0.032631192325708366,-0.022843195367171557,0.16760144609996055,0.071943400497696125,0.11992561030559708,-0.097015137991933759],[0.00086837107609009359,0.098354541392438252,0.03494119686036181,-0.080412765420858859,-0.059879380230085794,0.023656125049108481,0.11388825761211437,-0.025207342945575004,0.018706078492882101,-0.018023091946400036,-0.013431570532555042,0.029721871750519709,0.058620462599582583,-0.01102269478220743,0.17302396547131629,0.028517891577622866,-0.064602054354914035,-0.01753527789696872,-0.0096240348389936663,0.10017991728015548],[0.093264891131244823,0.01869625635332417,0.025225522728041395,0.034613636044571898,-0.0037872760428480719,-0.017798486629238417,0.0087869071633989888,-0.021749382668845366,0.038373129017708049,-0.02387977956539547,0.026520826150974057,0.0030564676199522,-0.053563707436167715,-0.11976093779742616,0.031582894163982841,-0.0047501037484688367,0.063198064822796177,-0.13796648876910192,0.12072631763615553,-0.013553871931192441],[0.00065587974480378023,0.10872892910029817,0.024057766727453193,-0.054739640129557052,-0.076268218539154262,0.042400737230636511,0.12175192703198599,-0.018777124089696604,-0.010246368849578542,-0.026986359795397864,-0.0030675587070682357,0.037088381781813853,0.087933926719009473,0.009112177063499604,0.18769670173732864,0.013734105437928577,-0.08301134398793153,-0.091118848539309905,-0.013492812125432366,0.10600238839912123],[0.15198329888645534,0.0028006329231055624,0.00074600501456857128,0.00047877576221698378,-0.00028276186426712897,0.00046544182592499889,0.0027810265190758971,0.014577335068213435,-0.0023713561635063558,-7.4399427398391733e-05,0.00042809416639977911,0.032335351595210671,0.0025660999077709401,-0.11258044828872535,-0.0019629261392470339,-0.068299111724211686,-0.00085203598771659819,-0.001085913705477137,0.13519669471746937,0.00036773380244120628],[-0.0029933181650393316,0.14219986221144601,0.03787779876667053,0.024309450501608269,-0.014357004020670722,0.023632430715189428,0.14120436296966274,-0.00028710129453176221,-0.12040368336844545,-0.0037775705046386573,0.0217361336336362,-0.00063684625884668155,0.13029163882764647,0.00221727718347658,-0.099665980582218289,0.0013451541931120844,-0.0432614353180815,-0.055136386499758307,-0.0026627052124549278,0.018671385173615346],[0.1316377984929808,-0.02362242079673707,-0.010985661443978204,-0.039968343205424334,0.011570505836073249,0.033205834150693059,-0.051170416514177627,-0.014142357469543666,-0.040076184864964268,0.014047529939951571,-0.038612435433181186,-0.0061341283358575102,0.019089531531501298,-0.16518066221941546,0.03038866293059846,-0.0032824916332468497,-0.11074112146459174,-0.013923765545995706,0.17523174961640861,0.020527889008506092],[-0.01333077899561892,0.15174038102342471,0.050439117821201064,-0.032633802973101728,-0.024681537713083592,0.047849917736861383,0.19726449414187786,0.024421895341756646,-0.12826274594269291,-0.0096122374810214146,-0.051464351914932593,-0.034670744528944086,0.12764585703241688,0.0036731932047622887,0.04396417565977026,-0.024460064437484951,0.038083140431675586,0.0069072900028640674,-0.0048465499204577989,0.038264694747099537],[0.13206061186311063,0.029578852069042368,0.012963173373203693,0.038652398078394837,-0.012533364143145624,-0.031296001493739657,0.058897988383271399,-0.015092997962523761,0.034994783686450703,-0.01441511635728865,0.036556092321482714,-0.0047642170603121895,-0.014048695159930489,-0.16519719776774375,-0.028634015353771358,-0.0023168354615989029,0.11215475975367495,0.014184941121037223,0.17528669136738098,-0.01900530438792368],[0.0081372264961395695,0.15069257947128609,0.049967444401719879,-0.034182242142128616,-0.024206810868850334,0.049120284400353223,0.19509669177023312,-0.023846103652028865,-0.1297412721720777,-0.0090516643337693273,-0.052944799577375898,0.034885387950180834,0.12829851595375544,0.002833614167307253,0.045126630063328788,0.024570343445953734,0.033693195647928866,0.0063536877131480183,-0.0020569271343593674,0.039043302836162586],[-0.0038309214028131441,-0.006327609729933484,-0.052088333861299019,-0.18060229644188955,0.066849870072778358,-0.12575488626154094,-0.2125060648853131,-0.073443087091755968,-0.16677568935528311,0.074329338740259696,0.013077140393708553,-0.062464753970647387,0.12874919357305487,0.012954480511230384,0.029466872112777671,0.0018815134527229026,0.01668552514963443,-0.033447189900894674,-0.18253121075591622,0.065848575934592049],[0.0040363724128006729,0.0054285031489339237,-0.044557203531833921,-0.17695699954660296,0.0049670275463198459,-0.10595366487499482,-0.15416871677359822,0.058039359533206859,0.23028436557624588,-0.0065144055070889047,0.086590768314136965,-0.058097017518508931,-0.016970687725788164,0.018175711463983675,0.14783066559284957,-0.078001208441342826,-0.097636412590754701,-0.23238594617718841,0.021669545651174356,0.02589071093035987],[0.066274862156580475,0.010935323985695435,0.014806079420386867,-0.12123528814039794,0.02855589378925754,-0.036047598017287408,-0.10364050007965218,-0.075579190193593049,-0.14632862610243588,0.04639984248265229,-0.037991214935095025,-0.05285698609791422,0.077592314922658084,-0.036722314655055044,-0.06038133373732392,0.045720314892436477,0.040593347514767376,0.17850961871979443,-0.11243932211559991,0.010951767221505329],[0.00064917569290233825,0.075925963194159299,0.0174751696005488,-0.19376068891082923,0.0040828318816701452,-0.031841460036281556,-0.044576969573996782,0.030139223137968539,0.14151154571182542,-0.021340478372072667,0.010565323177547331,-0.049083297160211432,-0.090521299110574008,0.019607952775614269,-0.10735829803366925,-0.035450005106403344,0.0033882421104407122,-0.0017408685781109632,0.013726786778436431,-0.052913524981135822],[0.10398820287198415,0.002555304662503209,0.0092925475363547921,-0.039068549667282911,0.0011161779327457165,-0.0035912785865321356,-0.041179596831509013,-0.062868314541723383,-0.065948016538531801,0.030964888548817092,-0.014728513450262418,-0.042241476052874177,0.064679635499551844,-0.073966411482394828,-0.027365421654483347,0.052599561053486892,0.011955557066130695,0.12005062922777424,-0.03260051882859781,-0.005169167432061912],[-0.0023092618200368058,0.1119484805026983,0.046231968719573899,-0.16547162937327961,0.0046113699175225863,-0.010780969312844432,0.051679447504111693,0.011460267729800142,0.08980407463741813,-0.034390966251272775,-0.051200507366371613,-0.020256685820207513,-0.08342543815233526,0.0026742274714927723,-0.23595294011547635,-0.023520579545326849,0.056009972045851487,0.075816529529921281,0.0087273605289674705,-0.033058495383148763],[0.1120645151564317,0.0022079729500584741,0.00098928742937460612,-0.003301014092801275,0.00025018449162577777,-0.00015106332155457444,0.00091684303783099363,-0.063279768671292175,0.0017042671887136874,-0.00032171922161875388,-0.0013785209562622491,-0.052334921761096997,-0.0015448840382170492,-0.053191625186315088,-0.0044536651788212962,0.059985955751636004,0.0014679630382097369,0.0015595511447703578,-0.019700230648099601,-0.00085419779416753654],[-0.0022071158563591849,0.1121080333929546,0.050230265803129975,-0.16760630973155033,0.01270291438164515,-0.0076701174698927919,0.046551960656267183,0.0012462979974182488,0.086532782431857316,-0.016335032202010345,-0.069993282025136702,0.0010307387266987771,-0.078440232404101987,0.0010476115406416152,-0.22613123252942074,-0.0011814261982336107,0.074534631098160928,0.079184942827846119,0.00038799696207817563,-0.043371199284965904],[0.10399848794160393,0.0018546282231649443,-0.0074649658195946539,0.032522836809174546,-0.00093374048841793583,0.0031639948630730577,0.043182531456502818,-0.063270806840101071,0.069432893861544234,-0.032295013728537755,0.012701080887017291,-0.041411114897206752,-0.067914338774211269,-0.074014348575406799,0.018053595514753489,0.053484889263948468,-0.0097409030935217272,-0.11697226908769014,-0.032918875737885253,0.0038634864930026259],[-0.0017870457628367537,0.1119622803578736,0.046562008727237675,-0.16688162507129661,0.0046517431565028695,-0.010914014738721261,0.05001793145007153,-0.0089759518469328132,0.087137741288496093,-0.033145059523410833,-0.051740734507055609,0.021904227503264234,-0.080813993640496004,0.00024026050450727578,-0.23684746977845314,0.021431241345078487,0.05643728484132754,0.080484706574742798,-0.0074369529950133462,-0.03323639392378238],[0.066197905559296805,-0.007937272624853435,-0.014106515811415555,0.11351197925830203,-0.028372988239404456,0.034765891745263566,0.10180491786473986,-0.076707305856766231,0.15178714152250369,-0.04720413741476337,0.038377760867838853,-0.05088335009753632,-0.08109640280587968,-0.037465896519152928,0.056107295015633704,0.047080696866891356,-0.040428456400197134,-0.17843973287559281,-0.1128926164266072,-0.013026734771989946],[-0.003258233035928045,0.076297659865239037,0.018044604513067886,-0.19838404729853476,0.0052040488702490692,-0.033236135022211573,-0.048623226669103181,-0.027139933490635631,0.13564014175458514,-0.01949694361924361,0.0090612326347666739,0.051126467923420758,-0.087395917408481461,-0.018146812493972552,-0.10965254701379751,0.033622284848530311,0.0049839703200505025,0.0052892655613498776,-0.0092888637319964926,-0.052441267265233169],[-0.0039868820031456502,0.0065364490733629474,0.050293508064377906,0.17349459134769435,-0.066602452923475206,0.12148545825215637,0.20627090330577347,-0.075671422129284432,0.17571376211231018,-0.074528200706336797,-0.0096575032954606538,-0.060128753635612778,-0.12931756777555675,0.012228769086885426,-0.02362321502366381,0.0049513379063351008,-0.020517001886349622,0.024271097161742621,-0.18324289428534218,-0.064778069009668593],[-0.003882400409842432,0.0051751449104026556,-0.04657361868699695,-0.18393095427827572,0.0075953772763110682,-0.11082307499956565,-0.16241654870757216,-0.055102542314522565,0.22353901984468466,-0.003582649320105733,0.08703852818268723,0.060511502372577727,-0.011888050816356367,-0.018671696740185807,0.14887627733685901,0.077866635114920285,-0.096903707084442264,-0.23352271053475368,-0.014465607580724772,0.028463408799233134],[0.030970322681001344,0.0047092200014083761,-0.0075287381199665099,0.16357528456660905,-0.052689892202482637,0.089603666894719117,0.14218940432389821,-0.10513747604797508,0.14519927390557394,-0.054724870498712809,-0.029363608692248001,-0.050838750489416849,-0.061890285829241144,0.044141490765737125,-0.050417517293536961,0.025015137007616546,-0.016424178217207281,0.044950698551189411,-0.2067799302490973,-0.068404093672558383],[-0.0061910554636544247,0.025490142152652336,-0.17773317220354787,-0.011649348642623007,-0.033779282406239355,-0.037805216091529065,-0.10672838541759473,-0.042820997106558227,0.11269092441672976,0.087330253747772396,0.0073968040077101753,0.043681348504218676,0.017817631930504733,-0.025762018942079048,0.053616783973747938,0.05392914604451754,-0.045882436605483475,-0.054493601747828906,-0.018289999358621918,0.050792370931913529],[0.072541861006159419,0.006476680970671134,-0.026270676170072199,0.11039354583740993,-0.034051788978890947,0.048185260694194772,0.068956955964512401,-0.088822070980787649,0.083965194657350153,-0.032425744904939727,-0.026027916755625602,-0.062975614492549584,-0.033734092336045483,0.050170467939578731,-0.0071563112069314367,0.036377300918928768,-0.027785475091142361,0.045788377840654343,-0.16056788078199066,-0.044453878673682577],[-0.0046479508538619374,0.046087217023970839,-0.27900795030851655,0.098063569589822888,-0.061903898032388743,0.015660875349017691,-0.064717698941130067,-0.035866374649349185,0.014465297947944376,0.15613902852083919,-0.056401659837762089,0.029190158094928927,0.06489892032450216,-0.012065605931256339,0.018024896454018453,0.032618292440983028,0.022591293266887181,0.09812652322448133,-0.011371173195259793,0.053107627097234475],[0.092348192058670925,0.0010952096884211909,-0.0059954126082538226,0.0025490185537617518,-0.0015525730855718725,0.00060010147540871892,-0.00090016832239136872,-0.096893901856154083,-0.00043212015089025225,0.003109771883908815,-0.0013362209789642928,-0.068512309872291427,0.0017057933812730085,0.027410918821544273,-0.00020315778991813945,0.051832972363327026,0.00062915076693509831,0.0030023947570177061,-0.12667198858307449,0.0010261238764925802],[-0.0018188019527347944,0.055608382484283542,-0.30441220616984355,0.12942434694989627,-0.078830637539146028,0.03046966505748637,-0.045705315521775092,0.0019083299193569704,-0.021940549726592977,0.15789614188725432,-0.06784553503059583,0.0013493531405928255,0.086610273619572284,-0.00053985932553349931,-0.010315171793919409,-0.0010208528098808126,0.031944619243145525,0.1524441554727779,0.0024948107272665665,0.052100606489871464],[0.072668617825301429,-0.0046569824991961615,0.015264415714518009,-0.10644670145937027,0.031587927348150538,-0.047531249409710249,-0.071451728359471056,-0.087340958401163751,-0.083330512075594679,0.03854854525064836,0.023786927187687674,-0.064076134823726288,0.036263315230795352,0.050606642360040699,0.0078604886212777329,0.035064751329812231,0.028653455870299018,-0.041889155266448416,-0.1599956242713681,0.04651050844387359],[0.0017880236959115089,0.046306495045648009,-0.27982598588173846,0.10233424838085241,-0.063196675309032335,0.017546016482861838,-0.061952343350116838,0.039335913735030842,0.017760194700190777,0.15474118656366273,-0.057382765514220439,-0.026687867962290814,0.063520318115506472,0.010080796040363754,0.017729139880527298,-0.034025346994416339,0.021479725887446274,0.09985333633117191,0.017684686388847928,0.05131607924740187],[0.031190077233784839,-0.0037018982930456636,0.0005246879936731259,-0.16390712475261301,0.051318978608620253,-0.091022753824708383,-0.14628154898705953,-0.10336987404471408,-0.14064948860692097,0.058121044994734826,0.029632085365876047,-0.052519270838883962,0.062543856649474996,0.045121634388888533,0.052489570288457181,0.022872287624848182,0.014604828763976164,-0.047061515545538023,-0.20589940927102812,0.070350987521525382],[0.004966803486139159,0.02565579952003115,-0.17789178480673115,-0.0051995673065931896,-0.03582774197123851,-0.034247770305137808,-0.10104693652841799,0.046927559098234456,0.11832072913574611,0.08510774817530592,0.0062348810597435385,-0.041645707450159532,0.015366895686711617,0.024003977526008316,0.051590024080869948,-0.054872291107689583,-0.046493554346182915,-0.052681416896737082,0.026417738211326147,0.048059583131722365],[0.057822167916677866,0.0015818691524278872,-0.0086989311774794305,-0.10253564278062774,0.025956947528960845,-0.056268310823976389,-0.10131954273559655,-0.10023331381082408,-0.11388888765265529,0.05842928132354492,0.015546668169134321,-0.071095203622811659,0.06231399292864441,0.036858492295635148,-0.0010999714881740621,0.026105216445068306,0.061097310720830501,0.077303858214289992,-0.18755963663306235,0.047389410510084273],[0.0013806130436272196,0.028279785525396724,-0.24779758418898035,0.092947078419168605,-0.038757957330367888,0.0028008391133760783,0.01252921060623961,0.044696812467934832,0.077376575265403702,0.071988012448027799,0.010778528628600051,-0.031045644082364751,0.0010043548601519081,0.0066662232244777365,-0.12622795800741801,-0.045083852480253137,-0.044807980460019228,0.017776390020602231,0.016228237723703562,0.056646065257650355],[0.08743934914534307,0.00080254649884021882,-0.0057786355332734261,0.0027136736414979869,-0.00091802840943314655,0.00011137735951005171,0.00064188936915962668,-0.10811931560815041,0.00033513970260685885,0.0014622751318325126,-0.00028756414198402813,-0.059023549879327397,0.00068450082974115685,0.025379280968380467,-0.0033295795726401762,0.027241769541909207,2.5402298056486418e-05,0.0016213486083215725,-0.13466444154822188,0.0019403531333068763],[-0.0017221220624478687,0.040748646711902918,-0.29340552623742644,0.13778457530947336,-0.046612146936721104,0.0056550949769633985,0.032591411425749707,0.0021294149671227474,0.017016446225115087,0.074245832271085804,-0.014600835771580457,0.0011624715696626617,0.034754973731009088,-0.00049984612319328887,-0.1690566987716989,-0.00053652792257516575,0.0012897810540676788,0.082322658852477748,0.0026522224614447111,0.098519854537740509],[0.057722966076044338,-0.00046713096417426854,-0.0010648000347449808,0.10611590201326676,-0.02746290579936882,0.056334957908550129,0.10173430596600778,-0.10191551293463318,0.11684725680985987,-0.055549455027095192,-0.015110209275042964,-0.069817653430995413,-0.062226122825756187,0.036567427603391177,-0.0038710846599720981,0.027860140717788494,-0.062814236601042656,-0.076543967770580645,-0.18805317015343495,-0.045122231921033401],[-0.0036562798504169839,0.028320140678325608,-0.24794793875814208,0.088837676506122579,-0.037705850825817878,0.00058311248019061101,0.0085300555789909818,-0.040715481890351971,0.072832216131135635,0.074232828980148546,0.011382317260704876,0.033820929378822563,0.0034571782525573127,-0.0081123501438758478,-0.12617338080416468,0.04402100225222013,-0.042367536752229679,0.020806430133868493,-0.0088305259631811031,0.05846808637309852],[0.06632787150069476,0.0005024945974418921,0.00068789731494344527,0.099052827103458627,-0.027081197212793062,0.043963347280316291,0.085985928084049035,-0.064402105970983711,0.11344648894176523,-0.045255083619287213,-0.0033627481062759495,-0.065526585575091861,-0.065674092536073009,-0.020837968861429697,0.024402999253028874,0.015466292580588225,-0.049326952278705233,-0.099548532965597292,-0.11056103199623027,-0.052035175908553173],[-0.0034584653198352355,0.081730476144182482,0.042050903254929328,-0.20673617233092098,-0.019186781291530772,-0.017709312635985481,-0.062968880438414046,-0.020672760790206416,0.10430012736186442,0.0046453384558402724,0.0023476603249214939,0.04000959099000892,-0.060975072974956919,0.0036578431925638182,-0.017462918205026205,0.022780444868397098,0.078177903575462684,0.099431926790962424,-0.0024518885244070067,-0.12599928693973769],[0.097128615119178252,0.0021091910624301854,0.0011487974317803925,-0.0036646797964441928,-0.00020402199216735107,-0.0002950630790080626,0.00015780066191907344,-0.082650389488317363,0.0016065974001583869,-0.00015594162162705649,-5.4727904831485806e-05,-0.048473628411413568,-0.0013575663381852705,-0.037546402774221881,-0.0016561616161499832,0.026718742004923881,0.0026342928535636671,0.0026626671036050439,-0.042087730824440769,-0.0029947917415798823],[-0.0019129526080266935,0.10709246327169396,0.05832925663349231,-0.18607114049263718,-0.010359050961291636,-0.014981588209040738,0.0080122004553344981,0.0016278032784891297,0.081573678237876118,-0.0079178091943084804,-0.0027787649219276709,0.00095469037395777079,-0.068929328310090771,0.00073947815503061336,-0.084090261052632717,-0.00052622687082184809,0.13375408026912178,0.13519475977153123,0.00082891982293697986,-0.1520581185386175],[0.066412611420979081,0.0027160178727324764,0.00096838289061252475,-0.10711621231805085,0.026304719983661629,-0.044626555190009395,-0.088398635285978924,-0.063538176615308029,-0.10925171370014186,0.04540289816921849,0.0034525790352213999,-0.067051140879800644,0.063222280478838544,-0.020965836164988375,-0.025071674259481383,0.014557322724614043,0.052366940659376415,0.1033864484065217,-0.11037875047163209,0.047033623955948213],[0.00084413531333646472,0.081686880699964534,0.042045379078425649,-0.20267566347704935,-0.020238219422379647,-0.015964530372102555,-0.059534368323843435,0.023192550627061579,0.10868617885682233,0.0028598252732636277,0.0022134321387772254,-0.037398466479719547,-0.063513693057426587,-0.0028345153014708558,-0.016488512201080392,-0.023371761373115647,0.076175037607720986,0.095435112861314508,0.0068033078519711999,-0.12795045157687654],[0.20703888776046808,0.0040955306438840667,0.00091829030602567484,-0.00029318224193783675,-0.00055127789316487255,-0.00022805224437934772,0.0051995057930183932,-0.0070650309926390707,-0.0025937632986591107,-0.00022702125921550729,-0.00086173305987560507,0.0039240564283781008,0.0027605436927608689,-0.18348670413797583,-0.00045015275908286324,-0.021588694232823304,0.00096281376926177914,-0.00018547586884016306,0.23464452882669662,0.0015329766435944019],[-0.0040776405575057902,0.20794724236737283,0.046625444523509314,-0.014886090234270774,-0.027990687319841629,-0.011579167501817512,0.26400068400072507,0.00013914611514436953,-0.13169622503382422,-0.01152682006741342,-0.043753796281685783,-7.7284474501817166e-05,0.14016436409825117,0.0036137792018137043,-0.022856140762930171,0.00042519034051920836,0.048886087210756428,-0.0094173866110174916,-0.0046213349467353892,0.077835644112284094],[0.001600149798509044,-0.029891049610734331,-0.073100016972691292,-0.058468287694032256,0.11859715192490811,0.12934983734389552,0.032157533878495161,0.082573315128634459,-0.041100473797450493,-0.0057089075464736442,-0.11638049064707184,-0.0053600186457387336,0.0098026006087696335,0.099418622679411317,-0.049008089369327941,0.096626712331893835,0.019636547733371066,-0.043651581474207432,0.0051686639646904564,0.0072428841031747272],[-0.0084655797579516363,-0.0046796039747889337,0.045349170381251615,0.075740338407896624,-0.034637874980380609,0.082185012813799529,-0.12096517723818774,0.11907027593886906,-0.077532966005268225,-0.07891922561825053,-0.012653839329841899,-0.11579889444409854,-0.086081021299873675,0.014700684484061042,-0.0022790983807368559,-0.072634107643920642,0.13958423960770075,-0.080189569403226982,0.0020189064619431322,0.12988268130836492],[0.01424380662597859,-0.014200096866361181,-0.056192009903351103,-0.043173116638536083,0.080962018527769866,0.084430862834772316,0.022292726265859285,0.0819540031923333,0.021520036248995907,0.023644742127952947,-0.069978359098797141,0.010578253533974168,0.0055637826130301481,0.10753640013705529,0.04781691310140064,0.10988794493865349,-0.10152366815496501,-0.038775585391088246,0.009852910151646431,-0.10479520228312821],[-0.0019267548176591992,0.0089253887142499537,0.038395556537414034,0.072665186105416488,-0.035316486177484258,0.085965924697292445,-0.095827634585293003,0.067000919870278841,-0.079359015546978925,-0.060241496386490526,0.022959701461265629,-0.082723836506042564,-0.073346522132294159,0.034408742374915882,-0.038907662769628905,-0.046992930274581561,0.098012549165148996,-0.061028767847837867,0.00076321736854494809,0.10756844632916053],[0.0059814141378770683,-0.019986810144644714,-0.052159516892456757,-0.044470068674562206,0.076646118870655117,0.092443985277207139,0.004678028369475922,0.10415240351429292,0.0046581309098169387,0.0051387821644296996,-0.096441880503777305,0.0059706943668324346,-0.0081662190478821537,0.083068312844982603,0.047686224996273292,0.097270615186996257,-0.082539469495457859,-0.026822366473815737,0.0086196546781417416,-0.097324503721316472],[-0.0021942894961033254,0.014672723795261092,0.0297720048321981,0.032614772081342773,-0.070295075024643439,0.11259463615333912,-0.099268692243530854,0.067976663605742033,-0.030441862025488736,-0.007886017458831291,0.043349675685024236,-0.085122999155765849,-0.02423614615027082,0.010447936760906771,0.034457826074821618,-0.043728626489175956,-0.10420367455137278,0.051653432878078387,-0.0020921056059804294,-0.13233775532920924],[-0.0042059935392670346,-0.036744548164445875,-0.071150072959197758,-0.055275730345418772,0.11733258745742503,0.12551113047364854,0.026702116872438945,0.098002215324570499,-0.032058017685709768,-0.0047389532692274257,-0.10681090062656813,0.0020600345006132207,0.030173430742514089,0.081617365370315068,-0.060517548931821992,0.076498984061509942,0.010560607875077087,-0.048467808387472493,0.0058354971872773553,-0.010407245460860998],[-0.0044631564451177276,-0.00045295155675293449,0.035712505776059139,0.033807803564813034,-0.072124316297525748,0.10250509947932059,-0.1226494724455383,0.11180724612070779,-0.025713763387405553,-0.018860328071287888,0.019240580467794626,-0.11284980000963721,-0.030120981721104612,0.016747429515335161,0.051983556502342557,-0.066147016249778562,-0.080512483822065731,0.055429747589261724,-0.0091079370182397448,-0.11890323290806679],[0.0019322395797021119,0.029683610868556625,0.074828944142974155,0.061405208380541323,-0.11986904124223763,-0.12601350788764124,-0.036895578153987703,0.077820909748784958,0.038015754250682834,0.0025970500443394723,0.11579199621960418,-0.00079630137938405913,-0.013184423524449153,0.098762687832966226,0.048880345050464534,0.099411734305558719,-0.014125215491144956,0.040460280290956802,0.0050851616444164346,-0.0021231601220420642],[0.0083960091842815946,-0.0058529296934387584,0.042435702587835022,0.073379424307888352,-0.02994127217609336,0.087214405816630577,-0.11960517297381305,-0.12222924768386143,-0.079091163809245135,-0.079082811840663722,-0.017226487294788227,0.11592014345432393,-0.085628290786705655,-0.018603874644254632,-0.0042070156653518124,0.068773121287758837,0.14024917911015872,-0.081846156446419099,-0.0022208560358934135,0.13006714598651917],[0.014308626336015217,0.014540520423140585,0.057660251751921007,0.046000814992156927,-0.082289813667776351,-0.080980494820433804,-0.026048634371759079,0.079252299607605575,-0.024628094656255289,-0.02599840397250559,0.070828125770320438,0.01382728639225384,-0.0084474740718789628,0.10609816881106175,-0.049311813835476996,0.11165306622847265,0.10530416416182468,0.036342518602119435,0.0098152177824551573,0.10894942298282573],[0.0013644133178536335,0.0083593409153309445,0.036153230930321134,0.070908901359961918,-0.03210123372298971,0.089223709106505664,-0.094875549231313291,-0.070175885527856877,-0.078450125954942412,-0.059263772307063395,0.020186511169956366,0.08224316825811924,-0.0730705697779436,-0.038616285181248482,-0.036994707959346715,0.04262966971973222,0.09393906535445655,-0.062508222411948575,-0.0011505820661768321,0.10335873595850939],[0.0060631753715524039,0.020549046454011372,0.053291335098044221,0.045719783410926723,-0.079354536584653024,-0.087938902453332982,-0.0085830875044931674,0.101395065582099,-0.0058531614203063097,-0.005445307614197795,0.098073976573685884,0.0093177669338030018,0.007205592342012423,0.08259250865896775,-0.046292474156033811,0.098916989702066069,0.078372460116979403,0.028835410650639128,0.0086953465132257254,0.092038254344599224],[0.0019570707435616432,0.01387436820763277,0.027695145380569608,0.030838478735115384,-0.067222634834479697,0.11614728554614781,-0.099007513947460796,-0.072024930603050749,-0.030234841632456377,-0.0076775633166532029,0.039518676801310174,0.084821892196893151,-0.024538894693039576,-0.013710634372263898,0.036308740940865211,0.039864702454276729,-0.10737284251528514,0.050557250359913708,0.0017510858493843574,-0.13606726368738839],[-0.0040269958559816504,0.036698218288480453,0.072501070354695815,0.056564040810879776,-0.12008147931184913,-0.12137767813607811,-0.031510710584075563,0.09352382549573536,0.031020682241923343,0.0039926562394971814,0.10748566435040698,0.0065018775352949773,-0.031336039816478478,0.080894644984347966,0.062517461426333687,0.07904418680908222,-0.013722582803368383,0.05061275847617297,0.0061895952050397204,0.0057173813576256987],[0.0046253055555129877,-0.0018994102698154198,0.032883289803905605,0.031605114052025748,-0.067448435171749935,0.10736758608785574,-0.12150296809183195,-0.115579360433701,-0.02695610132653348,-0.019032297528091081,0.015019999618782623,0.11268117275248012,-0.028909549827634367,-0.019948111144142567,0.04956037623096271,0.063083586239858991,-0.080034225248293553,0.053478351200525617,0.0088711022623346666,-0.11922080818583679]],'numEvalues':20,'eigenValues':[448.2615028731629,152.88433766749935,77.079422234111703,38.340488190771154,27.754350120854401,15.293153116152746,13.085890189100295,10.196616391772121,7.2364679411701438,6.5964537073839553,5.7388999381293884,5.6223215910853748,4.6227291984146053,4.393149515511058,3.9714381417641094,3.5791364382171165,3.4263759023353697,3.078849017302407,2.6395798573836098,2.4414195196560233],'numPtsPerSample':71,'nonRegularizedVectors':[0],'meanShape':[[25.011254225136952,34.815173567571549],[24.381567267455893,45.626763203908808],[25.830707280728745,56.164927637057076],[28.675368741312013,66.695735954974964],[33.59842962462659,75.549155778418879],[40.332640541597783,82.561857303541444],[48.359309091167063,87.999836114954576],[57.763839129670998,89.783311477497705],[67.090852037871969,87.63091750236714],[74.897176557764965,81.881107153483129],[81.35004130814275,74.608685557615786],[85.920682599877409,65.568286826736994],[88.348489374468954,54.933637000847114],[89.381567267455921,44.346585170183118],[88.326664228593643,33.56817361245254],[81.566856326247773,27.444862527091914],[76.619772918209833,25.17298033285374],[69.153548565650397,25.746811251285578],[63.337202235413088,27.340674714612589],[31.524715699235657,28.430444822342793],[36.378507746326761,25.965533928582431],[43.861536613791145,26.244938607124027],[49.736130518962113,27.608548456866743],[35.982434927065498,35.443406084328842],[41.74296700227427,32.491136119230305],[48.056933854020826,35.383200094731308],[41.827893337283342,37.01094114500529],[41.960848751111143,34.61071899652552],[77.388728098024785,34.627907207783039],[71.516418152976826,31.904746609209838],[65.321222211179702,35.043179129766543],[71.609524186972465,36.424390535431939],[71.382163563407005,34.031264828125074],[56.645668790714296,33.009120609139984],[50.194189402484938,46.941098052316647],[47.456988308925929,51.770997981023982],[50.07251572822895,55.035267306968535],[57.101339593814998,56.145435575714828],[64.081000008569561,54.759369555253215],[66.565969098022094,51.394645712515057],[63.640714233003223,46.676268118194287],[56.826129496946521,42.171866411747999],[52.142251303692888,53.25579760946124],[61.942803190976235,53.062775282622852],[45.090870407180603,66.45744111296608],[49.30691311256561,63.535961653371373],[54.022310354591866,62.360055474188812],[57.235786373192525,62.971861611246879],[60.422680620195308,62.233999883085119],[65.180722218119797,63.223326242164035],[69.508528157121361,65.976534203943174],[66.692952911540658,69.861040892668086],[62.796902525468738,72.430437387210816],[57.438793685614598,73.279393032509802],[52.051412524023078,72.642070314310331],[48.057213957229465,70.228072641153915],[51.312826281003822,68.334857344858165],[57.355342381712035,69.042220849614353],[63.365320267430491,68.097482913273097],[63.302666508653772,65.1057867536814],[57.283082963456252,65.373307571221233],[51.257633954541575,65.343014232008443],[56.997384601005933,50.86720524009678],[38.345016967805378,33.379866011204456],[45.43217757469057,33.213084051757619],[45.102977179460538,36.387811845290685],[38.616928471611573,36.562115185290565],[74.946726694421386,32.658993629837994],[67.858495092410578,32.771396681549788],[68.312444531975871,35.930700302534717],[74.800326543573135,35.849481471486683]]},'hints':{'rightEye':[71.382163563407005,34.031264828125074],'leftEye':[41.960848751111143,34.61071899652552],'nose':[56.997384601005933,50.86720524009678]}};// CommonJS and Node.js module support
	if(true){// Support Node.js specific `module.exports` (which can be a function)
	if(typeof module!=='undefined'&&module.exports){exports=module.exports=pModel;}// But always support CommonJS module 1.1.1 spec (`exports` cannot be a function)
	exports.pModel=pModel;}else{// No CommonJS or Node.js module support, export to the global (window)
	global.pModel=pModel;}})(undefined);

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * circletype 2.2.1
	 * A JavaScript library that lets you curve type on the web.
	 * Copyright © 2014-2018 Peter Hrynkow
	 * Licensed MIT
	 * https://github.com/peterhry/CircleType#readme
	 */
	!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.CircleType=e():t.CircleType=e()}("undefined"!=typeof self?self:this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,e),i.l=!0,i.exports}var n={};return e.m=t,e.c=n,e.d=function(t,n,r){e.o(t,n)||Object.defineProperty(t,n,{configurable:!1,enumerable:!0,get:r})},e.n=function(t){var n=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(n,"a",n),n},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=29)}([function(t,e,n){var r=n(24)("wks"),i=n(12),o=n(1).Symbol,u="function"==typeof o;(t.exports=function(t){return r[t]||(r[t]=u&&o[t]||(u?o:i)("Symbol."+t))}).store=r},function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e){var n=t.exports={version:"2.5.6"};"number"==typeof __e&&(__e=n)},function(t,e,n){var r=n(4),i=n(11);t.exports=n(6)?function(t,e,n){return r.f(t,e,i(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e,n){var r=n(5),i=n(34),o=n(35),u=Object.defineProperty;e.f=n(6)?Object.defineProperty:function(t,e,n){if(r(t),e=o(e,!0),r(n),i)try{return u(t,e,n)}catch(t){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e,n){var r=n(10);t.exports=function(t){if(!r(t))throw TypeError(t+" is not an object!");return t}},function(t,e,n){t.exports=!n(17)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e){var n=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:n)(t)}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e){var n=0,r=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+r).toString(36))}},function(t,e){t.exports={}},function(t,e,n){var r=n(24)("keys"),i=n(12);t.exports=function(t){return r[t]||(r[t]=i(t))}},function(t,e){t.exports=!1},function(t,e,n){var r=n(1),i=n(2),o=n(3),u=n(19),c=n(20),f=function(t,e,n){var a,s,l,p,h=t&f.F,d=t&f.G,v=t&f.S,y=t&f.P,_=t&f.B,m=d?r:v?r[e]||(r[e]={}):(r[e]||{}).prototype,g=d?i:i[e]||(i[e]={}),x=g.prototype||(g.prototype={});d&&(n=e);for(a in n)s=!h&&m&&void 0!==m[a],l=(s?m:n)[a],p=_&&s?c(l,r):y&&"function"==typeof l?c(Function.call,l):l,m&&u(m,a,l,t&f.U),g[a]!=l&&o(g,a,p),y&&x[a]!=l&&(x[a]=l)};r.core=i,f.F=1,f.G=2,f.S=4,f.P=8,f.B=16,f.W=32,f.U=64,f.R=128,t.exports=f},function(t,e){t.exports=function(t){try{return!!t()}catch(t){return!0}}},function(t,e,n){var r=n(10),i=n(1).document,o=r(i)&&r(i.createElement);t.exports=function(t){return o?i.createElement(t):{}}},function(t,e,n){var r=n(1),i=n(3),o=n(7),u=n(12)("src"),c=Function.toString,f=(""+c).split("toString");n(2).inspectSource=function(t){return c.call(t)},(t.exports=function(t,e,n,c){var a="function"==typeof n;a&&(o(n,"name")||i(n,"name",e)),t[e]!==n&&(a&&(o(n,u)||i(n,u,t[e]?""+t[e]:f.join(String(e)))),t===r?t[e]=n:c?t[e]?t[e]=n:i(t,e,n):(delete t[e],i(t,e,n)))})(Function.prototype,"toString",function(){return"function"==typeof this&&this[u]||c.call(this)})},function(t,e,n){var r=n(36);t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,i){return t.call(e,n,r,i)}}return function(){return t.apply(e,arguments)}}},function(t,e,n){var r=n(42),i=n(9);t.exports=function(t){return r(i(t))}},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e,n){var r=n(8),i=Math.min;t.exports=function(t){return t>0?i(r(t),9007199254740991):0}},function(t,e,n){var r=n(2),i=n(1),o=i["__core-js_shared__"]||(i["__core-js_shared__"]={});(t.exports=function(t,e){return o[t]||(o[t]=void 0!==e?e:{})})("versions",[]).push({version:r.version,mode:n(15)?"pure":"global",copyright:"© 2018 Denis Pushkarev (zloirock.ru)"})},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e,n){var r=n(4).f,i=n(7),o=n(0)("toStringTag");t.exports=function(t,e,n){t&&!i(t=n?t:t.prototype,o)&&r(t,o,{configurable:!0,value:e})}},function(t,e,n){var r=n(9);t.exports=function(t){return Object(r(t))}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=Math.PI/180;e.default=function(t){return t*r}},function(t,e,n){"use strict";n(30);var r=n(54),i=function(t){return t&&t.__esModule?t:{default:t}}(r);t.exports=i.default},function(t,e,n){n(31),n(47),t.exports=n(2).Array.from},function(t,e,n){"use strict";var r=n(32)(!0);n(33)(String,"String",function(t){this._t=String(t),this._i=0},function(){var t,e=this._t,n=this._i;return n>=e.length?{value:void 0,done:!0}:(t=r(e,n),this._i+=t.length,{value:t,done:!1})})},function(t,e,n){var r=n(8),i=n(9);t.exports=function(t){return function(e,n){var o,u,c=String(i(e)),f=r(n),a=c.length;return f<0||f>=a?t?"":void 0:(o=c.charCodeAt(f),o<55296||o>56319||f+1===a||(u=c.charCodeAt(f+1))<56320||u>57343?t?c.charAt(f):o:t?c.slice(f,f+2):u-56320+(o-55296<<10)+65536)}}},function(t,e,n){"use strict";var r=n(15),i=n(16),o=n(19),u=n(3),c=n(13),f=n(37),a=n(26),s=n(46),l=n(0)("iterator"),p=!([].keys&&"next"in[].keys()),h=function(){return this};t.exports=function(t,e,n,d,v,y,_){f(n,e,d);var m,g,x,b=function(t){if(!p&&t in M)return M[t];switch(t){case"keys":case"values":return function(){return new n(this,t)}}return function(){return new n(this,t)}},O=e+" Iterator",w="values"==v,j=!1,M=t.prototype,S=M[l]||M["@@iterator"]||v&&M[v],P=S||b(v),A=v?w?b("entries"):P:void 0,T="Array"==e?M.entries||S:S;if(T&&(x=s(T.call(new t)))!==Object.prototype&&x.next&&(a(x,O,!0),r||"function"==typeof x[l]||u(x,l,h)),w&&S&&"values"!==S.name&&(j=!0,P=function(){return S.call(this)}),r&&!_||!p&&!j&&M[l]||u(M,l,P),c[e]=P,c[O]=h,v)if(m={values:w?P:b("values"),keys:y?P:b("keys"),entries:A},_)for(g in m)g in M||o(M,g,m[g]);else i(i.P+i.F*(p||j),e,m);return m}},function(t,e,n){t.exports=!n(6)&&!n(17)(function(){return 7!=Object.defineProperty(n(18)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){var r=n(10);t.exports=function(t,e){if(!r(t))return t;var n,i;if(e&&"function"==typeof(n=t.toString)&&!r(i=n.call(t)))return i;if("function"==typeof(n=t.valueOf)&&!r(i=n.call(t)))return i;if(!e&&"function"==typeof(n=t.toString)&&!r(i=n.call(t)))return i;throw TypeError("Can't convert object to primitive value")}},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e,n){"use strict";var r=n(38),i=n(11),o=n(26),u={};n(3)(u,n(0)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=r(u,{next:i(1,n)}),o(t,e+" Iterator")}},function(t,e,n){var r=n(5),i=n(39),o=n(25),u=n(14)("IE_PROTO"),c=function(){},f=function(){var t,e=n(18)("iframe"),r=o.length;for(e.style.display="none",n(45).appendChild(e),e.src="javascript:",t=e.contentWindow.document,t.open(),t.write("<script>document.F=Object<\/script>"),t.close(),f=t.F;r--;)delete f.prototype[o[r]];return f()};t.exports=Object.create||function(t,e){var n;return null!==t?(c.prototype=r(t),n=new c,c.prototype=null,n[u]=t):n=f(),void 0===e?n:i(n,e)}},function(t,e,n){var r=n(4),i=n(5),o=n(40);t.exports=n(6)?Object.defineProperties:function(t,e){i(t);for(var n,u=o(e),c=u.length,f=0;c>f;)r.f(t,n=u[f++],e[n]);return t}},function(t,e,n){var r=n(41),i=n(25);t.exports=Object.keys||function(t){return r(t,i)}},function(t,e,n){var r=n(7),i=n(21),o=n(43)(!1),u=n(14)("IE_PROTO");t.exports=function(t,e){var n,c=i(t),f=0,a=[];for(n in c)n!=u&&r(c,n)&&a.push(n);for(;e.length>f;)r(c,n=e[f++])&&(~o(a,n)||a.push(n));return a}},function(t,e,n){var r=n(22);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==r(t)?t.split(""):Object(t)}},function(t,e,n){var r=n(21),i=n(23),o=n(44);t.exports=function(t){return function(e,n,u){var c,f=r(e),a=i(f.length),s=o(u,a);if(t&&n!=n){for(;a>s;)if((c=f[s++])!=c)return!0}else for(;a>s;s++)if((t||s in f)&&f[s]===n)return t||s||0;return!t&&-1}}},function(t,e,n){var r=n(8),i=Math.max,o=Math.min;t.exports=function(t,e){return t=r(t),t<0?i(t+e,0):o(t,e)}},function(t,e,n){var r=n(1).document;t.exports=r&&r.documentElement},function(t,e,n){var r=n(7),i=n(27),o=n(14)("IE_PROTO"),u=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=i(t),r(t,o)?t[o]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?u:null}},function(t,e,n){"use strict";var r=n(20),i=n(16),o=n(27),u=n(48),c=n(49),f=n(23),a=n(50),s=n(51);i(i.S+i.F*!n(53)(function(t){Array.from(t)}),"Array",{from:function(t){var e,n,i,l,p=o(t),h="function"==typeof this?this:Array,d=arguments.length,v=d>1?arguments[1]:void 0,y=void 0!==v,_=0,m=s(p);if(y&&(v=r(v,d>2?arguments[2]:void 0,2)),void 0==m||h==Array&&c(m))for(e=f(p.length),n=new h(e);e>_;_++)a(n,_,y?v(p[_],_):p[_]);else for(l=m.call(p),n=new h;!(i=l.next()).done;_++)a(n,_,y?u(l,v,[i.value,_],!0):i.value);return n.length=_,n}})},function(t,e,n){var r=n(5);t.exports=function(t,e,n,i){try{return i?e(r(n)[0],n[1]):e(n)}catch(e){var o=t.return;throw void 0!==o&&r(o.call(t)),e}}},function(t,e,n){var r=n(13),i=n(0)("iterator"),o=Array.prototype;t.exports=function(t){return void 0!==t&&(r.Array===t||o[i]===t)}},function(t,e,n){"use strict";var r=n(4),i=n(11);t.exports=function(t,e,n){e in t?r.f(t,e,i(0,n)):t[e]=n}},function(t,e,n){var r=n(52),i=n(0)("iterator"),o=n(13);t.exports=n(2).getIteratorMethod=function(t){if(void 0!=t)return t[i]||t["@@iterator"]||o[r(t)]}},function(t,e,n){var r=n(22),i=n(0)("toStringTag"),o="Arguments"==r(function(){return arguments}()),u=function(t,e){try{return t[e]}catch(t){}};t.exports=function(t){var e,n,c;return void 0===t?"Undefined":null===t?"Null":"string"==typeof(n=u(e=Object(t),i))?n:o?r(e):"Object"==(c=r(e))&&"function"==typeof e.callee?"Arguments":c}},function(t,e,n){var r=n(0)("iterator"),i=!1;try{var o=[7][r]();o.return=function(){i=!0},Array.from(o,function(){throw 2})}catch(t){}t.exports=function(t,e){if(!e&&!i)return!1;var n=!1;try{var o=[7],u=o[r]();u.next=function(){return{done:n=!0}},o[r]=function(){return u},t(o)}catch(t){}return n}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{default:t}}function i(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var o=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),u=n(55),c=r(u),f=n(56),a=r(f),s=n(57),l=r(s),p=n(58),h=r(p),d=n(59),v=r(d),y=Math.PI,_=Math.max,m=Math.min,g=function(){function t(e){i(this,t),this.element=e,this.originalHTML=this.element.innerHTML;var n=document.createElement("div");n.setAttribute("aria-label",e.innerText),n.style.position="relative",this.container=n,this._letters=(0,a.default)(e),this._letters.forEach(function(t){return n.appendChild(t)}),this.element.innerHTML="",this.element.appendChild(n);var r=window.getComputedStyle(this.element),o=r.fontSize,u=r.lineHeight;this._fontSize=parseFloat(o),this._lineHeight=parseFloat(u)||this._fontSize,this._metrics=this._letters.map(c.default);var f=this._metrics.reduce(function(t,e){return t+e.width},0);this._minRadius=f/y/2+this._lineHeight,this._dir=1,this._forceWidth=!1,this._forceHeight=!0,this._radius=this._minRadius,this._invalidate()}return o(t,[{key:"radius",value:function(t){return void 0!==t?(this._radius=_(this._minRadius,t),this._invalidate(),this):this._radius}},{key:"dir",value:function(t){return void 0!==t?(this._dir=t,this._invalidate(),this):this._dir}},{key:"forceWidth",value:function(t){return void 0!==t?(this._forceWidth=t,this._invalidate(),this):this._forceWidth}},{key:"forceHeight",value:function(t){return void 0!==t?(this._forceHeight=t,this._invalidate(),this):this._forceHeight}},{key:"refresh",value:function(){return this._invalidate()}},{key:"destroy",value:function(){return this.element.innerHTML=this.originalHTML,this}},{key:"_invalidate",value:function(){var t=this;return cancelAnimationFrame(this._raf),this._raf=requestAnimationFrame(function(){t._layout()}),this}},{key:"_layout",value:function(){var t=this,e=this._radius,n=this._dir,r=-1===n?-e+this._lineHeight:e,i="center "+r/this._fontSize+"em",o=e-this._lineHeight,u=(0,v.default)(this._metrics,o),c=u.rotations,f=u.θ;if(this._letters.forEach(function(e,r){var o=e.style,u=(-.5*f+c[r])*n,a=-.5*t._metrics[r].width/t._fontSize,s="translateX("+a+"em) rotate("+u+"deg)";o.position="absolute",o.bottom=-1===n?0:"auto",o.left="50%",o.transform=s,o.transformOrigin=i,o.webkitTransform=s,o.webkitTransformOrigin=i}),this._forceHeight){var a=f>180?(0,l.default)(e,f):(0,l.default)(o,f)+this._lineHeight;this.container.style.height=a/this._fontSize+"em"}if(this._forceWidth){var s=(0,h.default)(e,m(180,f));this.container.style.width=s/this._fontSize+"em"}return this}}]),t}();e.default=g},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(t){var e=t.getBoundingClientRect();return{height:e.height,left:e.left+window.pageXOffset,top:e.top+window.pageYOffset,width:e.width}}},function(t,e,n){"use strict";function r(t){if(Array.isArray(t)){for(var e=0,n=Array(t.length);e<t.length;e++)n[e]=t[e];return n}return Array.from(t)}Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"span",n=document.createElement(e);return[].concat(r(t.innerText.trim())).map(function(t){var e=n.cloneNode();return e.insertAdjacentHTML("afterbegin"," "===t?"&nbsp;":t),e})}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(28),i=function(t){return t&&t.__esModule?t:{default:t}}(r);e.default=function(t,e){return t*(1-Math.cos((0,i.default)(e/2)))}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(28),i=function(t){return t&&t.__esModule?t:{default:t}}(r);e.default=function(t,e){return 2*t*Math.sin((0,i.default)(e/2))}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=n(60),i=function(t){return t&&t.__esModule?t:{default:t}}(r);e.default=function(t,e){return t.reduce(function(t,n){var r=n.width,o=(0,i.default)(r/e);return{"θ":t.θ+o,rotations:t.rotations.concat([t.θ+o/2])}},{"θ":0,rotations:[]})}},function(t,e,n){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var r=180/Math.PI;e.default=function(t){return t*r}}])});

/***/ }),
/* 107 */
/***/ (function(module, exports) {

	/*!
	 * cookie
	 * Copyright(c) 2012-2014 Roman Shtylman
	 * Copyright(c) 2015 Douglas Christopher Wilson
	 * MIT Licensed
	 */
	
	'use strict';
	
	/**
	 * Module exports.
	 * @public
	 */
	
	exports.parse = parse;
	exports.serialize = serialize;
	
	/**
	 * Module variables.
	 * @private
	 */
	
	var decode = decodeURIComponent;
	var encode = encodeURIComponent;
	var pairSplitRegExp = /; */;
	
	/**
	 * RegExp to match field-content in RFC 7230 sec 3.2
	 *
	 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
	 * field-vchar   = VCHAR / obs-text
	 * obs-text      = %x80-FF
	 */
	
	var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
	
	/**
	 * Parse a cookie header.
	 *
	 * Parse the given cookie header string into an object
	 * The object has the various cookies as keys(names) => values
	 *
	 * @param {string} str
	 * @param {object} [options]
	 * @return {object}
	 * @public
	 */
	
	function parse(str, options) {
	  if (typeof str !== 'string') {
	    throw new TypeError('argument str must be a string');
	  }
	
	  var obj = {}
	  var opt = options || {};
	  var pairs = str.split(pairSplitRegExp);
	  var dec = opt.decode || decode;
	
	  for (var i = 0; i < pairs.length; i++) {
	    var pair = pairs[i];
	    var eq_idx = pair.indexOf('=');
	
	    // skip things that don't look like key=value
	    if (eq_idx < 0) {
	      continue;
	    }
	
	    var key = pair.substr(0, eq_idx).trim()
	    var val = pair.substr(++eq_idx, pair.length).trim();
	
	    // quoted values
	    if ('"' == val[0]) {
	      val = val.slice(1, -1);
	    }
	
	    // only assign once
	    if (undefined == obj[key]) {
	      obj[key] = tryDecode(val, dec);
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Serialize data into a cookie header.
	 *
	 * Serialize the a name value pair into a cookie string suitable for
	 * http headers. An optional options object specified cookie parameters.
	 *
	 * serialize('foo', 'bar', { httpOnly: true })
	 *   => "foo=bar; httpOnly"
	 *
	 * @param {string} name
	 * @param {string} val
	 * @param {object} [options]
	 * @return {string}
	 * @public
	 */
	
	function serialize(name, val, options) {
	  var opt = options || {};
	  var enc = opt.encode || encode;
	
	  if (typeof enc !== 'function') {
	    throw new TypeError('option encode is invalid');
	  }
	
	  if (!fieldContentRegExp.test(name)) {
	    throw new TypeError('argument name is invalid');
	  }
	
	  var value = enc(val);
	
	  if (value && !fieldContentRegExp.test(value)) {
	    throw new TypeError('argument val is invalid');
	  }
	
	  var str = name + '=' + value;
	
	  if (null != opt.maxAge) {
	    var maxAge = opt.maxAge - 0;
	    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
	    str += '; Max-Age=' + Math.floor(maxAge);
	  }
	
	  if (opt.domain) {
	    if (!fieldContentRegExp.test(opt.domain)) {
	      throw new TypeError('option domain is invalid');
	    }
	
	    str += '; Domain=' + opt.domain;
	  }
	
	  if (opt.path) {
	    if (!fieldContentRegExp.test(opt.path)) {
	      throw new TypeError('option path is invalid');
	    }
	
	    str += '; Path=' + opt.path;
	  }
	
	  if (opt.expires) {
	    if (typeof opt.expires.toUTCString !== 'function') {
	      throw new TypeError('option expires is invalid');
	    }
	
	    str += '; Expires=' + opt.expires.toUTCString();
	  }
	
	  if (opt.httpOnly) {
	    str += '; HttpOnly';
	  }
	
	  if (opt.secure) {
	    str += '; Secure';
	  }
	
	  if (opt.sameSite) {
	    var sameSite = typeof opt.sameSite === 'string'
	      ? opt.sameSite.toLowerCase() : opt.sameSite;
	
	    switch (sameSite) {
	      case true:
	        str += '; SameSite=Strict';
	        break;
	      case 'lax':
	        str += '; SameSite=Lax';
	        break;
	      case 'strict':
	        str += '; SameSite=Strict';
	        break;
	      default:
	        throw new TypeError('option sameSite is invalid');
	    }
	  }
	
	  return str;
	}
	
	/**
	 * Try decoding a string using a decoding function.
	 *
	 * @param {string} str
	 * @param {function} decode
	 * @private
	 */
	
	function tryDecode(str, decode) {
	  try {
	    return decode(str);
	  } catch (e) {
	    return str;
	  }
	}


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(132);
	module.exports = __webpack_require__(32).Object.assign;


/***/ }),
/* 109 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(35);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(60);
	var toLength = __webpack_require__(129);
	var toAbsoluteIndex = __webpack_require__(128);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 112 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(109);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(35);
	var document = __webpack_require__(24).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 115 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(24);
	var core = __webpack_require__(32);
	var hide = __webpack_require__(57);
	var redefine = __webpack_require__(125);
	var ctx = __webpack_require__(113);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(33) && !__webpack_require__(34)(function () {
	  return Object.defineProperty(__webpack_require__(114)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(122);
	var gOPS = __webpack_require__(120);
	var pIE = __webpack_require__(123);
	var toObject = __webpack_require__(130);
	var IObject = __webpack_require__(58);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(34)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(110);
	var IE8_DOM_DEFINE = __webpack_require__(117);
	var toPrimitive = __webpack_require__(131);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(33) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 120 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(56);
	var toIObject = __webpack_require__(60);
	var arrayIndexOf = __webpack_require__(111)(false);
	var IE_PROTO = __webpack_require__(126)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(121);
	var enumBugKeys = __webpack_require__(115);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 123 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 124 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(24);
	var hide = __webpack_require__(57);
	var has = __webpack_require__(56);
	var SRC = __webpack_require__(61)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(32).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(127)('keys');
	var uid = __webpack_require__(61);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(24);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(59);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(59);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(55);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(35);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(116);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(118) });


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var emptyObject = __webpack_require__(25);
	var _invariant = __webpack_require__(1);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 134 */
/***/ (function(module, exports) {

	(function(self) {
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob();
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  };
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ];
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    };
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    };
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name);
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value);
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift();
	        return {done: value === undefined, value: value}
	      }
	    };
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      };
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {};
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value);
	      }, this);
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1]);
	      }, this);
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name]);
	      }, this);
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name);
	    value = normalizeValue(value);
	    var oldValue = this.map[name];
	    this.map[name] = oldValue ? oldValue+','+value : value;
	  };
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)];
	  };
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name);
	    return this.has(name) ? this.map[name] : null
	  };
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  };
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value);
	  };
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this);
	      }
	    }
	  };
	
	  Headers.prototype.keys = function() {
	    var items = [];
	    this.forEach(function(value, name) { items.push(name); });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.values = function() {
	    var items = [];
	    this.forEach(function(value) { items.push(value); });
	    return iteratorFor(items)
	  };
	
	  Headers.prototype.entries = function() {
	    var items = [];
	    this.forEach(function(value, name) { items.push([name, value]); });
	    return iteratorFor(items)
	  };
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true;
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result);
	      };
	      reader.onerror = function() {
	        reject(reader.error);
	      };
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsArrayBuffer(blob);
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader();
	    var promise = fileReaderReady(reader);
	    reader.readAsText(blob);
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf);
	    var chars = new Array(view.length);
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i]);
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength);
	      view.set(new Uint8Array(buf));
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false;
	
	    this._initBody = function(body) {
	      this._bodyInit = body;
	      if (!body) {
	        this._bodyText = '';
	      } else if (typeof body === 'string') {
	        this._bodyText = body;
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body;
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body;
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString();
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer);
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer]);
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body);
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8');
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type);
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
	        }
	      }
	    };
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this);
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      };
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      };
	    }
	
	    this.text = function() {
	      var rejected = consumed(this);
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    };
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      };
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    };
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase();
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {};
	    var body = options.body;
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url;
	      this.credentials = input.credentials;
	      if (!options.headers) {
	        this.headers = new Headers(input.headers);
	      }
	      this.method = input.method;
	      this.mode = input.mode;
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit;
	        input.bodyUsed = true;
	      }
	    } else {
	      this.url = String(input);
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit';
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers);
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET');
	    this.mode = options.mode || this.mode || null;
	    this.referrer = null;
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body);
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  };
	
	  function decode(body) {
	    var form = new FormData();
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=');
	        var name = split.shift().replace(/\+/g, ' ');
	        var value = split.join('=').replace(/\+/g, ' ');
	        form.append(decodeURIComponent(name), decodeURIComponent(value));
	      }
	    });
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers();
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':');
	      var key = parts.shift().trim();
	      if (key) {
	        var value = parts.join(':').trim();
	        headers.append(key, value);
	      }
	    });
	    return headers
	  }
	
	  Body.call(Request.prototype);
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {};
	    }
	
	    this.type = 'default';
	    this.status = options.status === undefined ? 200 : options.status;
	    this.ok = this.status >= 200 && this.status < 300;
	    this.statusText = 'statusText' in options ? options.statusText : 'OK';
	    this.headers = new Headers(options.headers);
	    this.url = options.url || '';
	    this._initBody(bodyInit);
	  }
	
	  Body.call(Response.prototype);
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  };
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''});
	    response.type = 'error';
	    return response
	  };
	
	  var redirectStatuses = [301, 302, 303, 307, 308];
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  };
	
	  self.Headers = Headers;
	  self.Request = Request;
	  self.Response = Response;
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init);
	      var xhr = new XMLHttpRequest();
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        };
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
	        var body = 'response' in xhr ? xhr.response : xhr.responseText;
	        resolve(new Response(body, options));
	      };
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'));
	      };
	
	      xhr.open(request.method, request.url, true);
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true;
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false;
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob';
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value);
	      });
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
	    })
	  };
	  self.fetch.polyfill = true;
	})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(136)();
	// imports
	
	
	// module
	exports.push([module.id, "html{box-sizing:border-box}*,:after,:before{box-sizing:inherit}body,html{height:100%}div{position:relative}.clear{clear:both}.aligncenter{display:block;margin:0 auto}.text-center{text-align:center}.text-right{text-align:right}.pull-left{float:left}.pull-right{float:right}img{max-width:100%}img.alignleft{margin-right:1em;margin-bottom:1.8em}img.alignright{margin-left:1em;margin-bottom:1.8em}ul{list-style:none!important;margin:0!important;padding:0!important}.half{width:45%}ul.unstyled{list-style-type:none}.hide{visibility:hidden;width:0!important;height:0!important;line-height:0!important;padding:0!important;margin:0!important}*,address,blockquote,body,caption,cite,code,dd,dfn,div,dl,dt,em,fieldset,form,h1,h2,h3,h4,h5,h6,html,input,label,li,ol,p,pre,strong,td,th,ul,var{margin:0;padding:0;border:0;font-family:inherit}article,aside,details,div,figcaption,figure,footer,header,hgroup,main,nav,section,summary{display:block}table{border-collapse:collapse;border-spacing:0}fieldset,img{border:0}img{-ms-interpolation-mode:bicubic;vertical-align:top}q:after,q:before{content:\"\"}html{overflow-y:scroll;font-size:100%;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}strong{font-weight:700}em{font-style:italic}a img{border:none}audio,canvas,video{display:inline-block;*display:inline;*zoom:1}audio:not([controls]){display:none}button,input,select,textarea{font-size:100%;margin:0;vertical-align:baseline;*vertical-align:middle}button,input{line-height:normal;*overflow:visible}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}button,input[type=button],input[type=reset],input[type=submit]{cursor:pointer;-webkit-appearance:button}input[type=search]{-webkit-appearance:textfield}input[type=search]::-webkit-search-decoration{-webkit-appearance:none}textarea{overflow:auto;vertical-align:top}.alert{background:red;color:#fff}img[data-sizes=auto]{display:block;width:100%}::-moz-selection{color:#fff;background:#26418a}::selection{color:#fff;background:#26418a}@font-face{font-family:liberation_monoregular;src:url(" + __webpack_require__(236) + ") format(\"woff\");font-weight:400;font-style:normal}body{color:#fff;font-family:liberation_monoregular;letter-spacing:.04em;font-size:20px}body,h1,h2,h3{font-weight:400;line-height:1.23em}h1,h2,h3{font-size:20px!important}input{font-size:20px;line-height:1.23em}input[type=text]{margin-right:1em}a{text-decoration:none;color:#fff}a:hover{color:#colorSecondary}.skills,accr,header li{color:#26418a}@media only screen and (max-width:768px){body,h1,h2,h3{font-size:16px!important}}.container-fluid{margin-right:auto;margin-left:auto;padding-right:60px;padding-left:60px}.row{box-sizing:border-box;display:-moz-flex;display:-ms-flexbox;display:flex;-moz-flex:0 1 auto;-ms-flex:0 1 auto;flex:0 1 auto;-moz-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-30px;margin-left:-30px}.row.reverse{-moz-flex-direction:row-reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.col.reverse{-moz-flex-direction:column-reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}.col-xs{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:auto;flex-basis:auto}.col-xs,.col-xs-1{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-xs-1{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:8.33333%;flex-basis:8.33333%;max-width:8.33333%}.col-xs-2{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:16.66667%;flex-basis:16.66667%;max-width:16.66667%}.col-xs-2,.col-xs-3{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-xs-3{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-xs-4{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:33.33333%;flex-basis:33.33333%;max-width:33.33333%}.col-xs-4,.col-xs-5{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-xs-5{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:41.66667%;flex-basis:41.66667%;max-width:41.66667%}.col-xs-6{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-xs-6,.col-xs-7{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-xs-7{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:58.33333%;flex-basis:58.33333%;max-width:58.33333%}.col-xs-8{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:66.66667%;flex-basis:66.66667%;max-width:66.66667%}.col-xs-8,.col-xs-9{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-xs-9{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-xs-10{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:83.33333%;flex-basis:83.33333%;max-width:83.33333%}.col-xs-10,.col-xs-11{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-xs-11{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:91.66667%;flex-basis:91.66667%;max-width:91.66667%}.col-xs-12{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.col-xs-12,.col-xs-offset-1{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-xs-offset-1{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;margin-left:8.33333%}.col-xs-offset-2{margin-left:16.66667%}.col-xs-offset-2,.col-xs-offset-3{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px}.col-xs-offset-3{margin-left:25%}.col-xs-offset-4{margin-left:33.33333%}.col-xs-offset-4,.col-xs-offset-5{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px}.col-xs-offset-5{margin-left:41.66667%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-6,.col-xs-offset-7{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px}.col-xs-offset-7{margin-left:58.33333%}.col-xs-offset-8{margin-left:66.66667%}.col-xs-offset-8,.col-xs-offset-9{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px}.col-xs-offset-9{margin-left:75%}.col-xs-offset-10{margin-left:83.33333%}.col-xs-offset-10,.col-xs-offset-11{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px}.col-xs-offset-11{margin-left:91.66667%}.col-xs-offset-12{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px;margin-left:100%}.col-xs{-moz-flex-grow:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}.start-xs{-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;text-align:start}.center-xs{-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;text-align:center}.end-xs{-ms-flex-pack:end;-moz-justify-content:flex-end;justify-content:flex-end;text-align:end}.top-xs{-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start}.middle-xs{-ms-flex-align:center;-moz-align-items:center;align-items:center}.bottom-xs{-ms-flex-align:end;-moz-align-items:flex-end;align-items:flex-end}.around-xs{-ms-flex-pack:distribute;-moz-justify-content:space-around;justify-content:space-around}.between-xs{-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between}.first-xs{order:-1}.last-xs{order:1}@media only screen and (min-width:320px){.container{width:46em}.col-sm{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:auto;flex-basis:auto}.col-sm,.col-sm-1{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-sm-1{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:8.33333%;flex-basis:8.33333%;max-width:8.33333%}.col-sm-2{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:16.66667%;flex-basis:16.66667%;max-width:16.66667%}.col-sm-2,.col-sm-3{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-sm-3{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-sm-4{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:33.33333%;flex-basis:33.33333%;max-width:33.33333%}.col-sm-4,.col-sm-5{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-sm-5{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:41.66667%;flex-basis:41.66667%;max-width:41.66667%}.col-sm-6{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-sm-6,.col-sm-7{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-sm-7{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:58.33333%;flex-basis:58.33333%;max-width:58.33333%}.col-sm-8{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:66.66667%;flex-basis:66.66667%;max-width:66.66667%}.col-sm-8,.col-sm-9{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-sm-9{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-sm-10{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:83.33333%;flex-basis:83.33333%;max-width:83.33333%}.col-sm-10,.col-sm-11{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-sm-11{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:91.66667%;flex-basis:91.66667%;max-width:91.66667%}.col-sm-12{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.col-sm-12,.col-sm-offset-1{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-sm-offset-1{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;margin-left:8.33333%}.col-sm-offset-2{margin-left:16.66667%}.col-sm-offset-2,.col-sm-offset-3{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px}.col-sm-offset-3{margin-left:25%}.col-sm-offset-4{margin-left:33.33333%}.col-sm-offset-4,.col-sm-offset-5{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px}.col-sm-offset-5{margin-left:41.66667%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-6,.col-sm-offset-7{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px}.col-sm-offset-7{margin-left:58.33333%}.col-sm-offset-8{margin-left:66.66667%}.col-sm-offset-8,.col-sm-offset-9{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px}.col-sm-offset-9{margin-left:75%}.col-sm-offset-10{margin-left:83.33333%}.col-sm-offset-10,.col-sm-offset-11{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px}.col-sm-offset-11{margin-left:91.66667%}.col-sm-offset-12{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px;margin-left:100%}.col-sm{-moz-flex-grow:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}.start-sm{-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;text-align:start}.center-sm{-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;text-align:center}.end-sm{-ms-flex-pack:end;-moz-justify-content:flex-end;justify-content:flex-end;text-align:end}.top-sm{-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start}.middle-sm{-ms-flex-align:center;-moz-align-items:center;align-items:center}.bottom-sm{-ms-flex-align:end;-moz-align-items:flex-end;align-items:flex-end}.around-sm{-ms-flex-pack:distribute;-moz-justify-content:space-around;justify-content:space-around}.between-sm{-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between}.first-sm{order:-1}.last-sm{order:1}}@media only screen and (min-width:992px){.container{width:61em}.col-md{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:auto;flex-basis:auto}.col-md,.col-md-1{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-md-1{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:8.33333%;flex-basis:8.33333%;max-width:8.33333%}.col-md-2{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:16.66667%;flex-basis:16.66667%;max-width:16.66667%}.col-md-2,.col-md-3{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-md-3{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-md-4{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:33.33333%;flex-basis:33.33333%;max-width:33.33333%}.col-md-4,.col-md-5{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-md-5{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:41.66667%;flex-basis:41.66667%;max-width:41.66667%}.col-md-6{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-md-6,.col-md-7{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-md-7{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:58.33333%;flex-basis:58.33333%;max-width:58.33333%}.col-md-8{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:66.66667%;flex-basis:66.66667%;max-width:66.66667%}.col-md-8,.col-md-9{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-md-9{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-md-10{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:83.33333%;flex-basis:83.33333%;max-width:83.33333%}.col-md-10,.col-md-11{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-md-11{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:91.66667%;flex-basis:91.66667%;max-width:91.66667%}.col-md-12{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.col-md-12,.col-md-offset-1{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-md-offset-1{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;margin-left:8.33333%}.col-md-offset-2{margin-left:16.66667%}.col-md-offset-2,.col-md-offset-3{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px}.col-md-offset-3{margin-left:25%}.col-md-offset-4{margin-left:33.33333%}.col-md-offset-4,.col-md-offset-5{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px}.col-md-offset-5{margin-left:41.66667%}.col-md-offset-6{margin-left:50%}.col-md-offset-6,.col-md-offset-7{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px}.col-md-offset-7{margin-left:58.33333%}.col-md-offset-8{margin-left:66.66667%}.col-md-offset-8,.col-md-offset-9{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px}.col-md-offset-9{margin-left:75%}.col-md-offset-10{margin-left:83.33333%}.col-md-offset-10,.col-md-offset-11{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px}.col-md-offset-11{margin-left:91.66667%}.col-md-offset-12{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px;margin-left:100%}.col-md{-moz-flex-grow:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}.start-md{-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;text-align:start}.center-md{-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;text-align:center}.end-md{-ms-flex-pack:end;-moz-justify-content:flex-end;justify-content:flex-end;text-align:end}.top-md{-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start}.middle-md{-ms-flex-align:center;-moz-align-items:center;align-items:center}.bottom-md{-ms-flex-align:end;-moz-align-items:flex-end;align-items:flex-end}.around-md{-ms-flex-pack:distribute;-moz-justify-content:space-around;justify-content:space-around}.between-md{-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between}.first-md{order:-1}.last-md{order:1}}@media only screen and (min-width:1441px){.container{width:71em}.col-lg{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:auto;flex-basis:auto}.col-lg,.col-lg-1{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-lg-1{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:8.33333%;flex-basis:8.33333%;max-width:8.33333%}.col-lg-2{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:16.66667%;flex-basis:16.66667%;max-width:16.66667%}.col-lg-2,.col-lg-3{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-lg-3{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}.col-lg-4{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:33.33333%;flex-basis:33.33333%;max-width:33.33333%}.col-lg-4,.col-lg-5{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-lg-5{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:41.66667%;flex-basis:41.66667%;max-width:41.66667%}.col-lg-6{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.col-lg-6,.col-lg-7{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-lg-7{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:58.33333%;flex-basis:58.33333%;max-width:58.33333%}.col-lg-8{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:66.66667%;flex-basis:66.66667%;max-width:66.66667%}.col-lg-8,.col-lg-9{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-lg-9{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.col-lg-10{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:83.33333%;flex-basis:83.33333%;max-width:83.33333%}.col-lg-10,.col-lg-11{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-lg-11{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:91.66667%;flex-basis:91.66667%;max-width:91.66667%}.col-lg-12{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.col-lg-12,.col-lg-offset-1{box-sizing:border-box;padding-right:30px;padding-left:30px}.col-lg-offset-1{-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;margin-left:8.33333%}.col-lg-offset-2{margin-left:16.66667%}.col-lg-offset-2,.col-lg-offset-3{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px}.col-lg-offset-3{margin-left:25%}.col-lg-offset-4{margin-left:33.33333%}.col-lg-offset-4,.col-lg-offset-5{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px}.col-lg-offset-5{margin-left:41.66667%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-6,.col-lg-offset-7{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px}.col-lg-offset-7{margin-left:58.33333%}.col-lg-offset-8{margin-left:66.66667%}.col-lg-offset-8,.col-lg-offset-9{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px}.col-lg-offset-9{margin-left:75%}.col-lg-offset-10{margin-left:83.33333%}.col-lg-offset-10,.col-lg-offset-11{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px}.col-lg-offset-11{margin-left:91.66667%}.col-lg-offset-12{box-sizing:border-box;-moz-flex-grow:0;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;padding-right:30px;padding-left:30px;margin-left:100%}.col-lg{-moz-flex-grow:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}.start-lg{-ms-flex-pack:start;-moz-justify-content:flex-start;justify-content:flex-start;text-align:start}.center-lg{-ms-flex-pack:center;-moz-justify-content:center;justify-content:center;text-align:center}.end-lg{-ms-flex-pack:end;-moz-justify-content:flex-end;justify-content:flex-end;text-align:end}.top-lg{-ms-flex-align:start;-moz-align-items:flex-start;align-items:flex-start}.middle-lg{-ms-flex-align:center;-moz-align-items:center;align-items:center}.bottom-lg{-ms-flex-align:end;-moz-align-items:flex-end;align-items:flex-end}.around-lg{-ms-flex-pack:distribute;-moz-justify-content:space-around;justify-content:space-around}.between-lg{-ms-flex-pack:justify;-moz-justify-content:space-between;justify-content:space-between}.first-lg{order:-1}.last-lg{order:1}}body,html{margin:0;padding:0}.row{margin:0}#page{padding:0;min-height:100vh;background-color:#fff}#page li{margin-bottom:.2em}#page .projects{padding:30px}#page .infos{background-color:#fff}#page .infos a,#page .infos h1{color:#26418a}#page .projects{background-color:#26418a;font-weight:100;min-height:100vh}@media screen and (max-device-width:768px){#page{padding-top:281px}#page header{width:100%;top:0;left:0}#page header h1{margin-bottom:22.2px}#page header h1 .logo{margin-right:11px}#page header .skills ul{flex-direction:row;flex-wrap:wrap}#page .projects,#page header{padding:20px}#page .projects{width:100vw}#page img{display:none!important}}header{display:flex;flex-direction:column;position:fixed;left:0;width:50%;padding:30px}header h1{margin-bottom:32px}header h1 .logo{margin-right:14px}header a:hover{cursor:url(" + __webpack_require__(94) + ") 31 23,auto}header .connecteurs,header .itw,header .skills{display:flex}header .connecteurs accr,header .itw accr,header .skills accr{margin-right:15px}header .connecteurs ul,header .itw ul,header .skills ul{display:flex}header .connecteurs ul li,header .itw ul li,header .skills ul li{padding-right:.5em}header .skills{margin-bottom:32px}header .skills ul{flex-wrap:wrap}header .skills ul li{padding-right:0;cursor:pointer}header .skills ul li:after{content:\"\\2014\";display:inline-block;margin:0 5px}header .skills ul li:last-child:after{content:\"\"}header .itw ul{display:block}.project-component{position:relative;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.project-component sup{font-size:.6em;vertical-align:baseline;margin-right:10px}.project-component .project-name{margin-right:.5em}.project-component .skill{opacity:1}.project-component img{position:absolute;display:none;pointer-events:none;right:0;top:0}.project-component:hover{z-index:255}.project-component:hover img{display:block}.project-component a:hover{cursor:url(" + __webpack_require__(94) + ") 31 23,auto}.followmouse-component,.skill-component{display:inline-block}.overlay{position:fixed;width:100%;height:100%;top:0;background-color:#f5f5f5;z-index:250;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:center;-moz-justify-content:center;-ms-flex-align:center;-moz-align-items:center}#smile-wrap,.overlay{justify-content:center;align-items:center}#smile-wrap{font-family:helvetica;color:#000;width:90vh;height:90vh;text-align:center;position:relative;background:#fff;border-radius:100%;display:flex}#smile-wrap .inner{width:80%;height:50%}#smile-wrap .eyes{display:flex;justify-content:space-around;margin-bottom:150px}#smile-wrap .noze{width:180px;margin:0 auto;margin-bottom:250px}#smile-wrap #smile-component{position:absolute;bottom:0;left:0;width:100%}#smile-wrap .jauge{text-align:right;padding:1em;position:fixed;width:100%;height:100%;left:0;bottom:0;z-index:-1;display:-moz-flex;display:-ms-flexbox;display:flex;-ms-flex-pack:end;-moz-justify-content:flex-end;justify-content:flex-end}#smile-wrap .jauge .value{margin-right:.5em}#smile-wrap .detector-component{display:none}@media screen and (max-device-width:768px){#smile-wrap{font-family:helvetica;font-size:.7em;line-height:1em;width:90vw;height:50vh}#smile-wrap .inner{height:50%}#smile-wrap .inner .eyes{margin-bottom:60px}}", ""]);
	
	// exports


/***/ }),
/* 136 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(137);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(147);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(6);
	
	var createArrayFromMixed = __webpack_require__(140);
	var getMarkupWrap = __webpack_require__(142);
	var invariant = __webpack_require__(1);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(6);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(144);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ }),
/* 146 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(146);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * VERSION: 1.20.4
	 * DATE: 2018-02-15
	 * UPDATES AND DOCS AT: http://greensock.com
	 * 
	 * Includes all of the following: TweenLite, TweenMax, TimelineLite, TimelineMax, EasePack, CSSPlugin, RoundPropsPlugin, BezierPlugin, AttrPlugin, DirectionalRotationPlugin
	 *
	 * @license Copyright (c) 2008-2018, GreenSock. All rights reserved.
	 * This work is subject to the terms at http://greensock.com/standard-license or for
	 * Club GreenSock members, the software agreement that was issued with your membership.
	 * 
	 * @author: Jack Doyle, jack@greensock.com
	 **/
	var _gsScope = (typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window; //helps ensure compatibility with AMD/RequireJS and CommonJS/Node
	(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push( function() {
	
		"use strict";
	
		_gsScope._gsDefine("TweenMax", ["core.Animation","core.SimpleTimeline","TweenLite"], function(Animation, SimpleTimeline, TweenLite) {
	
			var _slice = function(a) { //don't use [].slice because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++]));
					return b;
				},
				_applyCycle = function(vars, targets, i) {
					var alt = vars.cycle,
						p, val;
					for (p in alt) {
						val = alt[p];
						vars[p] = (typeof(val) === "function") ? val(i, targets[i]) : val[i % val.length];
					}
					delete vars.cycle;
				},
				TweenMax = function(target, duration, vars) {
					TweenLite.call(this, target, duration, vars);
					this._cycle = 0;
					this._yoyo = (this.vars.yoyo === true || !!this.vars.yoyoEase);
					this._repeat = this.vars.repeat || 0;
					this._repeatDelay = this.vars.repeatDelay || 0;
					if (this._repeat) {
						this._uncache(true); //ensures that if there is any repeat, the totalDuration will get recalculated to accurately report it.
					}
					this.render = TweenMax.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)
				},
				_tinyNum = 0.0000000001,
				TweenLiteInternals = TweenLite._internals,
				_isSelector = TweenLiteInternals.isSelector,
				_isArray = TweenLiteInternals.isArray,
				p = TweenMax.prototype = TweenLite.to({}, 0.1, {}),
				_blankArray = [];
	
			TweenMax.version = "1.20.4";
			p.constructor = TweenMax;
			p.kill()._gc = false;
			TweenMax.killTweensOf = TweenMax.killDelayedCallsTo = TweenLite.killTweensOf;
			TweenMax.getTweensOf = TweenLite.getTweensOf;
			TweenMax.lagSmoothing = TweenLite.lagSmoothing;
			TweenMax.ticker = TweenLite.ticker;
			TweenMax.render = TweenLite.render;
	
			p.invalidate = function() {
				this._yoyo = (this.vars.yoyo === true || !!this.vars.yoyoEase);
				this._repeat = this.vars.repeat || 0;
				this._repeatDelay = this.vars.repeatDelay || 0;
				this._yoyoEase = null;
				this._uncache(true);
				return TweenLite.prototype.invalidate.call(this);
			};
			
			p.updateTo = function(vars, resetDuration) {
				var curRatio = this.ratio,
					immediate = this.vars.immediateRender || vars.immediateRender,
					p;
				if (resetDuration && this._startTime < this._timeline._time) {
					this._startTime = this._timeline._time;
					this._uncache(false);
					if (this._gc) {
						this._enabled(true, false);
					} else {
						this._timeline.insert(this, this._startTime - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
					}
				}
				for (p in vars) {
					this.vars[p] = vars[p];
				}
				if (this._initted || immediate) {
					if (resetDuration) {
						this._initted = false;
						if (immediate) {
							this.render(0, true, true);
						}
					} else {
						if (this._gc) {
							this._enabled(true, false);
						}
						if (this._notifyPluginsOfEnabled && this._firstPT) {
							TweenLite._onPluginEvent("_onDisable", this); //in case a plugin like MotionBlur must perform some cleanup tasks
						}
						if (this._time / this._duration > 0.998) { //if the tween has finished (or come extremely close to finishing), we just need to rewind it to 0 and then render it again at the end which forces it to re-initialize (parsing the new vars). We allow tweens that are close to finishing (but haven't quite finished) to work this way too because otherwise, the values are so small when determining where to project the starting values that binary math issues creep in and can make the tween appear to render incorrectly when run backwards. 
							var prevTime = this._totalTime;
							this.render(0, true, false);
							this._initted = false;
							this.render(prevTime, true, false);
						} else {
							this._initted = false;
							this._init();
							if (this._time > 0 || immediate) {
								var inv = 1 / (1 - curRatio),
									pt = this._firstPT, endValue;
								while (pt) {
									endValue = pt.s + pt.c;
									pt.c *= inv;
									pt.s = endValue - pt.c;
									pt = pt._next;
								}
							}
						}
					}
				}
				return this;
			};
					
			p.render = function(time, suppressEvents, force) {
				if (!this._initted) if (this._duration === 0 && this.vars.repeat) { //zero duration tweens that render immediately have render() called from TweenLite's constructor, before TweenMax's constructor has finished setting _repeat, _repeatDelay, and _yoyo which are critical in determining totalDuration() so we need to call invalidate() which is a low-kb way to get those set properly.
					this.invalidate();
				}
				var totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
					prevTime = this._time,
					prevTotalTime = this._totalTime, 
					prevCycle = this._cycle,
					duration = this._duration,
					prevRawPrevTime = this._rawPrevTime,
					isComplete, callback, pt, cycleDuration, r, type, pow, rawPrevTime, yoyoEase;
				if (time >= totalDur - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
					this._totalTime = totalDur;
					this._cycle = this._repeat;
					if (this._yoyo && (this._cycle & 1) !== 0) {
						this._time = 0;
						this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					} else {
						this._time = duration;
						this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1;
					}
					if (!this._reversed) {
						isComplete = true;
						callback = "onComplete";
						force = (force || this._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
					}
					if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (this._startTime === this._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
							time = 0;
						}
						if (prevRawPrevTime < 0 || (time <= 0 && time >= -0.0000001) || (prevRawPrevTime === _tinyNum && this.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
							force = true;
							if (prevRawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
						this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
					
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = this._cycle = 0;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					if (prevTotalTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
							if (prevRawPrevTime >= 0) {
								force = true;
							}
							this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						}
					}
					if (!this._initted) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
						force = true;
					}
				} else {
					this._totalTime = this._time = time;
					if (this._repeat !== 0) {
						cycleDuration = duration + this._repeatDelay;
						this._cycle = (this._totalTime / cycleDuration) >> 0; //originally _totalTime % cycleDuration but floating point errors caused problems, so I normalized it. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
						if (this._cycle !== 0) if (this._cycle === this._totalTime / cycleDuration && prevTotalTime <= time) {
							this._cycle--; //otherwise when rendered exactly at the end time, it will act as though it is repeating (at the beginning)
						}
						this._time = this._totalTime - (this._cycle * cycleDuration);
						if (this._yoyo) if ((this._cycle & 1) !== 0) {
							this._time = duration - this._time;
							yoyoEase = this._yoyoEase || this.vars.yoyoEase; //note: we don't set this._yoyoEase in _init() like we do other properties because it's TweenMax-specific and doing it here allows us to optimize performance (most tweens don't have a yoyoEase). Note that we also must skip the this.ratio calculation further down right after we _init() in this function, because we're doing it here.
							if (yoyoEase) {
								if (!this._yoyoEase) {
									if (yoyoEase === true && !this._initted) { //if it's not initted and yoyoEase is true, this._ease won't have been populated yet so we must discern it here.
										yoyoEase = this.vars.ease;
										this._yoyoEase = yoyoEase = !yoyoEase ? TweenLite.defaultEase : (yoyoEase instanceof Ease) ? yoyoEase : (typeof(yoyoEase) === "function") ? new Ease(yoyoEase, this.vars.easeParams) : Ease.map[yoyoEase] || TweenLite.defaultEase;
									} else {
										this._yoyoEase = yoyoEase = (yoyoEase === true) ? this._ease : (yoyoEase instanceof Ease) ? yoyoEase : Ease.map[yoyoEase];
									}
								}
								this.ratio = yoyoEase ? 1 - yoyoEase.getRatio((duration - this._time) / duration) : 0;
							}
						}
						if (this._time > duration) {
							this._time = duration;
						} else if (this._time < 0) {
							this._time = 0;
						}
					}
					if (this._easeType && !yoyoEase) {
						r = this._time / duration;
						type = this._easeType;
						pow = this._easePower;
						if (type === 1 || (type === 3 && r >= 0.5)) {
							r = 1 - r;
						}
						if (type === 3) {
							r *= 2;
						}
						if (pow === 1) {
							r *= r;
						} else if (pow === 2) {
							r *= r * r;
						} else if (pow === 3) {
							r *= r * r * r;
						} else if (pow === 4) {
							r *= r * r * r * r;
						}
	
						if (type === 1) {
							this.ratio = 1 - r;
						} else if (type === 2) {
							this.ratio = r;
						} else if (this._time / duration < 0.5) {
							this.ratio = r / 2;
						} else {
							this.ratio = 1 - (r / 2);
						}
	
					} else if (!yoyoEase) {
						this.ratio = this._ease.getRatio(this._time / duration);
					}
					
				}
					
				if (prevTime === this._time && !force && prevCycle === this._cycle) {
					if (prevTotalTime !== this._totalTime) if (this._onUpdate) if (!suppressEvents) { //so that onUpdate fires even during the repeatDelay - as long as the totalTime changed, we should trigger onUpdate.
						this._callback("onUpdate");
					}
					return;
				} else if (!this._initted) {
					this._init();
					if (!this._initted || this._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
						return;
					} else if (!force && this._firstPT && ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration))) { //we stick it in the queue for rendering at the very end of the tick - this is a performance optimization because browsers invalidate styles and force a recalculation if you read, write, and then read style data (so it's better to read/read/read/write/write/write than read/write/read/write/read/write). The down side, of course, is that usually you WANT things to render immediately because you may have code running right after that which depends on the change. Like imagine running TweenLite.set(...) and then immediately after that, creating a nother tween that animates the same property to another value; the starting values of that 2nd tween wouldn't be accurate if lazy is true.
						this._time = prevTime;
						this._totalTime = prevTotalTime;
						this._rawPrevTime = prevRawPrevTime;
						this._cycle = prevCycle;
						TweenLiteInternals.lazyTweens.push(this);
						this._lazy = [time, suppressEvents];
						return;
					}
					//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
					if (this._time && !isComplete && !yoyoEase) {
						this.ratio = this._ease.getRatio(this._time / duration);
					} else if (isComplete && this._ease._calcEnd && !yoyoEase) {
						this.ratio = this._ease.getRatio((this._time === 0) ? 0 : 1);
					}
				}
				if (this._lazy !== false) {
					this._lazy = false;
				}
	
				if (!this._active) if (!this._paused && this._time !== prevTime && time >= 0) {
					this._active = true; //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
				}
				if (prevTotalTime === 0) {
					if (this._initted === 2 && time > 0) {
						//this.invalidate();
						this._init(); //will just apply overwriting since _initted of (2) means it was a from() tween that had immediateRender:true
					}
					if (this._startAt) {
						if (time >= 0) {
							this._startAt.render(time, true, force);
						} else if (!callback) {
							callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
						}
					}
					if (this.vars.onStart) if (this._totalTime !== 0 || duration === 0) if (!suppressEvents) {
						this._callback("onStart");
					}
				}
				
				pt = this._firstPT;
				while (pt) {
					if (pt.f) {
						pt.t[pt.p](pt.c * this.ratio + pt.s);
					} else {
						pt.t[pt.p] = pt.c * this.ratio + pt.s;
					}
					pt = pt._next;
				}
				
				if (this._onUpdate) {
					if (time < 0) if (this._startAt && this._startTime) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
						this._startAt.render(time, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
					}
					if (!suppressEvents) if (this._totalTime !== prevTotalTime || callback) {
						this._callback("onUpdate");
					}
				}
				if (this._cycle !== prevCycle) if (!suppressEvents) if (!this._gc) if (this.vars.onRepeat) {
					this._callback("onRepeat");
				}
				if (callback) if (!this._gc || force) { //check gc because there's a chance that kill() could be called in an onUpdate
					if (time < 0 && this._startAt && !this._onUpdate && this._startTime) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
						this._startAt.render(time, true, force);
					}
					if (isComplete) {
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
					if (duration === 0 && this._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
						this._rawPrevTime = 0;
					}
				}
			};
			
	//---- STATIC FUNCTIONS -----------------------------------------------------------------------------------------------------------
			
			TweenMax.to = function(target, duration, vars) {
				return new TweenMax(target, duration, vars);
			};
			
			TweenMax.from = function(target, duration, vars) {
				vars.runBackwards = true;
				vars.immediateRender = (vars.immediateRender != false);
				return new TweenMax(target, duration, vars);
			};
			
			TweenMax.fromTo = function(target, duration, fromVars, toVars) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return new TweenMax(target, duration, toVars);
			};
			
			TweenMax.staggerTo = TweenMax.allTo = function(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				stagger = stagger || 0;
				var delay = 0,
					a = [],
					finalComplete = function() {
						if (vars.onComplete) {
							vars.onComplete.apply(vars.onCompleteScope || this, arguments);
						}
						onCompleteAll.apply(onCompleteAllScope || vars.callbackScope || this, onCompleteAllParams || _blankArray);
					},
					cycle = vars.cycle,
					fromCycle = (vars.startAt && vars.startAt.cycle),
					l, copy, i, p;
				if (!_isArray(targets)) {
					if (typeof(targets) === "string") {
						targets = TweenLite.selector(targets) || targets;
					}
					if (_isSelector(targets)) {
						targets = _slice(targets);
					}
				}
				targets = targets || [];
				if (stagger < 0) {
					targets = _slice(targets);
					targets.reverse();
					stagger *= -1;
				}
				l = targets.length - 1;
				for (i = 0; i <= l; i++) {
					copy = {};
					for (p in vars) {
						copy[p] = vars[p];
					}
					if (cycle) {
						_applyCycle(copy, targets, i);
						if (copy.duration != null) {
							duration = copy.duration;
							delete copy.duration;
						}
					}
					if (fromCycle) {
						fromCycle = copy.startAt = {};
						for (p in vars.startAt) {
							fromCycle[p] = vars.startAt[p];
						}
						_applyCycle(copy.startAt, targets, i);
					}
					copy.delay = delay + (copy.delay || 0);
					if (i === l && onCompleteAll) {
						copy.onComplete = finalComplete;
					}
					a[i] = new TweenMax(targets[i], duration, copy);
					delay += stagger;
				}
				return a;
			};
			
			TweenMax.staggerFrom = TweenMax.allFrom = function(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				vars.runBackwards = true;
				vars.immediateRender = (vars.immediateRender != false);
				return TweenMax.staggerTo(targets, duration, vars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
			
			TweenMax.staggerFromTo = TweenMax.allFromTo = function(targets, duration, fromVars, toVars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return TweenMax.staggerTo(targets, duration, toVars, stagger, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
					
			TweenMax.delayedCall = function(delay, callback, params, scope, useFrames) {
				return new TweenMax(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, useFrames:useFrames, overwrite:0});
			};
			
			TweenMax.set = function(target, vars) {
				return new TweenMax(target, 0, vars);
			};
			
			TweenMax.isTweening = function(target) {
				return (TweenLite.getTweensOf(target, true).length > 0);
			};
			
			var _getChildrenOf = function(timeline, includeTimelines) {
					var a = [],
						cnt = 0,
						tween = timeline._first;
					while (tween) {
						if (tween instanceof TweenLite) {
							a[cnt++] = tween;
						} else {
							if (includeTimelines) {
								a[cnt++] = tween;
							}
							a = a.concat(_getChildrenOf(tween, includeTimelines));
							cnt = a.length;
						}
						tween = tween._next;
					}
					return a;
				}, 
				getAllTweens = TweenMax.getAllTweens = function(includeTimelines) {
					return _getChildrenOf(Animation._rootTimeline, includeTimelines).concat( _getChildrenOf(Animation._rootFramesTimeline, includeTimelines) );
				};
			
			TweenMax.killAll = function(complete, tweens, delayedCalls, timelines) {
				if (tweens == null) {
					tweens = true;
				}
				if (delayedCalls == null) {
					delayedCalls = true;
				}
				var a = getAllTweens((timelines != false)),
					l = a.length,
					allTrue = (tweens && delayedCalls && timelines),
					isDC, tween, i;
				for (i = 0; i < l; i++) {
					tween = a[i];
					if (allTrue || (tween instanceof SimpleTimeline) || ((isDC = (tween.target === tween.vars.onComplete)) && delayedCalls) || (tweens && !isDC)) {
						if (complete) {
							tween.totalTime(tween._reversed ? 0 : tween.totalDuration());
						} else {
							tween._enabled(false, false);
						}
					}
				}
			};
			
			TweenMax.killChildTweensOf = function(parent, complete) {
				if (parent == null) {
					return;
				}
				var tl = TweenLiteInternals.tweenLookup,
					a, curParent, p, i, l;
				if (typeof(parent) === "string") {
					parent = TweenLite.selector(parent) || parent;
				}
				if (_isSelector(parent)) {
					parent = _slice(parent);
				}
				if (_isArray(parent)) {
					i = parent.length;
					while (--i > -1) {
						TweenMax.killChildTweensOf(parent[i], complete);
					}
					return;
				}
				a = [];
				for (p in tl) {
					curParent = tl[p].target.parentNode;
					while (curParent) {
						if (curParent === parent) {
							a = a.concat(tl[p].tweens);
						}
						curParent = curParent.parentNode;
					}
				}
				l = a.length;
				for (i = 0; i < l; i++) {
					if (complete) {
						a[i].totalTime(a[i].totalDuration());
					}
					a[i]._enabled(false, false);
				}
			};
	
			var _changePause = function(pause, tweens, delayedCalls, timelines) {
				tweens = (tweens !== false);
				delayedCalls = (delayedCalls !== false);
				timelines = (timelines !== false);
				var a = getAllTweens(timelines),
					allTrue = (tweens && delayedCalls && timelines),
					i = a.length,
					isDC, tween;
				while (--i > -1) {
					tween = a[i];
					if (allTrue || (tween instanceof SimpleTimeline) || ((isDC = (tween.target === tween.vars.onComplete)) && delayedCalls) || (tweens && !isDC)) {
						tween.paused(pause);
					}
				}
			};
			
			TweenMax.pauseAll = function(tweens, delayedCalls, timelines) {
				_changePause(true, tweens, delayedCalls, timelines);
			};
			
			TweenMax.resumeAll = function(tweens, delayedCalls, timelines) {
				_changePause(false, tweens, delayedCalls, timelines);
			};
	
			TweenMax.globalTimeScale = function(value) {
				var tl = Animation._rootTimeline,
					t = TweenLite.ticker.time;
				if (!arguments.length) {
					return tl._timeScale;
				}
				value = value || _tinyNum; //can't allow zero because it'll throw the math off
				tl._startTime = t - ((t - tl._startTime) * tl._timeScale / value);
				tl = Animation._rootFramesTimeline;
				t = TweenLite.ticker.frame;
				tl._startTime = t - ((t - tl._startTime) * tl._timeScale / value);
				tl._timeScale = Animation._rootTimeline._timeScale = value;
				return value;
			};
			
		
	//---- GETTERS / SETTERS ----------------------------------------------------------------------------------------------------------
			
			p.progress = function(value, suppressEvents) {
				return (!arguments.length) ? this._time / this.duration() : this.totalTime( this.duration() * ((this._yoyo && (this._cycle & 1) !== 0) ? 1 - value : value) + (this._cycle * (this._duration + this._repeatDelay)), suppressEvents);
			};
			
			p.totalProgress = function(value, suppressEvents) {
				return (!arguments.length) ? this._totalTime / this.totalDuration() : this.totalTime( this.totalDuration() * value, suppressEvents);
			};
			
			p.time = function(value, suppressEvents) {
				if (!arguments.length) {
					return this._time;
				}
				if (this._dirty) {
					this.totalDuration();
				}
				if (value > this._duration) {
					value = this._duration;
				}
				if (this._yoyo && (this._cycle & 1) !== 0) {
					value = (this._duration - value) + (this._cycle * (this._duration + this._repeatDelay));
				} else if (this._repeat !== 0) {
					value += this._cycle * (this._duration + this._repeatDelay);
				}
				return this.totalTime(value, suppressEvents);
			};
	
			p.duration = function(value) {
				if (!arguments.length) {
					return this._duration; //don't set _dirty = false because there could be repeats that haven't been factored into the _totalDuration yet. Otherwise, if you create a repeated TweenMax and then immediately check its duration(), it would cache the value and the totalDuration would not be correct, thus repeats wouldn't take effect.
				}
				return Animation.prototype.duration.call(this, value);
			};
	
			p.totalDuration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						//instead of Infinity, we use 999999999999 so that we can accommodate reverses
						this._totalDuration = (this._repeat === -1) ? 999999999999 : this._duration * (this._repeat + 1) + (this._repeatDelay * this._repeat);
						this._dirty = false;
					}
					return this._totalDuration;
				}
				return (this._repeat === -1) ? this : this.duration( (value - (this._repeat * this._repeatDelay)) / (this._repeat + 1) );
			};
			
			p.repeat = function(value) {
				if (!arguments.length) {
					return this._repeat;
				}
				this._repeat = value;
				return this._uncache(true);
			};
			
			p.repeatDelay = function(value) {
				if (!arguments.length) {
					return this._repeatDelay;
				}
				this._repeatDelay = value;
				return this._uncache(true);
			};
			
			p.yoyo = function(value) {
				if (!arguments.length) {
					return this._yoyo;
				}
				this._yoyo = value;
				return this;
			};
			
			
			return TweenMax;
			
		}, true);
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * TimelineLite
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("TimelineLite", ["core.Animation","core.SimpleTimeline","TweenLite"], function(Animation, SimpleTimeline, TweenLite) {
	
			var TimelineLite = function(vars) {
					SimpleTimeline.call(this, vars);
					this._labels = {};
					this.autoRemoveChildren = (this.vars.autoRemoveChildren === true);
					this.smoothChildTiming = (this.vars.smoothChildTiming === true);
					this._sortChildren = true;
					this._onUpdate = this.vars.onUpdate;
					var v = this.vars,
						val, p;
					for (p in v) {
						val = v[p];
						if (_isArray(val)) if (val.join("").indexOf("{self}") !== -1) {
							v[p] = this._swapSelfInParams(val);
						}
					}
					if (_isArray(v.tweens)) {
						this.add(v.tweens, 0, v.align, v.stagger);
					}
				},
				_tinyNum = 0.0000000001,
				TweenLiteInternals = TweenLite._internals,
				_internals = TimelineLite._internals = {},
				_isSelector = TweenLiteInternals.isSelector,
				_isArray = TweenLiteInternals.isArray,
				_lazyTweens = TweenLiteInternals.lazyTweens,
				_lazyRender = TweenLiteInternals.lazyRender,
				_globals = _gsScope._gsDefine.globals,
				_copy = function(vars) {
					var copy = {}, p;
					for (p in vars) {
						copy[p] = vars[p];
					}
					return copy;
				},
				_applyCycle = function(vars, targets, i) {
					var alt = vars.cycle,
						p, val;
					for (p in alt) {
						val = alt[p];
						vars[p] = (typeof(val) === "function") ? val(i, targets[i]) : val[i % val.length];
					}
					delete vars.cycle;
				},
				_pauseCallback = _internals.pauseCallback = function() {},
				_slice = function(a) { //don't use [].slice because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++]));
					return b;
				},
				p = TimelineLite.prototype = new SimpleTimeline();
	
			TimelineLite.version = "1.20.4";
			p.constructor = TimelineLite;
			p.kill()._gc = p._forcingPlayhead = p._hasPause = false;
	
			/* might use later...
			//translates a local time inside an animation to the corresponding time on the root/global timeline, factoring in all nesting and timeScales.
			function localToGlobal(time, animation) {
				while (animation) {
					time = (time / animation._timeScale) + animation._startTime;
					animation = animation.timeline;
				}
				return time;
			}
	
			//translates the supplied time on the root/global timeline into the corresponding local time inside a particular animation, factoring in all nesting and timeScales
			function globalToLocal(time, animation) {
				var scale = 1;
				time -= localToGlobal(0, animation);
				while (animation) {
					scale *= animation._timeScale;
					animation = animation.timeline;
				}
				return time * scale;
			}
			*/
	
			p.to = function(target, duration, vars, position) {
				var Engine = (vars.repeat && _globals.TweenMax) || TweenLite;
				return duration ? this.add( new Engine(target, duration, vars), position) : this.set(target, vars, position);
			};
	
			p.from = function(target, duration, vars, position) {
				return this.add( ((vars.repeat && _globals.TweenMax) || TweenLite).from(target, duration, vars), position);
			};
	
			p.fromTo = function(target, duration, fromVars, toVars, position) {
				var Engine = (toVars.repeat && _globals.TweenMax) || TweenLite;
				return duration ? this.add( Engine.fromTo(target, duration, fromVars, toVars), position) : this.set(target, toVars, position);
			};
	
			p.staggerTo = function(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				var tl = new TimelineLite({onComplete:onCompleteAll, onCompleteParams:onCompleteAllParams, callbackScope:onCompleteAllScope, smoothChildTiming:this.smoothChildTiming}),
					cycle = vars.cycle,
					copy, i;
				if (typeof(targets) === "string") {
					targets = TweenLite.selector(targets) || targets;
				}
				targets = targets || [];
				if (_isSelector(targets)) { //senses if the targets object is a selector. If it is, we should translate it into an array.
					targets = _slice(targets);
				}
				stagger = stagger || 0;
				if (stagger < 0) {
					targets = _slice(targets);
					targets.reverse();
					stagger *= -1;
				}
				for (i = 0; i < targets.length; i++) {
					copy = _copy(vars);
					if (copy.startAt) {
						copy.startAt = _copy(copy.startAt);
						if (copy.startAt.cycle) {
							_applyCycle(copy.startAt, targets, i);
						}
					}
					if (cycle) {
						_applyCycle(copy, targets, i);
						if (copy.duration != null) {
							duration = copy.duration;
							delete copy.duration;
						}
					}
					tl.to(targets[i], duration, copy, i * stagger);
				}
				return this.add(tl, position);
			};
	
			p.staggerFrom = function(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				vars.immediateRender = (vars.immediateRender != false);
				vars.runBackwards = true;
				return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
	
			p.staggerFromTo = function(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams, onCompleteAllScope);
			};
	
			p.call = function(callback, params, scope, position) {
				return this.add( TweenLite.delayedCall(0, callback, params, scope), position);
			};
	
			p.set = function(target, vars, position) {
				position = this._parseTimeOrLabel(position, 0, true);
				if (vars.immediateRender == null) {
					vars.immediateRender = (position === this._time && !this._paused);
				}
				return this.add( new TweenLite(target, 0, vars), position);
			};
	
			TimelineLite.exportRoot = function(vars, ignoreDelayedCalls) {
				vars = vars || {};
				if (vars.smoothChildTiming == null) {
					vars.smoothChildTiming = true;
				}
				var tl = new TimelineLite(vars),
					root = tl._timeline,
					hasNegativeStart, time,	tween, next;
				if (ignoreDelayedCalls == null) {
					ignoreDelayedCalls = true;
				}
				root._remove(tl, true);
				tl._startTime = 0;
				tl._rawPrevTime = tl._time = tl._totalTime = root._time;
				tween = root._first;
				while (tween) {
					next = tween._next;
					if (!ignoreDelayedCalls || !(tween instanceof TweenLite && tween.target === tween.vars.onComplete)) {
						time = tween._startTime - tween._delay;
						if (time < 0) {
							hasNegativeStart = 1;
						}
						tl.add(tween, time);
					}
					tween = next;
				}
				root.add(tl, 0);
				if (hasNegativeStart) { //calling totalDuration() will force the adjustment necessary to shift the children forward so none of them start before zero, and moves the timeline backwards the same amount, so the playhead is still aligned where it should be globally, but the timeline doesn't have illegal children that start before zero.
					tl.totalDuration();
				}
				return tl;
			};
	
			p.add = function(value, position, align, stagger) {
				var curTime, l, i, child, tl, beforeRawTime;
				if (typeof(position) !== "number") {
					position = this._parseTimeOrLabel(position, 0, true, value);
				}
				if (!(value instanceof Animation)) {
					if ((value instanceof Array) || (value && value.push && _isArray(value))) {
						align = align || "normal";
						stagger = stagger || 0;
						curTime = position;
						l = value.length;
						for (i = 0; i < l; i++) {
							if (_isArray(child = value[i])) {
								child = new TimelineLite({tweens:child});
							}
							this.add(child, curTime);
							if (typeof(child) !== "string" && typeof(child) !== "function") {
								if (align === "sequence") {
									curTime = child._startTime + (child.totalDuration() / child._timeScale);
								} else if (align === "start") {
									child._startTime -= child.delay();
								}
							}
							curTime += stagger;
						}
						return this._uncache(true);
					} else if (typeof(value) === "string") {
						return this.addLabel(value, position);
					} else if (typeof(value) === "function") {
						value = TweenLite.delayedCall(0, value);
					} else {
						throw("Cannot add " + value + " into the timeline; it is not a tween, timeline, function, or string.");
					}
				}
	
				SimpleTimeline.prototype.add.call(this, value, position);
	
				if (value._time) { //in case, for example, the _startTime is moved on a tween that has already rendered. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning.
					value.render((this.rawTime() - value._startTime) * value._timeScale, false, false);
				}
	
				//if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
				if (this._gc || this._time === this._duration) if (!this._paused) if (this._duration < this.duration()) {
					//in case any of the ancestors had completed but should now be enabled...
					tl = this;
					beforeRawTime = (tl.rawTime() > value._startTime); //if the tween is placed on the timeline so that it starts BEFORE the current rawTime, we should align the playhead (move the timeline). This is because sometimes users will create a timeline, let it finish, and much later append a tween and expect it to run instead of jumping to its end state. While technically one could argue that it should jump to its end state, that's not what users intuitively expect.
					while (tl._timeline) {
						if (beforeRawTime && tl._timeline.smoothChildTiming) {
							tl.totalTime(tl._totalTime, true); //moves the timeline (shifts its startTime) if necessary, and also enables it.
						} else if (tl._gc) {
							tl._enabled(true, false);
						}
						tl = tl._timeline;
					}
				}
	
				return this;
			};
	
			p.remove = function(value) {
				if (value instanceof Animation) {
					this._remove(value, false);
					var tl = value._timeline = value.vars.useFrames ? Animation._rootFramesTimeline : Animation._rootTimeline; //now that it's removed, default it to the root timeline so that if it gets played again, it doesn't jump back into this timeline.
					value._startTime = (value._paused ? value._pauseTime : tl._time) - ((!value._reversed ? value._totalTime : value.totalDuration() - value._totalTime) / value._timeScale); //ensure that if it gets played again, the timing is correct.
					return this;
				} else if (value instanceof Array || (value && value.push && _isArray(value))) {
					var i = value.length;
					while (--i > -1) {
						this.remove(value[i]);
					}
					return this;
				} else if (typeof(value) === "string") {
					return this.removeLabel(value);
				}
				return this.kill(null, value);
			};
	
			p._remove = function(tween, skipDisable) {
				SimpleTimeline.prototype._remove.call(this, tween, skipDisable);
				var last = this._last;
				if (!last) {
					this._time = this._totalTime = this._duration = this._totalDuration = 0;
				} else if (this._time > this.duration()) {
					this._time = this._duration;
					this._totalTime = this._totalDuration;
				}
				return this;
			};
	
			p.append = function(value, offsetOrLabel) {
				return this.add(value, this._parseTimeOrLabel(null, offsetOrLabel, true, value));
			};
	
			p.insert = p.insertMultiple = function(value, position, align, stagger) {
				return this.add(value, position || 0, align, stagger);
			};
	
			p.appendMultiple = function(tweens, offsetOrLabel, align, stagger) {
				return this.add(tweens, this._parseTimeOrLabel(null, offsetOrLabel, true, tweens), align, stagger);
			};
	
			p.addLabel = function(label, position) {
				this._labels[label] = this._parseTimeOrLabel(position);
				return this;
			};
	
			p.addPause = function(position, callback, params, scope) {
				var t = TweenLite.delayedCall(0, _pauseCallback, params, scope || this);
				t.vars.onComplete = t.vars.onReverseComplete = callback;
				t.data = "isPause";
				this._hasPause = true;
				return this.add(t, position);
			};
	
			p.removeLabel = function(label) {
				delete this._labels[label];
				return this;
			};
	
			p.getLabelTime = function(label) {
				return (this._labels[label] != null) ? this._labels[label] : -1;
			};
	
			p._parseTimeOrLabel = function(timeOrLabel, offsetOrLabel, appendIfAbsent, ignore) {
				var clippedDuration, i;
				//if we're about to add a tween/timeline (or an array of them) that's already a child of this timeline, we should remove it first so that it doesn't contaminate the duration().
				if (ignore instanceof Animation && ignore.timeline === this) {
					this.remove(ignore);
				} else if (ignore && ((ignore instanceof Array) || (ignore.push && _isArray(ignore)))) {
					i = ignore.length;
					while (--i > -1) {
						if (ignore[i] instanceof Animation && ignore[i].timeline === this) {
							this.remove(ignore[i]);
						}
					}
				}
				clippedDuration = (typeof(timeOrLabel) === "number" && !offsetOrLabel) ? 0 : (this.duration() > 99999999999) ? this.recent().endTime(false) : this._duration; //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
				if (typeof(offsetOrLabel) === "string") {
					return this._parseTimeOrLabel(offsetOrLabel, (appendIfAbsent && typeof(timeOrLabel) === "number" && this._labels[offsetOrLabel] == null) ? timeOrLabel - clippedDuration : 0, appendIfAbsent);
				}
				offsetOrLabel = offsetOrLabel || 0;
				if (typeof(timeOrLabel) === "string" && (isNaN(timeOrLabel) || this._labels[timeOrLabel] != null)) { //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
					i = timeOrLabel.indexOf("=");
					if (i === -1) {
						if (this._labels[timeOrLabel] == null) {
							return appendIfAbsent ? (this._labels[timeOrLabel] = clippedDuration + offsetOrLabel) : offsetOrLabel;
						}
						return this._labels[timeOrLabel] + offsetOrLabel;
					}
					offsetOrLabel = parseInt(timeOrLabel.charAt(i-1) + "1", 10) * Number(timeOrLabel.substr(i+1));
					timeOrLabel = (i > 1) ? this._parseTimeOrLabel(timeOrLabel.substr(0, i-1), 0, appendIfAbsent) : clippedDuration;
				} else if (timeOrLabel == null) {
					timeOrLabel = clippedDuration;
				}
				return Number(timeOrLabel) + offsetOrLabel;
			};
	
			p.seek = function(position, suppressEvents) {
				return this.totalTime((typeof(position) === "number") ? position : this._parseTimeOrLabel(position), (suppressEvents !== false));
			};
	
			p.stop = function() {
				return this.paused(true);
			};
	
			p.gotoAndPlay = function(position, suppressEvents) {
				return this.play(position, suppressEvents);
			};
	
			p.gotoAndStop = function(position, suppressEvents) {
				return this.pause(position, suppressEvents);
			};
	
			p.render = function(time, suppressEvents, force) {
				if (this._gc) {
					this._enabled(true, false);
				}
				var prevTime = this._time,
					totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
					prevStart = this._startTime,
					prevTimeScale = this._timeScale,
					prevPaused = this._paused,
					tween, isComplete, next, callback, internalForce, pauseTween, curTime;
				if (prevTime !== this._time) { //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
					time += this._time - prevTime;
				}
				if (time >= totalDur - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
					this._totalTime = this._time = totalDur;
					if (!this._reversed) if (!this._hasPausedChild()) {
						isComplete = true;
						callback = "onComplete";
						internalForce = !!this._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
						if (this._duration === 0) if ((time <= 0 && time >= -0.0000001) || this._rawPrevTime < 0 || this._rawPrevTime === _tinyNum) if (this._rawPrevTime !== time && this._first) {
							internalForce = true;
							if (this._rawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
					}
					this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					time = totalDur + 0.0001; //to avoid occasional floating point rounding errors - sometimes child tweens/timelines were not being fully completed (their progress might be 0.999999999999998 instead of 1 because when _time - tween._startTime is performed, floating point errors would return a value that was SLIGHTLY off). Try (999999999999.7 - 999999999999) * 1 = 0.699951171875 instead of 0.7.
	
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = 0;
					if (prevTime !== 0 || (this._duration === 0 && this._rawPrevTime !== _tinyNum && (this._rawPrevTime > 0 || (time < 0 && this._rawPrevTime >= 0)))) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (this._timeline.autoRemoveChildren && this._reversed) { //ensures proper GC if a timeline is resumed after it's finished reversing.
							internalForce = isComplete = true;
							callback = "onReverseComplete";
						} else if (this._rawPrevTime >= 0 && this._first) { //when going back beyond the start, force a render so that zero-duration tweens that sit at the very beginning render their start values properly. Otherwise, if the parent timeline's playhead lands exactly at this timeline's startTime, and then moves backwards, the zero-duration tweens at the beginning would still be at their end state.
							internalForce = true;
						}
						this._rawPrevTime = time;
					} else {
						this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						if (time === 0 && isComplete) { //if there's a zero-duration tween at the very beginning of a timeline and the playhead lands EXACTLY at time 0, that tween will correctly render its end values, but we need to keep the timeline alive for one more render so that the beginning values render properly as the parent's playhead keeps moving beyond the begining. Imagine obj.x starts at 0 and then we do tl.set(obj, {x:100}).to(obj, 1, {x:200}) and then later we tl.reverse()...the goal is to have obj.x revert to 0. If the playhead happens to land on exactly 0, without this chunk of code, it'd complete the timeline and remove it from the rendering queue (not good).
							tween = this._first;
							while (tween && tween._startTime === 0) {
								if (!tween._duration) {
									isComplete = false;
								}
								tween = tween._next;
							}
						}
						time = 0; //to avoid occasional floating point rounding errors (could cause problems especially with zero-duration tweens at the very beginning of the timeline)
						if (!this._initted) {
							internalForce = true;
						}
					}
	
				} else {
	
					if (this._hasPause && !this._forcingPlayhead && !suppressEvents) {
						if (time >= prevTime) {
							tween = this._first;
							while (tween && tween._startTime <= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && !tween.ratio && !(tween._startTime === 0 && this._rawPrevTime === 0)) {
									pauseTween = tween;
								}
								tween = tween._next;
							}
						} else {
							tween = this._last;
							while (tween && tween._startTime >= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && tween._rawPrevTime > 0) {
									pauseTween = tween;
								}
								tween = tween._prev;
							}
						}
						if (pauseTween) {
							this._time = time = pauseTween._startTime;
							this._totalTime = time + (this._cycle * (this._totalDuration + this._repeatDelay));
						}
					}
	
					this._totalTime = this._time = this._rawPrevTime = time;
				}
				if ((this._time === prevTime || !this._first) && !force && !internalForce && !pauseTween) {
					return;
				} else if (!this._initted) {
					this._initted = true;
				}
	
				if (!this._active) if (!this._paused && this._time !== prevTime && time > 0) {
					this._active = true;  //so that if the user renders the timeline (as opposed to the parent timeline rendering it), it is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the timeline already finished but the user manually re-renders it as halfway done, for example.
				}
	
				if (prevTime === 0) if (this.vars.onStart) if (this._time !== 0 || !this._duration) if (!suppressEvents) {
					this._callback("onStart");
				}
	
				curTime = this._time;
				if (curTime >= prevTime) {
					tween = this._first;
					while (tween) {
						next = tween._next; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= curTime && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				} else {
					tween = this._last;
					while (tween) {
						next = tween._prev; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= prevTime && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								pauseTween = tween._prev; //the linked list is organized by _startTime, thus it's possible that a tween could start BEFORE the pause and end after it, in which case it would be positioned before the pause tween in the linked list, but we should render it before we pause() the timeline and cease rendering. This is only a concern when going in reverse.
								while (pauseTween && pauseTween.endTime() > this._time) {
									pauseTween.render( (pauseTween._reversed ? pauseTween.totalDuration() - ((time - pauseTween._startTime) * pauseTween._timeScale) : (time - pauseTween._startTime) * pauseTween._timeScale), suppressEvents, force);
									pauseTween = pauseTween._prev;
								}
								pauseTween = null;
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				}
	
				if (this._onUpdate) if (!suppressEvents) {
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
						_lazyRender();
					}
					this._callback("onUpdate");
				}
	
				if (callback) if (!this._gc) if (prevStart === this._startTime || prevTimeScale !== this._timeScale) if (this._time === 0 || totalDur >= this.totalDuration()) { //if one of the tweens that was rendered altered this timeline's startTime (like if an onComplete reversed the timeline), it probably isn't complete. If it is, don't worry, because whatever call altered the startTime would complete if it was necessary at the new time. The only exception is the timeScale property. Also check _gc because there's a chance that kill() could be called in an onUpdate
					if (isComplete) {
						if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onComplete on a timeline that reports/checks tweened values.
							_lazyRender();
						}
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
				}
			};
	
			p._hasPausedChild = function() {
				var tween = this._first;
				while (tween) {
					if (tween._paused || ((tween instanceof TimelineLite) && tween._hasPausedChild())) {
						return true;
					}
					tween = tween._next;
				}
				return false;
			};
	
			p.getChildren = function(nested, tweens, timelines, ignoreBeforeTime) {
				ignoreBeforeTime = ignoreBeforeTime || -9999999999;
				var a = [],
					tween = this._first,
					cnt = 0;
				while (tween) {
					if (tween._startTime < ignoreBeforeTime) {
						//do nothing
					} else if (tween instanceof TweenLite) {
						if (tweens !== false) {
							a[cnt++] = tween;
						}
					} else {
						if (timelines !== false) {
							a[cnt++] = tween;
						}
						if (nested !== false) {
							a = a.concat(tween.getChildren(true, tweens, timelines));
							cnt = a.length;
						}
					}
					tween = tween._next;
				}
				return a;
			};
	
			p.getTweensOf = function(target, nested) {
				var disabled = this._gc,
					a = [],
					cnt = 0,
					tweens, i;
				if (disabled) {
					this._enabled(true, true); //getTweensOf() filters out disabled tweens, and we have to mark them as _gc = true when the timeline completes in order to allow clean garbage collection, so temporarily re-enable the timeline here.
				}
				tweens = TweenLite.getTweensOf(target);
				i = tweens.length;
				while (--i > -1) {
					if (tweens[i].timeline === this || (nested && this._contains(tweens[i]))) {
						a[cnt++] = tweens[i];
					}
				}
				if (disabled) {
					this._enabled(false, true);
				}
				return a;
			};
	
			p.recent = function() {
				return this._recent;
			};
	
			p._contains = function(tween) {
				var tl = tween.timeline;
				while (tl) {
					if (tl === this) {
						return true;
					}
					tl = tl.timeline;
				}
				return false;
			};
	
			p.shiftChildren = function(amount, adjustLabels, ignoreBeforeTime) {
				ignoreBeforeTime = ignoreBeforeTime || 0;
				var tween = this._first,
					labels = this._labels,
					p;
				while (tween) {
					if (tween._startTime >= ignoreBeforeTime) {
						tween._startTime += amount;
					}
					tween = tween._next;
				}
				if (adjustLabels) {
					for (p in labels) {
						if (labels[p] >= ignoreBeforeTime) {
							labels[p] += amount;
						}
					}
				}
				return this._uncache(true);
			};
	
			p._kill = function(vars, target) {
				if (!vars && !target) {
					return this._enabled(false, false);
				}
				var tweens = (!target) ? this.getChildren(true, true, false) : this.getTweensOf(target),
					i = tweens.length,
					changed = false;
				while (--i > -1) {
					if (tweens[i]._kill(vars, target)) {
						changed = true;
					}
				}
				return changed;
			};
	
			p.clear = function(labels) {
				var tweens = this.getChildren(false, true, true),
					i = tweens.length;
				this._time = this._totalTime = 0;
				while (--i > -1) {
					tweens[i]._enabled(false, false);
				}
				if (labels !== false) {
					this._labels = {};
				}
				return this._uncache(true);
			};
	
			p.invalidate = function() {
				var tween = this._first;
				while (tween) {
					tween.invalidate();
					tween = tween._next;
				}
				return Animation.prototype.invalidate.call(this);;
			};
	
			p._enabled = function(enabled, ignoreTimeline) {
				if (enabled === this._gc) {
					var tween = this._first;
					while (tween) {
						tween._enabled(enabled, true);
						tween = tween._next;
					}
				}
				return SimpleTimeline.prototype._enabled.call(this, enabled, ignoreTimeline);
			};
	
			p.totalTime = function(time, suppressEvents, uncapped) {
				this._forcingPlayhead = true;
				var val = Animation.prototype.totalTime.apply(this, arguments);
				this._forcingPlayhead = false;
				return val;
			};
	
			p.duration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						this.totalDuration(); //just triggers recalculation
					}
					return this._duration;
				}
				if (this.duration() !== 0 && value !== 0) {
					this.timeScale(this._duration / value);
				}
				return this;
			};
	
			p.totalDuration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						var max = 0,
							tween = this._last,
							prevStart = 999999999999,
							prev, end;
						while (tween) {
							prev = tween._prev; //record it here in case the tween changes position in the sequence...
							if (tween._dirty) {
								tween.totalDuration(); //could change the tween._startTime, so make sure the tween's cache is clean before analyzing it.
							}
							if (tween._startTime > prevStart && this._sortChildren && !tween._paused && !this._calculatingDuration) { //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
								this._calculatingDuration = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add(), like _parseTimeOrLabel().
								this.add(tween, tween._startTime - tween._delay);
								this._calculatingDuration = 0;
							} else {
								prevStart = tween._startTime;
							}
							if (tween._startTime < 0 && !tween._paused) { //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
								max -= tween._startTime;
								if (this._timeline.smoothChildTiming) {
									this._startTime += tween._startTime / this._timeScale;
									this._time -= tween._startTime;
									this._totalTime -= tween._startTime;
									this._rawPrevTime -= tween._startTime;
								}
								this.shiftChildren(-tween._startTime, false, -9999999999);
								prevStart = 0;
							}
							end = tween._startTime + (tween._totalDuration / tween._timeScale);
							if (end > max) {
								max = end;
							}
							tween = prev;
						}
						this._duration = this._totalDuration = max;
						this._dirty = false;
					}
					return this._totalDuration;
				}
				return (value && this.totalDuration()) ? this.timeScale(this._totalDuration / value) : this;
			};
	
			p.paused = function(value) {
				if (!value) { //if there's a pause directly at the spot from where we're unpausing, skip it.
					var tween = this._first,
						time = this._time;
					while (tween) {
						if (tween._startTime === time && tween.data === "isPause") {
							tween._rawPrevTime = 0; //remember, _rawPrevTime is how zero-duration tweens/callbacks sense directionality and determine whether or not to fire. If _rawPrevTime is the same as _startTime on the next render, it won't fire.
						}
						tween = tween._next;
					}
				}
				return Animation.prototype.paused.apply(this, arguments);
			};
	
			p.usesFrames = function() {
				var tl = this._timeline;
				while (tl._timeline) {
					tl = tl._timeline;
				}
				return (tl === Animation._rootFramesTimeline);
			};
	
			p.rawTime = function(wrapRepeats) {
				return (wrapRepeats && (this._paused || (this._repeat && this.time() > 0 && this.totalProgress() < 1))) ? this._totalTime % (this._duration + this._repeatDelay) : this._paused ? this._totalTime : (this._timeline.rawTime(wrapRepeats) - this._startTime) * this._timeScale;
			};
	
			return TimelineLite;
	
		}, true);
	
	
	
	
	
	
	
	
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * TimelineMax
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("TimelineMax", ["TimelineLite","TweenLite","easing.Ease"], function(TimelineLite, TweenLite, Ease) {
	
			var TimelineMax = function(vars) {
					TimelineLite.call(this, vars);
					this._repeat = this.vars.repeat || 0;
					this._repeatDelay = this.vars.repeatDelay || 0;
					this._cycle = 0;
					this._yoyo = (this.vars.yoyo === true);
					this._dirty = true;
				},
				_tinyNum = 0.0000000001,
				TweenLiteInternals = TweenLite._internals,
				_lazyTweens = TweenLiteInternals.lazyTweens,
				_lazyRender = TweenLiteInternals.lazyRender,
				_globals = _gsScope._gsDefine.globals,
				_easeNone = new Ease(null, null, 1, 0),
				p = TimelineMax.prototype = new TimelineLite();
	
			p.constructor = TimelineMax;
			p.kill()._gc = false;
			TimelineMax.version = "1.20.4";
	
			p.invalidate = function() {
				this._yoyo = (this.vars.yoyo === true);
				this._repeat = this.vars.repeat || 0;
				this._repeatDelay = this.vars.repeatDelay || 0;
				this._uncache(true);
				return TimelineLite.prototype.invalidate.call(this);
			};
	
			p.addCallback = function(callback, position, params, scope) {
				return this.add( TweenLite.delayedCall(0, callback, params, scope), position);
			};
	
			p.removeCallback = function(callback, position) {
				if (callback) {
					if (position == null) {
						this._kill(null, callback);
					} else {
						var a = this.getTweensOf(callback, false),
							i = a.length,
							time = this._parseTimeOrLabel(position);
						while (--i > -1) {
							if (a[i]._startTime === time) {
								a[i]._enabled(false, false);
							}
						}
					}
				}
				return this;
			};
	
			p.removePause = function(position) {
				return this.removeCallback(TimelineLite._internals.pauseCallback, position);
			};
	
			p.tweenTo = function(position, vars) {
				vars = vars || {};
				var copy = {ease:_easeNone, useFrames:this.usesFrames(), immediateRender:false, lazy:false},
					Engine = (vars.repeat && _globals.TweenMax) || TweenLite,
					duration, p, t;
				for (p in vars) {
					copy[p] = vars[p];
				}
				copy.time = this._parseTimeOrLabel(position);
				duration = (Math.abs(Number(copy.time) - this._time) / this._timeScale) || 0.001;
				t = new Engine(this, duration, copy);
				copy.onStart = function() {
					t.target.paused(true);
					if (t.vars.time !== t.target.time() && duration === t.duration() && !t.isFromTo) { //don't make the duration zero - if it's supposed to be zero, don't worry because it's already initting the tween and will complete immediately, effectively making the duration zero anyway. If we make duration zero, the tween won't run at all.
						t.duration( Math.abs( t.vars.time - t.target.time()) / t.target._timeScale ).render(t.time(), true, true); //render() right away to ensure that things look right, especially in the case of .tweenTo(0).
					}
					if (vars.onStart) { //in case the user had an onStart in the vars - we don't want to overwrite it.
						vars.onStart.apply(vars.onStartScope || vars.callbackScope || t, vars.onStartParams || []); //don't use t._callback("onStart") or it'll point to the copy.onStart and we'll get a recursion error.
					}
				};
				return t;
			};
	
			p.tweenFromTo = function(fromPosition, toPosition, vars) {
				vars = vars || {};
				fromPosition = this._parseTimeOrLabel(fromPosition);
				vars.startAt = {onComplete:this.seek, onCompleteParams:[fromPosition], callbackScope:this};
				vars.immediateRender = (vars.immediateRender !== false);
				var t = this.tweenTo(toPosition, vars);
				t.isFromTo = 1; //to ensure we don't mess with the duration in the onStart (we've got the start and end values here, so lock it in)
				return t.duration((Math.abs( t.vars.time - fromPosition) / this._timeScale) || 0.001);
			};
	
			p.render = function(time, suppressEvents, force) {
				if (this._gc) {
					this._enabled(true, false);
				}
				var prevTime = this._time,
					totalDur = (!this._dirty) ? this._totalDuration : this.totalDuration(),
					dur = this._duration,
					prevTotalTime = this._totalTime,
					prevStart = this._startTime,
					prevTimeScale = this._timeScale,
					prevRawPrevTime = this._rawPrevTime,
					prevPaused = this._paused,
					prevCycle = this._cycle,
					tween, isComplete, next, callback, internalForce, cycleDuration, pauseTween, curTime;
				if (prevTime !== this._time) { //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
					time += this._time - prevTime;
				}
				if (time >= totalDur - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
					if (!this._locked) {
						this._totalTime = totalDur;
						this._cycle = this._repeat;
					}
					if (!this._reversed) if (!this._hasPausedChild()) {
						isComplete = true;
						callback = "onComplete";
						internalForce = !!this._timeline.autoRemoveChildren; //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
						if (this._duration === 0) if ((time <= 0 && time >= -0.0000001) || prevRawPrevTime < 0 || prevRawPrevTime === _tinyNum) if (prevRawPrevTime !== time && this._first) {
							internalForce = true;
							if (prevRawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
					}
					this._rawPrevTime = (this._duration || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					if (this._yoyo && (this._cycle & 1) !== 0) {
						this._time = time = 0;
					} else {
						this._time = dur;
						time = dur + 0.0001; //to avoid occasional floating point rounding errors - sometimes child tweens/timelines were not being fully completed (their progress might be 0.999999999999998 instead of 1 because when _time - tween._startTime is performed, floating point errors would return a value that was SLIGHTLY off). Try (999999999999.7 - 999999999999) * 1 = 0.699951171875 instead of 0.7. We cannot do less then 0.0001 because the same issue can occur when the duration is extremely large like 999999999999 in which case adding 0.00000001, for example, causes it to act like nothing was added.
					}
	
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					if (!this._locked) {
						this._totalTime = this._cycle = 0;
					}
					this._time = 0;
					if (prevTime !== 0 || (dur === 0 && prevRawPrevTime !== _tinyNum && (prevRawPrevTime > 0 || (time < 0 && prevRawPrevTime >= 0)) && !this._locked)) { //edge case for checking time < 0 && prevRawPrevTime >= 0: a zero-duration fromTo() tween inside a zero-duration timeline (yeah, very rare)
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (this._timeline.autoRemoveChildren && this._reversed) {
							internalForce = isComplete = true;
							callback = "onReverseComplete";
						} else if (prevRawPrevTime >= 0 && this._first) { //when going back beyond the start, force a render so that zero-duration tweens that sit at the very beginning render their start values properly. Otherwise, if the parent timeline's playhead lands exactly at this timeline's startTime, and then moves backwards, the zero-duration tweens at the beginning would still be at their end state.
							internalForce = true;
						}
						this._rawPrevTime = time;
					} else {
						this._rawPrevTime = (dur || !suppressEvents || time || this._rawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline or tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						if (time === 0 && isComplete) { //if there's a zero-duration tween at the very beginning of a timeline and the playhead lands EXACTLY at time 0, that tween will correctly render its end values, but we need to keep the timeline alive for one more render so that the beginning values render properly as the parent's playhead keeps moving beyond the begining. Imagine obj.x starts at 0 and then we do tl.set(obj, {x:100}).to(obj, 1, {x:200}) and then later we tl.reverse()...the goal is to have obj.x revert to 0. If the playhead happens to land on exactly 0, without this chunk of code, it'd complete the timeline and remove it from the rendering queue (not good).
							tween = this._first;
							while (tween && tween._startTime === 0) {
								if (!tween._duration) {
									isComplete = false;
								}
								tween = tween._next;
							}
						}
						time = 0; //to avoid occasional floating point rounding errors (could cause problems especially with zero-duration tweens at the very beginning of the timeline)
						if (!this._initted) {
							internalForce = true;
						}
					}
	
				} else {
					if (dur === 0 && prevRawPrevTime < 0) { //without this, zero-duration repeating timelines (like with a simple callback nested at the very beginning and a repeatDelay) wouldn't render the first time through.
						internalForce = true;
					}
					this._time = this._rawPrevTime = time;
					if (!this._locked) {
						this._totalTime = time;
						if (this._repeat !== 0) {
							cycleDuration = dur + this._repeatDelay;
							this._cycle = (this._totalTime / cycleDuration) >> 0; //originally _totalTime % cycleDuration but floating point errors caused problems, so I normalized it. (4 % 0.8 should be 0 but it gets reported as 0.79999999!)
							if (this._cycle !== 0) if (this._cycle === this._totalTime / cycleDuration && prevTotalTime <= time) {
								this._cycle--; //otherwise when rendered exactly at the end time, it will act as though it is repeating (at the beginning)
							}
							this._time = this._totalTime - (this._cycle * cycleDuration);
							if (this._yoyo) if ((this._cycle & 1) !== 0) {
								this._time = dur - this._time;
							}
							if (this._time > dur) {
								this._time = dur;
								time = dur + 0.0001; //to avoid occasional floating point rounding error
							} else if (this._time < 0) {
								this._time = time = 0;
							} else {
								time = this._time;
							}
						}
					}
	
					if (this._hasPause && !this._forcingPlayhead && !suppressEvents) {
						time = this._time;
						if (time >= prevTime || (this._repeat && prevCycle !== this._cycle)) {
							tween = this._first;
							while (tween && tween._startTime <= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && !tween.ratio && !(tween._startTime === 0 && this._rawPrevTime === 0)) {
									pauseTween = tween;
								}
								tween = tween._next;
							}
						} else {
							tween = this._last;
							while (tween && tween._startTime >= time && !pauseTween) {
								if (!tween._duration) if (tween.data === "isPause" && tween._rawPrevTime > 0) {
									pauseTween = tween;
								}
								tween = tween._prev;
							}
						}
						if (pauseTween && pauseTween._startTime < dur) {
							this._time = time = pauseTween._startTime;
							this._totalTime = time + (this._cycle * (this._totalDuration + this._repeatDelay));
						}
					}
	
				}
	
				if (this._cycle !== prevCycle) if (!this._locked) {
					/*
					make sure children at the end/beginning of the timeline are rendered properly. If, for example,
					a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
					would get transated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
					could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
					we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
					ensure that zero-duration tweens at the very beginning or end of the TimelineMax work.
					*/
					var backwards = (this._yoyo && (prevCycle & 1) !== 0),
						wrap = (backwards === (this._yoyo && (this._cycle & 1) !== 0)),
						recTotalTime = this._totalTime,
						recCycle = this._cycle,
						recRawPrevTime = this._rawPrevTime,
						recTime = this._time;
	
					this._totalTime = prevCycle * dur;
					if (this._cycle < prevCycle) {
						backwards = !backwards;
					} else {
						this._totalTime += dur;
					}
					this._time = prevTime; //temporarily revert _time so that render() renders the children in the correct order. Without this, tweens won't rewind correctly. We could arhictect things in a "cleaner" way by splitting out the rendering queue into a separate method but for performance reasons, we kept it all inside this method.
	
					this._rawPrevTime = (dur === 0) ? prevRawPrevTime - 0.0001 : prevRawPrevTime;
					this._cycle = prevCycle;
					this._locked = true; //prevents changes to totalTime and skips repeat/yoyo behavior when we recursively call render()
					prevTime = (backwards) ? 0 : dur;
					this.render(prevTime, suppressEvents, (dur === 0));
					if (!suppressEvents) if (!this._gc) {
						if (this.vars.onRepeat) {
							this._cycle = recCycle; //in case the onRepeat alters the playhead or invalidates(), we shouldn't stay locked or use the previous cycle.
							this._locked = false;
							this._callback("onRepeat");
						}
					}
					if (prevTime !== this._time) { //in case there's a callback like onComplete in a nested tween/timeline that changes the playhead position, like via seek(), we should just abort.
						return;
					}
					if (wrap) {
						this._cycle = prevCycle; //if there's an onRepeat, we reverted this above, so make sure it's set properly again. We also unlocked in that scenario, so reset that too.
						this._locked = true;
						prevTime = (backwards) ? dur + 0.0001 : -0.0001;
						this.render(prevTime, true, false);
					}
					this._locked = false;
					if (this._paused && !prevPaused) { //if the render() triggered callback that paused this timeline, we should abort (very rare, but possible)
						return;
					}
					this._time = recTime;
					this._totalTime = recTotalTime;
					this._cycle = recCycle;
					this._rawPrevTime = recRawPrevTime;
				}
	
				if ((this._time === prevTime || !this._first) && !force && !internalForce && !pauseTween) {
					if (prevTotalTime !== this._totalTime) if (this._onUpdate) if (!suppressEvents) { //so that onUpdate fires even during the repeatDelay - as long as the totalTime changed, we should trigger onUpdate.
						this._callback("onUpdate");
					}
					return;
				} else if (!this._initted) {
					this._initted = true;
				}
	
				if (!this._active) if (!this._paused && this._totalTime !== prevTotalTime && time > 0) {
					this._active = true;  //so that if the user renders the timeline (as opposed to the parent timeline rendering it), it is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the timeline already finished but the user manually re-renders it as halfway done, for example.
				}
	
				if (prevTotalTime === 0) if (this.vars.onStart) if (this._totalTime !== 0 || !this._totalDuration) if (!suppressEvents) {
					this._callback("onStart");
				}
	
				curTime = this._time;
				if (curTime >= prevTime) {
					tween = this._first;
					while (tween) {
						next = tween._next; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= this._time && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				} else {
					tween = this._last;
					while (tween) {
						next = tween._prev; //record it here because the value could change after rendering...
						if (curTime !== this._time || (this._paused && !prevPaused)) { //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
							break;
						} else if (tween._active || (tween._startTime <= prevTime && !tween._paused && !tween._gc)) {
							if (pauseTween === tween) {
								pauseTween = tween._prev; //the linked list is organized by _startTime, thus it's possible that a tween could start BEFORE the pause and end after it, in which case it would be positioned before the pause tween in the linked list, but we should render it before we pause() the timeline and cease rendering. This is only a concern when going in reverse.
								while (pauseTween && pauseTween.endTime() > this._time) {
									pauseTween.render( (pauseTween._reversed ? pauseTween.totalDuration() - ((time - pauseTween._startTime) * pauseTween._timeScale) : (time - pauseTween._startTime) * pauseTween._timeScale), suppressEvents, force);
									pauseTween = pauseTween._prev;
								}
								pauseTween = null;
								this.pause();
							}
							if (!tween._reversed) {
								tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
							} else {
								tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
							}
						}
						tween = next;
					}
				}
	
				if (this._onUpdate) if (!suppressEvents) {
					if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
						_lazyRender();
					}
					this._callback("onUpdate");
				}
				if (callback) if (!this._locked) if (!this._gc) if (prevStart === this._startTime || prevTimeScale !== this._timeScale) if (this._time === 0 || totalDur >= this.totalDuration()) { //if one of the tweens that was rendered altered this timeline's startTime (like if an onComplete reversed the timeline), it probably isn't complete. If it is, don't worry, because whatever call altered the startTime would complete if it was necessary at the new time. The only exception is the timeScale property. Also check _gc because there's a chance that kill() could be called in an onUpdate
					if (isComplete) {
						if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onComplete on a timeline that reports/checks tweened values.
							_lazyRender();
						}
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
				}
			};
	
			p.getActive = function(nested, tweens, timelines) {
				if (nested == null) {
					nested = true;
				}
				if (tweens == null) {
					tweens = true;
				}
				if (timelines == null) {
					timelines = false;
				}
				var a = [],
					all = this.getChildren(nested, tweens, timelines),
					cnt = 0,
					l = all.length,
					i, tween;
				for (i = 0; i < l; i++) {
					tween = all[i];
					if (tween.isActive()) {
						a[cnt++] = tween;
					}
				}
				return a;
			};
	
	
			p.getLabelAfter = function(time) {
				if (!time) if (time !== 0) { //faster than isNan()
					time = this._time;
				}
				var labels = this.getLabelsArray(),
					l = labels.length,
					i;
				for (i = 0; i < l; i++) {
					if (labels[i].time > time) {
						return labels[i].name;
					}
				}
				return null;
			};
	
			p.getLabelBefore = function(time) {
				if (time == null) {
					time = this._time;
				}
				var labels = this.getLabelsArray(),
					i = labels.length;
				while (--i > -1) {
					if (labels[i].time < time) {
						return labels[i].name;
					}
				}
				return null;
			};
	
			p.getLabelsArray = function() {
				var a = [],
					cnt = 0,
					p;
				for (p in this._labels) {
					a[cnt++] = {time:this._labels[p], name:p};
				}
				a.sort(function(a,b) {
					return a.time - b.time;
				});
				return a;
			};
	
			p.invalidate = function() {
				this._locked = false; //unlock and set cycle in case invalidate() is called from inside an onRepeat
				return TimelineLite.prototype.invalidate.call(this);
			};
	
	
	//---- GETTERS / SETTERS -------------------------------------------------------------------------------------------------------
	
			p.progress = function(value, suppressEvents) {
				return (!arguments.length) ? (this._time / this.duration()) || 0 : this.totalTime( this.duration() * ((this._yoyo && (this._cycle & 1) !== 0) ? 1 - value : value) + (this._cycle * (this._duration + this._repeatDelay)), suppressEvents);
			};
	
			p.totalProgress = function(value, suppressEvents) {
				return (!arguments.length) ? (this._totalTime / this.totalDuration()) || 0 : this.totalTime( this.totalDuration() * value, suppressEvents);
			};
	
			p.totalDuration = function(value) {
				if (!arguments.length) {
					if (this._dirty) {
						TimelineLite.prototype.totalDuration.call(this); //just forces refresh
						//Instead of Infinity, we use 999999999999 so that we can accommodate reverses.
						this._totalDuration = (this._repeat === -1) ? 999999999999 : this._duration * (this._repeat + 1) + (this._repeatDelay * this._repeat);
					}
					return this._totalDuration;
				}
				return (this._repeat === -1 || !value) ? this : this.timeScale( this.totalDuration() / value );
			};
	
			p.time = function(value, suppressEvents) {
				if (!arguments.length) {
					return this._time;
				}
				if (this._dirty) {
					this.totalDuration();
				}
				if (value > this._duration) {
					value = this._duration;
				}
				if (this._yoyo && (this._cycle & 1) !== 0) {
					value = (this._duration - value) + (this._cycle * (this._duration + this._repeatDelay));
				} else if (this._repeat !== 0) {
					value += this._cycle * (this._duration + this._repeatDelay);
				}
				return this.totalTime(value, suppressEvents);
			};
	
			p.repeat = function(value) {
				if (!arguments.length) {
					return this._repeat;
				}
				this._repeat = value;
				return this._uncache(true);
			};
	
			p.repeatDelay = function(value) {
				if (!arguments.length) {
					return this._repeatDelay;
				}
				this._repeatDelay = value;
				return this._uncache(true);
			};
	
			p.yoyo = function(value) {
				if (!arguments.length) {
					return this._yoyo;
				}
				this._yoyo = value;
				return this;
			};
	
			p.currentLabel = function(value) {
				if (!arguments.length) {
					return this.getLabelBefore(this._time + 0.00000001);
				}
				return this.seek(value, true);
			};
	
			return TimelineMax;
	
		}, true);
		
	
	
	
	
		
		
		
		
		
	
		
	/*
	 * ----------------------------------------------------------------
	 * BezierPlugin
	 * ----------------------------------------------------------------
	 */
		(function() {
	
			var _RAD2DEG = 180 / Math.PI,
				_r1 = [],
				_r2 = [],
				_r3 = [],
				_corProps = {},
				_globals = _gsScope._gsDefine.globals,
				Segment = function(a, b, c, d) {
					if (c === d) { //if c and d match, the final autoRotate value could lock at -90 degrees, so differentiate them slightly.
						c = d - (d - b) / 1000000;
					}
					if (a === b) { //if a and b match, the starting autoRotate value could lock at -90 degrees, so differentiate them slightly.
						b = a + (c - a) / 1000000;
					}
					this.a = a;
					this.b = b;
					this.c = c;
					this.d = d;
					this.da = d - a;
					this.ca = c - a;
					this.ba = b - a;
				},
				_correlate = ",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,",
				cubicToQuadratic = function(a, b, c, d) {
					var q1 = {a:a},
						q2 = {},
						q3 = {},
						q4 = {c:d},
						mab = (a + b) / 2,
						mbc = (b + c) / 2,
						mcd = (c + d) / 2,
						mabc = (mab + mbc) / 2,
						mbcd = (mbc + mcd) / 2,
						m8 = (mbcd - mabc) / 8;
					q1.b = mab + (a - mab) / 4;
					q2.b = mabc + m8;
					q1.c = q2.a = (q1.b + q2.b) / 2;
					q2.c = q3.a = (mabc + mbcd) / 2;
					q3.b = mbcd - m8;
					q4.b = mcd + (d - mcd) / 4;
					q3.c = q4.a = (q3.b + q4.b) / 2;
					return [q1, q2, q3, q4];
				},
				_calculateControlPoints = function(a, curviness, quad, basic, correlate) {
					var l = a.length - 1,
						ii = 0,
						cp1 = a[0].a,
						i, p1, p2, p3, seg, m1, m2, mm, cp2, qb, r1, r2, tl;
					for (i = 0; i < l; i++) {
						seg = a[ii];
						p1 = seg.a;
						p2 = seg.d;
						p3 = a[ii+1].d;
	
						if (correlate) {
							r1 = _r1[i];
							r2 = _r2[i];
							tl = ((r2 + r1) * curviness * 0.25) / (basic ? 0.5 : _r3[i] || 0.5);
							m1 = p2 - (p2 - p1) * (basic ? curviness * 0.5 : (r1 !== 0 ? tl / r1 : 0));
							m2 = p2 + (p3 - p2) * (basic ? curviness * 0.5 : (r2 !== 0 ? tl / r2 : 0));
							mm = p2 - (m1 + (((m2 - m1) * ((r1 * 3 / (r1 + r2)) + 0.5) / 4) || 0));
						} else {
							m1 = p2 - (p2 - p1) * curviness * 0.5;
							m2 = p2 + (p3 - p2) * curviness * 0.5;
							mm = p2 - (m1 + m2) / 2;
						}
						m1 += mm;
						m2 += mm;
	
						seg.c = cp2 = m1;
						if (i !== 0) {
							seg.b = cp1;
						} else {
							seg.b = cp1 = seg.a + (seg.c - seg.a) * 0.6; //instead of placing b on a exactly, we move it inline with c so that if the user specifies an ease like Back.easeIn or Elastic.easeIn which goes BEYOND the beginning, it will do so smoothly.
						}
	
						seg.da = p2 - p1;
						seg.ca = cp2 - p1;
						seg.ba = cp1 - p1;
	
						if (quad) {
							qb = cubicToQuadratic(p1, cp1, cp2, p2);
							a.splice(ii, 1, qb[0], qb[1], qb[2], qb[3]);
							ii += 4;
						} else {
							ii++;
						}
	
						cp1 = m2;
					}
					seg = a[ii];
					seg.b = cp1;
					seg.c = cp1 + (seg.d - cp1) * 0.4; //instead of placing c on d exactly, we move it inline with b so that if the user specifies an ease like Back.easeOut or Elastic.easeOut which goes BEYOND the end, it will do so smoothly.
					seg.da = seg.d - seg.a;
					seg.ca = seg.c - seg.a;
					seg.ba = cp1 - seg.a;
					if (quad) {
						qb = cubicToQuadratic(seg.a, cp1, seg.c, seg.d);
						a.splice(ii, 1, qb[0], qb[1], qb[2], qb[3]);
					}
				},
				_parseAnchors = function(values, p, correlate, prepend) {
					var a = [],
						l, i, p1, p2, p3, tmp;
					if (prepend) {
						values = [prepend].concat(values);
						i = values.length;
						while (--i > -1) {
							if (typeof( (tmp = values[i][p]) ) === "string") if (tmp.charAt(1) === "=") {
								values[i][p] = prepend[p] + Number(tmp.charAt(0) + tmp.substr(2)); //accommodate relative values. Do it inline instead of breaking it out into a function for speed reasons
							}
						}
					}
					l = values.length - 2;
					if (l < 0) {
						a[0] = new Segment(values[0][p], 0, 0, values[0][p]);
						return a;
					}
					for (i = 0; i < l; i++) {
						p1 = values[i][p];
						p2 = values[i+1][p];
						a[i] = new Segment(p1, 0, 0, p2);
						if (correlate) {
							p3 = values[i+2][p];
							_r1[i] = (_r1[i] || 0) + (p2 - p1) * (p2 - p1);
							_r2[i] = (_r2[i] || 0) + (p3 - p2) * (p3 - p2);
						}
					}
					a[i] = new Segment(values[i][p], 0, 0, values[i+1][p]);
					return a;
				},
				bezierThrough = function(values, curviness, quadratic, basic, correlate, prepend) {
					var obj = {},
						props = [],
						first = prepend || values[0],
						i, p, a, j, r, l, seamless, last;
					correlate = (typeof(correlate) === "string") ? ","+correlate+"," : _correlate;
					if (curviness == null) {
						curviness = 1;
					}
					for (p in values[0]) {
						props.push(p);
					}
					//check to see if the last and first values are identical (well, within 0.05). If so, make seamless by appending the second element to the very end of the values array and the 2nd-to-last element to the very beginning (we'll remove those segments later)
					if (values.length > 1) {
						last = values[values.length - 1];
						seamless = true;
						i = props.length;
						while (--i > -1) {
							p = props[i];
							if (Math.abs(first[p] - last[p]) > 0.05) { //build in a tolerance of +/-0.05 to accommodate rounding errors.
								seamless = false;
								break;
							}
						}
						if (seamless) {
							values = values.concat(); //duplicate the array to avoid contaminating the original which the user may be reusing for other tweens
							if (prepend) {
								values.unshift(prepend);
							}
							values.push(values[1]);
							prepend = values[values.length - 3];
						}
					}
					_r1.length = _r2.length = _r3.length = 0;
					i = props.length;
					while (--i > -1) {
						p = props[i];
						_corProps[p] = (correlate.indexOf(","+p+",") !== -1);
						obj[p] = _parseAnchors(values, p, _corProps[p], prepend);
					}
					i = _r1.length;
					while (--i > -1) {
						_r1[i] = Math.sqrt(_r1[i]);
						_r2[i] = Math.sqrt(_r2[i]);
					}
					if (!basic) {
						i = props.length;
						while (--i > -1) {
							if (_corProps[p]) {
								a = obj[props[i]];
								l = a.length - 1;
								for (j = 0; j < l; j++) {
									r = (a[j+1].da / _r2[j] + a[j].da / _r1[j]) || 0;
									_r3[j] = (_r3[j] || 0) + r * r;
								}
							}
						}
						i = _r3.length;
						while (--i > -1) {
							_r3[i] = Math.sqrt(_r3[i]);
						}
					}
					i = props.length;
					j = quadratic ? 4 : 1;
					while (--i > -1) {
						p = props[i];
						a = obj[p];
						_calculateControlPoints(a, curviness, quadratic, basic, _corProps[p]); //this method requires that _parseAnchors() and _setSegmentRatios() ran first so that _r1, _r2, and _r3 values are populated for all properties
						if (seamless) {
							a.splice(0, j);
							a.splice(a.length - j, j);
						}
					}
					return obj;
				},
				_parseBezierData = function(values, type, prepend) {
					type = type || "soft";
					var obj = {},
						inc = (type === "cubic") ? 3 : 2,
						soft = (type === "soft"),
						props = [],
						a, b, c, d, cur, i, j, l, p, cnt, tmp;
					if (soft && prepend) {
						values = [prepend].concat(values);
					}
					if (values == null || values.length < inc + 1) { throw "invalid Bezier data"; }
					for (p in values[0]) {
						props.push(p);
					}
					i = props.length;
					while (--i > -1) {
						p = props[i];
						obj[p] = cur = [];
						cnt = 0;
						l = values.length;
						for (j = 0; j < l; j++) {
							a = (prepend == null) ? values[j][p] : (typeof( (tmp = values[j][p]) ) === "string" && tmp.charAt(1) === "=") ? prepend[p] + Number(tmp.charAt(0) + tmp.substr(2)) : Number(tmp);
							if (soft) if (j > 1) if (j < l - 1) {
								cur[cnt++] = (a + cur[cnt-2]) / 2;
							}
							cur[cnt++] = a;
						}
						l = cnt - inc + 1;
						cnt = 0;
						for (j = 0; j < l; j += inc) {
							a = cur[j];
							b = cur[j+1];
							c = cur[j+2];
							d = (inc === 2) ? 0 : cur[j+3];
							cur[cnt++] = tmp = (inc === 3) ? new Segment(a, b, c, d) : new Segment(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
						}
						cur.length = cnt;
					}
					return obj;
				},
				_addCubicLengths = function(a, steps, resolution) {
					var inc = 1 / resolution,
						j = a.length,
						d, d1, s, da, ca, ba, p, i, inv, bez, index;
					while (--j > -1) {
						bez = a[j];
						s = bez.a;
						da = bez.d - s;
						ca = bez.c - s;
						ba = bez.b - s;
						d = d1 = 0;
						for (i = 1; i <= resolution; i++) {
							p = inc * i;
							inv = 1 - p;
							d = d1 - (d1 = (p * p * da + 3 * inv * (p * ca + inv * ba)) * p);
							index = j * resolution + i - 1;
							steps[index] = (steps[index] || 0) + d * d;
						}
					}
				},
				_parseLengthData = function(obj, resolution) {
					resolution = resolution >> 0 || 6;
					var a = [],
						lengths = [],
						d = 0,
						total = 0,
						threshold = resolution - 1,
						segments = [],
						curLS = [], //current length segments array
						p, i, l, index;
					for (p in obj) {
						_addCubicLengths(obj[p], a, resolution);
					}
					l = a.length;
					for (i = 0; i < l; i++) {
						d += Math.sqrt(a[i]);
						index = i % resolution;
						curLS[index] = d;
						if (index === threshold) {
							total += d;
							index = (i / resolution) >> 0;
							segments[index] = curLS;
							lengths[index] = total;
							d = 0;
							curLS = [];
						}
					}
					return {length:total, lengths:lengths, segments:segments};
				},
	
	
	
				BezierPlugin = _gsScope._gsDefine.plugin({
						propName: "bezier",
						priority: -1,
						version: "1.3.8",
						API: 2,
						global:true,
	
						//gets called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
						init: function(target, vars, tween) {
							this._target = target;
							if (vars instanceof Array) {
								vars = {values:vars};
							}
							this._func = {};
							this._mod = {};
							this._props = [];
							this._timeRes = (vars.timeResolution == null) ? 6 : parseInt(vars.timeResolution, 10);
							var values = vars.values || [],
								first = {},
								second = values[0],
								autoRotate = vars.autoRotate || tween.vars.orientToBezier,
								p, isFunc, i, j, prepend;
	
							this._autoRotate = autoRotate ? (autoRotate instanceof Array) ? autoRotate : [["x","y","rotation",((autoRotate === true) ? 0 : Number(autoRotate) || 0)]] : null;
							for (p in second) {
								this._props.push(p);
							}
	
							i = this._props.length;
							while (--i > -1) {
								p = this._props[i];
	
								this._overwriteProps.push(p);
								isFunc = this._func[p] = (typeof(target[p]) === "function");
								first[p] = (!isFunc) ? parseFloat(target[p]) : target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ]();
								if (!prepend) if (first[p] !== values[0][p]) {
									prepend = first;
								}
							}
							this._beziers = (vars.type !== "cubic" && vars.type !== "quadratic" && vars.type !== "soft") ? bezierThrough(values, isNaN(vars.curviness) ? 1 : vars.curviness, false, (vars.type === "thruBasic"), vars.correlate, prepend) : _parseBezierData(values, vars.type, first);
							this._segCount = this._beziers[p].length;
	
							if (this._timeRes) {
								var ld = _parseLengthData(this._beziers, this._timeRes);
								this._length = ld.length;
								this._lengths = ld.lengths;
								this._segments = ld.segments;
								this._l1 = this._li = this._s1 = this._si = 0;
								this._l2 = this._lengths[0];
								this._curSeg = this._segments[0];
								this._s2 = this._curSeg[0];
								this._prec = 1 / this._curSeg.length;
							}
	
							if ((autoRotate = this._autoRotate)) {
								this._initialRotations = [];
								if (!(autoRotate[0] instanceof Array)) {
									this._autoRotate = autoRotate = [autoRotate];
								}
								i = autoRotate.length;
								while (--i > -1) {
									for (j = 0; j < 3; j++) {
										p = autoRotate[i][j];
										this._func[p] = (typeof(target[p]) === "function") ? target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ] : false;
									}
									p = autoRotate[i][2];
									this._initialRotations[i] = (this._func[p] ? this._func[p].call(this._target) : this._target[p]) || 0;
									this._overwriteProps.push(p);
								}
							}
							this._startRatio = tween.vars.runBackwards ? 1 : 0; //we determine the starting ratio when the tween inits which is always 0 unless the tween has runBackwards:true (indicating it's a from() tween) in which case it's 1.
							return true;
						},
	
						//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
						set: function(v) {
							var segments = this._segCount,
								func = this._func,
								target = this._target,
								notStart = (v !== this._startRatio),
								curIndex, inv, i, p, b, t, val, l, lengths, curSeg;
							if (!this._timeRes) {
								curIndex = (v < 0) ? 0 : (v >= 1) ? segments - 1 : (segments * v) >> 0;
								t = (v - (curIndex * (1 / segments))) * segments;
							} else {
								lengths = this._lengths;
								curSeg = this._curSeg;
								v *= this._length;
								i = this._li;
								//find the appropriate segment (if the currently cached one isn't correct)
								if (v > this._l2 && i < segments - 1) {
									l = segments - 1;
									while (i < l && (this._l2 = lengths[++i]) <= v) {	}
									this._l1 = lengths[i-1];
									this._li = i;
									this._curSeg = curSeg = this._segments[i];
									this._s2 = curSeg[(this._s1 = this._si = 0)];
								} else if (v < this._l1 && i > 0) {
									while (i > 0 && (this._l1 = lengths[--i]) >= v) { }
									if (i === 0 && v < this._l1) {
										this._l1 = 0;
									} else {
										i++;
									}
									this._l2 = lengths[i];
									this._li = i;
									this._curSeg = curSeg = this._segments[i];
									this._s1 = curSeg[(this._si = curSeg.length - 1) - 1] || 0;
									this._s2 = curSeg[this._si];
								}
								curIndex = i;
								//now find the appropriate sub-segment (we split it into the number of pieces that was defined by "precision" and measured each one)
								v -= this._l1;
								i = this._si;
								if (v > this._s2 && i < curSeg.length - 1) {
									l = curSeg.length - 1;
									while (i < l && (this._s2 = curSeg[++i]) <= v) {	}
									this._s1 = curSeg[i-1];
									this._si = i;
								} else if (v < this._s1 && i > 0) {
									while (i > 0 && (this._s1 = curSeg[--i]) >= v) {	}
									if (i === 0 && v < this._s1) {
										this._s1 = 0;
									} else {
										i++;
									}
									this._s2 = curSeg[i];
									this._si = i;
								}
								t = ((i + (v - this._s1) / (this._s2 - this._s1)) * this._prec) || 0;
							}
							inv = 1 - t;
	
							i = this._props.length;
							while (--i > -1) {
								p = this._props[i];
								b = this._beziers[p][curIndex];
								val = (t * t * b.da + 3 * inv * (t * b.ca + inv * b.ba)) * t + b.a;
								if (this._mod[p]) {
									val = this._mod[p](val, target);
								}
								if (func[p]) {
									target[p](val);
								} else {
									target[p] = val;
								}
							}
	
							if (this._autoRotate) {
								var ar = this._autoRotate,
									b2, x1, y1, x2, y2, add, conv;
								i = ar.length;
								while (--i > -1) {
									p = ar[i][2];
									add = ar[i][3] || 0;
									conv = (ar[i][4] === true) ? 1 : _RAD2DEG;
									b = this._beziers[ar[i][0]];
									b2 = this._beziers[ar[i][1]];
	
									if (b && b2) { //in case one of the properties got overwritten.
										b = b[curIndex];
										b2 = b2[curIndex];
	
										x1 = b.a + (b.b - b.a) * t;
										x2 = b.b + (b.c - b.b) * t;
										x1 += (x2 - x1) * t;
										x2 += ((b.c + (b.d - b.c) * t) - x2) * t;
	
										y1 = b2.a + (b2.b - b2.a) * t;
										y2 = b2.b + (b2.c - b2.b) * t;
										y1 += (y2 - y1) * t;
										y2 += ((b2.c + (b2.d - b2.c) * t) - y2) * t;
	
										val = notStart ? Math.atan2(y2 - y1, x2 - x1) * conv + add : this._initialRotations[i];
	
										if (this._mod[p]) {
											val = this._mod[p](val, target); //for modProps
										}
	
										if (func[p]) {
											target[p](val);
										} else {
											target[p] = val;
										}
									}
								}
							}
						}
				}),
				p = BezierPlugin.prototype;
	
	
			BezierPlugin.bezierThrough = bezierThrough;
			BezierPlugin.cubicToQuadratic = cubicToQuadratic;
			BezierPlugin._autoCSS = true; //indicates that this plugin can be inserted into the "css" object using the autoCSS feature of TweenLite
			BezierPlugin.quadraticToCubic = function(a, b, c) {
				return new Segment(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
			};
	
			BezierPlugin._cssRegister = function() {
				var CSSPlugin = _globals.CSSPlugin;
				if (!CSSPlugin) {
					return;
				}
				var _internals = CSSPlugin._internals,
					_parseToProxy = _internals._parseToProxy,
					_setPluginRatio = _internals._setPluginRatio,
					CSSPropTween = _internals.CSSPropTween;
				_internals._registerComplexSpecialProp("bezier", {parser:function(t, e, prop, cssp, pt, plugin) {
					if (e instanceof Array) {
						e = {values:e};
					}
					plugin = new BezierPlugin();
					var values = e.values,
						l = values.length - 1,
						pluginValues = [],
						v = {},
						i, p, data;
					if (l < 0) {
						return pt;
					}
					for (i = 0; i <= l; i++) {
						data = _parseToProxy(t, values[i], cssp, pt, plugin, (l !== i));
						pluginValues[i] = data.end;
					}
					for (p in e) {
						v[p] = e[p]; //duplicate the vars object because we need to alter some things which would cause problems if the user plans to reuse the same vars object for another tween.
					}
					v.values = pluginValues;
					pt = new CSSPropTween(t, "bezier", 0, 0, data.pt, 2);
					pt.data = data;
					pt.plugin = plugin;
					pt.setRatio = _setPluginRatio;
					if (v.autoRotate === 0) {
						v.autoRotate = true;
					}
					if (v.autoRotate && !(v.autoRotate instanceof Array)) {
						i = (v.autoRotate === true) ? 0 : Number(v.autoRotate);
						v.autoRotate = (data.end.left != null) ? [["left","top","rotation",i,false]] : (data.end.x != null) ? [["x","y","rotation",i,false]] : false;
					}
					if (v.autoRotate) {
						if (!cssp._transform) {
							cssp._enableTransforms(false);
						}
						data.autoRotate = cssp._target._gsTransform;
						data.proxy.rotation = data.autoRotate.rotation || 0;
						cssp._overwriteProps.push("rotation");
					}
					plugin._onInitTween(data.proxy, v, cssp._tween);
					return pt;
				}});
			};
	
			p._mod = function(lookup) {
				var op = this._overwriteProps,
					i = op.length,
					val;
				while (--i > -1) {
					val = lookup[op[i]];
					if (val && typeof(val) === "function") {
						this._mod[op[i]] = val;
					}
				}
			};
	
			p._kill = function(lookup) {
				var a = this._props,
					p, i;
				for (p in this._beziers) {
					if (p in lookup) {
						delete this._beziers[p];
						delete this._func[p];
						i = a.length;
						while (--i > -1) {
							if (a[i] === p) {
								a.splice(i, 1);
							}
						}
					}
				}
				a = this._autoRotate;
				if (a) {
					i = a.length;
					while (--i > -1) {
						if (lookup[a[i][2]]) {
							a.splice(i, 1);
						}
					}
				}
				return this._super._kill.call(this, lookup);
			};
	
		}());
	
	
	
	
	
	
		
		
		
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * CSSPlugin
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("plugins.CSSPlugin", ["plugins.TweenPlugin","TweenLite"], function(TweenPlugin, TweenLite) {
	
			/** @constructor **/
			var CSSPlugin = function() {
					TweenPlugin.call(this, "css");
					this._overwriteProps.length = 0;
					this.setRatio = CSSPlugin.prototype.setRatio; //speed optimization (avoid prototype lookup on this "hot" method)
				},
				_globals = _gsScope._gsDefine.globals,
				_hasPriority, //turns true whenever a CSSPropTween instance is created that has a priority other than 0. This helps us discern whether or not we should spend the time organizing the linked list or not after a CSSPlugin's _onInitTween() method is called.
				_suffixMap, //we set this in _onInitTween() each time as a way to have a persistent variable we can use in other methods like _parse() without having to pass it around as a parameter and we keep _parse() decoupled from a particular CSSPlugin instance
				_cs, //computed style (we store this in a shared variable to conserve memory and make minification tighter
				_overwriteProps, //alias to the currently instantiating CSSPlugin's _overwriteProps array. We use this closure in order to avoid having to pass a reference around from method to method and aid in minification.
				_specialProps = {},
				p = CSSPlugin.prototype = new TweenPlugin("css");
	
			p.constructor = CSSPlugin;
			CSSPlugin.version = "1.20.4";
			CSSPlugin.API = 2;
			CSSPlugin.defaultTransformPerspective = 0;
			CSSPlugin.defaultSkewType = "compensated";
			CSSPlugin.defaultSmoothOrigin = true;
			p = "px"; //we'll reuse the "p" variable to keep file size down
			CSSPlugin.suffixMap = {top:p, right:p, bottom:p, left:p, width:p, height:p, fontSize:p, padding:p, margin:p, perspective:p, lineHeight:""};
	
	
			var _numExp = /(?:\-|\.|\b)(\d|\.|e\-)+/g,
				_relNumExp = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
				_valuesExp = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi, //finds all the values that begin with numbers or += or -= and then a number. Includes suffixes. We use this to split complex values apart like "1px 5px 20px rgb(255,102,51)"
				_NaNExp = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g, //also allows scientific notation and doesn't kill the leading -/+ in -= and +=
				_suffixExp = /(?:\d|\-|\+|=|#|\.)*/g,
				_opacityExp = /opacity *= *([^)]*)/i,
				_opacityValExp = /opacity:([^;]*)/i,
				_alphaFilterExp = /alpha\(opacity *=.+?\)/i,
				_rgbhslExp = /^(rgb|hsl)/,
				_capsExp = /([A-Z])/g,
				_camelExp = /-([a-z])/gi,
				_urlExp = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi, //for pulling out urls from url(...) or url("...") strings (some browsers wrap urls in quotes, some don't when reporting things like backgroundImage)
				_camelFunc = function(s, g) { return g.toUpperCase(); },
				_horizExp = /(?:Left|Right|Width)/i,
				_ieGetMatrixExp = /(M11|M12|M21|M22)=[\d\-\.e]+/gi,
				_ieSetMatrixExp = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,
				_commasOutsideParenExp = /,(?=[^\)]*(?:\(|$))/gi, //finds any commas that are not within parenthesis
				_complexExp = /[\s,\(]/i, //for testing a string to find if it has a space, comma, or open parenthesis (clues that it's a complex value)
				_DEG2RAD = Math.PI / 180,
				_RAD2DEG = 180 / Math.PI,
				_forcePT = {},
				_dummyElement = {style:{}},
				_doc = _gsScope.document || {createElement: function() {return _dummyElement;}},
				_createElement = function(type, ns) {
					return _doc.createElementNS ? _doc.createElementNS(ns || "http://www.w3.org/1999/xhtml", type) : _doc.createElement(type);
				},
				_tempDiv = _createElement("div"),
				_tempImg = _createElement("img"),
				_internals = CSSPlugin._internals = {_specialProps:_specialProps}, //provides a hook to a few internal methods that we need to access from inside other plugins
				_agent = (_gsScope.navigator || {}).userAgent || "",
				_autoRound,
				_reqSafariFix, //we won't apply the Safari transform fix until we actually come across a tween that affects a transform property (to maintain best performance).
	
				_isSafari,
				_isFirefox, //Firefox has a bug that causes 3D transformed elements to randomly disappear unless a repaint is forced after each update on each element.
				_isSafariLT6, //Safari (and Android 4 which uses a flavor of Safari) has a bug that prevents changes to "top" and "left" properties from rendering properly if changed on the same frame as a transform UNLESS we set the element's WebkitBackfaceVisibility to hidden (weird, I know). Doing this for Android 3 and earlier seems to actually cause other problems, though (fun!)
				_ieVers,
				_supportsOpacity = (function() { //we set _isSafari, _ieVers, _isFirefox, and _supportsOpacity all in one function here to reduce file size slightly, especially in the minified version.
					var i = _agent.indexOf("Android"),
						a = _createElement("a");
					_isSafari = (_agent.indexOf("Safari") !== -1 && _agent.indexOf("Chrome") === -1 && (i === -1 || parseFloat(_agent.substr(i+8, 2)) > 3));
					_isSafariLT6 = (_isSafari && (parseFloat(_agent.substr(_agent.indexOf("Version/")+8, 2)) < 6));
					_isFirefox = (_agent.indexOf("Firefox") !== -1);
					if ((/MSIE ([0-9]{1,}[\.0-9]{0,})/).exec(_agent) || (/Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/).exec(_agent)) {
						_ieVers = parseFloat( RegExp.$1 );
					}
					if (!a) {
						return false;
					}
					a.style.cssText = "top:1px;opacity:.55;";
					return /^0.55/.test(a.style.opacity);
				}()),
				_getIEOpacity = function(v) {
					return (_opacityExp.test( ((typeof(v) === "string") ? v : (v.currentStyle ? v.currentStyle.filter : v.style.filter) || "") ) ? ( parseFloat( RegExp.$1 ) / 100 ) : 1);
				},
				_log = function(s) {//for logging messages, but in a way that won't throw errors in old versions of IE.
					if (_gsScope.console) {
						console.log(s);
					}
				},
				_target, //when initting a CSSPlugin, we set this variable so that we can access it from within many other functions without having to pass it around as params
				_index, //when initting a CSSPlugin, we set this variable so that we can access it from within many other functions without having to pass it around as params
	
				_prefixCSS = "", //the non-camelCase vendor prefix like "-o-", "-moz-", "-ms-", or "-webkit-"
				_prefix = "", //camelCase vendor prefix like "O", "ms", "Webkit", or "Moz".
	
				// @private feed in a camelCase property name like "transform" and it will check to see if it is valid as-is or if it needs a vendor prefix. It returns the corrected camelCase property name (i.e. "WebkitTransform" or "MozTransform" or "transform" or null if no such property is found, like if the browser is IE8 or before, "transform" won't be found at all)
				_checkPropPrefix = function(p, e) {
					e = e || _tempDiv;
					var s = e.style,
						a, i;
					if (s[p] !== undefined) {
						return p;
					}
					p = p.charAt(0).toUpperCase() + p.substr(1);
					a = ["O","Moz","ms","Ms","Webkit"];
					i = 5;
					while (--i > -1 && s[a[i]+p] === undefined) { }
					if (i >= 0) {
						_prefix = (i === 3) ? "ms" : a[i];
						_prefixCSS = "-" + _prefix.toLowerCase() + "-";
						return _prefix + p;
					}
					return null;
				},
	
				_getComputedStyle = _doc.defaultView ? _doc.defaultView.getComputedStyle : function() {},
	
				/**
				 * @private Returns the css style for a particular property of an element. For example, to get whatever the current "left" css value for an element with an ID of "myElement", you could do:
				 * var currentLeft = CSSPlugin.getStyle( document.getElementById("myElement"), "left");
				 *
				 * @param {!Object} t Target element whose style property you want to query
				 * @param {!string} p Property name (like "left" or "top" or "marginTop", etc.)
				 * @param {Object=} cs Computed style object. This just provides a way to speed processing if you're going to get several properties on the same element in quick succession - you can reuse the result of the getComputedStyle() call.
				 * @param {boolean=} calc If true, the value will not be read directly from the element's "style" property (if it exists there), but instead the getComputedStyle() result will be used. This can be useful when you want to ensure that the browser itself is interpreting the value.
				 * @param {string=} dflt Default value that should be returned in the place of null, "none", "auto" or "auto auto".
				 * @return {?string} The current property value
				 */
				_getStyle = CSSPlugin.getStyle = function(t, p, cs, calc, dflt) {
					var rv;
					if (!_supportsOpacity) if (p === "opacity") { //several versions of IE don't use the standard "opacity" property - they use things like filter:alpha(opacity=50), so we parse that here.
						return _getIEOpacity(t);
					}
					if (!calc && t.style[p]) {
						rv = t.style[p];
					} else if ((cs = cs || _getComputedStyle(t))) {
						rv = cs[p] || cs.getPropertyValue(p) || cs.getPropertyValue(p.replace(_capsExp, "-$1").toLowerCase());
					} else if (t.currentStyle) {
						rv = t.currentStyle[p];
					}
					return (dflt != null && (!rv || rv === "none" || rv === "auto" || rv === "auto auto")) ? dflt : rv;
				},
	
				/**
				 * @private Pass the target element, the property name, the numeric value, and the suffix (like "%", "em", "px", etc.) and it will spit back the equivalent pixel number.
				 * @param {!Object} t Target element
				 * @param {!string} p Property name (like "left", "top", "marginLeft", etc.)
				 * @param {!number} v Value
				 * @param {string=} sfx Suffix (like "px" or "%" or "em")
				 * @param {boolean=} recurse If true, the call is a recursive one. In some browsers (like IE7/8), occasionally the value isn't accurately reported initially, but if we run the function again it will take effect.
				 * @return {number} value in pixels
				 */
				_convertToPixels = _internals.convertToPixels = function(t, p, v, sfx, recurse) {
					if (sfx === "px" || (!sfx && p !== "lineHeight")) { return v; }
					if (sfx === "auto" || !v) { return 0; }
					var horiz = _horizExp.test(p),
						node = t,
						style = _tempDiv.style,
						neg = (v < 0),
						precise = (v === 1),
						pix, cache, time;
					if (neg) {
						v = -v;
					}
					if (precise) {
						v *= 100;
					}
					if (p === "lineHeight" && !sfx) { //special case of when a simple lineHeight (without a unit) is used. Set it to the value, read back the computed value, and then revert.
						cache = _getComputedStyle(t).lineHeight;
						t.style.lineHeight = v;
						pix = parseFloat(_getComputedStyle(t).lineHeight);
						t.style.lineHeight = cache;
					} else if (sfx === "%" && p.indexOf("border") !== -1) {
						pix = (v / 100) * (horiz ? t.clientWidth : t.clientHeight);
					} else {
						style.cssText = "border:0 solid red;position:" + _getStyle(t, "position") + ";line-height:0;";
						if (sfx === "%" || !node.appendChild || sfx.charAt(0) === "v" || sfx === "rem") {
							node = t.parentNode || _doc.body;
							if (_getStyle(node, "display").indexOf("flex") !== -1) { //Edge and IE11 have a bug that causes offsetWidth to report as 0 if the container has display:flex and the child is position:relative. Switching to position: absolute solves it.
								style.position = "absolute";
							}
							cache = node._gsCache;
							time = TweenLite.ticker.frame;
							if (cache && horiz && cache.time === time) { //performance optimization: we record the width of elements along with the ticker frame so that we can quickly get it again on the same tick (seems relatively safe to assume it wouldn't change on the same tick)
								return cache.width * v / 100;
							}
							style[(horiz ? "width" : "height")] = v + sfx;
						} else {
							style[(horiz ? "borderLeftWidth" : "borderTopWidth")] = v + sfx;
						}
						node.appendChild(_tempDiv);
						pix = parseFloat(_tempDiv[(horiz ? "offsetWidth" : "offsetHeight")]);
						node.removeChild(_tempDiv);
						if (horiz && sfx === "%" && CSSPlugin.cacheWidths !== false) {
							cache = node._gsCache = node._gsCache || {};
							cache.time = time;
							cache.width = pix / v * 100;
						}
						if (pix === 0 && !recurse) {
							pix = _convertToPixels(t, p, v, sfx, true);
						}
					}
					if (precise) {
						pix /= 100;
					}
					return neg ? -pix : pix;
				},
				_calculateOffset = _internals.calculateOffset = function(t, p, cs) { //for figuring out "top" or "left" in px when it's "auto". We need to factor in margin with the offsetLeft/offsetTop
					if (_getStyle(t, "position", cs) !== "absolute") { return 0; }
					var dim = ((p === "left") ? "Left" : "Top"),
						v = _getStyle(t, "margin" + dim, cs);
					return t["offset" + dim] - (_convertToPixels(t, p, parseFloat(v), v.replace(_suffixExp, "")) || 0);
				},
	
				// @private returns at object containing ALL of the style properties in camelCase and their associated values.
				_getAllStyles = function(t, cs) {
					var s = {},
						i, tr, p;
					if ((cs = cs || _getComputedStyle(t, null))) {
						if ((i = cs.length)) {
							while (--i > -1) {
								p = cs[i];
								if (p.indexOf("-transform") === -1 || _transformPropCSS === p) { //Some webkit browsers duplicate transform values, one non-prefixed and one prefixed ("transform" and "WebkitTransform"), so we must weed out the extra one here.
									s[p.replace(_camelExp, _camelFunc)] = cs.getPropertyValue(p);
								}
							}
						} else { //some browsers behave differently - cs.length is always 0, so we must do a for...in loop.
							for (i in cs) {
								if (i.indexOf("Transform") === -1 || _transformProp === i) { //Some webkit browsers duplicate transform values, one non-prefixed and one prefixed ("transform" and "WebkitTransform"), so we must weed out the extra one here.
									s[i] = cs[i];
								}
							}
						}
					} else if ((cs = t.currentStyle || t.style)) {
						for (i in cs) {
							if (typeof(i) === "string" && s[i] === undefined) {
								s[i.replace(_camelExp, _camelFunc)] = cs[i];
							}
						}
					}
					if (!_supportsOpacity) {
						s.opacity = _getIEOpacity(t);
					}
					tr = _getTransform(t, cs, false);
					s.rotation = tr.rotation;
					s.skewX = tr.skewX;
					s.scaleX = tr.scaleX;
					s.scaleY = tr.scaleY;
					s.x = tr.x;
					s.y = tr.y;
					if (_supports3D) {
						s.z = tr.z;
						s.rotationX = tr.rotationX;
						s.rotationY = tr.rotationY;
						s.scaleZ = tr.scaleZ;
					}
					if (s.filters) {
						delete s.filters;
					}
					return s;
				},
	
				// @private analyzes two style objects (as returned by _getAllStyles()) and only looks for differences between them that contain tweenable values (like a number or color). It returns an object with a "difs" property which refers to an object containing only those isolated properties and values for tweening, and a "firstMPT" property which refers to the first MiniPropTween instance in a linked list that recorded all the starting values of the different properties so that we can revert to them at the end or beginning of the tween - we don't want the cascading to get messed up. The forceLookup parameter is an optional generic object with properties that should be forced into the results - this is necessary for className tweens that are overwriting others because imagine a scenario where a rollover/rollout adds/removes a class and the user swipes the mouse over the target SUPER fast, thus nothing actually changed yet and the subsequent comparison of the properties would indicate they match (especially when px rounding is taken into consideration), thus no tweening is necessary even though it SHOULD tween and remove those properties after the tween (otherwise the inline styles will contaminate things). See the className SpecialProp code for details.
				_cssDif = function(t, s1, s2, vars, forceLookup) {
					var difs = {},
						style = t.style,
						val, p, mpt;
					for (p in s2) {
						if (p !== "cssText") if (p !== "length") if (isNaN(p)) if (s1[p] !== (val = s2[p]) || (forceLookup && forceLookup[p])) if (p.indexOf("Origin") === -1) if (typeof(val) === "number" || typeof(val) === "string") {
							difs[p] = (val === "auto" && (p === "left" || p === "top")) ? _calculateOffset(t, p) : ((val === "" || val === "auto" || val === "none") && typeof(s1[p]) === "string" && s1[p].replace(_NaNExp, "") !== "") ? 0 : val; //if the ending value is defaulting ("" or "auto"), we check the starting value and if it can be parsed into a number (a string which could have a suffix too, like 700px), then we swap in 0 for "" or "auto" so that things actually tween.
							if (style[p] !== undefined) { //for className tweens, we must remember which properties already existed inline - the ones that didn't should be removed when the tween isn't in progress because they were only introduced to facilitate the transition between classes.
								mpt = new MiniPropTween(style, p, style[p], mpt);
							}
						}
					}
					if (vars) {
						for (p in vars) { //copy properties (except className)
							if (p !== "className") {
								difs[p] = vars[p];
							}
						}
					}
					return {difs:difs, firstMPT:mpt};
				},
				_dimensions = {width:["Left","Right"], height:["Top","Bottom"]},
				_margins = ["marginLeft","marginRight","marginTop","marginBottom"],
	
				/**
				 * @private Gets the width or height of an element
				 * @param {!Object} t Target element
				 * @param {!string} p Property name ("width" or "height")
				 * @param {Object=} cs Computed style object (if one exists). Just a speed optimization.
				 * @return {number} Dimension (in pixels)
				 */
				_getDimension = function(t, p, cs) {
					if ((t.nodeName + "").toLowerCase() === "svg") { //Chrome no longer supports offsetWidth/offsetHeight on SVG elements.
						return (cs || _getComputedStyle(t))[p] || 0;
					} else if (t.getCTM && _isSVG(t)) {
						return t.getBBox()[p] || 0;
					}
					var v = parseFloat((p === "width") ? t.offsetWidth : t.offsetHeight),
						a = _dimensions[p],
						i = a.length;
					cs = cs || _getComputedStyle(t, null);
					while (--i > -1) {
						v -= parseFloat( _getStyle(t, "padding" + a[i], cs, true) ) || 0;
						v -= parseFloat( _getStyle(t, "border" + a[i] + "Width", cs, true) ) || 0;
					}
					return v;
				},
	
				// @private Parses position-related complex strings like "top left" or "50px 10px" or "70% 20%", etc. which are used for things like transformOrigin or backgroundPosition. Optionally decorates a supplied object (recObj) with the following properties: "ox" (offsetX), "oy" (offsetY), "oxp" (if true, "ox" is a percentage not a pixel value), and "oxy" (if true, "oy" is a percentage not a pixel value)
				_parsePosition = function(v, recObj) {
					if (v === "contain" || v === "auto" || v === "auto auto") { //note: Firefox uses "auto auto" as default whereas Chrome uses "auto".
						return v + " ";
					}
					if (v == null || v === "") {
						v = "0 0";
					}
					var a = v.split(" "),
						x = (v.indexOf("left") !== -1) ? "0%" : (v.indexOf("right") !== -1) ? "100%" : a[0],
						y = (v.indexOf("top") !== -1) ? "0%" : (v.indexOf("bottom") !== -1) ? "100%" : a[1],
						i;
					if (a.length > 3 && !recObj) { //multiple positions
						a = v.split(", ").join(",").split(",");
						v = [];
						for (i = 0; i < a.length; i++) {
							v.push(_parsePosition(a[i]));
						}
						return v.join(",");
					}
					if (y == null) {
						y = (x === "center") ? "50%" : "0";
					} else if (y === "center") {
						y = "50%";
					}
					if (x === "center" || (isNaN(parseFloat(x)) && (x + "").indexOf("=") === -1)) { //remember, the user could flip-flop the values and say "bottom center" or "center bottom", etc. "center" is ambiguous because it could be used to describe horizontal or vertical, hence the isNaN(). If there's an "=" sign in the value, it's relative.
						x = "50%";
					}
					v = x + " " + y + ((a.length > 2) ? " " + a[2] : "");
					if (recObj) {
						recObj.oxp = (x.indexOf("%") !== -1);
						recObj.oyp = (y.indexOf("%") !== -1);
						recObj.oxr = (x.charAt(1) === "=");
						recObj.oyr = (y.charAt(1) === "=");
						recObj.ox = parseFloat(x.replace(_NaNExp, ""));
						recObj.oy = parseFloat(y.replace(_NaNExp, ""));
						recObj.v = v;
					}
					return recObj || v;
				},
	
				/**
				 * @private Takes an ending value (typically a string, but can be a number) and a starting value and returns the change between the two, looking for relative value indicators like += and -= and it also ignores suffixes (but make sure the ending value starts with a number or +=/-= and that the starting value is a NUMBER!)
				 * @param {(number|string)} e End value which is typically a string, but could be a number
				 * @param {(number|string)} b Beginning value which is typically a string but could be a number
				 * @return {number} Amount of change between the beginning and ending values (relative values that have a "+=" or "-=" are recognized)
				 */
				_parseChange = function(e, b) {
					if (typeof(e) === "function") {
						e = e(_index, _target);
					}
					return (typeof(e) === "string" && e.charAt(1) === "=") ? parseInt(e.charAt(0) + "1", 10) * parseFloat(e.substr(2)) : (parseFloat(e) - parseFloat(b)) || 0;
				},
	
				/**
				 * @private Takes a value and a default number, checks if the value is relative, null, or numeric and spits back a normalized number accordingly. Primarily used in the _parseTransform() function.
				 * @param {Object} v Value to be parsed
				 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
				 * @return {number} Parsed value
				 */
				_parseVal = function(v, d) {
					if (typeof(v) === "function") {
						v = v(_index, _target);
					}
					return (v == null) ? d : (typeof(v) === "string" && v.charAt(1) === "=") ? parseInt(v.charAt(0) + "1", 10) * parseFloat(v.substr(2)) + d : parseFloat(v) || 0;
				},
	
				/**
				 * @private Translates strings like "40deg" or "40" or 40rad" or "+=40deg" or "270_short" or "-90_cw" or "+=45_ccw" to a numeric radian angle. Of course a starting/default value must be fed in too so that relative values can be calculated properly.
				 * @param {Object} v Value to be parsed
				 * @param {!number} d Default value (which is also used for relative calculations if "+=" or "-=" is found in the first parameter)
				 * @param {string=} p property name for directionalEnd (optional - only used when the parsed value is directional ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation). Property name would be "rotation", "rotationX", or "rotationY"
				 * @param {Object=} directionalEnd An object that will store the raw end values for directional angles ("_short", "_cw", or "_ccw" suffix). We need a way to store the uncompensated value so that at the end of the tween, we set it to exactly what was requested with no directional compensation.
				 * @return {number} parsed angle in radians
				 */
				_parseAngle = function(v, d, p, directionalEnd) {
					var min = 0.000001,
						cap, split, dif, result, isRelative;
					if (typeof(v) === "function") {
						v = v(_index, _target);
					}
					if (v == null) {
						result = d;
					} else if (typeof(v) === "number") {
						result = v;
					} else {
						cap = 360;
						split = v.split("_");
						isRelative = (v.charAt(1) === "=");
						dif = (isRelative ? parseInt(v.charAt(0) + "1", 10) * parseFloat(split[0].substr(2)) : parseFloat(split[0])) * ((v.indexOf("rad") === -1) ? 1 : _RAD2DEG) - (isRelative ? 0 : d);
						if (split.length) {
							if (directionalEnd) {
								directionalEnd[p] = d + dif;
							}
							if (v.indexOf("short") !== -1) {
								dif = dif % cap;
								if (dif !== dif % (cap / 2)) {
									dif = (dif < 0) ? dif + cap : dif - cap;
								}
							}
							if (v.indexOf("_cw") !== -1 && dif < 0) {
								dif = ((dif + cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							} else if (v.indexOf("ccw") !== -1 && dif > 0) {
								dif = ((dif - cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							}
						}
						result = d + dif;
					}
					if (result < min && result > -min) {
						result = 0;
					}
					return result;
				},
	
				_colorLookup = {aqua:[0,255,255],
					lime:[0,255,0],
					silver:[192,192,192],
					black:[0,0,0],
					maroon:[128,0,0],
					teal:[0,128,128],
					blue:[0,0,255],
					navy:[0,0,128],
					white:[255,255,255],
					fuchsia:[255,0,255],
					olive:[128,128,0],
					yellow:[255,255,0],
					orange:[255,165,0],
					gray:[128,128,128],
					purple:[128,0,128],
					green:[0,128,0],
					red:[255,0,0],
					pink:[255,192,203],
					cyan:[0,255,255],
					transparent:[255,255,255,0]},
	
				_hue = function(h, m1, m2) {
					h = (h < 0) ? h + 1 : (h > 1) ? h - 1 : h;
					return ((((h * 6 < 1) ? m1 + (m2 - m1) * h * 6 : (h < 0.5) ? m2 : (h * 3 < 2) ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * 255) + 0.5) | 0;
				},
	
				/**
				 * @private Parses a color (like #9F0, #FF9900, rgb(255,51,153) or hsl(108, 50%, 10%)) into an array with 3 elements for red, green, and blue or if toHSL parameter is true, it will populate the array with hue, saturation, and lightness values. If a relative value is found in an hsl() or hsla() string, it will preserve those relative prefixes and all the values in the array will be strings instead of numbers (in all other cases it will be populated with numbers).
				 * @param {(string|number)} v The value the should be parsed which could be a string like #9F0 or rgb(255,102,51) or rgba(255,0,0,0.5) or it could be a number like 0xFF00CC or even a named color like red, blue, purple, etc.
				 * @param {(boolean)} toHSL If true, an hsl() or hsla() value will be returned instead of rgb() or rgba()
				 * @return {Array.<number>} An array containing red, green, and blue (and optionally alpha) in that order, or if the toHSL parameter was true, the array will contain hue, saturation and lightness (and optionally alpha) in that order. Always numbers unless there's a relative prefix found in an hsl() or hsla() string and toHSL is true.
				 */
				_parseColor = CSSPlugin.parseColor = function(v, toHSL) {
					var a, r, g, b, h, s, l, max, min, d, wasHSL;
					if (!v) {
						a = _colorLookup.black;
					} else if (typeof(v) === "number") {
						a = [v >> 16, (v >> 8) & 255, v & 255];
					} else {
						if (v.charAt(v.length - 1) === ",") { //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
							v = v.substr(0, v.length - 1);
						}
						if (_colorLookup[v]) {
							a = _colorLookup[v];
						} else if (v.charAt(0) === "#") {
							if (v.length === 4) { //for shorthand like #9F0
								r = v.charAt(1);
								g = v.charAt(2);
								b = v.charAt(3);
								v = "#" + r + r + g + g + b + b;
							}
							v = parseInt(v.substr(1), 16);
							a = [v >> 16, (v >> 8) & 255, v & 255];
						} else if (v.substr(0, 3) === "hsl") {
							a = wasHSL = v.match(_numExp);
							if (!toHSL) {
								h = (Number(a[0]) % 360) / 360;
								s = Number(a[1]) / 100;
								l = Number(a[2]) / 100;
								g = (l <= 0.5) ? l * (s + 1) : l + s - l * s;
								r = l * 2 - g;
								if (a.length > 3) {
									a[3] = Number(a[3]);
								}
								a[0] = _hue(h + 1 / 3, r, g);
								a[1] = _hue(h, r, g);
								a[2] = _hue(h - 1 / 3, r, g);
							} else if (v.indexOf("=") !== -1) { //if relative values are found, just return the raw strings with the relative prefixes in place.
								return v.match(_relNumExp);
							}
						} else {
							a = v.match(_numExp) || _colorLookup.transparent;
						}
						a[0] = Number(a[0]);
						a[1] = Number(a[1]);
						a[2] = Number(a[2]);
						if (a.length > 3) {
							a[3] = Number(a[3]);
						}
					}
					if (toHSL && !wasHSL) {
						r = a[0] / 255;
						g = a[1] / 255;
						b = a[2] / 255;
						max = Math.max(r, g, b);
						min = Math.min(r, g, b);
						l = (max + min) / 2;
						if (max === min) {
							h = s = 0;
						} else {
							d = max - min;
							s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
							h = (max === r) ? (g - b) / d + (g < b ? 6 : 0) : (max === g) ? (b - r) / d + 2 : (r - g) / d + 4;
							h *= 60;
						}
						a[0] = (h + 0.5) | 0;
						a[1] = (s * 100 + 0.5) | 0;
						a[2] = (l * 100 + 0.5) | 0;
					}
					return a;
				},
				_formatColors = function(s, toHSL) {
					var colors = s.match(_colorExp) || [],
						charIndex = 0,
						parsed = "",
						i, color, temp;
					if (!colors.length) {
						return s;
					}
					for (i = 0; i < colors.length; i++) {
						color = colors[i];
						temp = s.substr(charIndex, s.indexOf(color, charIndex)-charIndex);
						charIndex += temp.length + color.length;
						color = _parseColor(color, toHSL);
						if (color.length === 3) {
							color.push(1);
						}
						parsed += temp + (toHSL ? "hsla(" + color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : "rgba(" + color.join(",")) + ")";
					}
					return parsed + s.substr(charIndex);
				},
				_colorExp = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b"; //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.
	
			for (p in _colorLookup) {
				_colorExp += "|" + p + "\\b";
			}
			_colorExp = new RegExp(_colorExp+")", "gi");
	
			CSSPlugin.colorStringFilter = function(a) {
				var combined = a[0] + " " + a[1],
					toHSL;
				if (_colorExp.test(combined)) {
					toHSL = (combined.indexOf("hsl(") !== -1 || combined.indexOf("hsla(") !== -1);
					a[0] = _formatColors(a[0], toHSL);
					a[1] = _formatColors(a[1], toHSL);
				}
				_colorExp.lastIndex = 0;
			};
	
			if (!TweenLite.defaultStringFilter) {
				TweenLite.defaultStringFilter = CSSPlugin.colorStringFilter;
			}
	
			/**
			 * @private Returns a formatter function that handles taking a string (or number in some cases) and returning a consistently formatted one in terms of delimiters, quantity of values, etc. For example, we may get boxShadow values defined as "0px red" or "0px 0px 10px rgb(255,0,0)" or "0px 0px 20px 20px #F00" and we need to ensure that what we get back is described with 4 numbers and a color. This allows us to feed it into the _parseComplex() method and split the values up appropriately. The neat thing about this _getFormatter() function is that the dflt defines a pattern as well as a default, so for example, _getFormatter("0px 0px 0px 0px #777", true) not only sets the default as 0px for all distances and #777 for the color, but also sets the pattern such that 4 numbers and a color will always get returned.
			 * @param {!string} dflt The default value and pattern to follow. So "0px 0px 0px 0px #777" will ensure that 4 numbers and a color will always get returned.
			 * @param {boolean=} clr If true, the values should be searched for color-related data. For example, boxShadow values typically contain a color whereas borderRadius don't.
			 * @param {boolean=} collapsible If true, the value is a top/left/right/bottom style one that acts like margin or padding, where if only one value is received, it's used for all 4; if 2 are received, the first is duplicated for 3rd (bottom) and the 2nd is duplicated for the 4th spot (left), etc.
			 * @return {Function} formatter function
			 */
			var _getFormatter = function(dflt, clr, collapsible, multi) {
					if (dflt == null) {
						return function(v) {return v;};
					}
					var dColor = clr ? (dflt.match(_colorExp) || [""])[0] : "",
						dVals = dflt.split(dColor).join("").match(_valuesExp) || [],
						pfx = dflt.substr(0, dflt.indexOf(dVals[0])),
						sfx = (dflt.charAt(dflt.length - 1) === ")") ? ")" : "",
						delim = (dflt.indexOf(" ") !== -1) ? " " : ",",
						numVals = dVals.length,
						dSfx = (numVals > 0) ? dVals[0].replace(_numExp, "") : "",
						formatter;
					if (!numVals) {
						return function(v) {return v;};
					}
					if (clr) {
						formatter = function(v) {
							var color, vals, i, a;
							if (typeof(v) === "number") {
								v += dSfx;
							} else if (multi && _commasOutsideParenExp.test(v)) {
								a = v.replace(_commasOutsideParenExp, "|").split("|");
								for (i = 0; i < a.length; i++) {
									a[i] = formatter(a[i]);
								}
								return a.join(",");
							}
							color = (v.match(_colorExp) || [dColor])[0];
							vals = v.split(color).join("").match(_valuesExp) || [];
							i = vals.length;
							if (numVals > i--) {
								while (++i < numVals) {
									vals[i] = collapsible ? vals[(((i - 1) / 2) | 0)] : dVals[i];
								}
							}
							return pfx + vals.join(delim) + delim + color + sfx + (v.indexOf("inset") !== -1 ? " inset" : "");
						};
						return formatter;
	
					}
					formatter = function(v) {
						var vals, a, i;
						if (typeof(v) === "number") {
							v += dSfx;
						} else if (multi && _commasOutsideParenExp.test(v)) {
							a = v.replace(_commasOutsideParenExp, "|").split("|");
							for (i = 0; i < a.length; i++) {
								a[i] = formatter(a[i]);
							}
							return a.join(",");
						}
						vals = v.match(_valuesExp) || [];
						i = vals.length;
						if (numVals > i--) {
							while (++i < numVals) {
								vals[i] = collapsible ? vals[(((i - 1) / 2) | 0)] : dVals[i];
							}
						}
						return pfx + vals.join(delim) + sfx;
					};
					return formatter;
				},
	
				/**
				 * @private returns a formatter function that's used for edge-related values like marginTop, marginLeft, paddingBottom, paddingRight, etc. Just pass a comma-delimited list of property names related to the edges.
				 * @param {!string} props a comma-delimited list of property names in order from top to left, like "marginTop,marginRight,marginBottom,marginLeft"
				 * @return {Function} a formatter function
				 */
				_getEdgeParser = function(props) {
					props = props.split(",");
					return function(t, e, p, cssp, pt, plugin, vars) {
						var a = (e + "").split(" "),
							i;
						vars = {};
						for (i = 0; i < 4; i++) {
							vars[props[i]] = a[i] = a[i] || a[(((i - 1) / 2) >> 0)];
						}
						return cssp.parse(t, vars, pt, plugin);
					};
				},
	
				// @private used when other plugins must tween values first, like BezierPlugin or ThrowPropsPlugin, etc. That plugin's setRatio() gets called first so that the values are updated, and then we loop through the MiniPropTweens which handle copying the values into their appropriate slots so that they can then be applied correctly in the main CSSPlugin setRatio() method. Remember, we typically create a proxy object that has a bunch of uniquely-named properties that we feed to the sub-plugin and it does its magic normally, and then we must interpret those values and apply them to the css because often numbers must get combined/concatenated, suffixes added, etc. to work with css, like boxShadow could have 4 values plus a color.
				_setPluginRatio = _internals._setPluginRatio = function(v) {
					this.plugin.setRatio(v);
					var d = this.data,
						proxy = d.proxy,
						mpt = d.firstMPT,
						min = 0.000001,
						val, pt, i, str, p;
					while (mpt) {
						val = proxy[mpt.v];
						if (mpt.r) {
							val = Math.round(val);
						} else if (val < min && val > -min) {
							val = 0;
						}
						mpt.t[mpt.p] = val;
						mpt = mpt._next;
					}
					if (d.autoRotate) {
						d.autoRotate.rotation = d.mod ? d.mod(proxy.rotation, this.t) : proxy.rotation; //special case for ModifyPlugin to hook into an auto-rotating bezier
					}
					//at the end, we must set the CSSPropTween's "e" (end) value dynamically here because that's what is used in the final setRatio() method. Same for "b" at the beginning.
					if (v === 1 || v === 0) {
						mpt = d.firstMPT;
						p = (v === 1) ? "e" : "b";
						while (mpt) {
							pt = mpt.t;
							if (!pt.type) {
								pt[p] = pt.s + pt.xs0;
							} else if (pt.type === 1) {
								str = pt.xs0 + pt.s + pt.xs1;
								for (i = 1; i < pt.l; i++) {
									str += pt["xn"+i] + pt["xs"+(i+1)];
								}
								pt[p] = str;
							}
							mpt = mpt._next;
						}
					}
				},
	
				/**
				 * @private @constructor Used by a few SpecialProps to hold important values for proxies. For example, _parseToProxy() creates a MiniPropTween instance for each property that must get tweened on the proxy, and we record the original property name as well as the unique one we create for the proxy, plus whether or not the value needs to be rounded plus the original value.
				 * @param {!Object} t target object whose property we're tweening (often a CSSPropTween)
				 * @param {!string} p property name
				 * @param {(number|string|object)} v value
				 * @param {MiniPropTween=} next next MiniPropTween in the linked list
				 * @param {boolean=} r if true, the tweened value should be rounded to the nearest integer
				 */
				MiniPropTween = function(t, p, v, next, r) {
					this.t = t;
					this.p = p;
					this.v = v;
					this.r = r;
					if (next) {
						next._prev = this;
						this._next = next;
					}
				},
	
				/**
				 * @private Most other plugins (like BezierPlugin and ThrowPropsPlugin and others) can only tween numeric values, but CSSPlugin must accommodate special values that have a bunch of extra data (like a suffix or strings between numeric values, etc.). For example, boxShadow has values like "10px 10px 20px 30px rgb(255,0,0)" which would utterly confuse other plugins. This method allows us to split that data apart and grab only the numeric data and attach it to uniquely-named properties of a generic proxy object ({}) so that we can feed that to virtually any plugin to have the numbers tweened. However, we must also keep track of which properties from the proxy go with which CSSPropTween values and instances. So we create a linked list of MiniPropTweens. Each one records a target (the original CSSPropTween), property (like "s" or "xn1" or "xn2") that we're tweening and the unique property name that was used for the proxy (like "boxShadow_xn1" and "boxShadow_xn2") and whether or not they need to be rounded. That way, in the _setPluginRatio() method we can simply copy the values over from the proxy to the CSSPropTween instance(s). Then, when the main CSSPlugin setRatio() method runs and applies the CSSPropTween values accordingly, they're updated nicely. So the external plugin tweens the numbers, _setPluginRatio() copies them over, and setRatio() acts normally, applying css-specific values to the element.
				 * This method returns an object that has the following properties:
				 *  - proxy: a generic object containing the starting values for all the properties that will be tweened by the external plugin.  This is what we feed to the external _onInitTween() as the target
				 *  - end: a generic object containing the ending values for all the properties that will be tweened by the external plugin. This is what we feed to the external plugin's _onInitTween() as the destination values
				 *  - firstMPT: the first MiniPropTween in the linked list
				 *  - pt: the first CSSPropTween in the linked list that was created when parsing. If shallow is true, this linked list will NOT attach to the one passed into the _parseToProxy() as the "pt" (4th) parameter.
				 * @param {!Object} t target object to be tweened
				 * @param {!(Object|string)} vars the object containing the information about the tweening values (typically the end/destination values) that should be parsed
				 * @param {!CSSPlugin} cssp The CSSPlugin instance
				 * @param {CSSPropTween=} pt the next CSSPropTween in the linked list
				 * @param {TweenPlugin=} plugin the external TweenPlugin instance that will be handling tweening the numeric values
				 * @param {boolean=} shallow if true, the resulting linked list from the parse will NOT be attached to the CSSPropTween that was passed in as the "pt" (4th) parameter.
				 * @return An object containing the following properties: proxy, end, firstMPT, and pt (see above for descriptions)
				 */
				_parseToProxy = _internals._parseToProxy = function(t, vars, cssp, pt, plugin, shallow) {
					var bpt = pt,
						start = {},
						end = {},
						transform = cssp._transform,
						oldForce = _forcePT,
						i, p, xp, mpt, firstPT;
					cssp._transform = null;
					_forcePT = vars;
					pt = firstPT = cssp.parse(t, vars, pt, plugin);
					_forcePT = oldForce;
					//break off from the linked list so the new ones are isolated.
					if (shallow) {
						cssp._transform = transform;
						if (bpt) {
							bpt._prev = null;
							if (bpt._prev) {
								bpt._prev._next = null;
							}
						}
					}
					while (pt && pt !== bpt) {
						if (pt.type <= 1) {
							p = pt.p;
							end[p] = pt.s + pt.c;
							start[p] = pt.s;
							if (!shallow) {
								mpt = new MiniPropTween(pt, "s", p, mpt, pt.r);
								pt.c = 0;
							}
							if (pt.type === 1) {
								i = pt.l;
								while (--i > 0) {
									xp = "xn" + i;
									p = pt.p + "_" + xp;
									end[p] = pt.data[xp];
									start[p] = pt[xp];
									if (!shallow) {
										mpt = new MiniPropTween(pt, xp, p, mpt, pt.rxp[xp]);
									}
								}
							}
						}
						pt = pt._next;
					}
					return {proxy:start, end:end, firstMPT:mpt, pt:firstPT};
				},
	
	
	
				/**
				 * @constructor Each property that is tweened has at least one CSSPropTween associated with it. These instances store important information like the target, property, starting value, amount of change, etc. They can also optionally have a number of "extra" strings and numeric values named xs1, xn1, xs2, xn2, xs3, xn3, etc. where "s" indicates string and "n" indicates number. These can be pieced together in a complex-value tween (type:1) that has alternating types of data like a string, number, string, number, etc. For example, boxShadow could be "5px 5px 8px rgb(102, 102, 51)". In that value, there are 6 numbers that may need to tween and then pieced back together into a string again with spaces, suffixes, etc. xs0 is special in that it stores the suffix for standard (type:0) tweens, -OR- the first string (prefix) in a complex-value (type:1) CSSPropTween -OR- it can be the non-tweening value in a type:-1 CSSPropTween. We do this to conserve memory.
				 * CSSPropTweens have the following optional properties as well (not defined through the constructor):
				 *  - l: Length in terms of the number of extra properties that the CSSPropTween has (default: 0). For example, for a boxShadow we may need to tween 5 numbers in which case l would be 5; Keep in mind that the start/end values for the first number that's tweened are always stored in the s and c properties to conserve memory. All additional values thereafter are stored in xn1, xn2, etc.
				 *  - xfirst: The first instance of any sub-CSSPropTweens that are tweening properties of this instance. For example, we may split up a boxShadow tween so that there's a main CSSPropTween of type:1 that has various xs* and xn* values associated with the h-shadow, v-shadow, blur, color, etc. Then we spawn a CSSPropTween for each of those that has a higher priority and runs BEFORE the main CSSPropTween so that the values are all set by the time it needs to re-assemble them. The xfirst gives us an easy way to identify the first one in that chain which typically ends at the main one (because they're all prepende to the linked list)
				 *  - plugin: The TweenPlugin instance that will handle the tweening of any complex values. For example, sometimes we don't want to use normal subtweens (like xfirst refers to) to tween the values - we might want ThrowPropsPlugin or BezierPlugin some other plugin to do the actual tweening, so we create a plugin instance and store a reference here. We need this reference so that if we get a request to round values or disable a tween, we can pass along that request.
				 *  - data: Arbitrary data that needs to be stored with the CSSPropTween. Typically if we're going to have a plugin handle the tweening of a complex-value tween, we create a generic object that stores the END values that we're tweening to and the CSSPropTween's xs1, xs2, etc. have the starting values. We store that object as data. That way, we can simply pass that object to the plugin and use the CSSPropTween as the target.
				 *  - setRatio: Only used for type:2 tweens that require custom functionality. In this case, we call the CSSPropTween's setRatio() method and pass the ratio each time the tween updates. This isn't quite as efficient as doing things directly in the CSSPlugin's setRatio() method, but it's very convenient and flexible.
				 * @param {!Object} t Target object whose property will be tweened. Often a DOM element, but not always. It could be anything.
				 * @param {string} p Property to tween (name). For example, to tween element.width, p would be "width".
				 * @param {number} s Starting numeric value
				 * @param {number} c Change in numeric value over the course of the entire tween. For example, if element.width starts at 5 and should end at 100, c would be 95.
				 * @param {CSSPropTween=} next The next CSSPropTween in the linked list. If one is defined, we will define its _prev as the new instance, and the new instance's _next will be pointed at it.
				 * @param {number=} type The type of CSSPropTween where -1 = a non-tweening value, 0 = a standard simple tween, 1 = a complex value (like one that has multiple numbers in a comma- or space-delimited string like border:"1px solid red"), and 2 = one that uses a custom setRatio function that does all of the work of applying the values on each update.
				 * @param {string=} n Name of the property that should be used for overwriting purposes which is typically the same as p but not always. For example, we may need to create a subtween for the 2nd part of a "clip:rect(...)" tween in which case "p" might be xs1 but "n" is still "clip"
				 * @param {boolean=} r If true, the value(s) should be rounded
				 * @param {number=} pr Priority in the linked list order. Higher priority CSSPropTweens will be updated before lower priority ones. The default priority is 0.
				 * @param {string=} b Beginning value. We store this to ensure that it is EXACTLY what it was when the tween began without any risk of interpretation issues.
				 * @param {string=} e Ending value. We store this to ensure that it is EXACTLY what the user defined at the end of the tween without any risk of interpretation issues.
				 */
				CSSPropTween = _internals.CSSPropTween = function(t, p, s, c, next, type, n, r, pr, b, e) {
					this.t = t; //target
					this.p = p; //property
					this.s = s; //starting value
					this.c = c; //change value
					this.n = n || p; //name that this CSSPropTween should be associated to (usually the same as p, but not always - n is what overwriting looks at)
					if (!(t instanceof CSSPropTween)) {
						_overwriteProps.push(this.n);
					}
					this.r = r; //round (boolean)
					this.type = type || 0; //0 = normal tween, -1 = non-tweening (in which case xs0 will be applied to the target's property, like tp.t[tp.p] = tp.xs0), 1 = complex-value SpecialProp, 2 = custom setRatio() that does all the work
					if (pr) {
						this.pr = pr;
						_hasPriority = true;
					}
					this.b = (b === undefined) ? s : b;
					this.e = (e === undefined) ? s + c : e;
					if (next) {
						this._next = next;
						next._prev = this;
					}
				},
	
				_addNonTweeningNumericPT = function(target, prop, start, end, next, overwriteProp) { //cleans up some code redundancies and helps minification. Just a fast way to add a NUMERIC non-tweening CSSPropTween
					var pt = new CSSPropTween(target, prop, start, end - start, next, -1, overwriteProp);
					pt.b = start;
					pt.e = pt.xs0 = end;
					return pt;
				},
	
				/**
				 * Takes a target, the beginning value and ending value (as strings) and parses them into a CSSPropTween (possibly with child CSSPropTweens) that accommodates multiple numbers, colors, comma-delimited values, etc. For example:
				 * sp.parseComplex(element, "boxShadow", "5px 10px 20px rgb(255,102,51)", "0px 0px 0px red", true, "0px 0px 0px rgb(0,0,0,0)", pt);
				 * It will walk through the beginning and ending values (which should be in the same format with the same number and type of values) and figure out which parts are numbers, what strings separate the numeric/tweenable values, and then create the CSSPropTweens accordingly. If a plugin is defined, no child CSSPropTweens will be created. Instead, the ending values will be stored in the "data" property of the returned CSSPropTween like: {s:-5, xn1:-10, xn2:-20, xn3:255, xn4:0, xn5:0} so that it can be fed to any other plugin and it'll be plain numeric tweens but the recomposition of the complex value will be handled inside CSSPlugin's setRatio().
				 * If a setRatio is defined, the type of the CSSPropTween will be set to 2 and recomposition of the values will be the responsibility of that method.
				 *
				 * @param {!Object} t Target whose property will be tweened
				 * @param {!string} p Property that will be tweened (its name, like "left" or "backgroundColor" or "boxShadow")
				 * @param {string} b Beginning value
				 * @param {string} e Ending value
				 * @param {boolean} clrs If true, the value could contain a color value like "rgb(255,0,0)" or "#F00" or "red". The default is false, so no colors will be recognized (a performance optimization)
				 * @param {(string|number|Object)} dflt The default beginning value that should be used if no valid beginning value is defined or if the number of values inside the complex beginning and ending values don't match
				 * @param {?CSSPropTween} pt CSSPropTween instance that is the current head of the linked list (we'll prepend to this).
				 * @param {number=} pr Priority in the linked list order. Higher priority properties will be updated before lower priority ones. The default priority is 0.
				 * @param {TweenPlugin=} plugin If a plugin should handle the tweening of extra properties, pass the plugin instance here. If one is defined, then NO subtweens will be created for any extra properties (the properties will be created - just not additional CSSPropTween instances to tween them) because the plugin is expected to do so. However, the end values WILL be populated in the "data" property, like {s:100, xn1:50, xn2:300}
				 * @param {function(number)=} setRatio If values should be set in a custom function instead of being pieced together in a type:1 (complex-value) CSSPropTween, define that custom function here.
				 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parseComplex() call.
				 */
				_parseComplex = CSSPlugin.parseComplex = function(t, p, b, e, clrs, dflt, pt, pr, plugin, setRatio) {
					//DEBUG: _log("parseComplex: "+p+", b: "+b+", e: "+e);
					b = b || dflt || "";
					if (typeof(e) === "function") {
						e = e(_index, _target);
					}
					pt = new CSSPropTween(t, p, 0, 0, pt, (setRatio ? 2 : 1), null, false, pr, b, e);
					e += ""; //ensures it's a string
					if (clrs && _colorExp.test(e + b)) { //if colors are found, normalize the formatting to rgba() or hsla().
						e = [b, e];
						CSSPlugin.colorStringFilter(e);
						b = e[0];
						e = e[1];
					}
					var ba = b.split(", ").join(",").split(" "), //beginning array
						ea = e.split(", ").join(",").split(" "), //ending array
						l = ba.length,
						autoRound = (_autoRound !== false),
						i, xi, ni, bv, ev, bnums, enums, bn, hasAlpha, temp, cv, str, useHSL;
					if (e.indexOf(",") !== -1 || b.indexOf(",") !== -1) {
						if ((e + b).indexOf("rgb") !== -1 || (e + b).indexOf("hsl") !== -1) { //keep rgb(), rgba(), hsl(), and hsla() values together! (remember, we're splitting on spaces)
							ba = ba.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
							ea = ea.join(" ").replace(_commasOutsideParenExp, ", ").split(" ");
						} else {
							ba = ba.join(" ").split(",").join(", ").split(" ");
							ea = ea.join(" ").split(",").join(", ").split(" ");
						}
						l = ba.length;
					}
					if (l !== ea.length) {
						//DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
						ba = (dflt || "").split(" ");
						l = ba.length;
					}
					pt.plugin = plugin;
					pt.setRatio = setRatio;
					_colorExp.lastIndex = 0;
					for (i = 0; i < l; i++) {
						bv = ba[i];
						ev = ea[i];
						bn = parseFloat(bv);
						//if the value begins with a number (most common). It's fine if it has a suffix like px
						if (bn || bn === 0) {
							pt.appendXtra("", bn, _parseChange(ev, bn), ev.replace(_relNumExp, ""), (autoRound && ev.indexOf("px") !== -1), true);
	
						//if the value is a color
						} else if (clrs && _colorExp.test(bv)) {
							str = ev.indexOf(")") + 1;
							str = ")" + (str ? ev.substr(str) : ""); //if there's a comma or ) at the end, retain it.
							useHSL = (ev.indexOf("hsl") !== -1 && _supportsOpacity);
							temp = ev; //original string value so we can look for any prefix later.
							bv = _parseColor(bv, useHSL);
							ev = _parseColor(ev, useHSL);
							hasAlpha = (bv.length + ev.length > 6);
							if (hasAlpha && !_supportsOpacity && ev[3] === 0) { //older versions of IE don't support rgba(), so if the destination alpha is 0, just use "transparent" for the end color
								pt["xs" + pt.l] += pt.l ? " transparent" : "transparent";
								pt.e = pt.e.split(ea[i]).join("transparent");
							} else {
								if (!_supportsOpacity) { //old versions of IE don't support rgba().
									hasAlpha = false;
								}
								if (useHSL) {
									pt.appendXtra(temp.substr(0, temp.indexOf("hsl")) + (hasAlpha ? "hsla(" : "hsl("), bv[0], _parseChange(ev[0], bv[0]), ",", false, true)
										.appendXtra("", bv[1], _parseChange(ev[1], bv[1]), "%,", false)
										.appendXtra("", bv[2], _parseChange(ev[2], bv[2]), (hasAlpha ? "%," : "%" + str), false);
								} else {
									pt.appendXtra(temp.substr(0, temp.indexOf("rgb")) + (hasAlpha ? "rgba(" : "rgb("), bv[0], ev[0] - bv[0], ",", true, true)
										.appendXtra("", bv[1], ev[1] - bv[1], ",", true)
										.appendXtra("", bv[2], ev[2] - bv[2], (hasAlpha ? "," : str), true);
								}
	
								if (hasAlpha) {
									bv = (bv.length < 4) ? 1 : bv[3];
									pt.appendXtra("", bv, ((ev.length < 4) ? 1 : ev[3]) - bv, str, false);
								}
							}
							_colorExp.lastIndex = 0; //otherwise the test() on the RegExp could move the lastIndex and taint future results.
	
						} else {
							bnums = bv.match(_numExp); //gets each group of numbers in the beginning value string and drops them into an array
	
							//if no number is found, treat it as a non-tweening value and just append the string to the current xs.
							if (!bnums) {
								pt["xs" + pt.l] += (pt.l || pt["xs" + pt.l]) ? " " + ev : ev;
	
							//loop through all the numbers that are found and construct the extra values on the pt.
							} else {
								enums = ev.match(_relNumExp); //get each group of numbers in the end value string and drop them into an array. We allow relative values too, like +=50 or -=.5
								if (!enums || enums.length !== bnums.length) {
									//DEBUG: _log("mismatched formatting detected on " + p + " (" + b + " vs " + e + ")");
									return pt;
								}
								ni = 0;
								for (xi = 0; xi < bnums.length; xi++) {
									cv = bnums[xi];
									temp = bv.indexOf(cv, ni);
									pt.appendXtra(bv.substr(ni, temp - ni), Number(cv), _parseChange(enums[xi], cv), "", (autoRound && bv.substr(temp + cv.length, 2) === "px"), (xi === 0));
									ni = temp + cv.length;
								}
								pt["xs" + pt.l] += bv.substr(ni);
							}
						}
					}
					//if there are relative values ("+=" or "-=" prefix), we need to adjust the ending value to eliminate the prefixes and combine the values properly.
					if (e.indexOf("=") !== -1) if (pt.data) {
						str = pt.xs0 + pt.data.s;
						for (i = 1; i < pt.l; i++) {
							str += pt["xs" + i] + pt.data["xn" + i];
						}
						pt.e = str + pt["xs" + i];
					}
					if (!pt.l) {
						pt.type = -1;
						pt.xs0 = pt.e;
					}
					return pt.xfirst || pt;
				},
				i = 9;
	
	
			p = CSSPropTween.prototype;
			p.l = p.pr = 0; //length (number of extra properties like xn1, xn2, xn3, etc.
			while (--i > 0) {
				p["xn" + i] = 0;
				p["xs" + i] = "";
			}
			p.xs0 = "";
			p._next = p._prev = p.xfirst = p.data = p.plugin = p.setRatio = p.rxp = null;
	
	
			/**
			 * Appends and extra tweening value to a CSSPropTween and automatically manages any prefix and suffix strings. The first extra value is stored in the s and c of the main CSSPropTween instance, but thereafter any extras are stored in the xn1, xn2, xn3, etc. The prefixes and suffixes are stored in the xs0, xs1, xs2, etc. properties. For example, if I walk through a clip value like "rect(10px, 5px, 0px, 20px)", the values would be stored like this:
			 * xs0:"rect(", s:10, xs1:"px, ", xn1:5, xs2:"px, ", xn2:0, xs3:"px, ", xn3:20, xn4:"px)"
			 * And they'd all get joined together when the CSSPlugin renders (in the setRatio() method).
			 * @param {string=} pfx Prefix (if any)
			 * @param {!number} s Starting value
			 * @param {!number} c Change in numeric value over the course of the entire tween. For example, if the start is 5 and the end is 100, the change would be 95.
			 * @param {string=} sfx Suffix (if any)
			 * @param {boolean=} r Round (if true).
			 * @param {boolean=} pad If true, this extra value should be separated by the previous one by a space. If there is no previous extra and pad is true, it will automatically drop the space.
			 * @return {CSSPropTween} returns itself so that multiple methods can be chained together.
			 */
			p.appendXtra = function(pfx, s, c, sfx, r, pad) {
				var pt = this,
					l = pt.l;
				pt["xs" + l] += (pad && (l || pt["xs" + l])) ? " " + pfx : pfx || "";
				if (!c) if (l !== 0 && !pt.plugin) { //typically we'll combine non-changing values right into the xs to optimize performance, but we don't combine them when there's a plugin that will be tweening the values because it may depend on the values being split apart, like for a bezier, if a value doesn't change between the first and second iteration but then it does on the 3rd, we'll run into trouble because there's no xn slot for that value!
					pt["xs" + l] += s + (sfx || "");
					return pt;
				}
				pt.l++;
				pt.type = pt.setRatio ? 2 : 1;
				pt["xs" + pt.l] = sfx || "";
				if (l > 0) {
					pt.data["xn" + l] = s + c;
					pt.rxp["xn" + l] = r; //round extra property (we need to tap into this in the _parseToProxy() method)
					pt["xn" + l] = s;
					if (!pt.plugin) {
						pt.xfirst = new CSSPropTween(pt, "xn" + l, s, c, pt.xfirst || pt, 0, pt.n, r, pt.pr);
						pt.xfirst.xs0 = 0; //just to ensure that the property stays numeric which helps modern browsers speed up processing. Remember, in the setRatio() method, we do pt.t[pt.p] = val + pt.xs0 so if pt.xs0 is "" (the default), it'll cast the end value as a string. When a property is a number sometimes and a string sometimes, it prevents the compiler from locking in the data type, slowing things down slightly.
					}
					return pt;
				}
				pt.data = {s:s + c};
				pt.rxp = {};
				pt.s = s;
				pt.c = c;
				pt.r = r;
				return pt;
			};
	
			/**
			 * @constructor A SpecialProp is basically a css property that needs to be treated in a non-standard way, like if it may contain a complex value like boxShadow:"5px 10px 15px rgb(255, 102, 51)" or if it is associated with another plugin like ThrowPropsPlugin or BezierPlugin. Every SpecialProp is associated with a particular property name like "boxShadow" or "throwProps" or "bezier" and it will intercept those values in the vars object that's passed to the CSSPlugin and handle them accordingly.
			 * @param {!string} p Property name (like "boxShadow" or "throwProps")
			 * @param {Object=} options An object containing any of the following configuration options:
			 *                      - defaultValue: the default value
			 *                      - parser: A function that should be called when the associated property name is found in the vars. This function should return a CSSPropTween instance and it should ensure that it is properly inserted into the linked list. It will receive 4 paramters: 1) The target, 2) The value defined in the vars, 3) The CSSPlugin instance (whose _firstPT should be used for the linked list), and 4) A computed style object if one was calculated (this is a speed optimization that allows retrieval of starting values quicker)
			 *                      - formatter: a function that formats any value received for this special property (for example, boxShadow could take "5px 5px red" and format it to "5px 5px 0px 0px red" so that both the beginning and ending values have a common order and quantity of values.)
			 *                      - prefix: if true, we'll determine whether or not this property requires a vendor prefix (like Webkit or Moz or ms or O)
			 *                      - color: set this to true if the value for this SpecialProp may contain color-related values like rgb(), rgba(), etc.
			 *                      - priority: priority in the linked list order. Higher priority SpecialProps will be updated before lower priority ones. The default priority is 0.
			 *                      - multi: if true, the formatter should accommodate a comma-delimited list of values, like boxShadow could have multiple boxShadows listed out.
			 *                      - collapsible: if true, the formatter should treat the value like it's a top/right/bottom/left value that could be collapsed, like "5px" would apply to all, "5px, 10px" would use 5px for top/bottom and 10px for right/left, etc.
			 *                      - keyword: a special keyword that can [optionally] be found inside the value (like "inset" for boxShadow). This allows us to validate beginning/ending values to make sure they match (if the keyword is found in one, it'll be added to the other for consistency by default).
			 */
			var SpecialProp = function(p, options) {
					options = options || {};
					this.p = options.prefix ? _checkPropPrefix(p) || p : p;
					_specialProps[p] = _specialProps[this.p] = this;
					this.format = options.formatter || _getFormatter(options.defaultValue, options.color, options.collapsible, options.multi);
					if (options.parser) {
						this.parse = options.parser;
					}
					this.clrs = options.color;
					this.multi = options.multi;
					this.keyword = options.keyword;
					this.dflt = options.defaultValue;
					this.pr = options.priority || 0;
				},
	
				//shortcut for creating a new SpecialProp that can accept multiple properties as a comma-delimited list (helps minification). dflt can be an array for multiple values (we don't do a comma-delimited list because the default value may contain commas, like rect(0px,0px,0px,0px)). We attach this method to the SpecialProp class/object instead of using a private _createSpecialProp() method so that we can tap into it externally if necessary, like from another plugin.
				_registerComplexSpecialProp = _internals._registerComplexSpecialProp = function(p, options, defaults) {
					if (typeof(options) !== "object") {
						options = {parser:defaults}; //to make backwards compatible with older versions of BezierPlugin and ThrowPropsPlugin
					}
					var a = p.split(","),
						d = options.defaultValue,
						i, temp;
					defaults = defaults || [d];
					for (i = 0; i < a.length; i++) {
						options.prefix = (i === 0 && options.prefix);
						options.defaultValue = defaults[i] || d;
						temp = new SpecialProp(a[i], options);
					}
				},
	
				//creates a placeholder special prop for a plugin so that the property gets caught the first time a tween of it is attempted, and at that time it makes the plugin register itself, thus taking over for all future tweens of that property. This allows us to not mandate that things load in a particular order and it also allows us to log() an error that informs the user when they attempt to tween an external plugin-related property without loading its .js file.
				_registerPluginProp = _internals._registerPluginProp = function(p) {
					if (!_specialProps[p]) {
						var pluginName = p.charAt(0).toUpperCase() + p.substr(1) + "Plugin";
						_registerComplexSpecialProp(p, {parser:function(t, e, p, cssp, pt, plugin, vars) {
							var pluginClass = _globals.com.greensock.plugins[pluginName];
							if (!pluginClass) {
								_log("Error: " + pluginName + " js file not loaded.");
								return pt;
							}
							pluginClass._cssRegister();
							return _specialProps[p].parse(t, e, p, cssp, pt, plugin, vars);
						}});
					}
				};
	
	
			p = SpecialProp.prototype;
	
			/**
			 * Alias for _parseComplex() that automatically plugs in certain values for this SpecialProp, like its property name, whether or not colors should be sensed, the default value, and priority. It also looks for any keyword that the SpecialProp defines (like "inset" for boxShadow) and ensures that the beginning and ending values have the same number of values for SpecialProps where multi is true (like boxShadow and textShadow can have a comma-delimited list)
			 * @param {!Object} t target element
			 * @param {(string|number|object)} b beginning value
			 * @param {(string|number|object)} e ending (destination) value
			 * @param {CSSPropTween=} pt next CSSPropTween in the linked list
			 * @param {TweenPlugin=} plugin If another plugin will be tweening the complex value, that TweenPlugin instance goes here.
			 * @param {function=} setRatio If a custom setRatio() method should be used to handle this complex value, that goes here.
			 * @return {CSSPropTween=} First CSSPropTween in the linked list
			 */
			p.parseComplex = function(t, b, e, pt, plugin, setRatio) {
				var kwd = this.keyword,
					i, ba, ea, l, bi, ei;
				//if this SpecialProp's value can contain a comma-delimited list of values (like boxShadow or textShadow), we must parse them in a special way, and look for a keyword (like "inset" for boxShadow) and ensure that the beginning and ending BOTH have it if the end defines it as such. We also must ensure that there are an equal number of values specified (we can't tween 1 boxShadow to 3 for example)
				if (this.multi) if (_commasOutsideParenExp.test(e) || _commasOutsideParenExp.test(b)) {
					ba = b.replace(_commasOutsideParenExp, "|").split("|");
					ea = e.replace(_commasOutsideParenExp, "|").split("|");
				} else if (kwd) {
					ba = [b];
					ea = [e];
				}
				if (ea) {
					l = (ea.length > ba.length) ? ea.length : ba.length;
					for (i = 0; i < l; i++) {
						b = ba[i] = ba[i] || this.dflt;
						e = ea[i] = ea[i] || this.dflt;
						if (kwd) {
							bi = b.indexOf(kwd);
							ei = e.indexOf(kwd);
							if (bi !== ei) {
								if (ei === -1) { //if the keyword isn't in the end value, remove it from the beginning one.
									ba[i] = ba[i].split(kwd).join("");
								} else if (bi === -1) { //if the keyword isn't in the beginning, add it.
									ba[i] += " " + kwd;
								}
							}
						}
					}
					b = ba.join(", ");
					e = ea.join(", ");
				}
				return _parseComplex(t, this.p, b, e, this.clrs, this.dflt, pt, this.pr, plugin, setRatio);
			};
	
			/**
			 * Accepts a target and end value and spits back a CSSPropTween that has been inserted into the CSSPlugin's linked list and conforms with all the conventions we use internally, like type:-1, 0, 1, or 2, setting up any extra property tweens, priority, etc. For example, if we have a boxShadow SpecialProp and call:
			 * this._firstPT = sp.parse(element, "5px 10px 20px rgb(2550,102,51)", "boxShadow", this);
			 * It should figure out the starting value of the element's boxShadow, compare it to the provided end value and create all the necessary CSSPropTweens of the appropriate types to tween the boxShadow. The CSSPropTween that gets spit back should already be inserted into the linked list (the 4th parameter is the current head, so prepend to that).
			 * @param {!Object} t Target object whose property is being tweened
			 * @param {Object} e End value as provided in the vars object (typically a string, but not always - like a throwProps would be an object).
			 * @param {!string} p Property name
			 * @param {!CSSPlugin} cssp The CSSPlugin instance that should be associated with this tween.
			 * @param {?CSSPropTween} pt The CSSPropTween that is the current head of the linked list (we'll prepend to it)
			 * @param {TweenPlugin=} plugin If a plugin will be used to tween the parsed value, this is the plugin instance.
			 * @param {Object=} vars Original vars object that contains the data for parsing.
			 * @return {CSSPropTween} The first CSSPropTween in the linked list which includes the new one(s) added by the parse() call.
			 */
			p.parse = function(t, e, p, cssp, pt, plugin, vars) {
				return this.parseComplex(t.style, this.format(_getStyle(t, this.p, _cs, false, this.dflt)), this.format(e), pt, plugin);
			};
	
			/**
			 * Registers a special property that should be intercepted from any "css" objects defined in tweens. This allows you to handle them however you want without CSSPlugin doing it for you. The 2nd parameter should be a function that accepts 3 parameters:
			 *  1) Target object whose property should be tweened (typically a DOM element)
			 *  2) The end/destination value (could be a string, number, object, or whatever you want)
			 *  3) The tween instance (you probably don't need to worry about this, but it can be useful for looking up information like the duration)
			 *
			 * Then, your function should return a function which will be called each time the tween gets rendered, passing a numeric "ratio" parameter to your function that indicates the change factor (usually between 0 and 1). For example:
			 *
			 * CSSPlugin.registerSpecialProp("myCustomProp", function(target, value, tween) {
			 *      var start = target.style.width;
			 *      return function(ratio) {
			 *              target.style.width = (start + value * ratio) + "px";
			 *              console.log("set width to " + target.style.width);
			 *          }
			 * }, 0);
			 *
			 * Then, when I do this tween, it will trigger my special property:
			 *
			 * TweenLite.to(element, 1, {css:{myCustomProp:100}});
			 *
			 * In the example, of course, we're just changing the width, but you can do anything you want.
			 *
			 * @param {!string} name Property name (or comma-delimited list of property names) that should be intercepted and handled by your function. For example, if I define "myCustomProp", then it would handle that portion of the following tween: TweenLite.to(element, 1, {css:{myCustomProp:100}})
			 * @param {!function(Object, Object, Object, string):function(number)} onInitTween The function that will be called when a tween of this special property is performed. The function will receive 4 parameters: 1) Target object that should be tweened, 2) Value that was passed to the tween, 3) The tween instance itself (rarely used), and 4) The property name that's being tweened. Your function should return a function that should be called on every update of the tween. That function will receive a single parameter that is a "change factor" value (typically between 0 and 1) indicating the amount of change as a ratio. You can use this to determine how to set the values appropriately in your function.
			 * @param {number=} priority Priority that helps the engine determine the order in which to set the properties (default: 0). Higher priority properties will be updated before lower priority ones.
			 */
			CSSPlugin.registerSpecialProp = function(name, onInitTween, priority) {
				_registerComplexSpecialProp(name, {parser:function(t, e, p, cssp, pt, plugin, vars) {
					var rv = new CSSPropTween(t, p, 0, 0, pt, 2, p, false, priority);
					rv.plugin = plugin;
					rv.setRatio = onInitTween(t, e, cssp._tween, p);
					return rv;
				}, priority:priority});
			};
	
	
	
	
	
	
			//transform-related methods and properties
			CSSPlugin.useSVGTransformAttr = true; //Safari and Firefox both have some rendering bugs when applying CSS transforms to SVG elements, so default to using the "transform" attribute instead (users can override this).
			var _transformProps = ("scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent").split(","),
				_transformProp = _checkPropPrefix("transform"), //the Javascript (camelCase) transform property, like msTransform, WebkitTransform, MozTransform, or OTransform.
				_transformPropCSS = _prefixCSS + "transform",
				_transformOriginProp = _checkPropPrefix("transformOrigin"),
				_supports3D = (_checkPropPrefix("perspective") !== null),
				Transform = _internals.Transform = function() {
					this.perspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0;
					this.force3D = (CSSPlugin.defaultForce3D === false || !_supports3D) ? false : CSSPlugin.defaultForce3D || "auto";
				},
				_SVGElement = _gsScope.SVGElement,
				_useSVGTransformAttr,
				//Some browsers (like Firefox and IE) don't honor transform-origin properly in SVG elements, so we need to manually adjust the matrix accordingly. We feature detect here rather than always doing the conversion for certain browsers because they may fix the problem at some point in the future.
	
				_createSVG = function(type, container, attributes) {
					var element = _doc.createElementNS("http://www.w3.org/2000/svg", type),
						reg = /([a-z])([A-Z])/g,
						p;
					for (p in attributes) {
						element.setAttributeNS(null, p.replace(reg, "$1-$2").toLowerCase(), attributes[p]);
					}
					container.appendChild(element);
					return element;
				},
				_docElement = _doc.documentElement || {},
				_forceSVGTransformAttr = (function() {
					//IE and Android stock don't support CSS transforms on SVG elements, so we must write them to the "transform" attribute. We populate this variable in the _parseTransform() method, and only if/when we come across an SVG element
					var force = _ieVers || (/Android/i.test(_agent) && !_gsScope.chrome),
						svg, rect, width;
					if (_doc.createElementNS && !force) { //IE8 and earlier doesn't support SVG anyway
						svg = _createSVG("svg", _docElement);
						rect = _createSVG("rect", svg, {width:100, height:50, x:100});
						width = rect.getBoundingClientRect().width;
						rect.style[_transformOriginProp] = "50% 50%";
						rect.style[_transformProp] = "scaleX(0.5)";
						force = (width === rect.getBoundingClientRect().width && !(_isFirefox && _supports3D)); //note: Firefox fails the test even though it does support CSS transforms in 3D. Since we can't push 3D stuff into the transform attribute, we force Firefox to pass the test here (as long as it does truly support 3D).
						_docElement.removeChild(svg);
					}
					return force;
				})(),
				_parseSVGOrigin = function(e, local, decoratee, absolute, smoothOrigin, skipRecord) {
					var tm = e._gsTransform,
						m = _getMatrix(e, true),
						v, x, y, xOrigin, yOrigin, a, b, c, d, tx, ty, determinant, xOriginOld, yOriginOld;
					if (tm) {
						xOriginOld = tm.xOrigin; //record the original values before we alter them.
						yOriginOld = tm.yOrigin;
					}
					if (!absolute || (v = absolute.split(" ")).length < 2) {
						b = e.getBBox();
						if (b.x === 0 && b.y === 0 && b.width + b.height === 0) { //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
							b = {x: parseFloat(e.hasAttribute("x") ? e.getAttribute("x") : e.hasAttribute("cx") ? e.getAttribute("cx") : 0) || 0, y: parseFloat(e.hasAttribute("y") ? e.getAttribute("y") : e.hasAttribute("cy") ? e.getAttribute("cy") : 0) || 0, width:0, height:0};
						}
						local = _parsePosition(local).split(" ");
						v = [(local[0].indexOf("%") !== -1 ? parseFloat(local[0]) / 100 * b.width : parseFloat(local[0])) + b.x,
							 (local[1].indexOf("%") !== -1 ? parseFloat(local[1]) / 100 * b.height : parseFloat(local[1])) + b.y];
					}
					decoratee.xOrigin = xOrigin = parseFloat(v[0]);
					decoratee.yOrigin = yOrigin = parseFloat(v[1]);
					if (absolute && m !== _identity2DMatrix) { //if svgOrigin is being set, we must invert the matrix and determine where the absolute point is, factoring in the current transforms. Otherwise, the svgOrigin would be based on the element's non-transformed position on the canvas.
						a = m[0];
						b = m[1];
						c = m[2];
						d = m[3];
						tx = m[4];
						ty = m[5];
						determinant = (a * d - b * c);
						if (determinant) { //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
							x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + ((c * ty - d * tx) / determinant);
							y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - ((a * ty - b * tx) / determinant);
							xOrigin = decoratee.xOrigin = v[0] = x;
							yOrigin = decoratee.yOrigin = v[1] = y;
						}
					}
					if (tm) { //avoid jump when transformOrigin is changed - adjust the x/y values accordingly
						if (skipRecord) {
							decoratee.xOffset = tm.xOffset;
							decoratee.yOffset = tm.yOffset;
							tm = decoratee;
						}
						if (smoothOrigin || (smoothOrigin !== false && CSSPlugin.defaultSmoothOrigin !== false)) {
							x = xOrigin - xOriginOld;
							y = yOrigin - yOriginOld;
							//originally, we simply adjusted the x and y values, but that would cause problems if, for example, you created a rotational tween part-way through an x/y tween. Managing the offset in a separate variable gives us ultimate flexibility.
							//tm.x -= x - (x * m[0] + y * m[2]);
							//tm.y -= y - (x * m[1] + y * m[3]);
							tm.xOffset += (x * m[0] + y * m[2]) - x;
							tm.yOffset += (x * m[1] + y * m[3]) - y;
						} else {
							tm.xOffset = tm.yOffset = 0;
						}
					}
					if (!skipRecord) {
						e.setAttribute("data-svg-origin", v.join(" "));
					}
				},
				_getBBoxHack = function(swapIfPossible) { //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
					var svg = _createElement("svg", (this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns")) || "http://www.w3.org/2000/svg"),
						oldParent = this.parentNode,
						oldSibling = this.nextSibling,
						oldCSS = this.style.cssText,
						bbox;
					_docElement.appendChild(svg);
					svg.appendChild(this);
					this.style.display = "block";
					if (swapIfPossible) {
						try {
							bbox = this.getBBox();
							this._originalGetBBox = this.getBBox;
							this.getBBox = _getBBoxHack;
						} catch (e) { }
					} else if (this._originalGetBBox) {
						bbox = this._originalGetBBox();
					}
					if (oldSibling) {
						oldParent.insertBefore(this, oldSibling);
					} else {
						oldParent.appendChild(this);
					}
					_docElement.removeChild(svg);
					this.style.cssText = oldCSS;
					return bbox;
				},
				_getBBox = function(e) {
					try {
						return e.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
					} catch (error) {
						return _getBBoxHack.call(e, true);
					}
				},
				_isSVG = function(e) { //reports if the element is an SVG on which getBBox() actually works
					return !!(_SVGElement && e.getCTM && (!e.parentNode || e.ownerSVGElement) && _getBBox(e));
				},
				_identity2DMatrix = [1,0,0,1,0,0],
				_getMatrix = function(e, force2D) {
					var tm = e._gsTransform || new Transform(),
						rnd = 100000,
						style = e.style,
						isDefault, s, m, n, dec, none;
					if (_transformProp) {
						s = _getStyle(e, _transformPropCSS, null, true);
					} else if (e.currentStyle) {
						//for older versions of IE, we need to interpret the filter portion that is in the format: progid:DXImageTransform.Microsoft.Matrix(M11=6.123233995736766e-17, M12=-1, M21=1, M22=6.123233995736766e-17, sizingMethod='auto expand') Notice that we need to swap b and c compared to a normal matrix.
						s = e.currentStyle.filter.match(_ieGetMatrixExp);
						s = (s && s.length === 4) ? [s[0].substr(4), Number(s[2].substr(4)), Number(s[1].substr(4)), s[3].substr(4), (tm.x || 0), (tm.y || 0)].join(",") : "";
					}
					isDefault = (!s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)");
					if (_transformProp && ((none = (!_getComputedStyle(e) || _getComputedStyle(e).display === "none")) || !e.parentNode)) { //note: Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
						if (none) { //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
							n = style.display;
							style.display = "block";
						}
						if (!e.parentNode) {
							dec = 1; //flag
							_docElement.appendChild(e);
						}
						s = _getStyle(e, _transformPropCSS, null, true);
						isDefault = (!s || s === "none" || s === "matrix(1, 0, 0, 1, 0, 0)");
						if (n) {
							style.display = n;
						} else if (none) {
							_removeProp(style, "display");
						}
						if (dec) {
							_docElement.removeChild(e);
						}
					}
					if (tm.svg || (e.getCTM && _isSVG(e))) {
						if (isDefault && (style[_transformProp] + "").indexOf("matrix") !== -1) { //some browsers (like Chrome 40) don't correctly report transforms that are applied inline on an SVG element (they don't get included in the computed style), so we double-check here and accept matrix values
							s = style[_transformProp];
							isDefault = 0;
						}
						m = e.getAttribute("transform");
						if (isDefault && m) {
							m = e.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
							s = "matrix(" + m.a + "," + m.b + "," + m.c + "," + m.d + "," + m.e + "," + m.f + ")";
							isDefault = 0;
						}
					}
					if (isDefault) {
						return _identity2DMatrix;
					}
					//split the matrix values out into an array (m for matrix)
					m = (s || "").match(_numExp) || [];
					i = m.length;
					while (--i > -1) {
						n = Number(m[i]);
						m[i] = (dec = n - (n |= 0)) ? ((dec * rnd + (dec < 0 ? -0.5 : 0.5)) | 0) / rnd + n : n; //convert strings to Numbers and round to 5 decimal places to avoid issues with tiny numbers. Roughly 20x faster than Number.toFixed(). We also must make sure to round before dividing so that values like 0.9999999999 become 1 to avoid glitches in browser rendering and interpretation of flipped/rotated 3D matrices. And don't just multiply the number by rnd, floor it, and then divide by rnd because the bitwise operations max out at a 32-bit signed integer, thus it could get clipped at a relatively low value (like 22,000.00000 for example).
					}
					return (force2D && m.length > 6) ? [m[0], m[1], m[4], m[5], m[12], m[13]] : m;
				},
	
				/**
				 * Parses the transform values for an element, returning an object with x, y, z, scaleX, scaleY, scaleZ, rotation, rotationX, rotationY, skewX, and skewY properties. Note: by default (for performance reasons), all skewing is combined into skewX and rotation but skewY still has a place in the transform object so that we can record how much of the skew is attributed to skewX vs skewY. Remember, a skewY of 10 looks the same as a rotation of 10 and skewX of -10.
				 * @param {!Object} t target element
				 * @param {Object=} cs computed style object (optional)
				 * @param {boolean=} rec if true, the transform values will be recorded to the target element's _gsTransform object, like target._gsTransform = {x:0, y:0, z:0, scaleX:1...}
				 * @param {boolean=} parse if true, we'll ignore any _gsTransform values that already exist on the element, and force a reparsing of the css (calculated style)
				 * @return {object} object containing all of the transform properties/values like {x:0, y:0, z:0, scaleX:1...}
				 */
				_getTransform = _internals.getTransform = function(t, cs, rec, parse) {
					if (t._gsTransform && rec && !parse) {
						return t._gsTransform; //if the element already has a _gsTransform, use that. Note: some browsers don't accurately return the calculated style for the transform (particularly for SVG), so it's almost always safest to just use the values we've already applied rather than re-parsing things.
					}
					var tm = rec ? t._gsTransform || new Transform() : new Transform(),
						invX = (tm.scaleX < 0), //in order to interpret things properly, we need to know if the user applied a negative scaleX previously so that we can adjust the rotation and skewX accordingly. Otherwise, if we always interpret a flipped matrix as affecting scaleY and the user only wants to tween the scaleX on multiple sequential tweens, it would keep the negative scaleY without that being the user's intent.
						min = 0.00002,
						rnd = 100000,
						zOrigin = _supports3D ? parseFloat(_getStyle(t, _transformOriginProp, cs, false, "0 0 0").split(" ")[2]) || tm.zOrigin  || 0 : 0,
						defaultTransformPerspective = parseFloat(CSSPlugin.defaultTransformPerspective) || 0,
						m, i, scaleX, scaleY, rotation, skewX;
	
					tm.svg = !!(t.getCTM && _isSVG(t));
					if (tm.svg) {
						_parseSVGOrigin(t, _getStyle(t, _transformOriginProp, cs, false, "50% 50%") + "", tm, t.getAttribute("data-svg-origin"));
						_useSVGTransformAttr = CSSPlugin.useSVGTransformAttr || _forceSVGTransformAttr;
					}
					m = _getMatrix(t);
					if (m !== _identity2DMatrix) {
	
						if (m.length === 16) {
							//we'll only look at these position-related 6 variables first because if x/y/z all match, it's relatively safe to assume we don't need to re-parse everything which risks losing important rotational information (like rotationX:180 plus rotationY:180 would look the same as rotation:180 - there's no way to know for sure which direction was taken based solely on the matrix3d() values)
							var a11 = m[0], a21 = m[1], a31 = m[2], a41 = m[3],
								a12 = m[4], a22 = m[5], a32 = m[6], a42 = m[7],
								a13 = m[8], a23 = m[9], a33 = m[10],
								a14 = m[12], a24 = m[13], a34 = m[14],
								a43 = m[11],
								angle = Math.atan2(a32, a33),
								t1, t2, t3, t4, cos, sin;
							//we manually compensate for non-zero z component of transformOrigin to work around bugs in Safari
							if (tm.zOrigin) {
								a34 = -tm.zOrigin;
								a14 = a13*a34-m[12];
								a24 = a23*a34-m[13];
								a34 = a33*a34+tm.zOrigin-m[14];
							}
							//note for possible future consolidation: rotationX: Math.atan2(a32, a33), rotationY: Math.atan2(-a31, Math.sqrt(a33 * a33 + a32 * a32)), rotation: Math.atan2(a21, a11), skew: Math.atan2(a12, a22). However, it doesn't seem to be quite as reliable as the full-on backwards rotation procedure.
							tm.rotationX = angle * _RAD2DEG;
							//rotationX
							if (angle) {
								cos = Math.cos(-angle);
								sin = Math.sin(-angle);
								t1 = a12*cos+a13*sin;
								t2 = a22*cos+a23*sin;
								t3 = a32*cos+a33*sin;
								a13 = a12*-sin+a13*cos;
								a23 = a22*-sin+a23*cos;
								a33 = a32*-sin+a33*cos;
								a43 = a42*-sin+a43*cos;
								a12 = t1;
								a22 = t2;
								a32 = t3;
							}
							//rotationY
							angle = Math.atan2(-a31, a33);
							tm.rotationY = angle * _RAD2DEG;
							if (angle) {
								cos = Math.cos(-angle);
								sin = Math.sin(-angle);
								t1 = a11*cos-a13*sin;
								t2 = a21*cos-a23*sin;
								t3 = a31*cos-a33*sin;
								a23 = a21*sin+a23*cos;
								a33 = a31*sin+a33*cos;
								a43 = a41*sin+a43*cos;
								a11 = t1;
								a21 = t2;
								a31 = t3;
							}
							//rotationZ
							angle = Math.atan2(a21, a11);
							tm.rotation = angle * _RAD2DEG;
							if (angle) {
								cos = Math.cos(angle);
								sin = Math.sin(angle);
								t1 = a11*cos+a21*sin;
								t2 = a12*cos+a22*sin;
								t3 = a13*cos+a23*sin;
								a21 = a21*cos-a11*sin;
								a22 = a22*cos-a12*sin;
								a23 = a23*cos-a13*sin;
								a11 = t1;
								a12 = t2;
								a13 = t3;
							}
	
							if (tm.rotationX && Math.abs(tm.rotationX) + Math.abs(tm.rotation) > 359.9) { //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
								tm.rotationX = tm.rotation = 0;
								tm.rotationY = 180 - tm.rotationY;
							}
	
							//skewX
							angle = Math.atan2(a12, a22);
	
							//scales
							tm.scaleX = ((Math.sqrt(a11 * a11 + a21 * a21 + a31 * a31) * rnd + 0.5) | 0) / rnd;
							tm.scaleY = ((Math.sqrt(a22 * a22 + a32 * a32) * rnd + 0.5) | 0) / rnd;
							tm.scaleZ = ((Math.sqrt(a13 * a13 + a23 * a23 + a33 * a33) * rnd + 0.5) | 0) / rnd;
							a11 /= tm.scaleX;
							a12 /= tm.scaleY;
							a21 /= tm.scaleX;
							a22 /= tm.scaleY;
							if (Math.abs(angle) > min) {
								tm.skewX = angle * _RAD2DEG;
								a12 = 0; //unskews
								if (tm.skewType !== "simple") {
									tm.scaleY *= 1 / Math.cos(angle); //by default, we compensate the scale based on the skew so that the element maintains a similar proportion when skewed, so we have to alter the scaleY here accordingly to match the default (non-adjusted) skewing that CSS does (stretching more and more as it skews).
								}
	
							} else {
								tm.skewX = 0;
							}
	
							/* //for testing purposes
							var transform = "matrix3d(",
								comma = ",",
								zero = "0";
							a13 /= tm.scaleZ;
							a23 /= tm.scaleZ;
							a31 /= tm.scaleX;
							a32 /= tm.scaleY;
							a33 /= tm.scaleZ;
							transform += ((a11 < min && a11 > -min) ? zero : a11) + comma + ((a21 < min && a21 > -min) ? zero : a21) + comma + ((a31 < min && a31 > -min) ? zero : a31);
							transform += comma + ((a41 < min && a41 > -min) ? zero : a41) + comma + ((a12 < min && a12 > -min) ? zero : a12) + comma + ((a22 < min && a22 > -min) ? zero : a22);
							transform += comma + ((a32 < min && a32 > -min) ? zero : a32) + comma + ((a42 < min && a42 > -min) ? zero : a42) + comma + ((a13 < min && a13 > -min) ? zero : a13);
							transform += comma + ((a23 < min && a23 > -min) ? zero : a23) + comma + ((a33 < min && a33 > -min) ? zero : a33) + comma + ((a43 < min && a43 > -min) ? zero : a43) + comma;
							transform += a14 + comma + a24 + comma + a34 + comma + (tm.perspective ? (1 + (-a34 / tm.perspective)) : 1) + ")";
							console.log(transform);
							document.querySelector(".test").style[_transformProp] = transform;
							*/
	
							tm.perspective = a43 ? 1 / ((a43 < 0) ? -a43 : a43) : 0;
							tm.x = a14;
							tm.y = a24;
							tm.z = a34;
							if (tm.svg) {
								tm.x -= tm.xOrigin - (tm.xOrigin * a11 - tm.yOrigin * a12);
								tm.y -= tm.yOrigin - (tm.yOrigin * a21 - tm.xOrigin * a22);
							}
	
						} else if ((!_supports3D || parse || !m.length || tm.x !== m[4] || tm.y !== m[5] || (!tm.rotationX && !tm.rotationY))) { //sometimes a 6-element matrix is returned even when we performed 3D transforms, like if rotationX and rotationY are 180. In cases like this, we still need to honor the 3D transforms. If we just rely on the 2D info, it could affect how the data is interpreted, like scaleY might get set to -1 or rotation could get offset by 180 degrees. For example, do a TweenLite.to(element, 1, {css:{rotationX:180, rotationY:180}}) and then later, TweenLite.to(element, 1, {css:{rotationX:0}}) and without this conditional logic in place, it'd jump to a state of being unrotated when the 2nd tween starts. Then again, we need to honor the fact that the user COULD alter the transforms outside of CSSPlugin, like by manually applying new css, so we try to sense that by looking at x and y because if those changed, we know the changes were made outside CSSPlugin and we force a reinterpretation of the matrix values. Also, in Webkit browsers, if the element's "display" is "none", its calculated style value will always return empty, so if we've already recorded the values in the _gsTransform object, we'll just rely on those.
							var k = (m.length >= 6),
								a = k ? m[0] : 1,
								b = m[1] || 0,
								c = m[2] || 0,
								d = k ? m[3] : 1;
							tm.x = m[4] || 0;
							tm.y = m[5] || 0;
							scaleX = Math.sqrt(a * a + b * b);
							scaleY = Math.sqrt(d * d + c * c);
							rotation = (a || b) ? Math.atan2(b, a) * _RAD2DEG : tm.rotation || 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
							skewX = (c || d) ? Math.atan2(c, d) * _RAD2DEG + rotation : tm.skewX || 0;
							tm.scaleX = scaleX;
							tm.scaleY = scaleY;
							tm.rotation = rotation;
							tm.skewX = skewX;
							if (_supports3D) {
								tm.rotationX = tm.rotationY = tm.z = 0;
								tm.perspective = defaultTransformPerspective;
								tm.scaleZ = 1;
							}
							if (tm.svg) {
								tm.x -= tm.xOrigin - (tm.xOrigin * a + tm.yOrigin * c);
								tm.y -= tm.yOrigin - (tm.xOrigin * b + tm.yOrigin * d);
							}
						}
						if (Math.abs(tm.skewX) > 90 && Math.abs(tm.skewX) < 270) {
							if (invX) {
								tm.scaleX *= -1;
								tm.skewX += (tm.rotation <= 0) ? 180 : -180;
								tm.rotation += (tm.rotation <= 0) ? 180 : -180;
							} else {
								tm.scaleY *= -1;
								tm.skewX += (tm.skewX <= 0) ? 180 : -180;
							}
						}
						tm.zOrigin = zOrigin;
						//some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 0 in these cases. The conditional logic here is faster than calling Math.abs(). Also, browsers tend to render a SLIGHTLY rotated object in a fuzzy way, so we need to snap to exactly 0 when appropriate.
						for (i in tm) {
							if (tm[i] < min) if (tm[i] > -min) {
								tm[i] = 0;
							}
						}
					}
					//DEBUG: _log("parsed rotation of " + t.getAttribute("id")+": "+(tm.rotationX)+", "+(tm.rotationY)+", "+(tm.rotation)+", scale: "+tm.scaleX+", "+tm.scaleY+", "+tm.scaleZ+", position: "+tm.x+", "+tm.y+", "+tm.z+", perspective: "+tm.perspective+ ", origin: "+ tm.xOrigin+ ","+ tm.yOrigin);
					if (rec) {
						t._gsTransform = tm; //record to the object's _gsTransform which we use so that tweens can control individual properties independently (we need all the properties to accurately recompose the matrix in the setRatio() method)
						if (tm.svg) { //if we're supposed to apply transforms to the SVG element's "transform" attribute, make sure there aren't any CSS transforms applied or they'll override the attribute ones. Also clear the transform attribute if we're using CSS, just to be clean.
							if (_useSVGTransformAttr && t.style[_transformProp]) {
								TweenLite.delayedCall(0.001, function(){ //if we apply this right away (before anything has rendered), we risk there being no transforms for a brief moment and it also interferes with adjusting the transformOrigin in a tween with immediateRender:true (it'd try reading the matrix and it wouldn't have the appropriate data in place because we just removed it).
									_removeProp(t.style, _transformProp);
								});
							} else if (!_useSVGTransformAttr && t.getAttribute("transform")) {
								TweenLite.delayedCall(0.001, function(){
									t.removeAttribute("transform");
								});
							}
						}
					}
					return tm;
				},
	
				//for setting 2D transforms in IE6, IE7, and IE8 (must use a "filter" to emulate the behavior of modern day browser transforms)
				_setIETransformRatio = function(v) {
					var t = this.data, //refers to the element's _gsTransform object
						ang = -t.rotation * _DEG2RAD,
						skew = ang + t.skewX * _DEG2RAD,
						rnd = 100000,
						a = ((Math.cos(ang) * t.scaleX * rnd) | 0) / rnd,
						b = ((Math.sin(ang) * t.scaleX * rnd) | 0) / rnd,
						c = ((Math.sin(skew) * -t.scaleY * rnd) | 0) / rnd,
						d = ((Math.cos(skew) * t.scaleY * rnd) | 0) / rnd,
						style = this.t.style,
						cs = this.t.currentStyle,
						filters, val;
					if (!cs) {
						return;
					}
					val = b; //just for swapping the variables an inverting them (reused "val" to avoid creating another variable in memory). IE's filter matrix uses a non-standard matrix configuration (angle goes the opposite way, and b and c are reversed and inverted)
					b = -c;
					c = -val;
					filters = cs.filter;
					style.filter = ""; //remove filters so that we can accurately measure offsetWidth/offsetHeight
					var w = this.t.offsetWidth,
						h = this.t.offsetHeight,
						clip = (cs.position !== "absolute"),
						m = "progid:DXImageTransform.Microsoft.Matrix(M11=" + a + ", M12=" + b + ", M21=" + c + ", M22=" + d,
						ox = t.x + (w * t.xPercent / 100),
						oy = t.y + (h * t.yPercent / 100),
						dx, dy;
	
					//if transformOrigin is being used, adjust the offset x and y
					if (t.ox != null) {
						dx = ((t.oxp) ? w * t.ox * 0.01 : t.ox) - w / 2;
						dy = ((t.oyp) ? h * t.oy * 0.01 : t.oy) - h / 2;
						ox += dx - (dx * a + dy * b);
						oy += dy - (dx * c + dy * d);
					}
	
					if (!clip) {
						m += ", sizingMethod='auto expand')";
					} else {
						dx = (w / 2);
						dy = (h / 2);
						//translate to ensure that transformations occur around the correct origin (default is center).
						m += ", Dx=" + (dx - (dx * a + dy * b) + ox) + ", Dy=" + (dy - (dx * c + dy * d) + oy) + ")";
					}
					if (filters.indexOf("DXImageTransform.Microsoft.Matrix(") !== -1) {
						style.filter = filters.replace(_ieSetMatrixExp, m);
					} else {
						style.filter = m + " " + filters; //we must always put the transform/matrix FIRST (before alpha(opacity=xx)) to avoid an IE bug that slices part of the object when rotation is applied with alpha.
					}
	
					//at the end or beginning of the tween, if the matrix is normal (1, 0, 0, 1) and opacity is 100 (or doesn't exist), remove the filter to improve browser performance.
					if (v === 0 || v === 1) if (a === 1) if (b === 0) if (c === 0) if (d === 1) if (!clip || m.indexOf("Dx=0, Dy=0") !== -1) if (!_opacityExp.test(filters) || parseFloat(RegExp.$1) === 100) if (filters.indexOf("gradient(" && filters.indexOf("Alpha")) === -1) {
						style.removeAttribute("filter");
					}
	
					//we must set the margins AFTER applying the filter in order to avoid some bugs in IE8 that could (in rare scenarios) cause them to be ignored intermittently (vibration).
					if (!clip) {
						var mult = (_ieVers < 8) ? 1 : -1, //in Internet Explorer 7 and before, the box model is broken, causing the browser to treat the width/height of the actual rotated filtered image as the width/height of the box itself, but Microsoft corrected that in IE8. We must use a negative offset in IE8 on the right/bottom
							marg, prop, dif;
						dx = t.ieOffsetX || 0;
						dy = t.ieOffsetY || 0;
						t.ieOffsetX = Math.round((w - ((a < 0 ? -a : a) * w + (b < 0 ? -b : b) * h)) / 2 + ox);
						t.ieOffsetY = Math.round((h - ((d < 0 ? -d : d) * h + (c < 0 ? -c : c) * w)) / 2 + oy);
						for (i = 0; i < 4; i++) {
							prop = _margins[i];
							marg = cs[prop];
							//we need to get the current margin in case it is being tweened separately (we want to respect that tween's changes)
							val = (marg.indexOf("px") !== -1) ? parseFloat(marg) : _convertToPixels(this.t, prop, parseFloat(marg), marg.replace(_suffixExp, "")) || 0;
							if (val !== t[prop]) {
								dif = (i < 2) ? -t.ieOffsetX : -t.ieOffsetY; //if another tween is controlling a margin, we cannot only apply the difference in the ieOffsets, so we essentially zero-out the dx and dy here in that case. We record the margin(s) later so that we can keep comparing them, making this code very flexible.
							} else {
								dif = (i < 2) ? dx - t.ieOffsetX : dy - t.ieOffsetY;
							}
							style[prop] = (t[prop] = Math.round( val - dif * ((i === 0 || i === 2) ? 1 : mult) )) + "px";
						}
					}
				},
	
				/* translates a super small decimal to a string WITHOUT scientific notation
				_safeDecimal = function(n) {
					var s = (n < 0 ? -n : n) + "",
						a = s.split("e-");
					return (n < 0 ? "-0." : "0.") + new Array(parseInt(a[1], 10) || 0).join("0") + a[0].split(".").join("");
				},
				*/
	
				_setTransformRatio = _internals.set3DTransformRatio = _internals.setTransformRatio = function(v) {
					var t = this.data, //refers to the element's _gsTransform object
						style = this.t.style,
						angle = t.rotation,
						rotationX = t.rotationX,
						rotationY = t.rotationY,
						sx = t.scaleX,
						sy = t.scaleY,
						sz = t.scaleZ,
						x = t.x,
						y = t.y,
						z = t.z,
						isSVG = t.svg,
						perspective = t.perspective,
						force3D = t.force3D,
						skewY = t.skewY,
						skewX = t.skewX,
						t1,	a11, a12, a13, a21, a22, a23, a31, a32, a33, a41, a42, a43,
						zOrigin, min, cos, sin, t2, transform, comma, zero, skew, rnd;
					if (skewY) { //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
						skewX += skewY;
						angle += skewY;
					}
	
					//check to see if we should render as 2D (and SVGs must use 2D when _useSVGTransformAttr is true)
					if (((((v === 1 || v === 0) && force3D === "auto" && (this.tween._totalTime === this.tween._totalDuration || !this.tween._totalTime)) || !force3D) && !z && !perspective && !rotationY && !rotationX && sz === 1) || (_useSVGTransformAttr && isSVG) || !_supports3D) { //on the final render (which could be 0 for a from tween), if there are no 3D aspects, render in 2D to free up memory and improve performance especially on mobile devices. Check the tween's totalTime/totalDuration too in order to make sure it doesn't happen between repeats if it's a repeating tween.
	
						//2D
						if (angle || skewX || isSVG) {
							angle *= _DEG2RAD;
							skew = skewX * _DEG2RAD;
							rnd = 100000;
							a11 = Math.cos(angle) * sx;
							a21 = Math.sin(angle) * sx;
							a12 = Math.sin(angle - skew) * -sy;
							a22 = Math.cos(angle - skew) * sy;
							if (skew && t.skewType === "simple") { //by default, we compensate skewing on the other axis to make it look more natural, but you can set the skewType to "simple" to use the uncompensated skewing that CSS does
								t1 = Math.tan(skew - skewY * _DEG2RAD);
								t1 = Math.sqrt(1 + t1 * t1);
								a12 *= t1;
								a22 *= t1;
								if (skewY) {
									t1 = Math.tan(skewY * _DEG2RAD);
									t1 = Math.sqrt(1 + t1 * t1);
									a11 *= t1;
									a21 *= t1;
								}
							}
							if (isSVG) {
								x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
								y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
								if (_useSVGTransformAttr && (t.xPercent || t.yPercent)) { //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the matrix to simulate it.
									min = this.t.getBBox();
									x += t.xPercent * 0.01 * min.width;
									y += t.yPercent * 0.01 * min.height;
								}
								min = 0.000001;
								if (x < min) if (x > -min) {
									x = 0;
								}
								if (y < min) if (y > -min) {
									y = 0;
								}
							}
							transform = (((a11 * rnd) | 0) / rnd) + "," + (((a21 * rnd) | 0) / rnd) + "," + (((a12 * rnd) | 0) / rnd) + "," + (((a22 * rnd) | 0) / rnd) + "," + x + "," + y + ")";
							if (isSVG && _useSVGTransformAttr) {
								this.t.setAttribute("transform", "matrix(" + transform);
							} else {
								//some browsers have a hard time with very small values like 2.4492935982947064e-16 (notice the "e-" towards the end) and would render the object slightly off. So we round to 5 decimal places.
								style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + transform;
							}
						} else {
							style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix(" : "matrix(") + sx + ",0,0," + sy + "," + x + "," + y + ")";
						}
						return;
	
					}
					if (_isFirefox) { //Firefox has a bug (at least in v25) that causes it to render the transparent part of 32-bit PNG images as black when displayed inside an iframe and the 3D scale is very small and doesn't change sufficiently enough between renders (like if you use a Power4.easeInOut to scale from 0 to 1 where the beginning values only change a tiny amount to begin the tween before accelerating). In this case, we force the scale to be 0.00002 instead which is visually the same but works around the Firefox issue.
						min = 0.0001;
						if (sx < min && sx > -min) {
							sx = sz = 0.00002;
						}
						if (sy < min && sy > -min) {
							sy = sz = 0.00002;
						}
						if (perspective && !t.z && !t.rotationX && !t.rotationY) { //Firefox has a bug that causes elements to have an odd super-thin, broken/dotted black border on elements that have a perspective set but aren't utilizing 3D space (no rotationX, rotationY, or z).
							perspective = 0;
						}
					}
					if (angle || skewX) {
						angle *= _DEG2RAD;
						cos = a11 = Math.cos(angle);
						sin = a21 = Math.sin(angle);
						if (skewX) {
							angle -= skewX * _DEG2RAD;
							cos = Math.cos(angle);
							sin = Math.sin(angle);
							if (t.skewType === "simple") { //by default, we compensate skewing on the other axis to make it look more natural, but you can set the skewType to "simple" to use the uncompensated skewing that CSS does
								t1 = Math.tan((skewX - skewY) * _DEG2RAD);
								t1 = Math.sqrt(1 + t1 * t1);
								cos *= t1;
								sin *= t1;
								if (t.skewY) {
									t1 = Math.tan(skewY * _DEG2RAD);
									t1 = Math.sqrt(1 + t1 * t1);
									a11 *= t1;
									a21 *= t1;
								}
							}
						}
						a12 = -sin;
						a22 = cos;
	
					} else if (!rotationY && !rotationX && sz === 1 && !perspective && !isSVG) { //if we're only translating and/or 2D scaling, this is faster...
						style[_transformProp] = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) translate3d(" : "translate3d(") + x + "px," + y + "px," + z +"px)" + ((sx !== 1 || sy !== 1) ? " scale(" + sx + "," + sy + ")" : "");
						return;
					} else {
						a11 = a22 = 1;
						a12 = a21 = 0;
					}
					// KEY  INDEX   AFFECTS a[row][column]
					// a11  0       rotation, rotationY, scaleX
					// a21  1       rotation, rotationY, scaleX
					// a31  2       rotationY, scaleX
					// a41  3       rotationY, scaleX
					// a12  4       rotation, skewX, rotationX, scaleY
					// a22  5       rotation, skewX, rotationX, scaleY
					// a32  6       rotationX, scaleY
					// a42  7       rotationX, scaleY
					// a13  8       rotationY, rotationX, scaleZ
					// a23  9       rotationY, rotationX, scaleZ
					// a33  10      rotationY, rotationX, scaleZ
					// a43  11      rotationY, rotationX, perspective, scaleZ
					// a14  12      x, zOrigin, svgOrigin
					// a24  13      y, zOrigin, svgOrigin
					// a34  14      z, zOrigin
					// a44  15
					// rotation: Math.atan2(a21, a11)
					// rotationY: Math.atan2(a13, a33) (or Math.atan2(a13, a11))
					// rotationX: Math.atan2(a32, a33)
					a33 = 1;
					a13 = a23 = a31 = a32 = a41 = a42 = 0;
					a43 = (perspective) ? -1 / perspective : 0;
					zOrigin = t.zOrigin;
					min = 0.000001; //threshold below which browsers use scientific notation which won't work.
					comma = ",";
					zero = "0";
					angle = rotationY * _DEG2RAD;
					if (angle) {
						cos = Math.cos(angle);
						sin = Math.sin(angle);
						a31 = -sin;
						a41 = a43*-sin;
						a13 = a11*sin;
						a23 = a21*sin;
						a33 = cos;
						a43 *= cos;
						a11 *= cos;
						a21 *= cos;
					}
					angle = rotationX * _DEG2RAD;
					if (angle) {
						cos = Math.cos(angle);
						sin = Math.sin(angle);
						t1 = a12*cos+a13*sin;
						t2 = a22*cos+a23*sin;
						a32 = a33*sin;
						a42 = a43*sin;
						a13 = a12*-sin+a13*cos;
						a23 = a22*-sin+a23*cos;
						a33 = a33*cos;
						a43 = a43*cos;
						a12 = t1;
						a22 = t2;
					}
					if (sz !== 1) {
						a13*=sz;
						a23*=sz;
						a33*=sz;
						a43*=sz;
					}
					if (sy !== 1) {
						a12*=sy;
						a22*=sy;
						a32*=sy;
						a42*=sy;
					}
					if (sx !== 1) {
						a11*=sx;
						a21*=sx;
						a31*=sx;
						a41*=sx;
					}
	
					if (zOrigin || isSVG) {
						if (zOrigin) {
							x += a13*-zOrigin;
							y += a23*-zOrigin;
							z += a33*-zOrigin+zOrigin;
						}
						if (isSVG) { //due to bugs in some browsers, we need to manage the transform-origin of SVG manually
							x += t.xOrigin - (t.xOrigin * a11 + t.yOrigin * a12) + t.xOffset;
							y += t.yOrigin - (t.xOrigin * a21 + t.yOrigin * a22) + t.yOffset;
						}
						if (x < min && x > -min) {
							x = zero;
						}
						if (y < min && y > -min) {
							y = zero;
						}
						if (z < min && z > -min) {
							z = 0; //don't use string because we calculate perspective later and need the number.
						}
					}
	
					//optimized way of concatenating all the values into a string. If we do it all in one shot, it's slower because of the way browsers have to create temp strings and the way it affects memory. If we do it piece-by-piece with +=, it's a bit slower too. We found that doing it in these sized chunks works best overall:
					transform = ((t.xPercent || t.yPercent) ? "translate(" + t.xPercent + "%," + t.yPercent + "%) matrix3d(" : "matrix3d(");
					transform += ((a11 < min && a11 > -min) ? zero : a11) + comma + ((a21 < min && a21 > -min) ? zero : a21) + comma + ((a31 < min && a31 > -min) ? zero : a31);
					transform += comma + ((a41 < min && a41 > -min) ? zero : a41) + comma + ((a12 < min && a12 > -min) ? zero : a12) + comma + ((a22 < min && a22 > -min) ? zero : a22);
					if (rotationX || rotationY || sz !== 1) { //performance optimization (often there's no rotationX or rotationY, so we can skip these calculations)
						transform += comma + ((a32 < min && a32 > -min) ? zero : a32) + comma + ((a42 < min && a42 > -min) ? zero : a42) + comma + ((a13 < min && a13 > -min) ? zero : a13);
						transform += comma + ((a23 < min && a23 > -min) ? zero : a23) + comma + ((a33 < min && a33 > -min) ? zero : a33) + comma + ((a43 < min && a43 > -min) ? zero : a43) + comma;
					} else {
						transform += ",0,0,0,0,1,0,";
					}
					transform += x + comma + y + comma + z + comma + (perspective ? (1 + (-z / perspective)) : 1) + ")";
	
					style[_transformProp] = transform;
				};
	
			p = Transform.prototype;
			p.x = p.y = p.z = p.skewX = p.skewY = p.rotation = p.rotationX = p.rotationY = p.zOrigin = p.xPercent = p.yPercent = p.xOffset = p.yOffset = 0;
			p.scaleX = p.scaleY = p.scaleZ = 1;
	
			_registerComplexSpecialProp("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin", {parser:function(t, e, parsingProp, cssp, pt, plugin, vars) {
				if (cssp._lastParsedTransform === vars) { return pt; } //only need to parse the transform once, and only if the browser supports it.
				cssp._lastParsedTransform = vars;
				var scaleFunc = (vars.scale && typeof(vars.scale) === "function") ? vars.scale : 0, //if there's a function-based "scale" value, swap in the resulting numeric value temporarily. Otherwise, if it's called for both scaleX and scaleY independently, they may not match (like if the function uses Math.random()).
					swapFunc;
				if (typeof(vars[parsingProp]) === "function") { //whatever property triggers the initial parsing might be a function-based value in which case it already got called in parse(), thus we don't want to call it again in here. The most efficient way to avoid this is to temporarily swap the value directly into the vars object, and then after we do all our parsing in this function, we'll swap it back again.
					swapFunc = vars[parsingProp];
					vars[parsingProp] = e;
				}
				if (scaleFunc) {
					vars.scale = scaleFunc(_index, t);
				}
				var originalGSTransform = t._gsTransform,
					style = t.style,
					min = 0.000001,
					i = _transformProps.length,
					v = vars,
					endRotations = {},
					transformOriginString = "transformOrigin",
					m1 = _getTransform(t, _cs, true, v.parseTransform),
					orig = v.transform && ((typeof(v.transform) === "function") ? v.transform(_index, _target) : v.transform),
					m2, copy, has3D, hasChange, dr, x, y, matrix, p;
				m1.skewType = v.skewType || m1.skewType || CSSPlugin.defaultSkewType;
				cssp._transform = m1;
				if (orig && typeof(orig) === "string" && _transformProp) { //for values like transform:"rotate(60deg) scale(0.5, 0.8)"
					copy = _tempDiv.style; //don't use the original target because it might be SVG in which case some browsers don't report computed style correctly.
					copy[_transformProp] = orig;
					copy.display = "block"; //if display is "none", the browser often refuses to report the transform properties correctly.
					copy.position = "absolute";
					_doc.body.appendChild(_tempDiv);
					m2 = _getTransform(_tempDiv, null, false);
					if (m1.skewType === "simple") { //the default _getTransform() reports the skewX/scaleY as if skewType is "compensated", thus we need to adjust that here if skewType is "simple".
						m2.scaleY *= Math.cos(m2.skewX * _DEG2RAD);
					}
					if (m1.svg) { //if it's an SVG element, x/y part of the matrix will be affected by whatever we use as the origin and the offsets, so compensate here...
						x = m1.xOrigin;
						y = m1.yOrigin;
						m2.x -= m1.xOffset;
						m2.y -= m1.yOffset;
						if (v.transformOrigin || v.svgOrigin) { //if this tween is altering the origin, we must factor that in here. The actual work of recording the transformOrigin values and setting up the PropTween is done later (still inside this function) so we cannot leave the changes intact here - we only want to update the x/y accordingly.
							orig = {};
							_parseSVGOrigin(t, _parsePosition(v.transformOrigin), orig, v.svgOrigin, v.smoothOrigin, true);
							x = orig.xOrigin;
							y = orig.yOrigin;
							m2.x -= orig.xOffset - m1.xOffset;
							m2.y -= orig.yOffset - m1.yOffset;
						}
						if (x || y) {
							matrix = _getMatrix(_tempDiv, true);
							m2.x -= x - (x * matrix[0] + y * matrix[2]);
							m2.y -= y - (x * matrix[1] + y * matrix[3]);
						}
					}
					_doc.body.removeChild(_tempDiv);
					if (!m2.perspective) {
						m2.perspective = m1.perspective; //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
					}
					if (v.xPercent != null) {
						m2.xPercent = _parseVal(v.xPercent, m1.xPercent);
					}
					if (v.yPercent != null) {
						m2.yPercent = _parseVal(v.yPercent, m1.yPercent);
					}
				} else if (typeof(v) === "object") { //for values like scaleX, scaleY, rotation, x, y, skewX, and skewY or transform:{...} (object)
					m2 = {scaleX:_parseVal((v.scaleX != null) ? v.scaleX : v.scale, m1.scaleX),
						scaleY:_parseVal((v.scaleY != null) ? v.scaleY : v.scale, m1.scaleY),
						scaleZ:_parseVal(v.scaleZ, m1.scaleZ),
						x:_parseVal(v.x, m1.x),
						y:_parseVal(v.y, m1.y),
						z:_parseVal(v.z, m1.z),
						xPercent:_parseVal(v.xPercent, m1.xPercent),
						yPercent:_parseVal(v.yPercent, m1.yPercent),
						perspective:_parseVal(v.transformPerspective, m1.perspective)};
					dr = v.directionalRotation;
					if (dr != null) {
						if (typeof(dr) === "object") {
							for (copy in dr) {
								v[copy] = dr[copy];
							}
						} else {
							v.rotation = dr;
						}
					}
					if (typeof(v.x) === "string" && v.x.indexOf("%") !== -1) {
						m2.x = 0;
						m2.xPercent = _parseVal(v.x, m1.xPercent);
					}
					if (typeof(v.y) === "string" && v.y.indexOf("%") !== -1) {
						m2.y = 0;
						m2.yPercent = _parseVal(v.y, m1.yPercent);
					}
	
					m2.rotation = _parseAngle(("rotation" in v) ? v.rotation : ("shortRotation" in v) ? v.shortRotation + "_short" : ("rotationZ" in v) ? v.rotationZ : m1.rotation, m1.rotation, "rotation", endRotations);
					if (_supports3D) {
						m2.rotationX = _parseAngle(("rotationX" in v) ? v.rotationX : ("shortRotationX" in v) ? v.shortRotationX + "_short" : m1.rotationX || 0, m1.rotationX, "rotationX", endRotations);
						m2.rotationY = _parseAngle(("rotationY" in v) ? v.rotationY : ("shortRotationY" in v) ? v.shortRotationY + "_short" : m1.rotationY || 0, m1.rotationY, "rotationY", endRotations);
					}
					m2.skewX = _parseAngle(v.skewX, m1.skewX);
					m2.skewY = _parseAngle(v.skewY, m1.skewY);
				}
				if (_supports3D && v.force3D != null) {
					m1.force3D = v.force3D;
					hasChange = true;
				}
	
				has3D = (m1.force3D || m1.z || m1.rotationX || m1.rotationY || m2.z || m2.rotationX || m2.rotationY || m2.perspective);
				if (!has3D && v.scale != null) {
					m2.scaleZ = 1; //no need to tween scaleZ.
				}
	
				while (--i > -1) {
					p = _transformProps[i];
					orig = m2[p] - m1[p];
					if (orig > min || orig < -min || v[p] != null || _forcePT[p] != null) {
						hasChange = true;
						pt = new CSSPropTween(m1, p, m1[p], orig, pt);
						if (p in endRotations) {
							pt.e = endRotations[p]; //directional rotations typically have compensated values during the tween, but we need to make sure they end at exactly what the user requested
						}
						pt.xs0 = 0; //ensures the value stays numeric in setRatio()
						pt.plugin = plugin;
						cssp._overwriteProps.push(pt.n);
					}
				}
	
				orig = v.transformOrigin;
				if (m1.svg && (orig || v.svgOrigin)) {
					x = m1.xOffset; //when we change the origin, in order to prevent things from jumping we adjust the x/y so we must record those here so that we can create PropTweens for them and flip them at the same time as the origin
					y = m1.yOffset;
					_parseSVGOrigin(t, _parsePosition(orig), m2, v.svgOrigin, v.smoothOrigin);
					pt = _addNonTweeningNumericPT(m1, "xOrigin", (originalGSTransform ? m1 : m2).xOrigin, m2.xOrigin, pt, transformOriginString); //note: if there wasn't a transformOrigin defined yet, just start with the destination one; it's wasteful otherwise, and it causes problems with fromTo() tweens. For example, TweenLite.to("#wheel", 3, {rotation:180, transformOrigin:"50% 50%", delay:1}); TweenLite.fromTo("#wheel", 3, {scale:0.5, transformOrigin:"50% 50%"}, {scale:1, delay:2}); would cause a jump when the from values revert at the beginning of the 2nd tween.
					pt = _addNonTweeningNumericPT(m1, "yOrigin", (originalGSTransform ? m1 : m2).yOrigin, m2.yOrigin, pt, transformOriginString);
					if (x !== m1.xOffset || y !== m1.yOffset) {
						pt = _addNonTweeningNumericPT(m1, "xOffset", (originalGSTransform ? x : m1.xOffset), m1.xOffset, pt, transformOriginString);
						pt = _addNonTweeningNumericPT(m1, "yOffset", (originalGSTransform ? y : m1.yOffset), m1.yOffset, pt, transformOriginString);
					}
					orig = "0px 0px"; //certain browsers (like firefox) completely botch transform-origin, so we must remove it to prevent it from contaminating transforms. We manage it ourselves with xOrigin and yOrigin
				}
				if (orig || (_supports3D && has3D && m1.zOrigin)) { //if anything 3D is happening and there's a transformOrigin with a z component that's non-zero, we must ensure that the transformOrigin's z-component is set to 0 so that we can manually do those calculations to get around Safari bugs. Even if the user didn't specifically define a "transformOrigin" in this particular tween (maybe they did it via css directly).
					if (_transformProp) {
						hasChange = true;
						p = _transformOriginProp;
						orig = (orig || _getStyle(t, p, _cs, false, "50% 50%")) + ""; //cast as string to avoid errors
						pt = new CSSPropTween(style, p, 0, 0, pt, -1, transformOriginString);
						pt.b = style[p];
						pt.plugin = plugin;
						if (_supports3D) {
							copy = m1.zOrigin;
							orig = orig.split(" ");
							m1.zOrigin = ((orig.length > 2 && !(copy !== 0 && orig[2] === "0px")) ? parseFloat(orig[2]) : copy) || 0; //Safari doesn't handle the z part of transformOrigin correctly, so we'll manually handle it in the _set3DTransformRatio() method.
							pt.xs0 = pt.e = orig[0] + " " + (orig[1] || "50%") + " 0px"; //we must define a z value of 0px specifically otherwise iOS 5 Safari will stick with the old one (if one was defined)!
							pt = new CSSPropTween(m1, "zOrigin", 0, 0, pt, -1, pt.n); //we must create a CSSPropTween for the _gsTransform.zOrigin so that it gets reset properly at the beginning if the tween runs backward (as opposed to just setting m1.zOrigin here)
							pt.b = copy;
							pt.xs0 = pt.e = m1.zOrigin;
						} else {
							pt.xs0 = pt.e = orig;
						}
	
						//for older versions of IE (6-8), we need to manually calculate things inside the setRatio() function. We record origin x and y (ox and oy) and whether or not the values are percentages (oxp and oyp).
					} else {
						_parsePosition(orig + "", m1);
					}
				}
				if (hasChange) {
					cssp._transformType = (!(m1.svg && _useSVGTransformAttr) && (has3D || this._transformType === 3)) ? 3 : 2; //quicker than calling cssp._enableTransforms();
				}
				if (swapFunc) {
					vars[parsingProp] = swapFunc;
				}
				if (scaleFunc) {
					vars.scale = scaleFunc;
				}
				return pt;
			}, prefix:true});
	
			_registerComplexSpecialProp("boxShadow", {defaultValue:"0px 0px 0px 0px #999", prefix:true, color:true, multi:true, keyword:"inset"});
	
			_registerComplexSpecialProp("borderRadius", {defaultValue:"0px", parser:function(t, e, p, cssp, pt, plugin) {
				e = this.format(e);
				var props = ["borderTopLeftRadius","borderTopRightRadius","borderBottomRightRadius","borderBottomLeftRadius"],
					style = t.style,
					ea1, i, es2, bs2, bs, es, bn, en, w, h, esfx, bsfx, rel, hn, vn, em;
				w = parseFloat(t.offsetWidth);
				h = parseFloat(t.offsetHeight);
				ea1 = e.split(" ");
				for (i = 0; i < props.length; i++) { //if we're dealing with percentages, we must convert things separately for the horizontal and vertical axis!
					if (this.p.indexOf("border")) { //older browsers used a prefix
						props[i] = _checkPropPrefix(props[i]);
					}
					bs = bs2 = _getStyle(t, props[i], _cs, false, "0px");
					if (bs.indexOf(" ") !== -1) {
						bs2 = bs.split(" ");
						bs = bs2[0];
						bs2 = bs2[1];
					}
					es = es2 = ea1[i];
					bn = parseFloat(bs);
					bsfx = bs.substr((bn + "").length);
					rel = (es.charAt(1) === "=");
					if (rel) {
						en = parseInt(es.charAt(0)+"1", 10);
						es = es.substr(2);
						en *= parseFloat(es);
						esfx = es.substr((en + "").length - (en < 0 ? 1 : 0)) || "";
					} else {
						en = parseFloat(es);
						esfx = es.substr((en + "").length);
					}
					if (esfx === "") {
						esfx = _suffixMap[p] || bsfx;
					}
					if (esfx !== bsfx) {
						hn = _convertToPixels(t, "borderLeft", bn, bsfx); //horizontal number (we use a bogus "borderLeft" property just because the _convertToPixels() method searches for the keywords "Left", "Right", "Top", and "Bottom" to determine of it's a horizontal or vertical property, and we need "border" in the name so that it knows it should measure relative to the element itself, not its parent.
						vn = _convertToPixels(t, "borderTop", bn, bsfx); //vertical number
						if (esfx === "%") {
							bs = (hn / w * 100) + "%";
							bs2 = (vn / h * 100) + "%";
						} else if (esfx === "em") {
							em = _convertToPixels(t, "borderLeft", 1, "em");
							bs = (hn / em) + "em";
							bs2 = (vn / em) + "em";
						} else {
							bs = hn + "px";
							bs2 = vn + "px";
						}
						if (rel) {
							es = (parseFloat(bs) + en) + esfx;
							es2 = (parseFloat(bs2) + en) + esfx;
						}
					}
					pt = _parseComplex(style, props[i], bs + " " + bs2, es + " " + es2, false, "0px", pt);
				}
				return pt;
			}, prefix:true, formatter:_getFormatter("0px 0px 0px 0px", false, true)});
			_registerComplexSpecialProp("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius", {defaultValue:"0px", parser:function(t, e, p, cssp, pt, plugin) {
				return _parseComplex(t.style, p, this.format(_getStyle(t, p, _cs, false, "0px 0px")), this.format(e), false, "0px", pt);
			}, prefix:true, formatter:_getFormatter("0px 0px", false, true)});
			_registerComplexSpecialProp("backgroundPosition", {defaultValue:"0 0", parser:function(t, e, p, cssp, pt, plugin) {
				var bp = "background-position",
					cs = (_cs || _getComputedStyle(t, null)),
					bs = this.format( ((cs) ? _ieVers ? cs.getPropertyValue(bp + "-x") + " " + cs.getPropertyValue(bp + "-y") : cs.getPropertyValue(bp) : t.currentStyle.backgroundPositionX + " " + t.currentStyle.backgroundPositionY) || "0 0"), //Internet Explorer doesn't report background-position correctly - we must query background-position-x and background-position-y and combine them (even in IE10). Before IE9, we must do the same with the currentStyle object and use camelCase
					es = this.format(e),
					ba, ea, i, pct, overlap, src;
				if ((bs.indexOf("%") !== -1) !== (es.indexOf("%") !== -1) && es.split(",").length < 2) {
					src = _getStyle(t, "backgroundImage").replace(_urlExp, "");
					if (src && src !== "none") {
						ba = bs.split(" ");
						ea = es.split(" ");
						_tempImg.setAttribute("src", src); //set the temp IMG's src to the background-image so that we can measure its width/height
						i = 2;
						while (--i > -1) {
							bs = ba[i];
							pct = (bs.indexOf("%") !== -1);
							if (pct !== (ea[i].indexOf("%") !== -1)) {
								overlap = (i === 0) ? t.offsetWidth - _tempImg.width : t.offsetHeight - _tempImg.height;
								ba[i] = pct ? (parseFloat(bs) / 100 * overlap) + "px" : (parseFloat(bs) / overlap * 100) + "%";
							}
						}
						bs = ba.join(" ");
					}
				}
				return this.parseComplex(t.style, bs, es, pt, plugin);
			}, formatter:_parsePosition});
			_registerComplexSpecialProp("backgroundSize", {defaultValue:"0 0", formatter:function(v) {
				v += ""; //ensure it's a string
				return _parsePosition(v.indexOf(" ") === -1 ? v + " " + v : v); //if set to something like "100% 100%", Safari typically reports the computed style as just "100%" (no 2nd value), but we should ensure that there are two values, so copy the first one. Otherwise, it'd be interpreted as "100% 0" (wrong).
			}});
			_registerComplexSpecialProp("perspective", {defaultValue:"0px", prefix:true});
			_registerComplexSpecialProp("perspectiveOrigin", {defaultValue:"50% 50%", prefix:true});
			_registerComplexSpecialProp("transformStyle", {prefix:true});
			_registerComplexSpecialProp("backfaceVisibility", {prefix:true});
			_registerComplexSpecialProp("userSelect", {prefix:true});
			_registerComplexSpecialProp("margin", {parser:_getEdgeParser("marginTop,marginRight,marginBottom,marginLeft")});
			_registerComplexSpecialProp("padding", {parser:_getEdgeParser("paddingTop,paddingRight,paddingBottom,paddingLeft")});
			_registerComplexSpecialProp("clip", {defaultValue:"rect(0px,0px,0px,0px)", parser:function(t, e, p, cssp, pt, plugin){
				var b, cs, delim;
				if (_ieVers < 9) { //IE8 and earlier don't report a "clip" value in the currentStyle - instead, the values are split apart into clipTop, clipRight, clipBottom, and clipLeft. Also, in IE7 and earlier, the values inside rect() are space-delimited, not comma-delimited.
					cs = t.currentStyle;
					delim = _ieVers < 8 ? " " : ",";
					b = "rect(" + cs.clipTop + delim + cs.clipRight + delim + cs.clipBottom + delim + cs.clipLeft + ")";
					e = this.format(e).split(",").join(delim);
				} else {
					b = this.format(_getStyle(t, this.p, _cs, false, this.dflt));
					e = this.format(e);
				}
				return this.parseComplex(t.style, b, e, pt, plugin);
			}});
			_registerComplexSpecialProp("textShadow", {defaultValue:"0px 0px 0px #999", color:true, multi:true});
			_registerComplexSpecialProp("autoRound,strictUnits", {parser:function(t, e, p, cssp, pt) {return pt;}}); //just so that we can ignore these properties (not tween them)
			_registerComplexSpecialProp("border", {defaultValue:"0px solid #000", parser:function(t, e, p, cssp, pt, plugin) {
				var bw = _getStyle(t, "borderTopWidth", _cs, false, "0px"),
					end = this.format(e).split(" "),
					esfx = end[0].replace(_suffixExp, "");
				if (esfx !== "px") { //if we're animating to a non-px value, we need to convert the beginning width to that unit.
					bw = (parseFloat(bw) / _convertToPixels(t, "borderTopWidth", 1, esfx)) + esfx;
				}
				return this.parseComplex(t.style, this.format(bw + " " + _getStyle(t, "borderTopStyle", _cs, false, "solid") + " " + _getStyle(t, "borderTopColor", _cs, false, "#000")), end.join(" "), pt, plugin);
				}, color:true, formatter:function(v) {
					var a = v.split(" ");
					return a[0] + " " + (a[1] || "solid") + " " + (v.match(_colorExp) || ["#000"])[0];
				}});
			_registerComplexSpecialProp("borderWidth", {parser:_getEdgeParser("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")}); //Firefox doesn't pick up on borderWidth set in style sheets (only inline).
			_registerComplexSpecialProp("float,cssFloat,styleFloat", {parser:function(t, e, p, cssp, pt, plugin) {
				var s = t.style,
					prop = ("cssFloat" in s) ? "cssFloat" : "styleFloat";
				return new CSSPropTween(s, prop, 0, 0, pt, -1, p, false, 0, s[prop], e);
			}});
	
			//opacity-related
			var _setIEOpacityRatio = function(v) {
					var t = this.t, //refers to the element's style property
						filters = t.filter || _getStyle(this.data, "filter") || "",
						val = (this.s + this.c * v) | 0,
						skip;
					if (val === 100) { //for older versions of IE that need to use a filter to apply opacity, we should remove the filter if opacity hits 1 in order to improve performance, but make sure there isn't a transform (matrix) or gradient in the filters.
						if (filters.indexOf("atrix(") === -1 && filters.indexOf("radient(") === -1 && filters.indexOf("oader(") === -1) {
							t.removeAttribute("filter");
							skip = (!_getStyle(this.data, "filter")); //if a class is applied that has an alpha filter, it will take effect (we don't want that), so re-apply our alpha filter in that case. We must first remove it and then check.
						} else {
							t.filter = filters.replace(_alphaFilterExp, "");
							skip = true;
						}
					}
					if (!skip) {
						if (this.xn1) {
							t.filter = filters = filters || ("alpha(opacity=" + val + ")"); //works around bug in IE7/8 that prevents changes to "visibility" from being applied properly if the filter is changed to a different alpha on the same frame.
						}
						if (filters.indexOf("pacity") === -1) { //only used if browser doesn't support the standard opacity style property (IE 7 and 8). We omit the "O" to avoid case-sensitivity issues
							if (val !== 0 || !this.xn1) { //bugs in IE7/8 won't render the filter properly if opacity is ADDED on the same frame/render as "visibility" changes (this.xn1 is 1 if this tween is an "autoAlpha" tween)
								t.filter = filters + " alpha(opacity=" + val + ")"; //we round the value because otherwise, bugs in IE7/8 can prevent "visibility" changes from being applied properly.
							}
						} else {
							t.filter = filters.replace(_opacityExp, "opacity=" + val);
						}
					}
				};
			_registerComplexSpecialProp("opacity,alpha,autoAlpha", {defaultValue:"1", parser:function(t, e, p, cssp, pt, plugin) {
				var b = parseFloat(_getStyle(t, "opacity", _cs, false, "1")),
					style = t.style,
					isAutoAlpha = (p === "autoAlpha");
				if (typeof(e) === "string" && e.charAt(1) === "=") {
					e = ((e.charAt(0) === "-") ? -1 : 1) * parseFloat(e.substr(2)) + b;
				}
				if (isAutoAlpha && b === 1 && _getStyle(t, "visibility", _cs) === "hidden" && e !== 0) { //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
					b = 0;
				}
				if (_supportsOpacity) {
					pt = new CSSPropTween(style, "opacity", b, e - b, pt);
				} else {
					pt = new CSSPropTween(style, "opacity", b * 100, (e - b) * 100, pt);
					pt.xn1 = isAutoAlpha ? 1 : 0; //we need to record whether or not this is an autoAlpha so that in the setRatio(), we know to duplicate the setting of the alpha in order to work around a bug in IE7 and IE8 that prevents changes to "visibility" from taking effect if the filter is changed to a different alpha(opacity) at the same time. Setting it to the SAME value first, then the new value works around the IE7/8 bug.
					style.zoom = 1; //helps correct an IE issue.
					pt.type = 2;
					pt.b = "alpha(opacity=" + pt.s + ")";
					pt.e = "alpha(opacity=" + (pt.s + pt.c) + ")";
					pt.data = t;
					pt.plugin = plugin;
					pt.setRatio = _setIEOpacityRatio;
				}
				if (isAutoAlpha) { //we have to create the "visibility" PropTween after the opacity one in the linked list so that they run in the order that works properly in IE8 and earlier
					pt = new CSSPropTween(style, "visibility", 0, 0, pt, -1, null, false, 0, ((b !== 0) ? "inherit" : "hidden"), ((e === 0) ? "hidden" : "inherit"));
					pt.xs0 = "inherit";
					cssp._overwriteProps.push(pt.n);
					cssp._overwriteProps.push(p);
				}
				return pt;
			}});
	
	
			var _removeProp = function(s, p) {
					if (p) {
						if (s.removeProperty) {
							if (p.substr(0,2) === "ms" || p.substr(0,6) === "webkit") { //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
								p = "-" + p;
							}
							s.removeProperty(p.replace(_capsExp, "-$1").toLowerCase());
						} else { //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
							s.removeAttribute(p);
						}
					}
				},
				_setClassNameRatio = function(v) {
					this.t._gsClassPT = this;
					if (v === 1 || v === 0) {
						this.t.setAttribute("class", (v === 0) ? this.b : this.e);
						var mpt = this.data, //first MiniPropTween
							s = this.t.style;
						while (mpt) {
							if (!mpt.v) {
								_removeProp(s, mpt.p);
							} else {
								s[mpt.p] = mpt.v;
							}
							mpt = mpt._next;
						}
						if (v === 1 && this.t._gsClassPT === this) {
							this.t._gsClassPT = null;
						}
					} else if (this.t.getAttribute("class") !== this.e) {
						this.t.setAttribute("class", this.e);
					}
				};
			_registerComplexSpecialProp("className", {parser:function(t, e, p, cssp, pt, plugin, vars) {
				var b = t.getAttribute("class") || "", //don't use t.className because it doesn't work consistently on SVG elements; getAttribute("class") and setAttribute("class", value") is more reliable.
					cssText = t.style.cssText,
					difData, bs, cnpt, cnptLookup, mpt;
				pt = cssp._classNamePT = new CSSPropTween(t, p, 0, 0, pt, 2);
				pt.setRatio = _setClassNameRatio;
				pt.pr = -11;
				_hasPriority = true;
				pt.b = b;
				bs = _getAllStyles(t, _cs);
				//if there's a className tween already operating on the target, force it to its end so that the necessary inline styles are removed and the class name is applied before we determine the end state (we don't want inline styles interfering that were there just for class-specific values)
				cnpt = t._gsClassPT;
				if (cnpt) {
					cnptLookup = {};
					mpt = cnpt.data; //first MiniPropTween which stores the inline styles - we need to force these so that the inline styles don't contaminate things. Otherwise, there's a small chance that a tween could start and the inline values match the destination values and they never get cleaned.
					while (mpt) {
						cnptLookup[mpt.p] = 1;
						mpt = mpt._next;
					}
					cnpt.setRatio(1);
				}
				t._gsClassPT = pt;
				pt.e = (e.charAt(1) !== "=") ? e : b.replace(new RegExp("(?:\\s|^)" + e.substr(2) + "(?![\\w-])"), "") + ((e.charAt(0) === "+") ? " " + e.substr(2) : "");
				t.setAttribute("class", pt.e);
				difData = _cssDif(t, bs, _getAllStyles(t), vars, cnptLookup);
				t.setAttribute("class", b);
				pt.data = difData.firstMPT;
				t.style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
				pt = pt.xfirst = cssp.parse(t, difData.difs, pt, plugin); //we record the CSSPropTween as the xfirst so that we can handle overwriting propertly (if "className" gets overwritten, we must kill all the properties associated with the className part of the tween, so we can loop through from xfirst to the pt itself)
				return pt;
			}});
	
	
			var _setClearPropsRatio = function(v) {
				if (v === 1 || v === 0) if (this.data._totalTime === this.data._totalDuration && this.data.data !== "isFromStart") { //this.data refers to the tween. Only clear at the END of the tween (remember, from() tweens make the ratio go from 1 to 0, so we can't just check that and if the tween is the zero-duration one that's created internally to render the starting values in a from() tween, ignore that because otherwise, for example, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in).
					var s = this.t.style,
						transformParse = _specialProps.transform.parse,
						a, p, i, clearTransform, transform;
					if (this.e === "all") {
						s.cssText = "";
						clearTransform = true;
					} else {
						a = this.e.split(" ").join("").split(",");
						i = a.length;
						while (--i > -1) {
							p = a[i];
							if (_specialProps[p]) {
								if (_specialProps[p].parse === transformParse) {
									clearTransform = true;
								} else {
									p = (p === "transformOrigin") ? _transformOriginProp : _specialProps[p].p; //ensures that special properties use the proper browser-specific property name, like "scaleX" might be "-webkit-transform" or "boxShadow" might be "-moz-box-shadow"
								}
							}
							_removeProp(s, p);
						}
					}
					if (clearTransform) {
						_removeProp(s, _transformProp);
						transform = this.t._gsTransform;
						if (transform) {
							if (transform.svg) {
								this.t.removeAttribute("data-svg-origin");
								this.t.removeAttribute("transform");
							}
							delete this.t._gsTransform;
						}
					}
	
				}
			};
			_registerComplexSpecialProp("clearProps", {parser:function(t, e, p, cssp, pt) {
				pt = new CSSPropTween(t, p, 0, 0, pt, 2);
				pt.setRatio = _setClearPropsRatio;
				pt.e = e;
				pt.pr = -10;
				pt.data = cssp._tween;
				_hasPriority = true;
				return pt;
			}});
	
			p = "bezier,throwProps,physicsProps,physics2D".split(",");
			i = p.length;
			while (i--) {
				_registerPluginProp(p[i]);
			}
	
	
	
	
	
	
	
	
			p = CSSPlugin.prototype;
			p._firstPT = p._lastParsedTransform = p._transform = null;
	
			//gets called when the tween renders for the first time. This kicks everything off, recording start/end values, etc.
			p._onInitTween = function(target, vars, tween, index) {
				if (!target.nodeType) { //css is only for dom elements
					return false;
				}
				this._target = _target = target;
				this._tween = tween;
				this._vars = vars;
				_index = index;
				_autoRound = vars.autoRound;
				_hasPriority = false;
				_suffixMap = vars.suffixMap || CSSPlugin.suffixMap;
				_cs = _getComputedStyle(target, "");
				_overwriteProps = this._overwriteProps;
				var style = target.style,
					v, pt, pt2, first, last, next, zIndex, tpt, threeD;
				if (_reqSafariFix) if (style.zIndex === "") {
					v = _getStyle(target, "zIndex", _cs);
					if (v === "auto" || v === "") {
						//corrects a bug in [non-Android] Safari that prevents it from repainting elements in their new positions if they don't have a zIndex set. We also can't just apply this inside _parseTransform() because anything that's moved in any way (like using "left" or "top" instead of transforms like "x" and "y") can be affected, so it is best to ensure that anything that's tweening has a z-index. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly. Plus zIndex is less memory-intensive.
						this._addLazySet(style, "zIndex", 0);
					}
				}
	
				if (typeof(vars) === "string") {
					first = style.cssText;
					v = _getAllStyles(target, _cs);
					style.cssText = first + ";" + vars;
					v = _cssDif(target, v, _getAllStyles(target)).difs;
					if (!_supportsOpacity && _opacityValExp.test(vars)) {
						v.opacity = parseFloat( RegExp.$1 );
					}
					vars = v;
					style.cssText = first;
				}
	
				if (vars.className) { //className tweens will combine any differences they find in the css with the vars that are passed in, so {className:"myClass", scale:0.5, left:20} would work.
					this._firstPT = pt = _specialProps.className.parse(target, vars.className, "className", this, null, null, vars);
				} else {
					this._firstPT = pt = this.parse(target, vars, null);
				}
	
				if (this._transformType) {
					threeD = (this._transformType === 3);
					if (!_transformProp) {
						style.zoom = 1; //helps correct an IE issue.
					} else if (_isSafari) {
						_reqSafariFix = true;
						//if zIndex isn't set, iOS Safari doesn't repaint things correctly sometimes (seemingly at random).
						if (style.zIndex === "") {
							zIndex = _getStyle(target, "zIndex", _cs);
							if (zIndex === "auto" || zIndex === "") {
								this._addLazySet(style, "zIndex", 0);
							}
						}
						//Setting WebkitBackfaceVisibility corrects 3 bugs:
						// 1) [non-Android] Safari skips rendering changes to "top" and "left" that are made on the same frame/render as a transform update.
						// 2) iOS Safari sometimes neglects to repaint elements in their new positions. Setting "WebkitPerspective" to a non-zero value worked too except that on iOS Safari things would flicker randomly.
						// 3) Safari sometimes displayed odd artifacts when tweening the transform (or WebkitTransform) property, like ghosts of the edges of the element remained. Definitely a browser bug.
						//Note: we allow the user to override the auto-setting by defining WebkitBackfaceVisibility in the vars of the tween.
						if (_isSafariLT6) {
							this._addLazySet(style, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (threeD ? "visible" : "hidden"));
						}
					}
					pt2 = pt;
					while (pt2 && pt2._next) {
						pt2 = pt2._next;
					}
					tpt = new CSSPropTween(target, "transform", 0, 0, null, 2);
					this._linkCSSP(tpt, null, pt2);
					tpt.setRatio = _transformProp ? _setTransformRatio : _setIETransformRatio;
					tpt.data = this._transform || _getTransform(target, _cs, true);
					tpt.tween = tween;
					tpt.pr = -1; //ensures that the transforms get applied after the components are updated.
					_overwriteProps.pop(); //we don't want to force the overwrite of all "transform" tweens of the target - we only care about individual transform properties like scaleX, rotation, etc. The CSSPropTween constructor automatically adds the property to _overwriteProps which is why we need to pop() here.
				}
	
				if (_hasPriority) {
					//reorders the linked list in order of pr (priority)
					while (pt) {
						next = pt._next;
						pt2 = first;
						while (pt2 && pt2.pr > pt.pr) {
							pt2 = pt2._next;
						}
						if ((pt._prev = pt2 ? pt2._prev : last)) {
							pt._prev._next = pt;
						} else {
							first = pt;
						}
						if ((pt._next = pt2)) {
							pt2._prev = pt;
						} else {
							last = pt;
						}
						pt = next;
					}
					this._firstPT = first;
				}
				return true;
			};
	
	
			p.parse = function(target, vars, pt, plugin) {
				var style = target.style,
					p, sp, bn, en, bs, es, bsfx, esfx, isStr, rel;
				for (p in vars) {
					es = vars[p]; //ending value string
					if (typeof(es) === "function") {
						es = es(_index, _target);
					}
					sp = _specialProps[p]; //SpecialProp lookup.
					if (sp) {
						pt = sp.parse(target, es, p, this, pt, plugin, vars);
					} else if (p.substr(0,2) === "--") { //for tweening CSS variables (which always start with "--"). To maximize performance and simplicity, we bypass CSSPlugin altogether and just add a normal property tween to the tween instance itself.
						this._tween._propLookup[p] = this._addTween.call(this._tween, target.style, "setProperty", _getComputedStyle(target).getPropertyValue(p) + "", es + "", p, false, p);
						continue;
					} else {
						bs = _getStyle(target, p, _cs) + "";
						isStr = (typeof(es) === "string");
						if (p === "color" || p === "fill" || p === "stroke" || p.indexOf("Color") !== -1 || (isStr && _rgbhslExp.test(es))) { //Opera uses background: to define color sometimes in addition to backgroundColor:
							if (!isStr) {
								es = _parseColor(es);
								es = ((es.length > 3) ? "rgba(" : "rgb(") + es.join(",") + ")";
							}
							pt = _parseComplex(style, p, bs, es, true, "transparent", pt, 0, plugin);
	
						} else if (isStr && _complexExp.test(es)) {
							pt = _parseComplex(style, p, bs, es, true, null, pt, 0, plugin);
	
						} else {
							bn = parseFloat(bs);
							bsfx = (bn || bn === 0) ? bs.substr((bn + "").length) : ""; //remember, bs could be non-numeric like "normal" for fontWeight, so we should default to a blank suffix in that case.
	
							if (bs === "" || bs === "auto") {
								if (p === "width" || p === "height") {
									bn = _getDimension(target, p, _cs);
									bsfx = "px";
								} else if (p === "left" || p === "top") {
									bn = _calculateOffset(target, p, _cs);
									bsfx = "px";
								} else {
									bn = (p !== "opacity") ? 0 : 1;
									bsfx = "";
								}
							}
	
							rel = (isStr && es.charAt(1) === "=");
							if (rel) {
								en = parseInt(es.charAt(0) + "1", 10);
								es = es.substr(2);
								en *= parseFloat(es);
								esfx = es.replace(_suffixExp, "");
							} else {
								en = parseFloat(es);
								esfx = isStr ? es.replace(_suffixExp, "") : "";
							}
	
							if (esfx === "") {
								esfx = (p in _suffixMap) ? _suffixMap[p] : bsfx; //populate the end suffix, prioritizing the map, then if none is found, use the beginning suffix.
							}
	
							es = (en || en === 0) ? (rel ? en + bn : en) + esfx : vars[p]; //ensures that any += or -= prefixes are taken care of. Record the end value before normalizing the suffix because we always want to end the tween on exactly what they intended even if it doesn't match the beginning value's suffix.
							//if the beginning/ending suffixes don't match, normalize them...
							if (bsfx !== esfx) if (esfx !== "" || p === "lineHeight") if (en || en === 0) if (bn) { //note: if the beginning value (bn) is 0, we don't need to convert units!
								bn = _convertToPixels(target, p, bn, bsfx);
								if (esfx === "%") {
									bn /= _convertToPixels(target, p, 100, "%") / 100;
									if (vars.strictUnits !== true) { //some browsers report only "px" values instead of allowing "%" with getComputedStyle(), so we assume that if we're tweening to a %, we should start there too unless strictUnits:true is defined. This approach is particularly useful for responsive designs that use from() tweens.
										bs = bn + "%";
									}
	
								} else if (esfx === "em" || esfx === "rem" || esfx === "vw" || esfx === "vh") {
									bn /= _convertToPixels(target, p, 1, esfx);
	
								//otherwise convert to pixels.
								} else if (esfx !== "px") {
									en = _convertToPixels(target, p, en, esfx);
									esfx = "px"; //we don't use bsfx after this, so we don't need to set it to px too.
								}
								if (rel) if (en || en === 0) {
									es = (en + bn) + esfx; //the changes we made affect relative calculations, so adjust the end value here.
								}
							}
	
							if (rel) {
								en += bn;
							}
	
							if ((bn || bn === 0) && (en || en === 0)) { //faster than isNaN(). Also, previously we required en !== bn but that doesn't really gain much performance and it prevents _parseToProxy() from working properly if beginning and ending values match but need to get tweened by an external plugin anyway. For example, a bezier tween where the target starts at left:0 and has these points: [{left:50},{left:0}] wouldn't work properly because when parsing the last point, it'd match the first (current) one and a non-tweening CSSPropTween would be recorded when we actually need a normal tween (type:0) so that things get updated during the tween properly.
								pt = new CSSPropTween(style, p, bn, en - bn, pt, 0, p, (_autoRound !== false && (esfx === "px" || p === "zIndex")), 0, bs, es);
								pt.xs0 = esfx;
								//DEBUG: _log("tween "+p+" from "+pt.b+" ("+bn+esfx+") to "+pt.e+" with suffix: "+pt.xs0);
							} else if (style[p] === undefined || !es && (es + "" === "NaN" || es == null)) {
								_log("invalid " + p + " tween value: " + vars[p]);
							} else {
								pt = new CSSPropTween(style, p, en || bn || 0, 0, pt, -1, p, false, 0, bs, es);
								pt.xs0 = (es === "none" && (p === "display" || p.indexOf("Style") !== -1)) ? bs : es; //intermediate value should typically be set immediately (end value) except for "display" or things like borderTopStyle, borderBottomStyle, etc. which should use the beginning value during the tween.
								//DEBUG: _log("non-tweening value "+p+": "+pt.xs0);
							}
						}
					}
					if (plugin) if (pt && !pt.plugin) {
						pt.plugin = plugin;
					}
				}
				return pt;
			};
	
	
			//gets called every time the tween updates, passing the new ratio (typically a value between 0 and 1, but not always (for example, if an Elastic.easeOut is used, the value can jump above 1 mid-tween). It will always start and 0 and end at 1.
			p.setRatio = function(v) {
				var pt = this._firstPT,
					min = 0.000001,
					val, str, i;
				//at the end of the tween, we set the values to exactly what we received in order to make sure non-tweening values (like "position" or "float" or whatever) are set and so that if the beginning/ending suffixes (units) didn't match and we normalized to px, the value that the user passed in is used here. We check to see if the tween is at its beginning in case it's a from() tween in which case the ratio will actually go from 1 to 0 over the course of the tween (backwards).
				if (v === 1 && (this._tween._time === this._tween._duration || this._tween._time === 0)) {
					while (pt) {
						if (pt.type !== 2) {
							if (pt.r && pt.type !== -1) {
								val = Math.round(pt.s + pt.c);
								if (!pt.type) {
									pt.t[pt.p] = val + pt.xs0;
								} else if (pt.type === 1) { //complex value (one that typically has multiple numbers inside a string, like "rect(5px,10px,20px,25px)"
									i = pt.l;
									str = pt.xs0 + val + pt.xs1;
									for (i = 1; i < pt.l; i++) {
										str += pt["xn"+i] + pt["xs"+(i+1)];
									}
									pt.t[pt.p] = str;
								}
							} else {
								pt.t[pt.p] = pt.e;
							}
						} else {
							pt.setRatio(v);
						}
						pt = pt._next;
					}
	
				} else if (v || !(this._tween._time === this._tween._duration || this._tween._time === 0) || this._tween._rawPrevTime === -0.000001) {
					while (pt) {
						val = pt.c * v + pt.s;
						if (pt.r) {
							val = Math.round(val);
						} else if (val < min) if (val > -min) {
							val = 0;
						}
						if (!pt.type) {
							pt.t[pt.p] = val + pt.xs0;
						} else if (pt.type === 1) { //complex value (one that typically has multiple numbers inside a string, like "rect(5px,10px,20px,25px)"
							i = pt.l;
							if (i === 2) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2;
							} else if (i === 3) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3;
							} else if (i === 4) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4;
							} else if (i === 5) {
								pt.t[pt.p] = pt.xs0 + val + pt.xs1 + pt.xn1 + pt.xs2 + pt.xn2 + pt.xs3 + pt.xn3 + pt.xs4 + pt.xn4 + pt.xs5;
							} else {
								str = pt.xs0 + val + pt.xs1;
								for (i = 1; i < pt.l; i++) {
									str += pt["xn"+i] + pt["xs"+(i+1)];
								}
								pt.t[pt.p] = str;
							}
	
						} else if (pt.type === -1) { //non-tweening value
							pt.t[pt.p] = pt.xs0;
	
						} else if (pt.setRatio) { //custom setRatio() for things like SpecialProps, external plugins, etc.
							pt.setRatio(v);
						}
						pt = pt._next;
					}
	
				//if the tween is reversed all the way back to the beginning, we need to restore the original values which may have different units (like % instead of px or em or whatever).
				} else {
					while (pt) {
						if (pt.type !== 2) {
							pt.t[pt.p] = pt.b;
						} else {
							pt.setRatio(v);
						}
						pt = pt._next;
					}
				}
			};
	
			/**
			 * @private
			 * Forces rendering of the target's transforms (rotation, scale, etc.) whenever the CSSPlugin's setRatio() is called.
			 * Basically, this tells the CSSPlugin to create a CSSPropTween (type 2) after instantiation that runs last in the linked
			 * list and calls the appropriate (3D or 2D) rendering function. We separate this into its own method so that we can call
			 * it from other plugins like BezierPlugin if, for example, it needs to apply an autoRotation and this CSSPlugin
			 * doesn't have any transform-related properties of its own. You can call this method as many times as you
			 * want and it won't create duplicate CSSPropTweens.
			 *
			 * @param {boolean} threeD if true, it should apply 3D tweens (otherwise, just 2D ones are fine and typically faster)
			 */
			p._enableTransforms = function(threeD) {
				this._transform = this._transform || _getTransform(this._target, _cs, true); //ensures that the element has a _gsTransform property with the appropriate values.
				this._transformType = (!(this._transform.svg && _useSVGTransformAttr) && (threeD || this._transformType === 3)) ? 3 : 2;
			};
	
			var lazySet = function(v) {
				this.t[this.p] = this.e;
				this.data._linkCSSP(this, this._next, null, true); //we purposefully keep this._next even though it'd make sense to null it, but this is a performance optimization, as this happens during the while (pt) {} loop in setRatio() at the bottom of which it sets pt = pt._next, so if we null it, the linked list will be broken in that loop.
			};
			/** @private Gives us a way to set a value on the first render (and only the first render). **/
			p._addLazySet = function(t, p, v) {
				var pt = this._firstPT = new CSSPropTween(t, p, 0, 0, this._firstPT, 2);
				pt.e = v;
				pt.setRatio = lazySet;
				pt.data = this;
			};
	
			/** @private **/
			p._linkCSSP = function(pt, next, prev, remove) {
				if (pt) {
					if (next) {
						next._prev = pt;
					}
					if (pt._next) {
						pt._next._prev = pt._prev;
					}
					if (pt._prev) {
						pt._prev._next = pt._next;
					} else if (this._firstPT === pt) {
						this._firstPT = pt._next;
						remove = true; //just to prevent resetting this._firstPT 5 lines down in case pt._next is null. (optimized for speed)
					}
					if (prev) {
						prev._next = pt;
					} else if (!remove && this._firstPT === null) {
						this._firstPT = pt;
					}
					pt._next = next;
					pt._prev = prev;
				}
				return pt;
			};
	
			p._mod = function(lookup) {
				var pt = this._firstPT;
				while (pt) {
					if (typeof(lookup[pt.p]) === "function" && lookup[pt.p] === Math.round) { //only gets called by RoundPropsPlugin (ModifyPlugin manages all the rendering internally for CSSPlugin properties that need modification). Remember, we handle rounding a bit differently in this plugin for performance reasons, leveraging "r" as an indicator that the value should be rounded internally..
						pt.r = 1;
					}
					pt = pt._next;
				}
			};
	
			//we need to make sure that if alpha or autoAlpha is killed, opacity is too. And autoAlpha affects the "visibility" property.
			p._kill = function(lookup) {
				var copy = lookup,
					pt, p, xfirst;
				if (lookup.autoAlpha || lookup.alpha) {
					copy = {};
					for (p in lookup) { //copy the lookup so that we're not changing the original which may be passed elsewhere.
						copy[p] = lookup[p];
					}
					copy.opacity = 1;
					if (copy.autoAlpha) {
						copy.visibility = 1;
					}
				}
				if (lookup.className && (pt = this._classNamePT)) { //for className tweens, we need to kill any associated CSSPropTweens too; a linked list starts at the className's "xfirst".
					xfirst = pt.xfirst;
					if (xfirst && xfirst._prev) {
						this._linkCSSP(xfirst._prev, pt._next, xfirst._prev._prev); //break off the prev
					} else if (xfirst === this._firstPT) {
						this._firstPT = pt._next;
					}
					if (pt._next) {
						this._linkCSSP(pt._next, pt._next._next, xfirst._prev);
					}
					this._classNamePT = null;
				}
				pt = this._firstPT;
				while (pt) {
					if (pt.plugin && pt.plugin !== p && pt.plugin._kill) { //for plugins that are registered with CSSPlugin, we should notify them of the kill.
						pt.plugin._kill(lookup);
						p = pt.plugin;
					}
					pt = pt._next;
				}
				return TweenPlugin.prototype._kill.call(this, copy);
			};
	
	
	
			//used by cascadeTo() for gathering all the style properties of each child element into an array for comparison.
			var _getChildStyles = function(e, props, targets) {
					var children, i, child, type;
					if (e.slice) {
						i = e.length;
						while (--i > -1) {
							_getChildStyles(e[i], props, targets);
						}
						return;
					}
					children = e.childNodes;
					i = children.length;
					while (--i > -1) {
						child = children[i];
						type = child.type;
						if (child.style) {
							props.push(_getAllStyles(child));
							if (targets) {
								targets.push(child);
							}
						}
						if ((type === 1 || type === 9 || type === 11) && child.childNodes.length) {
							_getChildStyles(child, props, targets);
						}
					}
				};
	
			/**
			 * Typically only useful for className tweens that may affect child elements, this method creates a TweenLite
			 * and then compares the style properties of all the target's child elements at the tween's start and end, and
			 * if any are different, it also creates tweens for those and returns an array containing ALL of the resulting
			 * tweens (so that you can easily add() them to a TimelineLite, for example). The reason this functionality is
			 * wrapped into a separate static method of CSSPlugin instead of being integrated into all regular className tweens
			 * is because it creates entirely new tweens that may have completely different targets than the original tween,
			 * so if they were all lumped into the original tween instance, it would be inconsistent with the rest of the API
			 * and it would create other problems. For example:
			 *  - If I create a tween of elementA, that tween instance may suddenly change its target to include 50 other elements (unintuitive if I specifically defined the target I wanted)
			 *  - We can't just create new independent tweens because otherwise, what happens if the original/parent tween is reversed or pause or dropped into a TimelineLite for tight control? You'd expect that tween's behavior to affect all the others.
			 *  - Analyzing every style property of every child before and after the tween is an expensive operation when there are many children, so this behavior shouldn't be imposed on all className tweens by default, especially since it's probably rare that this extra functionality is needed.
			 *
			 * @param {Object} target object to be tweened
			 * @param {number} Duration in seconds (or frames for frames-based tweens)
			 * @param {Object} Object containing the end values, like {className:"newClass", ease:Linear.easeNone}
			 * @return {Array} An array of TweenLite instances
			 */
			CSSPlugin.cascadeTo = function(target, duration, vars) {
				var tween = TweenLite.to(target, duration, vars),
					results = [tween],
					b = [],
					e = [],
					targets = [],
					_reservedProps = TweenLite._internals.reservedProps,
					i, difs, p, from;
				target = tween._targets || tween.target;
				_getChildStyles(target, b, targets);
				tween.render(duration, true, true);
				_getChildStyles(target, e);
				tween.render(0, true, true);
				tween._enabled(true);
				i = targets.length;
				while (--i > -1) {
					difs = _cssDif(targets[i], b[i], e[i]);
					if (difs.firstMPT) {
						difs = difs.difs;
						for (p in vars) {
							if (_reservedProps[p]) {
								difs[p] = vars[p];
							}
						}
						from = {};
						for (p in difs) {
							from[p] = b[i][p];
						}
						results.push(TweenLite.fromTo(targets[i], duration, from, difs));
					}
				}
				return results;
			};
	
			TweenPlugin.activate([CSSPlugin]);
			return CSSPlugin;
	
		}, true);
	
		
		
		
		
		
		
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * RoundPropsPlugin
	 * ----------------------------------------------------------------
	 */
		(function() {
	
			var RoundPropsPlugin = _gsScope._gsDefine.plugin({
					propName: "roundProps",
					version: "1.6.0",
					priority: -1,
					API: 2,
	
					//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
					init: function(target, value, tween) {
						this._tween = tween;
						return true;
					}
	
				}),
				_roundLinkedList = function(node) {
					while (node) {
						if (!node.f && !node.blob) {
							node.m = Math.round;
						}
						node = node._next;
					}
				},
				p = RoundPropsPlugin.prototype;
	
			p._onInitAllProps = function() {
				var tween = this._tween,
					rp = (tween.vars.roundProps.join) ? tween.vars.roundProps : tween.vars.roundProps.split(","),
					i = rp.length,
					lookup = {},
					rpt = tween._propLookup.roundProps,
					prop, pt, next;
				while (--i > -1) {
					lookup[rp[i]] = Math.round;
				}
				i = rp.length;
				while (--i > -1) {
					prop = rp[i];
					pt = tween._firstPT;
					while (pt) {
						next = pt._next; //record here, because it may get removed
						if (pt.pg) {
							pt.t._mod(lookup);
						} else if (pt.n === prop) {
							if (pt.f === 2 && pt.t) { //a blob (text containing multiple numeric values)
								_roundLinkedList(pt.t._firstPT);
							} else {
								this._add(pt.t, prop, pt.s, pt.c);
								//remove from linked list
								if (next) {
									next._prev = pt._prev;
								}
								if (pt._prev) {
									pt._prev._next = next;
								} else if (tween._firstPT === pt) {
									tween._firstPT = next;
								}
								pt._next = pt._prev = null;
								tween._propLookup[prop] = rpt;
							}
						}
						pt = next;
					}
				}
				return false;
			};
	
			p._add = function(target, p, s, c) {
				this._addTween(target, p, s, s + c, p, Math.round);
				this._overwriteProps.push(p);
			};
	
		}());
	
	
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * AttrPlugin
	 * ----------------------------------------------------------------
	 */
	
		(function() {
	
			_gsScope._gsDefine.plugin({
				propName: "attr",
				API: 2,
				version: "0.6.1",
	
				//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
				init: function(target, value, tween, index) {
					var p, end;
					if (typeof(target.setAttribute) !== "function") {
						return false;
					}
					for (p in value) {
						end = value[p];
						if (typeof(end) === "function") {
							end = end(index, target);
						}
						this._addTween(target, "setAttribute", target.getAttribute(p) + "", end + "", p, false, p);
						this._overwriteProps.push(p);
					}
					return true;
				}
	
			});
	
		}());
	
	
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * DirectionalRotationPlugin
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine.plugin({
			propName: "directionalRotation",
			version: "0.3.1",
			API: 2,
	
			//called when the tween renders for the first time. This is where initial values should be recorded and any setup routines should run.
			init: function(target, value, tween, index) {
				if (typeof(value) !== "object") {
					value = {rotation:value};
				}
				this.finals = {};
				var cap = (value.useRadians === true) ? Math.PI * 2 : 360,
					min = 0.000001,
					p, v, start, end, dif, split;
				for (p in value) {
					if (p !== "useRadians") {
						end = value[p];
						if (typeof(end) === "function") {
							end = end(index, target);
						}
						split = (end + "").split("_");
						v = split[0];
						start = parseFloat( (typeof(target[p]) !== "function") ? target[p] : target[ ((p.indexOf("set") || typeof(target["get" + p.substr(3)]) !== "function") ? p : "get" + p.substr(3)) ]() );
						end = this.finals[p] = (typeof(v) === "string" && v.charAt(1) === "=") ? start + parseInt(v.charAt(0) + "1", 10) * Number(v.substr(2)) : Number(v) || 0;
						dif = end - start;
						if (split.length) {
							v = split.join("_");
							if (v.indexOf("short") !== -1) {
								dif = dif % cap;
								if (dif !== dif % (cap / 2)) {
									dif = (dif < 0) ? dif + cap : dif - cap;
								}
							}
							if (v.indexOf("_cw") !== -1 && dif < 0) {
								dif = ((dif + cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							} else if (v.indexOf("ccw") !== -1 && dif > 0) {
								dif = ((dif - cap * 9999999999) % cap) - ((dif / cap) | 0) * cap;
							}
						}
						if (dif > min || dif < -min) {
							this._addTween(target, p, start, start + dif, p);
							this._overwriteProps.push(p);
						}
					}
				}
				return true;
			},
	
			//called each time the values should be updated, and the ratio gets passed as the only parameter (typically it's a value between 0 and 1, but it can exceed those when using an ease like Elastic.easeOut or Back.easeOut, etc.)
			set: function(ratio) {
				var pt;
				if (ratio !== 1) {
					this._super.setRatio.call(this, ratio);
				} else {
					pt = this._firstPT;
					while (pt) {
						if (pt.f) {
							pt.t[pt.p](this.finals[pt.p]);
						} else {
							pt.t[pt.p] = this.finals[pt.p];
						}
						pt = pt._next;
					}
				}
			}
	
		})._autoCSS = true;
	
	
	
	
	
	
	
		
		
		
		
	/*
	 * ----------------------------------------------------------------
	 * EasePack
	 * ----------------------------------------------------------------
	 */
		_gsScope._gsDefine("easing.Back", ["easing.Ease"], function(Ease) {
			
			var w = (_gsScope.GreenSockGlobals || _gsScope),
				gs = w.com.greensock,
				_2PI = Math.PI * 2,
				_HALF_PI = Math.PI / 2,
				_class = gs._class,
				_create = function(n, f) {
					var C = _class("easing." + n, function(){}, true),
						p = C.prototype = new Ease();
					p.constructor = C;
					p.getRatio = f;
					return C;
				},
				_easeReg = Ease.register || function(){}, //put an empty function in place just as a safety measure in case someone loads an OLD version of TweenLite.js where Ease.register doesn't exist.
				_wrap = function(name, EaseOut, EaseIn, EaseInOut, aliases) {
					var C = _class("easing."+name, {
						easeOut:new EaseOut(),
						easeIn:new EaseIn(),
						easeInOut:new EaseInOut()
					}, true);
					_easeReg(C, name);
					return C;
				},
				EasePoint = function(time, value, next) {
					this.t = time;
					this.v = value;
					if (next) {
						this.next = next;
						next.prev = this;
						this.c = next.v - value;
						this.gap = next.t - time;
					}
				},
	
				//Back
				_createBack = function(n, f) {
					var C = _class("easing." + n, function(overshoot) {
							this._p1 = (overshoot || overshoot === 0) ? overshoot : 1.70158;
							this._p2 = this._p1 * 1.525;
						}, true),
						p = C.prototype = new Ease();
					p.constructor = C;
					p.getRatio = f;
					p.config = function(overshoot) {
						return new C(overshoot);
					};
					return C;
				},
	
				Back = _wrap("Back",
					_createBack("BackOut", function(p) {
						return ((p = p - 1) * p * ((this._p1 + 1) * p + this._p1) + 1);
					}),
					_createBack("BackIn", function(p) {
						return p * p * ((this._p1 + 1) * p - this._p1);
					}),
					_createBack("BackInOut", function(p) {
						return ((p *= 2) < 1) ? 0.5 * p * p * ((this._p2 + 1) * p - this._p2) : 0.5 * ((p -= 2) * p * ((this._p2 + 1) * p + this._p2) + 2);
					})
				),
	
	
				//SlowMo
				SlowMo = _class("easing.SlowMo", function(linearRatio, power, yoyoMode) {
					power = (power || power === 0) ? power : 0.7;
					if (linearRatio == null) {
						linearRatio = 0.7;
					} else if (linearRatio > 1) {
						linearRatio = 1;
					}
					this._p = (linearRatio !== 1) ? power : 0;
					this._p1 = (1 - linearRatio) / 2;
					this._p2 = linearRatio;
					this._p3 = this._p1 + this._p2;
					this._calcEnd = (yoyoMode === true);
				}, true),
				p = SlowMo.prototype = new Ease(),
				SteppedEase, ExpoScaleEase, RoughEase, _createElastic;
	
			p.constructor = SlowMo;
			p.getRatio = function(p) {
				var r = p + (0.5 - p) * this._p;
				if (p < this._p1) {
					return this._calcEnd ? 1 - ((p = 1 - (p / this._p1)) * p) : r - ((p = 1 - (p / this._p1)) * p * p * p * r);
				} else if (p > this._p3) {
					return this._calcEnd ? (p === 1 ? 0 : 1 - (p = (p - this._p3) / this._p1) * p) : r + ((p - r) * (p = (p - this._p3) / this._p1) * p * p * p); //added p === 1 ? 0 to avoid floating point rounding errors from affecting the final value, like 1 - 0.7 = 0.30000000000000004 instead of 0.3
				}
				return this._calcEnd ? 1 : r;
			};
			SlowMo.ease = new SlowMo(0.7, 0.7);
	
			p.config = SlowMo.config = function(linearRatio, power, yoyoMode) {
				return new SlowMo(linearRatio, power, yoyoMode);
			};
	
	
			//SteppedEase
			SteppedEase = _class("easing.SteppedEase", function(steps, immediateStart) {
					steps = steps || 1;
					this._p1 = 1 / steps;
					this._p2 = steps + (immediateStart ? 0 : 1);
					this._p3 = immediateStart ? 1 : 0;
				}, true);
			p = SteppedEase.prototype = new Ease();
			p.constructor = SteppedEase;
			p.getRatio = function(p) {
				if (p < 0) {
					p = 0;
				} else if (p >= 1) {
					p = 0.999999999;
				}
				return (((this._p2 * p) | 0) + this._p3) * this._p1;
			};
			p.config = SteppedEase.config = function(steps, immediateStart) {
				return new SteppedEase(steps, immediateStart);
			};
	
			//ExpoScaleEase
			ExpoScaleEase = _class("easing.ExpoScaleEase", function(start, end, ease) {
				this._p1 = Math.log(end / start);
				this._p2 = end - start;
				this._p3 = start;
				this._ease = ease;
			}, true);
			p = ExpoScaleEase.prototype = new Ease();
			p.constructor = ExpoScaleEase;
			p.getRatio = function(p) {
				if (this._ease) {
					p = this._ease.getRatio(p);
				}
				return (this._p3 * Math.exp(this._p1 * p) - this._p3) / this._p2;
			};
			p.config = ExpoScaleEase.config = function(start, end, ease) {
				return new ExpoScaleEase(start, end, ease);
			};
	
	
			//RoughEase
			RoughEase = _class("easing.RoughEase", function(vars) {
				vars = vars || {};
				var taper = vars.taper || "none",
					a = [],
					cnt = 0,
					points = (vars.points || 20) | 0,
					i = points,
					randomize = (vars.randomize !== false),
					clamp = (vars.clamp === true),
					template = (vars.template instanceof Ease) ? vars.template : null,
					strength = (typeof(vars.strength) === "number") ? vars.strength * 0.4 : 0.4,
					x, y, bump, invX, obj, pnt;
				while (--i > -1) {
					x = randomize ? Math.random() : (1 / points) * i;
					y = template ? template.getRatio(x) : x;
					if (taper === "none") {
						bump = strength;
					} else if (taper === "out") {
						invX = 1 - x;
						bump = invX * invX * strength;
					} else if (taper === "in") {
						bump = x * x * strength;
					} else if (x < 0.5) {  //"both" (start)
						invX = x * 2;
						bump = invX * invX * 0.5 * strength;
					} else {				//"both" (end)
						invX = (1 - x) * 2;
						bump = invX * invX * 0.5 * strength;
					}
					if (randomize) {
						y += (Math.random() * bump) - (bump * 0.5);
					} else if (i % 2) {
						y += bump * 0.5;
					} else {
						y -= bump * 0.5;
					}
					if (clamp) {
						if (y > 1) {
							y = 1;
						} else if (y < 0) {
							y = 0;
						}
					}
					a[cnt++] = {x:x, y:y};
				}
				a.sort(function(a, b) {
					return a.x - b.x;
				});
	
				pnt = new EasePoint(1, 1, null);
				i = points;
				while (--i > -1) {
					obj = a[i];
					pnt = new EasePoint(obj.x, obj.y, pnt);
				}
	
				this._prev = new EasePoint(0, 0, (pnt.t !== 0) ? pnt : pnt.next);
			}, true);
			p = RoughEase.prototype = new Ease();
			p.constructor = RoughEase;
			p.getRatio = function(p) {
				var pnt = this._prev;
				if (p > pnt.t) {
					while (pnt.next && p >= pnt.t) {
						pnt = pnt.next;
					}
					pnt = pnt.prev;
				} else {
					while (pnt.prev && p <= pnt.t) {
						pnt = pnt.prev;
					}
				}
				this._prev = pnt;
				return (pnt.v + ((p - pnt.t) / pnt.gap) * pnt.c);
			};
			p.config = function(vars) {
				return new RoughEase(vars);
			};
			RoughEase.ease = new RoughEase();
	
	
			//Bounce
			_wrap("Bounce",
				_create("BounceOut", function(p) {
					if (p < 1 / 2.75) {
						return 7.5625 * p * p;
					} else if (p < 2 / 2.75) {
						return 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
					} else if (p < 2.5 / 2.75) {
						return 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
					}
					return 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
				}),
				_create("BounceIn", function(p) {
					if ((p = 1 - p) < 1 / 2.75) {
						return 1 - (7.5625 * p * p);
					} else if (p < 2 / 2.75) {
						return 1 - (7.5625 * (p -= 1.5 / 2.75) * p + 0.75);
					} else if (p < 2.5 / 2.75) {
						return 1 - (7.5625 * (p -= 2.25 / 2.75) * p + 0.9375);
					}
					return 1 - (7.5625 * (p -= 2.625 / 2.75) * p + 0.984375);
				}),
				_create("BounceInOut", function(p) {
					var invert = (p < 0.5);
					if (invert) {
						p = 1 - (p * 2);
					} else {
						p = (p * 2) - 1;
					}
					if (p < 1 / 2.75) {
						p = 7.5625 * p * p;
					} else if (p < 2 / 2.75) {
						p = 7.5625 * (p -= 1.5 / 2.75) * p + 0.75;
					} else if (p < 2.5 / 2.75) {
						p = 7.5625 * (p -= 2.25 / 2.75) * p + 0.9375;
					} else {
						p = 7.5625 * (p -= 2.625 / 2.75) * p + 0.984375;
					}
					return invert ? (1 - p) * 0.5 : p * 0.5 + 0.5;
				})
			);
	
	
			//CIRC
			_wrap("Circ",
				_create("CircOut", function(p) {
					return Math.sqrt(1 - (p = p - 1) * p);
				}),
				_create("CircIn", function(p) {
					return -(Math.sqrt(1 - (p * p)) - 1);
				}),
				_create("CircInOut", function(p) {
					return ((p*=2) < 1) ? -0.5 * (Math.sqrt(1 - p * p) - 1) : 0.5 * (Math.sqrt(1 - (p -= 2) * p) + 1);
				})
			);
	
	
			//Elastic
			_createElastic = function(n, f, def) {
				var C = _class("easing." + n, function(amplitude, period) {
						this._p1 = (amplitude >= 1) ? amplitude : 1; //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
						this._p2 = (period || def) / (amplitude < 1 ? amplitude : 1);
						this._p3 = this._p2 / _2PI * (Math.asin(1 / this._p1) || 0);
						this._p2 = _2PI / this._p2; //precalculate to optimize
					}, true),
					p = C.prototype = new Ease();
				p.constructor = C;
				p.getRatio = f;
				p.config = function(amplitude, period) {
					return new C(amplitude, period);
				};
				return C;
			};
			_wrap("Elastic",
				_createElastic("ElasticOut", function(p) {
					return this._p1 * Math.pow(2, -10 * p) * Math.sin( (p - this._p3) * this._p2 ) + 1;
				}, 0.3),
				_createElastic("ElasticIn", function(p) {
					return -(this._p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin( (p - this._p3) * this._p2 ));
				}, 0.3),
				_createElastic("ElasticInOut", function(p) {
					return ((p *= 2) < 1) ? -0.5 * (this._p1 * Math.pow(2, 10 * (p -= 1)) * Math.sin( (p - this._p3) * this._p2)) : this._p1 * Math.pow(2, -10 *(p -= 1)) * Math.sin( (p - this._p3) * this._p2 ) * 0.5 + 1;
				}, 0.45)
			);
	
	
			//Expo
			_wrap("Expo",
				_create("ExpoOut", function(p) {
					return 1 - Math.pow(2, -10 * p);
				}),
				_create("ExpoIn", function(p) {
					return Math.pow(2, 10 * (p - 1)) - 0.001;
				}),
				_create("ExpoInOut", function(p) {
					return ((p *= 2) < 1) ? 0.5 * Math.pow(2, 10 * (p - 1)) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
				})
			);
	
	
			//Sine
			_wrap("Sine",
				_create("SineOut", function(p) {
					return Math.sin(p * _HALF_PI);
				}),
				_create("SineIn", function(p) {
					return -Math.cos(p * _HALF_PI) + 1;
				}),
				_create("SineInOut", function(p) {
					return -0.5 * (Math.cos(Math.PI * p) - 1);
				})
			);
	
			_class("easing.EaseLookup", {
					find:function(s) {
						return Ease.map[s];
					}
				}, true);
	
			//register the non-standard eases
			_easeReg(w.SlowMo, "SlowMo", "ease,");
			_easeReg(RoughEase, "RoughEase", "ease,");
			_easeReg(SteppedEase, "SteppedEase", "ease,");
	
			return Back;
			
		}, true);
	
	
	});
	
	if (_gsScope._gsDefine) { _gsScope._gsQueue.pop()(); } //necessary in case TweenLite was already loaded separately.
	
	
	
	
	
	
	
	
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * Base classes like TweenLite, SimpleTimeline, Ease, Ticker, etc.
	 * ----------------------------------------------------------------
	 */
	(function(window, moduleName) {
	
			"use strict";
			var _exports = {},
				_doc = window.document,
				_globals = window.GreenSockGlobals = window.GreenSockGlobals || window;
			if (_globals.TweenLite) {
				return; //in case the core set of classes is already loaded, don't instantiate twice.
			}
			var _namespace = function(ns) {
					var a = ns.split("."),
						p = _globals, i;
					for (i = 0; i < a.length; i++) {
						p[a[i]] = p = p[a[i]] || {};
					}
					return p;
				},
				gs = _namespace("com.greensock"),
				_tinyNum = 0.0000000001,
				_slice = function(a) { //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
					var b = [],
						l = a.length,
						i;
					for (i = 0; i !== l; b.push(a[i++])) {}
					return b;
				},
				_emptyFunc = function() {},
				_isArray = (function() { //works around issues in iframe environments where the Array global isn't shared, thus if the object originates in a different window/iframe, "(obj instanceof Array)" will evaluate false. We added some speed optimizations to avoid Object.prototype.toString.call() unless it's absolutely necessary because it's VERY slow (like 20x slower)
					var toString = Object.prototype.toString,
						array = toString.call([]);
					return function(obj) {
						return obj != null && (obj instanceof Array || (typeof(obj) === "object" && !!obj.push && toString.call(obj) === array));
					};
				}()),
				a, i, p, _ticker, _tickerActive,
				_defLookup = {},
	
				/**
				 * @constructor
				 * Defines a GreenSock class, optionally with an array of dependencies that must be instantiated first and passed into the definition.
				 * This allows users to load GreenSock JS files in any order even if they have interdependencies (like CSSPlugin extends TweenPlugin which is
				 * inside TweenLite.js, but if CSSPlugin is loaded first, it should wait to run its code until TweenLite.js loads and instantiates TweenPlugin
				 * and then pass TweenPlugin to CSSPlugin's definition). This is all done automatically and internally.
				 *
				 * Every definition will be added to a "com.greensock" global object (typically window, but if a window.GreenSockGlobals object is found,
				 * it will go there as of v1.7). For example, TweenLite will be found at window.com.greensock.TweenLite and since it's a global class that should be available anywhere,
				 * it is ALSO referenced at window.TweenLite. However some classes aren't considered global, like the base com.greensock.core.Animation class, so
				 * those will only be at the package like window.com.greensock.core.Animation. Again, if you define a GreenSockGlobals object on the window, everything
				 * gets tucked neatly inside there instead of on the window directly. This allows you to do advanced things like load multiple versions of GreenSock
				 * files and put them into distinct objects (imagine a banner ad uses a newer version but the main site uses an older one). In that case, you could
				 * sandbox the banner one like:
				 *
				 * <script>
				 *     var gs = window.GreenSockGlobals = {}; //the newer version we're about to load could now be referenced in a "gs" object, like gs.TweenLite.to(...). Use whatever alias you want as long as it's unique, "gs" or "banner" or whatever.
				 * </script>
				 * <script src="js/greensock/v1.7/TweenMax.js"></script>
				 * <script>
				 *     window.GreenSockGlobals = window._gsQueue = window._gsDefine = null; //reset it back to null (along with the special _gsQueue variable) so that the next load of TweenMax affects the window and we can reference things directly like TweenLite.to(...)
				 * </script>
				 * <script src="js/greensock/v1.6/TweenMax.js"></script>
				 * <script>
				 *     gs.TweenLite.to(...); //would use v1.7
				 *     TweenLite.to(...); //would use v1.6
				 * </script>
				 *
				 * @param {!string} ns The namespace of the class definition, leaving off "com.greensock." as that's assumed. For example, "TweenLite" or "plugins.CSSPlugin" or "easing.Back".
				 * @param {!Array.<string>} dependencies An array of dependencies (described as their namespaces minus "com.greensock." prefix). For example ["TweenLite","plugins.TweenPlugin","core.Animation"]
				 * @param {!function():Object} func The function that should be called and passed the resolved dependencies which will return the actual class for this definition.
				 * @param {boolean=} global If true, the class will be added to the global scope (typically window unless you define a window.GreenSockGlobals object)
				 */
				Definition = function(ns, dependencies, func, global) {
					this.sc = (_defLookup[ns]) ? _defLookup[ns].sc : []; //subclasses
					_defLookup[ns] = this;
					this.gsClass = null;
					this.func = func;
					var _classes = [];
					this.check = function(init) {
						var i = dependencies.length,
							missing = i,
							cur, a, n, cl;
						while (--i > -1) {
							if ((cur = _defLookup[dependencies[i]] || new Definition(dependencies[i], [])).gsClass) {
								_classes[i] = cur.gsClass;
								missing--;
							} else if (init) {
								cur.sc.push(this);
							}
						}
						if (missing === 0 && func) {
							a = ("com.greensock." + ns).split(".");
							n = a.pop();
							cl = _namespace(a.join("."))[n] = this.gsClass = func.apply(func, _classes);
	
							//exports to multiple environments
							if (global) {
								_globals[n] = _exports[n] = cl; //provides a way to avoid global namespace pollution. By default, the main classes like TweenLite, Power1, Strong, etc. are added to window unless a GreenSockGlobals is defined. So if you want to have things added to a custom object instead, just do something like window.GreenSockGlobals = {} before loading any GreenSock files. You can even set up an alias like window.GreenSockGlobals = windows.gs = {} so that you can access everything like gs.TweenLite. Also remember that ALL classes are added to the window.com.greensock object (in their respective packages, like com.greensock.easing.Power1, com.greensock.TweenLite, etc.)
								if (typeof(module) !== "undefined" && module.exports) { //node
									if (ns === moduleName) {
										module.exports = _exports[moduleName] = cl;
										for (i in _exports) {
											cl[i] = _exports[i];
										}
									} else if (_exports[moduleName]) {
										_exports[moduleName][n] = cl;
									}
								} else if (true){ //AMD
									!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() { return cl; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
								}
							}
							for (i = 0; i < this.sc.length; i++) {
								this.sc[i].check();
							}
						}
					};
					this.check(true);
				},
	
				//used to create Definition instances (which basically registers a class that has dependencies).
				_gsDefine = window._gsDefine = function(ns, dependencies, func, global) {
					return new Definition(ns, dependencies, func, global);
				},
	
				//a quick way to create a class that doesn't have any dependencies. Returns the class, but first registers it in the GreenSock namespace so that other classes can grab it (other classes might be dependent on the class).
				_class = gs._class = function(ns, func, global) {
					func = func || function() {};
					_gsDefine(ns, [], function(){ return func; }, global);
					return func;
				};
	
			_gsDefine.globals = _globals;
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * Ease
	 * ----------------------------------------------------------------
	 */
			var _baseParams = [0, 0, 1, 1],
				Ease = _class("easing.Ease", function(func, extraParams, type, power) {
					this._func = func;
					this._type = type || 0;
					this._power = power || 0;
					this._params = extraParams ? _baseParams.concat(extraParams) : _baseParams;
				}, true),
				_easeMap = Ease.map = {},
				_easeReg = Ease.register = function(ease, names, types, create) {
					var na = names.split(","),
						i = na.length,
						ta = (types || "easeIn,easeOut,easeInOut").split(","),
						e, name, j, type;
					while (--i > -1) {
						name = na[i];
						e = create ? _class("easing."+name, null, true) : gs.easing[name] || {};
						j = ta.length;
						while (--j > -1) {
							type = ta[j];
							_easeMap[name + "." + type] = _easeMap[type + name] = e[type] = ease.getRatio ? ease : ease[type] || new ease();
						}
					}
				};
	
			p = Ease.prototype;
			p._calcEnd = false;
			p.getRatio = function(p) {
				if (this._func) {
					this._params[0] = p;
					return this._func.apply(null, this._params);
				}
				var t = this._type,
					pw = this._power,
					r = (t === 1) ? 1 - p : (t === 2) ? p : (p < 0.5) ? p * 2 : (1 - p) * 2;
				if (pw === 1) {
					r *= r;
				} else if (pw === 2) {
					r *= r * r;
				} else if (pw === 3) {
					r *= r * r * r;
				} else if (pw === 4) {
					r *= r * r * r * r;
				}
				return (t === 1) ? 1 - r : (t === 2) ? r : (p < 0.5) ? r / 2 : 1 - (r / 2);
			};
	
			//create all the standard eases like Linear, Quad, Cubic, Quart, Quint, Strong, Power0, Power1, Power2, Power3, and Power4 (each with easeIn, easeOut, and easeInOut)
			a = ["Linear","Quad","Cubic","Quart","Quint,Strong"];
			i = a.length;
			while (--i > -1) {
				p = a[i]+",Power"+i;
				_easeReg(new Ease(null,null,1,i), p, "easeOut", true);
				_easeReg(new Ease(null,null,2,i), p, "easeIn" + ((i === 0) ? ",easeNone" : ""));
				_easeReg(new Ease(null,null,3,i), p, "easeInOut");
			}
			_easeMap.linear = gs.easing.Linear.easeIn;
			_easeMap.swing = gs.easing.Quad.easeInOut; //for jQuery folks
	
	
	/*
	 * ----------------------------------------------------------------
	 * EventDispatcher
	 * ----------------------------------------------------------------
	 */
			var EventDispatcher = _class("events.EventDispatcher", function(target) {
				this._listeners = {};
				this._eventTarget = target || this;
			});
			p = EventDispatcher.prototype;
	
			p.addEventListener = function(type, callback, scope, useParam, priority) {
				priority = priority || 0;
				var list = this._listeners[type],
					index = 0,
					listener, i;
				if (this === _ticker && !_tickerActive) {
					_ticker.wake();
				}
				if (list == null) {
					this._listeners[type] = list = [];
				}
				i = list.length;
				while (--i > -1) {
					listener = list[i];
					if (listener.c === callback && listener.s === scope) {
						list.splice(i, 1);
					} else if (index === 0 && listener.pr < priority) {
						index = i + 1;
					}
				}
				list.splice(index, 0, {c:callback, s:scope, up:useParam, pr:priority});
			};
	
			p.removeEventListener = function(type, callback) {
				var list = this._listeners[type], i;
				if (list) {
					i = list.length;
					while (--i > -1) {
						if (list[i].c === callback) {
							list.splice(i, 1);
							return;
						}
					}
				}
			};
	
			p.dispatchEvent = function(type) {
				var list = this._listeners[type],
					i, t, listener;
				if (list) {
					i = list.length;
					if (i > 1) {
						list = list.slice(0); //in case addEventListener() is called from within a listener/callback (otherwise the index could change, resulting in a skip)
					}
					t = this._eventTarget;
					while (--i > -1) {
						listener = list[i];
						if (listener) {
							if (listener.up) {
								listener.c.call(listener.s || t, {type:type, target:t});
							} else {
								listener.c.call(listener.s || t);
							}
						}
					}
				}
			};
	
	
	/*
	 * ----------------------------------------------------------------
	 * Ticker
	 * ----------------------------------------------------------------
	 */
	 		var _reqAnimFrame = window.requestAnimationFrame,
				_cancelAnimFrame = window.cancelAnimationFrame,
				_getTime = Date.now || function() {return new Date().getTime();},
				_lastUpdate = _getTime();
	
			//now try to determine the requestAnimationFrame and cancelAnimationFrame functions and if none are found, we'll use a setTimeout()/clearTimeout() polyfill.
			a = ["ms","moz","webkit","o"];
			i = a.length;
			while (--i > -1 && !_reqAnimFrame) {
				_reqAnimFrame = window[a[i] + "RequestAnimationFrame"];
				_cancelAnimFrame = window[a[i] + "CancelAnimationFrame"] || window[a[i] + "CancelRequestAnimationFrame"];
			}
	
			_class("Ticker", function(fps, useRAF) {
				var _self = this,
					_startTime = _getTime(),
					_useRAF = (useRAF !== false && _reqAnimFrame) ? "auto" : false,
					_lagThreshold = 500,
					_adjustedLag = 33,
					_tickWord = "tick", //helps reduce gc burden
					_fps, _req, _id, _gap, _nextTime,
					_tick = function(manual) {
						var elapsed = _getTime() - _lastUpdate,
							overlap, dispatch;
						if (elapsed > _lagThreshold) {
							_startTime += elapsed - _adjustedLag;
						}
						_lastUpdate += elapsed;
						_self.time = (_lastUpdate - _startTime) / 1000;
						overlap = _self.time - _nextTime;
						if (!_fps || overlap > 0 || manual === true) {
							_self.frame++;
							_nextTime += overlap + (overlap >= _gap ? 0.004 : _gap - overlap);
							dispatch = true;
						}
						if (manual !== true) { //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
							_id = _req(_tick);
						}
						if (dispatch) {
							_self.dispatchEvent(_tickWord);
						}
					};
	
				EventDispatcher.call(_self);
				_self.time = _self.frame = 0;
				_self.tick = function() {
					_tick(true);
				};
	
				_self.lagSmoothing = function(threshold, adjustedLag) {
					if (!arguments.length) { //if lagSmoothing() is called with no arguments, treat it like a getter that returns a boolean indicating if it's enabled or not. This is purposely undocumented and is for internal use.
						return (_lagThreshold < 1 / _tinyNum);
					}
					_lagThreshold = threshold || (1 / _tinyNum); //zero should be interpreted as basically unlimited
					_adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
				};
	
				_self.sleep = function() {
					if (_id == null) {
						return;
					}
					if (!_useRAF || !_cancelAnimFrame) {
						clearTimeout(_id);
					} else {
						_cancelAnimFrame(_id);
					}
					_req = _emptyFunc;
					_id = null;
					if (_self === _ticker) {
						_tickerActive = false;
					}
				};
	
				_self.wake = function(seamless) {
					if (_id !== null) {
						_self.sleep();
					} else if (seamless) {
						_startTime += -_lastUpdate + (_lastUpdate = _getTime());
					} else if (_self.frame > 10) { //don't trigger lagSmoothing if we're just waking up, and make sure that at least 10 frames have elapsed because of the iOS bug that we work around below with the 1.5-second setTimout().
						_lastUpdate = _getTime() - _lagThreshold + 5;
					}
					_req = (_fps === 0) ? _emptyFunc : (!_useRAF || !_reqAnimFrame) ? function(f) { return setTimeout(f, ((_nextTime - _self.time) * 1000 + 1) | 0); } : _reqAnimFrame;
					if (_self === _ticker) {
						_tickerActive = true;
					}
					_tick(2);
				};
	
				_self.fps = function(value) {
					if (!arguments.length) {
						return _fps;
					}
					_fps = value;
					_gap = 1 / (_fps || 60);
					_nextTime = this.time + _gap;
					_self.wake();
				};
	
				_self.useRAF = function(value) {
					if (!arguments.length) {
						return _useRAF;
					}
					_self.sleep();
					_useRAF = value;
					_self.fps(_fps);
				};
				_self.fps(fps);
	
				//a bug in iOS 6 Safari occasionally prevents the requestAnimationFrame from working initially, so we use a 1.5-second timeout that automatically falls back to setTimeout() if it senses this condition.
				setTimeout(function() {
					if (_useRAF === "auto" && _self.frame < 5 && (_doc || {}).visibilityState !== "hidden") {
						_self.useRAF(false);
					}
				}, 1500);
			});
	
			p = gs.Ticker.prototype = new gs.events.EventDispatcher();
			p.constructor = gs.Ticker;
	
	
	/*
	 * ----------------------------------------------------------------
	 * Animation
	 * ----------------------------------------------------------------
	 */
			var Animation = _class("core.Animation", function(duration, vars) {
					this.vars = vars = vars || {};
					this._duration = this._totalDuration = duration || 0;
					this._delay = Number(vars.delay) || 0;
					this._timeScale = 1;
					this._active = (vars.immediateRender === true);
					this.data = vars.data;
					this._reversed = (vars.reversed === true);
	
					if (!_rootTimeline) {
						return;
					}
					if (!_tickerActive) { //some browsers (like iOS 6 Safari) shut down JavaScript execution when the tab is disabled and they [occasionally] neglect to start up requestAnimationFrame again when returning - this code ensures that the engine starts up again properly.
						_ticker.wake();
					}
	
					var tl = this.vars.useFrames ? _rootFramesTimeline : _rootTimeline;
					tl.add(this, tl._time);
	
					if (this.vars.paused) {
						this.paused(true);
					}
				});
	
			_ticker = Animation.ticker = new gs.Ticker();
			p = Animation.prototype;
			p._dirty = p._gc = p._initted = p._paused = false;
			p._totalTime = p._time = 0;
			p._rawPrevTime = -1;
			p._next = p._last = p._onUpdate = p._timeline = p.timeline = null;
			p._paused = false;
	
	
			//some browsers (like iOS) occasionally drop the requestAnimationFrame event when the user switches to a different tab and then comes back again, so we use a 2-second setTimeout() to sense if/when that condition occurs and then wake() the ticker.
			var _checkTimeout = function() {
					if (_tickerActive && _getTime() - _lastUpdate > 2000 && ((_doc || {}).visibilityState !== "hidden" || !_ticker.lagSmoothing())) { //note: if the tab is hidden, we should still wake if lagSmoothing has been disabled.
						_ticker.wake();
					}
					var t = setTimeout(_checkTimeout, 2000);
					if (t.unref) {
						// allows a node process to exit even if the timeout’s callback hasn't been invoked. Without it, the node process could hang as this function is called every two seconds.
						t.unref();
					}
				};
			_checkTimeout();
	
	
			p.play = function(from, suppressEvents) {
				if (from != null) {
					this.seek(from, suppressEvents);
				}
				return this.reversed(false).paused(false);
			};
	
			p.pause = function(atTime, suppressEvents) {
				if (atTime != null) {
					this.seek(atTime, suppressEvents);
				}
				return this.paused(true);
			};
	
			p.resume = function(from, suppressEvents) {
				if (from != null) {
					this.seek(from, suppressEvents);
				}
				return this.paused(false);
			};
	
			p.seek = function(time, suppressEvents) {
				return this.totalTime(Number(time), suppressEvents !== false);
			};
	
			p.restart = function(includeDelay, suppressEvents) {
				return this.reversed(false).paused(false).totalTime(includeDelay ? -this._delay : 0, (suppressEvents !== false), true);
			};
	
			p.reverse = function(from, suppressEvents) {
				if (from != null) {
					this.seek((from || this.totalDuration()), suppressEvents);
				}
				return this.reversed(true).paused(false);
			};
	
			p.render = function(time, suppressEvents, force) {
				//stub - we override this method in subclasses.
			};
	
			p.invalidate = function() {
				this._time = this._totalTime = 0;
				this._initted = this._gc = false;
				this._rawPrevTime = -1;
				if (this._gc || !this.timeline) {
					this._enabled(true);
				}
				return this;
			};
	
			p.isActive = function() {
				var tl = this._timeline, //the 2 root timelines won't have a _timeline; they're always active.
					startTime = this._startTime,
					rawTime;
				return (!tl || (!this._gc && !this._paused && tl.isActive() && (rawTime = tl.rawTime(true)) >= startTime && rawTime < startTime + this.totalDuration() / this._timeScale - 0.0000001));
			};
	
			p._enabled = function (enabled, ignoreTimeline) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				this._gc = !enabled;
				this._active = this.isActive();
				if (ignoreTimeline !== true) {
					if (enabled && !this.timeline) {
						this._timeline.add(this, this._startTime - this._delay);
					} else if (!enabled && this.timeline) {
						this._timeline._remove(this, true);
					}
				}
				return false;
			};
	
	
			p._kill = function(vars, target) {
				return this._enabled(false, false);
			};
	
			p.kill = function(vars, target) {
				this._kill(vars, target);
				return this;
			};
	
			p._uncache = function(includeSelf) {
				var tween = includeSelf ? this : this.timeline;
				while (tween) {
					tween._dirty = true;
					tween = tween.timeline;
				}
				return this;
			};
	
			p._swapSelfInParams = function(params) {
				var i = params.length,
					copy = params.concat();
				while (--i > -1) {
					if (params[i] === "{self}") {
						copy[i] = this;
					}
				}
				return copy;
			};
	
			p._callback = function(type) {
				var v = this.vars,
					callback = v[type],
					params = v[type + "Params"],
					scope = v[type + "Scope"] || v.callbackScope || this,
					l = params ? params.length : 0;
				switch (l) { //speed optimization; call() is faster than apply() so use it when there are only a few parameters (which is by far most common). Previously we simply did var v = this.vars; v[type].apply(v[type + "Scope"] || v.callbackScope || this, v[type + "Params"] || _blankArray);
					case 0: callback.call(scope); break;
					case 1: callback.call(scope, params[0]); break;
					case 2: callback.call(scope, params[0], params[1]); break;
					default: callback.apply(scope, params);
				}
			};
	
	//----Animation getters/setters --------------------------------------------------------
	
			p.eventCallback = function(type, callback, params, scope) {
				if ((type || "").substr(0,2) === "on") {
					var v = this.vars;
					if (arguments.length === 1) {
						return v[type];
					}
					if (callback == null) {
						delete v[type];
					} else {
						v[type] = callback;
						v[type + "Params"] = (_isArray(params) && params.join("").indexOf("{self}") !== -1) ? this._swapSelfInParams(params) : params;
						v[type + "Scope"] = scope;
					}
					if (type === "onUpdate") {
						this._onUpdate = callback;
					}
				}
				return this;
			};
	
			p.delay = function(value) {
				if (!arguments.length) {
					return this._delay;
				}
				if (this._timeline.smoothChildTiming) {
					this.startTime( this._startTime + value - this._delay );
				}
				this._delay = value;
				return this;
			};
	
			p.duration = function(value) {
				if (!arguments.length) {
					this._dirty = false;
					return this._duration;
				}
				this._duration = this._totalDuration = value;
				this._uncache(true); //true in case it's a TweenMax or TimelineMax that has a repeat - we'll need to refresh the totalDuration.
				if (this._timeline.smoothChildTiming) if (this._time > 0) if (this._time < this._duration) if (value !== 0) {
					this.totalTime(this._totalTime * (value / this._duration), true);
				}
				return this;
			};
	
			p.totalDuration = function(value) {
				this._dirty = false;
				return (!arguments.length) ? this._totalDuration : this.duration(value);
			};
	
			p.time = function(value, suppressEvents) {
				if (!arguments.length) {
					return this._time;
				}
				if (this._dirty) {
					this.totalDuration();
				}
				return this.totalTime((value > this._duration) ? this._duration : value, suppressEvents);
			};
	
			p.totalTime = function(time, suppressEvents, uncapped) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				if (!arguments.length) {
					return this._totalTime;
				}
				if (this._timeline) {
					if (time < 0 && !uncapped) {
						time += this.totalDuration();
					}
					if (this._timeline.smoothChildTiming) {
						if (this._dirty) {
							this.totalDuration();
						}
						var totalDuration = this._totalDuration,
							tl = this._timeline;
						if (time > totalDuration && !uncapped) {
							time = totalDuration;
						}
						this._startTime = (this._paused ? this._pauseTime : tl._time) - ((!this._reversed ? time : totalDuration - time) / this._timeScale);
						if (!tl._dirty) { //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
							this._uncache(false);
						}
						//in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The startTime of that child would get pushed out, but one of the ancestors may have completed.
						if (tl._timeline) {
							while (tl._timeline) {
								if (tl._timeline._time !== (tl._startTime + tl._totalTime) / tl._timeScale) {
									tl.totalTime(tl._totalTime, true);
								}
								tl = tl._timeline;
							}
						}
					}
					if (this._gc) {
						this._enabled(true, false);
					}
					if (this._totalTime !== time || this._duration === 0) {
						if (_lazyTweens.length) {
							_lazyRender();
						}
						this.render(time, suppressEvents, false);
						if (_lazyTweens.length) { //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
							_lazyRender();
						}
					}
				}
				return this;
			};
	
			p.progress = p.totalProgress = function(value, suppressEvents) {
				var duration = this.duration();
				return (!arguments.length) ? (duration ? this._time / duration : this.ratio) : this.totalTime(duration * value, suppressEvents);
			};
	
			p.startTime = function(value) {
				if (!arguments.length) {
					return this._startTime;
				}
				if (value !== this._startTime) {
					this._startTime = value;
					if (this.timeline) if (this.timeline._sortChildren) {
						this.timeline.add(this, value - this._delay); //ensures that any necessary re-sequencing of Animations in the timeline occurs to make sure the rendering order is correct.
					}
				}
				return this;
			};
	
			p.endTime = function(includeRepeats) {
				return this._startTime + ((includeRepeats != false) ? this.totalDuration() : this.duration()) / this._timeScale;
			};
	
			p.timeScale = function(value) {
				if (!arguments.length) {
					return this._timeScale;
				}
				var pauseTime, t;
				value = value || _tinyNum; //can't allow zero because it'll throw the math off
				if (this._timeline && this._timeline.smoothChildTiming) {
					pauseTime = this._pauseTime;
					t = (pauseTime || pauseTime === 0) ? pauseTime : this._timeline.totalTime();
					this._startTime = t - ((t - this._startTime) * this._timeScale / value);
				}
				this._timeScale = value;
				t = this.timeline;
				while (t && t.timeline) { //must update the duration/totalDuration of all ancestor timelines immediately in case in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
					t._dirty = true;
					t.totalDuration();
					t = t.timeline;
				}
				return this;
			};
	
			p.reversed = function(value) {
				if (!arguments.length) {
					return this._reversed;
				}
				if (value != this._reversed) {
					this._reversed = value;
					this.totalTime(((this._timeline && !this._timeline.smoothChildTiming) ? this.totalDuration() - this._totalTime : this._totalTime), true);
				}
				return this;
			};
	
			p.paused = function(value) {
				if (!arguments.length) {
					return this._paused;
				}
				var tl = this._timeline,
					raw, elapsed;
				if (value != this._paused) if (tl) {
					if (!_tickerActive && !value) {
						_ticker.wake();
					}
					raw = tl.rawTime();
					elapsed = raw - this._pauseTime;
					if (!value && tl.smoothChildTiming) {
						this._startTime += elapsed;
						this._uncache(false);
					}
					this._pauseTime = value ? raw : null;
					this._paused = value;
					this._active = this.isActive();
					if (!value && elapsed !== 0 && this._initted && this.duration()) {
						raw = tl.smoothChildTiming ? this._totalTime : (raw - this._startTime) / this._timeScale;
						this.render(raw, (raw === this._totalTime), true); //in case the target's properties changed via some other tween or manual update by the user, we should force a render.
					}
				}
				if (this._gc && !value) {
					this._enabled(true, false);
				}
				return this;
			};
	
	
	/*
	 * ----------------------------------------------------------------
	 * SimpleTimeline
	 * ----------------------------------------------------------------
	 */
			var SimpleTimeline = _class("core.SimpleTimeline", function(vars) {
				Animation.call(this, 0, vars);
				this.autoRemoveChildren = this.smoothChildTiming = true;
			});
	
			p = SimpleTimeline.prototype = new Animation();
			p.constructor = SimpleTimeline;
			p.kill()._gc = false;
			p._first = p._last = p._recent = null;
			p._sortChildren = false;
	
			p.add = p.insert = function(child, position, align, stagger) {
				var prevTween, st;
				child._startTime = Number(position || 0) + child._delay;
				if (child._paused) if (this !== child._timeline) { //we only adjust the _pauseTime if it wasn't in this timeline already. Remember, sometimes a tween will be inserted again into the same timeline when its startTime is changed so that the tweens in the TimelineLite/Max are re-ordered properly in the linked list (so everything renders in the proper order).
					child._pauseTime = child._startTime + ((this.rawTime() - child._startTime) / child._timeScale);
				}
				if (child.timeline) {
					child.timeline._remove(child, true); //removes from existing timeline so that it can be properly added to this one.
				}
				child.timeline = child._timeline = this;
				if (child._gc) {
					child._enabled(true, true);
				}
				prevTween = this._last;
				if (this._sortChildren) {
					st = child._startTime;
					while (prevTween && prevTween._startTime > st) {
						prevTween = prevTween._prev;
					}
				}
				if (prevTween) {
					child._next = prevTween._next;
					prevTween._next = child;
				} else {
					child._next = this._first;
					this._first = child;
				}
				if (child._next) {
					child._next._prev = child;
				} else {
					this._last = child;
				}
				child._prev = prevTween;
				this._recent = child;
				if (this._timeline) {
					this._uncache(true);
				}
				return this;
			};
	
			p._remove = function(tween, skipDisable) {
				if (tween.timeline === this) {
					if (!skipDisable) {
						tween._enabled(false, true);
					}
	
					if (tween._prev) {
						tween._prev._next = tween._next;
					} else if (this._first === tween) {
						this._first = tween._next;
					}
					if (tween._next) {
						tween._next._prev = tween._prev;
					} else if (this._last === tween) {
						this._last = tween._prev;
					}
					tween._next = tween._prev = tween.timeline = null;
					if (tween === this._recent) {
						this._recent = this._last;
					}
	
					if (this._timeline) {
						this._uncache(true);
					}
				}
				return this;
			};
	
			p.render = function(time, suppressEvents, force) {
				var tween = this._first,
					next;
				this._totalTime = this._time = this._rawPrevTime = time;
				while (tween) {
					next = tween._next; //record it here because the value could change after rendering...
					if (tween._active || (time >= tween._startTime && !tween._paused && !tween._gc)) {
						if (!tween._reversed) {
							tween.render((time - tween._startTime) * tween._timeScale, suppressEvents, force);
						} else {
							tween.render(((!tween._dirty) ? tween._totalDuration : tween.totalDuration()) - ((time - tween._startTime) * tween._timeScale), suppressEvents, force);
						}
					}
					tween = next;
				}
			};
	
			p.rawTime = function() {
				if (!_tickerActive) {
					_ticker.wake();
				}
				return this._totalTime;
			};
	
	/*
	 * ----------------------------------------------------------------
	 * TweenLite
	 * ----------------------------------------------------------------
	 */
			var TweenLite = _class("TweenLite", function(target, duration, vars) {
					Animation.call(this, duration, vars);
					this.render = TweenLite.prototype.render; //speed optimization (avoid prototype lookup on this "hot" method)
	
					if (target == null) {
						throw "Cannot tween a null target.";
					}
	
					this.target = target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;
	
					var isSelector = (target.jquery || (target.length && target !== window && target[0] && (target[0] === window || (target[0].nodeType && target[0].style && !target.nodeType)))),
						overwrite = this.vars.overwrite,
						i, targ, targets;
	
					this._overwrite = overwrite = (overwrite == null) ? _overwriteLookup[TweenLite.defaultOverwrite] : (typeof(overwrite) === "number") ? overwrite >> 0 : _overwriteLookup[overwrite];
	
					if ((isSelector || target instanceof Array || (target.push && _isArray(target))) && typeof(target[0]) !== "number") {
						this._targets = targets = _slice(target);  //don't use Array.prototype.slice.call(target, 0) because that doesn't work in IE8 with a NodeList that's returned by querySelectorAll()
						this._propLookup = [];
						this._siblings = [];
						for (i = 0; i < targets.length; i++) {
							targ = targets[i];
							if (!targ) {
								targets.splice(i--, 1);
								continue;
							} else if (typeof(targ) === "string") {
								targ = targets[i--] = TweenLite.selector(targ); //in case it's an array of strings
								if (typeof(targ) === "string") {
									targets.splice(i+1, 1); //to avoid an endless loop (can't imagine why the selector would return a string, but just in case)
								}
								continue;
							} else if (targ.length && targ !== window && targ[0] && (targ[0] === window || (targ[0].nodeType && targ[0].style && !targ.nodeType))) { //in case the user is passing in an array of selector objects (like jQuery objects), we need to check one more level and pull things out if necessary. Also note that <select> elements pass all the criteria regarding length and the first child having style, so we must also check to ensure the target isn't an HTML node itself.
								targets.splice(i--, 1);
								this._targets = targets = targets.concat(_slice(targ));
								continue;
							}
							this._siblings[i] = _register(targ, this, false);
							if (overwrite === 1) if (this._siblings[i].length > 1) {
								_applyOverwrite(targ, this, null, 1, this._siblings[i]);
							}
						}
	
					} else {
						this._propLookup = {};
						this._siblings = _register(target, this, false);
						if (overwrite === 1) if (this._siblings.length > 1) {
							_applyOverwrite(target, this, null, 1, this._siblings);
						}
					}
					if (this.vars.immediateRender || (duration === 0 && this._delay === 0 && this.vars.immediateRender !== false)) {
						this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
						this.render(Math.min(0, -this._delay)); //in case delay is negative
					}
				}, true),
				_isSelector = function(v) {
					return (v && v.length && v !== window && v[0] && (v[0] === window || (v[0].nodeType && v[0].style && !v.nodeType))); //we cannot check "nodeType" if the target is window from within an iframe, otherwise it will trigger a security error in some browsers like Firefox.
				},
				_autoCSS = function(vars, target) {
					var css = {},
						p;
					for (p in vars) {
						if (!_reservedProps[p] && (!(p in target) || p === "transform" || p === "x" || p === "y" || p === "width" || p === "height" || p === "className" || p === "border") && (!_plugins[p] || (_plugins[p] && _plugins[p]._autoCSS))) { //note: <img> elements contain read-only "x" and "y" properties. We should also prioritize editing css width/height rather than the element's properties.
							css[p] = vars[p];
							delete vars[p];
						}
					}
					vars.css = css;
				};
	
			p = TweenLite.prototype = new Animation();
			p.constructor = TweenLite;
			p.kill()._gc = false;
	
	//----TweenLite defaults, overwrite management, and root updates ----------------------------------------------------
	
			p.ratio = 0;
			p._firstPT = p._targets = p._overwrittenProps = p._startAt = null;
			p._notifyPluginsOfEnabled = p._lazy = false;
	
			TweenLite.version = "1.20.4";
			TweenLite.defaultEase = p._ease = new Ease(null, null, 1, 1);
			TweenLite.defaultOverwrite = "auto";
			TweenLite.ticker = _ticker;
			TweenLite.autoSleep = 120;
			TweenLite.lagSmoothing = function(threshold, adjustedLag) {
				_ticker.lagSmoothing(threshold, adjustedLag);
			};
	
			TweenLite.selector = window.$ || window.jQuery || function(e) {
				var selector = window.$ || window.jQuery;
				if (selector) {
					TweenLite.selector = selector;
					return selector(e);
				}
				return (typeof(_doc) === "undefined") ? e : (_doc.querySelectorAll ? _doc.querySelectorAll(e) : _doc.getElementById((e.charAt(0) === "#") ? e.substr(1) : e));
			};
	
			var _lazyTweens = [],
				_lazyLookup = {},
				_numbersExp = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig,
				_relExp = /[\+-]=-?[\.\d]/,
				//_nonNumbersExp = /(?:([\-+](?!(\d|=)))|[^\d\-+=e]|(e(?![\-+][\d])))+/ig,
				_setRatio = function(v) {
					var pt = this._firstPT,
						min = 0.000001,
						val;
					while (pt) {
						val = !pt.blob ? pt.c * v + pt.s : (v === 1 && this.end != null) ? this.end : v ? this.join("") : this.start;
						if (pt.m) {
							val = pt.m(val, this._target || pt.t);
						} else if (val < min) if (val > -min && !pt.blob) { //prevents issues with converting very small numbers to strings in the browser
							val = 0;
						}
						if (!pt.f) {
							pt.t[pt.p] = val;
						} else if (pt.fp) {
							pt.t[pt.p](pt.fp, val);
						} else {
							pt.t[pt.p](val);
						}
						pt = pt._next;
					}
				},
				//compares two strings (start/end), finds the numbers that are different and spits back an array representing the whole value but with the changing values isolated as elements. For example, "rgb(0,0,0)" and "rgb(100,50,0)" would become ["rgb(", 0, ",", 50, ",0)"]. Notice it merges the parts that are identical (performance optimization). The array also has a linked list of PropTweens attached starting with _firstPT that contain the tweening data (t, p, s, c, f, etc.). It also stores the starting value as a "start" property so that we can revert to it if/when necessary, like when a tween rewinds fully. If the quantity of numbers differs between the start and end, it will always prioritize the end value(s). The pt parameter is optional - it's for a PropTween that will be appended to the end of the linked list and is typically for actually setting the value after all of the elements have been updated (with array.join("")).
				_blobDif = function(start, end, filter, pt) {
					var a = [],
						charIndex = 0,
						s = "",
						color = 0,
						startNums, endNums, num, i, l, nonNumbers, currentNum;
					a.start = start;
					a.end = end;
					start = a[0] = start + ""; //ensure values are strings
					end = a[1] = end + "";
					if (filter) {
						filter(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
						start = a[0];
						end = a[1];
					}
					a.length = 0;
					startNums = start.match(_numbersExp) || [];
					endNums = end.match(_numbersExp) || [];
					if (pt) {
						pt._next = null;
						pt.blob = 1;
						a._firstPT = a._applyPT = pt; //apply last in the linked list (which means inserting it first)
					}
					l = endNums.length;
					for (i = 0; i < l; i++) {
						currentNum = endNums[i];
						nonNumbers = end.substr(charIndex, end.indexOf(currentNum, charIndex)-charIndex);
						s += (nonNumbers || !i) ? nonNumbers : ","; //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
						charIndex += nonNumbers.length;
						if (color) { //sense rgba() values and round them.
							color = (color + 1) % 5;
						} else if (nonNumbers.substr(-5) === "rgba(") {
							color = 1;
						}
						if (currentNum === startNums[i] || startNums.length <= i) {
							s += currentNum;
						} else {
							if (s) {
								a.push(s);
								s = "";
							}
							num = parseFloat(startNums[i]);
							a.push(num);
							a._firstPT = {_next: a._firstPT, t:a, p: a.length-1, s:num, c:((currentNum.charAt(1) === "=") ? parseInt(currentNum.charAt(0) + "1", 10) * parseFloat(currentNum.substr(2)) : (parseFloat(currentNum) - num)) || 0, f:0, m:(color && color < 4) ? Math.round : 0};
							//note: we don't set _prev because we'll never need to remove individual PropTweens from this list.
						}
						charIndex += currentNum.length;
					}
					s += end.substr(charIndex);
					if (s) {
						a.push(s);
					}
					a.setRatio = _setRatio;
					if (_relExp.test(end)) { //if the end string contains relative values, delete it so that on the final render (in _setRatio()), we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
						a.end = null;
					}
					return a;
				},
				//note: "funcParam" is only necessary for function-based getters/setters that require an extra parameter like getAttribute("width") and setAttribute("width", value). In this example, funcParam would be "width". Used by AttrPlugin for example.
				_addPropTween = function(target, prop, start, end, overwriteProp, mod, funcParam, stringFilter, index) {
					if (typeof(end) === "function") {
						end = end(index || 0, target);
					}
					var type = typeof(target[prop]),
						getterName = (type !== "function") ? "" : ((prop.indexOf("set") || typeof(target["get" + prop.substr(3)]) !== "function") ? prop : "get" + prop.substr(3)),
						s = (start !== "get") ? start : !getterName ? target[prop] : funcParam ? target[getterName](funcParam) : target[getterName](),
						isRelative = (typeof(end) === "string" && end.charAt(1) === "="),
						pt = {t:target, p:prop, s:s, f:(type === "function"), pg:0, n:overwriteProp || prop, m:(!mod ? 0 : (typeof(mod) === "function") ? mod : Math.round), pr:0, c:isRelative ? parseInt(end.charAt(0) + "1", 10) * parseFloat(end.substr(2)) : (parseFloat(end) - s) || 0},
						blob;
	
					if (typeof(s) !== "number" || (typeof(end) !== "number" && !isRelative)) {
						if (funcParam || isNaN(s) || (!isRelative && isNaN(end)) || typeof(s) === "boolean" || typeof(end) === "boolean") {
							//a blob (string that has multiple numbers in it)
							pt.fp = funcParam;
							blob = _blobDif(s, (isRelative ? (parseFloat(pt.s) + pt.c) + (pt.s + "").replace(/[0-9\-\.]/g, "") : end), stringFilter || TweenLite.defaultStringFilter, pt);
							pt = {t: blob, p: "setRatio", s: 0, c: 1, f: 2, pg: 0, n: overwriteProp || prop, pr: 0, m: 0}; //"2" indicates it's a Blob property tween. Needed for RoundPropsPlugin for example.
						} else {
							pt.s = parseFloat(s);
							if (!isRelative) {
								pt.c = (parseFloat(end) - pt.s) || 0;
							}
						}
					}
					if (pt.c) { //only add it to the linked list if there's a change.
						if ((pt._next = this._firstPT)) {
							pt._next._prev = pt;
						}
						this._firstPT = pt;
						return pt;
					}
				},
				_internals = TweenLite._internals = {isArray:_isArray, isSelector:_isSelector, lazyTweens:_lazyTweens, blobDif:_blobDif}, //gives us a way to expose certain private values to other GreenSock classes without contaminating tha main TweenLite object.
				_plugins = TweenLite._plugins = {},
				_tweenLookup = _internals.tweenLookup = {},
				_tweenLookupNum = 0,
				_reservedProps = _internals.reservedProps = {ease:1, delay:1, overwrite:1, onComplete:1, onCompleteParams:1, onCompleteScope:1, useFrames:1, runBackwards:1, startAt:1, onUpdate:1, onUpdateParams:1, onUpdateScope:1, onStart:1, onStartParams:1, onStartScope:1, onReverseComplete:1, onReverseCompleteParams:1, onReverseCompleteScope:1, onRepeat:1, onRepeatParams:1, onRepeatScope:1, easeParams:1, yoyo:1, immediateRender:1, repeat:1, repeatDelay:1, data:1, paused:1, reversed:1, autoCSS:1, lazy:1, onOverwrite:1, callbackScope:1, stringFilter:1, id:1, yoyoEase:1},
				_overwriteLookup = {none:0, all:1, auto:2, concurrent:3, allOnStart:4, preexisting:5, "true":1, "false":0},
				_rootFramesTimeline = Animation._rootFramesTimeline = new SimpleTimeline(),
				_rootTimeline = Animation._rootTimeline = new SimpleTimeline(),
				_nextGCFrame = 30,
				_lazyRender = _internals.lazyRender = function() {
					var i = _lazyTweens.length,
						tween;
					_lazyLookup = {};
					while (--i > -1) {
						tween = _lazyTweens[i];
						if (tween && tween._lazy !== false) {
							tween.render(tween._lazy[0], tween._lazy[1], true);
							tween._lazy = false;
						}
					}
					_lazyTweens.length = 0;
				};
	
			_rootTimeline._startTime = _ticker.time;
			_rootFramesTimeline._startTime = _ticker.frame;
			_rootTimeline._active = _rootFramesTimeline._active = true;
			setTimeout(_lazyRender, 1); //on some mobile devices, there isn't a "tick" before code runs which means any lazy renders wouldn't run before the next official "tick".
	
			Animation._updateRoot = TweenLite.render = function() {
					var i, a, p;
					if (_lazyTweens.length) { //if code is run outside of the requestAnimationFrame loop, there may be tweens queued AFTER the engine refreshed, so we need to ensure any pending renders occur before we refresh again.
						_lazyRender();
					}
					_rootTimeline.render((_ticker.time - _rootTimeline._startTime) * _rootTimeline._timeScale, false, false);
					_rootFramesTimeline.render((_ticker.frame - _rootFramesTimeline._startTime) * _rootFramesTimeline._timeScale, false, false);
					if (_lazyTweens.length) {
						_lazyRender();
					}
					if (_ticker.frame >= _nextGCFrame) { //dump garbage every 120 frames or whatever the user sets TweenLite.autoSleep to
						_nextGCFrame = _ticker.frame + (parseInt(TweenLite.autoSleep, 10) || 120);
						for (p in _tweenLookup) {
							a = _tweenLookup[p].tweens;
							i = a.length;
							while (--i > -1) {
								if (a[i]._gc) {
									a.splice(i, 1);
								}
							}
							if (a.length === 0) {
								delete _tweenLookup[p];
							}
						}
						//if there are no more tweens in the root timelines, or if they're all paused, make the _timer sleep to reduce load on the CPU slightly
						p = _rootTimeline._first;
						if (!p || p._paused) if (TweenLite.autoSleep && !_rootFramesTimeline._first && _ticker._listeners.tick.length === 1) {
							while (p && p._paused) {
								p = p._next;
							}
							if (!p) {
								_ticker.sleep();
							}
						}
					}
				};
	
			_ticker.addEventListener("tick", Animation._updateRoot);
	
			var _register = function(target, tween, scrub) {
					var id = target._gsTweenID, a, i;
					if (!_tweenLookup[id || (target._gsTweenID = id = "t" + (_tweenLookupNum++))]) {
						_tweenLookup[id] = {target:target, tweens:[]};
					}
					if (tween) {
						a = _tweenLookup[id].tweens;
						a[(i = a.length)] = tween;
						if (scrub) {
							while (--i > -1) {
								if (a[i] === tween) {
									a.splice(i, 1);
								}
							}
						}
					}
					return _tweenLookup[id].tweens;
				},
				_onOverwrite = function(overwrittenTween, overwritingTween, target, killedProps) {
					var func = overwrittenTween.vars.onOverwrite, r1, r2;
					if (func) {
						r1 = func(overwrittenTween, overwritingTween, target, killedProps);
					}
					func = TweenLite.onOverwrite;
					if (func) {
						r2 = func(overwrittenTween, overwritingTween, target, killedProps);
					}
					return (r1 !== false && r2 !== false);
				},
				_applyOverwrite = function(target, tween, props, mode, siblings) {
					var i, changed, curTween, l;
					if (mode === 1 || mode >= 4) {
						l = siblings.length;
						for (i = 0; i < l; i++) {
							if ((curTween = siblings[i]) !== tween) {
								if (!curTween._gc) {
									if (curTween._kill(null, target, tween)) {
										changed = true;
									}
								}
							} else if (mode === 5) {
								break;
							}
						}
						return changed;
					}
					//NOTE: Add 0.0000000001 to overcome floating point errors that can cause the startTime to be VERY slightly off (when a tween's time() is set for example)
					var startTime = tween._startTime + _tinyNum,
						overlaps = [],
						oCount = 0,
						zeroDur = (tween._duration === 0),
						globalStart;
					i = siblings.length;
					while (--i > -1) {
						if ((curTween = siblings[i]) === tween || curTween._gc || curTween._paused) {
							//ignore
						} else if (curTween._timeline !== tween._timeline) {
							globalStart = globalStart || _checkOverlap(tween, 0, zeroDur);
							if (_checkOverlap(curTween, globalStart, zeroDur) === 0) {
								overlaps[oCount++] = curTween;
							}
						} else if (curTween._startTime <= startTime) if (curTween._startTime + curTween.totalDuration() / curTween._timeScale > startTime) if (!((zeroDur || !curTween._initted) && startTime - curTween._startTime <= 0.0000000002)) {
							overlaps[oCount++] = curTween;
						}
					}
	
					i = oCount;
					while (--i > -1) {
						curTween = overlaps[i];
						if (mode === 2) if (curTween._kill(props, target, tween)) {
							changed = true;
						}
						if (mode !== 2 || (!curTween._firstPT && curTween._initted)) {
							if (mode !== 2 && !_onOverwrite(curTween, tween)) {
								continue;
							}
							if (curTween._enabled(false, false)) { //if all property tweens have been overwritten, kill the tween.
								changed = true;
							}
						}
					}
					return changed;
				},
				_checkOverlap = function(tween, reference, zeroDur) {
					var tl = tween._timeline,
						ts = tl._timeScale,
						t = tween._startTime;
					while (tl._timeline) {
						t += tl._startTime;
						ts *= tl._timeScale;
						if (tl._paused) {
							return -100;
						}
						tl = tl._timeline;
					}
					t /= ts;
					return (t > reference) ? t - reference : ((zeroDur && t === reference) || (!tween._initted && t - reference < 2 * _tinyNum)) ? _tinyNum : ((t += tween.totalDuration() / tween._timeScale / ts) > reference + _tinyNum) ? 0 : t - reference - _tinyNum;
				};
	
	
	//---- TweenLite instance methods -----------------------------------------------------------------------------
	
			p._init = function() {
				var v = this.vars,
					op = this._overwrittenProps,
					dur = this._duration,
					immediate = !!v.immediateRender,
					ease = v.ease,
					i, initPlugins, pt, p, startVars, l;
				if (v.startAt) {
					if (this._startAt) {
						this._startAt.render(-1, true); //if we've run a startAt previously (when the tween instantiated), we should revert it so that the values re-instantiate correctly particularly for relative tweens. Without this, a TweenLite.fromTo(obj, 1, {x:"+=100"}, {x:"-=100"}), for example, would actually jump to +=200 because the startAt would run twice, doubling the relative change.
						this._startAt.kill();
					}
					startVars = {};
					for (p in v.startAt) { //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, 1, from, to).fromTo(e, 1, to, from);
						startVars[p] = v.startAt[p];
					}
					startVars.data = "isStart";
					startVars.overwrite = false;
					startVars.immediateRender = true;
					startVars.lazy = (immediate && v.lazy !== false);
					startVars.startAt = startVars.delay = null; //no nesting of startAt objects allowed (otherwise it could cause an infinite loop).
					startVars.onUpdate = v.onUpdate;
					startVars.onUpdateParams = v.onUpdateParams;
					startVars.onUpdateScope = v.onUpdateScope || v.callbackScope || this;
					this._startAt = TweenLite.to(this.target, 0, startVars);
					if (immediate) {
						if (this._time > 0) {
							this._startAt = null; //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in TimelineLite/Max instances where immediateRender was false (which is the default in the convenience methods like from()).
						} else if (dur !== 0) {
							return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a TimelineLite or TimelineMax, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
						}
					}
				} else if (v.runBackwards && dur !== 0) {
					//from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
					if (this._startAt) {
						this._startAt.render(-1, true);
						this._startAt.kill();
						this._startAt = null;
					} else {
						if (this._time !== 0) { //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
							immediate = false;
						}
						pt = {};
						for (p in v) { //copy props into a new object and skip any reserved props, otherwise onComplete or onUpdate or onStart could fire. We should, however, permit autoCSS to go through.
							if (!_reservedProps[p] || p === "autoCSS") {
								pt[p] = v[p];
							}
						}
						pt.overwrite = 0;
						pt.data = "isFromStart"; //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
						pt.lazy = (immediate && v.lazy !== false);
						pt.immediateRender = immediate; //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
						this._startAt = TweenLite.to(this.target, 0, pt);
						if (!immediate) {
							this._startAt._init(); //ensures that the initial values are recorded
							this._startAt._enabled(false); //no need to have the tween render on the next cycle. Disable it because we'll always manually control the renders of the _startAt tween.
							if (this.vars.immediateRender) {
								this._startAt = null;
							}
						} else if (this._time === 0) {
							return;
						}
					}
				}
				this._ease = ease = (!ease) ? TweenLite.defaultEase : (ease instanceof Ease) ? ease : (typeof(ease) === "function") ? new Ease(ease, v.easeParams) : _easeMap[ease] || TweenLite.defaultEase;
				if (v.easeParams instanceof Array && ease.config) {
					this._ease = ease.config.apply(ease, v.easeParams);
				}
				this._easeType = this._ease._type;
				this._easePower = this._ease._power;
				this._firstPT = null;
	
				if (this._targets) {
					l = this._targets.length;
					for (i = 0; i < l; i++) {
						if ( this._initProps( this._targets[i], (this._propLookup[i] = {}), this._siblings[i], (op ? op[i] : null), i) ) {
							initPlugins = true;
						}
					}
				} else {
					initPlugins = this._initProps(this.target, this._propLookup, this._siblings, op, 0);
				}
	
				if (initPlugins) {
					TweenLite._onPluginEvent("_onInitAllProps", this); //reorders the array in order of priority. Uses a static TweenPlugin method in order to minimize file size in TweenLite
				}
				if (op) if (!this._firstPT) if (typeof(this.target) !== "function") { //if all tweening properties have been overwritten, kill the tween. If the target is a function, it's probably a delayedCall so let it live.
					this._enabled(false, false);
				}
				if (v.runBackwards) {
					pt = this._firstPT;
					while (pt) {
						pt.s += pt.c;
						pt.c = -pt.c;
						pt = pt._next;
					}
				}
				this._onUpdate = v.onUpdate;
				this._initted = true;
			};
	
			p._initProps = function(target, propLookup, siblings, overwrittenProps, index) {
				var p, i, initPlugins, plugin, pt, v;
				if (target == null) {
					return false;
				}
	
				if (_lazyLookup[target._gsTweenID]) {
					_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
				}
	
				if (!this.vars.css) if (target.style) if (target !== window && target.nodeType) if (_plugins.css) if (this.vars.autoCSS !== false) { //it's so common to use TweenLite/Max to animate the css of DOM elements, we assume that if the target is a DOM element, that's what is intended (a convenience so that users don't have to wrap things in css:{}, although we still recommend it for a slight performance boost and better specificity). Note: we cannot check "nodeType" on the window inside an iframe.
					_autoCSS(this.vars, target);
				}
				for (p in this.vars) {
					v = this.vars[p];
					if (_reservedProps[p]) {
						if (v) if ((v instanceof Array) || (v.push && _isArray(v))) if (v.join("").indexOf("{self}") !== -1) {
							this.vars[p] = v = this._swapSelfInParams(v, this);
						}
	
					} else if (_plugins[p] && (plugin = new _plugins[p]())._onInitTween(target, this.vars[p], this, index)) {
	
						//t - target 		[object]
						//p - property 		[string]
						//s - start			[number]
						//c - change		[number]
						//f - isFunction	[boolean]
						//n - name			[string]
						//pg - isPlugin 	[boolean]
						//pr - priority		[number]
						//m - mod           [function | 0]
						this._firstPT = pt = {_next:this._firstPT, t:plugin, p:"setRatio", s:0, c:1, f:1, n:p, pg:1, pr:plugin._priority, m:0};
						i = plugin._overwriteProps.length;
						while (--i > -1) {
							propLookup[plugin._overwriteProps[i]] = this._firstPT;
						}
						if (plugin._priority || plugin._onInitAllProps) {
							initPlugins = true;
						}
						if (plugin._onDisable || plugin._onEnable) {
							this._notifyPluginsOfEnabled = true;
						}
						if (pt._next) {
							pt._next._prev = pt;
						}
	
					} else {
						propLookup[p] = _addPropTween.call(this, target, p, "get", v, p, 0, null, this.vars.stringFilter, index);
					}
				}
	
				if (overwrittenProps) if (this._kill(overwrittenProps, target)) { //another tween may have tried to overwrite properties of this tween before init() was called (like if two tweens start at the same time, the one created second will run first)
					return this._initProps(target, propLookup, siblings, overwrittenProps, index);
				}
				if (this._overwrite > 1) if (this._firstPT) if (siblings.length > 1) if (_applyOverwrite(target, this, propLookup, this._overwrite, siblings)) {
					this._kill(propLookup, target);
					return this._initProps(target, propLookup, siblings, overwrittenProps, index);
				}
				if (this._firstPT) if ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration)) { //zero duration tweens don't lazy render by default; everything else does.
					_lazyLookup[target._gsTweenID] = true;
				}
				return initPlugins;
			};
	
			p.render = function(time, suppressEvents, force) {
				var prevTime = this._time,
					duration = this._duration,
					prevRawPrevTime = this._rawPrevTime,
					isComplete, callback, pt, rawPrevTime;
				if (time >= duration - 0.0000001 && time >= 0) { //to work around occasional floating point math artifacts.
					this._totalTime = this._time = duration;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(1) : 1;
					if (!this._reversed ) {
						isComplete = true;
						callback = "onComplete";
						force = (force || this._timeline.autoRemoveChildren); //otherwise, if the animation is unpaused/activated after it's already finished, it doesn't get removed from the parent timeline.
					}
					if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
						if (this._startTime === this._timeline._duration) { //if a zero-duration tween is at the VERY end of a timeline and that timeline renders at its end, it will typically add a tiny bit of cushion to the render time to prevent rounding errors from getting in the way of tweens rendering their VERY end. If we then reverse() that timeline, the zero-duration tween will trigger its onReverseComplete even though technically the playhead didn't pass over it again. It's a very specific edge case we must accommodate.
							time = 0;
						}
						if (prevRawPrevTime < 0 || (time <= 0 && time >= -0.0000001) || (prevRawPrevTime === _tinyNum && this.data !== "isPause")) if (prevRawPrevTime !== time) { //note: when this.data is "isPause", it's a callback added by addPause() on a timeline that we should not be triggered when LEAVING its exact start time. In other words, tl.addPause(1).play(1) shouldn't pause.
							force = true;
							if (prevRawPrevTime > _tinyNum) {
								callback = "onReverseComplete";
							}
						}
						this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
					}
	
				} else if (time < 0.0000001) { //to work around occasional floating point math artifacts, round super small values to 0.
					this._totalTime = this._time = 0;
					this.ratio = this._ease._calcEnd ? this._ease.getRatio(0) : 0;
					if (prevTime !== 0 || (duration === 0 && prevRawPrevTime > 0)) {
						callback = "onReverseComplete";
						isComplete = this._reversed;
					}
					if (time < 0) {
						this._active = false;
						if (duration === 0) if (this._initted || !this.vars.lazy || force) { //zero-duration tweens are tricky because we must discern the momentum/direction of time in order to determine whether the starting values should be rendered or the ending values. If the "playhead" of its timeline goes past the zero-duration tween in the forward direction or lands directly on it, the end values should be rendered, but if the timeline's "playhead" moves past it in the backward direction (from a postitive time to a negative time), the starting values must be rendered.
							if (prevRawPrevTime >= 0 && !(prevRawPrevTime === _tinyNum && this.data === "isPause")) {
								force = true;
							}
							this._rawPrevTime = rawPrevTime = (!suppressEvents || time || prevRawPrevTime === time) ? time : _tinyNum; //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect. We set the _rawPrevTime to be a precise tiny number to indicate this scenario rather than using another property/variable which would increase memory usage. This technique is less readable, but more efficient.
						}
					}
					if (!this._initted || (this._startAt && this._startAt.progress())) { //if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately. Also, we check progress() because if startAt has already rendered at its end, we should force a render at its beginning. Otherwise, if you put the playhead directly on top of where a fromTo({immediateRender:false}) starts, and then move it backwards, the from() won't revert its values.
						force = true;
					}
				} else {
					this._totalTime = this._time = time;
	
					if (this._easeType) {
						var r = time / duration, type = this._easeType, pow = this._easePower;
						if (type === 1 || (type === 3 && r >= 0.5)) {
							r = 1 - r;
						}
						if (type === 3) {
							r *= 2;
						}
						if (pow === 1) {
							r *= r;
						} else if (pow === 2) {
							r *= r * r;
						} else if (pow === 3) {
							r *= r * r * r;
						} else if (pow === 4) {
							r *= r * r * r * r;
						}
	
						if (type === 1) {
							this.ratio = 1 - r;
						} else if (type === 2) {
							this.ratio = r;
						} else if (time / duration < 0.5) {
							this.ratio = r / 2;
						} else {
							this.ratio = 1 - (r / 2);
						}
	
					} else {
						this.ratio = this._ease.getRatio(time / duration);
					}
				}
	
				if (this._time === prevTime && !force) {
					return;
				} else if (!this._initted) {
					this._init();
					if (!this._initted || this._gc) { //immediateRender tweens typically won't initialize until the playhead advances (_time is greater than 0) in order to ensure that overwriting occurs properly. Also, if all of the tweening properties have been overwritten (which would cause _gc to be true, as set in _init()), we shouldn't continue otherwise an onStart callback could be called for example.
						return;
					} else if (!force && this._firstPT && ((this.vars.lazy !== false && this._duration) || (this.vars.lazy && !this._duration))) {
						this._time = this._totalTime = prevTime;
						this._rawPrevTime = prevRawPrevTime;
						_lazyTweens.push(this);
						this._lazy = [time, suppressEvents];
						return;
					}
					//_ease is initially set to defaultEase, so now that init() has run, _ease is set properly and we need to recalculate the ratio. Overall this is faster than using conditional logic earlier in the method to avoid having to set ratio twice because we only init() once but renderTime() gets called VERY frequently.
					if (this._time && !isComplete) {
						this.ratio = this._ease.getRatio(this._time / duration);
					} else if (isComplete && this._ease._calcEnd) {
						this.ratio = this._ease.getRatio((this._time === 0) ? 0 : 1);
					}
				}
				if (this._lazy !== false) { //in case a lazy render is pending, we should flush it because the new render is occurring now (imagine a lazy tween instantiating and then immediately the user calls tween.seek(tween.duration()), skipping to the end - the end render would be forced, and then if we didn't flush the lazy render, it'd fire AFTER the seek(), rendering it at the wrong time.
					this._lazy = false;
				}
				if (!this._active) if (!this._paused && this._time !== prevTime && time >= 0) {
					this._active = true;  //so that if the user renders a tween (as opposed to the timeline rendering it), the timeline is forced to re-render and align it with the proper time/frame on the next rendering cycle. Maybe the tween already finished but the user manually re-renders it as halfway done.
				}
				if (prevTime === 0) {
					if (this._startAt) {
						if (time >= 0) {
							this._startAt.render(time, true, force);
						} else if (!callback) {
							callback = "_dummyGS"; //if no callback is defined, use a dummy value just so that the condition at the end evaluates as true because _startAt should render AFTER the normal render loop when the time is negative. We could handle this in a more intuitive way, of course, but the render loop is the MOST important thing to optimize, so this technique allows us to avoid adding extra conditional logic in a high-frequency area.
						}
					}
					if (this.vars.onStart) if (this._time !== 0 || duration === 0) if (!suppressEvents) {
						this._callback("onStart");
					}
				}
				pt = this._firstPT;
				while (pt) {
					if (pt.f) {
						pt.t[pt.p](pt.c * this.ratio + pt.s);
					} else {
						pt.t[pt.p] = pt.c * this.ratio + pt.s;
					}
					pt = pt._next;
				}
	
				if (this._onUpdate) {
					if (time < 0) if (this._startAt && time !== -0.0001) { //if the tween is positioned at the VERY beginning (_startTime 0) of its parent timeline, it's illegal for the playhead to go back further, so we should not render the recorded startAt values.
						this._startAt.render(time, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
					}
					if (!suppressEvents) if (this._time !== prevTime || isComplete || force) {
						this._callback("onUpdate");
					}
				}
				if (callback) if (!this._gc || force) { //check _gc because there's a chance that kill() could be called in an onUpdate
					if (time < 0 && this._startAt && !this._onUpdate && time !== -0.0001) { //-0.0001 is a special value that we use when looping back to the beginning of a repeated TimelineMax, in which case we shouldn't render the _startAt values.
						this._startAt.render(time, true, force);
					}
					if (isComplete) {
						if (this._timeline.autoRemoveChildren) {
							this._enabled(false, false);
						}
						this._active = false;
					}
					if (!suppressEvents && this.vars[callback]) {
						this._callback(callback);
					}
					if (duration === 0 && this._rawPrevTime === _tinyNum && rawPrevTime !== _tinyNum) { //the onComplete or onReverseComplete could trigger movement of the playhead and for zero-duration tweens (which must discern direction) that land directly back on their start time, we don't want to fire again on the next render. Think of several addPause()'s in a timeline that forces the playhead to a certain spot, but what if it's already paused and another tween is tweening the "time" of the timeline? Each time it moves [forward] past that spot, it would move back, and since suppressEvents is true, it'd reset _rawPrevTime to _tinyNum so that when it begins again, the callback would fire (so ultimately it could bounce back and forth during that tween). Again, this is a very uncommon scenario, but possible nonetheless.
						this._rawPrevTime = 0;
					}
				}
			};
	
			p._kill = function(vars, target, overwritingTween) {
				if (vars === "all") {
					vars = null;
				}
				if (vars == null) if (target == null || target === this.target) {
					this._lazy = false;
					return this._enabled(false, false);
				}
				target = (typeof(target) !== "string") ? (target || this._targets || this.target) : TweenLite.selector(target) || target;
				var simultaneousOverwrite = (overwritingTween && this._time && overwritingTween._startTime === this._startTime && this._timeline === overwritingTween._timeline),
					i, overwrittenProps, p, pt, propLookup, changed, killProps, record, killed;
				if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
					i = target.length;
					while (--i > -1) {
						if (this._kill(vars, target[i], overwritingTween)) {
							changed = true;
						}
					}
				} else {
					if (this._targets) {
						i = this._targets.length;
						while (--i > -1) {
							if (target === this._targets[i]) {
								propLookup = this._propLookup[i] || {};
								this._overwrittenProps = this._overwrittenProps || [];
								overwrittenProps = this._overwrittenProps[i] = vars ? this._overwrittenProps[i] || {} : "all";
								break;
							}
						}
					} else if (target !== this.target) {
						return false;
					} else {
						propLookup = this._propLookup;
						overwrittenProps = this._overwrittenProps = vars ? this._overwrittenProps || {} : "all";
					}
	
					if (propLookup) {
						killProps = vars || propLookup;
						record = (vars !== overwrittenProps && overwrittenProps !== "all" && vars !== propLookup && (typeof(vars) !== "object" || !vars._tempKill)); //_tempKill is a super-secret way to delete a particular tweening property but NOT have it remembered as an official overwritten property (like in BezierPlugin)
						if (overwritingTween && (TweenLite.onOverwrite || this.vars.onOverwrite)) {
							for (p in killProps) {
								if (propLookup[p]) {
									if (!killed) {
										killed = [];
									}
									killed.push(p);
								}
							}
							if ((killed || !vars) && !_onOverwrite(this, overwritingTween, target, killed)) { //if the onOverwrite returned false, that means the user wants to override the overwriting (cancel it).
								return false;
							}
						}
	
						for (p in killProps) {
							if ((pt = propLookup[p])) {
								if (simultaneousOverwrite) { //if another tween overwrites this one and they both start at exactly the same time, yet this tween has already rendered once (for example, at 0.001) because it's first in the queue, we should revert the values to where they were at 0 so that the starting values aren't contaminated on the overwriting tween.
									if (pt.f) {
										pt.t[pt.p](pt.s);
									} else {
										pt.t[pt.p] = pt.s;
									}
									changed = true;
								}
								if (pt.pg && pt.t._kill(killProps)) {
									changed = true; //some plugins need to be notified so they can perform cleanup tasks first
								}
								if (!pt.pg || pt.t._overwriteProps.length === 0) {
									if (pt._prev) {
										pt._prev._next = pt._next;
									} else if (pt === this._firstPT) {
										this._firstPT = pt._next;
									}
									if (pt._next) {
										pt._next._prev = pt._prev;
									}
									pt._next = pt._prev = null;
								}
								delete propLookup[p];
							}
							if (record) {
								overwrittenProps[p] = 1;
							}
						}
						if (!this._firstPT && this._initted) { //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
							this._enabled(false, false);
						}
					}
				}
				return changed;
			};
	
			p.invalidate = function() {
				if (this._notifyPluginsOfEnabled) {
					TweenLite._onPluginEvent("_onDisable", this);
				}
				this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null;
				this._notifyPluginsOfEnabled = this._active = this._lazy = false;
				this._propLookup = (this._targets) ? {} : [];
				Animation.prototype.invalidate.call(this);
				if (this.vars.immediateRender) {
					this._time = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
					this.render(Math.min(0, -this._delay)); //in case delay is negative.
				}
				return this;
			};
	
			p._enabled = function(enabled, ignoreTimeline) {
				if (!_tickerActive) {
					_ticker.wake();
				}
				if (enabled && this._gc) {
					var targets = this._targets,
						i;
					if (targets) {
						i = targets.length;
						while (--i > -1) {
							this._siblings[i] = _register(targets[i], this, true);
						}
					} else {
						this._siblings = _register(this.target, this, true);
					}
				}
				Animation.prototype._enabled.call(this, enabled, ignoreTimeline);
				if (this._notifyPluginsOfEnabled) if (this._firstPT) {
					return TweenLite._onPluginEvent((enabled ? "_onEnable" : "_onDisable"), this);
				}
				return false;
			};
	
	
	//----TweenLite static methods -----------------------------------------------------
	
			TweenLite.to = function(target, duration, vars) {
				return new TweenLite(target, duration, vars);
			};
	
			TweenLite.from = function(target, duration, vars) {
				vars.runBackwards = true;
				vars.immediateRender = (vars.immediateRender != false);
				return new TweenLite(target, duration, vars);
			};
	
			TweenLite.fromTo = function(target, duration, fromVars, toVars) {
				toVars.startAt = fromVars;
				toVars.immediateRender = (toVars.immediateRender != false && fromVars.immediateRender != false);
				return new TweenLite(target, duration, toVars);
			};
	
			TweenLite.delayedCall = function(delay, callback, params, scope, useFrames) {
				return new TweenLite(callback, 0, {delay:delay, onComplete:callback, onCompleteParams:params, callbackScope:scope, onReverseComplete:callback, onReverseCompleteParams:params, immediateRender:false, lazy:false, useFrames:useFrames, overwrite:0});
			};
	
			TweenLite.set = function(target, vars) {
				return new TweenLite(target, 0, vars);
			};
	
			TweenLite.getTweensOf = function(target, onlyActive) {
				if (target == null) { return []; }
				target = (typeof(target) !== "string") ? target : TweenLite.selector(target) || target;
				var i, a, j, t;
				if ((_isArray(target) || _isSelector(target)) && typeof(target[0]) !== "number") {
					i = target.length;
					a = [];
					while (--i > -1) {
						a = a.concat(TweenLite.getTweensOf(target[i], onlyActive));
					}
					i = a.length;
					//now get rid of any duplicates (tweens of arrays of objects could cause duplicates)
					while (--i > -1) {
						t = a[i];
						j = i;
						while (--j > -1) {
							if (t === a[j]) {
								a.splice(i, 1);
							}
						}
					}
				} else if (target._gsTweenID) {
					a = _register(target).concat();
					i = a.length;
					while (--i > -1) {
						if (a[i]._gc || (onlyActive && !a[i].isActive())) {
							a.splice(i, 1);
						}
					}
				}
				return a || [];
			};
	
			TweenLite.killTweensOf = TweenLite.killDelayedCallsTo = function(target, onlyActive, vars) {
				if (typeof(onlyActive) === "object") {
					vars = onlyActive; //for backwards compatibility (before "onlyActive" parameter was inserted)
					onlyActive = false;
				}
				var a = TweenLite.getTweensOf(target, onlyActive),
					i = a.length;
				while (--i > -1) {
					a[i]._kill(vars, target);
				}
			};
	
	
	
	/*
	 * ----------------------------------------------------------------
	 * TweenPlugin   (could easily be split out as a separate file/class, but included for ease of use (so that people don't need to include another script call before loading plugins which is easy to forget)
	 * ----------------------------------------------------------------
	 */
			var TweenPlugin = _class("plugins.TweenPlugin", function(props, priority) {
						this._overwriteProps = (props || "").split(",");
						this._propName = this._overwriteProps[0];
						this._priority = priority || 0;
						this._super = TweenPlugin.prototype;
					}, true);
	
			p = TweenPlugin.prototype;
			TweenPlugin.version = "1.19.0";
			TweenPlugin.API = 2;
			p._firstPT = null;
			p._addTween = _addPropTween;
			p.setRatio = _setRatio;
	
			p._kill = function(lookup) {
				var a = this._overwriteProps,
					pt = this._firstPT,
					i;
				if (lookup[this._propName] != null) {
					this._overwriteProps = [];
				} else {
					i = a.length;
					while (--i > -1) {
						if (lookup[a[i]] != null) {
							a.splice(i, 1);
						}
					}
				}
				while (pt) {
					if (lookup[pt.n] != null) {
						if (pt._next) {
							pt._next._prev = pt._prev;
						}
						if (pt._prev) {
							pt._prev._next = pt._next;
							pt._prev = null;
						} else if (this._firstPT === pt) {
							this._firstPT = pt._next;
						}
					}
					pt = pt._next;
				}
				return false;
			};
	
			p._mod = p._roundProps = function(lookup) {
				var pt = this._firstPT,
					val;
				while (pt) {
					val = lookup[this._propName] || (pt.n != null && lookup[ pt.n.split(this._propName + "_").join("") ]);
					if (val && typeof(val) === "function") { //some properties that are very plugin-specific add a prefix named after the _propName plus an underscore, so we need to ignore that extra stuff here.
						if (pt.f === 2) {
							pt.t._applyPT.m = val;
						} else {
							pt.m = val;
						}
					}
					pt = pt._next;
				}
			};
	
			TweenLite._onPluginEvent = function(type, tween) {
				var pt = tween._firstPT,
					changed, pt2, first, last, next;
				if (type === "_onInitAllProps") {
					//sorts the PropTween linked list in order of priority because some plugins need to render earlier/later than others, like MotionBlurPlugin applies its effects after all x/y/alpha tweens have rendered on each frame.
					while (pt) {
						next = pt._next;
						pt2 = first;
						while (pt2 && pt2.pr > pt.pr) {
							pt2 = pt2._next;
						}
						if ((pt._prev = pt2 ? pt2._prev : last)) {
							pt._prev._next = pt;
						} else {
							first = pt;
						}
						if ((pt._next = pt2)) {
							pt2._prev = pt;
						} else {
							last = pt;
						}
						pt = next;
					}
					pt = tween._firstPT = first;
				}
				while (pt) {
					if (pt.pg) if (typeof(pt.t[type]) === "function") if (pt.t[type]()) {
						changed = true;
					}
					pt = pt._next;
				}
				return changed;
			};
	
			TweenPlugin.activate = function(plugins) {
				var i = plugins.length;
				while (--i > -1) {
					if (plugins[i].API === TweenPlugin.API) {
						_plugins[(new plugins[i]())._propName] = plugins[i];
					}
				}
				return true;
			};
	
			//provides a more concise way to define plugins that have no dependencies besides TweenPlugin and TweenLite, wrapping common boilerplate stuff into one function (added in 1.9.0). You don't NEED to use this to define a plugin - the old way still works and can be useful in certain (rare) situations.
			_gsDefine.plugin = function(config) {
				if (!config || !config.propName || !config.init || !config.API) { throw "illegal plugin definition."; }
				var propName = config.propName,
					priority = config.priority || 0,
					overwriteProps = config.overwriteProps,
					map = {init:"_onInitTween", set:"setRatio", kill:"_kill", round:"_mod", mod:"_mod", initAll:"_onInitAllProps"},
					Plugin = _class("plugins." + propName.charAt(0).toUpperCase() + propName.substr(1) + "Plugin",
						function() {
							TweenPlugin.call(this, propName, priority);
							this._overwriteProps = overwriteProps || [];
						}, (config.global === true)),
					p = Plugin.prototype = new TweenPlugin(propName),
					prop;
				p.constructor = Plugin;
				Plugin.API = config.API;
				for (prop in map) {
					if (typeof(config[prop]) === "function") {
						p[map[prop]] = config[prop];
					}
				}
				Plugin.version = config.version;
				TweenPlugin.activate([Plugin]);
				return Plugin;
			};
	
	
			//now run through all the dependencies discovered and if any are missing, log that to the console as a warning. This is why it's best to have TweenLite load last - it can check all the dependencies for you.
			a = window._gsQueue;
			if (a) {
				for (i = 0; i < a.length; i++) {
					a[i]();
				}
				for (p in _defLookup) {
					if (!_defLookup[p].func) {
						window.console.log("GSAP encountered missing dependency: " + p);
					}
				}
			}
	
			_tickerActive = false; //ensures that the first official animation forces a ticker.tick() to update the time when it is instantiated
	
	})((typeof(module) !== "undefined" && module.exports && typeof(global) !== "undefined") ? global : this || window, "TweenMax");
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	!function(t,e){ true?module.exports=e(__webpack_require__(134)):"function"==typeof define&&define.amd?define("PrismicJS",["cross-fetch/polyfill"],e):"object"==typeof exports?exports.PrismicJS=e(require("cross-fetch/polyfill")):t.PrismicJS=e(t["cross-fetch/polyfill"])}("undefined"!=typeof self?self:this,function(t){return function(t){var e={};function n(r){if(e[r])return e[r].exports;var i=e[r]={i:r,l:!1,exports:{}};return t[r].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=t,n.c=e,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var i in t)n.d(r,i,function(e){return t[e]}.bind(null,i));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=20)}([function(t,e,n){"use strict";e.a=function(t){var e=this.constructor;return this.then(function(n){return e.resolve(t()).then(function(){return n})},function(n){return e.resolve(t()).then(function(){return e.reject(n)})})}},function(t,e){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){"use strict";e.__esModule=!0;var r=n(5),i=n(4),o=n(6),u=n(12);e.PREVIEW_COOKIE="io.prismic.preview",e.EXPERIMENT_COOKIE="io.prismic.experiment";var a=function(){function t(t,e,n){this.data=t,this.masterRef=t.refs.filter(function(t){return t.isMasterRef})[0],this.experiments=new r.Experiments(t.experiments),this.bookmarks=t.bookmarks,this.httpClient=e,this.options=n,this.refs=t.refs,this.tags=t.tags,this.types=t.types}return t.prototype.form=function(t){var e=this.data.forms[t];return e?new i.SearchForm(e,this.httpClient):null},t.prototype.everything=function(){var t=this.form("everything");if(!t)throw new Error("Missing everything form");return t},t.prototype.master=function(){return this.masterRef.ref},t.prototype.ref=function(t){var e=this.data.refs.filter(function(e){return e.label===t})[0];return e?e.ref:null},t.prototype.currentExperiment=function(){return this.experiments.current()},t.prototype.query=function(t,n,r){void 0===r&&(r=function(){});var i="function"==typeof n?{options:{},callback:n}:{options:n||{},callback:r},o=i.options,a=i.callback,s=this.everything();for(var f in o)s=s.set(f,o[f]);if(!o.ref){var c="";this.options.req?c=this.options.req.headers.cookie||"":"undefined"!=typeof window&&window.document&&(c=window.document.cookie||"");var l=u.default.parse(c),h=l[e.PREVIEW_COOKIE],p=this.experiments.refFromCookie(l[e.EXPERIMENT_COOKIE]);s=s.ref(h||p||this.masterRef.ref)}return t&&s.query(t),s.submit(a)},t.prototype.queryFirst=function(t,e,n){var r="function"==typeof e?{options:{},callback:e}:{options:e||{},callback:n||function(){}},i=r.options,o=r.callback;return i.page=1,i.pageSize=1,this.query(t,i).then(function(t){var e=t&&t.results&&t.results[0];return o(null,e),e}).catch(function(t){throw o(t),t})},t.prototype.getByID=function(t,e,n){var r=e||{};return r.lang||(r.lang="*"),this.queryFirst(o.default.at("document.id",t),r,n)},t.prototype.getByIDs=function(t,e,n){var r=e||{};return r.lang||(r.lang="*"),this.query(o.default.in("document.id",t),r,n)},t.prototype.getByUID=function(t,e,n,r){var i=n||{};if("*"===i.lang)throw new Error("FORDIDDEN. You can't use getByUID with *, use the predicates instead.");return i.page||(i.page=1),this.queryFirst(o.default.at("my."+t+".uid",e),i,r)},t.prototype.getSingle=function(t,e,n){var r=e||{};return this.queryFirst(o.default.at("document.type",t),r,n)},t.prototype.getBookmark=function(t,e,n){var r=this.data.bookmarks[t];return r?this.getByID(r,e,n):Promise.reject("Error retrieving bookmarked id")},t.prototype.previewSession=function(t,e,n,r){var i=this;return new Promise(function(o,u){i.httpClient.request(t,function(a,s){if(a)r&&r(a),u(a);else if(s){if(s.mainDocument)return i.getByID(s.mainDocument,{ref:t}).then(function(t){if(t){var i=e(t);r&&r(null,i),o(i)}else r&&r(null,n),o(n)}).catch(u);r&&r(null,n),o(n)}})})},t}();e.default=a},function(t,e,n){"use strict";e.__esModule=!0;var r=n(2),i=n(11),o=function(){function t(t,e){if(this.options=e||{},this.url=t,this.options.accessToken){var n="access_token="+this.options.accessToken;this.url+=(t.indexOf("?")>-1?"&":"?")+n}this.apiDataTTL=this.options.apiDataTTL||5,this.httpClient=new i.default(this.options.requestHandler,this.options.apiCache,this.options.proxyAgent)}return t.prototype.get=function(t){var e=this;return this.httpClient.cachedRequest(this.url,{ttl:this.apiDataTTL}).then(function(n){var i=new r.default(n,e.httpClient,e.options);return t&&t(null,i),i}).catch(function(e){throw t&&t(e),e})},t}();e.default=o},function(t,e,n){"use strict";e.__esModule=!0;var r=function(){function t(t,e){this.id=t,this.api=e,this.fields={}}return t.prototype.set=function(t,e){return this.fields[t]=e,this},t.prototype.ref=function(t){return this.set("ref",t)},t.prototype.query=function(t){return this.set("q",t)},t.prototype.pageSize=function(t){return this.set("pageSize",t)},t.prototype.fetch=function(t){return console.warn("Warning: Using Fetch is deprecated. Use the property `graphQuery` instead."),this.set("fetch",t)},t.prototype.fetchLinks=function(t){return console.warn("Warning: Using FetchLinks is deprecated. Use the property `graphQuery` instead."),this.set("fetchLinks",t)},t.prototype.graphQuery=function(t){return this.set("graphQuery",t)},t.prototype.lang=function(t){return this.set("lang",t)},t.prototype.page=function(t){return this.set("page",t)},t.prototype.after=function(t){return this.set("after",t)},t.prototype.orderings=function(t){return this.set("orderings",t)},t.prototype.url=function(){var e=this;return this.api.get().then(function(n){return t.toSearchForm(e,n).url()})},t.prototype.submit=function(e){var n=this;return this.api.get().then(function(r){return t.toSearchForm(n,r).submit(e)})},t.toSearchForm=function(t,e){var n=e.form(t.id);if(n)return Object.keys(t.fields).reduce(function(e,n){var r=t.fields[n];return"q"===n?e.query(r):"pageSize"===n?e.pageSize(r):"fetch"===n?e.fetch(r):"fetchLinks"===n?e.fetchLinks(r):"graphQuery"===n?e.graphQuery(r):"lang"===n?e.lang(r):"page"===n?e.page(r):"after"===n?e.after(r):"orderings"===n?e.orderings(r):e.set(n,r)},n);throw new Error("Unable to access to form "+t.id)},t}();e.LazySearchForm=r;var i=function(){function t(t,e){for(var n in this.httpClient=e,this.form=t,this.data={},t.fields)t.fields[n].default&&(this.data[n]=[t.fields[n].default])}return t.prototype.set=function(t,e){var n=this.form.fields[t];if(!n)throw new Error("Unknown field "+t);var r=""===e||void 0===e?null:e,i=this.data[t]||[];return i=n.multiple?r?i.concat([r]):i:r?[r]:i,this.data[t]=i,this},t.prototype.ref=function(t){return this.set("ref",t)},t.prototype.query=function(t){if("string"==typeof t)return this.query([t]);if(Array.isArray(t))return this.set("q","["+t.join("")+"]");throw new Error("Invalid query : "+t)},t.prototype.pageSize=function(t){return this.set("pageSize",t)},t.prototype.fetch=function(t){console.warn("Warning: Using Fetch is deprecated. Use the property `graphQuery` instead.");var e=Array.isArray(t)?t.join(","):t;return this.set("fetch",e)},t.prototype.fetchLinks=function(t){console.warn("Warning: Using FetchLinks is deprecated. Use the property `graphQuery` instead.");var e=Array.isArray(t)?t.join(","):t;return this.set("fetchLinks",e)},t.prototype.graphQuery=function(t){return this.set("graphQuery",t)},t.prototype.lang=function(t){return this.set("lang",t)},t.prototype.page=function(t){return this.set("page",t)},t.prototype.after=function(t){return this.set("after",t)},t.prototype.orderings=function(t){return t?this.set("orderings","["+t.join(",")+"]"):this},t.prototype.url=function(){var t=this.form.action;if(this.data){var e=t.indexOf("?")>-1?"&":"?";for(var n in this.data)if(this.data.hasOwnProperty(n)){var r=this.data[n];if(r)for(var i=0;i<r.length;i++)t+=e+n+"="+encodeURIComponent(r[i]),e="&"}}return t},t.prototype.submit=function(t){return this.httpClient.cachedRequest(this.url()).then(function(e){return t&&t(null,e),e}).catch(function(e){throw t&&t(e),e})},t}();e.SearchForm=i},function(t,e,n){"use strict";e.__esModule=!0;var r=function(){function t(t){this.data={},this.data=t}return t.prototype.id=function(){return this.data.id},t.prototype.ref=function(){return this.data.ref},t.prototype.label=function(){return this.data.label},t}();e.Variation=r;var i=function(){function t(t){this.data={},this.data=t,this.variations=(t.variations||[]).map(function(t){return new r(t)})}return t.prototype.id=function(){return this.data.id},t.prototype.googleId=function(){return this.data.googleId},t.prototype.name=function(){return this.data.name},t}();e.Experiment=i;var o=function(){function t(t){t&&(this.drafts=(t.drafts||[]).map(function(t){return new i(t)}),this.running=(t.running||[]).map(function(t){return new i(t)}))}return t.prototype.current=function(){return this.running.length>0?this.running[0]:null},t.prototype.refFromCookie=function(t){if(!t||""===t.trim())return null;var e=t.trim().split(" ");if(e.length<2)return null;var n=e[0],r=parseInt(e[1],10),i=this.running.filter(function(t){return t.googleId()===n&&t.variations.length>r})[0];return i?i.variations[r].ref():null},t}();e.Experiments=o},function(t,e,n){"use strict";e.__esModule=!0;var r="at",i="not",o="missing",u="has",a="any",s="in",f="fulltext",c="similar",l="number.gt",h="number.lt",p="number.inRange",d="date.before",y="date.after",m="date.between",g="date.day-of-month",v="date.day-of-month-after",w="date.day-of-month-before",_="date.day-of-week",k="date.day-of-week-after",b="date.day-of-week-before",T="date.month",I="date.month-before",E="date.month-after",O="date.year",A="date.hour",x="date.hour-before",M="date.hour-after",j="geopoint.near";function q(t){if("string"==typeof t)return'"'+t+'"';if("number"==typeof t)return t.toString();if(t instanceof Date)return t.getTime().toString();if(Array.isArray(t))return"["+t.map(function(t){return q(t)}).join(",")+"]";throw new Error("Unable to encode "+t+" of type "+typeof t)}var S={near:function(t,e,n,r){return"["+j+"("+t+", "+e+", "+n+", "+r+")]"}},C={before:function(t,e){return"["+d+"("+t+", "+q(e)+")]"},after:function(t,e){return"["+y+"("+t+", "+q(e)+")]"},between:function(t,e,n){return"["+m+"("+t+", "+q(e)+", "+q(n)+")]"},dayOfMonth:function(t,e){return"["+g+"("+t+", "+e+")]"},dayOfMonthAfter:function(t,e){return"["+v+"("+t+", "+e+")]"},dayOfMonthBefore:function(t,e){return"["+w+"("+t+", "+e+")]"},dayOfWeek:function(t,e){return"["+_+"("+t+", "+q(e)+")]"},dayOfWeekAfter:function(t,e){return"["+k+"("+t+", "+q(e)+")]"},dayOfWeekBefore:function(t,e){return"["+b+"("+t+", "+q(e)+")]"},month:function(t,e){return"["+T+"("+t+", "+q(e)+")]"},monthBefore:function(t,e){return"["+I+"("+t+", "+q(e)+")]"},monthAfter:function(t,e){return"["+E+"("+t+", "+q(e)+")]"},year:function(t,e){return"["+O+"("+t+", "+e+")]"},hour:function(t,e){return"["+A+"("+t+", "+e+")]"},hourBefore:function(t,e){return"["+x+"("+t+", "+e+")]"},hourAfter:function(t,e){return"["+M+"("+t+", "+e+")]"}},F={gt:function(t,e){return"["+l+"("+t+", "+e+")]"},lt:function(t,e){return"["+h+"("+t+", "+e+")]"},inRange:function(t,e,n){return"["+p+"("+t+", "+e+", "+n+")]"}};e.default={at:function(t,e){return"["+r+"("+t+", "+q(e)+")]"},not:function(t,e){return"["+i+"("+t+", "+q(e)+")]"},missing:function(t){return"["+o+"("+t+")]"},has:function(t){return"["+u+"("+t+")]"},any:function(t,e){return"["+a+"("+t+", "+q(e)+")]"},in:function(t,e){return"["+s+"("+t+", "+q(e)+")]"},fulltext:function(t,e){return"["+f+"("+t+", "+q(e)+")]"},similar:function(t,e){return"["+c+'("'+t+'", '+e+")]"},date:C,dateBefore:C.before,dateAfter:C.after,dateBetween:C.between,dayOfMonth:C.dayOfMonth,dayOfMonthAfter:C.dayOfMonthAfter,dayOfMonthBefore:C.dayOfMonthBefore,dayOfWeek:C.dayOfWeek,dayOfWeekAfter:C.dayOfWeekAfter,dayOfWeekBefore:C.dayOfWeekBefore,month:C.month,monthBefore:C.monthBefore,monthAfter:C.monthAfter,year:C.year,hour:C.hour,hourBefore:C.hourBefore,hourAfter:C.hourAfter,number:F,gt:F.gt,lt:F.lt,inRange:F.inRange,near:S.near,geopoint:S}},function(t,e,n){"use strict";(function(t){var r=n(0),i=setTimeout;function o(){}function u(t){if(!(this instanceof u))throw new TypeError("Promises must be constructed via new");if("function"!=typeof t)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],l(t,this)}function a(t,e){for(;3===t._state;)t=t._value;0!==t._state?(t._handled=!0,u._immediateFn(function(){var n=1===t._state?e.onFulfilled:e.onRejected;if(null!==n){var r;try{r=n(t._value)}catch(t){return void f(e.promise,t)}s(e.promise,r)}else(1===t._state?s:f)(e.promise,t._value)})):t._deferreds.push(e)}function s(t,e){try{if(e===t)throw new TypeError("A promise cannot be resolved with itself.");if(e&&("object"==typeof e||"function"==typeof e)){var n=e.then;if(e instanceof u)return t._state=3,t._value=e,void c(t);if("function"==typeof n)return void l(function(t,e){return function(){t.apply(e,arguments)}}(n,e),t)}t._state=1,t._value=e,c(t)}catch(e){f(t,e)}}function f(t,e){t._state=2,t._value=e,c(t)}function c(t){2===t._state&&0===t._deferreds.length&&u._immediateFn(function(){t._handled||u._unhandledRejectionFn(t._value)});for(var e=0,n=t._deferreds.length;e<n;e++)a(t,t._deferreds[e]);t._deferreds=null}function l(t,e){var n=!1;try{t(function(t){n||(n=!0,s(e,t))},function(t){n||(n=!0,f(e,t))})}catch(t){if(n)return;n=!0,f(e,t)}}u.prototype.catch=function(t){return this.then(null,t)},u.prototype.then=function(t,e){var n=new this.constructor(o);return a(this,new function(t,e,n){this.onFulfilled="function"==typeof t?t:null,this.onRejected="function"==typeof e?e:null,this.promise=n}(t,e,n)),n},u.prototype.finally=r.a,u.all=function(t){return new u(function(e,n){if(!t||void 0===t.length)throw new TypeError("Promise.all accepts an array");var r=Array.prototype.slice.call(t);if(0===r.length)return e([]);var i=r.length;function o(t,u){try{if(u&&("object"==typeof u||"function"==typeof u)){var a=u.then;if("function"==typeof a)return void a.call(u,function(e){o(t,e)},n)}r[t]=u,0==--i&&e(r)}catch(t){n(t)}}for(var u=0;u<r.length;u++)o(u,r[u])})},u.resolve=function(t){return t&&"object"==typeof t&&t.constructor===u?t:new u(function(e){e(t)})},u.reject=function(t){return new u(function(e,n){n(t)})},u.race=function(t){return new u(function(e,n){for(var r=0,i=t.length;r<i;r++)t[r].then(e,n)})},u._immediateFn="function"==typeof t&&function(e){t(e)}||function(t){i(t,0)},u._unhandledRejectionFn=function(t){"undefined"!=typeof console&&console&&console.warn("Possible Unhandled Promise Rejection:",t)},e.a=u}).call(this,n(18).setImmediate)},function(t,e,n){"use strict";e.__esModule=!0;var r=function(){function t(t){this.options=t||{}}return t.prototype.request=function(t,e){!function(t,e,n){var r={headers:{Accept:"application/json"}};e&&e.proxyAgent&&(r.agent=e.proxyAgent),fetch(t,r).then(function(e){return~~(e.status/100!=2)?e.text().then(function(){var n=new Error("Unexpected status code ["+e.status+"] on URL "+t);throw n.status=e.status,n}):e.json().then(function(t){var r=e.headers.get("cache-control"),i=r?/max-age=(\d+)/.exec(r):null,o=i?parseInt(i[1],10):void 0;n(null,t,e,o)})}).catch(n)}(t,this.options,e)},t}();e.DefaultRequestHandler=r},function(t,e,n){"use strict";function r(t){this.size=0,this.limit=t,this._keymap={}}e.__esModule=!0,e.MakeLRUCache=function(t){return new r(t)},r.prototype.put=function(t,e){var n={key:t,value:e};if(this._keymap[t]=n,this.tail?(this.tail.newer=n,n.older=this.tail):this.head=n,this.tail=n,this.size===this.limit)return this.shift();this.size++},r.prototype.shift=function(){var t=this.head;return t&&(this.head.newer?(this.head=this.head.newer,this.head.older=void 0):this.head=void 0,t.newer=t.older=void 0,delete this._keymap[t.key]),console.log("purging ",t.key),t},r.prototype.get=function(t,e){var n=this._keymap[t];if(void 0!==n)return n===this.tail?e?n:n.value:(n.newer&&(n===this.head&&(this.head=n.newer),n.newer.older=n.older),n.older&&(n.older.newer=n.newer),n.newer=void 0,n.older=this.tail,this.tail&&(this.tail.newer=n),this.tail=n,e?n:n.value)},r.prototype.find=function(t){return this._keymap[t]},r.prototype.set=function(t,e){var n,r=this.get(t,!0);return r?(n=r.value,r.value=e):(n=this.put(t,e))&&(n=n.value),n},r.prototype.remove=function(t){var e=this._keymap[t];if(e)return delete this._keymap[e.key],e.newer&&e.older?(e.older.newer=e.newer,e.newer.older=e.older):e.newer?(e.newer.older=void 0,this.head=e.newer):e.older?(e.older.newer=void 0,this.tail=e.older):this.head=this.tail=void 0,this.size--,e.value},r.prototype.removeAll=function(){this.head=this.tail=void 0,this.size=0,this._keymap={}},"function"==typeof Object.keys?r.prototype.keys=function(){return Object.keys(this._keymap)}:r.prototype.keys=function(){var t=[];for(var e in this._keymap)t.push(e);return t},r.prototype.forEach=function(t,e,n){var r;if(!0===e?(n=!0,e=void 0):"object"!=typeof e&&(e=this),n)for(r=this.tail;r;)t.call(e,r.key,r.value,this),r=r.older;else for(r=this.head;r;)t.call(e,r.key,r.value,this),r=r.newer},r.prototype.toString=function(){for(var t="",e=this.head;e;)t+=String(e.key)+":"+e.value,(e=e.newer)&&(t+=" < ");return t}},function(t,e,n){"use strict";e.__esModule=!0;var r=n(9),i=function(){function t(t){void 0===t&&(t=1e3),this.lru=r.MakeLRUCache(t)}return t.prototype.isExpired=function(t){var e=this.lru.get(t,!1);return!!e&&(0!==e.expiredIn&&e.expiredIn<Date.now())},t.prototype.get=function(t,e){var n=this.lru.get(t,!1);n&&!this.isExpired(t)?e(null,n.data):e&&e(null)},t.prototype.set=function(t,e,n,r){this.lru.remove(t),this.lru.put(t,{data:e,expiredIn:n?Date.now()+1e3*n:0}),r&&r(null)},t.prototype.remove=function(t,e){this.lru.remove(t),e&&e(null)},t.prototype.clear=function(t){this.lru.removeAll(),t&&t(null)},t}();e.DefaultApiCache=i},function(t,e,n){"use strict";e.__esModule=!0;var r=n(10),i=n(8),o=function(){function t(t,e,n){this.requestHandler=t||new i.DefaultRequestHandler({proxyAgent:n}),this.cache=e||new r.DefaultApiCache}return t.prototype.request=function(t,e){this.requestHandler.request(t,function(t,n,r,i){t?e&&e(t,null,r,i):n&&e&&e(null,n,r,i)})},t.prototype.cachedRequest=function(t,e){var n=this,r=e||{};return new Promise(function(e,i){!function(e){var i=r.cacheKey||t;n.cache.get(i,function(o,u){o||u?e(o,u):n.request(t,function(t,o,u,a){if(t)e(t,null);else{var s=a||r.ttl;s&&n.cache.set(i,o,s,e),e(null,o)}})})}(function(t,n){t&&i(t),n&&e(n)})})},t}();e.default=o},function(t,e,n){"use strict";e.__esModule=!0;var r=decodeURIComponent;e.default={parse:function(t,e){if("string"!=typeof t)throw new TypeError("argument str must be a string");var n={},i=e||{},o=t.split(/; */),u=i.decode||r;return o.forEach(function(t){var e=t.indexOf("=");if(!(e<0)){var r=t.substr(0,e).trim(),i=t.substr(++e,t.length).trim();'"'==i[0]&&(i=i.slice(1,-1)),void 0==n[r]&&(n[r]=function(t,e){try{return e(t)}catch(e){return t}}(i,u))}}),n}}},function(t,e,n){"use strict";e.__esModule=!0;var r=n(4),i=n(3),o=function(){function t(t,e){this.api=new i.default(t,e)}return t.prototype.getApi=function(){return this.api.get()},t.prototype.everything=function(){return this.form("everything")},t.prototype.form=function(t){return new r.LazySearchForm(t,this.api)},t.prototype.query=function(t,e,n){return this.getApi().then(function(r){return r.query(t,e,n)})},t.prototype.queryFirst=function(t,e,n){return this.getApi().then(function(r){return r.queryFirst(t,e,n)})},t.prototype.getByID=function(t,e,n){return this.getApi().then(function(r){return r.getByID(t,e,n)})},t.prototype.getByIDs=function(t,e,n){return this.getApi().then(function(r){return r.getByIDs(t,e,n)})},t.prototype.getByUID=function(t,e,n,r){return this.getApi().then(function(i){return i.getByUID(t,e,n,r)})},t.prototype.getSingle=function(t,e,n){return this.getApi().then(function(r){return r.getSingle(t,e,n)})},t.prototype.getBookmark=function(t,e,n){return this.getApi().then(function(r){return r.getBookmark(t,e,n)})},t.prototype.previewSession=function(t,e,n,r){return this.getApi().then(function(i){return i.previewSession(t,e,n,r)})},t.getApi=function(t,e){return new i.default(t,e).get()},t}();e.DefaultClient=o},function(t,e,n){"use strict";var r,i=n(6),o=n(5),u=n(13),a=n(3),s=n(2);!function(t){function e(t,e){return u.DefaultClient.getApi(t,e)}t.experimentCookie=s.EXPERIMENT_COOKIE,t.previewCookie=s.PREVIEW_COOKIE,t.Predicates=i.default,t.Experiments=o.Experiments,t.Api=a.default,t.client=function(t,e){return new u.DefaultClient(t,e)},t.getApi=e,t.api=function(t,n){return e(t,n)}}(r||(r={})),t.exports=r},function(e,n){e.exports=t},function(t,e){var n,r,i=t.exports={};function o(){throw new Error("setTimeout has not been defined")}function u(){throw new Error("clearTimeout has not been defined")}function a(t){if(n===setTimeout)return setTimeout(t,0);if((n===o||!n)&&setTimeout)return n=setTimeout,setTimeout(t,0);try{return n(t,0)}catch(e){try{return n.call(null,t,0)}catch(e){return n.call(this,t,0)}}}!function(){try{n="function"==typeof setTimeout?setTimeout:o}catch(t){n=o}try{r="function"==typeof clearTimeout?clearTimeout:u}catch(t){r=u}}();var s,f=[],c=!1,l=-1;function h(){c&&s&&(c=!1,s.length?f=s.concat(f):l=-1,f.length&&p())}function p(){if(!c){var t=a(h);c=!0;for(var e=f.length;e;){for(s=f,f=[];++l<e;)s&&s[l].run();l=-1,e=f.length}s=null,c=!1,function(t){if(r===clearTimeout)return clearTimeout(t);if((r===u||!r)&&clearTimeout)return r=clearTimeout,clearTimeout(t);try{r(t)}catch(e){try{return r.call(null,t)}catch(e){return r.call(this,t)}}}(t)}}function d(t,e){this.fun=t,this.array=e}function y(){}i.nextTick=function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)e[n-1]=arguments[n];f.push(new d(t,e)),1!==f.length||c||a(p)},d.prototype.run=function(){this.fun.apply(null,this.array)},i.title="browser",i.browser=!0,i.env={},i.argv=[],i.version="",i.versions={},i.on=y,i.addListener=y,i.once=y,i.off=y,i.removeListener=y,i.removeAllListeners=y,i.emit=y,i.prependListener=y,i.prependOnceListener=y,i.listeners=function(t){return[]},i.binding=function(t){throw new Error("process.binding is not supported")},i.cwd=function(){return"/"},i.chdir=function(t){throw new Error("process.chdir is not supported")},i.umask=function(){return 0}},function(t,e,n){(function(t,e){!function(t,n){"use strict";if(!t.setImmediate){var r,i=1,o={},u=!1,a=t.document,s=Object.getPrototypeOf&&Object.getPrototypeOf(t);s=s&&s.setTimeout?s:t,"[object process]"==={}.toString.call(t.process)?r=function(t){e.nextTick(function(){c(t)})}:function(){if(t.postMessage&&!t.importScripts){var e=!0,n=t.onmessage;return t.onmessage=function(){e=!1},t.postMessage("","*"),t.onmessage=n,e}}()?function(){var e="setImmediate$"+Math.random()+"$",n=function(n){n.source===t&&"string"==typeof n.data&&0===n.data.indexOf(e)&&c(+n.data.slice(e.length))};t.addEventListener?t.addEventListener("message",n,!1):t.attachEvent("onmessage",n),r=function(n){t.postMessage(e+n,"*")}}():t.MessageChannel?function(){var t=new MessageChannel;t.port1.onmessage=function(t){c(t.data)},r=function(e){t.port2.postMessage(e)}}():a&&"onreadystatechange"in a.createElement("script")?function(){var t=a.documentElement;r=function(e){var n=a.createElement("script");n.onreadystatechange=function(){c(e),n.onreadystatechange=null,t.removeChild(n),n=null},t.appendChild(n)}}():r=function(t){setTimeout(c,0,t)},s.setImmediate=function(t){"function"!=typeof t&&(t=new Function(""+t));for(var e=new Array(arguments.length-1),n=0;n<e.length;n++)e[n]=arguments[n+1];var u={callback:t,args:e};return o[i]=u,r(i),i++},s.clearImmediate=f}function f(t){delete o[t]}function c(t){if(u)setTimeout(c,0,t);else{var e=o[t];if(e){u=!0;try{!function(t){var e=t.callback,r=t.args;switch(r.length){case 0:e();break;case 1:e(r[0]);break;case 2:e(r[0],r[1]);break;case 3:e(r[0],r[1],r[2]);break;default:e.apply(n,r)}}(e)}finally{f(t),u=!1}}}}}("undefined"==typeof self?void 0===t?this:t:self)}).call(this,n(1),n(16))},function(t,e,n){(function(t){var r=void 0!==t&&t||"undefined"!=typeof self&&self||window,i=Function.prototype.apply;function o(t,e){this._id=t,this._clearFn=e}e.setTimeout=function(){return new o(i.call(setTimeout,r,arguments),clearTimeout)},e.setInterval=function(){return new o(i.call(setInterval,r,arguments),clearInterval)},e.clearTimeout=e.clearInterval=function(t){t&&t.close()},o.prototype.unref=o.prototype.ref=function(){},o.prototype.close=function(){this._clearFn.call(r,this._id)},e.enroll=function(t,e){clearTimeout(t._idleTimeoutId),t._idleTimeout=e},e.unenroll=function(t){clearTimeout(t._idleTimeoutId),t._idleTimeout=-1},e._unrefActive=e.active=function(t){clearTimeout(t._idleTimeoutId);var e=t._idleTimeout;e>=0&&(t._idleTimeoutId=setTimeout(function(){t._onTimeout&&t._onTimeout()},e))},n(17),e.setImmediate="undefined"!=typeof self&&self.setImmediate||void 0!==t&&t.setImmediate||this&&this.setImmediate,e.clearImmediate="undefined"!=typeof self&&self.clearImmediate||void 0!==t&&t.clearImmediate||this&&this.clearImmediate}).call(this,n(1))},function(t,e,n){"use strict";n.r(e),function(t){var e=n(7),r=n(0),i=function(){if("undefined"!=typeof self)return self;if("undefined"!=typeof window)return window;if(void 0!==t)return t;throw new Error("unable to locate global object")}();i.Promise?i.Promise.prototype.finally||(i.Promise.prototype.finally=r.a):i.Promise=e.a}.call(this,n(1))},function(t,e,n){n(19),n(15),t.exports=n(14)}])});

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(7);
	var invariant = __webpack_require__(1);
	var ReactPropTypesSecret = __webpack_require__(66);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(7);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	var assign = __webpack_require__(4);
	
	var ReactPropTypesSecret = __webpack_require__(66);
	var checkPropTypes = __webpack_require__(151);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(152)();
	}


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.load = load;
	exports.loadAll = loadAll;
	exports.select = select;
	exports.save = save;
	exports.remove = remove;
	exports.setRawCookie = setRawCookie;
	exports.plugToRequest = plugToRequest;
	
	var _cookie = __webpack_require__(107);
	
	var _cookie2 = _interopRequireDefault(_cookie);
	
	var _objectAssign = __webpack_require__(4);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IS_NODE = typeof document === 'undefined' || process && process.env && ("production") === 'test';
	var _rawCookie = {};
	var _res = void 0;
	
	function _isResWritable() {
	  return _res && !_res.headersSent;
	}
	
	function load(name, doNotParse) {
	  var cookies = IS_NODE ? _rawCookie : _cookie2.default.parse(document.cookie);
	  var cookieVal = cookies && cookies[name];
	
	  if (typeof doNotParse === 'undefined') {
	    doNotParse = !cookieVal || cookieVal[0] !== '{' && cookieVal[0] !== '[';
	  }
	
	  if (!doNotParse) {
	    try {
	      cookieVal = JSON.parse(cookieVal);
	    } catch (err) {
	      // Not serialized object
	    }
	  }
	
	  return cookieVal;
	}
	
	function loadAll(doNotParse) {
	  var cookies = IS_NODE ? _rawCookie : _cookie2.default.parse(document.cookie);
	  var cookieVal = cookies;
	
	  if (typeof doNotParse === 'undefined') {
	    doNotParse = !cookieVal || cookieVal[0] !== '{' && cookieVal[0] !== '[';
	  }
	
	  if (!doNotParse) {
	    try {
	      cookieVal = JSON.parse(cookieVal);
	    } catch (err) {
	      // Not serialized object
	    }
	  }
	
	  return cookieVal;
	}
	
	function select(regex) {
	  var cookies = IS_NODE ? _rawCookie : _cookie2.default.parse(document.cookie);
	
	  if (!cookies) {
	    return {};
	  }
	
	  if (!regex) {
	    return cookies;
	  }
	
	  return Object.keys(cookies).reduce(function (accumulator, name) {
	    if (!regex.test(name)) {
	      return accumulator;
	    }
	
	    var newCookie = {};
	    newCookie[name] = cookies[name];
	    return (0, _objectAssign2.default)({}, accumulator, newCookie);
	  }, {});
	}
	
	function save(name, val, opt) {
	  _rawCookie[name] = val;
	
	  // Allow you to work with cookies as objects.
	  if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
	    _rawCookie[name] = JSON.stringify(val);
	  }
	
	  // Cookies only work in the browser
	  if (!IS_NODE) {
	    document.cookie = _cookie2.default.serialize(name, _rawCookie[name], opt);
	  }
	
	  if (_isResWritable() && _res.cookie) {
	    _res.cookie(name, val, opt);
	  }
	}
	
	function remove(name, opt) {
	  delete _rawCookie[name];
	
	  if (typeof opt === 'undefined') {
	    opt = {};
	  } else if (typeof opt === 'string') {
	    // Will be deprecated in future versions
	    opt = { path: opt };
	  } else {
	    // Prevent mutation of opt below
	    opt = (0, _objectAssign2.default)({}, opt);
	  }
	
	  if (typeof document !== 'undefined') {
	    opt.expires = new Date(1970, 1, 1, 0, 0, 1);
	    opt.maxAge = 0;
	    document.cookie = _cookie2.default.serialize(name, '', opt);
	  }
	
	  if (_isResWritable() && _res.clearCookie) {
	    _res.clearCookie(name, opt);
	  }
	}
	
	function setRawCookie(rawCookie) {
	  if (rawCookie) {
	    _rawCookie = _cookie2.default.parse(rawCookie);
	  } else {
	    _rawCookie = {};
	  }
	}
	
	function plugToRequest(req, res) {
	  if (req.cookie) {
	    _rawCookie = req.cookie;
	  } else if (req.cookies) {
	    _rawCookie = req.cookies;
	  } else if (req.headers && req.headers.cookie) {
	    setRawCookie(req.headers.cookie);
	  } else {
	    _rawCookie = {};
	  }
	
	  _res = res;
	
	  return function unplug() {
	    _res = null;
	    _rawCookie = {};
	  };
	}
	
	exports.default = {
	  setRawCookie: setRawCookie,
	  load: load,
	  loadAll: loadAll,
	  select: select,
	  save: save,
	  remove: remove,
	  plugToRequest: plugToRequest
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports =
	/******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId]) {
	/******/ 			return installedModules[moduleId].exports;
	/******/ 		}
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 1);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var UAParser = __webpack_require__(5);
	
	var UA = exports.UA = new UAParser();
	
	var browser = exports.browser = UA.getBrowser();
	var cpu = exports.cpu = UA.getCPU();
	var device = exports.device = UA.getDevice();
	var engine = exports.engine = UA.getEngine();
	var os = exports.os = UA.getOS();
	var ua = exports.ua = UA.getUA();
	var setUA = exports.setUA = function setUA(uaStr) {
	  return UA.setUA(uaStr);
	};
	
	var mockUserAgent = exports.mockUserAgent = function mockUserAgent(userAgent) {
	  window.navigator.__defineGetter__("userAgent", function () {
	    return userAgent;
	  });
	};
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.deviceDetect = undefined;
	
	var _views = __webpack_require__(2);
	
	Object.keys(_views).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _views[key];
	    }
	  });
	});
	
	var _selectors = __webpack_require__(4);
	
	Object.keys(_selectors).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _selectors[key];
	    }
	  });
	});
	
	var _detect = __webpack_require__(7);
	
	var _detect2 = _interopRequireDefault(_detect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.deviceDetect = _detect2.default;
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CustomView = exports.WearableView = exports.ConsoleView = exports.SmartTVView = exports.MobileOnlyView = exports.WinPhoneView = exports.TabletView = exports.MobileView = exports.IOSView = exports.IEView = exports.BrowserView = exports.AndroidView = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AndroidView = exports.AndroidView = function AndroidView(props) {
	  return props.device ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	var BrowserView = exports.BrowserView = function BrowserView(props) {
	  return props.device ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	var IEView = exports.IEView = function IEView(props) {
	  return props.device ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	var IOSView = exports.IOSView = function IOSView(props) {
	  return props.device ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	var MobileView = exports.MobileView = function MobileView(props) {
	  return props.device ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	var TabletView = exports.TabletView = function TabletView(props) {
	  return props.device ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	var WinPhoneView = exports.WinPhoneView = function WinPhoneView(props) {
	  return props.device ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	var MobileOnlyView = exports.MobileOnlyView = function MobileOnlyView(props) {
	  return props.device ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	var SmartTVView = exports.SmartTVView = function SmartTVView(props) {
	  return props.device ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	var ConsoleView = exports.ConsoleView = function ConsoleView(props) {
	  return props.device ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	var WearableView = exports.WearableView = function WearableView(props) {
	  return props.device ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	var CustomView = exports.CustomView = function CustomView(props) {
	  return props.condition ? _react2.default.createElement(
	    "div",
	    { className: props.viewClassName, style: props.style },
	    props.children
	  ) : null;
	};
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports) {
	
	module.exports = __webpack_require__(9);
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getUA = exports.engineVersion = exports.engineName = exports.mobileModel = exports.mobileVendor = exports.browserName = exports.browserVersion = exports.fullBrowserVersion = exports.osName = exports.osVersion = exports.isIE = exports.isOpera = exports.isSafari = exports.isFirefox = exports.isChrome = exports.isIOS = exports.isWinPhone = exports.isAndroid = exports.isBrowser = exports.isTablet = exports.isMobileOnly = exports.isMobile = exports.isChromium = exports.isMobileSafari = exports.isWearable = exports.isConsole = exports.isSmartTV = undefined;
	
	var _getUaData = __webpack_require__(0);
	
	var isMobileType = function isMobileType() {
	  return _getUaData.device.type === "mobile" ? true : false;
	};
	var isTabletType = function isTabletType() {
	  return _getUaData.device.type === "tablet" ? true : false;
	};
	
	var isMobileAndTabletType = function isMobileAndTabletType() {
	  switch (_getUaData.device.type) {
	    case "mobile":
	      return true;
	    case "tablet":
	      return true;
	    default:
	      return false;
	  }
	};
	
	var isSmartTVType = function isSmartTVType() {
	  return _getUaData.device.type === "smarttv" ? true : false;
	};
	var isBrowserType = function isBrowserType() {
	  return _getUaData.device.type === undefined ? true : false;
	};
	var isWearableType = function isWearableType() {
	  return _getUaData.device.type === 'wearable' ? true : false;
	};
	var isConsoleType = function isConsoleType() {
	  return _getUaData.device.type === 'console' ? true : false;
	};
	var isAndroidType = function isAndroidType() {
	  return _getUaData.os.name === "Android" ? true : false;
	};
	var isWinPhoneType = function isWinPhoneType() {
	  return _getUaData.os.name === "Windows Phone" ? true : false;
	};
	var isIOSType = function isIOSType() {
	  return _getUaData.os.name === "iOS" ? true : false;
	};
	var isChromeType = function isChromeType() {
	  return _getUaData.browser.name === "Chrome" ? true : false;
	};
	var isFirefoxType = function isFirefoxType() {
	  return _getUaData.browser.name === "Firefox" ? true : false;
	};
	var isChromiumType = function isChromiumType() {
	  return _getUaData.browser.name === 'Chromim' ? true : false;
	};
	
	var isSafariType = function isSafariType() {
	  return _getUaData.browser.name === "Safari" || _getUaData.browser.name === "Mobile Safari" ? true : false;
	};
	
	var isMobileSafariType = function isMobileSafariType() {
	  return _getUaData.browser.name === "Mobile Safari" ? true : false;
	};
	var isOperaType = function isOperaType() {
	  return _getUaData.browser.name === "Opera" ? true : false;
	};
	var isIEType = function isIEType() {
	  return _getUaData.browser.name === "Internet Explorer" ? true : false;
	};
	
	var getBrowserFullVersion = function getBrowserFullVersion() {
	  return _getUaData.browser.major;
	};
	var getBrowserVersion = function getBrowserVersion() {
	  return _getUaData.browser.version;
	};
	var getOsVersion = function getOsVersion() {
	  return _getUaData.os.version ? _getUaData.os.version : "none";
	};
	var getOsName = function getOsName() {
	  return _getUaData.os.name ? _getUaData.os.name : "none";
	};
	var getBrowserName = function getBrowserName() {
	  return _getUaData.browser.name;
	};
	var getMobileVendor = function getMobileVendor() {
	  return _getUaData.device.vendor ? _getUaData.device.vendor : "none";
	};
	var getMobileModel = function getMobileModel() {
	  return _getUaData.device.model ? _getUaData.device.model : "none";
	};
	var getEngineName = function getEngineName() {
	  return _getUaData.engine.name;
	};
	var getEngineVersion = function getEngineVersion() {
	  return _getUaData.engine.version;
	};
	var getUseragent = function getUseragent() {
	  return _getUaData.ua;
	};
	
	var isSmartTV = exports.isSmartTV = isSmartTVType();
	var isConsole = exports.isConsole = isConsoleType();
	var isWearable = exports.isWearable = isWearableType();
	var isMobileSafari = exports.isMobileSafari = isMobileSafariType();
	var isChromium = exports.isChromium = isChromiumType();
	var isMobile = exports.isMobile = isMobileAndTabletType();
	var isMobileOnly = exports.isMobileOnly = isMobileType();
	var isTablet = exports.isTablet = isTabletType();
	var isBrowser = exports.isBrowser = isBrowserType();
	var isAndroid = exports.isAndroid = isAndroidType();
	var isWinPhone = exports.isWinPhone = isWinPhoneType();
	var isIOS = exports.isIOS = isIOSType();
	var isChrome = exports.isChrome = isChromeType();
	var isFirefox = exports.isFirefox = isFirefoxType();
	var isSafari = exports.isSafari = isSafariType();
	var isOpera = exports.isOpera = isOperaType();
	var isIE = exports.isIE = isIEType();
	var osVersion = exports.osVersion = getOsVersion();
	var osName = exports.osName = getOsName();
	var fullBrowserVersion = exports.fullBrowserVersion = getBrowserFullVersion();
	var browserVersion = exports.browserVersion = getBrowserVersion();
	var browserName = exports.browserName = getBrowserName();
	var mobileVendor = exports.mobileVendor = getMobileVendor();
	var mobileModel = exports.mobileModel = getMobileModel();
	var engineName = exports.engineName = getEngineName();
	var engineVersion = exports.engineVersion = getEngineVersion();
	var getUA = exports.getUA = getUseragent();
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * UAParser.js v0.7.17
	 * Lightweight JavaScript-based User-Agent string parser
	 * https://github.com/faisalman/ua-parser-js
	 *
	 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
	 * Dual licensed under GPLv2 & MIT
	 */
	(function(window,undefined){"use strict";var LIBVERSION="0.7.17",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded";var util={extend:function(regexes,extensions){var margedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){margedRegexes[i]=extensions[i].concat(regexes[i])}else{margedRegexes[i]=regexes[i]}}return margedRegexes},has:function(str1,str2){if(typeof str1==="string"){return str2.toLowerCase().indexOf(str1.toLowerCase())!==-1}else{return false}},lowerize:function(str){return str.toLowerCase()},major:function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,"").split(".")[0]:undefined},trim:function(str){return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}};var mapper={rgx:function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length==2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length==3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length==4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},str:function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(util.has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(util.has(map[i],str)){return i===UNKNOWN?undefined:i}}return str}};var maps={browser:{oldsafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{amazon:{model:{"Fire Phone":["SD","KF"]}},sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2000:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}};var regexes={browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[NAME,VERSION],[/(opios)[\/\s]+([\w\.]+)/i],[[NAME,"Opera Mini"],VERSION],[/\s(opr)\/([\w\.]+)/i],[[NAME,"Opera"],VERSION],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,/(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]+)*/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser)\/([\w\.-]+)/i],[NAME,VERSION],[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],[[NAME,"IE"],VERSION],[/(edge)\/((\d+)?[\w\.]+)/i],[NAME,VERSION],[/(yabrowser)\/([\w\.]+)/i],[[NAME,"Yandex"],VERSION],[/(puffin)\/([\w\.]+)/i],[[NAME,"Puffin"],VERSION],[/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],[[NAME,"UCBrowser"],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(micromessenger)\/([\w\.]+)/i],[[NAME,"WeChat"],VERSION],[/(QQ)\/([\d\.]+)/i],[NAME,VERSION],[/m?(qqbrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI Browser"]],[/;fbav\/([\w\.]+);/i],[VERSION,[NAME,"Facebook"]],[/headlesschrome(?:\/([\w\.]+)|\s)/i],[VERSION,[NAME,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 WebView"],VERSION],[/((?:oculus|samsung)browser)\/([\w\.]+)/i],[[NAME,/(.+(?:g|us))(.+)/,"$1 $2"],VERSION],[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],[VERSION,[NAME,"Android Browser"]],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/(dolfin)\/([\w\.]+)/i],[[NAME,"Dolphin"],VERSION],[/((?:android.+)crmo|crios)\/([\w\.]+)/i],[[NAME,"Chrome"],VERSION],[/(coast)\/([\w\.]+)/i],[[NAME,"Opera Coast"],VERSION],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,"Firefox"]],[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],[VERSION,NAME],[/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[[NAME,"GSA"],VERSION],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,mapper.str,maps.browser.oldsafari.version]],[/(konqueror)\/([\w\.]+)/i,/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape)\/([\w\.-]+)/i],[[NAME,"Netscape"],VERSION],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]+)*/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,util.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/windows\s(ce|mobile);\sppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[[ARCHITECTURE,/ower/,"",util.lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],[[ARCHITECTURE,util.lowerize]]],device:[[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/applecoremedia\/[\w\.]+ \((ipad)/],[MODEL,[VENDOR,"Apple"],[TYPE,TABLET]],[/(apple\s{0,1}tv)/i],[[MODEL,"Apple TV"],[VENDOR,"Apple"]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad)/i,/(hp).+(tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i],[[MODEL,mapper.str,maps.device.amazon.model],[VENDOR,"Amazon"],[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);.+(apple)/i],[MODEL,VENDOR,[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);/i],[MODEL,[VENDOR,"Apple"],[TYPE,MOBILE]],[/(blackberry)[\s-]?(\w+)/i,/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/\(bb10;\s(\w+)/i],[MODEL,[VENDOR,"BlackBerry"],[TYPE,MOBILE]],[/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i],[MODEL,[VENDOR,"Asus"],[TYPE,TABLET]],[/(sony)\s(tablet\s[ps])\sbuild\//i,/(sony)?(?:sgp.+)\sbuild\//i],[[VENDOR,"Sony"],[MODEL,"Xperia Tablet"],[TYPE,TABLET]],[/android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i],[MODEL,[VENDOR,"Sony"],[TYPE,MOBILE]],[/\s(ouya)\s/i,/(nintendo)\s([wids3u]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/android.+;\s(shield)\sbuild/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation\s[34portablevi]+)/i],[MODEL,[VENDOR,"Sony"],[TYPE,CONSOLE]],[/(sprint\s(\w+))/i],[[VENDOR,mapper.str,maps.device.sprint.vendor],[MODEL,mapper.str,maps.device.sprint.model],[TYPE,MOBILE]],[/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,/(zte)-(\w+)*/i,/(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/(nexus\s9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/d\/huawei([\w\s-]+)[;\)]/i,/(nexus\s6p)/i],[MODEL,[VENDOR,"Huawei"],[TYPE,MOBILE]],[/(microsoft);\s(lumia[\s\w]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/[\s\(;](xbox(?:\sone)?)[\s\);]/i],[MODEL,[VENDOR,"Microsoft"],[TYPE,CONSOLE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,"Microsoft"],[TYPE,MOBILE]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,/mot[\s-]?(\w+)*/i,/(XT\d{3,4}) build\//i,/(nexus\s6)/i],[MODEL,[VENDOR,"Motorola"],[TYPE,MOBILE]],[/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[MODEL,[VENDOR,"Motorola"],[TYPE,TABLET]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[VENDOR,util.trim],[MODEL,util.trim],[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,"Samsung"],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,/((SM-T\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,TABLET]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV],MODEL],[/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,/(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,/sec-((sgh\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,MOBILE]],[/sie-(\w+)*/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/(maemo|nokia).*(n900|lumia\s\d+)/i,/(nokia)[\s_-]?([\w-]+)*/i],[[VENDOR,"Nokia"],MODEL,[TYPE,MOBILE]],[/android\s3\.[\s\w;-]{10}(a\d{3})/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/android.+([vl]k\-?\d{3})\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,TABLET]],[/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],[[VENDOR,"LG"],MODEL,[TYPE,TABLET]],[/(lg) netcast\.tv/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/(nexus\s[45])/i,/lg[e;\s\/-]+(\w+)*/i,/android.+lg(\-?[\d\w]+)\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,MOBILE]],[/android.+(ideatab[a-z0-9\-\s]+)/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/linux;.+((jolla));/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/((pebble))app\/[\d\.]+\s/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/crkey/i],[[MODEL,"Chromecast"],[VENDOR,"Google"]],[/android.+;\s(glass)\s\d/i],[MODEL,[VENDOR,"Google"],[TYPE,WEARABLE]],[/android.+;\s(pixel c)\s/i],[MODEL,[VENDOR,"Google"],[TYPE,TABLET]],[/android.+;\s(pixel xl|pixel)\s/i],[MODEL,[VENDOR,"Google"],[TYPE,MOBILE]],[/android.+(\w+)\s+build\/hm\1/i,/android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,/android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d\w)?)\s+build/i,/android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+)?)\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,MOBILE]],[/android.+(mi[\s\-_]*(?:pad)?(?:[\s_]*[\w\s]+)?)\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,TABLET]],[/android.+;\s(m[1-5]\snote)\sbuild/i],[MODEL,[VENDOR,"Meizu"],[TYPE,TABLET]],[/android.+a000(1)\s+build/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/android.+[;\/]\s*(Venue[\d\s]*)\s+build/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i],[[VENDOR,"Barnes & Noble"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/android.+[;\/]\s*(zte)?.+(k\d{2})\s+build/i],[[VENDOR,"ZTE"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/android.+[;\/]\s*(zur\d{3})\s+build/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/(android).+[;\/]\s+([YR]\d{2}x?.*)\s+build/i,/android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(.+)\s+build/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(NS-?.+)\s+build/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/android.+[;\/]\s*((NX|Next)-?.+)\s+build/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/android.+[;\/]\s*(Xtreme\_?)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(LVTEL\-?)?(V1[12])\s+build/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(.*\b)\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*TU_(1491)\s+build/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/android.+(KS(.+))\s+build/i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/android.+(Gigaset)[\s\-]+(Q.+)\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/\s(tablet|tab)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[TYPE,util.lowerize],VENDOR,MODEL],[/(android.+)[;\/].+build/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[VERSION,[NAME,"EdgeHTML"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]+).*(gecko)/i],[VERSION,NAME]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[NAME,VERSION],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s]+\w)*/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[NAME,[VERSION,mapper.str,maps.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,mapper.str,maps.os.windows.version]],[/\((bb)(10);/i],[[NAME,"BlackBerry"],VERSION],[/(blackberry)\w*\/?([\w\.]+)*/i,/(tizen)[\/\s]([\w\.]+)/i,/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,/linux;.+(sailfish);/i],[NAME,VERSION],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i],[[NAME,"Symbian"],VERSION],[/\((series40);/i],[NAME],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[NAME,"Firefox OS"],VERSION],[/(nintendo|playstation)\s([wids34portablevu]+)/i,/(mint)[\/\s\(]?(\w+)*/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]+)*/i,/(hurd|linux)\s?([\w\.]+)*/i,/(gnu)\s?([\w\.]+)*/i],[NAME,VERSION],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(sunos)\s?([\w\.]+\d)*/i],[[NAME,"Solaris"],VERSION],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i],[NAME,VERSION],[/(haiku)\s(\w+)/i],[NAME,VERSION],[/cfnetwork\/.+darwin/i,/ip[honead]+(?:.*os\s([\w]+)\slike\smac|;\sopera)/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac\sos\sx)\s?([\w\s\.]+\w)*/i,/(macintosh|mac(?=_powerpc)\s)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,/(unix)\s?([\w\.]+)*/i],[NAME,VERSION]]};var UAParser=function(uastring,extensions){if(typeof uastring==="object"){extensions=uastring;uastring=undefined}if(!(this instanceof UAParser)){return new UAParser(uastring,extensions).getResult()}var ua=uastring||(window&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var rgxmap=extensions?util.extend(regexes,extensions):regexes;this.getBrowser=function(){var browser={name:undefined,version:undefined};mapper.rgx.call(browser,ua,rgxmap.browser);browser.major=util.major(browser.version);return browser};this.getCPU=function(){var cpu={architecture:undefined};mapper.rgx.call(cpu,ua,rgxmap.cpu);return cpu};this.getDevice=function(){var device={vendor:undefined,model:undefined,type:undefined};mapper.rgx.call(device,ua,rgxmap.device);return device};this.getEngine=function(){var engine={name:undefined,version:undefined};mapper.rgx.call(engine,ua,rgxmap.engine);return engine};this.getOS=function(){var os={name:undefined,version:undefined};mapper.rgx.call(os,ua,rgxmap.os);return os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return ua};this.setUA=function(uastring){ua=uastring;return this};return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER={NAME:NAME,MAJOR:MAJOR,VERSION:VERSION};UAParser.CPU={ARCHITECTURE:ARCHITECTURE};UAParser.DEVICE={MODEL:MODEL,VENDOR:VENDOR,TYPE:TYPE,CONSOLE:CONSOLE,MOBILE:MOBILE,SMARTTV:SMARTTV,TABLET:TABLET,WEARABLE:WEARABLE,EMBEDDED:EMBEDDED};UAParser.ENGINE={NAME:NAME,VERSION:VERSION};UAParser.OS={NAME:NAME,VERSION:VERSION};if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if("function"===FUNC_TYPE&&__webpack_require__(6)){!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return UAParser}.call(exports, __webpack_require__, exports, module),
					__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(window){window.UAParser=UAParser}}var $=window&&(window.jQuery||window.Zepto);if(typeof $!==UNDEF_TYPE){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(uastring){parser.setUA(uastring);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports) {
	
	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
	module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getUaData = __webpack_require__(0);
	
	var _types = __webpack_require__(8);
	
	var create = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var type = create.checkType(_getUaData.device.type);
	
	exports.default = function () {
	  var isBrowser = type.isBrowser,
	      isMobile = type.isMobile,
	      isTablet = type.isTablet,
	      isSmartTV = type.isSmartTV,
	      isConsole = type.isConsole,
	      isWearable = type.isWearable;
	
	  if (isBrowser) {
	    return create.broPayload(isBrowser, _getUaData.browser, _getUaData.engine, _getUaData.os, _getUaData.ua);
	  }
	
	  if (isSmartTV) {
	    return create.stvPayload(isSmartTV, _getUaData.engine, _getUaData.os, _getUaData.ua);
	  }
	
	  if (isConsole) {
	    return create.consolePayload(isConsole, _getUaData.engine, _getUaData.os, _getUaData.ua);
	  }
	
	  if (isMobile) {
	    return create.mobilePayload(type, _getUaData.device, _getUaData.os, _getUaData.ua);
	  }
	
	  if (isTablet) {
	    return create.mobilePayload(type, _getUaData.device, _getUaData.os, _getUaData.ua);
	  }
	
	  if (isWearable) {
	    return create.wearPayload(isWearable, _getUaData.engine, _getUaData.os, _getUaData.ua);
	  }
	};
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var initialData = {
	  isMobile: false,
	  isTablet: false,
	  isBrowser: false,
	  isSmartTV: false,
	  isConsole: false,
	  isWearable: false
	};
	
	var checkType = exports.checkType = function checkType(type) {
	  switch (type) {
	    case "mobile":
	      return {
	        isMobile: true
	      };
	    case "tablet":
	      return {
	        isTablet: true
	      };
	    case "smarttv":
	      return {
	        isSmartTV: true
	      };
	    case "console":
	      return {
	        isConsole: true
	      };
	    case "wearable":
	      return {
	        isWearable: true
	      };
	    case undefined:
	      return {
	        isBrowser: true
	      };
	    default:
	      return initialData;
	  }
	};
	
	var getCurrentBrowser = exports.getCurrentBrowser = function getCurrentBrowser(name) {
	  switch (name) {
	    case "Chrome":
	      return true;
	    case "Firefox":
	      return true;
	    case "Opera":
	      return true;
	    case "Yandex":
	      return true;
	    case "Safari":
	      return true;
	    case "IE":
	      return true;
	    case "Edge":
	      return true;
	    case "Chromium":
	      return true;
	    default:
	      return false;
	  }
	};
	
	var broPayload = exports.broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
	  return {
	    isBrowser: isBrowser,
	    browserMajorVersion: browser.major,
	    browserFullVersion: browser.version,
	    browserName: browser.name,
	    engineName: engine.name || false,
	    engineVersion: engine.version,
	    osName: os.name,
	    osVersion: os.version,
	    userAgent: ua
	  };
	};
	
	var mobilePayload = exports.mobilePayload = function mobilePayload(type, device, os, ua) {
	  return _extends({}, type, {
	    vendor: device.vendor || "none",
	    model: device.model || "none",
	    os: os.name || "none",
	    osVersion: os.version || "none",
	    ua: ua || "none"
	  });
	};
	
	var stvPayload = exports.stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
	  return {
	    isSmartTV: isSmartTV,
	    engineName: engine.name || false,
	    engineVersion: engine.version,
	    osName: os.name,
	    osVersion: os.version,
	    userAgent: ua
	  };
	};
	
	var consolePayload = exports.consolePayload = function consolePayload(isConsole, engine, os, ua) {
	  return {
	    isConsole: isConsole,
	    engineName: engine.name || false,
	    engineVersion: engine.version,
	    osName: os.name,
	    osVersion: os.version,
	    userAgent: ua
	  };
	};
	
	var wearPayload = exports.wearPayload = function wearPayload(isWearable, engine, os, ua) {
	  return {
	    isWearable: isWearable,
	    engineName: engine.name || false,
	    engineVersion: engine.version,
	    osName: os.name,
	    osVersion: os.version,
	    userAgent: ua
	  };
	};
	
	/***/ })
	/******/ ]);

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(5);
	
	var focusNode = __webpack_require__(63);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(20);
	var ExecutionEnvironment = __webpack_require__(6);
	var FallbackCompositionState = __webpack_require__(165);
	var SyntheticCompositionEvent = __webpack_require__(202);
	var SyntheticInputEvent = __webpack_require__(205);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(68);
	var ExecutionEnvironment = __webpack_require__(6);
	var ReactInstrumentation = __webpack_require__(8);
	
	var camelizeStyleName = __webpack_require__(138);
	var dangerousStyleValue = __webpack_require__(211);
	var hyphenateStyleName = __webpack_require__(145);
	var memoizeStringOnly = __webpack_require__(148);
	var warning = __webpack_require__(2);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(19);
	var EventPropagators = __webpack_require__(20);
	var ExecutionEnvironment = __webpack_require__(6);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactUpdates = __webpack_require__(10);
	var SyntheticEvent = __webpack_require__(11);
	
	var inputValueTracking = __webpack_require__(84);
	var getEventTarget = __webpack_require__(50);
	var isEventSupported = __webpack_require__(51);
	var isTextInputElement = __webpack_require__(86);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var DOMLazyTree = __webpack_require__(14);
	var ExecutionEnvironment = __webpack_require__(6);
	
	var createNodesFromMarkup = __webpack_require__(141);
	var emptyFunction = __webpack_require__(7);
	var invariant = __webpack_require__(1);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(20);
	var ReactDOMComponentTree = __webpack_require__(5);
	var SyntheticMouseEvent = __webpack_require__(28);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(13);
	
	var getTextContentAccessor = __webpack_require__(83);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(15);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(16);
	
	var instantiateReactComponent = __webpack_require__(85);
	var KeyEscapeUtils = __webpack_require__(42);
	var shouldUpdateReactComponent = __webpack_require__(52);
	var traverseAllChildren = __webpack_require__(88);
	var warning = __webpack_require__(2);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(90);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(38);
	var ReactDOMIDOperations = __webpack_require__(175);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var React = __webpack_require__(17);
	var ReactComponentEnvironment = __webpack_require__(44);
	var ReactCurrentOwner = __webpack_require__(12);
	var ReactErrorUtils = __webpack_require__(45);
	var ReactInstanceMap = __webpack_require__(21);
	var ReactInstrumentation = __webpack_require__(8);
	var ReactNodeTypes = __webpack_require__(78);
	var ReactReconciler = __webpack_require__(16);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(25);
	var invariant = __webpack_require__(1);
	var shallowEqual = __webpack_require__(36);
	var shouldUpdateReactComponent = __webpack_require__(52);
	var warning = __webpack_require__(2);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactDefaultInjection = __webpack_require__(183);
	var ReactMount = __webpack_require__(77);
	var ReactReconciler = __webpack_require__(16);
	var ReactUpdates = __webpack_require__(10);
	var ReactVersion = __webpack_require__(196);
	
	var findDOMNode = __webpack_require__(212);
	var getHostComponentFromComposite = __webpack_require__(82);
	var renderSubtreeIntoContainer = __webpack_require__(219);
	var warning = __webpack_require__(2);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var AutoFocusUtils = __webpack_require__(158);
	var CSSPropertyOperations = __webpack_require__(160);
	var DOMLazyTree = __webpack_require__(14);
	var DOMNamespaces = __webpack_require__(39);
	var DOMProperty = __webpack_require__(15);
	var DOMPropertyOperations = __webpack_require__(70);
	var EventPluginHub = __webpack_require__(19);
	var EventPluginRegistry = __webpack_require__(40);
	var ReactBrowserEventEmitter = __webpack_require__(27);
	var ReactDOMComponentFlags = __webpack_require__(71);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactDOMInput = __webpack_require__(176);
	var ReactDOMOption = __webpack_require__(177);
	var ReactDOMSelect = __webpack_require__(72);
	var ReactDOMTextarea = __webpack_require__(180);
	var ReactInstrumentation = __webpack_require__(8);
	var ReactMultiChild = __webpack_require__(189);
	var ReactServerRenderingTransaction = __webpack_require__(194);
	
	var emptyFunction = __webpack_require__(7);
	var escapeTextContentForBrowser = __webpack_require__(30);
	var invariant = __webpack_require__(1);
	var isEventSupported = __webpack_require__(51);
	var shallowEqual = __webpack_require__(36);
	var inputValueTracking = __webpack_require__(84);
	var validateDOMNesting = __webpack_require__(53);
	var warning = __webpack_require__(2);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(53);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var DOMLazyTree = __webpack_require__(14);
	var ReactDOMComponentTree = __webpack_require__(5);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 174 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(38);
	var ReactDOMComponentTree = __webpack_require__(5);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var DOMPropertyOperations = __webpack_require__(70);
	var LinkedValueUtils = __webpack_require__(43);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactUpdates = __webpack_require__(10);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var React = __webpack_require__(17);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactDOMSelect = __webpack_require__(72);
	
	var warning = __webpack_require__(2);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(6);
	
	var getNodeForCharacterOffset = __webpack_require__(216);
	var getTextContentAccessor = __webpack_require__(83);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var DOMChildrenOperations = __webpack_require__(38);
	var DOMLazyTree = __webpack_require__(14);
	var ReactDOMComponentTree = __webpack_require__(5);
	
	var escapeTextContentForBrowser = __webpack_require__(30);
	var invariant = __webpack_require__(1);
	var validateDOMNesting = __webpack_require__(53);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3),
	    _assign = __webpack_require__(4);
	
	var LinkedValueUtils = __webpack_require__(43);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactUpdates = __webpack_require__(10);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var ReactUpdates = __webpack_require__(10);
	var Transaction = __webpack_require__(29);
	
	var emptyFunction = __webpack_require__(7);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(157);
	var BeforeInputEventPlugin = __webpack_require__(159);
	var ChangeEventPlugin = __webpack_require__(161);
	var DefaultEventPluginOrder = __webpack_require__(163);
	var EnterLeaveEventPlugin = __webpack_require__(164);
	var HTMLDOMPropertyConfig = __webpack_require__(166);
	var ReactComponentBrowserEnvironment = __webpack_require__(168);
	var ReactDOMComponent = __webpack_require__(171);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactDOMEmptyComponent = __webpack_require__(173);
	var ReactDOMTreeTraversal = __webpack_require__(181);
	var ReactDOMTextComponent = __webpack_require__(179);
	var ReactDefaultBatchingStrategy = __webpack_require__(182);
	var ReactEventListener = __webpack_require__(186);
	var ReactInjection = __webpack_require__(187);
	var ReactReconcileTransaction = __webpack_require__(192);
	var SVGDOMPropertyConfig = __webpack_require__(197);
	var SelectEventPlugin = __webpack_require__(198);
	var SimpleEventPlugin = __webpack_require__(199);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ }),
/* 184 */
91,
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(19);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var EventListener = __webpack_require__(62);
	var ExecutionEnvironment = __webpack_require__(6);
	var PooledClass = __webpack_require__(13);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactUpdates = __webpack_require__(10);
	
	var getEventTarget = __webpack_require__(50);
	var getUnboundedScrollPosition = __webpack_require__(143);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(15);
	var EventPluginHub = __webpack_require__(19);
	var EventPluginUtils = __webpack_require__(41);
	var ReactComponentEnvironment = __webpack_require__(44);
	var ReactEmptyComponent = __webpack_require__(73);
	var ReactBrowserEventEmitter = __webpack_require__(27);
	var ReactHostComponent = __webpack_require__(75);
	var ReactUpdates = __webpack_require__(10);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(210);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactComponentEnvironment = __webpack_require__(44);
	var ReactInstanceMap = __webpack_require__(21);
	var ReactInstrumentation = __webpack_require__(8);
	
	var ReactCurrentOwner = __webpack_require__(12);
	var ReactReconciler = __webpack_require__(16);
	var ReactChildReconciler = __webpack_require__(167);
	
	var emptyFunction = __webpack_require__(7);
	var flattenChildren = __webpack_require__(213);
	var invariant = __webpack_require__(1);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var CallbackQueue = __webpack_require__(69);
	var PooledClass = __webpack_require__(13);
	var ReactBrowserEventEmitter = __webpack_require__(27);
	var ReactInputSelection = __webpack_require__(76);
	var ReactInstrumentation = __webpack_require__(8);
	var Transaction = __webpack_require__(29);
	var ReactUpdateQueue = __webpack_require__(46);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(190);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(4);
	
	var PooledClass = __webpack_require__(13);
	var Transaction = __webpack_require__(29);
	var ReactInstrumentation = __webpack_require__(8);
	var ReactServerUpdateQueue = __webpack_require__(195);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(46);
	
	var warning = __webpack_require__(2);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ }),
/* 196 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ }),
/* 197 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(20);
	var ExecutionEnvironment = __webpack_require__(6);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactInputSelection = __webpack_require__(76);
	var SyntheticEvent = __webpack_require__(11);
	
	var getActiveElement = __webpack_require__(64);
	var isTextInputElement = __webpack_require__(86);
	var shallowEqual = __webpack_require__(36);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var EventListener = __webpack_require__(62);
	var EventPropagators = __webpack_require__(20);
	var ReactDOMComponentTree = __webpack_require__(5);
	var SyntheticAnimationEvent = __webpack_require__(200);
	var SyntheticClipboardEvent = __webpack_require__(201);
	var SyntheticEvent = __webpack_require__(11);
	var SyntheticFocusEvent = __webpack_require__(204);
	var SyntheticKeyboardEvent = __webpack_require__(206);
	var SyntheticMouseEvent = __webpack_require__(28);
	var SyntheticDragEvent = __webpack_require__(203);
	var SyntheticTouchEvent = __webpack_require__(207);
	var SyntheticTransitionEvent = __webpack_require__(208);
	var SyntheticUIEvent = __webpack_require__(22);
	var SyntheticWheelEvent = __webpack_require__(209);
	
	var emptyFunction = __webpack_require__(7);
	var getEventCharCode = __webpack_require__(48);
	var invariant = __webpack_require__(1);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(11);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(11);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(11);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(28);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(22);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(11);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(22);
	
	var getEventCharCode = __webpack_require__(48);
	var getEventKey = __webpack_require__(214);
	var getEventModifierState = __webpack_require__(49);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(22);
	
	var getEventModifierState = __webpack_require__(49);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(11);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(28);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ }),
/* 210 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(68);
	var warning = __webpack_require__(2);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(3);
	
	var ReactCurrentOwner = __webpack_require__(12);
	var ReactDOMComponentTree = __webpack_require__(5);
	var ReactInstanceMap = __webpack_require__(21);
	
	var getHostComponentFromComposite = __webpack_require__(82);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(2);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(42);
	var traverseAllChildren = __webpack_require__(88);
	var warning = __webpack_require__(2);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(90);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)))

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(48);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 216 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(6);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(30);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(77);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(9);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(154);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _screenReaderStyles = __webpack_require__(221);
	
	var _screenReaderStyles2 = _interopRequireDefault(_screenReaderStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A React component for the font-awesome icon library.
	 *
	 * @param {String} [ariaLabel] An extra accessibility label to put on the icon
	 * @param {Boolean} [border=false] Whether or not to show a border radius
	 * @param {String} [className] An extra set of CSS classes to add to the component
	 * @param {Object} [cssModule] Option to pass FontAwesome CSS as a module
	 * @param {Boolean} [fixedWidth=false] Make buttons fixed width
	 * @param {String} [flip=false] Flip the icon's orientation.
	 * @param {Boolean} [inverse=false]Inverse the icon's color
	 * @param {String} name Name of the icon to use
	 * @param {Boolean} [pulse=false] Rotate icon with 8 steps, rather than smoothly
	 * @param {Number} [rotate] The degress to rotate the icon by
	 * @param {String} [size] The icon scaling size
	 * @param {Boolean} [spin=false] Spin the icon
	 * @param {String} [stack] Stack an icon on top of another
	 * @param {String} [tag=span] The HTML tag to use as a string, eg 'i' or 'em'
	 * @module FontAwesome
	 * @type {ReactClass}
	 */
	var FontAwesome = function (_React$Component) {
	  _inherits(FontAwesome, _React$Component);
	
	  function FontAwesome() {
	    _classCallCheck(this, FontAwesome);
	
	    var _this = _possibleConstructorReturn(this, (FontAwesome.__proto__ || Object.getPrototypeOf(FontAwesome)).call(this));
	
	    _this.displayName = 'FontAwesome';
	    return _this;
	  }
	
	  _createClass(FontAwesome, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          border = _props.border,
	          cssModule = _props.cssModule,
	          className = _props.className,
	          fixedWidth = _props.fixedWidth,
	          flip = _props.flip,
	          inverse = _props.inverse,
	          name = _props.name,
	          pulse = _props.pulse,
	          rotate = _props.rotate,
	          size = _props.size,
	          spin = _props.spin,
	          stack = _props.stack,
	          _props$tag = _props.tag,
	          tag = _props$tag === undefined ? 'span' : _props$tag,
	          ariaLabel = _props.ariaLabel,
	          props = _objectWithoutProperties(_props, ['border', 'cssModule', 'className', 'fixedWidth', 'flip', 'inverse', 'name', 'pulse', 'rotate', 'size', 'spin', 'stack', 'tag', 'ariaLabel']);
	
	      var classNames = [];
	
	      if (cssModule) {
	        classNames.push(cssModule['fa']);
	        classNames.push(cssModule['fa-' + name]);
	        size && classNames.push(cssModule['fa-' + size]);
	        spin && classNames.push(cssModule['fa-spin']);
	        pulse && classNames.push(cssModule['fa-pulse']);
	        border && classNames.push(cssModule['fa-border']);
	        fixedWidth && classNames.push(cssModule['fa-fw']);
	        inverse && classNames.push(cssModule['fa-inverse']);
	        flip && classNames.push(cssModule['fa-flip-' + flip]);
	        rotate && classNames.push(cssModule['fa-rotate-' + rotate]);
	        stack && classNames.push(cssModule['fa-stack-' + stack]);
	      } else {
	        classNames.push('fa');
	        classNames.push('fa-' + name);
	        size && classNames.push('fa-' + size);
	        spin && classNames.push('fa-spin');
	        pulse && classNames.push('fa-pulse');
	        border && classNames.push('fa-border');
	        fixedWidth && classNames.push('fa-fw');
	        inverse && classNames.push('fa-inverse');
	        flip && classNames.push('fa-flip-' + flip);
	        rotate && classNames.push('fa-rotate-' + rotate);
	        stack && classNames.push('fa-stack-' + stack);
	      }
	
	      // Add any custom class names at the end.
	      className && classNames.push(className);
	      return _react2.default.createElement(tag, _extends({}, props, { 'aria-hidden': true, className: classNames.join(' ') }), ariaLabel ? _react2.default.createElement('span', { style: _screenReaderStyles2.default }, ariaLabel) : null);
	    }
	  }]);
	
	  return FontAwesome;
	}(_react2.default.Component);
	
	FontAwesome.propTypes = {
	  ariaLabel: _propTypes2.default.string,
	  border: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  cssModule: _propTypes2.default.object,
	  fixedWidth: _propTypes2.default.bool,
	  flip: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  inverse: _propTypes2.default.bool,
	  name: _propTypes2.default.string.isRequired,
	  pulse: _propTypes2.default.bool,
	  rotate: _propTypes2.default.oneOf([90, 180, 270]),
	  size: _propTypes2.default.oneOf(['lg', '2x', '3x', '4x', '5x']),
	  spin: _propTypes2.default.bool,
	  stack: _propTypes2.default.oneOf(['1x', '2x']),
	  tag: _propTypes2.default.string
	};
	
	exports.default = FontAwesome;
	module.exports = exports['default'];

/***/ }),
/* 221 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  position: 'absolute',
	  width: '1px',
	  height: '1px',
	  padding: '0px',
	  margin: '-1px',
	  overflow: 'hidden',
	  clip: 'rect(0px, 0px, 0px, 0px)',
	  border: '0px'
	};
	module.exports = exports['default'];

/***/ }),
/* 222 */
42,
/* 223 */
[238, 23],
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(223);
	var ReactElement = __webpack_require__(18);
	
	var emptyFunction = __webpack_require__(7);
	var traverseAllChildren = __webpack_require__(233);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(18);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(18),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(65);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 227 */
196,
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(89),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(18),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(92);
	var factory = __webpack_require__(133);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 229 */
215,
/* 230 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var ReactElement = __webpack_require__(18);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(23);
	
	var ReactCurrentOwner = __webpack_require__(12);
	var REACT_ELEMENT_TYPE = __webpack_require__(91);
	
	var getIteratorFn = __webpack_require__(229);
	var invariant = __webpack_require__(1);
	var KeyEscapeUtils = __webpack_require__(222);
	var warning = __webpack_require__(2);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(true) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(135);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(234)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js?outputStyle=expanded!./App.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js?outputStyle=expanded!./App.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "c9ab436e824d579f430b97d06a6fcbd4.woff";

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// app.js